webpackJsonp([1],{

/***/ "+B1v":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjI5NzhCMTNBRDY3RTExRTc4MjM4REQ5M0U2N0I2RjIyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjI5NzhCMTNCRDY3RTExRTc4MjM4REQ5M0U2N0I2RjIyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Mjk3OEIxMzhENjdFMTFFNzgyMzhERDkzRTY3QjZGMjIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Mjk3OEIxMzlENjdFMTFFNzgyMzhERDkzRTY3QjZGMjIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz53SuXxAAACPklEQVR42uyXzUtUURiH55ofG7EJdGWKCgkJMSpE0cJFO0Ex3LhoJa0SEs02QYvAtQvRwIWbImgnWEnUQv8AJdqkkuIXFlmWHyWZX+Pzyk85XK6DM46OCw883Dmv55zfeT/OuVcvGo2GUtHSQilqKRMOJRJq5lyFaZiBSEKahwljL4aqAPtt+A4b8B9+QG0yhcdgGa44tkZYhDXogxfwF35Da7KExyVcrn67+ivQAemQAU9gCVahB7xkCVfCS3n2C5rgmvJrVEAD/IR1+ACZyRAednJZLRa0kT+y18FN+AZb8AkuJSr8RYvswLxVLzxQWI02X78FimBKc6zqS+ISVkVb1Vqbg8vQJQ8tpHecsTXy2v72DMLwUZu2CNw6kjD9G5qwrWrNh7fK31fLacBCEUXFxgxANryDf9ro3ZjC/K7XQJvwHvJgRLu30OfHyJttcEJjR+R5t6rdUvE0UJjnQ3loIeuFQpjUQlZgOUc4Jjkau6W5lqJmnQYrxldw4UDY2ZkJP4brCqt53m9nNo7Lwc72Gyc1EeckWN0MucKLKpAGTR7VDjuP8Q7o1g33WX07+7M6+wfChW7+dIbtPg4fQzisNcYdW9p+qPdC6Hne3Gm8CdHZ2S+ulL2P0+MM3z0e9wM+IMyTLjx6flJfIC1QBrk+zPboxDxWW4MqvJtRFIp4DJ9/7J1Z4Vg5zoLXdu86tgLYPGR8AWMHfWtnxSs8Dxeh1GdfB9vIkmNbgQ3YVnX7x88GXibn/8KcVtsVYABjl1bbD9tZewAAAABJRU5ErkJggg=="

/***/ }),

/***/ "+FQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taskAudit_vue__ = __webpack_require__("QCU8");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8dc6b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taskAudit_vue__ = __webpack_require__("VNqE");
function injectStyle (ssrContext) {
  __webpack_require__("gW+x")
  __webpack_require__("xmOy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d8dc6b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taskAudit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8dc6b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taskAudit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "+FwL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+Zjf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+egd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+gcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zScore_vue__ = __webpack_require__("25n0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zStar_vue__ = __webpack_require__("I9zw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zSystem_vue__ = __webpack_require__("SH69");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰180718优化整理。组件每次销毁重置




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lookHistoryTwo',
  components: {
    Score: __WEBPACK_IMPORTED_MODULE_0__zScore_vue__["a" /* default */],
    Star: __WEBPACK_IMPORTED_MODULE_1__zStar_vue__["a" /* default */],
    System: __WEBPACK_IMPORTED_MODULE_2__zSystem_vue__["a" /* default */]
  },
  data: function data() {
    return {
      pages: [{
        name: '体系配置',
        icon: __webpack_require__("Ufaa"),
        checkedIcon: __webpack_require__("kub0")
      }, {
        name: '积分',
        icon: __webpack_require__("l2JT"),
        checkedIcon: __webpack_require__("uCnF")
      }, {
        name: '星级',
        icon: __webpack_require__("IMXc"),
        checkedIcon: __webpack_require__("ttW4")
      }, {
        name: '信用',
        icon: __webpack_require__("ZH05"),
        checkedIcon: __webpack_require__("Y+6D")
      }],
      navState: 1
    };
  }
});

/***/ }),

/***/ "+lts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      action: "/rest/CrmBlacklist/importBlackList?operatorId=" + sessionStorage.getItem("sysUserId"),
      openid: sessionStorage.getItem("sysUserId"),
      pageNo: 1,
      pageSize: 10,
      total: null,
      formData: {
        salemansName: null,
        idCard: null,
        empPk: null,
        pageNo: 1,
        qhrStatus: null,
        pageSize: 10
      },

      tableData: [],
      listLoading: false,
      uploadDialog: false,
      uploadDialogi: false,
      fileList: [],
      rules: {
        idCard: [{
          pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
          message: "请输入15位或18位身份证号",
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getData();
    this.$refs["formData"].resetFields();
  },

  methods: {
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      }
    },
    formatName: function formatName(row, column, cellValue) {
      var a = cellValue[0];
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        for (var i = 0; i < cellValue.length - 1; i++) {
          a = a + "*";
        }
        return a;
      }
    },
    insertBatchs: function insertBatchs() {
      this.uploadDialog = true;
    },
    getData: function getData(pageNo) {
      var _this = this;

      if (pageNo) {
        this.formData.pageNo = 1;
      }
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/findCBByIdCardAndName",
        params: this.formData
      }).then(function (res) {
        _this.tableData = res.data;
        _this.listLoading = false;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "查询失败，请稍后重试";
          }
          _this.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this.listLoading = false;
      });

      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/countCrmBlacklist",
        params: this.formData
      }).then(function (res) {
        _this.total = res.data;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = "查询失败，请稍后重试";
        }
        _this.$notify({
          title: "失败",
          message: errMsg,
          type: "error"
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(cellValue).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    remove: function remove(id) {
      var _this2 = this;

      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/removeCrmBlacklist",
        params: {
          id: id
        }
      }).then(function (res) {
        _this2.getData();
        _this2.$notify({
          title: "成功",
          message: "移除黑名单成功",
          type: "success"
        });
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = "操作失败，请稍后重试";
        }
        _this2.$notify({
          title: "失败",
          message: errMsg,
          type: "error"
        });
      });
    },
    downloadTmp: function downloadTmp() {
      var _this3 = this;

      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/downloademplate"
      }).then(function (res) {
        if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this3, "error", err.response, "查询失败，请稍后重试");
      });
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      console.log("222", fileList);
      if (response.message == "操作成功") {
        this.getData();
        this.uploadDialog = false;
      }
      this.$alert(response.message, "提示", {
        dangerouslyUseHTMLString: true
        // callback() {
        //   this.uploadDialog = false;
        // },
      });
    },
    handleError: function handleError(err, response, file) {
      var _this4 = this;

      var msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, "提示", {
        dangerouslyUseHTMLString: true,
        callback: function callback(action) {
          _this4.uploadDialog = false;
        }
      });
    },
    exportData: function exportData() {
      var _this5 = this;

      this.listLoading = true;
      this.$http({
        method: "get",
        url: "/rest/CrmBlacklist/export",
        params: {
          idcard: this.formData.idcard,
          name: this.formData.salemansName,
          qhrStatus: this.formData.qhrStatus,
          empPk: this.formData.empPk
        }
      }).then(function (res) {
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        _this5.listLoading = false;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "导出失败，请稍后重试";
          }
          _this5.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this5.listLoading = false;
      });
    },

    //点击确定
    aaa: function aaa() {
      var _this6 = this;

      // this.formatDate.cardId,
      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/addBlack",
        data: {
          cardId: this.formData.cardId,
          reason: this.formData.reason,
          name: this.formData.name0,
          operatorId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "success", res.data.message);
          _this6.uploadDialogi = false;
        }
        if (res && res.data && (res.data.code == 1 || res.data.code == null)) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "error", res.data.message);
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "error", err.response, "新增失败，请稍后重试");
      });
    },

    // action="/rest/CrmBlacklist/importBlackList"
    //                               :before-upload="handlePreview"
    //                               :on-success='handleSuccess'
    //                               :on-error='handleError'
    //                               :show-file-list="false"
    submitUpload: function submitUpload() {
      // operatorId: sessionStorage.getItem('sysUserId')
      console.log(this.openid);
      this.$refs.upload.submit();
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(2);

      console.log(file, fileList);
    },
    handlePreview: function handlePreview(file) {
      console.log(3);

      console.log(file);
    },
    exceed: function exceed(files, fileList) {
      // this.$refs.upload.clearFiles();
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, "warning", "只能上传一个文件,请删除后重新上传！");
    },
    handleUpload: function handleUpload() {
      console.log(111);
      this.$refs.upload.clearFiles();
    }
  }
});

/***/ }),

/***/ "/25y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"out flex_center"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"flex_center"},[_c('img',{staticClass:"one",attrs:{"src":__webpack_require__("bDEP")}}),_vm._v(" "),_c('div',{staticClass:"two",staticStyle:{"color":"#0da4e9","font-size":"26px","text-align":"center"}},[_vm._v("\n      您的租户用户无权登录CRM系统，"),_c('br'),_c('br'),_vm._v("请联系IT管理员\n    ")])]),_vm._v(" "),_c('div',{staticClass:"login-a1",staticStyle:{"text-align":"center"},attrs:{"onclick":"window.open('https://beian.miit.gov.cn')"}},[_c('h1',[_vm._v("普乐师（上海）数字科技股份有限公司 沪ICP备16008893号-4")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/5RU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ChN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰7月重写


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TiXi",
  data: function data() {
    return {
      cols: [{ name: '积分', scoreType: 1 }, { name: '星级', scoreType: 2 }, { name: '信用', scoreType: 3 }],
      tableData: [],
      loading: false,
      message: []
    };
  },

  props: ["isEdit"],
  mounted: function mounted() {
    this.getData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(["changeSystemArr"]), {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      //这个接口跟其他页面无关，数据也能从别的地方过滤出来，作用也就是方便而已，先留着
      this.$http({
        method: "get",
        url: "/rest/ScoreSystemSettings/searchMastName"
      }).then(function (res) {
        _this.tableData = res.data;
        _this.loading = false;
        _this.message = _this.$store.state.systemArr;
      }).catch(function () {
        _this.loading = false;
      });
    },
    changeState: function changeState(masterId, scoreType, masterName) {
      var _this2 = this;

      if (this.isEdit) {
        this.cols.map(function (item) {
          var type = item.scoreType;
          if (scoreType == item.name) {
            _this2.message.push({
              "scoreType": type,
              "masterId": masterId,
              "signId": -1,
              "masterName": masterName
            });
          } else if (scoreType == type) {
            //如果Type 等于1  那么积分就已经被选中 2星级3信用
            _this2.message.map(function (item2, index2) {
              if (item2.masterId == masterId && item2.scoreType == type) {
                _this2.message.splice(index2, 1);
              }
            });
          }
        });
        this.changeSystemArr(this.message);
      }
    }
  })
});

/***/ }),

/***/ "/gWG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_baseCenter_vue__ = __webpack_require__("Vi8a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5634171e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_baseCenter_vue__ = __webpack_require__("Lsem");
function injectStyle (ssrContext) {
  __webpack_require__("ZBqX")
  __webpack_require__("81vo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5634171e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_baseCenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5634171e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_baseCenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0JO2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0mlY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjUxNEFDN0VBREZCMDExRTc4QTJCOUI1OUFGQzg3OUI4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjUxNEFDN0VCREZCMDExRTc4QTJCOUI1OUFGQzg3OUI4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTE0QUM3RThERkIwMTFFNzhBMkI5QjU5QUZDODc5QjgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTE0QUM3RTlERkIwMTFFNzhBMkI5QjU5QUZDODc5QjgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6vh0xgAAACMUlEQVR42mJc03aWAQtgA+IAKLYEYikg/gXET4D4PBCvB+KNUDEUwILFsEAg7gJiFSyWaEBxJBDfAeJyIF6HrIgJic0MxJ1QBSoMhAFIzVqoHmZsLmwD4jIG0gFMTzmyC0PwGSYqx8sgKs9LyNAQmIGgsOnHp1rVXIxB1UyMkEsngMwCGRgKxDK4VIkr8TG8e/qV4d2zr2A2HiANxGEs0KSBAhiZGBm4+NkYeATZGVRNxRhOrL8PFrcMVgLTX97/ZPj28RfD/3//0bUGgAw0RRbRcZRmEJXlYXh+9yNY0+V9Txn+/PoLlru09wmDgAQXg7AMN4OkCj/Dy/ufGa7sf4qs3QRkoASyyNUDzxj03WQYPr36zvDs9kcU6z8CxUBYUpWfgY2DBawWDUgyoaf2////M1zY+RjoCh4GOR0hjICS1RJkEAHKXdj1GKwWHYAMfI4thG+fesUgpoAZCRLK/GA5HOA5yMBL2GT4xDiB3vvGwMTMyKBsLMqgbCQKZn968wMshwOcARm4AZsMvygHA58IJ4NNuAo4Uv78/stgHabCwCvEDpbDATaAImU1EHegp0UWNmaGt0+/MJzb8Q6ePB5dfc8gryvEwMnLhs0wUHSvZoFGShEQr0KWvX4EM2hBBj+4+BaX6wqB+CcsL4Nc2c1APuiGmoFSfFUC8RQyDJsK1YtRHoKyQy601LhDhEF3oOVADlQvzhIbVGhuhioGld7G0IwPC/iz0CpgNbYqACDAAEl6ns/SdIS9AAAAAElFTkSuQmCC"

/***/ }),

/***/ "1BE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__ = __webpack_require__("hhm8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      // 是否有编辑权限
      editAuth: false,
      // 公司下拉列表
      companiesAll: [],
      // 落地方下拉列表
      suppliersAll: [],
      // 落地方开户行下拉列表
      openBanks: [],
      // 落地方开户行账号下拉列表
      openBankNos: [],
      // 落地方开户行下拉列表
      serviceOpenBanks: [],
      // 落地方开户行账号下拉列表
      serviceOpenBankNos: [],
      // 服务商下拉列表
      servicesAll: [],

      // 虚拟项目页面加载
      listLoading: false,
      // 虚拟项目列表查询条件
      formConditionData: {
        pageNo: 1,
        pageSize: 10
      },
      // 虚拟项目编辑信息
      addData: {
        id: null,
        projectCode: null,
        projectName: null,
        serviceSupplier: null,
        status: null,
        company: null,
        batchNo: null
      },
      // 虚拟项目列表数据
      tableData: [],
      // 虚拟项目总数
      total: null,
      // 虚拟项目编辑弹出框
      showAddDialog: false,

      // 供应商列表加载
      supplierListLoading: false,
      // 供应商列表查询条件
      supplierConditionData: {
        projectCode: null,
        pageNo: 1,
        pageSize: 10
      },
      // 供应商列表数据
      supplierTableData: [],
      // 供应商总数
      supplierTotal: null,
      // 供应商列表弹出框
      showSupplierDialog: false,
      // 供应商编辑弹出框
      showSupplierEditDialog: false

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'showSupplierEditDialog', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'supplierProjectCode', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'editSupplierData', {
      id: null,
      projectCode: null,
      supplier: null,
      supplierBank: null,
      supplierBankAccount: null,
      beginDate: null,
      endDate: null,
      service: null,
      serviceOpenBank: null,
      serviceOpenBankCardNo: null
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'editSupplierFlag', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceSuppliers', []), _ref;
  },
  mounted: function mounted() {
    this.getEditVirtualProjectAuth();
    this.searchCompaniesAll();
    this.searchSuppliersAll();
    this.searchServicesAll();
    this.getData();
    this.getServiceSuppliers();
  },

  methods: {
    /**
     * 判断是否有编辑权限
     */
    getEditVirtualProjectAuth: function getEditVirtualProjectAuth() {
      var _this = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/edit-auth'
      }).then(function (res) {
        _this.editAuth = res.data.data;
      }).catch(function (err) {});
    },

    /**
     * 查询虚拟项目维护列表数据
     */
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/list',
        params: this.formConditionData
      }).then(function (res) {
        _this2.tableData = res.data.data.items;
        _this2.total = res.data.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
      });
    },

    /**
     * 查询公司下拉列表
     */
    searchCompaniesAll: function searchCompaniesAll() {
      var _this3 = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/companies'
      }).then(function (res) {
        _this3.companiesAll = res.data.data;
      }).catch(function (err) {});
    },

    /**
     * 查询落地方下拉列表
     */
    searchSuppliersAll: function searchSuppliersAll() {
      var _this4 = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/suppliers-all'
      }).then(function (res) {
        _this4.suppliersAll = res.data.data;
      }).catch(function (err) {});
    },

    /**
    * 查询服务商下拉列表
    */
    searchServicesAll: function searchServicesAll() {
      var _this5 = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/services-all'
      }).then(function (res) {
        _this5.servicesAll = res.data.data;
      }).catch(function (err) {});
    },

    /**
     * 查询落地方&服务商开户行下拉列表
     * type 1:落地方 2:服务商
     */
    searchOpenBanks: function searchOpenBanks(type) {
      if (type == 1) {
        this.editSupplierData.supplierBank = null;
        this.editSupplierData.supplierBankAccount = null;
        if (!this.editSupplierData.supplier.code) {
          return;
        }
        this.doSearchOpenBanks(this.editSupplierData.supplier.code, type);
      } else if (type == 2) {
        this.editSupplierData.serviceOpenBank = null;
        this.editSupplierData.serviceOpenBankCardNo = null;
        if (!this.editSupplierData.service.code) {
          return;
        }
        this.doSearchOpenBanks(this.editSupplierData.service.code, type);
      }
    },
    doSearchOpenBanks: function doSearchOpenBanks(supplierId, type) {
      var _this6 = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/open-banks',
        params: {
          // supplierId: this.editSupplierData.supplier.code
          supplierId: supplierId
        }
      }).then(function (res) {
        if (type == 1) {
          _this6.openBanks = res.data.data;
        } else if (type == 2) {
          _this6.serviceOpenBanks = res.data.data;
        }
      }).catch(function (err) {});
    },

    /**
     * 查询落地方&服务商开户行账户下拉列表
     * type 1:落地方 2:服务商
     */
    searchOpenBankNos: function searchOpenBankNos(type) {
      if (type == 1) {
        this.editSupplierData.supplierBankAccount = null;
        if (!this.editSupplierData.supplier.code || !this.editSupplierData.supplierBank) {
          return;
        }
        this.doSearchOpenBankNos(this.editSupplierData.supplier.code, this.editSupplierData.supplierBank, type);
      } else if (type == 2) {
        this.editSupplierData.serviceOpenBankCardNo = null;
        if (!this.editSupplierData.service.code || !this.editSupplierData.serviceOpenBank) {
          return;
        }

        this.doSearchOpenBankNos(this.editSupplierData.service.code, this.editSupplierData.serviceOpenBank, type);
      }
    },
    doSearchOpenBankNos: function doSearchOpenBankNos(supplierId, openBank, type) {
      var _this7 = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/open-bank-nos',
        params: {
          // supplierId: this.editSupplierData.supplier.code,
          // openBank: this.editSupplierData.supplierBank
          supplierId: supplierId,
          openBank: openBank
        }
      }).then(function (res) {
        if (type == 1) {
          _this7.openBankNos = res.data.data;
        } else if (type == 2) {
          _this7.serviceOpenBankNos = res.data.data;
        }
      }).catch(function (err) {});
    },

    /**
     *虚拟项目列表分页信息变化
     * @param val
     */
    handleSizeChange: function handleSizeChange(val) {
      this.formConditionData.pageSize = val;
      this.getData();
    },

    /**
     * 虚拟项目列表分页信息变化
     * @param val
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.formConditionData.pageNo = val;
      this.getData();
    },

    /**
     * 打开虚拟项目维护弹出框
     */
    addVirtualProjectDialog: function addVirtualProjectDialog() {
      this.clearAddData();
      this.showAddDialog = true;
    },

    /**
     * 清除页面缓存的编辑虚拟项目数据
     */
    clearAddData: function clearAddData() {
      this.addData = {
        id: null,
        projectCode: null,
        projectName: null,
        status: null,
        company: null,
        batchNo: null
      };
    },

    /**
     * 修改虚拟项目数据
     */
    addVirtualProject: function addVirtualProject() {
      var _this8 = this;

      if (!this.addData.projectCode) {
        alert("未填写项目编号");
        return;
      }
      if (!this.addData.projectName) {
        alert("未填写项目名称");
        return;
      }
      if (!this.addData.serviceSupplier) {
        alert("未选择签约平台");
        return;
      }
      if (!this.addData.company) {
        alert("未选择所属公司");
        return;
      }
      if (!this.addData.batchNo) {
        alert("未填写任务批次");
        return;
      }
      var submitData = {
        id: this.addData.id,
        projectCode: this.addData.projectCode,
        projectName: this.addData.projectName,
        serviceSupplier: this.addData.serviceSupplier,
        status: this.addData.status,
        companyCode: this.addData.company.code,
        companyName: this.addData.company.name,
        batchNo: this.addData.batchNo
      };
      this.listLoading = true;
      var url = '/rest/superviseContract/virtual-project/add';
      if (this.addData.id) {
        url = '/rest/superviseContract/virtual-project/edit';
      }
      this.$http({
        method: 'POST',
        url: url,
        data: submitData
      }).then(function (res) {
        _this8.listLoading = false;
        if (res.data.code == '0' && res.data.status == 200) {
          _this8.showAddDialog = false;
          _this8.clearAddData();
          _this8.getData();
          __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].myNotify(_this8, 'success', res, '操作成功');
        } else {
          __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].myNotify(_this8, 'error', res, '操作失败，请稍后重试');
        }
      }).catch(function (err) {
        _this8.listLoading = false;
        __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].myNotify(_this8, "error", err, '操作失败');
      });
    },

    /**
     * 获取虚拟项目数据
     * @param id
     */
    getVirtualProjectInfo: function getVirtualProjectInfo(id) {
      var _this9 = this;

      this.clearAddData();
      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/get',
        params: {
          id: id
        }
      }).then(function (res) {
        if (res.data.code == '0' && res.data.status == 200 && res.data.data) {
          var info = res.data.data;
          _this9.addData = {
            id: info.id,
            projectCode: info.projectCode,
            projectName: info.projectName,
            serviceSupplier: info.serviceSupplier,
            status: info.status,
            company: {
              code: info.companyCode,
              name: info.companyName
            },
            batchNo: info.batchNo
          };
          _this9.showAddDialog = true;
        }
      }).catch(function (err) {});
    },

    /**
     * 只能输入汉字、英文、数字
     * @param e
     */
    inputLimit1: function inputLimit1(e) {
      e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, "");
    },

    /**
     * 只能输入字母、数字和英文横杠线
     * @param e
     */
    inputLimit2: function inputLimit2(e) {
      e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\-]/g, "");
    },

    /**
     * 只能输入字母、数字、中英文括号、英文横杠线、中英文空格
     * @param e
     */
    inputLimit3: function inputLimit3(e) {
      e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5- ()（）\-]/g, "");
    },

    /**
     * 只能输入字母、数字和英文横杠线
     * @param e
     */
    inputLimit4: function inputLimit4(e) {
      e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\-]/g, "");
    },

    /**
     * 显示供应商维护列表
     * @param projectCode
     */
    supplierListDialog: function supplierListDialog(projectCode) {
      this.supplierConditionData.projectCode = projectCode;
      this.supplierProjectCode = projectCode;
      this.getSupplierList(projectCode);
    },

    /**
     * 查询供应商数据
     * @param projectCode
     */
    getSupplierList: function getSupplierList(projectCode) {
      var _this10 = this;

      this.supplierListLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/supplier/list',
        params: this.supplierConditionData
      }).then(function (res) {
        _this10.supplierTableData = res.data.data.items;
        _this10.supplierTotal = res.data.data.totalItemsCount;
        _this10.supplierListLoading = false;
        _this10.showSupplierDialog = true;
      }).catch(function (err) {
        _this10.supplierListLoading = false;
      });
    },

    /**
     *供应商列表分页信息变化
     * @param val
     */
    handleSupplierSizeChange: function handleSupplierSizeChange(val) {
      this.supplierConditionData.pageSize = val;
      this.getSupplierList(this.supplierProjectCode);
    },

    /**
     * 供应商列表分页信息变化
     * @param val
     */
    handleSupplierCurrentChange: function handleSupplierCurrentChange(val) {
      this.supplierConditionData.pageNo = val;
      this.getSupplierList(this.supplierProjectCode);
    },

    /**
     * 清除页面缓存编辑供应商维护数据
     */
    clearEditSupplierData: function clearEditSupplierData() {
      this.editSupplierData = {
        id: null,
        projectCode: null,
        supplierCode: null,
        supplierName: null,
        supplierBank: null,
        supplierBankAccount: null,
        beginDate: null,
        endDate: null,
        service: null,
        serviceOpenBank: null,
        serviceOpenBankCardNo: null
      };
    },

    /**
     * 打开编辑供应商弹出框
     * @param id
     */
    editSupplierDialog: function editSupplierDialog(id) {
      var _this11 = this;

      this.clearEditSupplierData();
      if (id) {
        // 编辑
        this.editSupplierFlag = true;
        this.editSupplierData.id = id;
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/supplier/get',
          params: { id: id }
        }).then(function (res) {
          if (res.data.code == '0' && res.data.status == 200 && res.data.data) {
            var info = res.data.data;
            _this11.editSupplierData = {
              id: info.id,
              projectCode: info.projectCode,
              supplier: {
                name: info.supplierName,
                code: info.supplierCode
              },
              service: {
                name: info.serviceNm,
                code: info.serviceId
              },
              supplierBank: info.supplierBank,
              supplierBankAccount: info.supplierBankAccount,
              beginDate: info.beginDate,
              endDate: info.endDate,
              serviceOpenBank: info.serviceOpenBank,
              serviceOpenBankCardNo: info.serviceOpenBankCardNo
            };
            _this11.doSearchOpenBanks(_this11.editSupplierData.supplier.code, 1);
            _this11.doSearchOpenBanks(_this11.editSupplierData.service.code, 2);

            _this11.doSearchOpenBankNos(_this11.editSupplierData.supplier.code, _this11.editSupplierData.supplierBank, 1);
            _this11.doSearchOpenBankNos(_this11.editSupplierData.service.code, _this11.editSupplierData.serviceOpenBank, 2);

            _this11.showSupplierEditDialog = true;
          }
        });
      } else {
        // 新增
        this.editSupplierFlag = false;
        this.showSupplierEditDialog = true;
      }
    },

    /**
     * 修改供应商数据
     */
    editSupplier: function editSupplier() {
      var _this12 = this;

      if (!this.supplierProjectCode) {
        alert("虚拟性项目信息错误，请刷新页面");
        return;
      }
      if (!this.editSupplierFlag && !this.editSupplierData.supplier) {
        alert("未选择供应商");
        return;
      }
      if (!this.editSupplierFlag && !this.editSupplierData.supplierBank) {
        alert("未选择开户行");
        return;
      }
      if (!this.editSupplierFlag && !this.editSupplierData.supplierBankAccount) {
        alert("未选择银行账号");
        return;
      }
      if (!this.editSupplierData.beginDate) {
        alert("未选择开始日期");
        return;
      }
      if (!this.editSupplierData.endDate) {
        alert("未选择结束日期");
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].compareDate(this.editSupplierData.beginDate, this.editSupplierData.endDate)) {
        alert("开始日期不能大于结束日期");
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].compareDate(__WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].currentDate(), this.editSupplierData.endDate)) {
        alert("结束日期不能晚于今天");
        return;
      }
      var submitData = {
        id: this.editSupplierData.id,
        projectCode: this.supplierProjectCode,
        supplierCode: this.editSupplierData.supplier.code,
        supplierName: this.editSupplierData.supplier.name,
        supplierBank: this.editSupplierData.supplierBank,
        supplierBankAccount: this.editSupplierData.supplierBankAccount,
        beginDate: this.editSupplierData.beginDate,
        endDate: this.editSupplierData.endDate,
        serviceId: this.editSupplierData.service == null ? null : this.editSupplierData.service.code,
        serviceNm: this.editSupplierData.service == null ? null : this.editSupplierData.service.name,
        serviceOpenBank: this.editSupplierData.serviceOpenBank,
        serviceOpenBankCardNo: this.editSupplierData.serviceOpenBankCardNo
      };
      var url = '/rest/superviseContract/virtual-project/supplier/add';
      if (this.editSupplierFlag) {
        url = '/rest/superviseContract/virtual-project/supplier/edit';
      }
      this.showSupplierEditDialog = true;
      this.$http({
        method: 'POST',
        url: url,
        data: submitData
      }).then(function (res) {
        if (res.data.code == '0' && res.data.status == 200) {
          _this12.showSupplierEditDialog = false;
          __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].myNotify(_this12, 'success', res, '操作成功');
          _this12.getSupplierList(_this12.supplierProjectCode);
        } else {
          __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].myNotify(_this12, 'error', res, '操作失败，请稍后重试');
        }
      }).catch(function (err) {
        _this12.showSupplierEditDialog = false;
        __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].myNotify(_this12, "error", err, '操作失败');
      });
    },
    getServiceSuppliers: function getServiceSuppliers() {
      var _this13 = this;

      this.$http({
        method: 'GET',
        url: '/rest/JiangYiJoint/getServiceSuppliers'

      }).then(function (res) {
        _this13.serviceSuppliers = res.data;
      }).catch(function (err) {});
    }
  }
});

/***/ }),

/***/ "1Q91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postJob_vue__ = __webpack_require__("9/nn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d883a76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postJob_vue__ = __webpack_require__("2wgl");
function injectStyle (ssrContext) {
  __webpack_require__("Z12W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d883a76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postJob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d883a76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postJob_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1QZ/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1xE0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "23pr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_filterParam__ = __webpack_require__("cPAl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_filterTag__ = __webpack_require__("PUCp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilterParam: __WEBPACK_IMPORTED_MODULE_0_components_filterParam__["a" /* default */],
    FilterTag: __WEBPACK_IMPORTED_MODULE_1_components_filterTag__["a" /* default */]
  },
  data: function data() {
    return {
      educationList: [],
      starLevelList: [],
      channelList: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      loading: false,
      userIsPLUS: true,
      page: 1
    };
  },

  props: ['webId'],
  mounted: function mounted() {
    var _this = this;

    this.userIsPLUS = Boolean(sessionStorage.getItem('user'));
    this.loading = true;

    // 学历
    this.$http({
      method: 'POST',
      url: '/rest/salesman/getEducation'
    }).then(function (res) {
      _this.educationList = res.data;
    }).catch(function (err) {
      var errMsg = void 0;
      if (err.response.message) {
        errMsg = err.response.message;
      } else {
        errMsg = '查询失败，请稍后重试';
      }
      _this.$notify({
        title: '失败',
        message: errMsg,
        type: 'error'
      });
    });
    if (this.userIsPLUS) {
      // 星级
      this.$http({
        method: 'POST',
        url: '/rest/salesman/getStarLevel'
      }).then(function (res) {
        _this.starLevelList = res.data;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询失败，请稍后重试';
        }
        _this.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        });
      });

      // 服务渠道
      this.$http({
        method: 'POST',
        url: '/rest/salesman/getChannel'
      }).then(function (res) {
        _this.channelList = res.data;
        _this.loading = false;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询失败，请稍后重试';
        }
        _this.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        });
      });
    }
  },

  methods: {
    tabClick: function tabClick(tab) {
      var _this2 = this;

      if (tab.label === '全部人员' && this.page != 1) {
        this.page = 1;
        setTimeout(function () {
          //好像是可以在FilterParam中赋值pageNo和size
          _this2.$refs['fp1'].resetForm('paramForm');
          var x = _this2.$refs['fp1'].paramForm;
          x.pageNo = 1;
          x.pageSize = 48;
          _this2.$emit('filterParam', x);
        }, 10);
      } else if (tab.label === '筛选长促' && this.page != 2) {
        this.page = 2;
        setTimeout(function () {
          _this2.$refs['fp2'].resetForm('paramForm');
          var x = _this2.$refs['fp2'].paramForm;
          x.pageNo = 1;
          x.pageSize = 48;
          _this2.$emit('filterParam', _this2.$refs['fp2'].paramForm);
        }, 10);
      } else if (tab.label === '筛选短促' && this.page != 3) {
        this.page = 3;
        setTimeout(function () {
          _this2.$refs['fp3'].resetForm('paramForm');
          var x = _this2.$refs['fp3'].paramForm;
          x.pageNo = 1;
          x.pageSize = 48;
          _this2.$emit('filterParam', _this2.$refs['fp3'].paramForm);
        }, 10);
      }
    },
    getParam: function getParam(data) {
      data.pageNo = 1;
      data.pageSize = 48;
      this.$emit('filterParam', data);
    }
  }
});

/***/ }),

/***/ "25n0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zScore_vue__ = __webpack_require__("ax23");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ae6b5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zScore_vue__ = __webpack_require__("qGYF");
function injectStyle (ssrContext) {
  __webpack_require__("JccC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6ae6b5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ae6b5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "26dS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("iFcm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68babc92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("WAyp");
function injectStyle (ssrContext) {
  __webpack_require__("IZle")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68babc92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68babc92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2E37":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "2f6u":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkYyMUJENUI0REZBRTExRTdBNEVDQjlBOThEODExQjE1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkYyMUJENUI1REZBRTExRTdBNEVDQjlBOThEODExQjE1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjIxQkQ1QjJERkFFMTFFN0E0RUNCOUE5OEQ4MTFCMTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjIxQkQ1QjNERkFFMTFFN0E0RUNCOUE5OEQ4MTFCMTUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6DMkZuAAABsklEQVR42mJsmnmbAQtgA+IAKLYEYikg/gXET4D4PBCvB+KNUDEUwILFsEAg7gJiFSyWaEBxJBDfAeJyIF6HrIgJic0MxJ1QBSoMhAFIzVqoHmZsLmwD4jIG0gFMTzmyC0PINAzZ0BCYC0Fh048s6+cgzqCnysvAyIjbhHtPvjEs3fYMWWgCEG8CGRgKxDLIMiDDWmbfweuk2jSMYJYG4jAWaNJAASCXYdFADAgAGWiKTaZ5FskuBAETUKRIEGu9lCg7Q7SXFL6wlWTCltphQFGaE64ZxI7wkGI4ffUjw///uC0Fefk5EPNiC0drA0EGI01+hpsPvjK4WYowrNn9guHRi+/4PPEc5MJL2GRArli+4zkDyIGuFiIMS7c+JWQYCJwBuXADLFEiGwYCf//+Z1i79wUDDycLw+dvfxiwqUEDG0AGrgbiDuS0ePn2Z4aaVBWcgQ8y7BJQDRp4CjKLEVp8gRL3KgbKQBjIQFheBrmymwLDuqFmoBRflUA8hQzDpkL1YpSHf4E4FxpBd4gw6A40qHKgenGW2KBCczNUMaj0NoZmfFjAn4VWAauxZQqAAAMAMSJu7fea4NkAAAAASUVORK5CYII="

/***/ }),

/***/ "2hsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"headerWrap"},[_c('router-link',{staticClass:"systemTitle pointer",attrs:{"to":"/SystemConfig","tag":"span"}},[_vm._v("< 返回上一页")]),_vm._v(" "),_c('div',{staticClass:"breadcrumb"},[_c('span',{staticClass:"currPage"},[_vm._v("配置历史查询")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("评估体系")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("体系配置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("配置历史查询")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"tableWrap",staticStyle:{"padding":"20px 20px 0 20px","background-color":"white"}},[_c('el-form',{ref:"form"},[_c('el-form-item',{attrs:{"label":"年份"}},[_c('el-date-picker',{attrs:{"align":"left","type":"year","placeholder":"请选择年份..."},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1)],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"startTime","align":"center","formatter":_vm.formatTime}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作用户","prop":"updatorName","width":"220","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"400","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{staticClass:"pointer mingxi",attrs:{"to":{ path:  '/LookHistoryTwo',  query: { sTime: scope.row.startTime }},"tag":"div"}},[_vm._v("查看配置明细\n            ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"total":_vm.total,"layout":"sizes,total,prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2piF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectCategory_vue__ = __webpack_require__("rvF4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61792500_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projectCategory_vue__ = __webpack_require__("hbbA");
function injectStyle (ssrContext) {
  __webpack_require__("swku")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61792500"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61792500_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projectCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uru":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlENTg5NjZGQzg0ODExRTdBQzJCOEI3QUQ1RjExMEM5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlENTg5NjcwQzg0ODExRTdBQzJCOEI3QUQ1RjExMEM5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUQ1ODk2NkRDODQ4MTFFN0FDMkI4QjdBRDVGMTEwQzkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUQ1ODk2NkVDODQ4MTFFN0FDMkI4QjdBRDVGMTEwQzkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4fDmLwAAAA90lEQVR42mJs3NPEQAlgIkGtOBDfAuLFQMxMqgEgDfOBOBuInwPxHJgEC5EGFAPxYSDeDcW3SXWBIxDfg7I1gPgOqS7IBOLzQLwXiKcCcRmpLqgA4llAnATEJ4H4LCkGVAKxJNR2XyBuQJYk5IVGIDYEYlBiWQDEHkD8C1c6AEVVNRAfBWJdIF4ExEpAXAuNwkggfoIrIUkA8TYg/gvEzUC8D4gvAvEKIF4IxOFAfBmbE2FeOAHEeUC8CcpXgwZcMBB7A/FTQkl5AxD7Q/n60MTyH4jt8WlGdkEhEHcB8TOoU9OA+Bwx8QszAGRbKRTTLDdiBQABBgCK7y+97GWOOwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "2wgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"systemNav"},[_c('div',{staticClass:"systemNavWrap"},[_c('div',{class:{'isActive': _vm.navState == 1 && !_vm.isModify,'modifyIsActive': _vm.navState >= 1 && _vm.isModify == true},on:{"click":function($event){_vm.navState = 1}}},[_c('span',[_c('img',{attrs:{"src":_vm.iconList.iconaddjobs,"alt":""}}),_vm._v("添加岗位")])]),_vm._v(" "),(_vm.isModify)?_c('i',{staticClass:"el-icon-arrow-right",class:{'changeColor': _vm.isModify == true && _vm.navState > 1}}):_vm._e(),_vm._v(" "),_c('div',{class:{'isActive' : _vm.navState == 2 && !_vm.isModify,'modifyIsActive': _vm.navState >= 2 && _vm.isModify == true},on:{"click":_vm.checkTabStore}},[_c('span',[_c('img',{attrs:{"src":_vm.iconList.iconselectstore,"alt":""}}),_vm._v("选择门店")])]),_vm._v(" "),(_vm.isModify)?_c('i',{staticClass:"el-icon-arrow-right",class:{'changeColor': _vm.isModify == true && _vm.navState > 2}}):_vm._e()])]),_vm._v(" "),_c('div',[(_vm.navState == 1)?_c('AddWorks',{ref:"addWorks",on:{"check-store":_vm.checkStore,"resetThis":_vm.resetAddWorks}}):_vm._e(),_vm._v(" "),(_vm.navState == 2)?_c('ChooseStore',{attrs:{"jobInformation":_vm.jobInformation,"proDuringTime":_vm.proDuringTime},on:{"ReceiveState":_vm.receiveState}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Tmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonLibrary_vue__ = __webpack_require__("iIyU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b147d5e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonLibrary_vue__ = __webpack_require__("nvWJ");
function injectStyle (ssrContext) {
  __webpack_require__("yDw1")
  __webpack_require__("fx2k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b147d5e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b147d5e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ele":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_formRules__ = __webpack_require__("8jay");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  props: ['isEdit'],
  data: function data() {
    var checkNum = function checkNum(rule, value, callback) {
      if (isNaN(Number(value))) {
        callback(new Error('*'));
      } else if (value == '') {
        callback(new Error('*'));
      } else {
        callback();
      }
    };
    return {
      startTime: this.$store.state.startTime,
      tableData: [],
      starSetArr: [],
      infoArr: [],
      starArr: [],
      danXuanArr: [],
      num: 1,
      loading: false,
      rules: {
        score: [__WEBPACK_IMPORTED_MODULE_2__common_js_formRules__["a" /* default */].number, { required: true, message: '分值不能为空', trigger: 'blur' }]
      },
      judgeArr: []
    };
  },
  mounted: function mounted() {
    this.getVuex();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeXinYongArr', 'changeSortPro']), {
    getVuex: function getVuex() {
      var _this = this;

      var danXuanArr = [];
      var duoXuanArr = [];
      var exceptArr = [118, 119, 120, 121, 122, 123, 124, 125, 127, 128, 129, 130, 131];
      this.tableData = this.$store.state.xinYongArr;

      //初始化单选和多选项目（不可选择长短促的那种）
      this.$store.state.systemArr.map(function (item, index) {
        if (item.scoreType == 3) {
          if (exceptArr.indexOf(item.masterId) < 0) {
            duoXuanArr.push(item);
          } else {
            danXuanArr.push(item);
          }
        }
      });
      danXuanArr.map(function (item, index) {
        _this.tableData.map(function (item2, index) {
          if (item.masterId == item2.masterId) {
            item.score = item2.score;
            item.longSign = item2.longSign;
            item.shortSign = item2.shortSign;
            item.signId = item2.signId;
          }
        });
      });
      duoXuanArr.map(function (item, index) {
        _this.$set(_this.infoArr, index, {
          masterId: item.masterId,
          masterName: item.masterName,
          long: [],
          short: []
        });
      });
      this.danXuanArr = danXuanArr;
      this.starArr = duoXuanArr;

      this.tableData.map(function (item, index) {
        _this.infoArr.map(function (item2, index2) {
          if (item2.masterId == item.masterId) {
            if (item.signId == 1) {
              item2.long.push(item);
            } else if (item.signId == 2) {
              item2.short.push(item);
            }
          }
        });
      });
    },
    changeState: function changeState(masterId, choose) {
      this.num++;
      this.infoArr.map(function (item, index) {
        if (item.masterId == masterId) {
          var type = '';
          if (choose == 1) {
            type = 'long';
          } else if (choose == 2) {
            type = 'short';
          }
          if (item[type].length > 0) {
            item[type] = [];
          } else {
            item[type].push({
              scoreMax: '',
              scoreMin: '',
              score: '',
              signId: choose,
              "scoreType": 3
            });
          }
        }
      });
      this.save();
    },
    addInfo: function addInfo(masterId, signId) {
      var _this2 = this;

      this.num++;
      this.infoArr.map(function (item, index) {
        if (item.masterId == masterId) {
          var type = '';
          if (signId == 1) {
            type = 'long';
          } else if (choose == 2) {
            type = 'short';
          }
          item[type].push({
            "masterId": masterId,
            "scoreMax": '',
            "scoreMin": '',
            "score": '',
            "scoreType": 2,
            "startTime": _this2.startTime,
            "signId": signId
          });
        }
      });
      this.save();
    },
    reduceInfo: function reduceInfo(masterId, signId) {
      this.num++;
      this.infoArr.map(function (item, index) {
        if (item.masterId == masterId) {
          if (signId == 1) {
            item.long.splice(item.long.length - 1, 1);
          } else if (signId == 2) {
            item.short.splice(item.short.length - 1, 1);
          }
        }
      });
      this.save();
    },
    changeMan: function changeMan(type, item) {
      if (type == 1) {
        item.longSign = !item.longSign;
      } else if (type == 2) {
        item.shortSign = !item.shortSign;
      }
      this.save();
    },
    save: function save() {
      var _this3 = this;

      this.changeSortPro(this.infoArr);
      var arr = [];
      this.infoArr.map(function (item, index) {
        item.long.map(function (item2, index2) {
          arr.push({
            masterId: item.masterId,
            scoreMax: item2.scoreMax,
            scoreMin: item2.scoreMin,
            signId: item2.signId,
            score: item2.score,
            scoreType: 3,
            startTime: _this3.startTime
          });
        });
        item.short.map(function (item2, index2) {
          arr.push({
            masterId: item.masterId,
            scoreMax: item2.scoreMax,
            scoreMin: item2.scoreMin,
            signId: item2.signId,
            score: item2.score,
            scoreType: 3,
            startTime: _this3.startTime
          });
        });
      });

      this.danXuanArr.map(function (item, index) {
        if (item.longSign == true && item.shortSign == true) {
          item.signId = 0;
        } else if (item.longSign == true && item.shortSign == false) {
          item.signId = 1;
        } else if (item.longSign == false && item.shortSign == true) {
          item.signId = 2;
        } else {
          item.signId = -1;
        }
      });

      this.danXuanArr.map(function (item, index) {
        arr.push(item);
      });
      this.changeXinYongArr(arr);
    }
  })
});

/***/ }),

/***/ "3kNb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3t46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_E_scoreDetailed_vue__ = __webpack_require__("I4rS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14111737_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_E_scoreDetailed_vue__ = __webpack_require__("J9Qr");
function injectStyle (ssrContext) {
  __webpack_require__("lzcG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14111737"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_E_scoreDetailed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14111737_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_E_scoreDetailed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3vnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreeProject_vue__ = __webpack_require__("mIHl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd28506_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreeProject_vue__ = __webpack_require__("b7sq");
function injectStyle (ssrContext) {
  __webpack_require__("qSDM")
  __webpack_require__("o8LF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cd28506"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreeProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd28506_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreeProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4AQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterTab_vue__ = __webpack_require__("23pr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19af08e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterTab_vue__ = __webpack_require__("SP5C");
function injectStyle (ssrContext) {
  __webpack_require__("KLML")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19af08e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19af08e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4N/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Whitelist_vue__ = __webpack_require__("9vWQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_090ca97c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Whitelist_vue__ = __webpack_require__("ZlSl");
function injectStyle (ssrContext) {
  __webpack_require__("Wpm7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-090ca97c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Whitelist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_090ca97c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Whitelist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4QAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login2"},[_c('div',{staticClass:"wrap"},[_c('el-form',{ref:"numberValidateForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.numberValidateForm,"rules":_vm.rules2,"label-width":"100px"}},[_c('div',{staticClass:"title"},[_c('div',[_vm._v("宝洁CRM")]),_vm._v(" "),_c('div',[_vm._v("通过验证后才能浏览该网站内容")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("+FwL"),"alt":""}})]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"checkPass"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","placeholder":"请输入密码"},nativeOn:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.submitForm('numberValidateForm')}},model:{value:(_vm.numberValidateForm.checkPass),callback:function ($$v) {_vm.$set(_vm.numberValidateForm, "checkPass", $$v)},expression:"numberValidateForm.checkPass"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{on:{"click":function($event){return _vm.submitForm('numberValidateForm')}}},[_vm._v("登陆")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4inT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bankCard-img.0e2941b.png";

/***/ }),

/***/ "4lWj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4xzm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "50tf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_XingJI_vue__ = __webpack_require__("zN4F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca3def6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XingJI_vue__ = __webpack_require__("bo56");
function injectStyle (ssrContext) {
  __webpack_require__("Uhh2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca3def6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_XingJI_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca3def6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XingJI_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "59bP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"1260px","center":true,"show-close":true,"visible":_vm.visiable,"top":"5vh","title":"注销记录"},on:{"update:visible":function($event){_vm.visiable=$event}}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"150px","size":"mini"}},[_c('div',{staticClass:"slide-wrap",staticStyle:{"height":"auto"}},[_c('el-form-item',{attrs:{"label":"促销员姓名："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员姓名...","maxlength":30},model:{value:(_vm.param.name),callback:function ($$v) {_vm.$set(_vm.param, "name", $$v)},expression:"param.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员身份证号码："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员身份证号码...","maxlength":30},model:{value:(_vm.param.idcard),callback:function ($$v) {_vm.$set(_vm.param, "idcard", $$v)},expression:"param.idcard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态："}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择...","clearable":""},model:{value:(_vm.param.status),callback:function ($$v) {_vm.$set(_vm.param, "status", $$v)},expression:"param.status"}},[_c('el-option',{attrs:{"label":"注销中","value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":"撤回注销","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已注销","value":2}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID...","maxlength":30},model:{value:(_vm.param.empPk),callback:function ($$v) {_vm.$set(_vm.param, "empPk", $$v)},expression:"param.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员手机号："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员手机号...","maxlength":30},model:{value:(_vm.param.tel),callback:function ($$v) {_vm.$set(_vm.param, "tel", $$v)},expression:"param.tel"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"float":"right","margin-right":"50px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},attrs:{"loading":_vm.btnLoading},on:{"click":function($event){return _vm.exportData()}}},[_vm._v("导出")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"mini","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"width":"50","type":"index","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"minWidth":"100","prop":"name","label":"促销员姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","minWidth":"100","label":"促销员ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"tel","label":"手机号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"idcard","label":"身份证号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"applyTime","label":"申请注销时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"状态","align":"center","prop":"statusName"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"revokeApplyTime","label":"撤回注销申请时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row.revokeApplyTime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"cancelApplyTime","label":"注销时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row.cancelApplyTime)))])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5hXt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_greyList_vue__ = __webpack_require__("kng/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb178b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_greyList_vue__ = __webpack_require__("ElhU");
function injectStyle (ssrContext) {
  __webpack_require__("dWM0")
  __webpack_require__("ddas")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bb178b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_greyList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb178b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_greyList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5l3o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6+Wg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: null,
      year: new Date()
    };
  },
  mounted: function mounted() {
    this.submitForm();
  },

  methods: {
    getData: function getData(refresh) {
      var _this = this;

      var year = this.year ? new Date(this.year).getFullYear() : null;
      if (refresh) this.pageNo = 1;
      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/searchHistory',
        params: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          year: year
        }
      }).then(function (res) {
        _this.tableData = res.data;
      });
      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/countSearchHistory',
        params: {
          year: year
        }
      }).then(function (res) {
        _this.total = res.data;
      });
    },
    handleSizeChange: function handleSizeChange(value) {
      this.pageSize = value;
      this.getData(false);
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.pageNo = value;
      this.getData(false);
    },
    formatTime: function formatTime(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(cellValue).format('YYYY-MM-DD');
    },
    submitForm: function submitForm() {
      this.getData(true);
    }
  }
});

/***/ }),

/***/ "6EgS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"90px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号","prop":"projectCode"}},[_c('el-input',{attrs:{"placeholder":"请输入项目编号..."},model:{value:(_vm.formData.projectCode),callback:function ($$v) {_vm.$set(_vm.formData, "projectCode", $$v)},expression:"formData.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectName"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称..."},model:{value:(_vm.formData.projectName),callback:function ($$v) {_vm.$set(_vm.formData, "projectName", $$v)},expression:"formData.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台","prop":"serviceSupplier"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择签约平台..."},model:{value:(_vm.formData.serviceSupplier),callback:function ($$v) {_vm.$set(_vm.formData, "serviceSupplier", $$v)},expression:"formData.serviceSupplier"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.serviceSuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"服务商","prop":"serviceId"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择服务商..."},model:{value:(_vm.formData.serviceId),callback:function ($$v) {_vm.$set(_vm.formData, "serviceId", $$v)},expression:"formData.serviceId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.allService),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"落地方","prop":"supplierId"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择落地方..."},model:{value:(_vm.formData.supplierId),callback:function ($$v) {_vm.$set(_vm.formData, "supplierId", $$v)},expression:"formData.supplierId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.allSupplier),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.resetForm}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.submitForm}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"0px"},on:{"click":_vm.exportExcel}},[_vm._v("导出")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectCode","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectStartTime","label":"项目开始时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectEndTime","label":"项目结束时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceSupplier","label":"签约平台","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"configurationTime","label":"签约配置时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceNm","label":"服务商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierNm","label":"落地方","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierStartDate","label":"落地方开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierEndDate","label":"落地方结束日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operatorAccount","label":"修改人账号","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":'修改任务批次：' + _vm.editCustomer,"visible":_vm.showEditDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.showEditDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_vm._v("当前期任务批次：")]),_vm._v(" "),_c('div',[_c('el-input',{model:{value:(_vm.editSuffix),callback:function ($$v) {_vm.editSuffix=$$v},expression:"editSuffix"}})],1)]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px","margin-top":"20px"}},[_vm._v("下一期任务批次：")]),_vm._v(" "),_c('div',[_c('el-input',{model:{value:(_vm.nextEditSuffix),callback:function ($$v) {_vm.nextEditSuffix=$$v},expression:"nextEditSuffix"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.editCustomerConfig}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showEditDialog=false}}},[_vm._v("取消")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6ha/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.Loading),expression:"Loading"}],staticClass:"postTask",staticStyle:{"overflow":"hidden"}},[_c('el-row',{staticClass:"common-box",staticStyle:{"width":"49%"}},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("任务信息")])]),_vm._v(" "),_c('el-form',{ref:"F_taskInfo",staticClass:"F_taskInfo",staticStyle:{"padding":"13px 15px 21px 15px"},attrs:{"model":_vm.taskInfo,"label-width":"80px"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务标题")]),_vm._v(" "),_c('el-input',{staticClass:"wid60",attrs:{"size":"mini","placeholder":"请输入任务标题...","maxlength":30,"clearable":""},model:{value:(_vm.taskInfo.title),callback:function ($$v) {_vm.$set(_vm.taskInfo, "title", $$v)},expression:"taskInfo.title"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务类型")]),_vm._v(" "),_c('el-select',{staticClass:"wid60",attrs:{"size":"mini","placeholder":"请选择任务类型...","clearable":true,"clearable":""},model:{value:(_vm.taskInfo.type),callback:function ($$v) {_vm.$set(_vm.taskInfo, "type", $$v)},expression:"taskInfo.type"}},_vm._l((_vm.taskInfo.options.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务参与时间")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"27.8%"},attrs:{"type":"date","size":"mini","format":"yyyy 年 MM 月 dd 日","placeholder":"任务开始时间"},model:{value:(_vm.taskInfo.during.start),callback:function ($$v) {_vm.$set(_vm.taskInfo.during, "start", $$v)},expression:"taskInfo.during.start"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","width":"10%","text-align":"center"}},[_vm._v("—")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"30%"},attrs:{"type":"date","size":"mini","format":"yyyy 年 MM 月 dd 日","placeholder":"任务结束时间"},model:{value:(_vm.taskInfo.during.end),callback:function ($$v) {_vm.$set(_vm.taskInfo.during, "end", $$v)},expression:"taskInfo.during.end"}})],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务审核时间")]),_vm._v(" "),_c('el-select',{staticClass:"wid60",attrs:{"size":"mini","placeholder":"请选择...","clearable":""},model:{value:(_vm.taskInfo.auditTime),callback:function ($$v) {_vm.$set(_vm.taskInfo, "auditTime", $$v)},expression:"taskInfo.auditTime"}},_vm._l((_vm.taskInfo.options.auditTime),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("完成时限")]),_vm._v(" "),_c('el-select',{staticClass:"wid60",attrs:{"size":"mini","placeholder":"请选择...","clearable":""},model:{value:(_vm.taskInfo.deadline),callback:function ($$v) {_vm.$set(_vm.taskInfo, "deadline", $$v)},expression:"taskInfo.deadline"}},_vm._l((_vm.taskInfo.options.deadline),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务描述")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"77.5%","margin":"8px 0 7px 0"},attrs:{"type":"textarea","rows":4,"maxlength":300,"size":"mini","placeholder":"请描述是否有社保相关福利待遇情况..."},model:{value:(_vm.taskInfo.details),callback:function ($$v) {_vm.$set(_vm.taskInfo, "details", $$v)},expression:"taskInfo.details"}})],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务预算")]),_vm._v(" "),_c('el-input',{staticClass:"wid60",attrs:{"size":"mini","placeholder":"请输入预算金额...","maxlength":30,"clearable":""},model:{value:(_vm.taskInfo.budget),callback:function ($$v) {_vm.$set(_vm.taskInfo, "budget", $$v)},expression:"taskInfo.budget"}},[_c('template',{slot:"append"},[_vm._v("元")])],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"common-box",staticStyle:{"width":"49%","margin-left":"2%"}},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("文件上传")])]),_vm._v(" "),_c('el-form',{ref:"F_taskFile",staticClass:"F_taskFile",staticStyle:{"padding":"13px 15px"},attrs:{"model":_vm.taskFile,"label-width":"80px"}},[_c('el-row',{staticStyle:{"background":"#f8f8f8"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("上传类型")]),_vm._v(" "),_c('el-select',{staticClass:"wid60",attrs:{"size":"mini","placeholder":"请选择...","clearable":true,"clearable":""},model:{value:(_vm.taskFile.type),callback:function ($$v) {_vm.$set(_vm.taskFile, "type", $$v)},expression:"taskFile.type"}},_vm._l((_vm.taskFile.options.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin":"11px 0"},attrs:{"span":12}},[_c('el-button',{staticStyle:{"margin-right":"5%","float":"right"},attrs:{"type":"primary","round":"","size":"mini","icon":"el-icon-plus"},on:{"click":_vm.addFile}},[_vm._v("添加\n          ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"fileList",attrs:{"id":"fileList"}},_vm._l((_vm.taskFile.fileList),function(item,index){return _c('el-row',{key:index,staticStyle:{"background":"#f8f8f8","margin-top":"8px","padding-right":"2.5%"},nativeOn:{"click":function($event){return _vm.editing(index)}}},[_c('el-row',[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("上传类型")]),_vm._v(" "),_c('b',{staticClass:"formLabel",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","margin":"13px 0","padding":"4px"},attrs:{"type":"primary","icon":"el-icon-close","circle":"","size":"mini "},on:{"click":function($event){return _vm.deleteFile(index)}}})],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-left":"5%"}},[(item.editing)?_c('el-col',{attrs:{"span":14}},[_c('div',[_c('h1',{staticStyle:{"font-size":"20px"}},[_vm._v("请上传"+_vm._s(item.type))]),_vm._v(" "),(item.type == '图片')?_c('p',[_vm._v("图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，")]):(item.type == '视频')?_c('p',[_vm._v("视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，")]):_c('p',[_vm._v("音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，")])])]):_c('el-col',{staticStyle:{"margin-bottom":"5px"},attrs:{"span":14}},[_c('div',[_c('h1',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(item.type)+"描述")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","margin":"8px 0 7px 0"},attrs:{"type":"textarea","rows":4,"maxlength":300,"size":"mini","placeholder":"任务要求..."},model:{value:(item.details),callback:function ($$v) {_vm.$set(item, "details", $$v)},expression:"item.details"}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://jsonplaceholder.typicode.com/posts/","show-file-list":false,"on-success":_vm.uploadSucc,"before-upload":_vm.checkUpload('pic')}},[(item.picUrl)?_c('img',{staticClass:"avatar",attrs:{"src":item.picUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),(item.editing)?_c('el-row',{staticStyle:{"margin-left":"5%"}},[_c('el-input',{staticStyle:{"width":"100%","margin":"8px 0 7px 0"},attrs:{"type":"textarea","rows":3,"maxlength":300,"size":"mini","placeholder":"请描述任务要求..."},model:{value:(item.details),callback:function ($$v) {_vm.$set(item, "details", $$v)},expression:"item.details"}})],1):_vm._e()],1)}),1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("任务参与范围")])]),_vm._v(" "),_c('el-form',{ref:"F_taskScope",staticClass:"F_taskScope",staticStyle:{"padding":"13px 15px"},attrs:{"model":_vm.taskScope,"label-width":"80px"}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_vm._v("门店")]),_vm._v(" "),_c('el-button',{staticClass:"clickSign",attrs:{"type":"success","round":"","size":"mini"},nativeOn:{"click":function($event){return _vm.checkShop.apply(null, arguments)}}},[_vm._v("选择门店")])],1),_vm._v(" "),_c('el-form-item',[_c('el-row',[_c('el-col',{staticStyle:{"width":"112px"}},[_c('span',{staticClass:"formLabel"},[_vm._v("已选门店")])]),_vm._v(" "),_c('el-col',{staticStyle:{"width":"90%"}},_vm._l((_vm.taskScope.ckeckedStores),function(item,index){return _c('span',{key:index,staticClass:"already-btn"},[_vm._v("\n              "+_vm._s(item.name)+"   "+_vm._s(item.num)+"人   ￥"+_vm._s(item.salary)+"\n              "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.deleteckeckedStore(index)}}})])}),0)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-col',{staticStyle:{"width":"112px"}},[_c('span',{staticClass:"formLabel"},[_vm._v("门店距离")])]),_vm._v(" "),_c('el-col',{staticStyle:{"width":"90%"}},[_c('el-radio-group',{attrs:{"size":"small"},model:{value:(_vm.taskScope.storesDistance),callback:function ($$v) {_vm.$set(_vm.taskScope, "storesDistance", $$v)},expression:"taskScope.storesDistance"}},_vm._l((_vm.taskScope.distanceList),function(item,index){return _c('el-radio-button',{key:index,staticClass:"elRadioB",attrs:{"label":item,"border":""}})}),1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("可见范围设定")]),_vm._v(" "),_c('div',[_c('el-checkbox',{attrs:{"label":"在岗时任务不可见"},model:{value:(_vm.visibleScope.noTaskOnDuty),callback:function ($$v) {_vm.$set(_vm.visibleScope, "noTaskOnDuty", $$v)},expression:"visibleScope.noTaskOnDuty"}})],1)]),_vm._v(" "),_c('el-form',{ref:"F_visibleScope",staticClass:"F_visibleScope",staticStyle:{"padding":"13px 15px"},attrs:{"model":_vm.visibleScope,"label-width":"80px"}},[_c('el-col',{staticStyle:{"margin-bottom":"15px"},attrs:{"span":6}},[_c('el-form-item',[_c('span',{staticClass:"formLabel",staticStyle:{"text-align":"left","width":"35px"}},[_vm._v("星级")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"40%"},attrs:{"size":"mini","placeholder":"请选择..."},model:{value:(_vm.visibleScope.star),callback:function ($$v) {_vm.$set(_vm.visibleScope, "star", $$v)},expression:"visibleScope.star"}},_vm._l((_vm.visibleScope.starOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.rankName,"value":item.rankName}})}),1),_vm._v(" "),_c('span',{staticStyle:{"width":"90px","text-align":"left","font-size":"14px","color":"#606266","position":"relative","left":"5px"}},[_vm._v("级别级以上")])],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-bottom":"15px"},attrs:{"span":5}},[_c('el-form-item',[_c('span',{staticClass:"formLabel pad20"},[_vm._v("信用分值下限")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"35%"},attrs:{"size":"mini","placeholder":"分"},model:{value:(_vm.visibleScope.crescoreMin),callback:function ($$v) {_vm.$set(_vm.visibleScope, "crescoreMin", _vm._n($$v))},expression:"visibleScope.crescoreMin"}})],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-bottom":"15px"},attrs:{"span":4}},[_c('el-form-item',[_c('span',{staticClass:"formLabel",staticStyle:{"text-align":"left","width":"35px"}},[_vm._v("性别")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"60%"},attrs:{"size":"mini","placeholder":"请选择..."},model:{value:(_vm.visibleScope.sex),callback:function ($$v) {_vm.$set(_vm.visibleScope, "sex", $$v)},expression:"visibleScope.sex"}},_vm._l((_vm.visibleScope.sexOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-bottom":"15px"},attrs:{"span":9}},[_c('el-form-item',[_c('span',{staticClass:"formLabel"},[_vm._v("角色")]),_vm._v(" "),_c('el-checkbox-group',{staticStyle:{"width":"70%","display":"inline-block"},model:{value:(_vm.visibleScope.role),callback:function ($$v) {_vm.$set(_vm.visibleScope, "role", $$v)},expression:"visibleScope.role"}},[_c('el-checkbox',{attrs:{"label":"认证促销员"}}),_vm._v(" "),_c('el-checkbox',{staticStyle:{"margin-left":"20px"},attrs:{"label":"未认证促销员"}}),_vm._v(" "),_c('el-checkbox',{staticStyle:{"margin-left":"20px"},attrs:{"label":"督导"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"15px","float":"left","width":"100%"}},[_c('div',{staticClass:"btns"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.viewTask}},[_vm._v("预览任务")]),_vm._v(" "),_c('el-button',{staticClass:"sureBtn",attrs:{"type":"primary"},on:{"click":_vm.postTask}},[_vm._v("发布")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"选择门店弹框","visible":_vm.storesDialog.show,"width":"30%"},on:{"update:visible":function($event){return _vm.$set(_vm.storesDialog, "show", $event)}}},[_c('span',[_vm._v("选择门店弹框,这是一段信息")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.storesDialog.show = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.storesDialog.show = false}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"预览岗位弹框","visible":_vm.viewTaskDialog.show,"width":"30%"},on:{"update:visible":function($event){return _vm.$set(_vm.viewTaskDialog, "show", $event)}}},[_c('span',[_vm._v("预览岗位弹框,这是一段信息")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.viewTaskDialog.show = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.viewTaskDialog.show = false}}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6yCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("s4KX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d656d78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("Syiw");
function injectStyle (ssrContext) {
  __webpack_require__("Iy/o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d656d78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d656d78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Il1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userManager_vue__ = __webpack_require__("RifP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd54efc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userManager_vue__ = __webpack_require__("Ojx6");
function injectStyle (ssrContext) {
  __webpack_require__("bpl+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dd54efc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd54efc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7X0c":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABLCAIAAABr1ZmKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo0NzIyQjFENEU2NDMxMUU3ODg5RUIwREVENkNEOUM3NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo0NzIyQjFENUU2NDMxMUU3ODg5RUIwREVENkNEOUM3NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjQ3MjJCMUQyRTY0MzExRTc4ODlFQjBERUQ2Q0Q5Qzc3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjQ3MjJCMUQzRTY0MzExRTc4ODlFQjBERUQ2Q0Q5Qzc3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YkVxIAAAAVhJREFUeNrsmeEKgzAMhG19T301wZf0j7qwg6NU7LTWKuPyQ1xXzJfkEnVz0zQ1LzDfvMPEIQ5xiEMc4hCHOMQhDnGIQxwVOZxzOFnXtTYHfdO9+1ptjmVZ4NUgcGIrD9TFfAMFEMMwXE9Gpj7MMSpiR+/9M/qIaMwsPaB5IB+Qhbk3jrZtn8kH2wR1uQ5xlGNvTgAl0inVU4aDQYedGQHhyE5GE7Fep2j8TxFEs4uTg4umD2yDbybplHjd3u+FrD0uanOCETNW28BkbCvS930BDrvoPM/mKZoWTDtKMI5j13XbGM4Ot5Q+GH04SYFiH0GJfIR7wrQdp0mVkC7D1qBimBX647cM47hUfXpOQGuRs72Zwf3l50fYn9FiYn+9+0uGEm/hyBuad91vC3K47P89ypYmPx/XnznK6KPIY+m/9Ive58QhDnGIQxziEIc4xCEOcVS3jwADAOFm/h/YKZkKAAAAAElFTkSuQmCC"

/***/ }),

/***/ "7lzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ "7qqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['postId'],
  data: function data() {
    return {
      checkboxGroup: [],
      checkboxGroup1: [],
      checkboxGroup2: [],
      checkboxIds: [],
      tabsData: [],
      tabsData2: [],
      tabsData3: []
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    // console.log('this.postId', this.postId)
    this.getIndustryLabel();
    this.getJobLabel();
    this.getSelfLabel();

    window.onresize = function () {
      return _this2.autoResize();
    };
  },

  methods: {
    //自动根据标签div的高度，添加或移除下拉小按钮。除此之外，在获取三类标签后，且渲染后，各执行一次。
    autoResize: function autoResize() {
      var arr = document.getElementsByClassName('label-tabs');
      if (arr.length != 0) {
        for (var i = 0; i < arr.length; i++) {
          //注意如果在引用了此组件 的页面里加了label-tabs类，一定要小心，记得关注这里
          // console.log(i,arr[i])
          // console.log(i,arr[i].offsetHeight)
          if (arr[i].offsetHeight < 51) {
            arr[i].previousElementSibling.setAttribute("style", "display:none;");
          } else {
            arr[i].previousElementSibling.setAttribute("style", "display:block;");
          }
          if (i == 2) {
            //因为有的时候arr不足3个，i上限是length，有时候大于3个，所以到3就停止
            break;
          }
        }
      }
    },
    toggleSlide: function toggleSlide(event) {
      var target = event.target;
      var parentNode = target.parentNode;
      if (parentNode.offsetHeight > 40) {
        target.className = 'toggle-btn';
        parentNode.style.height = 40 + 'px';
      } else {
        target.className = 'toggle-btn up';
        parentNode.style.height = 'auto';
      }
    },

    // 获取行业类型二级标签
    getIndustryLabel: function getIndustryLabel() {
      var _this3 = this;

      // this.$http({
      //   method:"GET",
      //   url:'/rest/PublishedWork/searchSignName',
      //   params: {
      //     signType: 1,
      //     signLevel:2
      //   }
      // }).then(res => {
      //   let data = res.data
      //   this.tabsData = data
      // }).catch(err => {
      //  	let errMsg;
      //     if(err.response.message){
      //      	errMsg = err.response.message
      //     }else{
      //      	errMsg = '查询失败，请稍后重试'
      //     }
      // 	  this.$notify({
      // 	    title: '失败',
      // 	    message: errMsg,
      // 	    type: 'error'
      // 	  })
      // })


      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchIndustrySignName',
        params: {
          signType: 1,
          signLevel: 2
        }
      }).then(function (res) {
        var data = res.data;
        _this3.tabsData = data;

        setTimeout(function () {
          _this3.autoResize(); //校验一下高度，添加下拉小按钮
        }, 100);
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询失败，请稍后重试';
        }
        _this3.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        });
      });
    },

    // 获取岗位标签
    getJobLabel: function getJobLabel() {
      var _this4 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchSignName',
        params: {
          signType: 2
        }
      }).then(function (res) {
        var data = res.data;
        _this4.tabsData2 = data;

        setTimeout(function () {
          _this4.autoResize(); //校验一下高度，添加下拉小按钮
        }, 100);
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询失败，请稍后重试';
        }
        _this4.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        });
      });
    },

    // 获取自我标签
    getSelfLabel: function getSelfLabel() {
      var _this5 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchSignName',
        params: {
          signType: 3
        }
      }).then(function (res) {
        var data = res.data;
        _this5.tabsData3 = data;

        setTimeout(function () {
          _this5.autoResize(); //校验一下高度，添加下拉小按钮
        }, 100);
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询失败，请稍后重试';
        }
        _this5.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        });
      });
    },
    showTabs: function showTabs(tab, e) {
      var _this = this;
      if (this.checkboxIds.indexOf(tab.id) < 0 && e) {
        this.checkboxIds.push(tab.id);
      }
      if (!e) {
        this.checkboxIds.forEach(function (item, index, arr) {
          if (item == tab.id) {
            delete _this.checkboxIds[index];
          }
        });
      }
    },
    integrationIds: function integrationIds() {
      var signIdLst = [];
      this.checkboxIds.forEach(function (item, index, arr) {
        signIdLst.push(item);
      });
      this.$emit('signId-Lst', signIdLst);
    },

    // 清空行业品类所选
    deleteSelfLabel: function deleteSelfLabel(val) {
      var _this6 = this;

      if (val == 1) {
        var rows = [];
        this.checkboxGroup.forEach(function (item) {
          _this6.tabsData.forEach(function (item2, index2, arr2) {
            if (item == item2.signName) {
              rows.push(item2);
            }
          });
        });
        rows.forEach(function (item) {
          _this6.checkboxIds.forEach(function (item2, index, arr) {
            if (item.id == item2) {
              _this6.checkboxIds.splice(index, 1);
            }
          });
        });
        this.checkboxGroup = [];
      } else if (val == 2) {

        var _rows = [];
        this.checkboxGroup1.forEach(function (item) {
          _this6.tabsData2.forEach(function (item2, index2, arr2) {
            if (item == item2.signName) {
              _rows.push(item2);
            }
          });
        });
        _rows.forEach(function (item) {
          _this6.checkboxIds.forEach(function (item2, index, arr) {
            if (item.id == item2) {
              _this6.checkboxIds.splice(index, 1);
            }
          });
        });
        this.checkboxGroup1 = [];
      } else {

        var _rows2 = [];
        this.checkboxGroup2.forEach(function (item) {
          _this6.tabsData3.forEach(function (item2, index2, arr2) {
            if (item == item2.signName) {
              _rows2.push(item2);
            }
          });
        });
        _rows2.forEach(function (item) {
          _this6.checkboxIds.forEach(function (item2, index, arr) {
            if (item.id == item2) {
              _this6.checkboxIds.splice(index, 1);
            }
          });
        });
        this.checkboxGroup2 = [];
      }
      this.integrationIds();
    },

    //清空全部所选
    reset: function reset() {
      this.deleteSelfLabel(1);
      this.deleteSelfLabel(2);
      this.deleteSelfLabel(3);
    }
  }
});

/***/ }),

/***/ "81vo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "85DT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8W/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"salesMansTabs"},[_c('div',{staticClass:"common-box-body",staticStyle:{"padding-top":"15px","padding-bottom":"0"}},[_c('div',{staticClass:"label-wrap clearfix"},[_c('div',{staticClass:"floatl label-name"},[_vm._v("\n        您已选择\n      ")]),_vm._v(" "),_c('div',{staticClass:"label-list",staticStyle:{"height":"auto"}},[(_vm.checkboxGroup.length>0)?_c('div',{staticClass:"industryCategory"},[_vm._v("\n          行业品类:\n          "),_c('span',[_vm._v(_vm._s(_vm.checkboxGroup.join("、")))]),_vm._v(" "),_c('span',{staticClass:"remove-btn",on:{"click":function($event){return _vm.deleteSelfLabel(1)}}})]):_vm._e(),_vm._v(" "),(_vm.checkboxGroup1.length>0 )?_c('div',{staticClass:"industryCategory"},[_vm._v("\n          岗位类型:\n          "),_c('span',[_vm._v(_vm._s(_vm.checkboxGroup1.join("、")))]),_vm._v(" "),_c('span',{staticClass:"remove-btn",on:{"click":function($event){return _vm.deleteSelfLabel(2)}}})]):_vm._e(),_vm._v(" "),(_vm.checkboxGroup2.length>0)?_c('div',{staticClass:"industryCategory"},[_vm._v("\n          自我标签：\n          "),_c('span',[_vm._v(_vm._s(_vm.checkboxGroup2.join("、")))]),_vm._v(" "),_c('span',{staticClass:"remove-btn",on:{"click":function($event){return _vm.deleteSelfLabel(3)}}})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"label-wrap clearfix"},[_c('div',{staticClass:"floatl label-name",staticStyle:{"margin-right":"-10px"}},[_vm._v("\n        行业品类\n      ")]),_vm._v(" "),_c('div',{ref:"slideWrap",staticClass:"label-list"},[_c('div',{staticClass:"toggle-btn",on:{"click":_vm.toggleSlide}}),_vm._v(" "),_c('div',{staticClass:"label-tabs"},[_c('el-checkbox-group',{attrs:{"size":"small"},on:{"change":_vm.integrationIds},model:{value:(_vm.checkboxGroup),callback:function ($$v) {_vm.checkboxGroup=$$v},expression:"checkboxGroup"}},_vm._l((_vm.tabsData),function(item){return _c('el-checkbox',{key:item.id,staticStyle:{"margin-left":"10px"},attrs:{"label":item.signName,"border":""},on:{"change":function($event){return _vm.showTabs(item,$event)}}})}),1)],1)])])]),_vm._v(" "),(_vm.postId == 0)?_c('div',{staticStyle:{"padding":"0"}},[_c('div',{staticClass:"label-wrap clearfix"},[_c('div',{staticClass:"floatl label-name",staticStyle:{"margin-right":"-10px"}},[_vm._v("\n        岗位类型\n      ")]),_vm._v(" "),_c('div',{ref:"slideWrap",staticClass:"label-list clearfix"},[_c('div',{staticClass:"toggle-btn",on:{"click":_vm.toggleSlide}}),_vm._v(" "),_c('div',{staticClass:"label-tabs"},[_c('el-checkbox-group',{attrs:{"size":"small"},on:{"change":_vm.integrationIds},model:{value:(_vm.checkboxGroup1),callback:function ($$v) {_vm.checkboxGroup1=$$v},expression:"checkboxGroup1"}},_vm._l((_vm.tabsData2),function(item){return _c('el-checkbox',{key:item.id,staticStyle:{"margin-left":"10px"},attrs:{"label":item.signName,"border":""},on:{"change":function($event){return _vm.showTabs(item,$event)}}})}),1)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding":"0"}},[_c('div',{staticClass:"label-wrap clearfix"},[_c('div',{staticClass:"floatl label-name",staticStyle:{"margin-right":"-10px"}},[_vm._v("\n        自我标签\n      ")]),_vm._v(" "),_c('div',{ref:"slideWrap",staticClass:"label-list clearfix"},[_c('div',{staticClass:"toggle-btn",on:{"click":_vm.toggleSlide}}),_vm._v(" "),_c('div',{staticClass:"label-tabs"},[_c('el-checkbox-group',{attrs:{"size":"small"},on:{"change":_vm.integrationIds},model:{value:(_vm.checkboxGroup2),callback:function ($$v) {_vm.checkboxGroup2=$$v},expression:"checkboxGroup2"}},_vm._l((_vm.tabsData3),function(item){return _c('el-checkbox',{key:item.id,staticStyle:{"margin-left":"10px"},attrs:{"label":item.signName,"border":""},on:{"change":function($event){return _vm.showTabs(item,$event)}}})}),1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8WPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    合同\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8jay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var numCheck = function numCheck(rule, value, callback) {
  var value1 = Number(value);
  if (isNaN(value1)) {
    callback(new Error('请输入数字'));
  } else if (value1 < 0) {
    callback(new Error('不应小于0'));
  } else if (value1 && Math.floor(value1) != value1) {
    callback(new Error('请输入整数'));
  } else if (String(value).length > 1 && String(value).indexOf('0') == 0) {
    callback(new Error('请输入数字'));
  } else {
    callback();
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  //人名
  name: [{ max: 6, message: '不得超过6个字符', trigger: 'change' }, { pattern: /^[A-Za-z\u4e00-\u9fa5]+$/, message: '请输入正确的名字', trigger: 'change' }],
  //身份证号
  idcard: {
    pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
    message: '请输入15位或18位身份证号',
    trigger: 'change'
  },
  //申请人
  applicant: {
    pattern: /^[\u4e00-\u9fa5|·]{1,20}$/,
    message: '请输入正确的申请人',
    trigger: 'change'
  },
  //数字
  number: {
    validator: numCheck, trigger: 'change'
  },
  //范围校验方法
  rangeMin: function rangeMin(value, max, callback) {
    if (!value) {
      callback();
    } else {
      if ((max || max === 0) && Number(value) > Number(max)) {
        callback(new Error('范围错误'));
      } else {
        callback();
      }
    }
  },
  rangeMax: function rangeMax(value, min, callback) {
    if (!value) {
      callback();
    } else {
      if ((min || min === 0) && Number(value) < Number(min)) {
        callback(new Error('范围错误'));
      } else {
        callback();
      }
    }
  }
});

/***/ }),

/***/ "8y9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublishTaskConfiguration_vue__ = __webpack_require__("obGH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b7b16a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublishTaskConfiguration_vue__ = __webpack_require__("go+I");
function injectStyle (ssrContext) {
  __webpack_require__("BhyX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21b7b16a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublishTaskConfiguration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b7b16a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublishTaskConfiguration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9/4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      params: {
        empCode: null,
        name: null,
        idCard: null,
        signed: null,
        serviceSupplier: null,
        company: null,
        activateBegin: null,
        activateEnd: null,
        pageSize: null,
        pageNo: null
      },
      total: null,
      tableData: [],
      listLoading: false,
      companiesAll: [],
      showContractDialog: false,
      contractParams: {
        empCode: null,
        pageSize: null,
        pageNo: null
      },
      contractTotal: null,
      contractTableData: [],
      showTaskDialog: false,
      taskParams: {
        empCode: null,
        pageSize: null,
        pageNo: null
      },
      taskTotal: null,
      taskTableData: [],
      serviceSuppliers: []
    };
  },
  mounted: function mounted() {
    this.searchCompaniesAll();
    this.getData();
    this.getServiceSuppliers();
  },

  methods: {
    // 翻页
    handleSizeChange: function handleSizeChange(value) {
      this.params.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.params.pageNo = value;
      this.getData();
    },

    /**
     * 查询公司下拉列表
     */
    searchCompaniesAll: function searchCompaniesAll() {
      var _this = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/companies'
      }).then(function (res) {
        _this.companiesAll = res.data.data;
      }).catch(function (err) {});
    },
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      this.$http({
        method: 'get',
        url: '/rest/superviseContract/supervises',
        params: this.params
      }).then(function (res) {
        if (res.data && res.data.code == '0') {
          var data = res.data.data;
          _this2.total = data.totalItemsCount;
          _this2.tableData = data.items;
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.listLoading = false;
      });
    },
    resetParams: function resetParams() {
      this.params.empCode = null;
      this.params.name = null;
      this.params.idCard = null;
      this.params.signed = null;
      this.params.company = null;
      this.params.activateBegin = null;
      this.params.activateEnd = null;
    },
    searchData: function searchData() {
      this.params.pageNo = 1;
      this.getData();
    },
    exportData: function exportData() {
      var _this3 = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/supervises/export',
        params: this.params
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          _this3.listLoading = false;
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        } else {
          _this3.listLoading = false;
          _this3.$alert(res.data.message);
        }
      }).catch(function (error) {
        console.log(error);
        _this3.listLoading = false;
        _this3.$alert("导出错误，请联系管理员！");
      });
    },

    // 翻页
    handleContractSizeChange: function handleContractSizeChange(value) {
      this.contractParams.pageSize = value;
      this.getContractData();
    },
    handleContractCurrentChange: function handleContractCurrentChange(value) {
      this.contractParams.pageNo = value;
      this.getContractData();
    },
    doShowContractDialog: function doShowContractDialog(empCode) {
      this.contractParams.empCode = empCode;
      this.showContractDialog = true;
      this.getContractData();
    },
    getContractData: function getContractData() {
      var _this4 = this;

      this.listLoading = true;
      this.$http({
        method: 'get',
        url: '/rest/superviseContract/supervise/contract-recodes',
        params: this.contractParams
      }).then(function (res) {
        if (res.data && res.data.code == '0') {
          var data = res.data.data;
          _this4.contractTotal = data.totalItemsCount;
          _this4.contractTableData = data.items;
        }
        _this4.listLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this4.listLoading = false;
      });
    },


    // 翻页
    handleTaskSizeChange: function handleTaskSizeChange(value) {
      this.taskParams.pageSize = value;
      this.getTaskData();
    },
    handleTaskCurrentChange: function handleTaskCurrentChange(value) {
      this.taskParams.pageNo = value;
      this.getTaskData();
    },
    doShowTaskDialog: function doShowTaskDialog(empCode) {
      this.taskParams.empCode = empCode;
      this.showTaskDialog = true;
      this.getTaskData();
    },
    getTaskData: function getTaskData() {
      var _this5 = this;

      this.listLoading = true;
      this.$http({
        method: 'get',
        url: '/rest/superviseContract/supervise/contracts',
        params: this.taskParams
      }).then(function (res) {
        if (res.data && res.data.code == '0') {
          var data = res.data.data;
          _this5.taskTotal = data.totalItemsCount;
          _this5.taskTableData = data.items;
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this5.listLoading = false;
      });
    },
    getServiceSuppliers: function getServiceSuppliers() {
      var _this6 = this;

      this.$http({
        method: 'GET',
        url: '/rest/JiangYiJoint/getServiceSuppliers'

      }).then(function (res) {
        _this6.serviceSuppliers = res.data;
      }).catch(function (err) {});
    }
  }
});

/***/ }),

/***/ "9/nn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addWorks_vue__ = __webpack_require__("rxb3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chooseStore_vue__ = __webpack_require__("E7oS");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这个页面暂时不加权限控制，否则江一没法调用了




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postJob',
  data: function data() {
    return {
      navState: 1,
      isModify: false,
      iconList: {
        iconaddjobs: __webpack_require__("kub0"),
        iconselectstore: __webpack_require__("l2JT")
      },
      jobInformation: {},
      proDuringTime: {} //本应放在jobInfo中的，怕塞进去出问题就单独扯出来，以便控制岗位的时间不能超出项目的时间
    };
  },

  components: {
    AddWorks: __WEBPACK_IMPORTED_MODULE_2__addWorks_vue__["a" /* default */],
    ChooseStore: __WEBPACK_IMPORTED_MODULE_3__chooseStore_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.getWorkCode();
  },
  destroyed: function destroyed() {
    //每次销毁前重置，清除vuex中store中第一页的数据、清除已经发布的状态
    this.saveWorkSquareInfo(null);
    this.workSquareIsEditMethods(false);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(["saveWorkSquareInfo", "workSquareIsEditMethods"]), {
    // 获取岗位唯一识别码，不希望nav切换时重新获取
    getWorkCode: function getWorkCode() {
      var _this = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchWorkCode'
      }).then(function (res) {
        _this.$refs.addWorks._data.jobInformation.workCode = res.data.message;
      });
    },
    changeIcon: function changeIcon() {
      if (!this.isModify) {
        this.iconList.iconaddjobs = __webpack_require__("Ufaa");
        this.iconList.iconselectstore = __webpack_require__("l2JT");
        if (this.navState == 1) {
          this.iconList.iconaddjobs = __webpack_require__("kub0");
        } else if (this.navState == 2) {
          this.iconList.iconselectstore = __webpack_require__("uCnF");
        }
      }
    },
    checkValues: function checkValues(jobInformation) {
      var errMag = '';
      if (jobInformation.projectCode == null) {
        errMag = "请选择项目";
      } else if (jobInformation.posName == null || jobInformation.posName == '' || jobInformation.posName == undefined) {
        errMag = "请输入任务名称";
      } else if (jobInformation.jobType == null || jobInformation.jobType == '' || jobInformation.jobType == undefined) {
        errMag = "请选择岗位类型";
      } else if (jobInformation.customer == null || jobInformation.customer == '' || jobInformation.customer == undefined) {
        errMag = "请输入服务对象";
      } else if (jobInformation.dateType == null || jobInformation.dateType == '' || jobInformation.dateType == undefined) {
        errMag = "请选择档期类型";
      } else if (jobInformation.posDetail == null || jobInformation.posDetail == '' || jobInformation.posDetail == undefined) {
        errMag = "请配置任务说明";
      } else if (jobInformation.salaryDetail == null || jobInformation.salaryDetail == '' || jobInformation.salaryDetail == undefined) {
        errMag = "此项目还未配置服务费说明，请联系项目组进行配置";
      } else if (jobInformation.welfareDetail == null || jobInformation.welfareDetail == '' || jobInformation.welfareDetail == undefined) {
        errMag = "请输入岗位福利";
      } else if (jobInformation.requirements == null || jobInformation.requirements == '' || jobInformation.requirements == undefined) {
        errMag = "请配置任务要求";
      } else if (jobInformation.salaryType == null) {
        errMag = "请选择岗位薪水";
      } else if (jobInformation.salaryType == 1 && (jobInformation.daySalary == null || jobInformation.daySalary == '' || jobInformation.daySalary == undefined)) {
        errMag = "请输入岗位薪水";
      } else if (jobInformation.salaryType == 1 && isNaN(Number(jobInformation.daySalary))) {
        errMag = "岗位薪水请输入数字类型!";
      } else if (jobInformation.salaryType == 1 && jobInformation.daySalary != null && jobInformation.daySalary != '' && jobInformation.daySalary != undefined && !isNaN(Number(jobInformation.daySalary)) && Number(jobInformation.daySalary) < 0) {
        errMag = "请输入正确岗位薪水";
      } else if (jobInformation.salaryType == 2 && (jobInformation.monthSalary == null || jobInformation.monthSalary == '' || jobInformation.monthSalary == undefined)) {
        errMag = "请输入岗位薪水";
      } else if (jobInformation.salaryType == 2 && isNaN(Number(jobInformation.monthSalary))) {
        errMag = "岗位薪水请输入数字类型!";
      } else if (jobInformation.salaryType == 2 && jobInformation.monthSalary != null && jobInformation.monthSalary != '' && jobInformation.monthSalary != undefined && !isNaN(Number(jobInformation.monthSalary)) && Number(jobInformation.monthSalary) < 0) {
        errMag = "请输入正确岗位薪水";
      } else if (jobInformation.salarySettlement == null || jobInformation.salarySettlement == '' || jobInformation.salarySettlement == undefined) {
        errMag = "请选择结算方式";
      } else if (jobInformation.sexName == null || jobInformation.sexName == '' || jobInformation.sexName == undefined) {
        errMag = "请选择性别要求";
        // } else if (jobInformation.moName == null || jobInformation.moName == '' || jobInformation.moName == undefined) {
        //   errMag = "请输入联系人姓名";
        // } else if (jobInformation.moTel == null || jobInformation.moTel == '' || jobInformation.moTel == undefined) {
        //   errMag = "请输入联系人电话！";
        // } else if (isNaN(parseInt(jobInformation.moTel))) {
        //   errMag = '请输入数字类型!'
        // } else if (typeof parseInt(jobInformation.moTel) !== 'number') {
        //   errMag = '请输入数字类型!'
        // } else if (!(/^1[345789]\d{9}$/.test(jobInformation.moTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(jobInformation.moTel)) {
        //   errMag = '请输入正确的电话号!'
      } /*else if(jobInformation.requirementsTel == null ||jobInformation.requirementsTel == '' || jobInformation.requirementsTel == undefined){
        errMag = "请输入联系人方式";
        }else if(isNaN(parseInt(jobInformation.requirementsTel))){
        errMag = '请输入数字类型!'
        }else if(typeof parseInt(jobInformation.requirementsTel) !== 'number'){
        errMag = '请输入数字类型!'
        }else if(!(/^1[345789]\d{9}$/.test(jobInformation.requirementsTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(jobInformation.requirementsTel)  ){
        errMag = '请输入正确的电话号!'
        }*/ /*else if( (jobInformation.crescoreMin /!*&& jobInformation.crescoreMax*!/) && ( typeof jobInformation.crescoreMin !== 'number' /!*|| typeof jobInformation.crescoreMax !== 'number' *!/) ){
            errMag = '信用分值请输入数字类型!'
            }*/ /*else if( (jobInformation.crescoreMin/!* && jobInformation.crescoreMax*!/) /!*&& ( jobInformation.crescoreMin > jobInformation.crescoreMax )*!/){
                errMag = '分值区间有误!'
                }*/ /*else if(((jobInformation.crescoreMin != null && jobInformation.crescoreMin != '' && jobInformation.crescoreMin != undefined )/!* && (jobInformation.crescoreMax != null || jobInformation.crescoreMax != '' || jobInformation.crescoreMax != undefined )*!/) && (jobInformation.crescoreMin < 0 /!*|| jobInformation.crescoreMax < 0*!/)){
                    errMag = '分值不能为负数!'
                    }*/else if (jobInformation.searchType == null || jobInformation.searchType.length == 0) {

          errMag = '请选择粉丝可见或者会员可见！';
        } else if (jobInformation.posDetail.split(';').includes('其他') && !jobInformation.otherPosDetail) {
          errMag = '请填写任务说明！';
        } else if (jobInformation.requirements.split(';').includes('其他') && !jobInformation.otherRequirements) {
          errMag = '请填写任务要求！';
        }
      if (errMag !== '') {
        this.$notify({
          title: '提示',
          message: errMag,
          type: 'warning'
        });
        return false;
      } else {
        this.navState = jobInformation.navState;
      }
    },
    checkStore: function checkStore(jobInformation, proDuringTime) {
      this.jobInformation = jobInformation;
      this.proDuringTime = proDuringTime;
      this.checkValues(jobInformation);
    },
    receiveState: function receiveState(msg) {
      this.navState = msg;
    },
    checkTabStore: function checkTabStore() {
      this.$children[0].checkStore();
    },

    //重置第一页，先销毁再重新渲染
    resetAddWorks: function resetAddWorks() {
      var _this2 = this;

      this.jobInformation = {};
      this.proDuringTime = {};
      this.navState = -99;
      setTimeout(function () {
        _this2.navState = 1;
      }, 10);
    }
  }),
  watch: {
    navState: function navState(newValue, oldValue) {
      this.changeIcon();
    }
  }
});

/***/ }),

/***/ "97cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_formRules__ = __webpack_require__("8jay");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰7月重写



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  data: function data() {
    return {
      scoreArr: [],
      rules: {
        score: [__WEBPACK_IMPORTED_MODULE_2__common_js_formRules__["a" /* default */].number, { required: true, message: '分值不能为空', trigger: 'blur' }]
      }
    };
  },

  props: ["isEdit"],
  mounted: function mounted() {
    console.log('主页传入积分页的数据', this.$store.state.jiFenArr);
    this.scoreArr = this.$store.state.jiFenArr;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(["changejiFenArr"]), {
    //勿删，会被父组件调用
    checkVals: function checkVals() {
      var text = '';
      //编辑时，积分页的数据被修改后，$store中的jsFenArr会被赋值为新的，初值是''，赋值后是[]类型
      this.scoreArr.map(function (item) {
        if (!item.score && item.score !== 0) {
          text = "警告 积分页分值设定没填写！";
        } else if (isNaN(item.score)) {
          text = "警告 积分页分值请填写数字类型！";
        }
      });
      if (text) {
        this.$message({
          message: text,
          type: "warning"
        });
        return false;
      } else {
        this.changejiFenArr(this.scoreArr);
        return true;
      }
    }
  })
});

/***/ }),

/***/ "9vWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      action: "/rest/projectWhiteList/importWhiteList?operatorId=" + sessionStorage.getItem("sysUserId"),
      openid: sessionStorage.getItem("sysUserId"),
      pageSize: 10,
      total: null,
      formData: {
        name: null,
        idCard: null,
        status: null,
        company: null,
        pageNo: 1,
        pageSize: 10
      },
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

      tableData: [],
      listLoading: false,
      uploadDialog: false,
      uploadDialogi: false,
      uploading: false,
      addUpBtnLoading: false,
      fileList: [],
      rules: {
        idCard: [{
          pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
          message: "请输入15位或18位身份证号",
          trigger: "blur"
        }]
      },
      formAddData: {},
      rulesAdd: {
        name: [{
          required: true,
          pattern: /^[\u4e00-\u9fa5|·]{1,20}$/,
          message: "请输入正确的姓名",
          trigger: "change"
        }],
        idCard: [{
          required: true,
          trigger: "blur",
          validator: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(rule, value, callback) {
              var res;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (value) {
                        _context.next = 2;
                        break;
                      }

                      return _context.abrupt("return", callback(new Error("请输入")));

                    case 2:
                      _context.next = 4;
                      return _this.$http({
                        method: "POST",
                        url: "/rest/projectWhiteList/checkIdCard",
                        params: { idcard: value }
                      });

                    case 4:
                      res = _context.sent;

                      if (!(res.data && res.data.code === "0")) {
                        _context.next = 9;
                        break;
                      }

                      return _context.abrupt("return", callback());

                    case 9:
                      return _context.abrupt("return", callback(new Error(res.data.message)));

                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function validator(_x, _x2, _x3) {
              return _ref.apply(this, arguments);
            };
          }()
        }],
        qiyuesuoAccountId: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        company: [{
          required: true,
          pattern: /.{0,50}$/,
          message: "请输入所属公司",
          trigger: "change"
        }],
        clientId: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        startDate: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        endDate: [{
          trigger: "blur",
          validator: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(rule, value, callback) {
              var diff;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (value) {
                        _context2.next = 2;
                        break;
                      }

                      return _context2.abrupt("return", callback());

                    case 2:
                      if (!_this.formAddData.startDate) {
                        _context2.next = 11;
                        break;
                      }

                      diff = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.formAddData.endDate).diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.formAddData.startDate), "days");

                      if (!(diff < 0)) {
                        _context2.next = 8;
                        break;
                      }

                      return _context2.abrupt("return", callback(new Error("结束日期需要大于等于开始日期")));

                    case 8:
                      return _context2.abrupt("return", callback());

                    case 9:
                      _context2.next = 12;
                      break;

                    case 11:
                      return _context2.abrupt("return", callback());

                    case 12:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, _this);
            }));

            return function validator(_x4, _x5, _x6) {
              return _ref2.apply(this, arguments);
            };
          }()
        }]
      },
      clientIdDropDownList: [],
      companyDownList: []
    };
  },
  mounted: function mounted() {
    this.getOptionList("clientIdDropDownList", "/rest/LongPromotionContractProject/clientIdDropDownList");
    this.getOptionList("companyDownList", "/rest/projectWhiteList/companyDownList");
    this.getData();
    this.$refs["formData"].resetFields();
  },

  methods: {
    getOptionList: function getOptionList(dataName, url) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$http({
                  method: "GET",
                  url: url
                });

              case 2:
                res = _context3.sent;

                _this2[dataName] = res.data.data;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      }
    },
    formatName: function formatName(row, column, cellValue) {
      var a = cellValue[0];
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        for (var i = 0; i < cellValue.length - 1; i++) {
          a = a + "*";
        }
        return a;
      }
    },
    insertBatchs: function insertBatchs() {
      var _this3 = this;

      this.uploadDialog = true;
      this.$nextTick(function () {
        _this3.$refs.upload.clearFiles();
      });
    },
    getData: function getData(pageNo) {
      var _this4 = this;

      if (pageNo) {
        this.formData.pageNo = 1;
      }
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/searchWhiteList",
        data: this.formData
      }).then(function (res) {
        _this4.tableData = res.data.data;
        _this4.listLoading = false;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "查询失败，请稍后重试";
          }
          _this4.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this4.listLoading = false;
      });

      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/countWhiteList",
        data: this.formData
      }).then(function (res) {
        _this4.total = res.data;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = "查询失败，请稍后重试";
        }
        _this4.$notify({
          title: "失败",
          message: errMsg,
          type: "error"
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(cellValue).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    formatDateNoTime: function formatDateNoTime(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(cellValue).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    close: function close(row) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.$confirm("关闭后该人员白名单将失效，确认关闭吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                });

              case 2:
                _this5.$http({
                  method: "POST",
                  url: "/rest/projectWhiteList/closeWhiteList",
                  params: {
                    id: row.id
                  }
                }).then(function (res) {
                  _this5.getData();
                  _this5.$notify({
                    title: "成功",
                    message: "关闭成功",
                    type: "success"
                  });
                }).catch(function (err) {
                  var errMsg = void 0;
                  if (err.response.message) {
                    errMsg = err.response.message;
                  } else {
                    errMsg = "操作失败，请稍后重试";
                  }
                  _this5.$notify({
                    title: "失败",
                    message: errMsg,
                    type: "error"
                  });
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    downloadTmp: function downloadTmp() {
      var _this6 = this;

      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/downloadTemplate"
      }).then(function (res) {
        if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
          location.href = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this6, "error", err.response, "查询失败，请稍后重试");
      });
    },
    changeUpload: function changeUpload(file, fileList) {
      var _this7 = this;

      if (file.size / 1024 / 1024 > 25) {
        this.$message({
          message: "附件超过25M，无法上传，请重新选择！",
          type: "warning"
        });
        this.$refs.upload.clearFiles();
        //进行一下测试环境可能不好用的容错
        this.$nextTick(function () {
          _this7.$refs.upload.clearFiles();
        });
        return;
      }
      this.fileList = fileList;
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.uploading = false;
      if (response.code == 0) {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(this, "success", response.message || "导入成功");
        this.getData();
        this.uploadDialog = false;
      } else if (response.code == 2) {
        this.$confirm("上传失败，点击确认下载错误文件！", "提示", {
          type: "warning",
          callback: function callback(action) {
            if (action === "confirm") {
              window.open(location.origin + '/' + response.message);
            }
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(this, "error", response.message);
      }
    },
    handleError: function handleError(err, response, file) {
      this.uploading = false;
      // this.$refs.upload.clearFiles()
      var msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, "提示", {
        dangerouslyUseHTMLString: true
        // callback: (action) => {
        //     this.uploadDialog = false;
        // },
      });
    },
    exportData: function exportData() {
      var _this8 = this;

      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/exportWhiteList",
        data: this.formData
      }).then(function (res) {
        _this8.listLoading = false;
        if (res.data.code != 0) {
          _this8.$notify({
            title: "失败",
            message: res.data.message,
            type: "error"
          });
          return;
        }
        location.href = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "导出失败，请稍后重试";
          }
          _this8.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this8.listLoading = false;
      });
    },

    //点击确定
    updata: function updata(formName) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this9.addUpBtnLoading = true;
                _context5.next = 3;
                return _this9.$refs[formName].validate().catch(function () {
                  _this9.addUpBtnLoading = false;
                });

              case 3:
                res = _context5.sent;

                if (!(res !== true)) {
                  _context5.next = 7;
                  break;
                }

                _this9.addUpBtnLoading = false;
                return _context5.abrupt("return");

              case 7:
                _this9.$http({
                  method: "POST",
                  url: "/rest/projectWhiteList/insertWhiteList",
                  data: _this9.formAddData
                }).then(function (res) {
                  _this9.addUpBtnLoading = false;
                  if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
                    __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this9, "success", "新增成功"); //res.data.message
                    _this9.uploadDialogi = false;
                    _this9.getData();
                  }
                  if (res && res.data && (res.data.code == 500 || res.data.code == null)) {
                    __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this9, "error", res.data.message);
                  }
                }).catch(function (err) {
                  _this9.addUpBtnLoading = false;
                  __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this9, "error", err.response, "新增失败，请稍后重试");
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    submitUpload: function submitUpload() {
      // operatorId: sessionStorage.getItem('sysUserId')
      console.log(this.openid);
      this.uploading = true;
      this.$refs.upload.submit();
    },
    exceed: function exceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(this, "warning", "只能上传一个文件,请删除后重新上传！");
    },
    handleUpload: function handleUpload() {
      this.$refs.upload.clearFiles();
    },
    add: function add() {
      var _this10 = this;

      this.uploadDialogi = true;
      this.formAddData = {
        startDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
      this.$nextTick(function () {
        _this10.$refs.formAdd.clearValidate();
      });
    }
  }
});

/***/ }),

/***/ "AC+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_labelManagement_vue__ = __webpack_require__("tu0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7601b886_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_labelManagement_vue__ = __webpack_require__("TYKg");
function injectStyle (ssrContext) {
  __webpack_require__("4lWj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7601b886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_labelManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7601b886_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_labelManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AExF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test123_vue__ = __webpack_require__("SADZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0acde64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test123_vue__ = __webpack_require__("JDpk");
function injectStyle (ssrContext) {
  __webpack_require__("Jut4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0acde64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test123_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0acde64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test123_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AMTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__E_scoreDetailed_vue__ = __webpack_require__("3t46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰180718整理优化，180725合并三个子组件后再次优化本页面
//除了子组件中的明细弹窗中的项目分交互分有可能有点问题，其他应该很稳了



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluationDetail',
  components: {
    superDetail: __WEBPACK_IMPORTED_MODULE_0__E_scoreDetailed_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navState: 1,
      pages: [{
        nav: 1,
        name: '积分',
        icon: __webpack_require__("l2JT"),
        checkedIcon: __webpack_require__("uCnF")
      }, {
        nav: 2,
        name: '星级',
        icon: __webpack_require__("IMXc"),
        checkedIcon: __webpack_require__("ttW4")
      }, {
        nav: 3,
        name: '信用',
        icon: __webpack_require__("ZH05"),
        checkedIcon: __webpack_require__("Y+6D")
      }],
      auths: [] // 页面内权限
    };
  },
  mounted: function mounted() {
    this.getAuth();
  },

  methods: {
    getAuth: function getAuth() {
      var _this = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 21,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        res.data.map(function (item) {
          _this.auths.push(item.auth);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
      });
    }
  }
});

/***/ }),

/***/ "AbRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"125px","size":"mini"}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.formData.projectCode),callback:function ($$v) {_vm.$set(_vm.formData, "projectCode", $$v)},expression:"formData.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.formData.projectName),callback:function ($$v) {_vm.$set(_vm.formData, "projectName", $$v)},expression:"formData.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否映射","prop":"serviceSupplier"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择是否映射..."},model:{value:(_vm.formData.mapper),callback:function ($$v) {_vm.$set(_vm.formData, "mapper", $$v)},expression:"formData.mapper"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已映射","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未映射","value":"2"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectCode","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"项目开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":"项目结束日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mapperProjectCode","label":"映射项目编号（HAP）","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mapperProjectName","label":"映射项目名称（HAP）","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateTimeStr","label":"更新时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateUser","label":"更新人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.openEditDialog(scope.row.id, scope.row.projectCode, scope.row.projectName, scope.row.mapperProjectCode)}}},[_vm._v("修改")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":'修改项目映射：' + _vm.projectName,"visible":_vm.showEditDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.showEditDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_vm._v("当前项目编码："+_vm._s(_vm.projectCode))])]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px","margin-top":"20px"}},[_vm._v("映射项目编码（HAP）：")]),_vm._v(" "),_c('div',[_c('el-input',{model:{value:(_vm.mapperProjectCode),callback:function ($$v) {_vm.mapperProjectCode=$$v},expression:"mapperProjectCode"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.editMapperProject}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showEditDialog=false}}},[_vm._v("取消")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BANe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.listLoading),expression:"listLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"addWorks"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("选择项目")])]),_vm._v(" "),_c('div',{staticClass:"common-search "},[_c('el-form',{ref:"jobInformation",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"90px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号","prop":"projectCode"}},[_c('el-input',{attrs:{"placeholder":"请输入项目编号...","maxlength":18},model:{value:(_vm.formData.projectCode),callback:function ($$v) {_vm.$set(_vm.formData, "projectCode", $$v)},expression:"formData.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectName"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称...","maxlength":18},model:{value:(_vm.formData.projectName),callback:function ($$v) {_vm.$set(_vm.formData, "projectName", $$v)},expression:"formData.projectName"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.searchData}},[_vm._v("搜索")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"multipleTable",staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"},on:{"selection-change":_vm.handleSelectionChange}},[(!_vm.store_WSIsEdit)?_c('el-table-column',{attrs:{"type":"selection","width":"50","align":"center"}}):_c('el-table-column',{attrs:{"type":"index","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectCode","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"项目开始时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":"项目结束时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"客户","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-row',{staticClass:"common-box",staticStyle:{"min-height":"300px","overflow-x":"hidden","margin-bottom":"0px"}},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("岗位信息")])]),_vm._v(" "),_c('div',{staticClass:"common-search"},[_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务名称")]),_vm._v(" "),_c('el-input',{staticClass:"formInpsssWid",staticStyle:{"width":"80%"},attrs:{"size":"mini","placeholder":"请输入任务名称...","maxlength":30,"disabled":_vm.store_WSIsEdit},on:{"blur":function($event){return _vm.checkValue(_vm.jobInformation.posName,'任务名称')}},model:{value:(_vm.jobInformation.posName),callback:function ($$v) {_vm.$set(_vm.jobInformation, "posName", $$v)},expression:"jobInformation.posName"}})],1),_vm._v(" "),_c('div',{staticClass:"formArea"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("性别要求")]),_vm._v(" "),_c('el-select',{staticClass:"formInpsssWid",staticStyle:{"width":"80%"},attrs:{"size":"mini","placeholder":"请选择...","clearable":true,"disabled":_vm.store_WSIsEdit},on:{"change":function($event){return _vm.checkValue(_vm.jobInformation.sexName,'性别要求')}},model:{value:(_vm.jobInformation.sexName),callback:function ($$v) {_vm.$set(_vm.jobInformation, "sexName", $$v)},expression:"jobInformation.sexName"}},_vm._l((_vm.jobInformation.sexOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.sexName,"value":item.sexName}})}),1)],1)]),_vm._v(" "),_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务说明")]),_vm._v(" "),_vm._l((_vm.taskInstructionsSigns1),function(item,index){return _c('label',{key:index,staticStyle:{"font-size":"14px","color":"#606266","line-height":"27px","padding-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskInstructionsSigns1V),expression:"taskInstructionsSigns1V"}],staticStyle:{"vertical-align":"middle","width":"16px","height":"16px","margin-right":"10px"},attrs:{"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.taskInstructionsSigns1V)?_vm._i(_vm.taskInstructionsSigns1V,item)>-1:(_vm.taskInstructionsSigns1V)},on:{"change":[function($event){var $$a=_vm.taskInstructionsSigns1V,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.taskInstructionsSigns1V=$$a.concat([$$v]))}else{$$i>-1&&(_vm.taskInstructionsSigns1V=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.taskInstructionsSigns1V=$$c}},function($event){return _vm.checkBoxValue(item,'任务说明')}]}}),_vm._v(_vm._s(item)+"\n              ")])}),_vm._v(" "),(_vm.taskInstructionsSigns1V.includes('其他'))?_c('el-input',{staticStyle:{"margin":"10px 0 0 102px","width":"calc(100% - 150px)"},attrs:{"type":"textarea","placeholder":"请输入其他说明","maxlength":500},model:{value:(_vm.jobInformation.otherPosDetail),callback:function ($$v) {_vm.$set(_vm.jobInformation, "otherPosDetail", $$v)},expression:"jobInformation.otherPosDetail"}}):_vm._e()],2)]),_vm._v(" "),_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务要求")]),_vm._v(" "),_vm._l((_vm.taskInstructionsSigns2),function(item,index){return _c('label',{key:index,staticStyle:{"font-size":"14px","color":"#606266","line-height":"27px","padding-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskInstructionsSigns2V),expression:"taskInstructionsSigns2V"}],staticStyle:{"vertical-align":"middle","width":"16px","height":"16px","margin-right":"10px"},attrs:{"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.taskInstructionsSigns2V)?_vm._i(_vm.taskInstructionsSigns2V,item)>-1:(_vm.taskInstructionsSigns2V)},on:{"change":[function($event){var $$a=_vm.taskInstructionsSigns2V,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.taskInstructionsSigns2V=$$a.concat([$$v]))}else{$$i>-1&&(_vm.taskInstructionsSigns2V=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.taskInstructionsSigns2V=$$c}},function($event){return _vm.checkBoxValue(item,'任务要求')}]}}),_vm._v(_vm._s(item)+"\n              ")])}),_vm._v(" "),(_vm.taskInstructionsSigns2V.includes('其他'))?_c('el-input',{staticStyle:{"margin":"10px 0 0 102px","width":"calc(100% - 150px)"},attrs:{"type":"textarea","placeholder":"请输入其他要求","maxlength":500},model:{value:(_vm.jobInformation.otherRequirements),callback:function ($$v) {_vm.$set(_vm.jobInformation, "otherRequirements", $$v)},expression:"jobInformation.otherRequirements"}}):_vm._e()],2)]),_vm._v(" "),_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"formLabel"},[_vm._v("服务费说明")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"90%"}},[_c('label',{staticStyle:{"font-size":"14px","color":"#606266","line-height":"27px","padding-right":"15px"}},[_vm._v("\n                "+_vm._s(_vm.jobInformation.salaryDetail)+"\n              ")])])])])],1)]),_vm._v(" "),_c('el-row',{staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"btns"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.cancelCheckStore}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"sureBtn",attrs:{"type":"primary"},on:{"click":_vm.checkStore}},[_vm._v("选择门店")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"岗位预览","visible":_vm.jobPreviewDialog,"width":"400px","center":true,"show-close":false},on:{"update:visible":function($event){_vm.jobPreviewDialog=$event}}},[_c('div',{staticClass:"jobInformation"},[_c('div',{staticClass:"jobInformationHeader"},[_c('span',{staticClass:"icon"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("岗位信息")])]),_vm._v(" "),_c('div',{staticClass:"jobInformationContent"},[_c('div',{staticClass:"jobType"},[_vm._v("\n            "+_vm._s(_vm.jobInformation.posName)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"salaryTel",staticStyle:{"justify-content":"flex-start"}},[_vm._v("岗位薪水 :\n            "),(_vm.jobInformation.salaryType == 1)?_c('div',{staticStyle:{"margin-left":"4px"}},[_vm._v("\n              ￥"),_c('span',{staticClass:"money"},[_vm._v(_vm._s(_vm.jobInformation.daySalary))]),_vm._v("\n              /天 | "+_vm._s(_vm.jobInformation.salarySettlement)+"\n            ")]):(_vm.jobInformation.salaryType == 2)?_c('div',{staticStyle:{"margin-left":"4px"}},[_vm._v("\n              ￥"),_c('span',{staticClass:"money"},[_vm._v(_vm._s(_vm.jobInformation.monthSalary))]),_vm._v("\n              /月 | "+_vm._s(_vm.jobInformation.salarySettlement)+"\n            ")]):_c('div',{staticStyle:{"margin-left":"4px"}},[_vm._v("面议")])]),_vm._v(" "),_c('div',{staticClass:"salaryTel"},[_c('div',[_vm._v("档期类型 : "+_vm._s(_vm.jobInformation.dateType))])]),_vm._v(" "),_c('div',{staticClass:"dataJob"},[_c('div',[_vm._v("岗位类型 : "+_vm._s(_vm.jobInformation.jobType))])]),_vm._v(" "),_c('div',{staticClass:"requirements"},[_c('div',{staticClass:"requirementsTitle"},[_vm._v("任务要求 :")]),_vm._v(" "),_c('div',{staticClass:"requirementsContent"},[_vm._v(_vm._s(_vm.jobInformation.requirements))])]),_vm._v(" "),_c('div',{staticClass:"welfareDetail"},[_c('div',{staticClass:"welfareDetailTitle"},[_vm._v("岗位福利 :")]),_vm._v(" "),_c('div',{staticClass:"welfareDetailContent"},[_vm._v(_vm._s(_vm.jobInformation.welfareDetail))])]),_vm._v(" "),_c('div',{staticClass:"salary"},[_c('div',{staticClass:"salaryTitle"},[_vm._v("薪资待遇 :")]),_vm._v(" "),_c('div',{staticClass:"salaryContent"},[_vm._v(_vm._s(_vm.jobInformation.salaryDetail))])]),_vm._v(" "),_c('div',{staticClass:"jobDescription"},[_c('div',{staticClass:"jobDescriptionTitle"},[_vm._v("任务说明 :")]),_vm._v(" "),_c('div',{staticClass:"jobDescriptionContent"},[_vm._v(_vm._s(_vm.jobInformation.posDetail))])])])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"type":"primary"},on:{"click":function($event){_vm.jobPreviewDialog = false}}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BEg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MappingMead_vue__ = __webpack_require__("I1Y2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f98c438_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MappingMead_vue__ = __webpack_require__("ZSZm");
function injectStyle (ssrContext) {
  __webpack_require__("cdeW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f98c438"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MappingMead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f98c438_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MappingMead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bbqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlexibleSigningRecord_vue__ = __webpack_require__("nEld");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_429763b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlexibleSigningRecord_vue__ = __webpack_require__("ljJo");
function injectStyle (ssrContext) {
  __webpack_require__("G6J7")
  __webpack_require__("cPt8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-429763b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlexibleSigningRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_429763b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlexibleSigningRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BhyX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CwPt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "DToB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__ = __webpack_require__("SRsY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afdd0d98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__ = __webpack_require__("Jly+");
function injectStyle (ssrContext) {
  __webpack_require__("sXZb")
  __webpack_require__("1xE0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afdd0d98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afdd0d98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DoUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__ = __webpack_require__("7lzC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4d16b46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_vue__ = __webpack_require__("JG58");
function injectStyle (ssrContext) {
  __webpack_require__("0JO2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4d16b46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4d16b46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Drhy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9shaixuan2.6d77577.png";

/***/ }),

/***/ "E4Zx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "questionnaire",
  data: function data() {
    return {
      param: {
        clerkId: null, // 员工id
        clerkName: null, // 姓名
        province: null, // 所在省份
        city: null, // 所在城市
        country: null, // 所在区县
        storeName: null, // 门店名称
        storeCode: null, // 门店编号
        wechatName: null, // 扫码消费者微信昵称
        isValid: null, // 促销员回收样本有效/无效
        reasonStr: null, // 无效样本原因,
        startDate: null, // 开始日期
        endDate: null, // 结束日期
        activityName: null, // 活动名称
        supplierName: null // 供应商名称
      },
      formData: {
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      tableData: [],
      chooseValid: [{ name: '不限', id: null }, { name: "有效", id: 1 }, { name: "无效", id: 0 }],
      handling: false
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    // 翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      this.$http({
        method: 'POST',
        url: '/rest/questionnaire/list',
        data: this.param,
        params: {
          pageNo: this.formData.pageNo,
          pageSize: this.formData.pageSize
        }
      }).then(function (res) {
        if (res.data && res.data.code == '0') {
          var data = res.data.data;
          _this.formData.total = data.totalCount;
          _this.tableData = data.results;
        }
      }).catch(function (err) {});
    },
    resetParams: function resetParams() {
      this.param.startDate = null;
      this.param.endDate = null;
      this.param.clerkId = null;
      this.param.clerkName = null;
      this.param.province = null;
      this.param.city = null;
      this.param.country = null;
      this.param.wechatName = null;
      this.param.isValid = null;
      this.param.reasonStr = null;
      this.param.activityName = null;
      this.param.supplierName = null;
    },
    searchData: function searchData() {
      this.formData.pageNo = 1;
      this.getData();
    },

    //时间格式化
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("YYYY-MM-DD");
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.handling = false;
      if (response.message == '导入成功') {
        this.getData();
      }
      this.$alert(response.message, '提示', {
        dangerouslyUseHTMLString: true,
        callback: function callback() {
          this.uploadDialog = false;
        }
      });
    },
    handlePreview: function handlePreview() {
      var _this2 = this;

      return this.$confirm("上传新数据会清空原有数据，您确定上传吗？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(function () {
        _this2.handling = true;
      });
    },
    handleError: function handleError(err, response, file) {
      var _this3 = this;

      this.handling = false;
      var msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, '提示', {
        dangerouslyUseHTMLString: true,
        callback: function callback(action) {
          _this3.uploadDialog = false;
        }
      });
    }
  }
});

/***/ }),

/***/ "E5Jd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E60D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E7oS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chooseStore_vue__ = __webpack_require__("fLMO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc2aeb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chooseStore_vue__ = __webpack_require__("fqQl");
function injectStyle (ssrContext) {
  __webpack_require__("LKnw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chooseStore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc2aeb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chooseStore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EY7K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ElhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"90px","size":"mini","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":"身份证号","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18},model:{value:(_vm.formData.idCard),callback:function ($$v) {_vm.$set(_vm.formData, "idCard", $$v)},expression:"formData.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名","prop":"salemansName"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":6},model:{value:(_vm.formData.salemansName),callback:function ($$v) {_vm.$set(_vm.formData, "salemansName", $$v)},expression:"formData.salemansName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID","prop":"empPk"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID...","maxlength":12},model:{value:(_vm.formData.empPk),callback:function ($$v) {_vm.$set(_vm.formData, "empPk", $$v)},expression:"formData.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否QHR人员","label-width":"20","prop":"qhrStatus"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.formData.qhrStatus),callback:function ($$v) {_vm.$set(_vm.formData, "qhrStatus", $$v)},expression:"formData.qhrStatus"}},[_c('el-option',{attrs:{"label":"全部","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"否","value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"是","value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"在职","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职中","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"取消离职","value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职","value":"4"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.getData(1)}}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.exportData}},[_vm._v("导出")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},attrs:{"disabled":_vm.auths.indexOf(2) < 0},on:{"click":_vm.addGrey}},[_vm._v("添加")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},attrs:{"disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.insertBatchs()}}},[_vm._v("批量添加")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":function($event){return _vm.clear('formData')}}},[_vm._v("清空筛选项")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idCard","label":"身份证","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salemansName","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","label":"促销员ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reason","label":"加入灰名单原因","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statusName","label":"状态","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qhrStatusName","label":"是否是qhr人员","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"account","label":"操作者","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateTime","label":"更新时间","align":"center","formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"150","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.checkStatus(scope.row))?_c('el-button',{staticStyle:{"color":"rgb(245, 108, 108)"},attrs:{"type":"text","disabled":_vm.auths.indexOf(2) < 0,"size":"mini"},on:{"click":function($event){return _vm.getSalesmanId(scope.row)}}},[_vm._v("拉黑")]):_vm._e(),_vm._v(" "),(_vm.checkResetStatus(scope.row))?_c('el-button',{staticStyle:{"color":"rgb(24, 167, 255)"},attrs:{"type":"text","disabled":_vm.auths.indexOf(2) < 0,"size":"mini"},on:{"click":function($event){return _vm.reset(scope.row)}}},[_vm._v("还原")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"导入灰名单","visible":_vm.uploadDialog,"width":"500px","center":""},on:{"update:visible":function($event){_vm.uploadDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex"}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px","width":"41%"},on:{"click":function($event){return _vm.downloadTmp()}}},[_vm._v("下载模板")]),_vm._v(" "),_c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":_vm.action,"on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"auto-upload":false,"limit":1,"data":{ operatorId: _vm.openid },"on-exceed":_vm.exceed}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px"},attrs:{"slot":"trigger"},on:{"click":function($event){return _vm.$refs.upload.clearFiles()}},slot:"trigger"},[_vm._v("上传附件")])]),_vm._v(" "),(_vm.fileList.length == 0)?_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n            只能上传excel文件\n          ")]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small","type":"success"},on:{"click":_vm.submitUpload}},[_vm._v("确认上传")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"添加灰名单","visible":_vm.uploadDialogi,"width":"600px","center":""},on:{"update:visible":function($event){_vm.uploadDialogi=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticStyle:{"width":"150px","text-align":"right"}},[_vm._v("身份证号：")]),_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18},model:{value:(_vm.formData.cardId),callback:function ($$v) {_vm.$set(_vm.formData, "cardId", $$v)},expression:"formData.cardId"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"150px","text-align":"right"}},[_vm._v("姓名：")]),_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":20},model:{value:(_vm.formData.name0),callback:function ($$v) {_vm.$set(_vm.formData, "name0", $$v)},expression:"formData.name0"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"150px","text-align":"right"}},[_vm._v("加入灰名单原因：")]),_c('el-input',{attrs:{"type":"textarea","placeholder":"请输入...","maxlength":200},model:{value:(_vm.formData.reason),callback:function ($$v) {_vm.$set(_vm.formData, "reason", $$v)},expression:"formData.reason"}})],1)]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.aaa()}}},[_vm._v("确定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"拉黑原因","visible":_vm.showBlackDialog,"width":"600px","center":""},on:{"update:visible":function($event){_vm.showBlackDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"请输入...","maxlength":200},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1)]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){_vm.showBlackDialog=false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.remove()}}},[_vm._v("确定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ep28":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eq+a":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ErWU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjY4NjRGNUQ2RDY3RTExRTdBMzkwQUVDMUY5RENFRTcyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjY4NjRGNUQ3RDY3RTExRTdBMzkwQUVDMUY5RENFRTcyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Njg2NEY1RDRENjdFMTFFN0EzOTBBRUMxRjlEQ0VFNzIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Njg2NEY1RDVENjdFMTFFN0EzOTBBRUMxRjlEQ0VFNzIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4abw+NAAABvklEQVR42uzWP0sCYRwH8DsNA6EptezPYpQ52NRbCGqqKWyptUEJagmdCmpqaoheQrQ6hi8hEBoihEKlIrFJCQy76/vA13jUu7p7Chy6Bz6gPI+/78nz73TTNLVBNJ82oOYF/9/gAGxCHp7AANMhg7/Js0bAKkC32E5LcA4xFrqFZ3520nSIQhz8cA/bcNU1SgRLMtCGJhxCtKffjQhrNFkzI/fLA1fBgCosuAzxwzIcwSlDptmXYE2DGV3BQahAA5IuQ+egaPa3FuxzTJK1K8z6Ck5zcM5laEj6N2ewCDOwASXW3OPYHL+n5eACfEDYZfBJT3GZqFWGN853mBkFOfiRT+h2AT1ADYZs+jN8sC1+Fxl18bmzj0NQUzgHJqAEbZv+O2mcxoxR+QCpQ0QhWBwUs9yvVi0ujdOY8Srv484chxTneNfhHLd757izqrN/sKpjkLJY1VmrVR1kAdV9fK26j4U1PnlZIdwHK3DMk2sHJtk3z0CDGX1HptVZPf6Ls1pMw4HdWf3T7WTwdqpCw+FKH4EpSHx3O+k2b5niDk3BOiRhDIYdBrfgBW7gEi7g3cl97L1zecFesFL7FGAAnfRtZjQ86/8AAAAASUVORK5CYII="

/***/ }),

/***/ "F0vU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FCKL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FO3r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handleApply__ = __webpack_require__("QxVi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postEdit__ = __webpack_require__("wYi7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { HandleApply: __WEBPACK_IMPORTED_MODULE_1__handleApply__["a" /* default */], PostEdit: __WEBPACK_IMPORTED_MODULE_2__postEdit__["a" /* default */] },
  watch: {
    bet: {
      tableData: function tableData(newValue, oldValue) {
        console.log(newValue);
      },

      deep: true
    }
  },
  data: function data() {
    return {
      //筛选项参数
      param: {
        posName: null, //岗位名称
        proCode: null, //项目编号
        proName: null, //项目名称
        storeName: null,
        storeCode: null, //门店编码
        province: null,
        city: null,
        terminal: null, //终端
        post: null, //岗位状态
        apply: null,
        postMan: null, //发布人
        salesmanName: null, //促销员姓名
        salesmanIdCard: null, //促销员身份证
        provinceId: null, //省级id
        cityId: null, //区级id
        publishTimeStart: null, // 发布日期
        publishTimeEnd: null,
        code: null, // 岗位编码
        scheduleNum: null
      },
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      provinceList: [], //省级数组
      cityList: [], //区级数组
      terminalList: [], //终端下拉列表
      terminals: [], //终端自动填充必须
      choosePost: [{ name: '不限', id: 0 }, { name: "招聘中", id: 1 }, { name: "已完成", id: 2 }, { name: "已结束", id: 3 }, { name: "已关闭", id: 4 }, { name: "卖进关闭", id: 5 }], //选择岗位
      chooseApply: [{ name: "不限", id: 0 }, { name: "待审核", id: 1 },
      // {name: "已审核，待面试", id: 2},
      // {name: "审核不通过", id: 3},
      { name: "审核不通过", id: 5 }, { name: "审核通过", id: 6 }, { name: "释放", id: 4 }], //选择应聘状态
      //表单信息
      tableData: [],
      listLoading: false,
      jobEdit: false, //处理应聘
      postEdit: false, //编辑
      msg: false, //返回处理应聘信息
      msg1: false, //返回编辑信息
      clickThis: [], //把首页数据 传向处理应聘
      clickPosStoreId: '',
      showExport: false,
      closePosStoreFLag: false // 是否有关闭岗位权限
    };
  },
  mounted: function mounted() {
    this.searchProvince(); //搜索省
    this.searchCity(); //搜索市
    this.getTerminal(); //获取终端筛选列表
    this.resetForm(); //清空并得到首页数据
    this.getPosStoreCloseFlag(); // 判断当前用户是否有关闭岗位权限
  },

  methods: {
    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    formatNum: function formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return '-';
      }
    },
    reFresh: function reFresh() {
      this.getData();
    },
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = {
        posName: this.param.posName, //岗位名称
        projectCode: this.param.proCode, //项目编号
        projectName: this.param.proName, //项目名称
        storeName: this.param.storeName, //门店名称
        storeCode: this.param.storeCode, //门店编码
        province: this.param.province,
        city: this.param.city,
        channel: this.param.terminal != null ? this.param.terminal.replace(/(^\s*)|(\s*$)/g, "") : null, //终端
        requirementsStatus: this.param.post || null, //岗位状态
        auditStatus: this.param.apply, //应聘状态
        userName: this.param.postMan, //发布人
        salesmanName: this.param.salesmanName, //促销员姓名
        salesmanIdCard: this.param.salesmanIdCard, //促销员身份证
        empPk: this.param.empPk, //促销员empPk
        userId: sessionStorage.getItem('sysUserId'),
        publishTimeStart: this.param.publishTimeStart,
        publishTimeEnd: this.param.publishTimeEnd,
        code: this.param.code,
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
        //获取表单数据
      };this.$http({
        method: "get",
        url: "/rest/PostManagement/searchUserProject",
        params: params
      }).then(function (res) {
        _this2.tableData = res.data.items;
        _this2.formData.total = res.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      var _this3 = this;

      //不限就是null的情况
      var pId = this.param.provinceId;
      if (pId === null) {
        this.param.province = null;
      } else {
        this.provinceList.map(function (item) {
          if (item.id == pId) {
            _this3.param.province = item.adName;
          }
        });
      }
      //city有343条，使用break优化，province才31条,map反而更快
      var cId = this.param.cityId;
      var cList = this.cityList;
      if (cId === null) {
        this.param.city = null;
      } else {
        for (var i = 0; i < cList.length; i++) {
          if (cList[i].id == cId) {
            this.param.city = cList[i].adName;
            break;
          }
        }
      }
      //上面这俩遍历最多时候，共用时0.5ms
      this.formData.pageNo = 1;
      this.getData();
    },

    //重置表单（清除筛选项）
    resetForm: function resetForm() {
      this.param.posName = null; //岗位名称
      this.param.proCode = null; //项目编号
      this.param.proName = null; //项目名称
      this.param.storeName = null; //门店名称
      this.param.storeCode = null; //门店编码
      this.param.postMan = null; //发布人
      this.param.salesmanName = null; //促销员姓名
      this.param.salesmanIdCard = null; //促销员身份证
      this.param.province = null; //地区清空
      this.param.provinceId = null;
      this.param.city = null;
      this.param.cityId = null;
      this.param.terminal = null; //终端
      this.param.post = null; //岗位状态
      this.param.apply = null; //应聘状态
      this.param.publishTimeStart = null;
      this.param.publishTimeEnd = null;
      this.param.code = null;
      this.getData();
    },

    //展开收起
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },

    //搜索省市
    searchProvince: function searchProvince(id) {
      var _this4 = this;

      this.$http({
        method: "POST",
        url: "/rest/salesman/getRegion",
        params: {
          deep: 1,
          regionId: id
        }
      }).then(function (res) {
        _this4.provinceList = res.data;
      }).catch(function (err) {
        _this4.myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    searchCity: function searchCity(id) {
      var _this5 = this;

      this.param.cityId = null;
      this.$http({
        method: "POST",
        url: "/rest/salesman/getRegion",
        params: {
          deep: 2,
          regionId: id
        }
      }).then(function (res) {
        _this5.cityList = res.data;
      }).catch(function (err) {
        _this5.myNotify(_this5, 'error', err.response, '查询失败，请稍后重试');
      });
    },


    // 终端下拉列表相关
    //获取终端下拉列表
    getTerminal: function getTerminal() {
      var _this6 = this;

      this.param.terminal = null;
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchMasterName",
        params: {
          masterCode: 'CHANNEL'
        }
      }).then(function (res) {
        var arr = [];
        res.data.map(function (item) {
          arr.push({ value: String(item.masterName) }); //
        });
        _this6.terminalList = arr;
      }).catch(function (err) {
        _this6.myNotify(_this6, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //自动填充方法
    querySearch: function querySearch(queryString, cb) {
      var results = queryString ? this.returnTerminal().filter(this.createFilter(queryString)) : this.returnTerminal();
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1;
      };
    },
    returnTerminal: function returnTerminal() {
      return this.terminalList;
    },


    //首页开关状态
    changeZhuangTai: function changeZhuangTai(value) {
      var _this7 = this;

      var flag = value.choose ? 1 : 2;
      this.$http({
        method: "POST",
        url: "/rest/PostManagement/updateRequirementsStatus",
        params: {
          posStoreId: value.posStoreId,
          requirementsStatus: flag
        }
      }).then(function (res) {
        _this7.getData();
      }).catch(function (err) {
        _this7.myNotify(_this7, 'error', err.response, '查询失败，请稍后重试');
        value.choose = !value.choose;
      });
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.jobEdit = false;

      this.getData();
    },

    //处理应聘
    changeHandle: function changeHandle(msg) {
      console.log('处理应聘', msg);
      this.jobEdit = msg;
    },
    handleApplyy: function handleApplyy(item) {
      var _this8 = this;

      this.$http({
        method: "GET",
        url: "/rest/PostManagement/auditSalesmanPermission",
        params: {
          posStoreId: item.posStoreId
        }
      }).then(function (res) {
        if (res.data.code == '500') {
          _this8.$alert(res.data.message, '提示', {
            dangerouslyUseHTMLString: true
          });
        } else {
          _this8.clickPosStoreId = item.posStoreId;
          _this8.clickThis = [];
          _this8.clickThis.push(item);
          _this8.jobEdit = true;
        }
      }).catch(function (error) {});
    },

    //编辑
    edit: function edit(item) {
      this.clickThis = [];
      this.clickThis.push(item);
      this.postEdit = true;
    },
    changeEdit: function changeEdit(msg1) {
      this.postEdit = msg1;
    },

    // 导出筛选结果
    exportResult: function exportResult() {
      var _this9 = this;

      var params = {
        posName: this.param.posName, //岗位名称
        projectCode: this.param.proCode, //项目编号
        projectName: this.param.proName, //项目名称
        storeName: this.param.storeName, //门店名称
        storeCode: this.param.storeCode, //门店编码
        province: this.param.province,
        city: this.param.city,
        channel: this.param.terminal != null ? this.param.terminal.replace(/(^\s*)|(\s*$)/g, "") : null, //终端
        requirementsStatus: this.param.post || null, //岗位状态
        auditStatus: this.param.apply, //应聘状态
        userName: this.param.postMan, //发布人
        salesmanName: this.param.salesmanName, //促销员姓名
        salesmanIdCard: this.param.salesmanIdCard, //促销员身份证
        userId: sessionStorage.getItem('sysUserId'),
        publishTimeStart: this.param.publishTimeStart,
        publishTimeEnd: this.param.publishTimeEnd,
        code: this.param.code,
        empPk: this.param.empPk //促销员empPk
      };
      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/PostManagement/exportPosStore',
        params: params
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          _this9.listLoading = false;
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
          // this.$alert(res.data.message);
        } else {
          _this9.listLoading = false;
          _this9.$alert(res.data.message);
        }
      }).catch(function (error) {
        _this9.listLoading = false;
        _this9.$alert("导出错误，请联系管理员！");
      });
    },

    // 查询是否有关闭岗位权限
    getPosStoreCloseFlag: function getPosStoreCloseFlag() {
      var _this10 = this;

      this.$http({
        method: 'GET',
        url: '/rest/role/canClosePos',
        params: { userId: sessionStorage.getItem('sysUserId') }
      }).then(function (res) {
        if (res.data.code == '0' && res.data.data == 1) {
          _this10.closePosStoreFLag = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 确认关闭岗位
    confirmClosePosStore: function confirmClosePosStore(posStoreId) {
      var _this11 = this;

      this.$confirm('确认关闭岗位？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this11.closePosStore(posStoreId);
      }).catch(function () {});
    },

    // 关闭岗位
    closePosStore: function closePosStore(posStoreId) {
      var _this12 = this;

      this.$http({
        method: 'POST',
        url: '/rest/PublishedWork/closePosStore',
        data: { posStoreId: posStoreId, userId: sessionStorage.getItem("sysUserId") }
      }).then(function (res) {
        if (res.data.code == '0') {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this12, "success", res, '操作成功');
          _this12.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this12, "error", res, '操作失败');
        }
      }).catch(function (error) {
        console.log(error);
        _this12.getData();
      });
    }
  }
});

/***/ }),

/***/ "FRJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰180711 整理


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flag: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(["saveWorkSquareInfo", "workSquareIsEditMethods"]), {
    checkFrom: function checkFrom(to) {
      var _this = this;

      console.log('to', to);
      //如果从发布岗位，或发布任务页跳出则弹框提示，跳出去后数据被清空
      //postTask相关判断，等三期上线时候再启用
      if (to === '/workNews') {
        window.open('http://wxmc.myfmes.cn/');
        return false;
      }
      if (this.$route.path == '/postJob' && to != '/postJob')
        // ||( this.$route.path == '/postTask' && to != '/postTask' )
        {
          // 暂时不加这个判断，task来了之后要增加判断
          // if(vm.$store.state.postJobHasData){
          this.$confirm('跳转后将清空本页未保存数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(function () {
            _this.$router.push({ path: to });
          }).catch(function () {
            return false;
          });
        }
    },
    loadMessage: function loadMessage() {
      var _this2 = this;

      //这里充分信任这三类session中只能存在一类，如果不是只能看运气。。很可能传参错误
      this.$http({
        method: "GET",
        url: '/rest/sysUser/sysUserLogin',
        params: {
          account: sessionStorage.getItem("usersPG") || sessionStorage.getItem("usersUL") || sessionStorage.getItem("user"),
          password: sessionStorage.getItem("passwordsPG") || sessionStorage.getItem("passwordsUL") || sessionStorage.getItem("passwords")
        }
      }).then(function (res) {
        //之前正式库没有这个webid，现在有了的话，就不用下面这一段了
        // if (sessionStorage.getItem("usersPG")) {
        //   res.data.webAuthLst.push({
        //     auth: 2,
        //     pId: 26,
        //     webId: 27,
        //     webLevel: 2,
        //     webName: "促销员数据",
        //   })
        // }
        //把用户密码发给后台，res中的webAuthLst是允许查看的页面，仅显示其中的webid与router里面相匹配的栏目，其他的设置为hidden
        //这里也只是导航中看不到而已，直接链接还是能访问的，但有些有权限控制的接口将不能返回数据
        var webIdArr = [];
        res.data.webAuthLst.map(function (item) {
          webIdArr.push(item.webId);
        });

        var routes = _this2.$router.options.routes;
        routes.map(function (item1) {
          item1.children.map(function (item2) {
            if (!item2.hidden) {
              if (webIdArr.indexOf(item2.webId) == -1) {
                item2.hidden = true;
              }
            }
          });
        });
        routes.map(function (item1) {
          var show = false;
          item1.children.map(function (item2) {
            if (!item2.hidden) {
              show = true;
            }
          });
          if (!show) {
            item1.hidden = true;
          }
        });
        // console.log('routes trans finished ! ', routes)
        //权限拿到才给他看侧边栏
        _this2.flag = true;
      });
    }
  }),
  mounted: function mounted() {
    this.loadMessage();
  },

  watch: {
    '$route': function $route(to, from) {
      //清空发布岗位第一页的数据
      this.saveWorkSquareInfo(null);
      //应该加判断，如果是从发布岗位出去，则置为false
      this.workSquareIsEditMethods(false);
      // console.log('router')
    }
  }
});

/***/ }),

/***/ "Fe1t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workNews_vue__ = __webpack_require__("PWqT");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workNews_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fjwn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fsl6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FzBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a420dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_noPermission_vue__ = __webpack_require__("kFVq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a420dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_noPermission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G+PA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"TiXiWrap"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"filterTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"masterName","label":"项目名称","align":"center"}}),_vm._v(" "),_vm._l((_vm.cols),function(item,index){return _c('el-table-column',{key:index,attrs:{"label":item.name,"width":"220","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.message),function(item2,index2){return (item2.masterId == scope.row.masterId && item2.scoreType == item.scoreType)?_c('div',{key:index2,staticClass:"isChecked"},[_c('img',{attrs:{"src":__webpack_require__("SXjM"),"alt":""}}),_vm._v("\n            已选择\n          ")]):_vm._e()})}}],null,true)})})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thisTitle"},[_c('span',{staticClass:"thisIcon"},[_c('img',{attrs:{"src":__webpack_require__("2f6u"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("体系")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G/Jk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_util__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_cook__ = __webpack_require__("xxzE");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: ""
      },
      checked: false,
      canNotLogin: 0, //已经由于上个账号未注销而无法登陆的次数
      queryParams: {},
      bind: false, //是否需要进行绑定平台操作
      rules2: {
        account: [{ required: true, message: "账号不能为空！", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码！", trigger: "blur" }]
      }
    };
  },

  methods: {
    handleSubmit2: function handleSubmit2(ev) {
      var _this = this;

      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this.logining = true;
          _this.$http({
            method: "post",
            url: "/rest/auth/login",
            headers: {
              "Content-type": "application/x-authc-username-password+json"
            },
            data: {
              user: _this.ruleForm2.account,
              password: _this.ruleForm2.checkPass
            }
          }).then(function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
              var resbindAccount;
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      //因为后台不允许同一个客户端登录两个账号，所以如果登陆了一个账号这里就提示他需要先注销
                      //当前请求登录的账号和服务端返回的‘已经登录的账号’名称不匹配时，则判定是第二次登陆
                      console.log("loginName = " + res.data.loginName + "  account=" + _this.ruleForm2.account);

                      if (!(res.data.loginName != _this.ruleForm2.account)) {
                        _context.next = 6;
                        break;
                      }

                      if (_this.canNotLogin <= 1) {
                        _this.$alert("您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆，本次登录无效", "提示", { type: "error" });
                      } else {
                        //如果连续2次没进去，则允许强制退出
                        _this.$confirm("您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆,  是否强制注销?", "提示", {
                          type: "warning"
                        }).then(function () {
                          _this.$http.post("/rest/auth/logout").then(function (res) {
                            __WEBPACK_IMPORTED_MODULE_3__common_js_util__["a" /* default */].myNotify(_this, "success", res, "注销成功"); //有时候提示该用户未登入，此时code是一串字母，但我们仍然提示注销成功
                            sessionStorage.clear();
                            setTimeout(function () {
                              location.reload(true);
                            }, 1000);
                          }).catch(function (err) {
                            __WEBPACK_IMPORTED_MODULE_3__common_js_util__["a" /* default */].myNotify(_this, "warning", err.response, "注销失败");
                          });
                        }).catch(function () {});
                      }
                      _this.canNotLogin += 1;
                      _context.next = 19;
                      break;

                    case 6:
                      _context.next = 8;
                      return _this.bindAccount();

                    case 8:
                      resbindAccount = _context.sent;

                      if (!(resbindAccount !== true)) {
                        _context.next = 12;
                        break;
                      }

                      console.log(222);
                      return _context.abrupt("return");

                    case 12:
                      //正常情况下直接登录
                      _this.checked ? localStorage.setItem("user", String(res.data.loginName)) : localStorage.clear();
                      //localstorage对应‘记住账号’，sessionstorage不论如何都存，仅在本标签页有效
                      sessionStorage.setItem("user", String(res.data.loginName));
                      sessionStorage.setItem("passwords", String(_this.ruleForm2.checkPass));
                      sessionStorage.setItem("nickname", String(res.data.nickname));
                      __WEBPACK_IMPORTED_MODULE_4__common_js_cook__["a" /* default */].setCookie("user", String(res.data.loginName), 7200);
                      //登录成功后获取权限
                      _this.$http({
                        method: "GET",
                        url: "/rest/sysUser/sysUserLogin",
                        params: {
                          account: _this.ruleForm2.account,
                          password: _this.ruleForm2.checkPass
                        }
                      }).then(function (res) {
                        //成功后自动跳转到第一个有权限的页面，缺点是顺序被后台控制
                        var webIdArr = [];
                        var pathArr = [];
                        var data = res.data;
                        var routes = _this.$router.options.routes;
                        data.webAuthLst.map(function (item) {
                          webIdArr.push(item.webId);
                        });
                        routes.map(function (item) {
                          item.children.map(function (item2) {
                            if (webIdArr.indexOf(item2.webId) > -1) {
                              pathArr.push(item2.path);
                            }
                          });
                        });
                        //这里其实可以优化，不等map结束，就可以跳转了，但也就几毫秒，无所谓
                        if (pathArr.length > 0) {
                          _this.$router.push({ path: pathArr[0] });
                        } else {
                          _this.$router.push({ path: "/noPermission" });
                        }
                        //获取登录人webid44的权限 给qhr页面权限使用
                        data.webAuthLst.forEach(function (item) {
                          if (item.webId == 44) {
                            sessionStorage.setItem("webId_44Auth", String(item.auth));
                          }
                        });
                        sessionStorage.setItem("account", String(res.data.sysUser.account));
                        sessionStorage.setItem("sysUserId", String(res.data.sysUser.id));
                        sessionStorage.setItem("empPk", String(res.data.sysUser.empPk));
                      }).catch(function (err) {
                        __WEBPACK_IMPORTED_MODULE_3__common_js_util__["a" /* default */].myNotify(_this, "error", err.response, "获取用户权限信息失败，请稍后重试");
                      });
                      _this.$alert("授权成功", "提示", { type: "success" });

                    case 19:
                      _this.logining = false;

                    case 20:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_3__common_js_util__["a" /* default */].myNotify(_this, "error", err.response, "登录失败");
            _this.logining = false;
          });
        }
      });
    },
    bindAccount: function bindAccount() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var res;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.$http({
                    method: "post",
                    url: "/rest/crmAccessFmes/saveAccessFmesUser",
                    data: {
                      account: _this2.ruleForm2.account,
                      password: _this2.ruleForm2.checkPass,
                      tenantCode: _this2.$route.query.tenantCode
                    }
                  }).catch(function (err) {
                    __WEBPACK_IMPORTED_MODULE_3__common_js_util__["a" /* default */].myNotify(_this2, "error", err.response, "绑定失败");
                  });

                case 2:
                  res = _context2.sent;

                  if (res.data.code === "0") {
                    console.log(res.data.code);
                    resolve(true);
                  }

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    // this.ruleForm2.account = localStorage.getItem('user') || '';
    setTimeout(function () {
      _this3.ruleForm2.account = "", _this3.ruleForm2.checkPass = "";
    }, 0);
  }
});

/***/ }),

/***/ "G6J7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJaG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"70px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入项目编号..."},model:{value:(_vm.formData.projectCode),callback:function ($$v) {_vm.$set(_vm.formData, "projectCode", $$v)},expression:"formData.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称..."},model:{value:(_vm.formData.projectName),callback:function ($$v) {_vm.$set(_vm.formData, "projectName", $$v)},expression:"formData.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"行业标签"}},[_c('el-select',{attrs:{"placeholder":"请选择行业标签"},model:{value:(_vm.formData.categoryStatus),callback:function ($$v) {_vm.$set(_vm.formData, "categoryStatus", $$v)},expression:"formData.categoryStatus"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已绑定","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未绑定","value":"2"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"岗位标签"}},[_c('el-select',{attrs:{"placeholder":"请选择岗位标签"},model:{value:(_vm.formData.postStatus),callback:function ($$v) {_vm.$set(_vm.formData, "postStatus", $$v)},expression:"formData.postStatus"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已绑定","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未绑定","value":"2"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.getData}},[_vm._v("搜索")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body",staticStyle:{"padding-top":"0"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"tableData",staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":""}},[_c('el-table-column',{attrs:{"prop":"crmProject.projectCode","label":"项目编号","min-width":"200","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"crmProject.projectName","label":"项目名称","min-width":"360","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"crmProject.startTime","label":"项目开始时间","width":"150","align":"center","formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"crmProject.endTime","label":"项目结束时间","width":"150","align":"center","formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"crmProject.projCode","label":"行业标签","min-width":"150","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',_vm._l((scope.row.crmSignLst),function(item){return (item.signType==1)?_c('span',{key:item.id},[_vm._v(_vm._s(item.signName))]):_vm._e()}),0)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"crmProject.projCode","label":"岗位标签","min-width":"120","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',_vm._l((scope.row.crmSignLst),function(item){return (item.signType==2)?_c('span',{key:item.id},[_vm._v(_vm._s(item.signName))]):_vm._e()}),0)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"100","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.toggleExpansion(scope.row)}}},[_vm._v("\n              编辑\n            ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"提 示","visible":_vm.confirmDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.confirmDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('img',{attrs:{"src":__webpack_require__("F0vU"),"alt":""}}),_vm._v("确认清除绑定吗？")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.confirmDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.updateProjectSign(_vm.editRowObj, 'clear')}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"limitPage",attrs:{"title":"编辑","visible":_vm.editRowDialog,"width":"780px","center":true,"show-close":false},on:{"update:visible":function($event){_vm.editRowDialog=$event}}},[_c('el-form',{staticClass:"formInline",staticStyle:{"margin":"20px 30px 0 30px"},attrs:{"inline":"","size":"mini"},model:{value:(_vm.editRowObj),callback:function ($$v) {_vm.editRowObj=$$v},expression:"editRowObj"}},[_c('el-row',[_c('el-form-item',{attrs:{"label":"项目编号："}},[_c('span',[_vm._v(_vm._s(_vm.editRowObj.crmProject.projectCode))])])],1),_vm._v(" "),_c('el-row',[_c('el-form-item',{attrs:{"label":"项目名称："}},[_c('span',[_vm._v(_vm._s(_vm.editRowObj.crmProject.projectName))])])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"行业标签："}},[_c('el-cascader',{attrs:{"placeholder":"请选择行业标签","options":_vm.signList,"change-on-select":""},model:{value:(_vm.editRowObj.categoryIdLst),callback:function ($$v) {_vm.$set(_vm.editRowObj, "categoryIdLst", $$v)},expression:"editRowObj.categoryIdLst"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"岗位标签："}},[_c('el-select',{attrs:{"clearable":"","placeholder":"请选择岗位标签"},model:{value:(_vm.editRowObj.postIdLst),callback:function ($$v) {_vm.$set(_vm.editRowObj, "postIdLst", $$v)},expression:"editRowObj.postIdLst"}},_vm._l((_vm.postList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"clear-btn",attrs:{"size":"mini","round":""},on:{"click":function($event){_vm.confirmDialog = true}}},[_vm._v("清除绑定\n        ")])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.editRowDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small","loading":_vm.ACKButtonLoading},on:{"click":function($event){return _vm.updateProjectSign(_vm.editRowObj, 'edit')}}},[_vm._v("确 定\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GQFJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GoZ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HK3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"paramForm",staticClass:"formInline",attrs:{"model":_vm.paramForm,"inline":true,"label-width":"90px","size":"mini","rules":_vm.rules}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-row',[_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='姓名')?_c('el-form-item',{key:i.id,attrs:{"label":"姓名","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":10},model:{value:(_vm.paramForm.name),callback:function ($$v) {_vm.$set(_vm.paramForm, "name", $$v)},expression:"paramForm.name"}})],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='身份证')?_c('el-form-item',{key:i.id,attrs:{"label":"身份证","prop":"idcard"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":18},model:{value:(_vm.paramForm.idcard),callback:function ($$v) {_vm.$set(_vm.paramForm, "idcard", $$v)},expression:"paramForm.idcard"}})],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='促销员ID')?_c('el-form-item',{key:i.id,attrs:{"label":"促销员ID","prop":"empPk"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50},model:{value:(_vm.paramForm.empPk),callback:function ($$v) {_vm.$set(_vm.paramForm, "empPk", $$v)},expression:"paramForm.empPk"}})],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='手机号')?_c('el-form-item',{key:i.id,attrs:{"label":"手机号","prop":"tel"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50},model:{value:(_vm.paramForm.tel),callback:function ($$v) {_vm.$set(_vm.paramForm, "tel", $$v)},expression:"paramForm.tel"}})],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='年龄')?_c('el-form-item',{key:i.id,staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"年龄"}},[_c('el-form-item',{staticStyle:{"width":"83.5px","margin":"0","padding":"0"},attrs:{"prop":"ageMin"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"岁"},model:{value:(_vm.paramForm.ageMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "ageMin", $$v)},expression:"paramForm.ageMin"}})],1),_vm._v("\n        -\n        "),_c('el-form-item',{attrs:{"prop":"ageMax"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"岁"},model:{value:(_vm.paramForm.ageMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "ageMax", $$v)},expression:"paramForm.ageMax"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='身高')?_c('el-form-item',{key:i.id,staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"身高"}},[_c('el-form-item',{staticStyle:{"width":"83.5px","margin":"0","padding":"0"},attrs:{"prop":"heightMin"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"CM"},model:{value:(_vm.paramForm.heightMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "heightMin", $$v)},expression:"paramForm.heightMin"}})],1),_vm._v("\n        -\n        "),_c('el-form-item',{attrs:{"prop":"heightMax"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"CM"},model:{value:(_vm.paramForm.heightMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "heightMax", $$v)},expression:"paramForm.heightMax"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='状态' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"状态","prop":"status"}},[_c('el-select',{attrs:{"placeholder":"请选择状态"},model:{value:(_vm.paramForm.status),callback:function ($$v) {_vm.$set(_vm.paramForm, "status", $$v)},expression:"paramForm.status"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"项目中","value":"在岗"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"待岗中","value":"待岗"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='性别')?_c('el-form-item',{key:i.id,attrs:{"label":"性别","prop":"sex"}},[_c('el-select',{attrs:{"placeholder":"请选择性别"},model:{value:(_vm.paramForm.sex),callback:function ($$v) {_vm.$set(_vm.paramForm, "sex", $$v)},expression:"paramForm.sex"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"男","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"女","value":"2"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='学历')?_c('el-form-item',{key:i.id,attrs:{"label":"学历","prop":"educationId"}},[_c('el-select',{attrs:{"placeholder":"请选择学历"},model:{value:(_vm.paramForm.educationId),callback:function ($$v) {_vm.$set(_vm.paramForm, "educationId", $$v)},expression:"paramForm.educationId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.educationList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.masterName,"value":item.id}})})],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='信用' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"信用"}},[_c('el-form-item',{staticStyle:{"width":"83.5px","margin":"0","padding":"0"},attrs:{"prop":"creditScoreMin"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"分数"},model:{value:(_vm.paramForm.creditScoreMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "creditScoreMin", $$v)},expression:"paramForm.creditScoreMin"}})],1),_vm._v("\n        -\n        "),_c('el-form-item',{attrs:{"prop":"creditScoreMax"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"分数"},model:{value:(_vm.paramForm.creditScoreMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "creditScoreMax", $$v)},expression:"paramForm.creditScoreMax"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='星级' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"星级","prop":"starLevelId"}},[_c('el-select',{attrs:{"placeholder":"请选择星级"},model:{value:(_vm.paramForm.starLevelId),callback:function ($$v) {_vm.$set(_vm.paramForm, "starLevelId", $$v)},expression:"paramForm.starLevelId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.starLevelList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.rankName,"value":item.id}})})],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='地区' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"省","prop":"provinceId"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择省"},on:{"change":_vm.searchCity},model:{value:(_vm.paramForm.provinceId),callback:function ($$v) {_vm.$set(_vm.paramForm, "provinceId", $$v)},expression:"paramForm.provinceId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.provinceList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.adName,"value":item.id}})})],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='地区' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"市","prop":"cityId"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择市"},on:{"change":_vm.searchArea},model:{value:(_vm.paramForm.cityId),callback:function ($$v) {_vm.$set(_vm.paramForm, "cityId", $$v)},expression:"paramForm.cityId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.cityList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.adName,"value":item.id}})})],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='地区' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"地区","prop":"areaId"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择地区"},model:{value:(_vm.paramForm.areaId),callback:function ($$v) {_vm.$set(_vm.paramForm, "areaId", $$v)},expression:"paramForm.areaId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.areaList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.adName,"value":item.id}})})],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='是否有合约' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"是否有合约","prop":"agreement"}},[_c('el-select',{attrs:{"placeholder":"请选择是否有合约"},model:{value:(_vm.paramForm.agreement),callback:function ($$v) {_vm.$set(_vm.paramForm, "agreement", $$v)},expression:"paramForm.agreement"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"有","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"没有","value":"2"}})],1)],1):_vm._e()}),_vm._v(" "),(_vm.userIsPLUS && _vm.showAuthorizeFlag)?_c('el-form-item',{staticStyle:{"white-space":"nowrap"},attrs:{"label":"个人信息授权","prop":"authorizeFlag"}},[_c('el-select',{attrs:{"placeholder":"个人信息授权"},model:{value:(_vm.paramForm.authorizeFlag),callback:function ($$v) {_vm.$set(_vm.paramForm, "authorizeFlag", $$v)},expression:"paramForm.authorizeFlag"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已授权","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未授权","value":"0"}})],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='认证状态' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"认证状态","prop":"isAuthentication"}},[_c('el-select',{attrs:{"placeholder":"请选择认证状态"},model:{value:(_vm.paramForm.isAuthentication),callback:function ($$v) {_vm.$set(_vm.paramForm, "isAuthentication", $$v)},expression:"paramForm.isAuthentication"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"注册会员","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"身份认证","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"实名认证","value":"2"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='银行卡认证状态' && _vm.userIsPLUS)?_c('el-form-item',{key:i.id,attrs:{"label":"银行卡认证状态","prop":"isBankAuthentication"}},[_c('el-select',{attrs:{"placeholder":"请选择银行卡认证状态"},model:{value:(_vm.paramForm.isBankAuthentication),callback:function ($$v) {_vm.$set(_vm.paramForm, "isBankAuthentication", $$v)},expression:"paramForm.isBankAuthentication"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"通过","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未通过","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"人工认证","value":"2"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='门店名称')?_c('el-form-item',{key:i.id,attrs:{"label":"门店名称","prop":"storeName"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50},model:{value:(_vm.paramForm.storeName),callback:function ($$v) {_vm.$set(_vm.paramForm, "storeName", $$v)},expression:"paramForm.storeName"}})],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='门店编码')?_c('el-form-item',{key:i.id,attrs:{"label":"门店编码","prop":"storeCode"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50},model:{value:(_vm.paramForm.storeCode),callback:function ($$v) {_vm.$set(_vm.paramForm, "storeCode", $$v)},expression:"paramForm.storeCode"}})],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='否签约薪太软')?_c('el-form-item',{key:i.id,attrs:{"label":"是否签约","prop":"signContract"}},[_c('el-select',{attrs:{"placeholder":"请选择..."},model:{value:(_vm.paramForm.signContract),callback:function ($$v) {_vm.$set(_vm.paramForm, "signContract", $$v)},expression:"paramForm.signContract"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已签约","value":"true"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未签约","value":"false"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='签约客户')?_c('el-form-item',{key:i.id,attrs:{"label":"签约客户","prop":"signCustomer"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.paramForm.signCustomer),callback:function ($$v) {_vm.$set(_vm.paramForm, "signCustomer", $$v)},expression:"paramForm.signCustomer"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.customerList),function(item){return _c('el-option',{key:item,attrs:{"value":item}})})],2)],1):_vm._e()})],2),_vm._v(" "),(_vm.userIsPLUS)?_c('el-row',[(_vm.config_top && _vm.config_bottom)?_c('hr'):_vm._e(),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='项目数量')?_c('el-form-item',{key:i.id,staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"项目数量"}},[_c('el-form-item',{staticStyle:{"width":"83.5px","margin":"0","padding":"0"},attrs:{"prop":"projectNumMin"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"个"},model:{value:(_vm.paramForm.projectNumMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "projectNumMin", $$v)},expression:"paramForm.projectNumMin"}})],1),_vm._v("\n        -\n        "),_c('el-form-item',{attrs:{"prop":"projectNumMax"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"个"},model:{value:(_vm.paramForm.projectNumMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "projectNumMax", $$v)},expression:"paramForm.projectNumMax"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='服务月数')?_c('el-form-item',{key:i.id,staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"服务月数"}},[_c('el-form-item',{staticStyle:{"width":"83.5px","margin":"0","padding":"0"},attrs:{"prop":"workMonthMin"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"月"},model:{value:(_vm.paramForm.workMonthMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "workMonthMin", $$v)},expression:"paramForm.workMonthMin"}})],1),_vm._v("\n        -\n        "),_c('el-form-item',{attrs:{"prop":"workMonthMax"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"月"},model:{value:(_vm.paramForm.workMonthMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "workMonthMax", $$v)},expression:"paramForm.workMonthMax"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='服务渠道')?_c('el-form-item',{key:i.id,attrs:{"label":"服务渠道","prop":"channel"}},[_c('el-select',{attrs:{"placeholder":"请选择服务渠道"},model:{value:(_vm.paramForm.channel),callback:function ($$v) {_vm.$set(_vm.paramForm, "channel", $$v)},expression:"paramForm.channel"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.channelList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.masterName,"value":item.masterName}})})],2)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='场次数量')?_c('el-form-item',{key:i.id,staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"场次数量"}},[_c('el-form-item',{staticStyle:{"width":"83.5px","margin":"0","padding":"0"},attrs:{"prop":"frequencyNumMin"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"场"},model:{value:(_vm.paramForm.frequencyNumMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "frequencyNumMin", $$v)},expression:"paramForm.frequencyNumMin"}})],1),_vm._v("\n        -\n        "),_c('el-form-item',{attrs:{"prop":"frequencyNumMax"}},[_c('el-input',{staticClass:"small-input",attrs:{"placeholder":"场"},model:{value:(_vm.paramForm.frequencyNumMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "frequencyNumMax", $$v)},expression:"paramForm.frequencyNumMax"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.paramConfig),function(i){return (i.crmMaster.masterName=='是否QHR人员')?_c('el-form-item',{key:i.id,attrs:{"label":"是否QHR人员","prop":"qhrStatus"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.paramForm.qhrStatus),callback:function ($$v) {_vm.$set(_vm.paramForm, "qhrStatus", $$v)},expression:"paramForm.qhrStatus"}},[_c('el-option',{attrs:{"label":"全部","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"否","value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"是","value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"在职","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职中","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"取消离职","value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职","value":"4"}})],1)],1):_vm._e()}),_vm._v(" "),(_vm.userIsPLUS)?_c('filter-tag',{ref:"filterTag",attrs:{"postId":_vm.postId},on:{"signId-Lst":_vm.signIdLsts}}):_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm('paramForm')}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm('paramForm', _vm.paramForm)}}},[_vm._v("筛选")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("展开筛选项")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HOQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "post-taskCenter",
  mounted: function mounted() {},
  data: function data() {
    return {
      Loading: false, //全局loading
      taskInfo: { //左上任务信息的数据
        title: '', //任务标题
        type: '', //任务类型
        during: { //任务参与时间
          start: '',
          end: ''
        },
        auditTime: '', //任务审核时间
        details: '', //任务详情描述
        budget: '', //预算金额
        deadline: '', //完成时限
        options: { //本div所有的选项框的选项
          type: [//任务类型
          { label: '类型一', value: 1 }, { label: '类型二', value: 2 }, { label: '类型三', value: 3 }, { label: '类型四', value: 4 }],
          auditTime: [//任务审核时间
          { label: '时间一', value: 1 }, { label: '时间二', value: 2 }, { label: '时间三', value: 3 }, { label: '时间四', value: 4 }],
          deadline: [//完成时限
          { label: '时限一', value: 1 }, { label: '时限二', value: 2 }, { label: '时限三', value: 3 }, { label: '时限四', value: 4 }]
        }
      },
      taskFile: { //右上文件上传窗口
        type: '', //上传类型
        options: { //本div所有的选项框的选项
          type: [//上传类型
          { label: '图片', value: 1 }, { label: '视频', value: 2 }, { label: '音频', value: 3 }]
        },
        fileList: [//上传上来的列表
        {
          type: '图片',
          picUrl: '',
          details: '',
          editing: false
        }, {
          type: '视频',
          videoUrl: '',
          details: '',
          editing: false
        }, {
          type: '音频',
          AudioUrl: '',
          details: '',
          editing: false
        }]
      },
      taskScope: { //中间：任务参与范围
        ckeckedStores: [//已选择的门店信息
        {
          name: '吉林省',
          num: 1,
          salary: 10
        }, {
          name: '沈阳市',
          num: 1,
          salary: 10
        }, {
          name: '门店名称门店名称',
          num: 1,
          salary: 10
        }, {
          name: '门店名称门店名称',
          num: 100,
          salary: 1000
        }, {
          name: '门店名称门店名称',
          num: 1,
          salary: 99999
        }],
        storesDistance: '', //门店距离选择结果
        distanceList: ['不限', '<1 Km', '<2 Km', '<3 Km', '<5 Km', '<10 Km'] //门店距离选项
      },
      visibleScope: { //下方可见范围设定
        noTaskOnDuty: '', //在岗时任务不可见
        star: '', //星级
        starOptions: [//星级选项
        { id: 1, rankName: '一级' }, { id: 2, rankName: '二级' }, { id: 3, rankName: '三级' }, { id: 4, rankName: '四级' }, { id: 5, rankName: '五级' }, { id: 6, rankName: '六级' }],
        crescoreMin: '', //信用分值下限
        sex: '', //性别
        sexOptions: [{ id: 1, name: '不限' }, { id: 2, name: '男' }, { id: 3, name: '女' }],
        role: [] //角色
      },
      storesDialog: { //选择门店弹框
        show: false

      },
      viewTaskDialog: { //预览岗位弹框
        show: false

      }
    };
  },

  methods: {
    //上传文件-清空编辑状态
    removeEditing: function removeEditing() {
      this.taskFile.fileList.map(function (item, index) {
        item.editing = false;
      });
    },

    //上传文件-切换展开状态
    editing: function editing(index) {
      //点自己且已展开，则关闭。其他所有情况，先清空再展开当前
      if (this.taskFile.fileList[index].editing) {
        this.taskFile.fileList[index].editing = false;
      } else {
        this.removeEditing();
        this.taskFile.fileList[index].editing = true;
      }
    },

    //上传文件-添加文件
    addFile: function addFile() {
      //先清空编辑状态
      this.removeEditing();

      if (this.taskFile.type) {
        var type = void 0;
        if (this.taskFile.type == 1) {
          // alert('添加图片类型')
          type = '图片';
        } else if (this.taskFile.type == 2) {
          // alert('添加视频类型')
          type = '视频';
        } else if (this.taskFile.type == 3) {
          // alert('添加音频类型')
          type = '音频';
        }
        this.taskFile.fileList.unshift({
          type: type,
          picUrl: '',
          videoUrl: '',
          AudioUrl: '',
          details: '',
          editing: true
        });
        //滑块自动置顶
        document.getElementById('fileList').scrollTo(0, 0);
      } else {
        alert('未选择类型');
      }

      //再清空选择的类型
      this.taskFile.type = '';
    },

    //上传文件-删除文件
    deleteFile: function deleteFile(index) {
      alert('删除第' + (index + 1) + '条数据');
      this.taskFile.fileList.splice(index, 1);
    },

    //上传文件-检查文件
    checkUpload: function checkUpload(type) {},

    //上传文件-成功回调
    uploadSucc: function uploadSucc(res, file) {
      this.taskFile.fileList[0] = URL.createObjectURL(file.raw);
      this.$notify({
        title: '成功',
        type: 'success'
      });
    },

    //任务范围-点击选择地区按钮，记得删除
    checkArea: function checkArea() {
      alert('选择地区');
    },

    //任务范围-点击选择门店按钮
    checkShop: function checkShop() {
      this.storesDialog.show = true;
    },

    //任务范围-删除已选的数据
    deleteckeckedStore: function deleteckeckedStore(index) {
      alert('删除第 ' + (index + 1) + ' 条数据');
      this.taskScope.ckeckedStores.splice(index, 1);
    },
    viewTask: function viewTask() {
      this.storesDialog.show = true;
    },
    postTask: function postTask() {
      // check
      // 是否空，日期范围，预算格式，文件添加了必须有数据
      alert('发布任务');
      //成功或错误提示
    }
  }
});

/***/ }),

/***/ "HWTB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXOI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user.2cb076c.jpg";

/***/ }),

/***/ "HtIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pageNo: 1,
      pageSize: 20,
      total: null,
      formData: {
        pageNo: 1,
        pageSize: 20
      },
      tableData: [],
      uploadDialog: false,
      listLoading: false,
      // 页面内权限
      auths: []
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getAuth();
  },

  methods: {
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (sessionStorage.getItem('user') == 'admin1' || sessionStorage.getItem('user') == 'tinashi') {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      }
    },
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/projectScore/getProjectScoreLog",
        data: this.formData
      }).then(function (res) {
        _this.listLoading = false;
        _this.tableData = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
        _this.listLoading = false;
      });

      this.$http({
        method: "POST",
        url: "/rest/projectScore/searchCount"
      }).then(function (res) {
        _this.total = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    getAuth: function getAuth() {
      var _this2 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 18,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          _this2.auths.push(item.auth);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    downloadTmp: function downloadTmp() {
      var _this3 = this;

      this.$http({
        method: "POST",
        url: "/rest/upDownload/downloademplate"
      }).then(function (res) {
        if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      if (response.message == '导入成功') {
        this.getData();
      }
      this.$alert(response.message, '提示', {
        dangerouslyUseHTMLString: true,
        callback: function callback() {
          this.uploadDialog = false;
        }
      });
    },
    handlePreview: function handlePreview(file) {
      // return this.$confirm("您确定上传评分数据吗？", "警告", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消"
      // })
    },
    handleError: function handleError(err, response, file) {
      var _this4 = this;

      var msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, '提示', {
        dangerouslyUseHTMLString: true,
        callback: function callback(action) {
          _this4.uploadDialog = false;
        }
      });
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(cellValue).format('YYYY-MM-DD');
      } else {
        return '';
      }
    }
  }
});

/***/ }),

/***/ "I+mo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I1Y2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      closeLoading: false,
      action: "/rest/CrmCustEmp/importEmployeeList",
      openid: sessionStorage.getItem("sysUserId"),
      // pageNo: 1,
      // pageSize: 10,
      total: null,
      searchData: {
        custEmpName: null,
        idCard: null,
        empPk: null,
        custRole: null,
        pageNo: 1,
        custEmpCode: null,
        type: null,
        pageSize: 10,
        status: null
      },
      formData: {
        custEmpName: null,
        idCard: null,
        empPk: null,
        custRole: null,
        pageNo: 1,
        custEmpCode: null,
        type: null,
        pageSize: 10
      },
      updateData: {
        id: null,
        custEmpName: null,
        idCard: null,
        empPk: null,
        custRole: null,
        pageNo: 1,
        custEmpCode: null,
        type: null,
        pageSize: 10
      },
      tableData: [],
      listLoading: false,
      uploadDialog: false,
      uploadDialogi: false,
      updateDialogi: false,
      uploading: false,
      fileList: [],
      allNcs: [],
      rules: {
        idCard: [{
          pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
          message: "请输入15位或18位身份证号",
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getTerminal();
    this.$refs["formData"].resetFields();
  },

  methods: {
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      }
    },

    //获取项目列表
    getTerminal: function getTerminal() {
      var _this = this;

      this.$http({
        method: "GET",
        url: "/rest/CrmCustEmp/ncList"
      }).then(function (res) {
        _this.allNcs = res.data;
      }).catch(function (err) {
        _this.myNotify(_this, "error", err.response, "查询失败，请稍后重试");
      });
    },
    formatName: function formatName(row, column, cellValue) {
      var a = cellValue[0];
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        for (var i = 0; i < cellValue.length - 1; i++) {
          a = a + "*";
        }
        return a;
      }
    },
    insertBatchs: function insertBatchs() {
      var _this2 = this;

      this.uploadDialog = true;
      this.$nextTick(function () {
        _this2.$refs.upload.clearFiles();
      });
    },
    getData: function getData(pageNo) {
      var _this3 = this;

      console.log("pageNopageNopageNopageNopageNopageNo:" + this.searchData.pageNo);
      if (pageNo) {
        this.searchData.pageNo = pageNo;
      }
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmCustEmp/findCBByIdCardAndName",
        params: this.searchData
      }).then(function (res) {
        console.log(res.data);
        _this3.tableData = res.data.data.list;
        _this3.listLoading = false;
        _this3.total = res.data.data.totalCount;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "查询失败，请稍后重试";
          }
          _this3.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this3.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.pageNo = val;
      this.getData();
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(cellValue).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    remove: function remove(id) {
      var _this4 = this;

      this.$http({
        method: "POST",
        url: "/rest/CrmCustEmp/removeCrmCustEmp",
        params: {
          id: id
        }
      }).then(function (res) {
        _this4.getData();
        _this4.$notify({
          title: "成功",
          message: "移除黑名单成功",
          type: "success"
        });
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = "操作失败，请稍后重试";
        }
        _this4.$notify({
          title: "失败",
          message: errMsg,
          type: "error"
        });
      });
    },
    downloadTmp: function downloadTmp() {
      var _this5 = this;

      this.$http({
        method: "POST",
        url: "/rest/CrmCustEmp/exportTemplate"
      }).then(function (res) {
        if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this5, "error", err.response, "查询失败，请稍后重试");
      });
    },
    changeUpload: function changeUpload(file, fileList) {
      this.fileList = fileList;
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      console.log("222", response);
      this.uploading = false;
      if (response.code == 0) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, "success", response.msg);
        this.getData();
        this.uploadDialog = false;
        this.fileList = [];
      } else {
        // utils.myNotify(this, "error", response.msg);
        if (response.url) {
          this.$confirm("上传失败，点击确认下载错误文件！", "提示", {
            type: "warning",
            callback: function callback(action) {
              // console.log("action: ", action);
              if (action === "confirm") {
                window.open(location.origin + '/' + response.url);
              }
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, "error", response.msg);
        }
      }
    },
    handleError: function handleError(err, response, file) {
      this.uploading = false;
      var msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, "提示", {
        dangerouslyUseHTMLString: true
        // callback: (action) => {
        //   this.uploadDialog = false;
        // },
      });
    },
    exportData: function exportData() {
      var _this6 = this;

      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmCustEmp/exportEmployeeList",
        params: this.searchData
      }).then(function (res) {
        console.log(__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data);
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        console.log(res.data.data);
        _this6.listLoading = false;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "导出失败，请稍后重试";
          }
          _this6.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this6.listLoading = false;
      });
    },

    //点击确定
    aaa: function aaa() {
      var _this7 = this;

      var reg = /^[A-Za-z0-9]+$/;
      var msg = '';
      if (!this.formData.custEmpName) {
        msg = '请输入姓名';
      } else if (!reg.test(this.formData.empPkOrCode || '')) {
        msg = '人员ID信息错误，请修改后重新上传！';
      } else if (!this.formData.custEmpCode) {
        msg = '请输入NC编码';
      } else if (!this.formData.custRole) {
        msg = '请选择职位';
      }
      if (msg) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, "error", msg);
        return;
      }
      // this.formatDate.cardId,
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmCustEmp/save",
        params: {
          empPkOrCode: this.formData.empPkOrCode,
          custEmpCode: this.formData.custEmpCode,
          custEmpName: this.formData.custEmpName,
          custRole: this.formData.custRole,
          type: 0,
          status: 0
        }
      }).then(function (res) {
        console.log("3333333333", res);
        _this7.listLoading = false;
        // if(res.data.code===500){
        //       utils.myNotify(this, "error", res.data.msg);
        // }else {
        //     utils.myNotify(this, "success", res.data.msg);
        // }
        console.log("44444", res.data.code != 0);
        if (res && res.data && res.data.code == 0) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this7, "success", "新增成功");
          _this7.uploadDialogi = false;
          _this7.getData();
        }
        if (res && res.data && (res.data.code != 0 || res.data.code == null)) {
          console.log("55555", res.data.message);
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this7, "error", res.data.msg);
          // this.uploadDialogi = false;
          // this.getData();
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this7, "error", err.response, "新增失败，请稍后重试");
      });
    },

    // 关闭人员映射
    closeEmployee: function closeEmployee(row) {
      var _this8 = this;

      // await this.$confirm("关闭后该人员没有映射关系，确认关闭吗?", "提示", {
      // confirmButtonText: "确定",
      // cancelButtonText: "取消",
      // type: "warning",
      // });
      this.closeLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmCustEmp/save",
        params: {
          id: row.id,
          idCard: row.idCard,
          custEmpCode: row.custEmpCode,
          custEmpName: row.custEmpName,
          custRole: row.custRole,
          type: 1,
          status: 1
        }
      }).then(function (res) {
        _this8.closeLoading = false;
        console.log("res.data.code:" + res.data.code);
        if (res && res.data && res.data.code == 0) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this8, "success", "修改成功");
          _this8.updateDialogi = false;
          _this8.getData();
        }
        if (res && res.data && (res.data.code != 0 || res.data.code == null)) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this8, "error", res.data.msg);
        }
      }).catch(function (err) {
        _this8.closeLoading = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this8, "error", err.response, "关闭失败，请稍后重试");
      });
    },
    update: function update() {
      var _this9 = this;

      this.$http({
        method: "POST",
        url: "/rest/CrmCustEmp/save",
        params: {
          id: this.updateData.id,
          idCard: this.updateData.idCard,
          custEmpCode: this.updateData.custEmpCode,
          custEmpName: this.updateData.custEmpName,
          custRole: this.updateData.custRole,
          type: 1
        }
      }).then(function (res) {
        console.log("res.data.code:" + res.data.code);
        if (res && res.data && res.data.code == 0) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this9, "success", "修改成功");
          _this9.updateDialogi = false;
          _this9.getData();
        }
        if (res && res.data && (res.data.code != 0 || res.data.code == null)) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this9, "error", res.data.msg);
          // this.getData();
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this9, "error", err.response, "修改失败，请稍后重试");
      });
    },

    // action="/rest/CrmCustEmp/importBlackList"
    //                               :before-upload="handlePreview"
    //                               :on-success='handleSuccess'
    //                               :on-error='handleError'
    //                               :show-file-list="false"
    submitUpload: function submitUpload() {
      // operatorId: sessionStorage.getItem('sysUserId')
      console.log(this.openid);
      this.uploading = true;
      this.$refs.upload.submit();
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(2);
      this.fileList = [];
      console.log(file, fileList);
    },
    handlePreview: function handlePreview(file) {
      console.log(3);

      console.log(file);
    },
    exceed: function exceed(files, fileList) {
      // this.$refs.upload.clearFiles();
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, "warning", "只能上传一个文件,请删除后重新上传！");
    },
    handleUpload: function handleUpload() {
      console.log(111);
      this.$refs.upload.clearFiles();
    },
    updateEmployee: function updateEmployee(employee) {
      this.updateData.id = employee.id;
      this.updateData.custEmpCode = employee.custEmpCode;
      this.updateData.custEmpName = employee.custEmpName;
      this.updateData.idCard = employee.custEmpIdcard;
      this.updateData.custRole = employee.custRole;
      this.updateDialogi = true;
    },
    add: function add() {
      this.formData = {
        custEmpName: null,
        idCard: null,
        empPk: null,
        custRole: null,
        pageNo: 1,
        custEmpCode: null,
        type: null,
        pageSize: 10
      };
      this.uploadDialogi = true;
    }
  }
});

/***/ }),

/***/ "I4rS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__ = __webpack_require__("8jay");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰180725重写，合并三个同级子组件，仅保留这一个




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["auths", "page", 'scoreType'],
  name: 'scoreDetailed',
  data: function data() {
    return {
      //页面数据
      rules: { idCard: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].idcard] },
      paramForm: {
        idCard: null,
        name: '',
        empPk: null
      },
      //主页table数据
      loading: false,
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: null,
      //弹框相关数据
      dialogTableVisible: false,
      load: false,
      dialogTab: 1, //弹窗中的第几页
      dialogData: {
        salesmanId: '',
        name: '',
        tab1: {
          data: [],
          pageNo: 1,
          total: null,
          time: '',
          startTime: '',
          endTime: ''
        },
        tab2: {
          data: [],
          pageNo: 1,
          total: null,
          time: '',
          startTime: '',
          endTime: ''
        }
      }
    };
  },
  mounted: function mounted() {
    this.getData(true);
  },

  methods: {
    hehe: function hehe(row) {
      console.log(row);
    },

    //工具类，叠加对象的每个属性的分值
    returnScore: function returnScore(obj) {
      var num = 0;
      for (var i in obj) {
        num += Number(obj[i]);
      }
      return num;
    },

    //工具类-时间转换
    formatTime: function formatTime(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(cellValue).format('YYYY-MM-DD');
    },

    //主页筛选按钮
    submitForm: function submitForm() {
      this.pageNo = 1;
      this.getData(true);
    },

    //获取主页数据
    getData: function getData(getCount) {
      var _this = this;

      this.loading = true;
      var params = {
        idCard: this.paramForm.idCard,
        name: this.paramForm.name,
        empPk: this.paramForm.empPk,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        scoreType: this.scoreType
        //查数据
      };this.$http({
        method: "get", params: params,
        url: '/rest/SearchScoreDetails/searchScore'
      }).then(function (res) {
        res.data.map(function (item) {
          item.idcard = __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].plusXing(String(item.idcard), 6, 4);
        });
        _this.tableData = res.data;
        _this.loading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this, 'warning', err.response, '查询失败，请稍后重试');
        _this.loading = false;
      });
      //查条数
      if (getCount) {
        this.$http({
          method: "get", params: params,
          url: '/rest/SearchScoreDetails/countSearchScore'
        }).then(function (res) {
          _this.total = res.data;
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this, 'warning', err.response, '查询失败，请稍后重试');
        });
      }
    },

    //主页table-跳页、调size
    handleSizeChange: function handleSizeChange(value) {
      this.pageSize = value;
      this.getData(false);
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.pageNo = value;
      this.getData(false);
    },

    //主页-点击查看明细
    showDetails: function showDetails(row) {
      var reset = {
        data: [],
        pageNo: 1,
        total: null,
        time: '',
        startTime: '',
        endTime: ''
      };
      this.dialogData = {
        salesmanId: row.salesmanId,
        name: row.name,
        tab1: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reset)), //直接存指针的话，tab1和2会串位
        tab2: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reset))
      };
      if (this.scoreType == 1) {
        this.getDetail(true, 0); //0是项目分
      } else {
        this.getDetail(true, 1); //1是星级交互分
        this.getDetail(true, 2); //2信用交互分
      }
    },

    //获取弹窗数据
    getDetail: function getDetail(getTotal, scoreFlag) {
      var _this2 = this;

      this.load = true;
      var data = this.dialogData;
      //目前tab2中没有搜索选项，所以仅在首次进入的时候获取一次数据，其他时间不涉及tab2的搜索
      // 获取tab2时pageNo sTime eTime都是初始值，直接用tab1的即可
      var params = {
        salesmanId: data.salesmanId,
        scoreType: this.scoreType,
        pageNo: data['tab' + (scoreFlag == 2 ? 2 : 1)].pageNo, //积分必是第一页，星级信用根据实际的来
        pageSize: 10,
        startTime: scoreFlag != 2 ? data.tab1.startTime : null, //积分传时间区间，星级信用的第一页传时间区间
        endTime: scoreFlag != 2 ? data.tab1.endTime : null,
        scoreFlg: scoreFlag //标志位，是查项目分1,还是交互分2,还是全部0
      };
      this.dialogTableVisible = true;
      //查数据
      this.$http({
        method: "get",
        url: '/rest/SearchScoreDetails/searchScoreDetails',
        params: params
      }).then(function (res) {
        data['tab' + (scoreFlag == 2 ? 2 : 1)].data = res.data.list;
        data['tab' + (scoreFlag == 2 ? 2 : 1)].total = res.data.countSize;
        _this2.load = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this2, 'warning', err.response, '查询失败，请稍后重试');
        _this2.load = false;
      });
      // //查条数
      // if (getTotal) {
      //   this.$http({
      //     method: "get",
      //     url: '/rest/SearchScoreDetails/countSearchScoreDetails',
      //     params
      //   }).then(res => {
      //     data[`tab${scoreFlag==2?2:1}`].total = res.data.count
      //   }).catch(err => {
      //     utils.myNotify(this, 'warning', err.response, '查询失败，请稍后重试')
      //   })
      // }
    },

    //弹窗-tab1跳页
    handleCurrentChange1: function handleCurrentChange1(value) {
      this.dialogData.tab1.pageNo = value;
      this.getDetail(false, this.scoreType == 1 ? 0 : 1); //可能是从积分或者星级和信用的项目页进来的
    },

    //弹窗-tab2的跳页，因为不能附加传参，所以只能写两个方法
    handleCurrentChange2: function handleCurrentChange2(value) {
      this.dialogData.tab2.pageNo = value;
      this.getDetail(false, 2); //只能是从星级和信用的交互页进来的
    },

    //弹窗-筛选按钮
    submitForm2: function submitForm2() {
      var data = this.dialogData.tab1;
      if (data.time[0]) {
        data.startTime = new Date(data.time[0]).getTime();
      }
      if (data.time[1]) {
        data.endTime = new Date(data.time[1]).getTime() + 82800000; //？？？？？？
      }
      data.pageNo = 1;
      this.getDetail(true, this.scoreType == 1 ? 0 : 1); //可能是从积分或者星级和信用的项目页进来的
    }
  }
});

/***/ }),

/***/ "I9zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zStar_vue__ = __webpack_require__("tNt/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2529eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zStar_vue__ = __webpack_require__("cYUX");
function injectStyle (ssrContext) {
  __webpack_require__("f6oV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f2529eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zStar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2529eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zStar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IMXc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhCQzEzNzA0REZBRTExRTc5RkM4ODFERjI3RDI0QjMwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhCQzEzNzA1REZBRTExRTc5RkM4ODFERjI3RDI0QjMwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEJDMTM3MDJERkFFMTFFNzlGQzg4MURGMjdEMjRCMzAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEJDMTM3MDNERkFFMTFFNzlGQzg4MURGMjdEMjRCMzAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7OnzrXAAABU0lEQVR42ozTvUvDQBjH8TaNb6i7i7gITurgv+AoDg5iFRSHJgpOzio6+A84mbmCFS2CZvGvKHRQfAU3QYRCh2rR6vfkV5Ca5HLwISHP3XPPvSTreV7G0nJ6fkUFgyD4fToZe8tLYnNTxLf1XsJnXEdbRQvqk7NV5aaoZh9ZbOE4rqq4irpQUPwIRSUuKBY5azd8jGFURvChge0KdnGIAzzjwfB9/9YcnpmxiRrWUME8hjCgpbSbqaofw1jGjcbUuAJN50+nvCowCd4S9u5FS14yY0hS7NzsUzRwjkVcxSSaxglWEMZtdqiqLtAbkaQPl+oT2k6tjle8R8Qa2s96muMfR1XvgzqtHe2dadfqkyrRHTbxhBnM4hEbuI9K5MYkmoS5H+so6/sc9nTfKraKHN3cVUzgDN9S1jcT6+kcG1XRVMJf3tIvU7ItrSW29m+iHwEGAKnXTijB5HBIAAAAAElFTkSuQmCC"

/***/ }),

/***/ "IWQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      total: null,
      pageNo: 1,
      pageSize: 10,
      //父级信息
      dataList: this.Child,
      //表单信息
      tableData: [],
      provinceId: null,
      listLoading: false,
      releaseInfo: null,
      release: false,
      radio: "8"
    };
  },

  props: ["Child"],
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    change: function change() {
      this.$emit("upup", false); //主动触发父级upup方法，'hehe'为向父组件传递的数据
    },
    Refresh: function Refresh() {
      this.$emit("fresh"); //主动触发父级fresh方法，'hehe'为向父组件传递的数据
    },
    getNumber: function getNumber() {
      var _this = this;

      //刷新内部人数数据
      this.$http({
        method: "GET",
        url: "/rest/PostManagement/searchPosStore",
        params: {
          postoreId: this.dataList[0].posStoreId
        }
      }).then(function (res) {
        var number = _this.dataList[0];
        var data = res.data;

        number.planNumber = data.planNumber;
        number.recruitsNumber = data.recruitsNumber;
        number.waitNumber = data.waitNumber;
        number.interviewNumber = data.interviewNumber;
        number.interviewPassNumber = data.interviewPassNumber;
      }).catch(function (err) {
        _this.$notify({
          title: "错误",
          message: '查询失败，请刷新重试',
          type: "error"
        });
      });
    },
    handleSizeChange: function handleSizeChange(value) {},
    handleCurrentChange: function handleCurrentChange(value) {
      this.pageNo = value;
      this.getData();
    },
    searchCity: function searchCity(value) {},
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      this.$http({
        method: "GET",
        url: "/rest/PostManagement/searchAuditSalesman",
        params: {
          posStoreId: this.dataList[0].posStoreId,
          operatorId: sessionStorage.getItem("sysUserId"),
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
      }).then(function (res) {
        _this2.tableData = res.data;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
      });

      this.$http({
        method: "GET",
        url: "/rest/PostManagement/countAuditSalesman",
        params: {
          posStoreId: this.dataList[0].posStoreId
        }
      }).then(function (res) {
        _this2.total = res.data;
      });
    },
    changeValue: function changeValue(i) {
      console.log(i);
    },
    operation: function operation(i, num, text) {
      var _this3 = this;

      var msg = '';
      if (num == 7) {
        msg = '确认将该人员从此任务上释放吗？';
      } else if (num == 5) {
        msg = '审核不通过之后，该人员将无法执行此任务，确认审核不通过吗？';
      } else {
        msg = "\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\uFF0C\u786E\u8BA4" + text + " \uFF1F";
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var a = new Date().getTime();
        var arr = [{
          salesmanWorkApplyId: i.salesmanWorkApplyId,
          posStoreId: i.posStoreId,
          salesmanId: i.salesmanId,
          name: i.name,
          tel: String(i.tel),
          idCard: String(i.idCard),
          applyTime: i.applyTime,
          passTime: _this3.formatTime(a),
          auditStatus: num,
          operatorId: sessionStorage.getItem("sysUserId")
        }];
        _this3.$http({
          method: "POST",
          url: "/rest/PostManagement/AuditSalesman",
          data: arr
        }).then(function (res) {
          console.log('rrrrrrrrrrrrrrrrrr' + res.data);
          var flg = false;
          var message = res.data.message;
          if (message == '成功') {
            flg = true;
            _this3.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            _this3.Refresh(); //刷新外部数据
          } else {
            //其他有多种情况，反正都是失败
            _this3.$notify({
              title: "警告",
              message: message,
              type: "warning"
            });
          }
          // 失败有时候也需要重载，干脆就全重载了，刷新外部那个太慢了，失败了不走
          _this3.getNumber(); //刷新内部人数数据
          _this3.getData(); //刷新内部table及count数据
          //只要是235就走，不管成功与否，但6必须是成功才走
          if (num == 2 || num == 3 || num == 5 || num == 6 && flg) {
            _this3.$http({
              method: "POST",
              url: '/rest/PostManagement/sendMessage',
              params: {
                salesmanId: i.salesmanId,
                posName: _this3.dataList[0].posName,
                auditStatus: num,
                posStoreId: i.posStoreId
              }
            });
          }
        }).catch(function (err) {
          console.log('eeeeeeeeeeeeeeeeeee' + err.response.data.message);
          var message = err.response.data.message;
          _this3.$notify({
            title: "警告",
            message: message,
            type: "warning"
          });
        });
      });
    },
    formatTime: function formatTime(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(cellValue).format("YYYY-MM-DD");
    },
    formatTime2: function formatTime2(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format("YYYY-MM-DD HH:mm:ss");
    },
    changeRelease: function changeRelease() {
      this.release = false;
    },
    releaseTrue: function releaseTrue(i) {
      this.releaseInfo = i;
      this.release = true;
    },
    submitRelease: function submitRelease() {
      console.log(this.radio);
      this.operation(this.releaseInfo, 7, '释放');
      this.release = false;
    },

    // 虚拟拨号
    createOutCall: function createOutCall(salesmanId, salesmanName, salesmanTel, projectBU, projectCode, projectName) {
      var _this4 = this;

      // 获取当前用户虚拟电话配置
      this.$http({
        method: 'get',
        url: '/rest/JiangYiJoint/dummy-config',
        params: {
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        if (res.data.status == '200' && res.data.data) {
          var config = res.data.data;
          // 拨打虚拟电话
          var ajaxdata = {
            city: null,
            cityCode: null,
            county: null,
            countyCode: null,
            empPK: config.phoneUserEmpPk,
            module: "岗位管理",
            phoneUserCode: config.phoneUserCode,
            phoneUserName: config.phoneUserName,
            projectBU: projectBU,
            projectCode: projectCode,
            projectName: projectName,
            province: null,
            provinceCode: null,
            salesId: salesmanId,
            salesName: salesmanName,
            storeCode: null,
            storeName: null,
            ivr: { called: salesmanTel, caller: config.phoneNumber }
          };
          var xhrs2 = new XMLHttpRequest();
          xhrs2.onreadystatechange = function () {
            if (xhrs2.readyState == 4) {
              if (xhrs2.status == 200) {
                // 成功不做任何事
                document.getElementById('mask_box').disabled = true;
                setTimeout(function () {
                  document.getElementById('mask_box').disabled = false;
                }, 5000);
                alert("号码呼叫中....");
              } else {
                var str = JSON.parse(xhrs2.responseText);
                document.getElementById('mask_box').disabled = true;
                setTimeout(function () {
                  document.getElementById('mask_box').disabled = false;
                }, 5000);
                alert(str.msg);
              }
            }
          };
          var callurl = _this4.globalParams.remotesUrl + "/plugs/phoneCall/createOutCall";
          xhrs2.open('POST', callurl, true);
          xhrs2.setRequestHeader("Content-type", "application/json");
          xhrs2.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ajaxdata));
        } else {
          alert("当前账号未配置虚拟拨号");
          console.log(res.data);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ "IZle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ImiH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/idCard-img.de61de3.png";

/***/ }),

/***/ "IsUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iy/o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J9Qr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evaluationdetail"},[_c('div',{staticClass:"tableWrap",staticStyle:{"padding":"20px 20px 0 20px","background-color":"white"}},[_c('span',[_vm._v("姓名")]),_vm._v(" "),_c('div',{staticClass:"name"},[_c('el-input',{attrs:{"placeholder":"请输入姓名..."},model:{value:(_vm.paramForm.name),callback:function ($$v) {_vm.$set(_vm.paramForm, "name", $$v)},expression:"paramForm.name"}})],1),_vm._v(" "),_c('span',[_vm._v("身份证")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('el-form',{ref:"paramForm",attrs:{"model":_vm.paramForm,"rules":_vm.rules}},[_c('el-form-item',{attrs:{"prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号..."},model:{value:(_vm.paramForm.idCard),callback:function ($$v) {_vm.$set(_vm.paramForm, "idCard", $$v)},expression:"paramForm.idCard"}})],1)],1)],1),_vm._v(" "),_c('span',[_vm._v("促销员ID")]),_vm._v(" "),_c('div',{staticClass:"name"},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID..."},model:{value:(_vm.paramForm.empPk),callback:function ($$v) {_vm.$set(_vm.paramForm, "empPk", $$v)},expression:"paramForm.empPk"}})],1),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")]),_vm._v(" "),_c('i',{staticClass:"table",staticStyle:{"margin-top":"20px","display":"block","font-style":"normal"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"60","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","width":"260","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","label":"促销员ID","width":"260","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idcard","label":"身份证","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"score","label":"积分","width":"200","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"360","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"pointer mingxi",attrs:{"type":"text","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.showDetails(scope.row)}}},[_vm._v("查看"+_vm._s(_vm.page)+"明细\n            ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"total":_vm.total,"layout":"sizes,total,prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('div',{staticClass:"popUp"},[_c('el-dialog',{attrs:{"title":_vm.dialogData.name+' '+_vm.page+'明细',"visible":_vm.dialogTableVisible},on:{"update:visible":function($event){_vm.dialogTableVisible=$event}}},[(_vm.scoreType != 1)?_c('div',{staticClass:"chooseHeader"},[_c('div',{staticClass:"pointer",class:{'isChoose' : _vm.dialogTab == 1},on:{"click":function($event){_vm.dialogTab = 1}}},[_vm._v("项目分")]),_vm._v(" "),_c('div',{staticClass:"pointer",class:{'isChoose' : _vm.dialogTab == 2},on:{"click":function($event){_vm.dialogTab = 2}}},[_vm._v("交互分")])]):_vm._e(),_vm._v(" "),(_vm.dialogTab == 1)?_c('i',{staticClass:"table",staticStyle:{"display":"block","font-style":"normal","padding":"20px 20px 0 20px","background-color":"#f4f4f4"}},[_c('div',{staticClass:"search popUp"},[_c('span',[_vm._v("时间段")]),_vm._v(" "),_c('el-date-picker',{attrs:{"range-separator":"至","type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期"},model:{value:(_vm.dialogData.tab1.time),callback:function ($$v) {_vm.$set(_vm.dialogData.tab1, "time", $$v)},expression:"dialogData.tab1.time"}}),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.submitForm2}},[_vm._v("筛选")])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.load),expression:"load"}],staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.dialogData.tab1.data}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"60","align":"center"}}),_vm._v(" "),(_vm.scoreType != 1)?_c('el-table-column',{attrs:{"prop":"projectName","label":"项目","width":"300","align":"center"}}):_vm._e(),_vm._v(" "),(_vm.scoreType != 1)?_c('el-table-column',{attrs:{"label":"岗位类型","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.signId == 1)?_c('div',[_vm._v("长促")]):_vm._e(),_vm._v(" "),(scope.row.signId == 2)?_c('div',[_vm._v("短促")]):_vm._e(),_vm._v(" "),(scope.row.signId == 0)?_c('div',[_vm._v("不限")]):_vm._e()]}}],null,false,1112033985)}):_vm._e(),_vm._v(" "),(_vm.scoreType != 1)?_c('el-table-column',{attrs:{"prop":"projectStartTime","label":"项目开始时间","width":"100","align":"center","formatter":_vm.formatTime}}):_vm._e(),_vm._v(" "),(_vm.scoreType != 1)?_c('el-table-column',{attrs:{"prop":"projectEndTime","label":"项目结束时间","width":"100","align":"center","formatter":_vm.formatTime}}):_vm._e(),_vm._v(" "),(_vm.scoreType != 1)?_c('el-table-column',{attrs:{"label":_vm.page+'得分',"align":"center","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"popover"},[_vm._v(_vm._s(_vm.returnScore(scope.row.itemScore))+"\n                "+_vm._s(_vm.hehe(scope.row))+"\n                "),_c('el-popover',{ref:"popover1",attrs:{"visible-arrow":"false","trigger":"hover","placement":"left","width":"210","popper-class":"popText"}},[_c('div',{staticClass:"hoverPop"},_vm._l((scope.row.itemScore),function(item,key){return _c('div',{key:key,staticClass:"hoverWrap"},[_c('div',{staticClass:"hoverPopKey"},[_vm._v(_vm._s(key))]),_vm._v(" "),(item >= 0)?_c('div',{staticClass:"hoverPopValue"},[_vm._v("+ "+_vm._s(item))]):_vm._e(),_vm._v(" "),(item < 0)?_c('div',{staticClass:"hoverPopValue"},[_vm._v(" - "+_vm._s(Math.abs(item)))]):_vm._e()])}),0),_vm._v(" "),_c('el-button',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v("查看得分详情")])],1)],1)]}}],null,false,4086897028)}):_vm._e(),_vm._v(" "),(_vm.scoreType == 1)?_c('el-table-column',{attrs:{"prop":"insertTime","label":"时间","formatter":_vm.formatTime,"align":"center"}}):_vm._e(),_vm._v(" "),(_vm.scoreType == 1)?_c('el-table-column',{attrs:{"prop":"item","label":"积分条目","align":"center"}}):_vm._e(),_vm._v(" "),(_vm.scoreType == 1)?_c('el-table-column',{attrs:{"prop":"score","label":"得分","align":"center"}}):_vm._e()],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.dialogData.tab1.pageNo,"total":_vm.dialogData.tab1.total,"page-size":10,"layout":"total,prev, pager, next, jumper"},on:{"current-change":_vm.handleCurrentChange1}})],1):_c('b',{staticClass:"table",staticStyle:{"display":"block","font-style":"normal","padding":"20px 20px 0 20px","background-color":"#f4f4f4"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.dialogData.tab2.data}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"insertTime","label":"时间","formatter":_vm.formatTime,"align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"item","label":"积分条目","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"score","label":"得分","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.dialogData.tab2.pageNo,"total":_vm.dialogData.tab2.total,"page-size":10,"layout":"total,prev, pager, next, jumper"},on:{"current-change":_vm.handleCurrentChange2}})],1),_vm._v(" "),_c('div',{staticClass:"Determine pointer",on:{"click":function($event){_vm.dialogTableVisible=false}}},[_vm._v("确定")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JDpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Page Not Found\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JG58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":__webpack_require__("YPvR"),"width":"100%","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JKGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"100px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号","prop":"projectCode"}},[_c('el-input',{attrs:{"placeholder":"请输入项目编号..."},model:{value:(_vm.formData.projectCode),callback:function ($$v) {_vm.$set(_vm.formData, "projectCode", $$v)},expression:"formData.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectName"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称..."},model:{value:(_vm.formData.projectName),callback:function ($$v) {_vm.$set(_vm.formData, "projectName", $$v)},expression:"formData.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"配置状态","prop":"status"}},[_c('el-select',{attrs:{"placeholder":"请选择配置状态"},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已配置","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未配置","value":"0"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称","prop":"customer"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择客户名称..."},model:{value:(_vm.formData.customer),callback:function ($$v) {_vm.$set(_vm.formData, "customer", $$v)},expression:"formData.customer"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.allCustomers),function(item){return _c('el-option',{key:item,attrs:{"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台","prop":"supplier"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选签约平台应商..."},model:{value:(_vm.formData.supplier),callback:function ($$v) {_vm.$set(_vm.formData, "supplier", $$v)},expression:"formData.supplier"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.serviceSuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"修改人","prop":"updater"}},[_c('el-input',{attrs:{"placeholder":"请输入修改人..."},model:{value:(_vm.formData.updater),callback:function ($$v) {_vm.$set(_vm.formData, "updater", $$v)},expression:"formData.updater"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目开始日期","prop":"startDate"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.formData.startDate),callback:function ($$v) {_vm.$set(_vm.formData, "startDate", $$v)},expression:"formData.startDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目结束日期","prop":"endDate"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.formData.endDate),callback:function ($$v) {_vm.$set(_vm.formData, "endDate", $$v)},expression:"formData.endDate"}})],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',{staticStyle:{"position":"relative"}},[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.resetForm}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.submitForm}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.exportProject}},[_vm._v("导出")]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","position":"absolute","right":"-150%"}},[_c('el-button',{attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.exportProjectCategory}},[_vm._v("未配置清单下载")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectCode","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceNm","label":"服务商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"客户名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"项目开始时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":"项目结束时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"配置状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 1)?_c('span',[_vm._v("已配置")]):_c('span',[_vm._v("未配置")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplier","label":"签约平台","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"secSupplier","label":"落地方","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierBeginDate","label":"落地方开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierEndDate","label":"落地方结束日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateTime","label":"修改时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updaterAccount","label":"修改人账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updaterNick","label":"修改人姓名","align":"center"}}),_vm._v(" "),(_vm.editProjectAuth)?_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.openEditDialog(scope.row.id, scope.row.projectName, scope.row.supplier)}}},[_vm._v("修改")])]}}],null,false,2541513518)}):_vm._e()],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.editProjectName,"visible":_vm.showEditDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.showEditDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择供应商"},model:{value:(_vm.selectSupplier),callback:function ($$v) {_vm.selectSupplier=$$v},expression:"selectSupplier"}},[_c('el-option',{attrs:{"label":"无","value":null}}),_vm._v(" "),_vm._l((_vm.serviceSuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})})],2),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.editProjectSupplier}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showEditDialog=false}}},[_vm._v("取消")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JViv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"100px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"公司名称","prop":"company"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择公司名称..."},model:{value:(_vm.formData.company),callback:function ($$v) {_vm.$set(_vm.formData, "company", $$v)},expression:"formData.company"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_vm._l((_vm.companiesAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"待置换供应商","prop":"originSupplier"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择待置换供应商..."},model:{value:(_vm.formData.originSupplier),callback:function ($$v) {_vm.$set(_vm.formData, "originSupplier", $$v)},expression:"formData.originSupplier"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_vm._l((_vm.suppliersAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"当前供应商","prop":"permuteSupplier"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择当前供应商..."},model:{value:(_vm.formData.permuteSupplier),callback:function ($$v) {_vm.$set(_vm.formData, "permuteSupplier", $$v)},expression:"formData.permuteSupplier"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_vm._l((_vm.suppliersAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择状态..."},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":'生效中',"value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":'已关闭',"value":0}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.resetForm}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.searchForm}},[_vm._v("筛选")]),_vm._v(" "),(_vm.editAuth)?_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"0px"},on:{"click":_vm.addDialog}},[_vm._v("新增")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"companyName","label":"公司名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"originSupplierName","label":"待置换供应商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"permuteSupplierName","label":"当前供应商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"permuteBank","label":"当前供应商开户行","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"permuteBankAccount","label":"当前供应商银行账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"creationTime","label":"生效时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 0)?_c('div',[_vm._v("已关闭")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('div',[_vm._v("生效中")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"closeTime","label":"关闭时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operatorAccount","label":"操作人账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operatorName","label":"操作人姓名","align":"center"}}),_vm._v(" "),(_vm.editAuth)?_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.showEdit(scope.row.id, scope.row.companyName)}}},[_vm._v("修改")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.close(scope.row.id)}}},[_vm._v("关闭")]):_vm._e()]}}],null,false,3815526236)}):_vm._e()],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":'供应商置换',"visible":_vm.showAddDialog,"width":"40%","center":""},on:{"update:visible":function($event){_vm.showAddDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"add-select",staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('el-form',{ref:"addData",attrs:{"model":_vm.addData,"label-width":"200px","size":"small","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"公司名称","required":"true"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择公司名称...","clearable":""},on:{"change":_vm.searchCompanySuppliers,"clear":function($event){_vm.addData.originSupplier = null}},model:{value:(_vm.addData.company),callback:function ($$v) {_vm.$set(_vm.addData, "company", $$v)},expression:"addData.company"}},_vm._l((_vm.companiesAll),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"待置换供应商","required":"true"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择待置换供应商...","clearable":""},model:{value:(_vm.addData.originSupplier),callback:function ($$v) {_vm.$set(_vm.addData, "originSupplier", $$v)},expression:"addData.originSupplier"}},_vm._l((_vm.companySuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"置换后供应商","required":"true"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择置换后供应商...","clearable":""},on:{"change":_vm.searchOpenBanks,"clear":function($event){_vm.addData.permuteBank = null,_vm.addData.permuteBankAccount = null}},model:{value:(_vm.addData.permuteSupplier),callback:function ($$v) {_vm.$set(_vm.addData, "permuteSupplier", $$v)},expression:"addData.permuteSupplier"}},_vm._l((_vm.suppliersAll),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"置换后供应商开户行","required":"true"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择置换后供应商开户行...","clearable":""},on:{"change":_vm.searchOpenBankNos,"clear":function($event){_vm.addData.permuteBankAccount = null}},model:{value:(_vm.addData.permuteBank),callback:function ($$v) {_vm.$set(_vm.addData, "permuteBank", $$v)},expression:"addData.permuteBank"}},_vm._l((_vm.openBanks),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"置换后供应商银行账号","required":"true"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择置换后供应商银行账号...","clearable":""},model:{value:(_vm.addData.permuteBankAccount),callback:function ($$v) {_vm.$set(_vm.addData, "permuteBankAccount", $$v)},expression:"addData.permuteBankAccount"}},_vm._l((_vm.openBankNos),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.add}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showAddDialog=false}}},[_vm._v("取消")])],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.detailCompany,"visible":_vm.showDetailDialog,"width":"80%","center":""},on:{"update:visible":function($event){_vm.showDetailDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('div',{staticClass:"add-select",staticStyle:{"text-align":"center","margin-top":"20px"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.detailsData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"companyName","label":"公司名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"originSupplierName","label":"原供应商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"permuteSupplierName","label":"当前供应商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"permuteBank","label":"当前供应商开户行","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"permuteBankAccount","label":"当前供应商银行账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"creationTime","label":"生效时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 0)?_c('div',[_vm._v("已关闭")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('div',[_vm._v("生效中")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"closeTime","label":"关闭时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operatorName","label":"操作人姓名","align":"center"}}),_vm._v(" "),(_vm.editAuth)?_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 1 && scope.row.lastNode == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.showAddDetail(scope.row.id, scope.row.permuteSupplierName)}}},[_vm._v("置换")]):(scope.row.status == 1 && scope.row.lastNode == 0)?_c('span',[_vm._v("置换")]):_vm._e(),_vm._v(" "),(scope.row.status == 1 && scope.row.lastNode == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.showCloseDetail(scope.row.id)}}},[_vm._v("关闭")]):(scope.row.status == 1 && scope.row.lastNode == 0)?_c('span',[_vm._v("关闭")]):_vm._e()]}}],null,false,1194503766)}):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showDetailDialog = false}}},[_vm._v("确定")])],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":'供应商置换',"visible":_vm.showAddDetailDialog,"width":"40%","center":""},on:{"update:visible":function($event){_vm.showAddDetailDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"add-select",staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('el-form',{ref:"addDetailData",attrs:{"model":_vm.addDetailData,"label-width":"200px","size":"small","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"公司名称"}},[_c('p',[_vm._v(_vm._s(_vm.detailCompany))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"当前供应商"}},[_c('p',[_vm._v(_vm._s(_vm.currentDetailSupplier))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"置换后供应商","required":"true"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择置换后供应商...","clearable":""},on:{"change":_vm.searchDetailOpenBanks,"clear":function($event){_vm.addDetailData.permuteBank = null,_vm.addDetailData.permuteBankAccount = null}},model:{value:(_vm.addDetailData.permuteSupplier),callback:function ($$v) {_vm.$set(_vm.addDetailData, "permuteSupplier", $$v)},expression:"addDetailData.permuteSupplier"}},_vm._l((_vm.suppliersAll),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"置换后供应商开户行","required":"true"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择置换后供应商开户行...","clearable":""},on:{"change":_vm.searchDetailOpenBankNos,"clear":function($event){_vm.addDetailData.permuteBankAccount = null}},model:{value:(_vm.addDetailData.permuteBank),callback:function ($$v) {_vm.$set(_vm.addDetailData, "permuteBank", $$v)},expression:"addDetailData.permuteBank"}},_vm._l((_vm.openBanks),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"置换后供应商银行账号","required":"true"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择置换后供应商银行账号...","clearable":""},model:{value:(_vm.addDetailData.permuteBankAccount),callback:function ($$v) {_vm.$set(_vm.addDetailData, "permuteBankAccount", $$v)},expression:"addDetailData.permuteBankAccount"}},_vm._l((_vm.openBankNos),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.addDetail}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showAddDetailDialog=false}}},[_vm._v("取消")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JccC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jly+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"outbox",attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"flexBox between"},[_c('div',{staticClass:"nameBox employeeName"},[_vm._v(_vm._s(_vm.param.employeeName))]),_vm._v(" "),_c('div',{staticClass:"flexBox ageBox",staticStyle:{"color":"#8299dc"}},[_c('div',[_vm._v(_vm._s(_vm.param.age)+"岁")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.param.sex))])])]),_vm._v(" "),_c('div',{staticClass:"nameBox"},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(_vm.status)+" ")])]),_vm._v(" "),_c('div',{staticClass:"itemBox"},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"size":"mini"}},[_c('el-form-item',{staticClass:"formItem",attrs:{"label":"人员类别:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.param.personType || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem",attrs:{"label":"米咖注册认证状态:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.isAuthentivayion || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem",attrs:{"label":"身份证号:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.param.documentNumber || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem",attrs:{"label":"人员ID:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.param.empPk || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem",attrs:{"label":"QHR手机号:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.param.phone || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem",attrs:{"label":"米咖手机号:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.param.tel || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem",attrs:{"label":"米咖银行卡号:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.param.bankNum || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem",attrs:{"label":"员工编号:"}},[_c('span',{staticClass:"contentType"},[_vm._v(" "+_vm._s(_vm.param.employeeNumber || "无"))])]),_vm._v(" "),_c('el-form-item',{staticClass:"formItem last",attrs:{"label":"联系地址:"}},[_c('span',{staticClass:"contentType last"},[_vm._v(" "+_vm._s(_vm.param.address || "无"))])])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('div',{staticClass:"title"},[_vm._v("工作履历")]),_vm._v(" "),_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"clientId","label":"项目客户","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"89","prop":"quitCrmStatus","label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.quitCrmStatus == 1)?_c('div',[_vm._v("在职")]):_vm._e(),_vm._v(" "),(scope.row.quitCrmStatus == 2)?_c('div',[_vm._v("离职中")]):_vm._e(),_vm._v(" "),(scope.row.quitCrmStatus == 4)?_c('div',[_vm._v("离职")]):_vm._e(),_vm._v(" "),(scope.row.quitCrmStatus == 3)?_c('div',[_vm._v("取消离职")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"89","prop":"zhangtaoId","label":"账套","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"130","label":"合同开始日期","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.enterDate && _vm.handleTime(scope.row.enterDate))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"130","label":"离职时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.lastWorkDay && _vm.handleTime(scope.row.lastWorkDay))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"pensionClassCityId","label":"缴保城市","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"contractTypeId","label":"合同类型","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"sentSyncTime","label":"发起时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"syncTime","label":"签约时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"230","prop":"qiyuesuoAccountId","label":"所属公司","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jut4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KLML":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KNks":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KhWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dialogVisible)?_c('div',[_c('el-dialog',{attrs:{"title":"合同发起记录查询","visible":_vm.dialogVisible,"width":"1160px","center":true,"show-close":true},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"125px","size":"mini"}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":30},model:{value:(_vm.param.employeeName),callback:function ($$v) {_vm.$set(_vm.param, "employeeName", $$v)},expression:"param.employeeName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18},model:{value:(_vm.param.idCard),callback:function ($$v) {_vm.$set(_vm.param, "idCard", $$v)},expression:"param.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目客户"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.clientId),callback:function ($$v) {_vm.$set(_vm.param, "clientId", $$v)},expression:"param.clientId"}},_vm._l((_vm.allCustomers),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","element-loading-text":"拼命加载中...","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"employeeName","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"documentNumber","label":"身份证号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"clientId","label":"项目客户","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"190","prop":"qiyuesuoAccount","label":"所属公司","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"190","prop":"syncTime","label":"发起时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"start","label":"合同开始日期","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedDate(scope.row.start)))])]}}],null,false,2441546306)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"isSign","label":"是否签约","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"190","prop":"signTime","label":"签约时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.signTime)?_c('span',[_vm._v("\n              "+_vm._s(scope.row.signTime)+"\n            ")]):(!scope.row.signTime)?_c('span',[_vm._v(" -- ")]):_vm._e()]}}],null,false,2731751401)})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.param.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.param.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LCYl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjYzMDFDQkM0RDY3RTExRTc5RTU0RUMxQjAwNDAyRjkxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjYzMDFDQkM1RDY3RTExRTc5RTU0RUMxQjAwNDAyRjkxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjMwMUNCQzJENjdFMTFFNzlFNTRFQzFCMDA0MDJGOTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NjMwMUNCQzNENjdFMTFFNzlFNTRFQzFCMDA0MDJGOTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7bUkrgAAACE0lEQVR42uSXuUskQRSHp2eFxVkRTDYSERZkxtADvFBxRdBQUMzMRTfa1H9BvG+TzVeNlvVmFDXUyFA8wCNYWG93Haf9vfEhz6JruqoVDCz4GKbqvf66X3VVzTiu64beooVDb9SCih3QB+6Aa8gt6H66QIBSk7QXfAO7YAYkfHIyQDvIBh9TPSS2gG60331sqyDHIneE81LfMwKUtwusgSZwaZHvqiUwlfaDTpY2gislJg+0gFywDqZBUn8bZuUd4DLFwSePmCpw7j5vP8EHETMsS20iHfSREjvgGjSDL2CWc9qCiEk6JKQRTdxnjvkh+vK5b0QnDqeZ00HQAeI8p9ea2AvwD0Q5j1qMP//YzLEj7m4lzZNKJjh+g5+S5vsKFJiW2hHrbdtQGuI4kt9x7i5oUGK0Yim9BwnQarnB0MuXy9dSx8Z04u88sAyKwFFAuRfZYA/ceIkPwYFYMlFw/AryTPCbH6rHS5zgANn3UjlJ51g6JadABm1yKcqU5FhAeUSRhuW4DCzlJfBXIz+xkEd0T6pbTvWvICfpPEsnNW+45wbyVcjLLeUkXfCTptur64S8Qhkr1MildCKd1O+Q8JOfCjlJF02lJsdiLcvPfORbLB03kZqIVXmlMlYCkiwdM5WaiokaIa/iviywFERqIyaqWU4n0C/eYqmN2kptxUQx/6z9D/b5YHGC7OHOu/vv9CDAAPwCD1N2x51IAAAAAElFTkSuQmCC"

/***/ }),

/***/ "LELj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LKnw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LNs8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"90px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"客户名称","prop":"customer"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择客户名称..."},model:{value:(_vm.formData.customer),callback:function ($$v) {_vm.$set(_vm.formData, "customer", $$v)},expression:"formData.customer"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.allCustomers),function(item){return _c('el-option',{key:item,attrs:{"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"公司名称","prop":"company"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择公司名称..."},model:{value:(_vm.formData.company),callback:function ($$v) {_vm.$set(_vm.formData, "company", $$v)},expression:"formData.company"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.allCompany),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台","prop":"serviceSupplier"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择签约平台..."},model:{value:(_vm.formData.serviceSupplier),callback:function ($$v) {_vm.$set(_vm.formData, "serviceSupplier", $$v)},expression:"formData.serviceSupplier"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.serviceSuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"服务商","prop":"serviceId"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择服务商..."},model:{value:(_vm.formData.serviceId),callback:function ($$v) {_vm.$set(_vm.formData, "serviceId", $$v)},expression:"formData.serviceId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.allService),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"落地方","prop":"supplierId"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择落地方..."},model:{value:(_vm.formData.supplierId),callback:function ($$v) {_vm.$set(_vm.formData, "supplierId", $$v)},expression:"formData.supplierId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.allSupplier),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.resetForm}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.submitForm}},[_vm._v("筛选")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customerName","label":"客户名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"companyName","label":"公司名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"companyCode","label":"公司编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceNm","label":"服务商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceSupplier","label":"签约平台","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierName","label":"落地方","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"suffix","label":"当前期任务批次","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contractName","label":"当前期合同任务名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nextSuffix","label":"下一期任务批次","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nextContractName","label":"下一期合同任务名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateTime","label":"更新时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operatorAccount","label":"操作者账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operatorName","label":"操作者姓名","align":"center"}}),_vm._v(" "),(_vm.editAuth)?_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.openEditDialog(scope.row.id, scope.row.customerName, scope.row.suffix, scope.row.nextSuffix)}}},[_vm._v("修改")])]}}],null,false,151688960)}):_vm._e()],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":'修改任务批次：' + _vm.editCustomer,"visible":_vm.showEditDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.showEditDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('div',[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_vm._v("当前期任务批次：")]),_vm._v(" "),_c('div',[_c('el-input',{model:{value:(_vm.editSuffix),callback:function ($$v) {_vm.editSuffix=$$v},expression:"editSuffix"}})],1)]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px","margin-top":"20px"}},[_vm._v("下一期任务批次：")]),_vm._v(" "),_c('div',[_c('el-input',{model:{value:(_vm.nextEditSuffix),callback:function ($$v) {_vm.nextEditSuffix=$$v},expression:"nextEditSuffix"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.editCustomerConfig}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showEditDialog=false}}},[_vm._v("取消")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LXjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projLabelConfig_vue__ = __webpack_require__("cMrC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056853ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projLabelConfig_vue__ = __webpack_require__("GJaG");
function injectStyle (ssrContext) {
  __webpack_require__("fvXH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-056853ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projLabelConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056853ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projLabelConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LmCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      param: {},
      formData: {
        pageNo: 1,
        pageSize: 10,
        projectCode: null,
        projectName: null,
        mapper: null
      },
      tableData: [],
      total: null,
      listLoading: false,

      id: null,
      projectCode: null,
      projectName: null,
      mapperProjectCode: null,
      showEditDialog: false
    };
  },
  mounted: function mounted() {

    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/project/mapperProjectList',
        params: this.formData
      }).then(function (res) {
        _this.tableData = res.data.items;
        _this.total = res.data.totalItemsCount;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    submitForm: function submitForm() {
      this.formData.pageSize = 10;
      this.formData.pageNo = 1;
      this.getData();
    },
    resetForm: function resetForm() {
      this.formData.projectCode = null;
      this.formData.projectName = null;
      this.formData.mapper = null;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    openEditDialog: function openEditDialog(id, projectCode, projectName, mapperProjectCode) {
      this.showEditDialog = true;
      this.id = id;
      this.projectCode = projectCode;
      this.projectName = projectName;
      this.mapperProjectCode = mapperProjectCode;
    },
    editMapperProject: function editMapperProject() {
      var _this2 = this;

      // if (!this.mapperProjectCode) {  
      // this.showError = true; // 提交前再次检查  
      // utils.myNotify(this, "error", "error", '项目映射编码不能为空！');
      // return;  
      // } 
      this.$http({
        method: 'POST',
        url: '/rest/project/editMapperProject',
        data: {
          id: this.id,
          projectCode: this.projectCode,
          projectName: this.projectName,
          mapperProjectCode: this.mapperProjectCode
        }
      }).then(function (res) {
        _this2.showEditDialog = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this2, "success", res, '操作成功');
        _this2.getData();
      }).catch(function (err) {
        // debugger
        console.log('err.message:' + err.response.data.message);
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this2, "error", "error", err.response.data.message);
      });
    }
  }
});

/***/ }),

/***/ "Lsem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container basecenter"},[_c('div',[_c('filter-tab',{attrs:{"webId":2},on:{"filterParam":_vm.getParam}})],1),_vm._v(" "),_c('el-row',{staticClass:"common-box",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("筛选结果")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.showLogout}},[_vm._v("\n          注销记录\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":"","disabled":_vm.idList.length === 0 || _vm.auths.indexOf(2) < 0},on:{"click":_vm.batchIdcard}},[_vm._v("注册解绑\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":"","disabled":_vm.idList.length === 0 || _vm.auths.indexOf(2) < 0},on:{"click":_vm.batchMarkAgreement}},[_vm._v("更改合约状态\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":"","disabled":_vm.idList.length === 0 || _vm.auths.indexOf(2) < 0},on:{"click":function($event){_vm.blacklistDialog = true}}},[_vm._v("拉黑\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":"","disabled":_vm.idList.length === 0 || _vm.auths.indexOf(2) < 0},on:{"click":function($event){_vm.greylistDialog = true}}},[_vm._v("加入灰名单\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":"","disabled":_vm.auths.indexOf(2) < 0},on:{"click":_vm.getOperationData}},[_vm._v("操作记录\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","tooltip-effect":"dark","header-row-class-name":"table-header"},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"50","align":"center","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idcard","label":"身份证","width":"160","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","label":"促销员ID","align":"center","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel","label":"手机","width":"160","align":"center","formatter":_vm.formatTel}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"portName","label":"注册来源","align":"center","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"signContract","label":"是否签约","width":"160","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.signContract == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.openContractDialog(scope.row.idcard, scope.row.name)}}},[_vm._v("是")]):_c('span',[_vm._v("否")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bank","label":"开户行","width":"200","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bankNum","label":"银行卡号","width":"200","align":"center","formatter":_vm.formatBankCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unionpayNum","label":"联行号","width":"110","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"agreement","label":"是否有合约","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.agreement == 1)?_c('span',[_vm._v("是")]):_vm._e(),_vm._v(" "),(scope.row.agreement == 2)?_c('span',[_vm._v("否")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"emergencyContact","label":"紧急联系人","width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"emergencyTel","label":"紧急联系人手机号","width":"160","align":"center","formatter":_vm.formatTel1}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"recommenderName","label":"推荐人姓名","width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"recommenderTel","label":"推荐人电话号码","width":"160","align":"center","formatter":_vm.formatTel1}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"身份证照片","width":"150","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"display":"flex","justify-content":"space-around"},on:{"click":function($event){return _vm.showIdCardDialog(scope.row)}}},[_c('div',{staticClass:"tableImg",style:(_vm.noCompression(scope.row.idcardCover,1))},[_c('img',{staticClass:"table-card-img",attrs:{"src":scope.row.idcardCover || '',"alt":""},on:{"error":_vm.idcardCoverImgTableError}})]),_vm._v(" "),_c('div',{staticClass:"tableImg",style:(_vm.noCompression(scope.row.idcardBack,2))},[_c('img',{staticClass:"table-card-img",attrs:{"src":scope.row.idcardBack || '',"alt":""},on:{"error":_vm.idcardBackTableError}})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"银行卡照片","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{on:{"click":function($event){return _vm.showBankCardDialog(scope.row)}}},[_c('img',{staticClass:"table-card-img",attrs:{"src":scope.row.bankCover || '',"alt":""},on:{"error":_vm.bankCoverError}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"autheentication","label":"认证状态","width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bankCardAuthentication","label":"银行卡 认证状态","width":"70","align":"center","label-class-name":"doubleRow"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.bankCardAuthentication == 0)?_c('span',[_vm._v("通过")]):(scope.row.bankCardAuthentication == 1)?_c('span',[_vm._v("人工认证")]):_c('span',[_vm._v("未通过")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"authorizeFlag","label":"个人信息授权","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.authorizeFlag == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.showAuthorize(scope.row.id  , scope.row.name)}}},[_vm._v("已授权")]):_c('span',[_vm._v("未授权")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qhrStatusName","label":"是否qhr人员","width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","fixed":"right","align":"center","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"mini","disabled":_vm.auths.indexOf(1) < 0},on:{"click":function($event){return _vm.viewInfo(scope.row.id)}}},[_vm._v("\n                查看详情\n              ")]),_vm._v("\n              |\n              "),_c('el-button',{staticStyle:{"margin-left":"2px"},attrs:{"type":"text","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.approveByAdmin(scope.row)}}},[_vm._v("\n                人工实名认证\n              ")]),_vm._v("\n              |\n              "),_c('el-button',{staticStyle:{"margin-left":"2px"},attrs:{"type":"text","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.bankCardArtificial(scope.row.id)}}},[_vm._v("\n                人工银行卡认证\n              ")]),_vm._v("\n              |\n              "),_c('el-button',{staticStyle:{"margin-left":"2px"},attrs:{"type":"text","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.approveReset(scope.row.id)}}},[_vm._v("\n                认证重置\n              ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.approveData.lockApproveDialog),expression:"approveData.lockApproveDialog"}],staticClass:"approveDialog",attrs:{"title":"注册解绑","visible":_vm.unbindDialog,"width":"500px","center":""},on:{"update:visible":function($event){_vm.unbindDialog=$event}}},[_c('div',{staticClass:"dialog-body",staticStyle:{"height":"250px"}},[_c('el-form',{ref:"approveForm",staticClass:"formInline",attrs:{"model":_vm.approveData,"inline":true,"label-width":"120px","size":"mini","rules":_vm.rules}},[_c('el-row',{staticStyle:{"height":"250px","background-color":"#fff"}},[_c('el-form-item',{staticStyle:{"margin-top":"10px"},attrs:{"prop":"applicant"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请人： ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"","maxlength":20},model:{value:(_vm.approveData.applicant),callback:function ($$v) {_vm.$set(_vm.approveData, "applicant", $$v)},expression:"approveData.applicant"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"applyReason"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请原因： ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"300px","height":"26px"},attrs:{"type":"textarea","rows":2,"placeholder":"","maxlength":200},model:{value:(_vm.approveData.applyReason),callback:function ($$v) {_vm.$set(_vm.approveData, "applyReason", $$v)},expression:"approveData.applyReason"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"40px"},attrs:{"prop":"projectCode"}},[_c('label',{staticClass:"mylabel"},[_vm._v("所属项目： ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"300px"},attrs:{"filterable":"","clearable":"","placeholder":"（项目编号）项目名称"},model:{value:(_vm.approveData.projectCode),callback:function ($$v) {_vm.$set(_vm.approveData, "projectCode", $$v)},expression:"approveData.projectCode"}},_vm._l((_vm.projectDropDownList),function(item){return _c('el-option',{key:item.valueOrgcode,staticStyle:{"width":"600px"},attrs:{"value":item.valueOrgcode,"label":item.label}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"orgName"}},[_c('label',{staticClass:"mylabel"},[_vm._v("所属部门： ")]),_vm._v("\n              "+_vm._s(_vm.getOptcode("idcard"))+"\n            ")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small","disabled":_vm.approveData.lockConfirm},on:{"click":_vm.unbindIdCardConfirm}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.approveData.lockApproveDialog),expression:"approveData.lockApproveDialog"}],staticClass:"approveDialog",attrs:{"title":"认证重置","visible":_vm.resetDialog,"width":"500px","center":""},on:{"update:visible":function($event){_vm.resetDialog=$event}}},[_c('div',{staticClass:"dialog-body",staticStyle:{"height":"250px"}},[_c('el-form',{ref:"approveForm",staticClass:"formInline",attrs:{"model":_vm.approveData,"inline":true,"label-width":"120px","size":"mini","rules":_vm.rules}},[_c('el-row',{staticStyle:{"height":"250px","background-color":"#fff"}},[_c('el-form-item',{staticStyle:{"margin-top":"10px"},attrs:{"prop":"applicant"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请人： ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"","maxlength":20},model:{value:(_vm.approveData.applicant),callback:function ($$v) {_vm.$set(_vm.approveData, "applicant", $$v)},expression:"approveData.applicant"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"applyReason"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请原因： ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"300px","height":"26px"},attrs:{"type":"textarea","rows":2,"placeholder":"","maxlength":200},model:{value:(_vm.approveData.applyReason),callback:function ($$v) {_vm.$set(_vm.approveData, "applyReason", $$v)},expression:"approveData.applyReason"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"40px"},attrs:{"prop":"projectCode"}},[_c('label',{staticClass:"mylabel"},[_vm._v("所属项目： ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"300px"},attrs:{"clearable":"","placeholder":"（项目编号）项目名称","filterable":""},model:{value:(_vm.approveData.projectCode),callback:function ($$v) {_vm.$set(_vm.approveData, "projectCode", $$v)},expression:"approveData.projectCode"}},_vm._l((_vm.projectDropDownList),function(item){return _c('el-option',{key:item.valueOrgcode,staticStyle:{"width":"600px"},attrs:{"value":item.valueOrgcode,"label":item.label}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"orgName"}},[_c('label',{staticClass:"mylabel"},[_vm._v("所属部门： ")]),_vm._v("\n              "+_vm._s(_vm.getOptcode("idcard"))+"\n            ")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small","disabled":_vm.approveData.lockConfirm},on:{"click":function($event){return _vm.resetConfirm()}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"拉黑原因","visible":_vm.blacklistDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.blacklistDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('el-input',{staticClass:"reason",attrs:{"type":"textarea","rows":6,"placeholder":"请输入拉黑原因"},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.blacklistDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.batchBlack}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"加入灰名单原因","visible":_vm.greylistDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.greylistDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('el-input',{staticClass:"reason",attrs:{"type":"textarea","rows":6,"placeholder":"请输入拉灰原因"},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.greylistDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.batchGrey}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"cardDialog dialog",attrs:{"title":"身份证信息","visible":_vm.idCardDialog,"width":"780px","center":""},on:{"update:visible":function($event){_vm.idCardDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticClass:"card-img clearfix"},[_c('p',[_vm._v("身份证号："+_vm._s(_vm.idcardNum))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"dialogImg",style:(_vm.noCompression(_vm.idcardCoverImg,1)),on:{"click":function($event){return _vm.viewImage(_vm.idcardCoverImg,1)}}},[_c('img',{staticClass:"floatle",attrs:{"src":_vm.idcardCoverImg || '',"alt":"身份证正面照片"},on:{"error":_vm.idcardCoverError}})]),_vm._v(" "),_c('div',{staticClass:"dialogImg",style:(_vm.noCompression(_vm.idcardBackImg,2)),on:{"click":function($event){return _vm.viewImage(_vm.idcardBackImg,2)}}},[_c('img',{staticClass:"floatri",attrs:{"src":_vm.idcardBackImg || '',"alt":"身份证背面照片"},on:{"error":_vm.idcardBackError}})])])])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.idCardDialog = false}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"cardDialog dialog",attrs:{"title":"银行卡信息","visible":_vm.bankCardDialog,"width":"400px","center":""},on:{"update:visible":function($event){_vm.bankCardDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticClass:"card-img"},[_c('p',[_vm._v("开户行："+_vm._s(_vm.bank))]),_vm._v(" "),_c('p',[_vm._v("银行卡号："+_vm._s(_vm.bankNum))]),_vm._v(" "),_c('div',{staticClass:"bankImg",style:(_vm.noCompression(_vm.bankCoverImg,3)),on:{"click":function($event){return _vm.viewImage(_vm.bankCoverImg,3)}}},[_c('img',{staticClass:"bankCardss",attrs:{"src":_vm.bankCoverImg || '',"alt":"银行卡照片"},on:{"error":_vm.bankCoverError2}})])])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.bankCardDialog = false}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"cardDialog dialog",attrs:{"title":"人员信息","visible":_vm.personInfoDialog,"width":"1030px","center":"","modal":false},on:{"update:visible":function($event){_vm.personInfoDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[(_vm.personInfoDialog)?_c('salesperson-info',{attrs:{"id":_vm.SalespersonId,"auths":_vm.auths}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.personInfoDialog = false}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.approveData.lockApproveDialog),expression:"approveData.lockApproveDialog"}],staticClass:"approveDialog",attrs:{"title":"人工认证","visible":_vm.approveDialog,"width":"1000px","center":""},on:{"update:visible":function($event){_vm.approveDialog=$event}}},[_c('div',{staticClass:"dialog-body",staticStyle:{"height":"400px","overflow-y":"scroll"}},[_c('el-form',{ref:"approveForm",staticClass:"formInline",attrs:{"model":_vm.approveData,"inline":true,"label-width":"120px","size":"mini","rules":_vm.rules}},[_c('el-row',{staticStyle:{"height":"250px"}},[_c('el-form-item',{attrs:{"prop":"newIdcard"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("身份证号： ")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18,"disabled":_vm.approveData.lockIdCard},model:{value:(_vm.approveData.newIdcard),callback:function ($$v) {_vm.$set(_vm.approveData, "newIdcard", $$v)},expression:"approveData.newIdcard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"newName"}},[_c('label',{staticClass:"mylabel",staticStyle:{"width":"266px"}},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("姓名： ")]),_vm._v(" "),_c('el-input',{staticStyle:{"margin-left":"2px"},attrs:{"placeholder":"请输入姓名..."},model:{value:(_vm.approveData.newName),callback:function ($$v) {_vm.$set(_vm.approveData, "newName", $$v)},expression:"approveData.newName"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"applicant"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请人： ")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"","maxlength":20},model:{value:(_vm.approveData.applicant),callback:function ($$v) {_vm.$set(_vm.approveData, "applicant", $$v)},expression:"approveData.applicant"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"projectCode"}},[_c('label',{staticClass:"mylabel",staticStyle:{"width":"266px"}},[_vm._v("所属项目： ")]),_vm._v(" "),_c('el-select',{staticStyle:{"margin-left":"2px"},attrs:{"filterable":"","clearable":"","placeholder":"（项目编号）项目名称"},model:{value:(_vm.approveData.projectCode),callback:function ($$v) {_vm.$set(_vm.approveData, "projectCode", $$v)},expression:"approveData.projectCode"}},_vm._l((_vm.projectDropDownList),function(item){return _c('el-option',{key:item.valueOrgcode,staticStyle:{"width":"600px"},attrs:{"value":item.valueOrgcode,"label":item.label}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"applyReason"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请原因： ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"330px","height":"103px"},attrs:{"type":"textarea","rows":7,"maxlength":200,"placeholder":""},model:{value:(_vm.approveData.applyReason),callback:function ($$v) {_vm.$set(_vm.approveData, "applyReason", $$v)},expression:"approveData.applyReason"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"},attrs:{"prop":"orgName"}},[_c('label',{staticClass:"mylabel",staticStyle:{"width":"117px"}},[_vm._v("所属部门： ")]),_vm._v("\n              "+_vm._s(_vm.getOptcode("idcard"))+"\n            ")])],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"50px"}},[_c('el-form-item',[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("身份证有效期： ")]),_vm._v(" "),_c('el-date-picker',{attrs:{"placeholder":"请选择身份有效期开始时间...","value-format":"yyyy-MM-dd"},model:{value:(_vm.approveData.idcardValidStart),callback:function ($$v) {_vm.$set(_vm.approveData, "idcardValidStart", $$v)},expression:"approveData.idcardValidStart"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-date-picker',{attrs:{"placeholder":"请选择身份有效期结束时间...","value-format":"yyyy-MM-dd"},model:{value:(_vm.approveData.idcardValidEnd),callback:function ($$v) {_vm.$set(_vm.approveData, "idcardValidEnd", $$v)},expression:"approveData.idcardValidEnd"}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"idcardImg"},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"idCardCover"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("身份证正面： ")]),_vm._v(" "),_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"/rest/Register/uploadHeadImg","show-file-list":false,"on-success":_vm.idcardCoverUpSucc,"on-error":_vm.imgUploadErr,"data":_vm.approveData.idCardCoverUpName,"before-upload":_vm.beforeImgUp},nativeOn:{"mousedown":function($event){_vm.isUploading = 'idCardCover'}}},[(_vm.approveData.idCardCoverImg)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.approveData.idCardCoverImg}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"idCardBack"}},[_c('label',{staticClass:"mylabel"},[_vm._v("示例： ")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.idCardCover_demo,"height":"200"}})])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"idcardImg"},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"idCardBack"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("身份证反面： ")]),_vm._v(" "),_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"/rest/Register/uploadHeadImg","show-file-list":false,"on-success":_vm.idCardBackUpSucc,"on-error":_vm.imgUploadErr,"data":_vm.approveData.idCardBackUpName,"before-upload":_vm.beforeImgUp},nativeOn:{"mousedown":function($event){_vm.isUploading = 'idCardBack';}}},[(_vm.approveData.idCardBackImg)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.approveData.idCardBackImg}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"idCardBack"}},[_c('label',{staticClass:"mylabel"},[_vm._v("示例： ")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.idCardBack_demo,"height":"200"}})])],1)],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.approveDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","disabled":_vm.approveData.lockConfirm},on:{"click":_vm.approveConfirm}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('div',{staticClass:"viewImage"},[_c('el-dialog',{staticClass:"dialog",attrs:{"title":"查看大图","visible":_vm.showbigImage,"width":_vm.bigImageWidth2},on:{"update:visible":function($event){_vm.showbigImage=$event}},model:{value:(_vm.bigImage),callback:function ($$v) {_vm.bigImage=$$v},expression:"bigImage"}},[_c('div',{staticClass:"dialogImage",style:(_vm.avatarBigImg(_vm.bigImage))},[_c('img',{attrs:{"src":_vm.bigImage || '',"alt":""},on:{"error":_vm.setErrorImage}})]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showbigImage = false}}},[_vm._v("确 定")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.rotate}},[_c('img',{staticStyle:{"margin":"-7px 5px -5px -5px"},attrs:{"src":__webpack_require__("dmCX"),"alt":""}}),_vm._v("\n            旋转\n          ")])],1)])],1),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.operationLoading),expression:"operationLoading"}],staticClass:"blacklistDialog dialog",attrs:{"title":"操作记录查询","visible":_vm.operationLogDialog,"width":"70%","center":""},on:{"update:visible":function($event){_vm.operationLogDialog=$event}}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.operationLogFormData,"inline":true,"label-width":"150px","size":"mini"}},[_c('div',{staticClass:"slide-wrap",staticStyle:{"height":"auto"}},[_c('el-form-item',{attrs:{"label":"促销员姓名："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员姓名...","maxlength":30},model:{value:(_vm.operationLogFormData.salesmanName),callback:function ($$v) {_vm.$set(_vm.operationLogFormData, "salesmanName", $$v)},expression:"operationLogFormData.salesmanName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员身份证号码："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员身份证号码...","maxlength":30},model:{value:(_vm.operationLogFormData.idcard),callback:function ($$v) {_vm.$set(_vm.operationLogFormData, "idcard", $$v)},expression:"operationLogFormData.idcard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID...","maxlength":30},model:{value:(_vm.operationLogFormData.empPk),callback:function ($$v) {_vm.$set(_vm.operationLogFormData, "empPk", $$v)},expression:"operationLogFormData.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员手机号："}},[_c('el-input',{attrs:{"placeholder":"请输入促销员手机号...","maxlength":30},model:{value:(_vm.operationLogFormData.tel),callback:function ($$v) {_vm.$set(_vm.operationLogFormData, "tel", $$v)},expression:"operationLogFormData.tel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"操作类型："}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择操作类型..."},model:{value:(_vm.operationLogFormData.operationType),callback:function ($$v) {_vm.$set(_vm.operationLogFormData, "operationType", $$v)},expression:"operationLogFormData.operationType"}},[_c('el-option',{attrs:{"label":"请选择","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":"认证重置","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"人工认证","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"注册解绑","value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"银行卡认证","value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"注销","value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"撤回注销","value":"6"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"操作人："}},[_c('el-input',{attrs:{"placeholder":"请输入操作人...","maxlength":30},model:{value:(_vm.operationLogFormData.userName),callback:function ($$v) {_vm.$set(_vm.operationLogFormData, "userName", $$v)},expression:"operationLogFormData.userName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"操作人账号："}},[_c('el-input',{attrs:{"placeholder":"请输入操作人账号...","maxlength":30},model:{value:(_vm.operationLogFormData.userAccount),callback:function ($$v) {_vm.$set(_vm.operationLogFormData, "userAccount", $$v)},expression:"operationLogFormData.userAccount"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"float":"right","margin-right":"50px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.searchOperationData()}}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":function($event){return _vm.exportOperationData()}}},[_vm._v("导出")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.operationLogTableData}},[_c('el-table-column',{attrs:{"width":"100","type":"index","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"salesmanName","label":"促销员姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"empPk","label":"促销员ID","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(emp){return [(emp.row.empPk!='null')?_c('div',[_vm._v(_vm._s(emp.row.empPk))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"wxName","label":"微信昵称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"idcard","label":"促销员身份证号码","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(id){return [(id.row.idcard!='null')?_c('div',[_vm._v(_vm._s(id.row.idcard))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"tel","label":"促销员手机号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"operationType","label":"操作类型","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.operationType == 1)?_c('div',[_vm._v("认证重置")]):_vm._e(),_vm._v(" "),(scope.row.operationType == 2)?_c('div',[_vm._v("人工认证")]):_vm._e(),_vm._v(" "),(scope.row.operationType == 3)?_c('div',[_vm._v("注册解绑")]):_vm._e(),_vm._v(" "),(scope.row.operationType == 4)?_c('div',[_vm._v("银行卡认证")]):_vm._e(),_vm._v(" "),(scope.row.operationType == 5)?_c('div',[_vm._v("注销")]):_vm._e(),_vm._v(" "),(scope.row.operationType == 6)?_c('div',[_vm._v("撤回注销")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"applicant","label":"申请人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"300","prop":"applyReason","label":"申请原因","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"projectName","label":"所属项目","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"orgName","label":"所属部门","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"userName","label":"操作人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"userAccount","label":"操作人账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"operationTime","label":"操作时间","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.operationLogFormData.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.operationLogFormData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.operationTotal},on:{"size-change":_vm.operationHandleSizeChange,"current-change":_vm.operationHandleCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"approveDialog",attrs:{"title":"银行卡认证","visible":_vm.bankCardDialogFlag,"width":"1000px","center":true},on:{"update:visible":function($event){_vm.bankCardDialogFlag=$event}}},[_c('div',{staticClass:"dialog-body",staticStyle:{"height":"400px","overflow-y":"scroll"}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"120px","size":"mini","model":_vm.bankCardArtificialData,"rules":_vm.rules}},[_c('el-row',{staticStyle:{"height":"45px"}},[_c('el-form-item',[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("银行卡号码： ")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入银行卡号码..."},on:{"blur":function($event){return _vm.getBank()},"change":function($event){return _vm.resetBankInfo()}},model:{value:(_vm.bankCardArtificialData.bankNum),callback:function ($$v) {_vm.$set(_vm.bankCardArtificialData, "bankNum", $$v)},expression:"bankCardArtificialData.bankNum"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"45px"}},[_c('el-form-item',[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("开户行： ")]),_vm._v(_vm._s(_vm.bankCardArtificialData.bank)+"\n            ")])],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"190px"}},[_c('el-form-item',{attrs:{"prop":"applicant"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请人： ")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"","maxlength":20},model:{value:(_vm.bankCardArtificialData.applicant),callback:function ($$v) {_vm.$set(_vm.bankCardArtificialData, "applicant", $$v)},expression:"bankCardArtificialData.applicant"}})],1),_vm._v(" "),_c('el-form-item',[_c('label',{staticClass:"mylabel",staticStyle:{"width":"266px"}},[_vm._v("所属项目： ")]),_vm._v(" "),_c('el-select',{staticStyle:{"margin-left":"2px"},attrs:{"filterable":"","clearable":"","placeholder":"（项目编号）项目名称"},model:{value:(_vm.bankCardArtificialData.projectCode),callback:function ($$v) {_vm.$set(_vm.bankCardArtificialData, "projectCode", $$v)},expression:"bankCardArtificialData.projectCode"}},_vm._l((_vm.projectDropDownList),function(item){return _c('el-option',{key:item.valueOrgcode,staticStyle:{"width":"600px"},attrs:{"value":item.valueOrgcode,"label":item.label}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"}},[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("申请原因： ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"330px","height":"103px"},attrs:{"type":"textarea","rows":6,"maxlength":200,"placeholder":""},model:{value:(_vm.bankCardArtificialData.applyReason),callback:function ($$v) {_vm.$set(_vm.bankCardArtificialData, "applyReason", $$v)},expression:"bankCardArtificialData.applyReason"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"}},[_c('label',{staticClass:"mylabel",staticStyle:{"width":"117px"}},[_vm._v("所属部门： ")]),_vm._v("\n              "+_vm._s(_vm.getOptcode("bank"))+"\n            ")])],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"50px"}},[_c('el-form-item',[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("姓名： ")]),_vm._v(_vm._s(_vm.bankCardArtificialData.salesmanName)+"\n            ")])],1),_vm._v(" "),_c('el-row',{staticClass:"idcardImg"},[_c('el-form-item',[_c('label',{staticClass:"mylabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("银行卡照片： ")]),_vm._v(" "),_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"/rest/Register/uploadHeadImg","show-file-list":false,"on-success":_vm.bankImageOnSuccess,"on-error":_vm.bankImageOnFailure,"data":_vm.bankCardArtificialData.bankCoverName,"before-upload":_vm.verifyBankImage}},[(_vm.bankCardArtificialData.bankCover && _vm.bankCardArtificialData.bankCover != '')?_c('img',{staticClass:"avatar",attrs:{"src":'https://resource.plscn.com/fileupload/' + _vm.bankCardArtificialData.bankCover}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.bankCardArtificialCancel}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.bankCardArtificialConfirm}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.contractLoading),expression:"contractLoading"}],staticClass:"blacklistDialog dialog",attrs:{"title":_vm.contractDialogTitle,"visible":_vm.showContractDialog,"width":"75%","center":""},on:{"update:visible":function($event){_vm.showContractDialog=$event}}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"150px","size":"mini"}},[_c('div',{staticClass:"slide-wrap",staticStyle:{"height":"auto"}},[_c('el-form-item',{attrs:{"label":"合同开始时间"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.startTimeFrom),callback:function ($$v) {_vm.$set(_vm.contractFormData, "startTimeFrom", $$v)},expression:"contractFormData.startTimeFrom"}}),_vm._v("\n            -\n            "),_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.startTimeTo),callback:function ($$v) {_vm.$set(_vm.contractFormData, "startTimeTo", $$v)},expression:"contractFormData.startTimeTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"合同结束时间："}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.endTimeFrom),callback:function ($$v) {_vm.$set(_vm.contractFormData, "endTimeFrom", $$v)},expression:"contractFormData.endTimeFrom"}}),_vm._v("\n            -\n            "),_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.endTimeTo),callback:function ($$v) {_vm.$set(_vm.contractFormData, "endTimeTo", $$v)},expression:"contractFormData.endTimeTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称："}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.contractFormData.customer),callback:function ($$v) {_vm.$set(_vm.contractFormData, "customer", $$v)},expression:"contractFormData.customer"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.customerList),function(item){return _c('el-option',{key:item,attrs:{"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台："}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择...","clearable":""},model:{value:(_vm.contractFormData.serviceSupplier),callback:function ($$v) {_vm.$set(_vm.contractFormData, "serviceSupplier", $$v)},expression:"contractFormData.serviceSupplier"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"薪太软","value":"薪太软"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"众简","value":"众简"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"float":"right","margin-right":"50px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.searchContractData()}}},[_vm._v("筛选")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.contractData}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"签约客户","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"merchantName","label":"供应商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"signTime","label":"签约时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"合同开始时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":"合同结束时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceSupplier","label":"签约平台","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.contractFormData.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.contractFormData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.contractTotal},on:{"size-change":_vm.handleContractSizeChange,"current-change":_vm.handleContractCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":_vm.authorizeDialogSalesmanName,"visible":_vm.authorizeDialogFlag,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialogFlag=$event}}},[_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.authorizeDialogList}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"authorizeType","label":"授权协议名称","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.authorizeType == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog1 = true}}},[_vm._v("个人信息授权协议")]):(scope.row.authorizeType == 2)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog2 =true}}},[_vm._v("个人信息授权协议2020版")]):(scope.row.authorizeType == 3)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog3 =true}}},[_vm._v("隐私政策2021")]):(scope.row.authorizeType == 4)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog4 =true}}},[_vm._v("隐私政策2021-2")]):(scope.row.authorizeType == 5)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog5 =true}}},[_vm._v("平台用户服务协议")]):(scope.row.authorizeType == 6)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog6 =true}}},[_vm._v("隐私政策2022")]):(scope.row.authorizeType == 7)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog7 =true}}},[_vm._v("个人信息采集授权")]):(scope.row.authorizeType == 8)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog8 =true}}},[_vm._v("人脸识别服务授权")]):(scope.row.authorizeType == 9)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog9 =true}}},[_vm._v("身份信息识别服务授权")]):(scope.row.authorizeType == 10)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog10 =true}}},[_vm._v("银行信息识别服务授权")]):(scope.row.authorizeType == 11)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog11 =true}}},[_vm._v("地理信息采集授权")]):(scope.row.authorizeType == 12)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog12 =true}}},[_vm._v("隐私政策")]):(scope.row.authorizeType == 13)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog13 =true}}},[_vm._v("DP免责规范及自我声明")]):(scope.row.authorizeType == 14)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog14 =true}}},[_vm._v("DP免责规范及自我声明V2")]):(scope.row.authorizeType == 15)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog15 =true}}},[_vm._v("RS免责规范及自我声明")]):(scope.row.authorizeType == 16)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog16 =true}}},[_vm._v("个人视频共享授权")]):(scope.row.authorizeType == 17)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog12 =true}}},[_vm._v("隐私政策（202404）")]):(scope.row.authorizeType == 18)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog18 =true}}},[_vm._v("小程序-隐私政策")]):(scope.row.authorizeType == 19)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog19 =true}}},[_vm._v("小程序-服务协议")]):(scope.row.authorizeType == 20)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog20 =true}}},[_vm._v("小程序-人脸识别服务授权")]):(scope.row.authorizeType == 21)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog21 =true}}},[_vm._v("小程序-身份信息识别服务授权")]):(scope.row.authorizeType == 22)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){_vm.authorizeDialog22 =true}}},[_vm._v("小程序-银行信息识别服务授权")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"authorized","label":"是否授权","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.authorized)?_c('span',[_vm._v("已授权")]):_c('span',[_vm._v("未授权")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"authorizeTime","label":"授权开始时间","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":"1","page-sizes":[10, 20, 50, 100],"page-size":"10","layout":"slot,sizes, total,  prev, pager, next, jumper","total":"2"},on:{"size-change":function($event){},"current-change":function($event){1}}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.authorizeDialogFlag = false}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"个人信息授权协议","visible":_vm.authorizeDialog1,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog1=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("合规采集个人信息相关条款")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n一、信息收集的种类与目的\n本公司需因下列原因向您收集下列信息：\n1、为了对您的身份进行认证、并与eHR系统米咖对接，便于对您的日常工作进行管理，本公司将收集您的姓名、手机号、身份证号、照片、刷脸视频（调用腾讯优图接口）；\n2、为了与您结算并向您支付项目费用，本公司将收集您的银行卡号、银行卡照片。\n\n二、信息的使用\n为了满足公司日常运营的需要，并为了遵守国家法律法规及监管要求，本公司会在以下情形中使用您的信息：\n1、实现上述第一条“信息收集的种类与目的”所述目的；\n2、根据法律法规或监管要求向相关部门进行报告。\n\n三、信息收集及使用的确认\n1、本公司已经向您充分披露了将收集您的信息的事实，并充分披露了向您收集的信息的种类、目的；\n2、您向本公司提供的第一条列示的信息均系自愿提供；\n3、您同意本公司按照第二条约定目的使用您提供的全部信息；\n4、本公司按照第一条收集您的信息、按照第二条使用您的信息不构成对您个人隐私的任何侵犯，您与本公司不会因为对您信息的收集及使用产生任何纠纷。\n          ")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"个人信息授权协议2020版","visible":_vm.authorizeDialog2,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog2=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("合规采集个人信息相关条款")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n一、信息收集的种类与目的\n本平台需因下列原因向您收集下列信息：\n1、\t为了对您的身份进行认证、并与eHR系统米咖对接，便于对您的日常工作进行管理，本公司将收集您的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等；\n2、\t为了与您结算并向您支付项目服务费，本公司将收集您的银行卡号、银行卡照片。\n\n二、信息的使用\n为了满足平台日常运营的需要，并为了遵守国家法律法规及监管要求，本平台会在以下情形中使用您的信息：\n1、实现上述第一条“信息收集的种类与目的”所述目的；\n2、根据法律法规或监管要求向相关部门进行报告；\n3、征得您同意的其他用途。\n\n三、信息收集及使用的确认\n1、\t本平台已经向您充分披露了将收集您的信息的事实，并充分披露了向您收集的信息的种类、目的；\n2、\t您向本平台提供的第一条列示的信息均系自愿提供，并确保您所提供的信息的真实、完整、准确和及时；\n3、\t您同意本平台按照第二条约定目的使用您提供的全部信息；\n4、\t本平台按照第一条收集您的信息、按照第二条使用您的信息不构成对您个人隐私的任何侵犯，您与本公司不会因为对您信息的收集及使用产生任何纠纷。\n5、\t本人同意平台将本人信息，包含但不限于本人的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等。披露给合作中的促销活动品牌方。\n          ")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"隐私政策2021","visible":_vm.authorizeDialog3,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog3=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("隐私政策2021")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n米咖非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。本政策适用于米咖平台所提供的服务，请您在使用本平台服务前，仔细阅读并了解本《隐私政策》。 当您按照米咖平台注册页面提示阅读并同意本政策且完成全部注册程序后，即表示您已充分阅读、理解并接受本政策的全部内容。\n\n我们承诺，米咖仅会出于本政策所述的以下目的，收集和使用您的个人信息。\n\n一、我们如何收集和使用您的个人信息\n\n个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。\n\n为更好地为您提供服务，米咖将遵循“合法、正当、必要”原则，按照法律法规的规定和您的同意收集您的个人信息，主要包括：\n\n1、您提供的信息\n\n当在你使用本平台服务的过程中，本平台会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的账号安全：\n\n用户个人基本信息：姓名（名称）、性别、年龄、常用地址、地理位置、电话号码、电子邮箱地址、身份证件号码、证件照片、用户人像、指纹识别；\n\n用户权限信息：通讯录权限、相册权限、相机权限、存储权限、读取权限、蓝牙权限、音频权限、定位权限、拨打电话权限、获取应用列表权限、语音识别权限、短信验证码； \n\n用户终端信息：设备MAC地址、唯一设备识别码、SIM卡IMSI信息、IMEI、终端版本型号、网络IP、本机号码、网络类型、手机品牌；\n\n电子商务信息：家庭住址、身份证、面部特征、开户行名称、银行卡卡号、银行卡有效期限、银行预留手机号码。\n\n您提供的上述信息，将在您使用本平台服务期间持续授权我们使用。\n\n2、您在使用服务过程中产生的信息 \n\n您使用我们提供的服务时，我们可能自动收集以下信息： \n\n（1）日志信息 \n指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括： \n\nA. 设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码； \n\nB. 您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息； \n\n（2）位置信息 \n\n指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过 GPS 或 WiFi等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。\n\n（3）手机账户信息 \n\n指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号相关信息。  \n\n3、业务功能需要获取的相关权限信息 \n\n当在你使用米咖平台服务的过程中，米咖平台需要获取您的手机相关权限，用以向你提供服务、优化我们的服务以及保障你的账号安全：\n\n（1）语音搜索：需要音频权限、语音识别权限； \n\n（2）投诉处理图片上传、保存邮件中的图片到本地相册、发送邮件时选择相册中的图片作为附件、保存米咖平台中的图片至本地相册：需要相册、相机权限； \n\n（3）实名制功能：相册、相机权限； \n\n（4）图片缓存加速、日志或附件存储到本地：本地存储权限； \n\n（5）分享功能：需要发送短信权限； \n\n（6）一键登录、活跃数据统计、云闪付：读取电话状态（IMSI/IMEI号）权限；\n\n（7）在线客服语音输入：音频权限； \n\n（8）在线客服拍照反馈：相机、相机权限； \n\n（9）在线客服转人工：拨打电话权限； \n\n（10）在线客服照片反馈：相册、相机权限\n\n4、第三方收集和使用信息\n\n（1）第三方服务收集信息的情形 \n\n在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务 。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。\n\n（2）从第三方获得您的个人信息 \n\n为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。\n\n二、我们可能将收集到的您的个人信息用于以下目的：\n\n1、为您提供服务 \n\n（1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性； \n\n（2）通过信息数据分析，帮助我们设计新服务，改善我们现有服务； \n\n（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应； \n\n（4）提供您关注或者与您相关的广告以替代普遍投放的广告，您在使用我们的服务时，我们可能使用您的信息向您发送电子邮件、短信或推送通知，如您不希望收到这些信息，可以按照我们的相关提示取消订阅； \n\n（5）评估我们服务中的广告和其他促销及推广活动的效果，并加以改善； \n\n（6）软件认证或管理软件升级； \n\n（7）让您参与有关我们产品和服务的调查； \n\n（8）其他您授权同意提供个人信息的情况。\n\n2、我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告。基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容。为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。 \n\n3、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。 \n\n4、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意： \n\n（1）与国家安全、国防安全有关的； \n\n（2）与公共安全、公共卫生、重大公共利益有关的 \n\n（3）与犯罪侦查、起诉、审判和判决执行等有关的； \n\n（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； \n\n（5）所收集的个人信息是个人信息主体自行向社会公众公开的； \n\n（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道； \n\n（7）根据您的要求签订合同所必需的； \n\n（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障； \n\n（9）为合法的新闻报道所必需的； \n\n（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； \n\n（11）法律法规规定的其他情形。\n\n三、个人信息的存储 \n\n（1）信息存储的地点 \n\n我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，不存在境外收集用户信息情况。\n\n（2）信息存储的期限 \n\n我们承诺您个人信息的存储时间始终处于合理必要期限内"),_c('b',[_vm._v("（原则上5年）")]),_vm._v("，我们根据业务需要时长去存储用户信息，超出保存期限的用户信息，米咖平台会做匿名化处理；当我们的产品或服务发生停止服务的情形时，"),_c('b',[_vm._v("我们将以推送通知、公告形式通知您")]),_vm._v("，并在合理的期限内删除您的个人信息或进行匿名化处理。\n \n四、个人信息安全保护措施和能力 \n\n1、我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。"),_c('b',[_vm._v("我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。")]),_vm._v("我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解你设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知你。  \n\n"),_c('b',[_vm._v("2、注销平台服务功能 ")]),_vm._v("\n\n您在本平台登录时的用户名为您的手机号码，本平台只通过关联方式展示该手机号码的信息。\n\n五、我们如何共享、转让、公开披露您的个人信息 \n\n"),_c('b',[_vm._v("（一）共享 ")]),_vm._v("\n\n我们不会与您在米咖平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： \n\n1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 \n\n2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 \n\n3、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 \n我们的关联公司包括"),_c('b',[_vm._v("米咖平台")]),_vm._v("现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。 \n\n4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下三大类型： \n\nA.供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。 \n\nB.第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。 \n\nC.广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。但我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率。 对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。 \n\n（二）转让 \n\n我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： \n\n1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； \n\n2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 \n\n（三）公开披露 \n\n我们仅会在以下情况下，公开披露您的个人信息： \n\n1、获得您明确同意后； \n\n2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。\n\n六、我们如何保护您的个人信息 \n\n（一）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。 \n\n（二）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。  \n\n（三）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。"),_c('b',[_vm._v("本APP在上线前已通过企业级安全加固技术进行加壳，确保程序安全稳定。")]),_vm._v("但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 \n\n七、您的权利 \n\n1、查询和更正您的个人信息 \n\n除法律法规规定外，您有权在登陆本平台后查询"),_c('b',[_vm._v("您的个人信息。")]),_vm._v("\n\n2、在以下情形中，您可以向我们提出删除个人信息的请求： \n\n（1）如果我们处理个人信息的行为违反法律法规； \n\n（2）如果我们收集、使用您的个人信息，却未征得您的同意； \n\n（3）如果我们处理个人信息的行为违反了与您的约定； \n\n（4）如果您不再使用我们的产品或服务，或您注销了账号；\n\n（5）如果我们不再为您提供产品或服务。 \n\n当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。\n\n八、本政策如何更新 \n\n我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会以通告的形式发布对本政策所做的任何变更，在该种情况下，界面上会有弹框进行提示，若您点击同意后，即表示接受修订后的隐私政策约束。 \n\n九、争议解决\n\n因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至【上海市普陀区】人民法院。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。\n          ")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"隐私政策2021-2","visible":_vm.authorizeDialog4,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog4=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("隐私政策2021-2")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n发布时间：2021年1月28日\n更新时间：2021年10月19日\n米咖非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。本政策适用于米咖平台所提供的服务，请您在使用本平台服务前，仔细阅读并了解本《隐私政策》。 当您按照米咖平台注册页面提示阅读并同意本政策且完成全部注册程序后，即表示您已充分阅读、理解并接受本政策的全部内容。\n我们承诺，米咖仅会出于本政策所述的以下目的，收集和使用您的个人信息。\n一、我们如何收集和使用您的个人信息 \n个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 \n为更好地为您提供服务，米咖将遵循“合法、正当、必要”原则，按照法律法规的规定和您的同意收集您的个人信息，主要包括： \n1、您提供的信息 \n当在你使用本平台服务的过程中，本平台会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的账号安全： \n用户个人基本信息：姓名（名称）、性别、年龄、常用地址、地理位置、电话号码、电子邮箱地址、身份证件号码、证件照片、用户人像、指纹识别； \n用户权限信息：通讯录权限、相册权限、相机权限、存储权限、读取权限、蓝牙权限、音频权限、定位权限、拨打电话权限、获取应用列表权限、语音识别权限、短信验证码； \n用户终端信息：设备MAC地址、唯一设备识别码、SIM卡IMSI信息、IMEI、终端版本型号、网络IP、本机号码、网络类型、手机品牌； \n电子商务信息：家庭住址、身份证、面部特征、开户行名称、银行卡卡号、银行卡有效期限、银行预留手机号码。\n您提供的上述信息，将在您使用本平台服务期间持续授权我们使用。 \n2、您在使用服务过程中产生的信息 \n您使用我们提供的服务时，我们可能自动收集以下信息： \n（1）日志信息 \n指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括： \nA. 设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码； \nB. 您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息； \n（2）位置信息 \n指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过 GPS 或 WiFi等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。\n（3）手机账户信息 \n指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号相关信息。  \n3、业务功能需要获取的相关权限信息 \n当在你使用米咖平台服务的过程中，米咖平台需要获取您的手机相关权限，用以向你提供服务、优化我们的服务以及保障你的账号安全：\n（1）语音搜索：需要音频权限、语音识别权限； \n（2）投诉处理图片上传、保存邮件中的图片到本地相册、发送邮件时选择相册中的图片作为附件、保存米咖平台中的图片至本地相册：需要相册、相机权限； \n（3）实名制功能：相册、相机权限； \n（4）图片缓存加速、日志或附件存储到本地：本地存储权限； \n（5）分享功能：需要发送短信权限； \n（6）一键登录、活跃数据统计、云闪付：读取电话状态（IMSI/IMEI号）权限；\n（7）在线客服语音输入：音频权限； \n（8）在线客服拍照反馈：相机、相机权限； \n（9）在线客服转人工：拨打电话权限； \n（10）在线客服照片反馈：相册、相机权限\n\n4、第三方收集和使用信息\n（1）第三方服务收集信息的情形 \n在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务 。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。\n（2）从第三方获得您的个人信息 \n为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。\n\n二、我们可能将收集到的您的个人信息用于以下目的： \n 1、为您提供服务 \n（1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性； \n（2）通过信息数据分析，帮助我们设计新服务，改善我们现有服务； \n（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应； \n（4）提供您关注或者与您相关的广告以替代普遍投放的广告，您在使用我们的服务时，我们可能使用您的信息向您发送电子邮件、短信或推送通知，如您不希望收到这些信息，可以按照我们的相关提示取消订阅； \n（5）评估我们服务中的广告和其他促销及推广活动的效果，并加以改善； \n（6）软件认证或管理软件升级； \n（7）让您参与有关我们产品和服务的调查； \n（8）其他您授权同意提供个人信息的情况。\n 2、我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告。基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容。为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。 \n3、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。 \n4、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意： \n（1）与国家安全、国防安全有关的； \n（2）与公共安全、公共卫生、重大公共利益有关的 \n（3）与犯罪侦查、起诉、审判和判决执行等有关的； \n（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； \n（5）所收集的个人信息是个人信息主体自行向社会公众公开的； \n（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道； \n（7）根据您的要求签订合同所必需的； \n（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障； \n（9）为合法的新闻报道所必需的； \n（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； \n（11）法律法规规定的其他情形。 \n\n三、个人信息的存储 \n（1）信息存储的地点 \n我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，不存在境外收集用户信息情况。 \n（2）信息存储的期限 \n我们承诺您个人信息的存储时间始终处于合理必要期限内（原则上5年），我们根据业务需要时长去存储用户信息，超出保存期限的用户信息，米咖平台会做匿名化处理；当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。 \n四、个人信息安全保护措施和能力 \n1、我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解你设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知你。 您在本平台登录时的用户名为您的手机号码，本平台只通过关联方式展示该手机号码的信息。\n五、我们如何共享、转让、公开披露您的个人信息 \n（一）共享 \n我们不会与您在米咖平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： \n1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 \n2、与我们合作中的促销活动品牌方共享：本人同意平台将本人信息，包含但不限于本人的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等，披露给合作中的促销活动品牌方，并允许品牌方使用。\n3、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 \n4、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 \n我们的关联公司包括米咖平台现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。 \n5、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下三大类型： \nA.供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。 \nB.第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。 \nC.广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。但我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率。 对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。 \n（二）转让 \n我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： \n1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； \n2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 \n（三）公开披露 \n我们仅会在以下情况下，公开披露您的个人信息： \n1、获得您明确同意后； \n2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。 \n六、我们如何保护您的个人信息 \n（一）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。 \n（二）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。  \n（三）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 \n七、您的权利 \n1、查询和更正您的个人信息 \n除法律法规规定外，您有权在登陆本平台后查询您的个人信息。\n2、在以下情形中，您可以向我们提出删除个人信息的请求： \n（1）如果我们处理个人信息的行为违反法律法规； \n（2）如果我们收集、使用您的个人信息，却未征得您的同意； \n（3）如果我们处理个人信息的行为违反了与您的约定； \n（1）如果您不再使用我们的产品或服务，或您注销了账号； \n（2）如果我们不再为您提供产品或服务。 \n当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。\n八、本政策如何更新 \n我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会以通告的形式发布对本政策所做的任何变更，在该种情况下，界面上会有弹框进行提示，若您点击同意后，即表示接受修订后的隐私政策约束。 \n九、争议解决\n因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至【上海市普陀区】人民法院。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。\n          ")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"平台用户服务协议","visible":_vm.authorizeDialog5,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog5=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("平台用户服务协议")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n          版本发布时间：【20220101】； \n版本更新时间：\n      欢迎您使用米咖平台向您提供的各项服务！以下简称“平台” \n      您在使用本平台所提供的服务前，应当仔细认真阅读本《平台用户服务协议》(以下简称“本协议”)中的全部规则、及平台不时发布或更新的其他服务条款、专项产品或服务规则或规范（包括但不限于《平台规则及违约责任条款》，以下合称“服务规则”）的内容（特别是其中以黑体字标示出的关于平台及用户重大权益的规则，该等规则可能涉及相关方的责任免除或限制、法律适用与争议 解决条款，请您重点阅读），确认对本条款、《平台用户服务协议》 及各项服务规则均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。如您使用平台或以其他方式使用或接受平台的任何服务，即视为您已阅读并与平台达成协议，自愿接受本条款的所有内容的约束。所有服务规则视为本条款不可分割的一部分，与本条款具有同等法律效力。\n本条款的签约双方为本平台的实际开发商上海若胜米咖信息技术有限公司及集团公司与使用平台服务的您（下称“您”），本条款是您与本平台之间关于您使用平台入驻服务商之间发布的任务服务所订立的服务条款， 具有正式书面合同的效力。 \n如本条款与《平台用户服务协议》文本内容存在冲突之处，则以时间上最新发布的内容为准，发布时间相同的，以本协议为准。本协议有待明确、存在歧义或未规定之处均以《平台用户服务协议》中的规定为准。 \n您理解并同意，平台将根据本条款及《平台用户服务协议》的规定及商业因素，对本协议条款或各项服务规则不时地进行修改更新。修改更新内容的发布和实施均适用《平台用户服务协议》的相关约定。变更后的协议和规则一经在平台公布后，立即自动生效。如您不同意相关变更，应当立即停止使用平台服务。您继续使用平台服务的，即表示您接受经修订的协议和规则。\n\n      一、定义 \n      1.1 平台任务：即平台，是指平台入驻方（以下简称第三方）提出的任务发布服务，并通过该平台展示出行费用及服务完成确认等信息的互联网技术平台。 \n      1.2 信息服务：平台利用电脑、服务器、互联网、电话、移动设备等信息通讯设备，向您展示订单，促成您与需求方达成服务合作。 \n      1.3 任务订单：登记第三方具体需求信息任务的电子订单。您按照平台的要求提供的抢单、签约、激活订单等信息，全部信息作为一个整体构成一个订单。 \n\n      二、账号注册与使用 \n      2.1 您知悉并同意，您可通过注册新的账号或登录您现有的账号以使用为第三方所提供的服务，并应遵守《平台用户服务协议》中的各项规定。 \n      2.2 您确认，在您完成注册程序或以其他平台允许的方式实际使用平台服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且平台有权注销或永久冻结您的账号，并保留向您及您的监护人索偿的权利。\n      2.3 您承诺向平台所提供的信息真实、准确、完整。平台有权要求您提供各项信息文件，并验证其真实性，当查验您提供的信息可能缺乏真实性、准确性时，平台有权进一步要求您提供其他证明文件或拒绝向您提供服务或拒绝您使用有关网站、服务、应用程序。 \n      2.4 您应是您注册账号的唯一授权使用人，可根据自己的需求使用，但不得以任何形式将账号转让或出借他人使用。未经平台授权同意，您也不得将账号相关的权利义务转让给他人。 \n      2.5 鉴于网络服务的特殊性，除您第三方使用平台服务时外，平台无义务审核是否是用户本人使用该账号，仅审核用户身份识别信息是否与数据库中保存的一致，所以即使用户认为账号登录行为并非用户本人所为，平台将不承担因此而产生的任何责任。\n\n      三、服务规范 \n      3.1 您在使用平台服务时，除了应当遵循诚实信用原则，遵守法律法规、所在服务单位的政策以及规章制度外，还应当遵守本协议、《平台用户服务协议》及服务规则的各项规定。 \n      3.2 平台根据您的服务状态向您提供第三方任务、订单信息等，您可自主选择是否处于服务状态。如您接受订单，您应按照订单需求为第三方提供服务，并遵守本条款约定的平台规则。您可通过下载并安装到移动设备上的平台提供的应用程序或其他方式选择并使用平台信息服务。 \n      3.3 本平台的运营权归普乐师（上海）数字科技有限公司所有。平台向您提供的是信息服务，而非通讯服务，您在使用平台提供的服务时，应具备可以安装平台相关应用程序的终端设备。 \n      3.4 您与平台合作为第三方提供服务的时间为订单成立且您准备提供服务的时间。在非合作期间，平台并不要求您继续为第三方提供服务。如因其他原因需要继续服务，则该服务行为属于您的个人行为与本平台无关。 \n      3.5 您注册和使用本平台过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等您所发送、回复或自动回复消息和相关链接页面，以及其他使用用户账号或本平台产生的内容均不得违反现行法律、法规、规章、政策规定；如果您在境外使用本平台，应同时遵守所在地或相关国家（地区）的法律法规。\n      3.6 您不得利用本平台制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容：\n      3.6.1 反对宪法所确定的基本原则的；\n      3.6.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；\n      3.6.3 损害国家荣誉和利益的；\n      3.6.4 煽动民族仇恨、民族歧视，破坏民族团结的；\n      3.6.5 破坏国家宗教政策，宣扬邪教和封建迷信的；\n      3.6.6 散布谣言，扰乱社会秩序，破坏社会稳定的；\n      3.6.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；\n      3.6.8 侮辱或者诽谤他人，侵害他人合法权益的；\n      3.6.9 含有法律、行政法规禁止的其他内容的信息。\n      3.7 您不得利用本平台制作、上载、复制、发布、传播如下干扰平台正常运营，以及侵犯其他用户或第三方合法权益的内容：\n      3.7.1 含有任何性或性暗示的；\n      3.7.2 含有辱骂、恐吓、威胁内容的；\n      3.7.3 含有骚扰、垃圾广告、恶意信息、诱骗信息的；\n      3.7.4 涉及他人隐私、个人信息或资料的；\n      3.7.5 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；\n      3.7.6 含有其他干扰本平台正常运营和侵犯其他用户或第三方合法权益内容的信息。\n      3.8 您不得利用本平台进行如下行为：\n      3.8.1 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；\n      3.8.2 虚构事实、隐瞒真相以误导、欺骗他人的；\n      3.8.3 利用技术手段批量建立虚假账号的；\n      3.8.4 利用本平台从事任何违法犯罪活动的；\n      3.8.5 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；\n      3.8.6 其他违反法律法规规定、侵犯其他用户合法权益、干扰本平台正常运营或本平台未明示授权的行为。\n      3.9 承诺与保证 \n      3.9.1 除遵守本条款、《平台用户服务协议》及服务规则外，您应进一步保证您符合从事社会服务的相关标准，包括但不限于您满足服务地城市、相关法律法规规定的户籍或居住证等有关要求，无限制从业的相关疾病，并符合以下条件： \n      3.9.1.1 年龄：18-60周岁；普通话标准；无犯罪记录、无吸毒记录、无精神病史，未列入公安部门不良记录。\n      3.9.1.2身体健康，外露皮肤无明显疤痕、纹身，无怪异发型(颜色），无传染性疾病；无下列可能影响服务的疾病：器质性心脏病；癫痫病；美尼尔氏症；眩晕症；癔病；震颤麻痹；精神病；痴呆以及影响肢体活动的神经系统疾病；妨碍安全服务疾病及传染性疾病（如：肺结核、腮腺炎等通过空气、飞沫传播的传染病）;长期服用依赖性精神药品成瘾尚未戒除的。 \n      3.9.2 如您未满足以上标准或要求，平台有权立即终止与您的合作。 \n      3.10 您在浏览、访问或使用平台产品及服务时可能以各种形式获取、知悉与平台或第三方有关的秘密信息（包括但不限于第三方信息、平台及其关联公司的运营或财务信息等）。为更好地保护您、第三方及我们的合法权益，您将严格遵守保密义务，不会在任何时间以任何方式窃取、泄露前述秘密信息。如果您发生本条款禁止行为，我们将会采取相应措施，包括但不限于中止或终止向您提供任何产品或服务、要求您承担损害赔偿责任；如果您的行为构成犯罪，将被追究相应的刑事责任。 \n      3.11 费用支付 \n      3.11.1 平台有权制定相关费用结算标准并不时更新予以公示，具体订单结算适用订单发生时公示的结算标准。 \n      3.11.2 如您使用第三方支付系统从服务单位处收取结算的费用，应由您自行开通第三方支付系统服务（包括但不限于平台支付、微信支付、支付宝等）。您在使用第三方支付时，除了受到本条款的约束之外，还要受电子支付服务商及信用卡/借记卡发卡行的条款和政策的约束。平台不为第三方提供的服务承担责任。 \n      3.11.3 您可以随时通过平台查询订单情况，您应在每次服务完成后及时核对订单信息。\n      3.12 您在平台中或通过平台所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表本平台的观点、立场；您不得以平台的名义传送或发布信息；也不得以易被公众或第三方混淆为平台官方意见的方式传送或发布信息。\n\n      四、风险承担 \n      4.1 您在使用平台的过程中，将会涉及到第三方提供的地图及导航等服务，请您务必在确保安全的前提下使用上述服务，以防发生其他危险情况。\n      4.2 平台向您提供信息技术服务，对于您给第三方提供的服务过程中产生的风险不承担责任，但法律法规另有强制性规定的除外。 \n      4.3 平台与您合作向第三方提供的服务，双方关系受《中华人民共和国民法典》等民事法律的约束。平台与您之间不构成任何直接或间接的劳动关系，不适用 《劳动法》《劳动合同法》《社会保险法》《住房公积金管理条例》等法律法规。 \n\n      五、对您信息的管理及限制 \n      5.1 您知悉、理解并同意，在您使用平台时，您同意平台依据《平台隐私政策》的规定执行相关个人信息的收集、使用和共享。平台亦有权应政府部门（包括司法及行政部门）的要求，向其提供您的相关信息。此外，您知悉并认可：平台可能会与第三方合作而向您提供相关的功能，在此情况下，如该第三方同意承担与平台同等的保护您隐私的责任，则平台有权将您的相关资料等提供给该第三方。另外，在不透露您隐私资料的前提下，平台有权对与您账号相关的整个数据库进行分析并对相关的数据库进行商业上的利用。 \n      5.2 您被平台终止服务或账号被注销后，平台没有义务为您保留或向您披露账号中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。 \n      5.3 您同意，平台停止向您提供服务后，平台仍享有下列权利： \n      5.3.1 继续保存您未及时删除的信息及使用平台期间发布的所有信息至法律规定的记录保存期满。 \n      5.3.2 您在使用期间存在违法行为或违反本条款和/或服务规则的行为的，平台仍可依据本条款向您主张权利。 \n\n      六、知识产权 \n      6.1 平台所展示的各运营系统由本平台自主开发、运营提供技术支持，并对平台服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。平台提供各项服务时所依托软件的著作权、专利权，所使用的各项商标、商业形象、商业标识、技术诀窍，其著作权、商标权及其他各项相关权利均归平台所有。 \n      6.2 您理解并同意：您在使用平台过程中所产生、上传的内容等所有信息的知识产权及所有权，适用《平台用户服务协议》中的相关约定。 \n\n      七、责任限制声明 \n      7.1 您确认，您在使用平台为平台第三方所提供的服务时，应当具备中华人民共和国法律规定的完全民事权利能力和民事行为能力。否则您及您的监护人应依照法律规定承担因此而导致的一切后果，在该等情形下，平台有权立即注销您的账号或停止向您提供服务，您应就由此给平台造成的所有损失予以赔偿。 \n      7.2 您应谨慎合理的保存、使用用户名和密码，并对通过您的账号和密码实施 的所有行为、活动及事件负全责。您若发现任何不当使用账号或存在安全漏洞等其他可能危及您账号安全的情况，应立即依照《平台用户服务协议》的相关规定采取措施并予以处理。\n      7.3 由于您的过错给平台第三方或其他第三方造成侵权损害，应当由您承担相应的赔偿责任，对于由于您的过错造成的侵权损害或您因违约给平台造成的损失，平台有权向您追偿。 \n      7.4 如您在使用平台的过程中发现平台中的相关服务信息违反法律规定，您可及时向平台或有关机关举报或投诉，平台将在收到您的举报或投诉时采取相应的核实与处理措施。 \n      7.5 平台在为您提供服务时，可能会引入平台范围之外的第三方服务商提供的服务（第三方签约服务、支付服务、查询服务等）。您知悉、理解并同意，您使用平台号访问或使用第三方服务商提供的服务时将跳转至第三方服务商的独立平台。第三方服务商并非本平台，亦不通过本平台向您提供任何服务或达成任何交易。因此，本平台无法实质审核、控制第三方服务商及其所提供的具体服务或对第三方服务予以任何形式的担保或承诺。您应在访问或使 用第三方服务商的服务前应自行核实第三方服务商的身份、资质、服务内容等 相关信息，仔细约定第三方服务商的相关服务协议或规则，并自行选择是否进行本条款下的授权操作并使用本平台账号接受相关第三方服务商服务，本平台将不就您所接受的第三方服务商服务向您承担任何责任。您拟接受的第三方服务商服务将由该第三方服务商独立运营并独立承担全部责任。因该第三方服务所产生的纠纷，或第三方服务商违反相关法律法规或本条款约定，或您在使用第三方服务过程中遭受的损失，请您根据与第三方服务商所订立的相关服务协议等相应协议或规则，联系第三方服务商予以解决。 \n      7.6 对于来源于外部的风险，比如违法犯罪活动、交通事故等意外事件等造成的损失，由相关责任方承担，本平台将会积极协助相关部门进行处理。对于您在提供平台服务过程中发生的不可抗力事件，本平台将会在合理范围内进行协助解决。 \n      7.7 您同意并确认，本平台拥有独自决定拒绝向您提供服务的权利。 \n      7.8 您同意本平台拥有通过消息推送、平台公示、短信、电话、邮件等形式向您通知告知信息的权利。此外，您允许本平台依照《平台用户服务协议》及《平台隐私政策》的相关规定向您发送商业性电子信息或广告促销信息。 \n      7.9 您不得在本平台上发布不良违法信息以及与本平台提供服务无关的信息、或发布《平台用户服务协议》中规定的其他禁止用户发布的信息或从事其他违反《平台用户服务协议》规定的行为，否则本平台有权随时永久停止向您提供服务，由此产生的一切责任应由您自行承担。 \n      7.10 不论在何种情况下,本平台对由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。 \n\n      八、通知的发送 \n      8.1 您同意本条款项下本平台对于您所有的通知（包括商品信息或商业性广告）均可通过网页公告、客户端推送消息、发送到用户注册的电子邮件、手机或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人，以上通知模式均具有同样的法律效力。 \n      8.2 您对于本平台的通知应当通过本平台对外正式公布的通信地址、传真 号码、电子邮件地址等联系信息进行送达。该等通知以本平台实际收到日为送达日。 \n\n      九、条款的终止 \n      9.1 本平台有权终止向您提供服务，本条款于全部服务依法定程序及方式终止之日终止。 9.2 本条款的终止不影响本平台其他主体依据本条款享有的各项权利的实现，也不影响守约方向违约方追究违约责任。 \n\n      十、争议解决 \n      10.1 如您与本平台第三方服务发生任何争议，平台可在法律法规要求的范围内协助您与平台第三方之间争议的协商调解。您同意，本平台有权通过电话或电子邮件等方式向争议双方了解情况，并将所了解的情况通过必要方式通知对方。此外，您有权通过司法或执法机关要求本平台提供相关资料，但您理解并同意，本平台无任何义务对您与服务单位之间的任何争议承担任何责任。 \n      10.2 若您与平台因本条款内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向平台主体公司所在地上海市普陀区人民法院提起诉讼。 \n      10.3 因您使用本平台服务而引起或与之相关的一切争议、权利主张或其它事项，均适用中华人民共和国大陆地区法律，并且排除一切冲突法规定的适用。您在使用我公司应用程序并通过该应用程序接单或服务平台第三方，即视为您已充分理解并与平台服务商之间签署的服务条款。并在此前提下同意接受本条款中约定的平台规则及违规责任。 \n\n      一、如您存在下列违反平台规则的行为，应当按照本条款约定承担违规责任。违规责任包括违约金、暂停服务或解除合作。在您接到投诉的情况下，平台有权进行调查，调查期间将暂停对您的平台服务。 \n      二、您在使用本平台服务时，不得有下列破坏平台规则，损害平台第三方、其他平台用户及平台利益的作弊行为。 \n      1 利用虚假的账号，以获取奖励、订单、好评等为目的的作弊行为 （如：伪造账号接单、团伙刷单、模拟刷单、自己或串通他人伪造第三方账号以骗取平台奖励等）。 \n      2 安装使用对平台产生干扰的设备或第三方作弊软件的行为。 \n      3 短时间内完成多个订单且订单金额不在正常交易范围内的订单/订单金额异常。 \n      4 其他作弊违规行为。 \n      三、违反平台规则，应当承担以下违约责任。 \n      1 平台判定您在服务过程中存在不规范操作行为（如：接单后不执行、爽约、违约等）的， 平台有权立即暂停该账号接单 24小时；不规范行为同时违反本条款第一条的，平台也有权按照第一条的规定，要求您承担违规责任。 \n      2 违反本条款第二条规定的，平台有权暂停该账号一切活动，包括关于该账号的费用结算。同一账号第一次被判定为作弊的，平台有权暂停该账号接单3天，第二次被判定为作弊的，平台有权暂停该账号接单7天；第三次及以上被判定为作弊的，平台有权暂停该账号接单30天。 \n      3 平台有权不结算作弊订单或收回已结算作弊订单的金额，并收取相当于作弊订单金额三倍的违约金。\n      四、您理解并同意，因您违反本协议约定或发生其它过错，导致或产生的任何第三方向平台或其合作方、关联方主张任何索赔、要求，如果造成平台或其合作方、关联方发生的任何损失，包括合理的律师费，您应当向平台与合作方、关联方承担赔偿责任。平台可以协助合作方、关联方向您主张权利。\n          ")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"隐私政策2022","visible":_vm.authorizeDialog6,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog6=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("隐私政策2022")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n                   发布时间：2021年1月28日\n更新时间：2022年1月10日\n      米咖非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。本政策适用于米咖平台所提供的服务，请您在使用本平台服务前，仔细阅读并了解本《隐私政策》。 当您按照米咖平台注册页面提示阅读并同意本政策且完成全部注册程序后，即表示您已充分阅读、理解并接受本政策的全部内容。\n\n      我们承诺，米咖仅会出于本政策所述的以下目的，收集和使用您的个人信息。\n\n      一、我们如何收集和使用您的个人信息： \n      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 \n      为更好地为您提供服务，米咖将遵循“合法、正当、必要”原则，按照法律法规的规定和您的同意收集您的个人信息，主要包括： \n      1、您提供的信息 \n当在你使用本平台服务的过程中，本平台会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的账号安全： \n      "),_c('b',[_vm._v(" 用户个人基本信息：姓名（名称）、性别、年龄、常用地址、地理位置、电话号码、电子邮箱地址、身份证件号码、证件照片、用户人像； \n      用户权限信息：通讯录权限、相册权限、相机权限、存储权限、读取权限、蓝牙权限、音频权限、定位权限、拨打电话权限、获取应用列表权限、语音识别权限、短信验证码； \n      用户终端信息：设备MAC地址、唯一设备识别码、SIM卡IMSI信息、IMEI、终端版本型号、网络IP、本机号码、网络类型、手机品牌； \n电子商务信息：家庭住址、身份证、面部特征、开户行名称、银行卡卡号、银行卡有效期限、银行预留手机号码。")]),_vm._v("\n      您提供的上述信息，将在您使用本平台服务期间持续授权我们使用。 \n      2、您在使用服务过程中产生的信息 \n      您使用我们提供的服务时，我们可能自动收集以下信息： \n      （1）日志信息 \n      指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括： \n      A. 设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码； \n      B. 您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息； \n      （2）位置信息 \n      指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过 GPS 或 WiFi等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。\n      （3）手机账户信息 \n      指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号相关信息。  \n      3、业务功能需要获取的相关权限信息 \n      当在你使用米咖平台服务的过程中，米咖平台需要获取您的手机相关权限，用以向你提供服务、优化我们的服务以及保障你的账号安全：\n      （1）语音搜索：需要音频权限、语音识别权限； \n      （2）投诉处理图片上传、保存邮件中的图片到本地相册、发送邮件时选择相册中的图片作为附件、保存米咖平台中的图片至本地相册：需要相册、相机权限； \n      （3）实名制功能：相册、相机权限； \n      （4）图片缓存加速、日志或附件存储到本地：本地存储权限； \n      （5）分享功能：需要发送短信权限； \n      （6）一键登录、活跃数据统计、云闪付：读取电话状态（IMSI/IMEI号）权限；\n      （7）在线客服语音输入：音频权限； \n      （8）在线客服拍照反馈：相机、相机权限； \n      （9）在线客服转人工：拨打电话权限； \n      （10）在线客服照片反馈：相册、相机权限\n\n      4、第三方收集和使用信息\n      （1）第三方服务收集信息的情形 \n在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务 。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。\n      （2）从第三方获得您的个人信息 \n为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。\n\n      二、我们可能将收集到的您的个人信息用于以下目的： \n       1、为您提供服务 \n      （1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性； \n      （2）通过信息数据分析，帮助我们设计新服务，改善我们现有服务； \n      （3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应； \n      （4）提供您关注或者与您相关的广告以替代普遍投放的广告，您在使用我们的服务时，我们可能使用您的信息向您发送电子邮件、短信或推送通知，如您不希望收到这些信息，可以按照我们的相关提示取消订阅； \n      （5）评估我们服务中的广告和其他促销及推广活动的效果，并加以改善； \n      （6）软件认证或管理软件升级； \n      （7）让您参与有关我们产品和服务的调查； \n      （8）其他您授权同意提供个人信息的情况。\n      2、我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告。基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容。为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。 \n      3、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。 \n      4、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意： \n      （1）与国家安全、国防安全有关的； \n      （2）与公共安全、公共卫生、重大公共利益有关的 \n      （3）与犯罪侦查、起诉、审判和判决执行等有关的； \n      （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； \n      （5）所收集的个人信息是个人信息主体自行向社会公众公开的； \n      （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道； \n      （7）根据您的要求签订合同所必需的； \n      （8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障； \n      （9）为合法的新闻报道所必需的； \n      （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； \n      （11）法律法规规定的其他情形。 \n\n      三、个人信息的存储 \n      （1）信息存储的地点 \n      我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，不存在境外收集用户信息情况。 \n      （2）信息存储的期限 \n      我们承诺您个人信息的存储时间始终处于合理必要期限内（原则上5年），我们根据业务需要时长去存储用户信息，超出保存期限的用户信息，米咖平台会做匿名化处理；当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。 \n\n      四、个人信息安全保护措施和能力 \n      1、我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解你设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知你。 您在本平台登录时的用户名为您的手机号码，本平台只通过关联方式展示该手机号码的信息。\n\n      五、我们如何共享、转让、公开披露您的个人信息 \n      （一）共享 \n      我们不会与您在米咖平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： \n      1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 \n      2、与我们合作中的促销活动品牌方共享：本人同意平台将本人信息，包含但不限于本人的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等，披露给合作中的促销活动品牌方，并允许品牌方使用。\n      3、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 \n      4、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 \n      我们的关联公司包括米咖平台现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。 \n      5、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下三大类型： \n      A.供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。 \n      B.第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。 \n      C.广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。但我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率。 对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。 \n      （二）转让 \n      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： \n      1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； \n      2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 \n      （三）公开披露 \n      我们仅会在以下情况下，公开披露您的个人信息： \n      1、获得您明确同意后； \n      2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。 \n\n      六、我们如何保护您的个人信息 \n      （一）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。 \n      （二）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。  \n      （三）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 \n\n      七、您的权利 \n      1、查询和更正您的个人信息 \n      除法律法规规定外，您有权在登陆本平台后查询您的个人信息。\n      2、在以下情形中，您可以向我们提出删除个人信息的请求： \n      （1）如果我们处理个人信息的行为违反法律法规； \n      （2）如果我们收集、使用您的个人信息，却未征得您的同意； \n      （3）如果我们处理个人信息的行为违反了与您的约定； \n      （1）如果您不再使用我们的产品或服务，或您注销了账号； \n      （2）如果我们不再为您提供产品或服务。 \n      当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。\n\n      八、本政策如何更新 \n      我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会以通告的形式发布对本政策所做的任何变更，在该种情况下，界面上会有弹框进行提示，若您点击同意后，即表示接受修订后的隐私政策约束。 \n\n      九、争议解决\n      因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至【上海市普陀区】人民法院。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。\n         ")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"个人信息采集授权","visible":_vm.authorizeDialog7,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog7=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("个人信息采集授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n        为了加强个人信息校验，提供更完善的服务包括推荐任务、紧急联系等，您将授权米咖收集、使用、保存您的个人信息，包括：身高、学历、住址、紧急联系人\n        我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。\n        我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。\n        您在进行个人信息采集的过程中，所执行的操作均视为您同意米咖的个人信息采集方式并予以授权执行。如在此过程中，您不同意或者对采集方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。\n")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"人脸识别服务授权","visible":_vm.authorizeDialog8,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog8=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("人脸识别服务授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n        为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，您授权米咖收集、使用、保存您通过您的设备终端提供的人脸识别信息。\n        我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括与法律法规允许或政府机关授权的机构所保存的信息，或在本人提供的各人脸信息之间进行比对核验。）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的人脸识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。\n         我们努力在现有技术能力基础之上保障人脸识别服务正常运行，并将尽力来提升人脸识别验证的准确性。但是，由于采集人脸信息容易受到表情、妆容、环境光等多种不特定因素影响，而且能收集的信息范围相对有限，技术水平和认证手段也在不断升级改进之中，我们无法保证每次人脸识别均能验证成功。\n        我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。\n        您在进行人脸识别的过程中，所执行的操作均视为您同意米咖的人脸识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。\n")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"身份信息识别服务授权","visible":_vm.authorizeDialog9,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog9=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("身份信息识别服务授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n        为加强个人信息校验，保障您的账号权益，您将授权米咖采集、使用、保存您的姓名、身份证号、身份证有效期、身份证照片进行身份识别。      \n                  我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的身份信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。\n                  我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。\n                  您在进行身份信息识别的过程中，所执行的操作均视为您同意米咖的身份信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。\n")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"银行信息识别服务授权","visible":_vm.authorizeDialog10,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog10=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("银行信息识别服务授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n        为确保您的服务费结算真实有效，您将授权米咖收集、使用、保存您的银行卡信息，包含：持卡人姓名、银行卡号、开户行，银行卡照片。\n        我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的银行信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。\n        我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。\n        您在进行银行信息识别的过程中，所执行的操作均视为您同意米咖的银行信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。\n")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"地理信息采集授权","visible":_vm.authorizeDialog11,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog11=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("地理信息采集授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n        为确保您的服务费结算真实有效，您将授权米咖收集、使用、保存您的银行卡信息，包含：持卡人姓名、银行卡号、开户行，银行卡照片。\n        我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的银行信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。\n        我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。\n        您在进行银行信息识别的过程中，所执行的操作均视为您同意米咖的银行信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。\n")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"隐私政策","visible":_vm.authorizeDialog12,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog12=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("隐私政策")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n          发布时间：2022年【6】月【29】日")]),_vm._v(" "),_c('p',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n          更新时间：2024年【4】月【29】日")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      相关定义：")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       1、【米咖】服务提供者：指【米咖】的互联网信息及软件技术服务提供者【普乐师（上海）数字科技有限公司】（注册地址：【上海市嘉定区马陆镇嘉昌路288号1幢A区104室】）、上海若胜米咖信息技术有限公司（注册地址：【上海市嘉定区马陆镇周赵路570弄8号1幢】）及关联公司。\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("        2、关联公司：指现在、将来控制【普乐师（上海）数字科技有限公司】、受【普乐师（上海）数字科技有限公司】控制或与【普乐师（上海）数字科技有限公司】处于共同控制下的公司、机构，包括不限于【上海赢迪营销服务有限公司、上海赢迪市场营销服务有限公司、上海明酷营销服务有限公司、上海明酷商务咨询有限公司、上海翰为市场营销策划有限公司、上海呈智信息科技有限公司、北京若胜科技有限公司、北京普乐师科技有限公司】。 ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       3、控制：指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("        米咖为【米咖】服务提供者（下称“我们”）运营的“米咖”微信公众号（下称“本平台”）。我们非常重视用户（下称“您“）的个人信息保护，并会尽全力保护您的个人信息安全可靠。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      本《隐私政策》（下称“本政策”）适用于本平台所提供的服务，请您在使用本平台服务前，仔细阅读并理解本政策，特别是以粗体标识的条款，并在确认充分理解并同意后再开始使用本平台服务；如您不同意本政策中的任何条款，您应立即停止访问或使用本平台服务。当您使用或继续使用本平台服务时，即表示您已充分阅读、理解并接受本政策的全部内容。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      如我们提供的某款服务有单独的隐私信息授权或相应的用户服务协议当中存在隐私授权，则该服务的隐私服务授权将优先适用，该款服务隐私授权未涵盖的内容，以本政策内容为准。如我们关联公司的产品或服务中使用了我们提供的产品或服务但未设置独立隐私政策的，则本隐私政策同样适用于该部分产品或服务。需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于【普乐师(上海)数字科技有限公司】和/或其关联公司已另行独立设置隐私政策的产品及/或服务。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      如对本政策有任何疑问、意见和建议，您可以通过本政策中提供的联系方式与我们联系。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("摘要")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      本《隐私政策摘要》（“本摘要”）适用于【普乐师(上海)数字科技有限公司】、上海若胜米咖信息技术有限公司及关联公司（下称“我们”）运营的“米咖”微信公众号（本摘要中称“平台”），我们希望通过本摘要向您简要说明我们如何收集、使用、共享、保护您的个人信息，以及您管理个人信息的方式。更多详细信息请查阅完整版的《隐私政策》 。\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      1.收集的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      平台会为实现【日常任务管理、任务推荐、任务结算、信息查询】等基本功能及其他扩展功能收集和使用您的个人信息。您可点此查看  个人信息收集清单。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      2.与第三方共享的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("       在法定情形之外，平台会与关联公司及合作伙伴共享您的个人信息（包括以SDK形式），您可点此查看我们 与第三方共享个人信息清单。 ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      3.您如何管理您的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      您可以访问、更正、删除您的个人信息，您还可以撤回同意、注销账号、获取您的个人信息副本、向指定的第三方转移个人信息，以及行使其他个人信息主体的法定权利")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       4.平台如何保存您的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      我们只会在达成本政策所述目的所必要的期限内保留您的个人信息，除非法律有强制的留存要求；我们在中华人民共和国境内运营过程中收集和产生的您的个人信息将存储于境内。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      5.平台如何处理未成年人的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       6．与我们联系")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("        我们设立了个人信息专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【service@plscn.com】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路652号6号楼2楼】。您还可以随时拨打我们的客服电话【021-60321998】与我们联系；一般情况下，我们将在15个工作日内回复。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("如您想了解更加详尽的信息，请根据本隐私政策目录阅读相应内容：")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      一、我们如何收集和使用您的个人信息\n          ")]),_vm._v(" "),_c('p',{},[_vm._v("       二、我们如何共享、委托处理、转让、公开披露您的个人信息")]),_vm._v(" "),_c('p',{},[_vm._v("      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("        三、我们如何保存和保护您的个人信息")]),_vm._v(" "),_c('p',{},[_vm._v("      四、您如何管理您的个人信息")]),_vm._v(" "),_c('p',{},[_vm._v("      五、我们如何处理未成年人的个人信息")]),_vm._v(" "),_c('p',{},[_vm._v("      六、本政策如何更新")]),_vm._v(" "),_c('p',{},[_vm._v("      七、如何联系我们")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       一、我们如何收集和使用您的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      （一）我们收集和使用您的个人信息的场景")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("       为更好地为您提供服务，我们将遵循“合法、正当、必要”原则，按照法律法规的规定或您的同意收集您的个人信息，包括以下场景：")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      （1）注册")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       为了您注册使用我们的产品，我们需要收集您的姓名、手机号。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      （2）身份认证、实名认证、银行卡认证")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，我们需要收集您的个人自拍照、个人自拍视频；为加强个人信息校验，保障您的账号权益，我们需要收集您的姓名、身份证号、身份证有效期、身份证照片；为确保您的服务费结算真实有效，我们需要收集您的持卡人姓名、持卡人身份证号、银行卡号、开户行、银行卡照片。")]),_vm._v(" "),_c('p',{},[_vm._v("      在认证的过程中，可能需要由提供认证服务的第三方认证机构核验你的真实身份信息。这些信息仅供完成认证的目的，或其他法律法规所规定的用途，未经您明示授权不会用作其他目的。若您拒绝提供相关个人信息进行认证，将可能无法使用必须认证才可使用的功能或相关服务，但不影响您浏览任务广场。")]),_vm._v(" "),_c('p',{},[_vm._v("      （3）完善信息")]),_vm._v(" "),_c('p',{},[_vm._v("      为了加强个人信息校验，提供更完善的服务包括推荐任务、紧急联系等，我们可能需要收集您的身高、学历、住址、紧急联系人姓名、紧急联系人手机号。 若您拒绝提供相关个人信息，将可能无法使用相关功能或服务，但不影响您浏览任务广场。")]),_vm._v(" "),_c('p',{},[_vm._v("      （4）任务广场")]),_vm._v(" "),_c('p',{},[_vm._v("      为了向您展示您所在城市的任务，我们需要收集您的位置信息，您可选择通过系统授权我们收集获取，或由您自主选择您所在的城市。若您拒绝提供地理位置信息，将可能无法使用相关功能或服务。")]),_vm._v(" "),_c('p',{},[_vm._v("      （5）开始任务、任务数据提报")]),_vm._v(" "),_c('p',{},[_vm._v("      在您领取任务后，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作，我们需要收集您的以下信息：个人自拍视频、位置信息。在您提供前述个人信息后，才可以开始任务。")]),_vm._v(" "),_c('p',{},[_vm._v("      在任务中进行中，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作并且确保您提报的任务数据的真实性，我们需要收集您的以下信息：个人形象照片、证件照、个人自拍视频、位置信息。您若不提供前述个人信息，则无法完成任务。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      （二）第三方收集和使用信息")]),_vm._v(" "),_c('p',{},[_vm._v("      1）第三方服务收集信息的情形\n\n            在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。")]),_vm._v(" "),_c('p',{},[_vm._v("      （2）从第三方获得您的个人信息")]),_vm._v(" "),_c('p',{},[_vm._v("      为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      （三）我们收集和使用个人信息的其他规则")]),_vm._v(" "),_c('p',{},[_vm._v("      1、我们会根据本政策的约定，在实现我们的产品/服务功能所必要的范围内，对所收集的个人信息进行使用。")]),_vm._v(" "),_c('p',{},[_vm._v("        2、若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。")]),_vm._v(" "),_c('p',{},[_vm._v("      3、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意：")]),_vm._v(" "),_c('p',{},[_vm._v("      1）为履行法定义务或法定职责所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；")]),_vm._v(" "),_c('p',{},[_vm._v("      （2）为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；")]),_vm._v(" "),_c('p',{},[_vm._v("      （3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；")]),_vm._v(" "),_c('p',{},[_vm._v("      （4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；")]),_vm._v(" "),_c('p',{},[_vm._v("      （5）依法在合理的范围内处理您自行公开或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；")]),_vm._v(" "),_c('p',{},[_vm._v("      （6）法律、行政法规规定的其他情形。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("       请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行匿名化地研究、统计分析和预测，用于改善我们的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），此类处理后数据的使用无需另行向您通知并征得您的同意。\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      二、我们如何共享、委托处理、转让、公开披露您的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      （一）共享")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      我们不会与您在本平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      2、与我们合作中的品牌客户公司共享：在你为品牌客户提供任务服务期间，为履行您作为一方当事人的合同所必需，您同意平台将您的信息，包括不限于您的姓名、身份证件号码、身份证照片、银行卡信息、银行卡照片、个人自拍照片、个人自拍视频、电话号码、必要的位置信息，披露给合作中的促销活动品牌方，并允许品牌方使用。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      3、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       4、与我们的关联公司共享：为实现我们的产品或服务的功能或提供您需要的服务，保护您的账号与交易安全，或为维护我们及我们的关联方或合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害而有必要的情形下，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      5、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。您可点此查看我们与 第三方共享个人信息清单。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      （二）委托处理")]),_vm._v(" "),_c('p',{},[_vm._v("       我们可能委托授权合作伙伴处理您的个人信息，以便向您提供相应的产品或服务。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供产品或服务所必要的个人信息。如果我们的合作伙伴将您的个人信息用于我们未委托的用途，其将单独征得您的同意。")]),_vm._v(" "),_c('p',{},[_vm._v("      我们的合作伙伴包括：提供技术服务的供应商。我们可能会将您的个人信息提供给支持我们功能的第三方，包括为我们提供基础设施技术服务、数据分析服务及数据处理服务等的供应商。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      对我们委托合作伙伴处理个人信息的，我们会与其签署数据保护协议，要求其按照协议约定、本隐私政策以及相关法律法规要求来处理个人信息。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      （三）转让")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：")]),_vm._v(" "),_c('p',{},[_vm._v("       1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；")]),_vm._v(" "),_c('p',{},[_vm._v("      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      2、在涉及重组、合并、收购、破产清算、资产转让等情形时，如涉及到个人信息转让，我们会向您告知新的持有您个人信息的公司、组织的名称或者姓名和联系方式，并要求该公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      （四）公开披露")]),_vm._v(" "),_c('p',{},[_vm._v("       我们仅会在以下情况下，公开披露您的个人信息：")]),_vm._v(" "),_c('p',{},[_vm._v("      1、获得您明确同意后；")]),_vm._v(" "),_c('p',{},[_vm._v("       2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      （五）共享、转让、公开披露个人信息时事先征得授权同意的例外")]),_vm._v(" "),_c('p',{},[_vm._v("      以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：")]),_vm._v(" "),_c('p',{},[_vm._v("        1、与我们履行法律法规规定的义务相关的；")]),_vm._v(" "),_c('p',{},[_vm._v("      2、与国家安全、国防安全直接相关的；")]),_vm._v(" "),_c('p',{},[_vm._v("      3、与公共安全、公共卫生、重大公共利益直接相关的；")]),_vm._v(" "),_c('p',{},[_vm._v("      4、与犯罪侦查、起诉、审判和判决执行等直接相关的；")]),_vm._v(" "),_c('p',{},[_vm._v("      5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；")]),_vm._v(" "),_c('p',{},[_vm._v("       6、您自行向社会公众公开的个人信息；")]),_vm._v(" "),_c('p',{},[_vm._v("       7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；")]),_vm._v(" "),_c('p',{},[_vm._v("       8、法律法规规定的其他情形。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      三、我们如何保存和保护您的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      1、信息存储的地点")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，如需向境外提供，我们将遵照个人信息出境的相关法律规定处理。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      2、信息存储的期限")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      我们承诺，只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年、《中华人民共和国网络安全法》要求相关的网络日志的保存时间不少于六个月。超出保存期限的用户信息，本平台会做删除或匿名化处理；")]),_vm._v(" "),_c('span',[_vm._v("当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式或其他形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       3、我们保护您个人信息的技术与措施")]),_vm._v(" "),_c('p',{},[_vm._v("       （1）我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权的访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在您设备端的软件的安全能力，以防止您的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解您设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知您。")]),_vm._v(" "),_c('p',{},[_vm._v("      （2）我们会严格按照《网络安全法》、《数据安全法》、《个人信息保护法》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。")]),_vm._v(" "),_c('p',{},[_vm._v("      （3）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      四、您如何管理您的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      1、查询、更正和补充您的个人信息")]),_vm._v(" "),_c('p',{},[_vm._v("除法律法规规定外，您有权在登陆本平台后查询、更正和补充您的个人信息")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      2、在以下情形中，您可以通过本政策提供的联系方式向我们提出删除个人信息的请求：")]),_vm._v(" "),_c('p',{},[_vm._v("      （1）如果我们处理个人信息的行为违反法律法规；")]),_vm._v(" "),_c('p',{},[_vm._v("      （2）如果我们收集、使用您的个人信息，却未征得您的同意；")]),_vm._v(" "),_c('p',{},[_vm._v("      （3）如果我们处理个人信息的行为违反了与您的约定；")]),_vm._v(" "),_c('p',{},[_vm._v("      （4）如果您不再使用我们的产品或服务，或您注销了账号；")]),_vm._v(" "),_c('p',{},[_vm._v("       （5）如果我们不再为您提供产品或服务。")]),_vm._v(" "),_c('p',{},[_vm._v("      当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      3、注销您的个人账号")]),_vm._v(" "),_c('p',{},[_vm._v("      您可以通过以下方式申请注销您的个人账号：")]),_vm._v(" "),_c('p',{},[_vm._v("      （1）在【个人中心】提交账号注销申请；")]),_vm._v(" "),_c('p',{},[_vm._v("      （2）通过拨打客服热线【021-60321998】进行注销。")]),_vm._v(" "),_c('p',{},[_vm._v("      我们会在接收到您提出的注销申请后15个工作日内完成您的注销申请并将你的个人信息匿名化处理")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       4、改变您授权同意的范围或撤回您的授权")]),_vm._v(" "),_c('p',{},[_vm._v("      您可以通过管理设备权限等方式改变或者撤回您授权我们收集和处理您的个人信息的范围。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。")]),_vm._v(" "),_c('p',{},[_vm._v("      请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      5、向指定的第三方转移个人信息")]),_vm._v(" "),_c('p',{},[_vm._v("      您如果需要将您的个人信息转移至您指定的第三方的，您可以通过本政策载明的方式联系我们，在符合法律法规规定的条件下，我们将逐一处理和响应")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       6、获取您的个人信息副本")]),_vm._v(" "),_c('p',{},[_vm._v("       如您需要获取我们收集的您的个人信息副本，您可通过本政策载明的方式联系我们，我们会对您进行个人信息校验。完成个人信息主体确认后，我们会在符合相关法律规定且技术可行的前提下，根据您的要求将个人信息副本通过您提供的联系方式或其他方式提交给您")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      7、响应您的请求")]),_vm._v(" "),_c('p',{},[_vm._v("      （1）如果您无法通过上述方式管理您的个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您可通过我们在本政策中提供的联系方式联系我们。")]),_vm._v(" "),_c('p',{},[_vm._v("      （2）为了保障安全，我们可能需要您提供书面请求，或以其它方式证明您的身份，我们将在收到您反馈并验证您的身份后的15个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      （3）在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：")]),_vm._v(" "),_c('p',{},[_vm._v("      ·与我们履行法律法规规定的义务相关的；")]),_vm._v(" "),_c('p',{},[_vm._v("        ·与国家安全、国防安全直接相关的；\n\n            ·与公共安全、公共卫生、重大公共利益直接相关的；")]),_vm._v(" "),_c('p',{},[_vm._v("       ·与犯罪侦查、起诉、审判和执行判决等直接相关的；")]),_vm._v(" "),_c('p',{},[_vm._v("      ·有充分证据表明您存在主观恶意或滥用权利的；")]),_vm._v(" "),_c('p',{},[_vm._v("        ·响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；")]),_vm._v(" "),_c('p',{},[_vm._v("       ·涉及商业秘密的。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("      五、我们如何处理未成年人的个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       六、本政策如何更新")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("       我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会通过在本平台上发出更新版本并在生效前以适当方式提醒您相关内容的更新，也请您及时了解最新的隐私政策。")]),_vm._v(" "),_c('p',{},[_vm._v("      对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。")]),_vm._v(" "),_c('p',{},[_vm._v("      本政策所指的重大变更包括但不限于：")]),_vm._v(" "),_c('p',{},[_vm._v("       1、本平台的业务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；")]),_vm._v(" "),_c('p',{},[_vm._v("        2、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；")]),_vm._v(" "),_c('p',{},[_vm._v("       3、个人信息共享或公开披露的主要对象发生变化；")]),_vm._v(" "),_c('p',{},[_vm._v("      4、用户个人信息权利及其行使方式发生重大变化；")]),_vm._v(" "),_c('p',{},[_vm._v("      5、处理个人信息保护负责人的联络方式及投诉渠道发生变化时；")]),_vm._v(" "),_c('p',{},[_vm._v("       6、个人信息保护影响评估报告表明存在有高风险时。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       七、如何联系我们")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{},[_vm._v("      我们设立了个人信息保护专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【service@plscn.com】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路652号6号楼2楼】。您还可以随时拨打我们的客服电话【021-60321998】与我们联系。 需注意的是，我们可能不会回复与本政策或您的个人信息权利无关的问题")]),_vm._v(" "),_c('p',{},[_vm._v("        一般情况下，我们将在15个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向本政策签订地上海市普陀区有管辖权的法院提起诉讼。")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"免责规范及自我声明","visible":_vm.authorizeDialog13,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog13=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("免责规范及自我声明")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticClass:"alertContainer"},[_vm._v("          为合法合规承揽业务、提供服务，本人特此声明和承诺如下：")]),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("        一、本人声明承揽业务、提供服务期间，与品牌方、业务发布方、平台方、服务门店不存在劳动关系或劳务派遣关系。\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("         二、本人声明和承诺承揽业务、提供服务期间，并未为且不会为与品牌方存在竞争关系的第三方（联合利华、上海家化、汉高、欧莱雅、霸王、金佰利、花王、立白）提供任何服务，坚决杜绝利益冲突行为。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。 ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("          三、本人承诺承揽业务、提供服务期间，为提高品牌知名度和美誉度，同意严格遵守品牌方和服务门店制定的各项工作守则及工作纪律。本人清楚知悉，此为品牌方和服务门店为确保服务质量所必要监督，不视为品牌方和服务门店对本人进行劳动用工管理。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("      四、本人承诺承揽业务、提供服务期间，严格遵守法律法规有关禁止商业贿赂行为、不正当竞争s行为规定，坚决拒绝商业贿赂（行贿、索贿、受贿）、不正当竞争及其他不正当利益。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("       五、本人承诺承揽业务、提供服务期间，严格履行保密义务，对因承揽业务、提供服务过程中所知悉的相关资料、业务数据、业务需求以及其他文件和信息予以保密。此保密义务不因服务终止而终止。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"alertContainer"},[_vm._v("        以上声明和承诺是本人真实意思表示，本人自愿接受声明和承诺的约束。本声明线上签署，与线下签署具有同等法律效力。")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"DP免责规范及自我声明V2","visible":_vm.authorizeDialog14,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog14=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("DP免责规范及自我声明V2")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("为合法合规承揽业务、提供服务，本人特此声明和承诺如下：")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("一、本人声明承揽业务、提供服务期间，与品牌方、业务发布方、平台方、服务门店不存在劳动关系或劳务派遣关系。\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("二、1）本人声明和承诺如承揽宝洁店内短促任务业务、提供服务期间，并未为且不会为与品牌方存在竞争关系的第三方（联合利华、上海家化、汉高、欧莱雅、霸王、金佰利、花王、立白）提供任何服务，坚决杜绝利益冲突行为。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("2）本人声明和承诺如承揽宝洁HPP业务、提供服务期间，不得同时承接其他促销任务（包括宝洁店内短促任务和其他公司促销活动等）。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("三、本人承诺承揽业务、提供服务期间，为提高品牌知名度和美誉度，同意严格遵守品牌方和服务门店制定的各项工作守则及工作纪律。本人清楚知悉，此为品牌方和服务门店为确保服务质量所必要监督，不视为品牌方和服务门店对本人进行劳动用工管理。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("四、本人承诺承揽业务、提供服务期间，严格遵守法律法规有关禁止商业贿赂行为、不正当竞争行为规定，坚决拒绝商业贿赂（行贿、索贿、受贿）、不正当竞争及其他不正当利益。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("五、本人承诺承揽业务、提供服务期间，严格履行保密义务，对因承揽业务、提供服务过程中所知悉的相关资料、业务数据、业务需求以及其他文件和信息予以保密。此保密义务不因服务终止而终止。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("以上声明和承诺是本人真实意思表示，本人自愿接受声明和承诺的约束。本声明线上签署，与线下签署具有同等法律效力。")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"RS免责规范及自我声明","visible":_vm.authorizeDialog15,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog15=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("RS免责规范及自我声明")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("为合法合规承揽业务、提供服务，本人特此声明和承诺如下：")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("一、本人声明承揽业务、提供服务期间，与品牌方、业务发布方、平台方、服务门店不存在劳动关系或劳务派遣关系。\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("二、1）本人声明和承诺如承揽宝洁店内短促任务业务、提供服务期间，并未为且不会为与品牌方存在竞争关系的第三方（联合利华、上海家化、汉高、欧莱雅、霸王、金佰利、花王、立白）提供任何服务，坚决杜绝利益冲突行为。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。 ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("2）本人声明和承诺如承揽宝洁HPP业务、提供服务期间，不得同时承接其他促销任务（包括宝洁店内短促任务和其他公司促销活动等）。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("三、本人承诺承揽业务、提供服务期间，为提高品牌知名度和美誉度，同意严格遵守品牌方和服务门店制定的各项工作守则及工作纪律。本人清楚知悉，此为品牌方和服务门店为确保服务质量所必要监督，不视为品牌方和服务门店对本人进行劳动用工管理。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("四、本人承诺承揽业务、提供服务期间，严格遵守法律法规有关禁止商业贿赂行为、不正当竞争行为规定，坚决拒绝商业贿赂（行贿、索贿、受贿）、不正当竞争及其他不正当利益。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v(" 五、本人承诺承揽业务、提供服务期间，严格履行保密义务，对因承揽业务、提供服务过程中所知悉的相关资料、业务数据、业务需求以及其他文件和信息予以保密。此保密义务不因服务终止而终止。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("以上声明和承诺是本人真实意思表示，本人自愿接受声明和承诺的约束。本声明线上签署，与线下签署具有同等法律效力。")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"个人视频共享授权","visible":_vm.authorizeDialog16,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog16=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("个人视频共享授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("为了加强个人信息校验，保障您的权益，您将授权我们向品牌方共享您的刷脸视频，如您不同意共享此信息，则可能影响任务的执行。")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"小程序-隐私政策","visible":_vm.authorizeDialog18,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog18=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("小程序-隐私政策")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('div',{attrs:{"id":"thirdPartyInfo"}},[_c('p',{staticClass:"p",staticStyle:{"text-align":"center"},attrs:{"align":"center"}},[_c('b',[_c('span',{staticStyle:{"font-family":"宋体","font-weight":"bold","font-size":"12.0000pt"}},[_c('span',[_vm._v("隐私政策")])])]),_c('b',[_c('span',{staticStyle:{"font-family":"宋体","font-weight":"bold","font-size":"12.0000pt"}},[_c('span',[_vm._v("-小程序版")])])]),_c('b',[_c('span',{staticStyle:{"font-family":"Calibri","font-weight":"bold","font-size":"12.0000pt"}})])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("     "),_c('span',[_vm._v("相关定义：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       1"),_c('span',[_vm._v("、【")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("FMES")]),_c('span',[_vm._v("米享家")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("】服务提供者：指【")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("FMES")]),_c('span',[_vm._v("米享家")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("】")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("的互联网信息及软件技术服务提供者【普乐师（上海）数字科技有限公司】（注册地址：【上海市嘉定区马陆镇嘉昌路")]),_vm._v("288"),_c('span',[_vm._v("号")]),_c('span',[_vm._v("1")]),_c('span',[_vm._v("幢")]),_c('span',[_vm._v("A")]),_c('span',[_vm._v("区")]),_c('span',[_vm._v("104")]),_c('span',[_vm._v("室】）、上海若胜")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("米咖")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("信息技术有限公司（注册地址：【上海市嘉定区马陆镇周赵路")]),_vm._v("570"),_c('span',[_vm._v("弄")]),_c('span',[_vm._v("8")]),_c('span',[_vm._v("号")]),_c('span',[_vm._v("1")]),_c('span',[_vm._v("幢】）及关联公司。 ")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p",staticStyle:{"margin-left":"26.0000pt","text-indent":"0.0000pt"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("2、")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("关联公司：指现在、将来控制【普乐师（上海）数字科技有限公司】、受【普乐师（上海）数字科技有限公司】控制或与【普乐师（上海）数字科技有限公司】处于共同控制下的公司、机构，包括不限于【上海赢迪营销服务有限公司、上海赢迪市场营销服务有限公司、上海明酷营销服务有限公司、上海明酷商务咨询有限公司、上海翰为市场营销策划有限公司、上海呈智信息科技有限公司、")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("若胜市场营销策划（上海）有限公司、上海若胜米咖信息技术有限公司、上海加诺普科技有限公司、")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("北京若胜科技有限公司、北京普乐师科技有限公司】。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      3"),_c('span',[_vm._v("、控制：指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理")]),_c('span',[_vm._v("/")]),_c('span',[_vm._v("经营的能力。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       ")]),_c('span',{staticClass:"16",staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("普乐师（上海）数字科技有限公司")])]),_c('span',{staticClass:"16",staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("（下称")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("我们")]),_c('span',[_vm._v("”")]),_c('span',[_vm._v("）运营的")]),_c('span',[_vm._v("“")])]),_c('span',{staticClass:"16",staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("FMES")]),_c('span',[_vm._v("米享家")])]),_c('span',{staticClass:"16",staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("”")])]),_c('span',{staticClass:"16",staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("小程序")])]),_c('span',{staticClass:"16",staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("（下称")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("本平台")]),_c('span',[_vm._v("”")]),_c('span',[_vm._v("）非常重视用户（下称")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("您")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("）的个人信息保护，并会尽全力保护您的个人信息安全可靠。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("本《隐私政策》（下称")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("本政策")]),_c('span',[_vm._v("”")]),_c('span',[_vm._v("）适用于本平台所提供的服务，请您在使用本平台服务前，仔细阅读并理解本政策，特别是以粗体标识的条款，并在确认充分理解并同意后再开始使用本平台服务；如您不同意本政策中的任何条款，您应立即停止访问或使用本平台服务。当您使用或继续使用本平台服务时，即表示您已充分阅读、理解并接受本政策的全部内容。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("如我们提供的某款服务有单独的隐私信息授权或相应的用户服务协议当中存在隐私授权，则该服务的隐私服务授权将优先适用，该款服务隐私授权未涵盖的内容，以本政策内容为准。如我们关联公司的产品或服务中使用了我们提供的产品或服务但未设置独立隐私政策的，则本隐私政策同样适用于该部分产品或服务。需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于【普乐师")]),_c('span',[_vm._v("(")]),_c('span',[_vm._v("上海")]),_c('span',[_vm._v(")")]),_c('span',[_vm._v("数字科技有限公司】和")]),_c('span',[_vm._v("/")]),_c('span',[_vm._v("或其关联公司已另行独立设置隐私政策的产品及")]),_c('span',[_vm._v("/")]),_c('span',[_vm._v("或服务。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("如对本政策有任何疑问、意见和建议，您可以通过本政策中提供的联系方式与我们联系。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("摘要")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("本《隐私政策摘要》（")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("本摘要")]),_c('span',[_vm._v("”")]),_c('span',[_vm._v("）适用于【普乐师")]),_c('span',[_vm._v("(")]),_c('span',[_vm._v("上海")]),_c('span',[_vm._v(")")]),_c('span',[_vm._v("数字科技有限公司】、上海若胜")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("米咖")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("信息技术有限公司及关联公司（下称")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("我们")]),_c('span',[_vm._v("”")]),_c('span',[_vm._v("）运营的")]),_c('span',[_vm._v("“")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("FMES")]),_c('span',[_vm._v("米享家")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("”")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("小程序")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("（本摘要中称")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("平台")]),_c('span',[_vm._v("”")]),_c('span',[_vm._v("），")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("我们希望通过本摘要向您简要说明我们如何收集、使用、共享、保护您的个人信息，以及您管理个人信息的方式。更多详细信息请查阅完整版的《隐私政策》")]),_vm._v(" "),_c('span',[_vm._v("。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1."),_c('span',[_vm._v("收集的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("平台会为实现【任务")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("查询")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("、任务推荐、任务结算")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("】等基本功能及其他扩展功能收集和使用您的个人信息。您可点此查看")]),_vm._v(" "),_c('span',[_vm._v("个人信息收集清单。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      2."),_c('span',[_vm._v("与第三方共享的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("在法定情形之外，平台会与关联公司及合作伙伴共享您的个人信息（包括以")]),_c('span',[_vm._v("SDK")]),_c('span',[_vm._v("形式），您可点此查看我们 与"),_c('span',{staticStyle:{"color":"blue","cursor":"pointer"},attrs:{"onclick":"document.getElementById('thirdPartyInfoPopup').style.display='';document.getElementById('thirdPartyInfo').style.display='none'"}},[_vm._v("第三方共享个人信息清单")]),_vm._v("。 ")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      3."),_c('span',[_vm._v("您如何管理您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("您可以访问、更正、删除您的个人信息，您还可以撤回同意、注销账号、获取您的个人信息副本、向指定的第三方转移个人信息，以及行使其他个人信息主体的法定权利")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       4."),_c('span',[_vm._v("平台如何保存您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们只会在达成本政策所述目的所必要的期限内保留您的个人信息，除非法律有强制的留存要求；我们在中华人民共和国境内运营过程中收集和产生的您的个人信息将存储于境内。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      5."),_c('span',[_vm._v("平台如何处理未成年人的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       6"),_c('span',[_vm._v("．与我们联系")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("我们设立了个人信息专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【")]),_c('span',[_vm._v("service@plscn.com")]),_c('span',[_vm._v("】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路")]),_c('span',[_vm._v("652")]),_c('span',[_vm._v("号")]),_c('span',[_vm._v("6")]),_c('span',[_vm._v("号楼")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("楼】。您还可以随时拨打我们的客服电话【")]),_c('span',[_vm._v("021-60321998")]),_c('span',[_vm._v("】与我们联系；一般情况下，我们将在")]),_c('span',[_vm._v("15")]),_c('span',[_vm._v("个工作日内回复。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("如您想了解更加详尽的信息，请根据本隐私政策目录阅读相应内容：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("一、我们如何收集和使用您的个人信息 ")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("二、我们如何共享、委托处理、转让、公开披露您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      ")]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("三、我们如何保存和保护您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("四、您如何管理您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("五、我们如何处理未成年人的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("六、本政策如何更新")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("七、如何联系我们")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("一、我们如何收集和使用您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（一）我们收集和使用您的个人信息的场景")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("为更好地为您提供服务，我们将遵循")]),_c('span',[_vm._v("“")]),_c('span',[_vm._v("合法、正当、必要")]),_c('span',[_vm._v("”")]),_c('span',[_vm._v("原则，按照法律法规的规定或您的同意收集您的个人信息，包括以下场景：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("1")]),_c('span',[_vm._v("）注册")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("为了您注册使用我们的产品，我们需要收集您的姓名、手机号。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("）身份认证、实名认证、银行卡认证")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，我们需要收集您的个人自拍照、个人自拍视频；为加强个人信息校验，保障您的账号权益，我们需要收集您的姓名、身份证号、身份证有效期、身份证照片；为确保您的服务费结算真实有效，我们需要收集您的持卡人姓名、持卡人身份证号、银行卡号、开户行、银行卡照片。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("在认证的过程中，可能需要由提供认证服务的第三方认证机构核验你的真实身份信息。这些信息仅供完成认证的目的，或其他法律法规所规定的用途，未经您明示授权不会用作其他目的。若您拒绝提供相关个人信息进行认证，将可能无法使用必须认证才可使用的功能或相关服务，但不影响您浏览任务广场。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("3")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("）任务广场")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("为了向您展示您所在城市的任务，我们需要收集您的位置信息，您可选择通过系统授权我们收集获取，或由您自主选择您所在的城市。若您拒绝提供地理位置信息，将可能无法使用相关功能或服务。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("4")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("）开始任务、任务数据提报")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("在您领取任务后，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作，我们需要收集您的以下信息：个人自拍视频、位置信息。在您提供前述个人信息后，才可以开始任务。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("在任务中进行中，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作并且确保您提报的任务数据的真实性，我们需要收集您的以下信息：个人形象照片、证件照、个人自拍视频、位置信息。您若不提供前述个人信息，则无法完成任务。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（二）第三方收集和使用信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1"),_c('span',[_vm._v("）第三方服务收集信息的情形 在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称")]),_c('span',[_vm._v("SDK")]),_c('span',[_vm._v("）来为您提供服务。这些")]),_c('span',[_vm._v("SDK")]),_c('span',[_vm._v("可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("）从第三方获得您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（三）我们收集和使用个人信息的其他规则")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1"),_c('span',[_vm._v("、我们会根据本政策的约定，在实现我们的产品")]),_c('span',[_vm._v("/")]),_c('span',[_vm._v("服务功能所必要的范围内，对所收集的个人信息进行使用。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       2"),_c('span',[_vm._v("、若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      3"),_c('span',[_vm._v("、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1"),_c('span',[_vm._v("）为履行法定义务或法定职责所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("）为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("3")]),_c('span',[_vm._v("）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("4")]),_c('span',[_vm._v("）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("5")]),_c('span',[_vm._v("）依法在合理的范围内处理您自行公开或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("6")]),_c('span',[_vm._v("）法律、行政法规规定的其他情形。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行匿名化地研究、统计分析和预测，用于改善我们的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），此类处理后数据的使用无需另行向您通知并征得您的同意。 ")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("二、我们如何共享、委托处理、转让、公开披露您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（一）共享")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们不会与您在本平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1"),_c('span',[_vm._v("、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      2"),_c('span',[_vm._v("、与我们合作中的品牌客户公司共享：在你为品牌客户提供任务服务期间，为履行您作为一方当事人的合同所必需，您同意平台将您的信息，包括不限于您的姓名、身份证件号码、身份证照片、银行卡信息、银行卡照片、个人自拍照片、个人自拍视频、电话号码、必要的位置信息，披露给合作中的促销活动品牌方，并允许品牌方使用。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      3"),_c('span',[_vm._v("、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       4"),_c('span',[_vm._v("、与我们的关联公司共享：为实现我们的产品或服务的功能或提供您需要的服务，保护您的账号与交易安全，或为维护我们及我们的关联方或合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害而有必要的情形下，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      5"),_c('span',[_vm._v("、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。您可点此查看我们与 第三方共享个人信息清单。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（二）委托处理")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("我们可能委托授权合作伙伴处理您的个人信息，以便向您提供相应的产品或服务。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供产品或服务所必要的个人信息。如果我们的合作伙伴将您的个人信息用于我们未委托的用途，其将单独征得您的同意。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们的合作伙伴包括：提供技术服务的供应商。我们可能会将您的个人信息提供给支持我们功能的第三方，包括为我们提供基础设施技术服务、数据分析服务及数据处理服务等的供应商。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      ")]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("对我们委托合作伙伴处理个人信息的，我们会与其签署数据保护协议，要求其按照协议约定、本隐私政策以及相关法律法规要求来处理个人信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（三）转让")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       1"),_c('span',[_vm._v("、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      ")]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      2"),_c('span',[_vm._v("、在涉及重组、合并、收购、破产清算、资产转让等情形时，如涉及到个人信息转让，我们会向您告知新的持有您个人信息的公司、组织的名称或者姓名和联系方式，并要求该公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（四）公开披露")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("我们仅会在以下情况下，公开披露您的个人信息：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1"),_c('span',[_vm._v("、获得您明确同意后；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       2"),_c('span',[_vm._v("、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（五）共享、转让、公开披露个人信息时事先征得授权同意的例外")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       1"),_c('span',[_vm._v("、与我们履行法律法规规定的义务相关的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      2"),_c('span',[_vm._v("、与国家安全、国防安全直接相关的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      3"),_c('span',[_vm._v("、与公共安全、公共卫生、重大公共利益直接相关的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      4"),_c('span',[_vm._v("、与犯罪侦查、起诉、审判和判决执行等直接相关的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      5"),_c('span',[_vm._v("、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       6"),_c('span',[_vm._v("、您自行向社会公众公开的个人信息；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       7"),_c('span',[_vm._v("、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       8"),_c('span',[_vm._v("、法律法规规定的其他情形。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("三、我们如何保存和保护您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1"),_c('span',[_vm._v("、信息存储的地点")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，如需向境外提供，我们将遵照个人信息出境的相关法律规定处理。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      2"),_c('span',[_vm._v("、信息存储的期限")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们承诺，只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年、《中华人民共和国网络安全法》要求相关的网络日志的保存时间不少于六个月。超出保存期限的用户信息，本平台会做删除或匿名化处理；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式或其他形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       3"),_c('span',[_vm._v("、我们保护您个人信息的技术与措施")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("1")]),_c('span',[_vm._v("）我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权的访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在您设备端的软件的安全能力，以防止您的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解您设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知您。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("）我们会严格按照《网络安全法》、《数据安全法》、《个人信息保护法》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("3")]),_c('span',[_vm._v("）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("四、您如何管理您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      1"),_c('span',[_vm._v("、查询、更正和补充您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("除法律法规规定外，您有权在登陆本平台后查询、更正和补充您的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      2"),_c('span',[_vm._v("、在以下情形中，您可以通过本政策提供的联系方式向我们提出删除个人信息的请求：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("1")]),_c('span',[_vm._v("）如果我们处理个人信息的行为违反法律法规；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("）如果我们收集、使用您的个人信息，却未征得您的同意；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("3")]),_c('span',[_vm._v("）如果我们处理个人信息的行为违反了与您的约定；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("4")]),_c('span',[_vm._v("）如果您不再使用我们的产品或服务，或您注销了账号；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("5")]),_c('span',[_vm._v("）如果我们不再为您提供产品或服务。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      3"),_c('span',[_vm._v("、注销您的个人账号")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("您可以通过以下方式申请注销您的个人账号：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("1")]),_c('span',[_vm._v("）在【")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("我的")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_c('span',[_vm._v("】提交账号注销申请；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("）通过拨打客服热线【")]),_c('span',[_vm._v("021-60321998")]),_c('span',[_vm._v("】进行注销。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们会在接收到您提出的注销申请后")]),_c('span',[_vm._v("15")]),_c('span',[_vm._v("个工作日内完成您的注销申请并将你的个人信息匿名化处理")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       4"),_c('span',[_vm._v("、改变您授权同意的范围或撤回您的授权")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("您可以通过管理设备权限等方式改变或者撤回您授权我们收集和处理您的个人信息的范围。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      5"),_c('span',[_vm._v("、向指定的第三方转移个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("您如果需要将您的个人信息转移至您指定的第三方的，您可以通过本政策载明的方式联系我们，在符合法律法规规定的条件下，我们将逐一处理和响应")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       6"),_c('span',[_vm._v("、获取您的个人信息副本")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("如您需要获取我们收集的您的个人信息副本，您可通过本政策载明的方式联系我们，我们会对您进行个人信息校验。完成个人信息主体确认后，我们会在符合相关法律规定且技术可行的前提下，根据您的要求将个人信息副本通过您提供的联系方式或其他方式提交给您")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      7"),_c('span',[_vm._v("、响应您的请求")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("1")]),_c('span',[_vm._v("）如果您无法通过上述方式管理您的个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您可通过我们在本政策中提供的联系方式联系我们。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("）为了保障安全，我们可能需要您提供书面请求，或以其它方式证明您的身份，我们将在收到您反馈并验证您的身份后的")]),_c('span',[_vm._v("15")]),_c('span',[_vm._v("个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("（")]),_c('span',[_vm._v("3")]),_c('span',[_vm._v("）在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      ·"),_c('span',[_vm._v("与我们履行法律法规规定的义务相关的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       ·"),_c('span',[_vm._v("与国家安全、国防安全直接相关的； ")]),_c('span',[_vm._v("·")]),_c('span',[_vm._v("与公共安全、公共卫生、重大公共利益直接相关的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       ·"),_c('span',[_vm._v("与犯罪侦查、起诉、审判和执行判决等直接相关的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      ·"),_c('span',[_vm._v("有充分证据表明您存在主观恶意或滥用权利的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       ·"),_c('span',[_vm._v("响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       ·"),_c('span',[_vm._v("涉及商业秘密的。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("五、我们如何处理未成年人的个人信息")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("六、本政策如何更新")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会通过在本平台上发出更新版本并在生效前以适当方式提醒您相关内容的更新，也请您及时了解最新的隐私政策。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("本政策所指的重大变更包括但不限于：")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       1"),_c('span',[_vm._v("、本平台的业务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       2"),_c('span',[_vm._v("、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       3"),_c('span',[_vm._v("、个人信息共享或公开披露的主要对象发生变化；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      4"),_c('span',[_vm._v("、用户个人信息权利及其行使方式发生重大变化；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      5"),_c('span',[_vm._v("、处理个人信息保护负责人的联络方式及投诉渠道发生变化时；")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       6"),_c('span',[_vm._v("、个人信息保护影响评估报告表明存在有高风险时。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("七、如何联系我们")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("      "),_c('span',[_vm._v("我们设立了个人信息保护专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【")]),_c('span',[_vm._v("service@plscn.com")]),_c('span',[_vm._v("】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路")]),_c('span',[_vm._v("652")]),_c('span',[_vm._v("号")]),_c('span',[_vm._v("6")]),_c('span',[_vm._v("号楼")]),_c('span',[_vm._v("2")]),_c('span',[_vm._v("楼】。您还可以随时拨打我们的客服电话【")]),_c('span',[_vm._v("021-60321998")]),_c('span',[_vm._v("】与我们联系。 需注意的是，我们可能不会回复与本政策或您的个人信息权利无关的问题")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}},[_vm._v("       "),_c('span',[_vm._v("一般情况下，我们将在")]),_c('span',[_vm._v("15")]),_c('span',[_vm._v("个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向本政策签订地上海市普陀区有管辖权的法院提起诉讼。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}},[_vm._v(" ")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"thirdPartyInfoPopup"}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('button',{attrs:{"onclick":"document.getElementById('thirdPartyInfoPopup').style.display='none';document.getElementById('thirdPartyInfo').style.display=''"}},[_vm._v("返回")])]),_vm._v(" "),_c('p',[_vm._v("\n\t 米咖接入第三方SDK清单\n\t"),_c('table',{staticClass:"ke-zeroborder",staticStyle:{"border-collapse":"collapse","width":"779.52pt"},attrs:{"border":"0","cellpadding":"0","cellspacing":"0","width":"1559","height":"770"}},[_c('tbody',[_c('tr',[_c('td',{staticClass:"et3",attrs:{"height":"28","width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"249"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"157"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"178"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"223"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"202"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"223"}},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"colspan":"9","height":"34"}},[_vm._v("\n\t\t\t\t\t第三方SDK列表\n\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et8",attrs:{"height":"56","width":"108"}},[_vm._v("\n\t\t\t\t\t序号\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_c('span',{staticClass:"font0"},[_vm._v("第三方")]),_c('span',{staticClass:"font3"},[_vm._v("SDK")])]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t第三方公司名称\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t使用目的\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t使用场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t个人信息收集类型\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t申请的权限\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\t收集方式\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t第三方隐私政策链接\n\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et9",attrs:{"height":"148","width":"108"}},[_vm._v("\n\t\t\t\t\t1\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t微信公众号SDK\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t深圳市腾讯计算机系统有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t用户业务入口\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t用户登入米咖时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\tGPS定位\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\tSDK本机采集，不涉及数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et12",attrs:{"width":"223"}},[_c('a',{attrs:{"href":"https://mp.weixin.qq.com/"}},[_vm._v("https://mp.weixin.qq.com/")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et9",attrs:{"height":"84","width":"108"}},[_vm._v("\n\t\t\t\t\t2\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t腾讯人脸核身\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t深圳市腾讯计算机系统有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t用户身份校验\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t执行任务刷脸时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t头像照、上半身视频、身份证号、姓名\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\tSDK本机采集，SDK传输\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et13",attrs:{"width":"223"}},[_c('a',{attrs:{"href":"https://cloud.tencent.com/document/product/1007/71390"}},[_vm._v("https://cloud.tencent.com/document/product/1007/71390")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et9",attrs:{"height":"140","width":"108"}},[_vm._v("\n\t\t\t\t\t3\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t百度地图\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t北京百度网讯科技有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t用于GPS定位和IP定位，如推荐附件任务、采集上报任务时的定位\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t用户查看附近任务时；用户上报任务时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\tGPS、ssid、bssid\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\tSDK传输\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et12",attrs:{"width":"223"}},[_c('a',{attrs:{"href":"https://lbsyun.baidu.com/index.php?title=openprivacy"}},[_vm._v("https://lbsyun.baidu.com/index.php?title=openprivacy")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et9",attrs:{"height":"112","width":"108"}},[_vm._v("\n\t\t\t\t\t5\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\tOCR识别\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t北京百度网讯科技有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t识别身份证和银行卡信息\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t用户实名认证时，用户银行卡认证时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t身份证照片、姓名、身份证号、身份证有效期、银行卡照片、银行卡号\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\tSDK传输\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et12",attrs:{"width":"223"}},[_c('a',{attrs:{"href":"https://cloud.baidu.com/campaign/OCR202203/index.html"}},[_vm._v("https://cloud.baidu.com/campaign/OCR202203/index.html")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et9",attrs:{"height":"112","width":"108"}},[_vm._v("\n\t\t\t\t\t6\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t人脸核身\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t深圳市腾讯计算机系统有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t用户身份校验\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t用户身份认证时；用户实名认证时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t上半身照片、自拍小视频、姓名、身份证号\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\tSDK传输\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et12",attrs:{"width":"223"}},[_c('a',{attrs:{"href":"https://cloud.tencent.com/document/product/1007/71390"}},[_vm._v("https://cloud.tencent.com/document/product/1007/71390")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et9",attrs:{"height":"56","width":"108"}},[_vm._v("\n\t\t\t\t\t7\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t银行卡三、四要素验证\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t上海加数信息科技有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t银行卡认证、服务费结算\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t用户银行卡认证时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t姓名、身份证号、银行卡号\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\tSDK传输\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10",attrs:{"width":"223"}},[_c('br')])])])])]),_vm._v(" "),_c('p',[_c('br')]),_vm._v(" "),_c('p',[_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n\t\t米咖与其他第三方共享个人信息清单\n\t")]),_vm._v(" "),_c('table',{staticClass:"ke-zeroborder",staticStyle:{"border-collapse":"collapse","width":"667.52pt"},attrs:{"border":"0","cellpadding":"0","cellspacing":"0","width":"1335","height":"1957"}},[_c('tbody',[_c('tr',[_c('td',{staticClass:"et3",attrs:{"height":"28","width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"249"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"157"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"178"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"223"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"108"}},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et3",attrs:{"width":"202"}},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et5",attrs:{"height":"60","width":"108"}},[_vm._v("\n\t\t\t\t\t序号\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et5",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t第三方公司名称\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et5",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t产品/类型\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et5",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t共享个人信息类型\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et5",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t使用目的\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et5",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t使用场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et5",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t共享方式\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et5",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\t第三方隐私政策链接\n\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"56","width":"108"}},[_vm._v("\n\t\t\t\t\t1\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et7",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t支付宝（杭州）信息技术有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et7",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t开户行查询\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et7",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t银行卡号\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et7",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t查询开户行信息\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et7",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t用户银行卡认证时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et7",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et7",attrs:{"width":"202"}},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"140","width":"108"}},[_vm._v("\n\t\t\t\t\t2\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t江西薪太软科技发展有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"157"}},[_vm._v("\n\t\t\t\t\t灵工任务签约\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"178"}},[_vm._v("\n\t\t\t\t\t姓名、身份证号码、手机号码\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\t领取第三方发布的灵工任务并进行签约\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"223"}},[_vm._v("\n\t\t\t\t\t用户领取灵工任务时，执行灵工任务时\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"108"}},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"202"}},[_vm._v("\n\t\t\t\t\t斜杠管家小程序\n\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"142","width":"108"}},[_vm._v("\n\t\t\t\t\t3\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海明酷市场营销服务有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et11"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"133","width":"108"}},[_vm._v("\n\t\t\t\t\t4\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海翰为市场营销策划有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"145","width":"108"}},[_vm._v("\n\t\t\t\t\t5\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海赢迪市场营销服务有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"136","width":"108"}},[_vm._v("\n\t\t\t\t\t6\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海明酷营销服务有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"120","width":"108"}},[_vm._v("\n\t\t\t\t\t7\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海明酷商务咨询有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"121","width":"108"}},[_vm._v("\n\t\t\t\t\t8\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海赢迪营销服务有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"154","width":"108"}},[_vm._v("\n\t\t\t\t\t9\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t若胜市场营销策划（上海）有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"126","width":"108"}},[_vm._v("\n\t\t\t\t\t10\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海呈智信息科技有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"148","width":"108"}},[_vm._v("\n\t\t\t\t\t11\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海若胜米咖信息技术有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"148","width":"108"}},[_vm._v("\n\t\t\t\t\t12\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t上海加诺普科技有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"148","width":"108"}},[_vm._v("\n\t\t\t\t\t13\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t北京普乐师科技有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"et6",attrs:{"height":"148","width":"108"}},[_vm._v("\n\t\t\t\t\t14\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et8",attrs:{"width":"249"}},[_vm._v("\n\t\t\t\t\t北京若胜科技有限公司\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t互联网/api\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t数据共享\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\t全场景\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_vm._v("\n\t\t\t\t\tapi\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"et10"},[_c('br')])])])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"小程序-服务协议","visible":_vm.authorizeDialog19,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog19=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("小程序-服务协议")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('h3',{staticStyle:{"text-align":"center"},attrs:{"align":"center"}},[_c('b',[_c('span',{staticStyle:{"font-family":"宋体","font-weight":"bold","font-size":"13.5000pt"}},[_c('span',[_vm._v("平台用户服务协议")])])]),_c('b',[_c('span',{staticStyle:{"font-family":"宋体","font-weight":"bold","font-size":"13.5000pt"}})])]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("欢迎您使用")])]),_c('span',{staticClass:"15",staticStyle:{"font-family":"宋体","font-size":"10.5000pt"}},[_c('span',[_vm._v("F")])]),_c('span',{staticClass:"15",staticStyle:{"font-family":"宋体","font-size":"10.5000pt"}},[_c('span',[_vm._v("ME")])]),_c('span',{staticClass:"15",staticStyle:{"font-family":"宋体","font-size":"10.5000pt"}},[_c('span',[_vm._v("S")])]),_c('span',{staticClass:"15",staticStyle:{"font-family":"宋体","font-size":"10.5000pt"}},[_c('span',[_vm._v("米享家")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("向您提供的各项服务！以下简称")]),_c('span',[_vm._v("“平台”       ")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("您在使用本平台所提供的服务前，应当仔细认真阅读本《平台用户服务协议》")]),_vm._v("(以下简称“本协议”)中的全部规则、及平台不时发布或更新的其他服务条款、专项产品或服务规则")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("（")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("以下合称")]),_c('span',[_vm._v("“服务规则”）的内容（特别是其中以黑体字标示出的关于平台及用户重大权益的规则，该等规则可能涉及相关方的责任免除或限制、法律适用与争议 解决条款，请您重点阅读），确认对本条款、《平台用户服务协议》 及各项服务规则均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。如您使用平台或以其他方式使用或接受平台的任何服务，即视为您已阅读并与平台达成协议，自愿接受本条款的所有内容的约束。所有服务规则视为本条款不可分割的一部分，与本条款具有同等法律效力。 本条款的签约双方为本平台的实际开发商上海若胜米咖信息技术有限公司及集团公司与使用平台服务的您（下称“您”），本条款是您与本平台之间关于您使用平台入驻服务商之间发布的任务服务所订立的服务条款， 具有正式书面合同的效力。 如本条款与《平台用户服务协议》文本内容存在冲突之处，则以时间上最新发布的内容为准，发布时间相同的，以本协议为准。本协议有待明确、存在歧义或未规定之处均以《平台用户服务协议》中的规定为准。 您理解并同意，平台将根据本条款及《平台用户服务协议》的规定及商业因素，对本协议条款或各项服务规则不时地进行修改更新。修改更新内容的发布和实施均适用《平台用户服务协议》的相关约定。变更后的协议和规则一经在平台公布后，立即自动生效。如您不同意相关变更，应当立即停止使用平台服务。您继续使用平台服务的，即表示您接受经修订的协议和规则。       ")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("一、")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("定义")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"margin-left":"0.0000pt","text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("1.1"),_c('span',[_vm._v(" ")])])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("平台任务：")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("指平台入驻方（以下简称第三方）提出的任务发布服务，并通过该平台展示")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("平台任务")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("、")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("任务")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("服务费")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("即")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("任务")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("确认")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("等信息的互联网技术平台。")]),_vm._v("   ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"margin-left":"0.0000pt","text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("1.2"),_c('span',[_vm._v(" ")])])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("信息服务：平台利用电脑、服务器、互联网、电话、移动设备等信息")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("通讯设备，向您展示订单，促成您与需求方达成服务合作。")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"margin-left":"0.0000pt","text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("1.3"),_c('span',[_vm._v(" ")])])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("任务订单：登记第三方具体需求信息任务的电子订单。您按照平台的要求提供的抢单、签约、激活订单等信息，全部信息作为一个整体构成一个订单。")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("二、")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("账号注册与使用")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("2.1 您知悉并同意")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("：")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("为使用")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("第三方服务，")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("您可")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("注册")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("新账号")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("或")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("登录")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("现有")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("账号，")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("同时")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("须")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("遵守")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("《")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("平台")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("用户服务")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("协议")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("》")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("的")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("规定")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("。")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("2.2 您确认，在您完成注册程序或以其他平台允许的方式实际使用平台服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且平台有权注销或永久冻结您的账号，并保留向您及您的监护人索偿的权利。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("2.3 您承诺向平台所提供的信息真实、准确、完整。平台有权要求您提供各项信息文件，并验证其真实性，当查验您提供的信息可能缺乏真实性、准确性时，平台有权进一步要求您提供其他证明文件或拒绝向您提供服务或拒绝您使用有关网站、服务、应用程序。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("2.4 您应是您注册账号的唯一授权使用人，可根据自己的需求使用，但不得以任何形式将账号转让或出借他人使用。未经平台授权同意，您也不得将账号相关的权利义务转让给他人。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("2.5 鉴于网络服务的特殊性，除您第三方使用平台服务时外，平台无义务审核是否是用户本人使用该账号，仅审核用户身份识别信息是否与数据库中保存的一致，所以即使用户认为账号登录行为并非用户本人所为，平台将不承担因此而产生的任何责任。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("三、服务规范")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.1 您在使用平台服务时，除了应当遵循诚实信用原则，遵守法律法规、所在服务单位的政策以及规章制度外，还应当遵守本协议")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("的各项规定。")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.2 平台根据您的服务状态向您提供第三方任务、订单信息等，您可自主选择是否处于服务状态。如您接受订单，您应按照订单需求为第三方提供服务，并遵守本条款约定的平台规则。您可通过下载并安装到移动设备上的平台提供的应用程序或其他方式选择并使用平台信息服务。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.3 本平台的运营权归普乐师（上海）数字科技有限公司所有。平台向您提供的是信息服务，而非通讯服务，您在使用平台提供的服务时，应具备可以安装平台相关应用程序的终端设备。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.4 您与平台合作为第三方提供服务的时间为订单成立且您准备提供服务的时间。在非合作期间，平台并不要求您继续为第三方提供服务。如因其他原因需要继续服务，则该服务行为属于您的个人行为与本平台无关。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.5 您注册和使用本平台过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等您所发送、回复或自动回复消息和相关链接页面，以及其他使用用户账号或本平台产生的内容均不得违反现行法律、法规、规章、政策规定；如果您在境外使用本平台，应同时遵守所在地或相关国家（地区）的法律法规。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6 您不得利用本平台制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容：       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.1 反对宪法所确定的基本原则的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.3 损害国家荣誉和利益的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.4 煽动民族仇恨、民族歧视，破坏民族团结的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.5 破坏国家宗教政策，宣扬邪教和封建迷信的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.6 散布谣言，扰乱社会秩序，破坏社会稳定的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.8 侮辱或者诽谤他人，侵害他人合法权益的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.6.9 含有法律、行政法规禁止的其他内容的信息。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.7 您不得利用本平台制作、上载、复制、发布、传播如下干扰平台正常运营，以及侵犯其他用户或第三方合法权益的内容：       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.7.1 含有任何性或性暗示的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.7.2 含有辱骂、恐吓、威胁内容的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.7.3 含有骚扰、垃圾广告、恶意信息、诱骗信息的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.7.4 涉及他人隐私、个人信息或资料的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.7.5 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.7.6 含有其他干扰本平台正常运营和侵犯其他用户或第三方合法权益内容的信息。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.8 您不得利用本平台进行如下行为：       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.8.1 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.8.2 虚构事实、隐瞒真相以误导、欺骗他人的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.8.3 利用技术手段批量建立虚假账号的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.8.4 利用本平台从事任何违法犯罪活动的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.8.5 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.8.6 其他违反法律法规规定、侵犯其他用户合法权益、干扰本平台正常运营或本平台未明示授权的行为。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.9 承诺与保证       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.9.1 除遵守本条款、《平台用户服务协议》及服务规则外，您应进一步保证您符合从事社会服务的相关标准，包括但不限于您满足服务地城市、相关法律法规规定的户籍或居住证等有关要求，无限制从业的相关疾病，并符合以下条件：       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.9.1.1 年龄：18-60周岁；普通话标准；无犯罪记录、无吸毒记录、无精神病史，未列入公安部门不良记录。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.9.1.2身体健康，外露皮肤无明显疤痕、纹身，无怪异发型(颜色），无传染性疾病；无下列可能影响服务的疾病：器质性心脏病；癫痫病；美尼尔氏症；眩晕症；癔病；震颤麻痹；精神病；痴呆以及影响肢体活动的神经系统疾病；妨碍安全服务疾病及传染性疾病（如：肺结核、腮腺炎等通过空气、飞沫传播的传染病）;长期服用依赖性精神药品成瘾尚未戒除的。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.9.2 如您未满足以上标准或要求，平台有权立即终止与您的合作。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.10 您在浏览、访问或使用平台产品及服务时可能以各种形式获取、知悉与平台或第三方有关的秘密信息（包括但不限于第三方信息、平台及其关联公司的运营或财务信息等）。为更好地保护您、第三方及我们的合法权益，您将严格遵守保密义务，不会在任何时间以任何方式窃取、泄露前述秘密信息。如果您发生本条款禁止行为，我们将会采取相应措施，包括但不限于中止或终止向您提供任何产品或服务、要求您承担损害赔偿责任；如果您的行为构成犯罪，将被追究相应的刑事责任。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.11 费用支付       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.11.1 平台有权制定相关费用结算标准并")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("实时")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("更新予以公示")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("，具体订单结算适用订单发生时")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("按照任务详情结算标准")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("。")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.11.2 如您使用第三方支付系统从服务单位处收取结算的费用，应由您自行开通第三方支付系统服务（包括但不限于")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("银行卡")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("、")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("微信支付、支付宝等）。您在使用第三方支付时，除了受到本条款的约束之外，还要受电子支付服务商")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("及信用卡")]),_vm._v("/借记卡发卡行的条款和政策的约束。平台不为第三方提供的服务承担责任。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.11.3 您可以随时通过平台查询订单情况，您应在每次服务完成后及时核对订单信息。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3.12 您在平台中或通过平台所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表本平台的观点、立场；您不得以平台的名义传送或发布信息；也不得以易被公众或第三方混淆为平台官方意见的方式传送或发布信息。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("四、风险承担")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("4.1 您在使用平台的过程中，将会涉及到第三方提供的地图及导航等服务，请您务必在确保安全的前提下使用上述服务，以防发生其他危险情况。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("4.2 平台向您提供信息技术服务，对于您给第三方提供的服务过程中产生的风险不承担责任，但法律法规另有强制性规定的除外。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("4.3 平台与您合作向第三方提供的服务，双方关系受《中华人民共和国民法典》等民事法律的约束。平台与您之间不构成任何直接或间接的劳动关系，不适用 《劳动法》《劳动合同法》《社会保险法》《住房公积金管理条例》等法律法规。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("五、对您信息的管理及限制")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("5.1 您知悉、理解并同意，在您使用平台时，您同意平台依据《平台隐私政策》的规定执行相关个人信息的收集、使用和共享。平台亦有权应政府部门（包括司法及行政部门）的要求，向其提供您的相关信息。此外，您知悉并认可：平台可能会与第三方合作而向您提供相关的功能，在此情况下，如该第三方同意承担与平台同等的保护您隐私的责任，则平台有权将您的相关资料等提供给该第三方。另外，在不透露您隐私资料的前提下，平台有权对与您账号相关的整个数据库进行分析并对相关的数据库进行商业上的利用。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("5.2 您被平台终止服务或账号被注销后，平台没有义务为您保留或向您披露账号中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("5.3 您同意，平台停止向您提供服务后，平台仍享有下列权利：       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("5.3.1 继续保存您未及时删除的信息及使用平台期间发布的所有信息至法律规定的记录保存期满。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("5.3.2 您在使用期间存在违法行为或违反本条款和/或服务规则的行为的，平台仍可依据本条款向您主张权利。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("六、知识产权")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("6.1 平台所展示的各运营系统由本平台自主开发、运营提供技术支持，并对平台服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。平台提供各项服务时所依托软件的著作权、专利权，所使用的各项商标、商业形象、商业标识、技术诀窍，其著作权、商标权及其他各项相关权利均归平台所有。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("6.2 您理解并同意：您在使用平台过程中所产生、上传的内容等所有信息的知识产权及所有权，适用《平台用户服务协议》中的相关约定。       七、责任限制声明       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.1 您确认，您在使用平台为平台第三方所提供的服务时，应当具备中华人民共和国法律规定的完全民事权利能力和民事行为能力。否则您及您的监护人应依照法律规定承担因此而导致的一切后果，在该等情形下，平台有权立即注销您的账号或停止向您提供服务，您应就由此给平台造成的所有损失予以赔偿。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.2 您应谨慎合理的保存、使用用户名和密码，并对通过您的账号和密码实施 的所有行为、活动及事件负全责。您若发现任何不当使用账号或存在安全漏洞等其他可能危及您账号安全的情况，应立即依照《平台用户服务协议》的相关规定采取措施并予以处理。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.3 由于您的过错给平台第三方或其他第三方造成侵权损害，应当由您承担相应的赔偿责任，对于由于您的过错造成的侵权损害或您因违约给平台造成的损失，平台有权向您追偿。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.4 如您在使用平台的过程中发现平台中的相关服务信息违反法律规定，您可及时向平台或有关机关举报或投诉，平台将在收到您的举报或投诉时采取相应的核实与处理措施。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.5 平台在为您提供服务时，可能会引入平台范围之外的第三方服务商提供的服务（第三方签约服务、支付服务、查询服务等）。您知悉、理解并同意，您使用平台号访问或使用第三方服务商提供的服务时将跳转至第三方服务商的独立平台。第三方服务商并非本平台，亦不通过本平台向您提供任何服务或达成任何交易。因此，本平台无法实质审核、控制第三方服务商及其所提供的具体服务或对第三方服务予以任何形式的担保或承诺。您应在访问或使 用第三方服务商的服务前应自行核实第三方服务商的身份、资质、服务内容等 相关信息，仔细约定第三方服务商的相关服务协议或规则，并自行选择是否进行本条款下的授权操作并使用本平台账号接受相关第三方服务商服务，本平台将不就您所接受的第三方服务商服务向您承担任何责任。您拟接受的第三方服务商服务将由该第三方服务商独立运营并独立承担全部责任。因该第三方服务所产生的纠纷，或第三方服务商违反相关法律法规或本条款约定，或您在使用第三方服务过程中遭受的损失，请您根据与第三方服务商所订立的相关服务协议等相应协议或规则，联系第三方服务商予以解决。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.6 对于来源于外部的风险，比如违法犯罪活动、交通事故等意外事件等造成的损失，由相关责任方承担，本平台将会积极协助相关部门进行处理。对于您在提供平台服务过程中发生的不可抗力事件，本平台将会在合理范围内进行协助解决。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.7 您同意并确认，本平台拥有独自决定拒绝向您提供服务的权利。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.8 您同意本平台拥有通过消息推送、平台公示、短信、电话、邮件等形式向您通知告知信息的权利。此外，您允许本平台依照《平台用户服务协议》及《平台隐私政策》的相关规定向您发送商业性电子信息或广告促销信息。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.9 您不得在本平台上发布不良违法信息以及与本平台提供服务无关的信息、或发布《平台用户服务协议》中规定的其他禁止用户发布的信息或从事其他违反《平台用户服务协议》规定的行为，否则本平台有权随时永久停止向您提供服务，由此产生的一切责任应由您自行承担。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("7.10 不论在何种情况下,本平台对由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("八、通知的发送")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("8.1 您同意本条款项下本平台对于您所有的通知（包括商品信息或商业性广告）均可通过网页公告、客户端推送消息、发送到用户注册的电子邮件、手机或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人，以上通知模式均具有同样的法律效力。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("8.2 您对于本平台的通知应当通过本平台对外正式公布的通信地址、传真 号码、电子邮件地址等联系信息进行送达。该等通知以本平台实际收到日为送达日。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("九、条款的终止")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("9.1 本平台有权终止向您提供服务，本条款于全部服务依法定程序及方式终止之日终止。 ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("9.2 本条款的终止不影响本平台其他主体依据本条款享有的各项权利的实现，也不影响守约方向违约方追究违约责任。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("十、争议解决")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("10.1 如您与本平台第三方服务发生任何争议，平台可在法律法规要求的范围内协助您与平台第三方之间争议的协商调解。您同意，本平台有权通过电话或电子邮件等方式向争议双方了解情况，并将所了解的情况通过必要方式通知对方。此外，您有权通过司法或执法机关要求本平台提供相关资料，但您理解并同意，本平台无任何义务对您与服务单位之间的任何争议承担任何责任。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("10.2 若您与平台因本条款内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向平台主体公司所在地上海市普陀区人民法院提起诉讼。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("10.3 因您使用本平台服务而引起或与之相关的一切争议、权利主张或其它事项，均适用中华人民共和国大陆地区法律，并且排除一切冲突法规定的适用。您在使用我公司应用程序并通过该应用程序接单或服务平台第三方，即视为您已充分理解并与平台服务商之间签署的服务条款。并在此前提下同意接受本条款中约定的平台规则及违规责任。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("一、如您存在下列违反平台规则的行为，应当按照本条款约定承担违规责任。违规责任包括违约金、暂停服务或解除合作。在您接到投诉的情况下，平台有权进行调查，调查期间将暂停对您的平台服务。")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("二、您在使用本平台服务时，不得有下列破坏平台规则，损害平台第三方、其他平台用户及平台利益的作弊行为。")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("1 利用虚假的账号，以获取奖励、订单、好评等为目的的作弊行为 （如：伪造账号接单、团伙刷单、模拟刷单、自己或串通他人伪造第三方账号以骗取平台奖励等）。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("2 安装使用对平台产生干扰的设备或第三方作弊软件的行为。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3 短时间内完成多个订单且订单金额不在正常交易范围内的订单/订单金额异常。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("4 其他作弊违规行为。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("三、")])]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("违反平台规则，应当承担以下违约责任。")]),_vm._v("       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"margin-left":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("1 平台判定您在服务过程中存在不规范操作行为（如：接单后不执行、爽约")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("、违约等）的，")]),_vm._v(" "),_c('span',[_vm._v("平台有权立即暂停该账号接单")]),_vm._v(" 24小时；不规范行为同时违反本条款第一条的，平台也有权按照第一条的规定，要求您承担违规责任。       ")]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"margin-left":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("2 违反本条款第二条规定的，平台有权暂停该账号一切活动，包括关于该")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal"},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("账号的费用结算。同一账号第一次被判定为作弊的，平台有权暂停该账号接单")]),_vm._v("3天，第二次被判定为作弊的，平台有权暂停该账号接单7天；第三次及以上被判定为作弊的，平台有权暂停该账号接单30天。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_vm._v("3 平台有权不结算作弊订单或收回已结算作弊订单的金额，并收取相当于作弊订单金额三倍的违约金。       ")]),_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}})]),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-indent":"21.0000pt"}},[_c('span',{staticStyle:{"font-family":"宋体","font-size":"12.0000pt"}},[_c('span',[_vm._v("四、您理解并同意，因您违反本协议约定或发生其它过错，导致或产生的任何第三方向平台或其合作方、关联方主张任何索赔、要求，如果造成平台或其合作方、关联方发生的任何损失，包括合理的律师费，您应当向平台与合作方、关联方承担赔偿责任。平台可以协助合作方、关联方向您主张权利。")])]),_c('span',{staticStyle:{"font-family":"Calibri","font-size":"10.5000pt"}})])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"小程序-人脸识别服务授权","visible":_vm.authorizeDialog20,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog20=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("小程序-人脸识别服务授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("人脸识别服务授权")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("      为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，您授权立白PLUS+收集、使用、保存您通过您的设备终端提供的人脸识别信息。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("        我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：立白PLUS+有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括与法律法规允许或政府机关授权的机构所保存的信息，或在本人提供的各人脸信息之间进行比对核验。）、验证、比对识别并向立白PLUS+反馈、输出验证结果，以便完成您的人脸识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("       我们努力在现有技术能力基础之上保障人脸识别服务正常运行，并将尽力来提升人脸识别验证的准确性。但是，由于采集人脸信息容易受到表情、妆容、环境光等多种不特定因素影响，而且能收集的信息范围相对有限，技术水平和认证手段也在不断升级改进之中，我们无法保证每次人脸识别均能验证成功。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("       我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("       您在进行人脸识别的过程中，所执行的操作均视为您同意立白PLUS+的人脸识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，立白PLUS+对您的操作信息不予保存。")]),_c('p',[_c('br')])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"小程序-身份信息识别服务授权","visible":_vm.authorizeDialog21,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog21=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("小程序-身份信息识别服务授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("身份信息识别服务授权")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("       为加强个人信息校验，保障您的账号权益，您将授权立白PLUS+采集、使用、保存您的姓名、身份证号、身份证有效期、身份证照片进行身份识别。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("        我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：立白PLUS+有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向立白PLUS+反馈、输出验证结果，以便完成您的身份信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("       我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("       您在进行身份信息识别的过程中，所执行的操作均视为您同意立白PLUS+的身份信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，立白PLUS+对您的操作信息不予保存。")]),_c('p',[_c('br')])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":"小程序-银行信息识别服务授权","visible":_vm.authorizeDialog22,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog22=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v("小程序-银行信息识别服务授权")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("银行信息识别服务授权")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("      为确保您的服务费结算真实有效，您将授权立白PLUS+收集、使用、保存您的银行卡信息，包含：持卡人姓名、银行卡号、开户行，银行卡照片。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("      我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：立白PLUS+有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向立白PLUS+反馈、输出验证结果，以便完成您的银行信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("       我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。")]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_c('br')]),_c('p',{staticStyle:{"margin-top":"0px","margin-bottom":"0px","text-rendering":"optimizelegibility","font-feature-settings":"\"kern\"","font-kerning":"normal"}},[_vm._v("      您在进行银行信息识别的过程中，所执行的操作均视为您同意立白PLUS+的银行信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，立白PLUS+对您的操作信息不予保存。")]),_c('p',[_c('br')])])])]),_vm._v(" "),_c('LogOut',{ref:"LogOut"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M3Rr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ab92946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("IsUY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ab92946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_questionnaire_vue__ = __webpack_require__("E4Zx");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a172401e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_questionnaire_vue__ = __webpack_require__("Udey");
function injectStyle (ssrContext) {
  __webpack_require__("Z9z7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a172401e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_questionnaire_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a172401e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_questionnaire_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Mn3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"拨号记录"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"200px","size":"mini"}},[_c('div',{staticClass:"slide-wrap",staticStyle:{"height":"auto"}},[_c('el-form-item',{attrs:{"label":"拨打人姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入所在拨打人姓名..."},model:{value:(_vm.param.callerName),callback:function ($$v) {_vm.$set(_vm.param, "callerName", $$v)},expression:"param.callerName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"拨打人账号"}},[_c('el-input',{attrs:{"placeholder":"请输入拨打人账号..."},model:{value:(_vm.param.callerAccount),callback:function ($$v) {_vm.$set(_vm.param, "callerAccount", $$v)},expression:"param.callerAccount"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"拨出页面"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择拨出页面..."},model:{value:(_vm.param.callPage),callback:function ($$v) {_vm.$set(_vm.param, "callPage", $$v)},expression:"param.callPage"}},_vm._l((_vm.chooseCallPage),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.name}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员姓名..."},model:{value:(_vm.param.salesmanName),callback:function ($$v) {_vm.$set(_vm.param, "salesmanName", $$v)},expression:"param.salesmanName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID..."},model:{value:(_vm.param.empPk),callback:function ($$v) {_vm.$set(_vm.param, "empPk", $$v)},expression:"param.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入项目编号..."},model:{value:(_vm.param.projectCode),callback:function ($$v) {_vm.$set(_vm.param, "projectCode", $$v)},expression:"param.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称..."},model:{value:(_vm.param.projectName),callback:function ($$v) {_vm.$set(_vm.param, "projectName", $$v)},expression:"param.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属部门"}},[_c('el-input',{attrs:{"placeholder":"请输入所属部门..."},model:{value:(_vm.param.projectDepartment),callback:function ($$v) {_vm.$set(_vm.param, "projectDepartment", $$v)},expression:"param.projectDepartment"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号码"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号码..."},model:{value:(_vm.param.salesmanTel),callback:function ($$v) {_vm.$set(_vm.param, "salesmanTel", $$v)},expression:"param.salesmanTel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"日期"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.param.callDateBegin),callback:function ($$v) {_vm.$set(_vm.param, "callDateBegin", $$v)},expression:"param.callDateBegin"}}),_vm._v(" -\n              "),_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.param.callDateEnd),callback:function ($$v) {_vm.$set(_vm.param, "callDateEnd", $$v)},expression:"param.callDateEnd"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.resetParams}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.searchData}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.exportData}},[_vm._v("导出")])],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.tableData}},[_c('el-table-column',{attrs:{"width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"callerName","label":"拨打人姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"callerAccount","label":"拨打人账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"callPage","label":"拨出页面","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"salesmanName","label":"促销员姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"empPk","label":"促销员id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"projectCode","label":"促销员所属项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"projectName","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"projectDepartment","label":"项目所属部门","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"salesmanTel","label":"促销员真实号码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"90","prop":"callDate","label":"拨打日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"90","prop":"callTime","label":"拨打时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"bellTime","label":"响铃时长（秒）","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"90","prop":"isResponse","label":"是否应答","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"90","prop":"talkTime","label":"通话时长","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"90","label":"通话录音","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.recode == '--')?_c('a',{staticClass:"buttonText"},[_vm._v("--")]):_c('a',{staticClass:"buttonText",attrs:{"href":scope.row.recode,"target":"_blank"}},[_vm._v("录音")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"unitPrice","label":"单价（元）","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"amount","label":"金额（元）","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_styles_index_scss__ = __webpack_require__("S0XV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_styles_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_global__ = __webpack_require__("kOl9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_js_cook__ = __webpack_require__("xxzE");

console.log('版本号：111158');
// 版本号：1800820 11.41
// import babelpolyfill from 'babel-polyfill'









//我觉得这个拦截器没用
// import interceptor from 'common/js/interceptor.js';

// 全局参数配置
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.globalParams = __WEBPACK_IMPORTED_MODULE_8__global_global__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
var vm = void 0;
// axios 拦截器--超时判断
var timeOut = 0;
//添加一个响应拦截器，在这里最优先对返回的数据进行处理
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.response.use(function (res) {
  //下面这行对应上面的请求拦截器，感觉没卵用
  return res;
}, function (error) {
  if (error.response.status == 403 /*|| error.response.status == 499*/) {
      //仅在最后一次err才提示，利用了timeOut的作用域，缺点是引入了全局变量
      timeOut++;
      var x = timeOut;
      setTimeout(function (x) {
        if (x == timeOut) {
          vm.$notify({
            title: '失败',
            message: error.response.data.message,
            type: 'error'
          });
          vm.$store.commit('changeLoginTimeOutTo', true); //登录超时的全局变量
          timeOut = 0;
        }
      }, 500, x);
      //这里没有return就会在此中断响应，err数据为空,但err状态是拦不住的,
      // 所以console里会报res.response.message不存在的错，在所有catch里先判断response是否存在再执行（但loading=false的语句可以放在判断外面）
    } else {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
});

__WEBPACK_IMPORTED_MODULE_3_router__["a" /* default */].beforeEach(function (to, from, next) {
  //NProgress.start();
  //新的登录方法，不好用的话就换成原来的
  var path = to.path.toLowerCase();
  var user = sessionStorage.getItem('usersPG') || sessionStorage.getItem('user');
  console.log('getCookie' + __WEBPACK_IMPORTED_MODULE_9_common_js_cook__["a" /* default */].getCookie('user'));
  //跳转促销员详情的时候，session会被清空
  if (path === '/salespersondetail' && __WEBPACK_IMPORTED_MODULE_9_common_js_cook__["a" /* default */].getCookie('user')) {
    user = __WEBPACK_IMPORTED_MODULE_9_common_js_cook__["a" /* default */].getCookie('user');
  }
  //180704最新的登录方法
  if (user) {
    //有账户登录，就给他随便跳页。这里不太安全，如果知道了别人的网址也可以访问
    next();
  } else {
    //没有账户登录，就让登录
    //path会自动变成小写，而switch会区分大小写，需要注意
    switch (path) {
      case '/login': //普乐师登录页
      case '/loginpg':
        //宝洁登录页
        next();
        break;
      case '/salespersondatashow':
        //宝洁的专有页面都跳到他自己的登陆
        next({ path: '/loginpg' });
        break;
      case '/jwtlogin':
        next();
        break;
      default:
        next({ path: '/login' });
    }
  }
});

//添加 Bus  进行传值
window.eventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
/* eslint-disable no-new */
vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_util__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js_cook__ = __webpack_require__("xxzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Login3_vue__ = __webpack_require__("YAws");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//  import { requestLogin } from '../api/api';
//import NProgress from 'nprogress'
var Url = __webpack_require__("e8qJ");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Login3: __WEBPACK_IMPORTED_MODULE_6__Login3_vue__["a" /* default */] },
  data: function data() {
    return {
      note: {
        backgroundImage: 'url(' + Url + ')',
        backgroundRepeat: "no-repeat",
        backgroundColor: '#1F2D3D',
        // height: "100vh",
        overflow: 'hidden',
        backgroundSize: '100% 100%'
      },
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: false,
      canNotLogin: 0, //已经由于上个账号未注销而无法登陆的次数
      show: false,
      queryParams: {},
      showLogin3: false
    };
  },

  methods: {
    handleSubmit2: function handleSubmit2(ev) {
      var _this = this;

      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          //this.$router.replace('/table');
          _this.logining = true;
          //NProgress.start();
          // var loginParams = {username: this.ruleForm2.account, password: this.ruleForm2.checkPass};
          // console.log(this.ruleForm2.account, this.ruleForm2.checkPass)
          _this.$http({
            method: "post",
            url: '/rest/auth/login',
            headers: { 'Content-type': 'application/x-authc-username-password+json' },
            data: {
              user: _this.ruleForm2.account,
              password: _this.ruleForm2.checkPass
            }
          }).then(function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(res) {
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      //因为后台不允许同一个客户端登录两个账号，所以如果登陆了一个账号这里就提示他需要先注销
                      //当前请求登录的账号和服务端返回的‘已经登录的账号’名称不匹配时，则判定是第二次登陆
                      if (res.data.loginName != _this.ruleForm2.account) {
                        if (_this.canNotLogin <= 1) {
                          _this.$alert('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆，本次登录无效', '提示', { type: 'error' });
                        } else {
                          //如果连续2次没进去，则允许强制退出
                          _this.$confirm('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆,  是否强制注销?', '提示', {
                            type: 'warning'
                          }).then(function () {
                            _this.$http.post('/rest/auth/logout').then(function (res) {
                              __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this, 'success', res, '注销成功'); //有时候提示该用户未登入，此时code是一串字母，但我们仍然提示注销成功
                              sessionStorage.clear();
                              setTimeout(function () {
                                location.reload(true);
                              }, 1000);
                            }).catch(function (err) {
                              __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this, 'warning', err.response, '注销失败');
                            });
                          }).catch(function () {});
                        }
                        _this.canNotLogin += 1;
                      } else {
                        //正常情况下直接登录
                        _this.checked ? localStorage.setItem("user", String(res.data.loginName)) : localStorage.clear();
                        //localstorage对应‘记住账号’，sessionstorage不论如何都存，仅在本标签页有效
                        sessionStorage.setItem("user", String(res.data.loginName));
                        sessionStorage.setItem("passwords", String(_this.ruleForm2.checkPass));
                        sessionStorage.setItem('nickname', String(res.data.nickname));
                        __WEBPACK_IMPORTED_MODULE_5__common_js_cook__["a" /* default */].setCookie('user', String(res.data.loginName), 7200);
                        //登录成功后获取权限
                        _this.$http({
                          method: "GET",
                          url: '/rest/sysUser/sysUserLogin',
                          params: {
                            account: _this.ruleForm2.account,
                            password: _this.ruleForm2.checkPass
                          }
                        }).then(function (res) {
                          //成功后自动跳转到第一个有权限的页面，缺点是顺序被后台控制
                          var webIdArr = [];
                          var pathArr = [];
                          var data = res.data;
                          var routes = _this.$router.options.routes;
                          data.webAuthLst.map(function (item) {
                            webIdArr.push(item.webId);
                          });
                          routes.map(function (item) {
                            item.children.map(function (item2) {
                              if (webIdArr.indexOf(item2.webId) > -1) {
                                pathArr.push(item2.path);
                              }
                            });
                          });
                          //这里其实可以优化，不等map结束，就可以跳转了，但也就几毫秒，无所谓
                          if (pathArr.length > 0) {
                            _this.$router.push({ path: pathArr[0] });
                          } else {
                            _this.$router.push({ path: '/noPermission' });
                          }
                          //获取登录人webid44的权限 给qhr页面权限使用
                          data.webAuthLst.forEach(function (item) {
                            if (item.webId == 44) {
                              sessionStorage.setItem("webId_44Auth", String(item.auth));
                            }
                          });
                          sessionStorage.setItem("account", String(res.data.sysUser.account));
                          sessionStorage.setItem("sysUserId", String(res.data.sysUser.id));
                          sessionStorage.setItem("empPk", String(res.data.sysUser.empPk));
                        }).catch(function (err) {
                          __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '获取用户权限信息失败，请稍后重试');
                        });
                      }

                      _this.logining = false;

                    case 2:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '登录失败');
            _this.logining = false;
          });
        }
      });
    },

    //校验是否是平台传过来的登录路径,无tenantCode传参非平台跳转直接渲染注册页,有tenantCode传参平台跳转
    //平台跳转 有用户名和密码->不渲染注册页面->直接登录  无用户名密码->渲染注册页面->登录成功后回调绑定接口
    checkPlatform: function checkPlatform() {
      var _this2 = this;

      console.log('登录路径', location.href, this.$route.query);
      //  const { tenantCode, account, password } = this.$route.query
      var _$route$query = this.$route.query,
          tenantCode = _$route$query.tenantCode,
          userId = _$route$query.userId,
          token = _$route$query.token,
          timeStamp = _$route$query.timeStamp;

      this.queryParams = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      // this.$router.replace('/login')
      if (tenantCode === undefined) {
        this.show = true;
      } else {
        if (userId !== 'null') {
          //根据userId, token, timeStamp获取账号密码
          this.$http({
            method: "get",
            url: '/rest/crmAccessFmes/searchByRebuild',
            params: {
              userId: userId,
              token: token,
              timeStamp: timeStamp
            }
          }).then(function (res) {
            if (res.data.account !== 'null' && res.data.password !== 'null') {
              _this2.ruleForm2.account = res.data.data.account;
              _this2.ruleForm2.checkPass = res.data.data.password;
              _this2.handleSubmit2();
            } else {
              _this2.showLogin3 = true;
              _this2.show = true;
            }
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败');
          });
        } else {
          this.showLogin3 = true;
          this.show = true;
        }
      }
    },
    bindAccount: function bindAccount() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var res;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this3.$http({
                    method: "post",
                    url: '/rest/crmAccessFmes/saveAccessFmesUser',
                    data: {
                      account: _this3.ruleForm2.account,
                      password: _this3.ruleForm2.checkPass,
                      tenantCode: _this3.queryParams.tenantCode
                    }
                  }).catch(function (err) {
                    __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this3, 'error', err.response, '绑定失败');
                  });

                case 2:
                  res = _context2.sent;

                  if (res.data.code === '0') {
                    resolve(true);
                  }

                case 4:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  mounted: function mounted() {
    document.title = '普乐师CRM';
    this.ruleForm2.account = localStorage.getItem('user') || '';
    this.checkPlatform();
  }
});

/***/ }),

/***/ "Nuj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"TiXiWrap"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"filterTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"masterName","label":"项目名称","align":"center"}}),_vm._v(" "),_vm._l((_vm.cols),function(item,index){return _c('el-table-column',{key:index,attrs:{"label":item.name,"width":"220","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.message),function(item2,index2){return (item2.masterId == scope.row.masterId && item2.scoreType == item.scoreType)?_c('div',{key:index2,staticClass:"isChecked",class:{pointer : _vm.isEdit},on:{"click":function($event){return _vm.changeState(scope.row.masterId,item2.scoreType,scope.row.masterName)}}},[_c('img',{attrs:{"src":__webpack_require__("SXjM"),"alt":""}}),_vm._v("\n            已选择\n          ")]):_vm._e()}),_vm._v(" "),_c('div',[(_vm.isEdit)?_c('div',{class:{pointer : _vm.isEdit},on:{"click":function($event){return _vm.changeState(scope.row.masterId,item.name,scope.row.masterName)}}},[_c('img',{attrs:{"src":__webpack_require__("i1bv"),"alt":""}}),_vm._v("\n              请选择\n            ")]):_vm._e()])]}}],null,true)})})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thisTitle"},[_c('span',{staticClass:"thisIcon"},[_c('img',{attrs:{"src":__webpack_require__("2f6u"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("体系")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OQY8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Od1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      signNameList: [{
        "id": 1,
        "signName": "长促销",
        "signType": 2,
        "pid": null,
        "signLevel": null,
        "signHot": null
      }, {
        "id": 2,
        "signName": "短促销",
        "signType": 2,
        "pid": null,
        "signLevel": null,
        "signHot": null
      }, {
        "id": 0,
        "signName": "不限",
        "signType": 2,
        "pid": null,
        "signLevel": null,
        "signHot": null
      }],
      configList: [],
      projectPricemonth: '',
      // 页面内权限
      auths: []
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getAuth();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.$http({
        method: "POST",
        url: '/rest/webCondition/findAllMaster'
      }).then(function (res) {
        _this.tableData = res.data;
        res.data.map(function (item) {
          if (item.id === 15) {
            _this.projectPricemonth = item.month;
          }
        });
      });

      this.$http({
        method: "POST",
        url: '/rest/webCondition/findCrmSingName'
      }).then(function (res) {
        // this.signNameList = res.data
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
      });

      this.$http({
        method: "POST",
        url: '/rest/webCondition/findCrmWebCondition'
      }).then(function (res) {
        _this.configList = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    getAuth: function getAuth() {
      var _this2 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 24,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          _this2.auths.push(item.auth);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    check: function check(handle, conditionId, postId, webId) {
      if (this.auths.indexOf(2) > -1) {
        if (handle === 'remove') {
          this.configList.forEach(function (item, index, arr) {
            if (item.conditionId === conditionId && item.postId === postId && item.webId === webId) {
              if (item.id == null) {
                arr.splice(index, 1);
              } else {
                item.postId = '';
              }
            }
          });
        } else if (handle === 'add') {
          this.configList.push({
            id: null,
            conditionId: conditionId,
            postId: postId,
            webId: webId
          });
        }
      }
    },
    save: function save() {
      var _this3 = this;

      this.configList.forEach(function (item) {
        item.projectPricemonth = _this3.projectPricemonth;
      });
      this.$http({
        method: "POST",
        url: '/rest/webCondition/saveCrmWebCondition',
        data: this.configList
      }).then(function (res) {
        _this3.getData();
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this3, 'success', '保存成功！');
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
      });
    }
  }
});

/***/ }),

/***/ "OgOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allCustomers: [],
      allCompany: [],
      allService: [], //服务商
      allSupplier: [], //落地方
      formData: {
        pageNo: 1,
        pageSize: 10,
        customer: null,
        company: null,
        serviceSupplier: null,
        serviceId: null,
        supplierId: null
      },
      tableData: [],
      total: null,
      listLoading: false,
      editId: null,
      editCustomer: null,
      showEditDialog: false,
      editSuffix: null,
      nextEditSuffix: null,
      editAuth: false,
      serviceSuppliers: []
    };
  },
  mounted: function mounted() {
    this.getEditCustomerConfigAuth();
    this.searchAllCustomer();
    this.searchAllCompany();
    this.getData();
    this.getServiceSuppliers();
    this.searchAllServiceSupplier('落地方');
    this.searchAllServiceSupplier('服务商');
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/customer/list',
        params: this.formData
      }).then(function (res) {
        _this.tableData = res.data.data.items;
        _this.total = res.data.data.totalItemsCount;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    searchAllCustomer: function searchAllCustomer() {
      var _this2 = this;

      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/all-customers'
      }).then(function (res) {
        _this2.allCustomers = res.data.data;
      }).catch(function (err) {});
    },
    searchAllCompany: function searchAllCompany() {
      var _this3 = this;

      this.$http({
        method: 'GET',
        url: '/rest/customer/company-list'
      }).then(function (res) {
        _this3.allCompany = res.data.data;
      }).catch(function (err) {});
    },
    searchAllServiceSupplier: function searchAllServiceSupplier(typeName) {
      var _this4 = this;

      this.$http({
        method: 'GET',
        url: '/rest/customer/service-supplier',
        params: {
          typeName: typeName
        }
      }).then(function (res) {
        if (typeName == '服务商') {
          _this4.allService = res.data.data;
        } else if (typeName == '落地方') {
          _this4.allSupplier = res.data.data;
        }
      }).catch(function (err) {});
    },
    submitForm: function submitForm() {
      this.formData.pageSize = 10;
      this.formData.pageNo = 1;
      this.getData();
    },
    exportExcel: function exportExcel() {
      var _this5 = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/customer/export',
        params: this.formData
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          _this5.listLoading = false;
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        } else {
          _this5.listLoading = false;
          _this5.$alert(res.data.message);
        }
      }).catch(function (error) {
        _this5.listLoading = false;
        _this5.$alert("导出错误，请联系管理员！");
      });
    },
    resetForm: function resetForm() {
      this.$refs['formData'].resetFields();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    openEditDialog: function openEditDialog(id, customer, suffix, nextSuffix) {
      this.editId = id;
      this.editCustomer = customer;
      this.showEditDialog = true;
      this.editSuffix = suffix;
      this.nextEditSuffix = nextSuffix;
    },
    editCustomerConfig: function editCustomerConfig() {
      var _this6 = this;

      this.$http({
        method: 'POST',
        url: '/rest/customer/edit',
        params: {
          id: this.editId,
          suffix: this.editSuffix,
          nextSuffix: this.nextEditSuffix
        }
      }).then(function (res) {
        _this6.showEditDialog = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "success", res, '操作成功');
        _this6.getData();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "error", res, '操作失败');
      });
    },
    getEditCustomerConfigAuth: function getEditCustomerConfigAuth() {
      var _this7 = this;

      this.$http({
        method: 'GET',
        url: '/rest/customer/edit-auth'
      }).then(function (res) {
        _this7.editAuth = res.data.data;
      }).catch(function (err) {});
    },
    getServiceSuppliers: function getServiceSuppliers() {
      var _this8 = this;

      this.$http({
        method: 'GET',
        url: '/rest/JiangYiJoint/getServiceSuppliers'

      }).then(function (res) {
        _this8.serviceSuppliers = res.data;
      }).catch(function (err) {});
    }
  }
});

/***/ }),

/***/ "Ojx6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userManger"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("用户管理")]),_vm._v(" "),_c('el-button',{staticClass:"el-icon-plus newUser",attrs:{"type":"primary","size":"mini","disabled":_vm.auths.indexOf(2) == -1},on:{"click":_vm.showNewUserDialog}},[_vm._v(" 创建用户")])],1),_vm._v(" "),_c('div',{staticClass:"common-search"},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"70px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":5},model:{value:(_vm.formData.nickName),callback:function ($$v) {_vm.$set(_vm.formData, "nickName", $$v)},expression:"formData.nickName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号码...","maxlength":11},model:{value:(_vm.formData.tel),callback:function ($$v) {_vm.$set(_vm.formData, "tel", $$v)},expression:"formData.tel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"人员编码"}},[_c('el-input',{attrs:{"placeholder":"请输入人员编码...","maxlength":100},model:{value:(_vm.formData.empCode),callback:function ($$v) {_vm.$set(_vm.formData, "empCode", $$v)},expression:"formData.empCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"角色"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.formData.roleId),callback:function ($$v) {_vm.$set(_vm.formData, "roleId", $$v)},expression:"formData.roleId"}},[_c('el-option',{attrs:{"label":"不限","value":""}}),_vm._v(" "),_vm._l((_vm.roleList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.roleName,"value":item.id}})})],2)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"vertical-align":"bottom"}},[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.getData(true)}}},[_vm._v("筛选")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"table",staticClass:"table-expand",attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sysUser.nickName","label":"姓名","width":"145","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sysUser.empCode","label":"人员编码","width":"145","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sysUser.tel","label":"手机号","width":"182","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sysUser.mail","label":"邮箱","width":"290","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sysUser.account","label":"用户名","width":"185","align":"center"}}),_vm._v(" "),(_vm.isAdmin)?_c('el-table-column',{attrs:{"prop":"sysUser.password","label":"密码","width":"120","align":"center"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sysRole.roleName","label":"角色","width":"290","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"项目","width":"130","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.projectCount))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"地区","width":"130","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(_vm.returnProjectCount(props.row.sysUserDivCount))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleEdit(scope.row, 'view')}}},[_vm._v("查看详情")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.auths.indexOf(2) == -1},on:{"click":function($event){return _vm.handleEdit(scope.row, 'edit')}}},[_vm._v("编辑")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.auths.indexOf(2) == -1},on:{"click":function($event){return _vm.handleDelete(scope.$index, scope.row)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"创建用户","visible":_vm.createNewUserModal,"center":true,"show-close":false,"width":"860px","top":"24vh"},on:{"close":_vm.createNewUserCancel,"update:visible":function($event){_vm.createNewUserModal=$event}}},[_c('el-form',{ref:"newUserForm",staticClass:"formInline",attrs:{"inline":true,"size":"mini","model":_vm.tableForm,"label-width":"80px","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":"人员编码","prop":"empCode"}},[_c('el-input',{attrs:{"placeholder":"请输入员工编码..."},model:{value:(_vm.tableForm.empCode),callback:function ($$v) {_vm.$set(_vm.tableForm, "empCode", $$v)},expression:"tableForm.empCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名","prop":"nickName"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":60},model:{value:(_vm.tableForm.nickName),callback:function ($$v) {_vm.$set(_vm.tableForm, "nickName", $$v)},expression:"tableForm.nickName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号","prop":"tel"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号码...","maxlength":11},model:{value:(_vm.tableForm.tel),callback:function ($$v) {_vm.$set(_vm.tableForm, "tel", _vm._n($$v))},expression:"tableForm.tel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"邮箱","prop":"mail"}},[_c('el-input',{attrs:{"placeholder":"请输入邮箱..."},model:{value:(_vm.tableForm.mail),callback:function ($$v) {_vm.$set(_vm.tableForm, "mail", $$v)},expression:"tableForm.mail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号..."},model:{value:(_vm.tableForm.idCard),callback:function ($$v) {_vm.$set(_vm.tableForm, "idCard", $$v)},expression:"tableForm.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户名","prop":"account"}},[_c('el-input',{attrs:{"placeholder":"请输入用户名...","minlength":6,"maxlength":16},model:{value:(_vm.tableForm.account),callback:function ($$v) {_vm.$set(_vm.tableForm, "account", $$v)},expression:"tableForm.account"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"密码","prop":"loginPassword"}},[_c('el-input',{attrs:{"placeholder":"请输入密码...","minlength":6,"maxlength":16},model:{value:(_vm.tableForm.loginPassword),callback:function ($$v) {_vm.$set(_vm.tableForm, "loginPassword", $$v)},expression:"tableForm.loginPassword"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"display":"block"},attrs:{"label":"角色"}},[(_vm.tableForm.roleName)?_c('el-tag',{staticClass:"createEditTag"},[_vm._v("\n          "+_vm._s(_vm.tableForm.roleName)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.tableForm.roleName == '')?_c('el-button',{staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewRoleModal}},[_c('i',{staticClass:" el-icon-plus"}),_vm._v("\n          增加\n        ")]):_c('el-button',{staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewRoleModal}},[_vm._v("修改")])],1),_vm._v(" "),_c('el-form-item',{staticClass:"wid90",staticStyle:{"display":"block"},attrs:{"label":"地区"}},[_vm._l((_vm.tableForm.regionLst),function(province,pIndex){return _c('span',{key:pIndex},_vm._l((province.cityLst),function(item,index){return _c('el-tag',{key:index,staticClass:"createEditTag"},[_vm._v("\n            "+_vm._s(item)+"\n          ")])}),1)}),_vm._v(" "),(_vm.tableForm.regionLst.length === 0)?_c('el-button',{staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewAreaModal}},[_c('i',{staticClass:" el-icon-plus"}),_vm._v("\n          增加\n        ")]):_c('el-button',{staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewAreaModal}},[_vm._v("修改")])],2),_vm._v(" "),_c('el-form-item',{staticClass:"wid90",staticStyle:{"display":"block"},attrs:{"label":"项目"}},[_vm._l((_vm.tableForm.projectLst),function(item,index){return _c('el-tag',{key:index,staticClass:"createEditTag"},[_vm._v("\n          "+_vm._s(item.projectName)+"\n        ")])}),_vm._v(" "),(_vm.tableForm.projectLst.length === 0)?_c('el-button',{staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewProjectModal}},[_c('i',{staticClass:" el-icon-plus"}),_vm._v("\n          增加\n        ")]):_c('el-button',{staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewProjectModal}},[_vm._v("修改")])],2)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"roleCancelBtn",on:{"click":_vm.createNewUserCancel}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"roleDefineBtn",attrs:{"loading":_vm.creatACKButtonLoading},on:{"click":_vm.createNewUserSave}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"角色","visible":_vm.createNewRoleModal,"center":true,"show-close":false,"width":"780px"},on:{"update:visible":function($event){_vm.createNewRoleModal=$event}}},[_c('div',{staticClass:"common-search",staticStyle:{"margin-bottom":"10px"}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":"角色名称"}},[_c('el-input',{staticStyle:{"width":"200px","margin-right":"10px"},attrs:{"placeholder":"请输入角色名称进行模糊搜索"},model:{value:(_vm.searchRole.sysRoleName),callback:function ($$v) {_vm.$set(_vm.searchRole, "sysRoleName", $$v)},expression:"searchRole.sysRoleName"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"vertical-align":"bottom"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.handleSearchRole}},[_vm._v("筛选")])],1),_vm._v(" "),_c('el-form-item',{staticClass:"floatr",staticStyle:{"vertical-align":"bottom"}},[_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedRoleId),expression:"checkedRoleId"}],staticClass:"roleEditTag"},[_vm._v("\n            "+_vm._s(_vm.checkedRoleName)+"\n            "),_c('i',{staticClass:"el-icon-circle-close-outline roleRightTag",on:{"click":_vm.removeShowRoleTag}})])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body",staticStyle:{"background-color":"#f4f4f4"}},[_c('div',{staticStyle:{"padding":"15px 20px","max-height":"350px","overflow-y":"auto"}},_vm._l((_vm.roleData),function(item,index){return _c('el-button',{key:index,staticClass:"unCreateRoleTag",class:{createRoleTag:item.id === _vm.checkedRoleId,marginL10:index == 0},on:{"click":function($event){return _vm.addRoleTag(item)}}},[_vm._v("\n          "+_vm._s(item.roleName)+"\n        ")])}),1)]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"roleCancelBtn",on:{"click":function($event){_vm.createNewRoleModal = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"roleDefineBtn",on:{"click":_vm.createNewRoleSave}},[_vm._v("确定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"地区","visible":_vm.createNewAreaModal,"center":true,"show-close":false,"width":"780px"},on:{"update:visible":function($event){_vm.createNewAreaModal=$event}}},[_c('el-form',{attrs:{"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":"城市"}},[_c('div',{staticStyle:{"width":"670px"}},_vm._l((_vm.checkedRegionLst),function(province,pIndex){return _c('span',{key:pIndex},_vm._l((province.cityLst),function(city,cIndex){return _c('el-tag',{key:cIndex,staticClass:"areaTag"},[_vm._v("\n              "+_vm._s(city || '不限')+"\n              "),_c('i',{staticClass:"el-icon-circle-close-outline areaIcon",on:{"click":function($event){return _vm.cancelCity(pIndex, cIndex)}}})])}),1)}),0)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省份"}},[_c('div',{staticStyle:{"width":"670px"}},_vm._l((_vm.checkedRegionLst),function(province,pIndex){return (province.cityLst.length != 0)?_c('el-tag',{key:pIndex,staticClass:"areaTag"},[_vm._v("\n            "+_vm._s(province.province == 'countrywide' ? '不限':province.province)+"\n            "),_c('i',{staticClass:"el-icon-circle-close-outline areaIcon",on:{"click":function($event){return _vm.cancelProvince(pIndex)}}})]):_vm._e()}),1)]),_vm._v(" "),_c('div',{staticClass:"common-box-body",staticStyle:{"background-color":"#f4f4f4"}},[_c('div',{staticClass:"userArea",staticStyle:{"margin":"0 20px","padding":"15px 0"}},[_c('span',{staticStyle:{"margin-right":"20px"}},[_c('img',{staticStyle:{"width":"18px","height":"18px","margin":"-3px 7px 0 0"},attrs:{"src":__webpack_require__("QV+x"),"alt":""}}),_vm._v("热门城市")]),_vm._v(" "),_vm._l((_vm.popularCity),function(item,index){return _c('el-button',{key:index,staticClass:"unPopularCityTag",class:{popularCityTag:item.show},on:{"click":function($event){return _vm.areaSelectedSave(item.province, item.city)}}},[_vm._v("\n            "+_vm._s(item.city)+"\n          ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"common-box-body",staticStyle:{"background-color":"#f4f4f4"}},[_c('div',{staticClass:"userAreaModal",staticStyle:{"margin":"0 20px","padding":"15px 0"}},[_c('span',{staticStyle:{"margin-right":"20px"}},[_c('i',{staticClass:"el-icon-location-outline",staticStyle:{"margin-right":"10px","color":"#f69c60"}}),_vm._v("其他城市")]),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v("省")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"请选择省份...","value-key":"id","filterable":""},on:{"change":_vm.getCities},model:{value:(_vm.province),callback:function ($$v) {_vm.province=$$v},expression:"province"}},_vm._l((_vm.provinceInfo),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.adName,"value":item}})}),1),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"28px","margin-right":"10px"}},[_vm._v("市")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"请选择城市...","value-key":"id","filterable":""},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}},_vm._l((_vm.cityInfo),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.adName,"value":item}})}),1),_vm._v(" "),_c('el-button',{staticClass:"areaModalSelectSave",attrs:{"size":"mini"},on:{"click":function($event){return _vm.areaSelectedSave(_vm.province ? _vm.province.adName : '', _vm.city ? _vm.city.adName: '')}}},[_vm._v("确认选择\n          ")])],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"roleCancelBtn",on:{"click":function($event){_vm.createNewAreaModal = false;}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"roleDefineBtn",on:{"click":_vm.createNewAreaSave}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"项目","visible":_vm.createNewProjectModal,"center":true,"show-close":false,"width":"1000px"},on:{"update:visible":function($event){_vm.createNewProjectModal=$event}}},[_c('el-form',{attrs:{"inline":true,"size":"mini"}},_vm._l((_vm.checkedPrjLst),function(item,index){return _c('el-tag',{key:index,staticClass:"projectTag"},[_vm._v("\n        "+_vm._s(item.projectName)+"\n        "),_c('i',{staticClass:"el-icon-error areaIcon",on:{"click":function($event){return _vm.removeProject(item, index)}}})])}),1),_vm._v(" "),_c('div',{staticClass:"common-search",staticStyle:{"margin-bottom":"10px"}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{staticStyle:{"width":"180px","margin-right":"10px"},attrs:{"placeholder":"请输入..."},model:{value:(_vm.projectInfo.projectCode),callback:function ($$v) {_vm.$set(_vm.projectInfo, "projectCode", $$v)},expression:"projectInfo.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{staticStyle:{"width":"180px","margin-right":"10px"},attrs:{"placeholder":"请输入..."},model:{value:(_vm.projectInfo.projectName),callback:function ($$v) {_vm.$set(_vm.projectInfo, "projectName", $$v)},expression:"projectInfo.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称"}},[_c('el-input',{staticStyle:{"width":"180px","margin-right":"10px"},attrs:{"placeholder":"请输入..."},model:{value:(_vm.projectInfo.customer),callback:function ($$v) {_vm.$set(_vm.projectInfo, "customer", $$v)},expression:"projectInfo.customer"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.searchProject}},[_vm._v("筛选")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#f4f4f4","padding":"10px"}},[_c('el-checkbox',{staticClass:"usermangerCheck",on:{"change":_vm.selectAllProject},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("\n        全选项目"),(_vm.checked && _vm.projectRealTotal)?_c('span',[_vm._v("："+_vm._s(_vm.projectRealTotal)+"条")]):_vm._e()]),_vm._v(" "),(!_vm.checked)?_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.getProjectDataLoading),expression:"getProjectDataLoading"}],ref:"projectTable",staticClass:"userProjectTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.projectTableData,"tooltip-effect":"dark","size":"small","border":"","header-row-class-name":"table-header"},on:{"select":_vm.changeProject,"select-all":_vm.selectAllChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"50","align":"center","label":"全选"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectCode","label":"项目编号","width":"200","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名称","align":"center","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"开始时间","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":"结束时间","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"客户名称","width":"120","align":"center"}})],1):_vm._e(),_vm._v(" "),(!_vm.checked)?_c('el-pagination',{staticClass:"pagination",attrs:{"current-page":_vm.projectInfo.pageNo,"layout":"slot, total, prev, pager, next, jumper","total":_vm.projectTotal},on:{"current-change":_vm.projectHandleCurrentChange}}):_vm._e(),_vm._v(" "),(_vm.checked)?_c('img',{staticStyle:{"display":"block","margin":"0 auto","margin-top":"100px","margin-bottom":"100px"},attrs:{"src":__webpack_require__("pXci"),"alt":""}}):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"roleCancelBtn",on:{"click":function($event){_vm.createNewProjectModal = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"roleDefineBtn",on:{"click":_vm.createNewProjectSave}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":_vm.title,"visible":_vm.editRowDialog,"width":"860px","center":true,"show-close":false},on:{"update:visible":function($event){_vm.editRowDialog=$event},"close":_vm.editUserCancel}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dialogLoading),expression:"dialogLoading"}],ref:"tableForm",staticClass:"formInline",attrs:{"model":_vm.tableForm,"inline":true,"size":"mini","rules":_vm.rules,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"人员编码","prop":"empCode"}},[_c('el-input',{attrs:{"placeholder":"请输入员工编码...","disabled":!_vm.isEdit,"maxlength":30},model:{value:(_vm.tableForm.empCode),callback:function ($$v) {_vm.$set(_vm.tableForm, "empCode", $$v)},expression:"tableForm.empCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名","prop":"nickName"}},[_c('el-input',{attrs:{"placeholder":"请输入角色名称...","disabled":!_vm.isEdit,"maxlength":60},model:{value:(_vm.tableForm.nickName),callback:function ($$v) {_vm.$set(_vm.tableForm, "nickName", $$v)},expression:"tableForm.nickName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号","prop":"tel"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号码...","disabled":!_vm.isEdit,"maxlength":11},model:{value:(_vm.tableForm.tel),callback:function ($$v) {_vm.$set(_vm.tableForm, "tel", $$v)},expression:"tableForm.tel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"邮箱","prop":"mail"}},[_c('el-input',{attrs:{"placeholder":"请输入邮箱...","disabled":!_vm.isEdit,"maxlength":30},model:{value:(_vm.tableForm.mail),callback:function ($$v) {_vm.$set(_vm.tableForm, "mail", $$v)},expression:"tableForm.mail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号...","disabled":!_vm.isEdit,"maxlength":30},model:{value:(_vm.tableForm.idCard),callback:function ($$v) {_vm.$set(_vm.tableForm, "idCard", $$v)},expression:"tableForm.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户名","prop":"account"}},[_c('el-input',{attrs:{"placeholder":"请输入用户名...","disabled":!_vm.isEdit,"minlength":6,"maxlength":16},model:{value:(_vm.tableForm.account),callback:function ($$v) {_vm.$set(_vm.tableForm, "account", $$v)},expression:"tableForm.account"}})],1),_vm._v(" "),(_vm.isAdmin)?_c('el-form-item',{attrs:{"label":"密码","prop":"loginPassword"}},[_c('el-input',{attrs:{"placeholder":"请输入密码...","disabled":!_vm.isEdit,"minlength":6,"maxlength":16},model:{value:(_vm.tableForm.loginPassword),callback:function ($$v) {_vm.$set(_vm.tableForm, "loginPassword", $$v)},expression:"tableForm.loginPassword"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{staticStyle:{"display":"block"},attrs:{"label":"角色"}},[(_vm.tableForm.roleId)?_c('el-tag',{staticClass:"createEditTag"},[_vm._v("\n          "+_vm._s(_vm.tableForm.roleName)+"\n        ")]):_vm._e(),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewRoleModal}},[_vm._v("修改")])],1),_vm._v(" "),_c('el-form-item',{staticClass:"wid90",staticStyle:{"display":"block"},attrs:{"label":"地区"}},[_vm._l((_vm.tableForm.regionLst),function(province,pIndex){return _c('span',{key:pIndex},_vm._l((province.cityLst),function(item,index){return _c('el-tag',{key:index,staticClass:"createEditTag"},[_vm._v("\n            "+_vm._s(_vm.returnCity(item,province))+"\n          ")])}),1)}),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewAreaModal}},[_vm._v("修改")])],2),_vm._v(" "),_c('el-form-item',{staticClass:"wid90",staticStyle:{"display":"block"},attrs:{"label":"项目","size":"mini"}},[_c('div',[_vm._l((_vm.tableForm.projectLst),function(item,index){return _c('el-tag',{key:index,staticClass:"createEditTag"},[_vm._v("\n            "+_vm._s(item.projectName)+"\n          ")])}),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],staticClass:"roleBtn",attrs:{"round":""},on:{"click":_vm.openCreateNewProjectModal}},[_vm._v("修改")])],2)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"rowCancel",attrs:{"size":"mini"},on:{"click":_vm.editUserCancel}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],staticClass:"rowSave",attrs:{"size":"mini","loading":_vm.editACKButtonLoading},on:{"click":function($event){return _vm.rowHandleSave()}}},[_vm._v("\n        确定\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OoVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("导入结果")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":_vm.auths.indexOf(2) < 0,"round":""},on:{"click":_vm.downloadTmp}},[_vm._v("下载模板")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":_vm.auths.indexOf(2) < 0,"round":""},on:{"click":function($event){_vm.uploadDialog=true}}},[_vm._v("上传数据")])],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectCode","label":"项目编号","align":"center","min-width":"155"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名","align":"center","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"项目时间","width":"160","align":"center","formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idCard","label":"身份证","width":"160","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trainScore","label":"培训得分","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customerScore","label":"客户评分","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customerStar","label":"客户星级","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectScore","label":"项目组评分","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"jobRate","label":"活动在岗率","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"jobScore","label":"活动在岗成绩","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salesVolume","label":"实际销量","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createTime","label":"创建时间","align":"center","formatter":_vm.formatDate}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"上传评分数据","visible":_vm.uploadDialog,"width":"500px","center":""},on:{"update:visible":function($event){_vm.uploadDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('el-upload',{attrs:{"action":"/rest/upDownload/importScore","before-upload":_vm.handlePreview,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传excel文件")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){_vm.uploadDialog = false}}},[_vm._v("关 闭")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Or9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tomd_vue__ = __webpack_require__("lgp0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a36e1ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tomd_vue__ = __webpack_require__("pn+i");
function injectStyle (ssrContext) {
  __webpack_require__("baD+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a36e1ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tomd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a36e1ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tomd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PDS/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PUCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterTag_vue__ = __webpack_require__("7qqA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f7ff9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterTag_vue__ = __webpack_require__("8W/m");
function injectStyle (ssrContext) {
  __webpack_require__("Qzj4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f7ff9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PWqT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.$router.back();
  }
});

/***/ }),

/***/ "PZAf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"JiFenWrap"},[_c('el-table',{staticClass:"filterTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.scoreArr,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"masterName","label":"指标","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分值设定","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isEdit)?_c('div',[_vm._v(_vm._s(scope.row.score))]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticClass:"form myForm"},[_c('el-form',{ref:"scoreArr",staticClass:"demo-ruleForm",attrs:{"model":scope.row,"rules":_vm.rules,"label-width":"100px"}},[_c('el-form-item',{attrs:{"prop":"score"}},[_c('el-input',{attrs:{"auto-complete":"on","maxlength":4},model:{value:(scope.row.score),callback:function ($$v) {_vm.$set(scope.row, "score", _vm._n($$v))},expression:"scope.row.score"}})],1)],1)],1):_vm._e()]}}])})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thisTitle"},[_c('span',{staticClass:"thisIcon"},[_c('img',{attrs:{"src":__webpack_require__("fsa8"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("积分")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QCU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_salespersonInfo__ = __webpack_require__("iepA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_formRules__ = __webpack_require__("8jay");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "task-audit",
  components: {
    SalespersonInfo: __WEBPACK_IMPORTED_MODULE_0_components_salespersonInfo__["a" /* default */]
  },
  data: function data() {
    return {
      //筛选项参数
      param: {
        taskNo: '', //任务编号
        taskName: '', //任务名称
        idCard: '', //身份证号
        state: '', //任务状态
        salesManName: '', //促销员姓名
        during: { //任务参与时间
          start: '',
          end: ""
        },
        pageNo: 1, //数据页码总数信息
        pageSize: 10 //当前页展示的信息条数
      },
      starLevelList: [], //获取到的星级列表
      signIdLst: [], //存储tag组件返回的选择的品类
      provinceList: [], //存储省-列表数据
      cityList: [], //存储获取到城市列表
      tableData: [], //展示的表格数据
      isAdmin: false, //是否是超级管理员进入
      total: null, //总数
      uploadDialog: false, //是否展示上传对话框
      listLoading: false, //列表的loading
      loading: false, //全局loading
      rules: { idCard: __WEBPACK_IMPORTED_MODULE_2__common_js_formRules__["a" /* default */].idcard //表单校验规则
      } };
  },
  mounted: function mounted() {
    //获取省市列表数据
    this.searchProvince();
    //判断是否是超级管理员
    //这里好像用不到
    var x = sessionStorage.getItem('user');
    this.isAdmin = Boolean(x == 'admin1' || x == 'tinashi');
    //获取数据
    this.getData();
  },

  methods: {
    //展开收起
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight == 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },

    //搜索省市
    searchProvince: function searchProvince(id) {
      var _this = this;

      this.$http({
        method: "POST",
        url: "/rest/salesman/getRegion",
        params: {
          deep: 1,
          regionId: id
        }
      }).then(function (res) {
        _this.provinceList = res.data;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询省市数据失败，请稍后重试';
        }
        _this.$notify({
          title: '错误',
          message: errMsg,
          type: 'warning'
        });
      });
    },


    //清空筛选项
    resetForm: function resetForm() {
      this.param.projectNo = null;
      this.param.projectName = null;
      this.param.brand = null;
      this.param.province = '';
      this.param.city = '';
      this.param.idCard = null;
      this.param.rank = '';
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      //是否要加上是否是市辖区的逻辑？如果是则city为市辖区
      this.getData();
    },

    //获取筛选数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      //获取table数据
      this.$http({
        method: "get",
        url: "/rest/BaoJieCr/searchBaoJieCr",
        params: this.param
      }).then(function (res) {
        _this2.tableData = res.data;
        _this2.listLoading = false;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询失败，请稍后重试';
        }
        _this2.$notify({
          title: '错误',
          message: errMsg,
          type: 'warning'
        });
        _this2.listLoading = false;
      });
      //获取页码数据
      this.$http({
        method: "get",
        url: "/rest/BaoJieCr/searchBaoJieCrSize",
        params: this.param
      }).then(function (res) {
        _this2.total = res.data;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '查询失败，请稍后重试';
        }
        _this2.$notify({
          title: '错误',
          message: errMsg,
          type: 'warning'
        });
      });
    },

    //获取城市列表
    searchCity: function searchCity() {
      var _this3 = this;

      var id = null;
      this.param.cityId = null;
      this.provinceList.map(function (item) {
        if (_this3.param.province == item.adName) {
          id = item.id;
        }
      });
      if (id != null) {
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 2,
            regionId: id
          }
        }).then(function (res) {
          _this3.cityList = res.data;
        }).catch(function (err) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = '查询失败，请稍后重试';
          }
          _this3.$notify({
            title: '错误',
            message: errMsg,
            type: 'warning'
          });
        });
      }
    },

    //对于非超级管理员，需要把数据加密
    //身份证加密
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (this.isAdmin) {
        return cellValue;
      } else {
        if (cellValue.length == 15) {
          return __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].plusXing(cellValue, 7, 4);
        } else if (cellValue.length == 18) {
          return __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
        } else {
          console.log('身份证位数不对', cellValue);
        }
      }
    },

    //姓名加密
    formatName: function formatName(row, column, cellValue) {
      if (cellValue) {
        if (this.isAdmin) {
          return cellValue;
        } else {
          return __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].plusXing(cellValue, 1, 1);
        }
      }
    },

    //数字转百分比
    formatPercent: function formatPercent(row, column, cellValue) {
      var x = 0;
      if (cellValue != 0) {
        x = parseFloat((cellValue * 100).toFixed(2)) + '%';
      }
      return x;
    },

    //每页的显示条目改变时
    handleSizeChange: function handleSizeChange(val) {
      this.param.pageSize = val;
      this.getData();
    },

    //手动选择页码时
    handleCurrentChange: function handleCurrentChange(val) {
      this.param.pageNo = val;
      this.getData();
    },

    //导出表格
    getExcel: function getExcel() {
      var _this4 = this;

      this.loading = true; //进入全局loading
      this.$http({
        method: "GET",
        url: "/rest/BaoJieCr/downLoadBaoJieCr",
        params: this.param
      }).then(function (res) {
        _this4.loading = false;
        location.href = __WEBPACK_IMPORTED_MODULE_1__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = '下载失败，请稍后重试';
        }
        _this4.$notify({
          title: '失败',
          message: errMsg,
          type: 'error'
        });
        _this4.loading = false;
      });
    },

    //任务详情
    taskDetail: function taskDetail(row) {
      alert('任务详情');
      console.log(row);
    },

    //审核通过
    pass: function pass(row) {
      alert('审核通过');
    },

    //审核不通过
    notPass: function notPass(row) {
      alert('审核不通过');
    }
  }
});

/***/ }),

/***/ "QV+x":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "QsHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customerProject_Project_vue__ = __webpack_require__("qIXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Project: __WEBPACK_IMPORTED_MODULE_3__customerProject_Project_vue__["a" /* default */] },
  watch: {},
  data: function data() {
    return {
      //筛选项参数
      param: {},
      param2: {}, //点击筛选之后param才赋值给param2
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      zhangTaoList: [], //账套数组
      allClientId: [], //合同下拉列表数组
      allCustomer: [], //项目客户下拉
      keepAllCustomer: [], //项目客户下拉 存储
      customer: false, //客户维护模态框
      customerValue: "", ///客户维护模态框 内的值
      disabledSubCustomer: true, //禁用提交按钮
      handleItem: {}, //当前操作对象
      tableData: [], //表单信息
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getAllClientId();
    this.getAllCustomer();
  },

  methods: {
    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.param2, {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      });
      //获取表单数据
      this.$http({
        method: "POST",
        // headers: { "content-type": "application/json" },
        url: "/rest/LongPromotionContractProject/crmQhrCustomerMappingList",
        // data: params,
        params: params
      }).then(function (res) {
        _this2.tableData = res.data.items;
        _this2.formData.total = res.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },

    //获取合同客户列表
    getAllClientId: function getAllClientId() {
      var _this3 = this;

      this.$http({
        method: "GET",
        url: "/rest/LongPromotionContractProject/clientIdDropDownList"
      }).then(function (res) {
        _this3.allClientId = res.data.data;
      }).catch(function (err) {
        _this3.myNotify(_this3, "error", err.response, "查询失败，请稍后重试");
      });
    },
    getAllCustomer: function getAllCustomer() {
      var _this4 = this;

      this.$http({
        method: "GET",
        url: "/rest/LongPromotionContractProject/customerDropDownList"
      }).then(function (res) {
        _this4.allCustomer = res.data.items;
        _this4.keepAllCustomer = res.data.items;
      }).catch(function (err) {
        _this4.myNotify(_this4, "error", err.response, "查询失败，请稍后重试");
      });
    },
    computedTime: function computedTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    formatNum: function formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      this.param2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },

    //重置表单（清除筛选项）
    resetForm: function resetForm() {
      this.param = {};
      this.param2 = {};
      this.getData();
    },


    //展开收起
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },

    // showSlideBtn() {
    //   return true;
    //   if (this.$refs.slideWrap1.offsetHeight > 42) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // 导出筛选结果
    exportResult: function exportResult() {
      var _this5 = this;

      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.param);
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/LongPromotionContractProject/exportCrmQhrCusMap",
        data: params
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          _this5.listLoading = false;
          // console.log(res);
          // console.log(utils.returnUrlHead() + res.data.message);
          location.href = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
          // this.$alert(res.data.message);
        } else {
          _this5.listLoading = false;
          _this5.$alert(res.data.message);
        }
      }).catch(function (error) {
        _this5.listLoading = false;
        _this5.$alert("导出错误，请联系管理员！");
      });
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },

    //客户维护
    handleCustomer: function handleCustomer(item) {
      //关联项目大于0 则无法直接修改客户
      if (item[5] > 0) {
        this.$alert("该合同客户已有关联项目，无法修改项目客户信息！", "提示", {
          confirmButtonText: "确定"
        });
        return;
      } else {
        this.disabledSubCustomer = true;
        this.handleItem = item;
        this.customerValue = item[3]; //字段需对接
        this.customer = true;
      }
    },

    //提交客户维护
    subCustomer: function subCustomer() {
      var _this6 = this;

      this.$http({
        method: "GET",
        url: "/rest/LongPromotionContractProject/updateCRMCusName",
        params: {
          id: this.handleItem[0],
          crmCustomerCode: this.customerValue[0],
          crmCustomerName: this.customerValue[1],
          operatorId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.status == 200) {
          _this6.getData();
          _this6.customer = false;
        } else {
          _this6.myNotify(_this6, "error", data.message);
        }
      });
    },

    //项目维护
    handleProject: function handleProject(item) {
      if (!item[3]) {
        this.$alert("该合同客户还未维护项目客户，无法关联项目，请先维护项目客户", "提示", {
          confirmButtonText: "确定"
        });
        return;
      } else {
        this.$refs.Project.show(item);
      }
    }
  }
});

/***/ }),

/***/ "Qv+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectConfig_vue__ = __webpack_require__("xV4O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494827a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projectConfig_vue__ = __webpack_require__("JKGb");
function injectStyle (ssrContext) {
  __webpack_require__("Fsl6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-494827a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494827a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projectConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QxVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_handleApply_vue__ = __webpack_require__("IWQI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d83b335_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_handleApply_vue__ = __webpack_require__("UiCG");
function injectStyle (ssrContext) {
  __webpack_require__("rIZC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d83b335"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_handleApply_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d83b335_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_handleApply_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qzj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R3fx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("角色管理")]),_vm._v(" "),_c('el-button',{staticClass:"el-icon-plus newRole",attrs:{"type":"primary","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":_vm.createNewRoleModalTrue}},[_vm._v(" 创建角色\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"common-search"},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"60px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"角色"}},[_c('el-input',{attrs:{"placeholder":"请输入角色名称...","maxlength":12},model:{value:(_vm.formData.roleName),callback:function ($$v) {_vm.$set(_vm.formData, "roleName", $$v)},expression:"formData.roleName"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.getData}},[_vm._v("筛选")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"table",staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"roleName","label":"角色名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"roleRemark","label":"备注","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"查看促销员电话","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-switch',{class:{switchBorder:!scope.row.checkTelBool},attrs:{"disabled":_vm.auths.indexOf(2) < 0,"active-color":"#8299dc","inactive-color":"#ffffff"},on:{"change":function($event){return _vm.telTool(scope.row)}},model:{value:(scope.row.checkTelBool),callback:function ($$v) {_vm.$set(scope.row, "checkTelBool", $$v)},expression:"scope.row.checkTelBool"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"关闭岗位","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-switch',{class:{switchBorder:!scope.row.closePosFlg},attrs:{"disabled":_vm.auths.indexOf(2) < 0,"active-color":"#8299dc","inactive-color":"#ffffff"},on:{"change":function($event){return _vm.editClosePosFlg(scope.row)}},model:{value:(scope.row.closePosFlg),callback:function ($$v) {_vm.$set(scope.row, "closePosFlg", $$v)},expression:"scope.row.closePosFlg"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"招聘特权","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-switch',{class:{switchBorder:!scope.row.recruitmentPrivilege},attrs:{"disabled":_vm.auths.indexOf(2) < 0,"active-color":"#8299dc","inactive-color":"#ffffff"},on:{"change":function($event){return _vm.editRecruitmentPrivilege(scope.row)}},model:{value:(scope.row.recruitmentPrivilege),callback:function ($$v) {_vm.$set(scope.row, "recruitmentPrivilege", $$v)},expression:"scope.row.recruitmentPrivilege"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","fixed":"right","align":"center","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.handleExamine(scope.row)}}},[_vm._v("\n              查看页面权限\n            ")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.handleEdit(scope.row)}}},[_vm._v("编辑\n            ")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.handleDelete(scope.row)}}},[_vm._v("删除\n            ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"createLine",attrs:{"title":"创建角色","visible":_vm.createNewRoleModal,"center":true,"show-close":false,"width":"780px"},on:{"update:visible":function($event){_vm.createNewRoleModal=$event}}},[_c('el-form',{staticClass:"roleInputBackColor",attrs:{"size":"mini"}},[_c('el-form-item',{attrs:{"label":"角色名称"}},[_c('el-input',{staticClass:"rowName",attrs:{"placeholder":"请输入角色名称...","maxlength":12},model:{value:(_vm.createRoleName),callback:function ($$v) {_vm.createRoleName=$$v},expression:"createRoleName"}}),_vm._v(" "),_c('span',{staticClass:"bottomFontColor"},[_vm._v(_vm._s(_vm.createRoleName.length)+"/12字符")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","label-width":"68px"}},[_c('el-input',{attrs:{"type":"textarea","rows":6,"placeholder":"请输入备注...","resize":"none","maxlength":140},model:{value:(_vm.createRoleMark),callback:function ($$v) {_vm.createRoleMark=$$v},expression:"createRoleMark"}}),_vm._v(" "),_c('span',{staticClass:"bottomFontColor floatr"},[_vm._v(_vm._s(_vm.createRoleMark.length)+"/140字符")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"可查看页面"}},[_vm._l((_vm.checkTagList),function(item,index){return (item.webAuth === 2)?_c('el-tag',{key:index,staticClass:"createEditTag"},[_c('span',[_vm._v(_vm._s(item.webName + '-编辑'))])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.checkTagList),function(item,index){return (item.webAuth === 1)?_c('el-tag',{key:index,staticClass:"createEditTag"},[_c('span',[_vm._v(_vm._s(item.webName + '-查看'))])]):_vm._e()}),_vm._v(" "),_c('el-button',{staticClass:"el-icon-plus roleAddBtn",attrs:{"round":""},on:{"click":function($event){_vm.reviseTag=true}}},[_vm._v(" 增加")])],2)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"roleCancelBtn",on:{"click":_vm.createNewRoleCancel}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"roleDefineBtn",attrs:{"disabled":_vm.new_ACKDisabled},on:{"click":_vm.createNewRole}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"limitPage",attrs:{"width":"780px","title":"页面权限查看","visible":_vm.handleView,"center":true,"show-close":false},on:{"update:visible":function($event){_vm.handleView=$event},"close":_vm.initTagInfo}},[_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.tagInfo),function(item,index){return _c('el-collapse-item',{key:index},[_c('template',{slot:"title"},[_c('span',{staticClass:"limitPageTagTopTitle"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_vm._l((item.info),function(childTitle,index){return (childTitle.webAuth === 2)?_c('el-tag',{key:index,staticClass:"createLimitPageTag"},[_c('span',[_vm._v(_vm._s(childTitle.webName + '-编辑'))])]):_vm._e()}),_vm._v(" "),_vm._l((item.info),function(childTitle,index){return (childTitle.webAuth === 1)?_c('el-tag',{key:index,staticClass:"bottomLimitPageTag"},[_c('span',[_vm._v(_vm._s(childTitle.webName + '-查看'))])]):_vm._e()})],2),_vm._v(" "),_c('div',_vm._l((item.info),function(childTitle,index){return _c('el-tag',{key:index,staticClass:"unCreateLimitPageTag",class:[{bottomLimitPageTag:childTitle.webAuth === 1},{topLimitPageTag:childTitle.webAuth === 2}]},[_c('span',{staticClass:"limitPageTagTitle"},[_vm._v(_vm._s(childTitle.webName))])])}),1)],2)}),1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"limitPageCancelBtn",on:{"click":_vm.colseViewPageTag}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"limitPageDefineBtn",on:{"click":_vm.colseViewPageTag}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"limitPage",attrs:{"width":"780px","title":"页面权限","visible":_vm.reviseTag,"top":"4vh","show-close":false},on:{"update:visible":function($event){_vm.reviseTag=$event}}},[_c('el-collapse',{attrs:{"accordion":""}},[_c('div',{staticClass:"common-search",staticStyle:{"margin-bottom":"10px"}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"size":"mini"}},[_c('el-form-item',{staticClass:"limitPageTop",attrs:{"label":"PLUS-CRM页面"}},[_c('el-input',{staticStyle:{"width":"200px","margin-right":"10px"},attrs:{"placeholder":"请输入页面名称进行模糊搜索"},model:{value:(_vm.webName),callback:function ($$v) {_vm.webName=$$v},expression:"webName"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.searchEditLimit}},[_vm._v("筛选")])],1)],1)],1),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.tagInfo),function(item,index){return _c('el-collapse-item',{directives:[{name:"show",rawName:"v-show",value:(item.show),expression:"item.show"}],key:index},[_c('template',{slot:"title"},[_c('span',{staticClass:"limitPageTagTopTitle"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_vm._l((item.info),function(childTitle,index){return (childTitle.webAuth === 2)?_c('el-tag',{key:index,staticClass:"topLimitPageTag notChangePD"},[_vm._v("\n                "+_vm._s(childTitle.webName + '-编辑')+"\n                "),_c('i',{staticClass:"el-icon-circle-close-outline editLimitTagClose",on:{"click":function($event){childTitle.webAuth = null}}})]):_vm._e()}),_vm._v(" "),_vm._l((item.info),function(childTitle,index){return (childTitle.webAuth === 1)?_c('el-tag',{key:index,staticClass:"bottomLimitPageTag notChangePD"},[_vm._v("\n                "+_vm._s(childTitle.webName + '-查看')+"\n                "),_c('i',{staticClass:"el-icon-circle-close-outline viewLimitTagClose",on:{"click":function($event){childTitle.webAuth = null}}})]):_vm._e()})],2),_vm._v(" "),_c('div',[_vm._l((item.info),function(childTitle,index){return (index<6)?_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(childTitle.webShow),expression:"childTitle.webShow"}],key:index,staticClass:"limitPageTag",class:[{bottomLimitPageTag:childTitle.viewTool},{topLimitPageTag:childTitle.editTool},{bottomLimitPageTag:childTitle.webAuth===0},{topLimitPageTag:childTitle.webAuth===1}]},[_c('span',{staticClass:"limitPageTagTitle"},[_vm._v(_vm._s(childTitle.webName))]),_vm._v(" "),(childTitle.webName != '黑名单')?_c('el-checkbox',{staticClass:"limitPageCheckEdit",attrs:{"size":"medium","label":"编辑","true-label":2},on:{"change":function($event){childTitle.viewTool=false}},model:{value:(childTitle.webAuth),callback:function ($$v) {_vm.$set(childTitle, "webAuth", $$v)},expression:"childTitle.webAuth"}}):_vm._e(),_vm._v(" "),_c('el-checkbox',{staticClass:"limitPageCheckView",attrs:{"size":"medium","label":"查看","true-label":1,"disabled":childTitle.webAuth === 2},model:{value:(childTitle.webAuth),callback:function ($$v) {_vm.$set(childTitle, "webAuth", $$v)},expression:"childTitle.webAuth"}})],1):_vm._e()}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((item.info),function(childTitle,index){return (index>=6)?_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(childTitle.webShow),expression:"childTitle.webShow"}],key:index,staticClass:"limitPageTag",class:[{bottomLimitPageTag:childTitle.viewTool},{topLimitPageTag:childTitle.editTool},{bottomLimitPageTag:childTitle.webAuth===0},{topLimitPageTag:childTitle.webAuth===1}]},[_c('span',{staticClass:"limitPageTagTitle"},[_vm._v(_vm._s(childTitle.webName))]),_vm._v(" "),(childTitle.webName != '黑名单')?_c('el-checkbox',{staticClass:"limitPageCheckEdit",attrs:{"size":"medium","label":"编辑","true-label":2},on:{"change":function($event){childTitle.viewTool=false}},model:{value:(childTitle.webAuth),callback:function ($$v) {_vm.$set(childTitle, "webAuth", $$v)},expression:"childTitle.webAuth"}}):_vm._e(),_vm._v(" "),_c('el-checkbox',{staticClass:"limitPageCheckView",attrs:{"size":"medium","label":"查看","true-label":1,"disabled":childTitle.webAuth === 2},model:{value:(childTitle.webAuth),callback:function ($$v) {_vm.$set(childTitle, "webAuth", $$v)},expression:"childTitle.webAuth"}})],1):_vm._e()})],2)],2)}),1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"limitPageCancelBtn",on:{"click":function($event){_vm.reviseTag=false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"limitPageDefineBtn",on:{"click":_vm.saveCheckedTags}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"limitPage",attrs:{"title":"角色编辑","visible":_vm.editRowDialog,"width":"780px","center":true,"show-close":false},on:{"update:visible":function($event){_vm.editRowDialog=$event}}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.editLoading),expression:"editLoading"}],staticClass:"table-expand-form",staticStyle:{"margin":"20px 30px 0 30px"},attrs:{"label-position":"left","label-width":"90px","inline":"","size":"mini"},model:{value:(_vm.editRowObj),callback:function ($$v) {_vm.editRowObj=$$v},expression:"editRowObj"}},[_c('el-form-item',{attrs:{"label":"角色名称"}},[_c('el-input',{staticClass:"rowName",attrs:{"placeholder":"请输入角色名称...","maxlength":12},on:{"input":_vm.check},model:{value:(_vm.editRowObj.aaa),callback:function ($$v) {_vm.$set(_vm.editRowObj, "aaa", $$v)},expression:"editRowObj.aaa"}}),_vm._v(" "),_c('span',{staticClass:"bottomFontColor"},[_vm._v(_vm._s(_vm.aaaLength)+"/12字符")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注"}},[_c('el-input',{staticClass:"rowRemark",attrs:{"placeholder":"请输入备注...","maxlength":140},on:{"input":_vm.checkb},model:{value:(_vm.editRowObj.bbb),callback:function ($$v) {_vm.$set(_vm.editRowObj, "bbb", $$v)},expression:"editRowObj.bbb"}}),_vm._v(" "),_c('span',{staticClass:"bottomFontColor"},[_vm._v(_vm._s(_vm.bbbLength)+"/140字符")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"可查看页面"}},[_vm._l((_vm.checkTagList),function(item,index){return _c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(item.webAuth === 2),expression:"item.webAuth === 2"}],key:index,staticClass:"createEditTag"},[_c('span',[_vm._v(_vm._s(item.webName + '-编辑'))])])}),_vm._v(" "),_vm._l((_vm.checkTagList),function(item,index){return _c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(item.webAuth === 1),expression:"item.webAuth === 1"}],key:index,staticClass:"createEditTag"},[_c('span',[_vm._v(_vm._s(item.webName + '-查看'))])])}),_vm._v(" "),_c('el-button',{staticClass:"reviseBtn",attrs:{"round":""},on:{"click":function($event){return _vm.reviseRowBtn(_vm.editRowObj)}}},[_vm._v("修改")])],2)],1),_vm._v(" "),_c('el-row',{staticClass:"tableBottomBtn"},[_c('el-col',{attrs:{"span":4,"xs":8,"sm":6,"md":6,"lg":4,"xl":4,"offset":10}},[_c('el-button',{staticClass:"rowCancel",attrs:{"size":"mini"},on:{"click":function($event){return _vm.rowHandleCancel(_vm.editRowObj)}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"rowSave",attrs:{"size":"mini","disabled":_vm.editLoading},on:{"click":function($event){return _vm.rowHandleSave(_vm.editRowObj)}}},[_vm._v("保存\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RifP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_formRules__ = __webpack_require__("8jay");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "userManager",
  data: function data() {
    return {
      /*
      首页数据
      */
      auths: [], // 页面内权限，没用到。。
      //首页的筛选表单数据
      formData: {
        nickName: "",
        tel: "",
        empCode: "",
        roleId: "",
        pageNo: 1,
        pageSize: 10
      },
      isAdmin: false, //是否是admin1或者tinashi
      tableData: [], //筛选到的当页数据，table数据
      listLoading: true, //首页loading
      pageNo: 1, //默认显示第一页的数据
      pageSize: 10, //默认显示10条数据
      total: null, //总页数
      /*
      创建、编辑、查看弹框
      */
      createNewUserModal: false, //创建用户弹窗 显示还是隐藏
      editRowDialog: false, //编辑和查看用户弹窗 显示还是隐藏
      rules: {
        empCode: [{ required: true, message: '请输入员工编码', trigger: 'blur' }, { pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur' }],
        nickName: [{ required: true, message: '请输入姓名', trigger: 'blur' }, { pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur' }, { max: 60, message: '最长为 60 个中文字符', trigger: 'blur' }],
        account: [{ required: true, message: '请输入用户名', trigger: 'blur' }, { pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur' }],
        loginPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }, { pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur' }],
        idCard: [__WEBPACK_IMPORTED_MODULE_1__common_js_formRules__["a" /* default */].idcard],
        mail: [{ pattern: /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/, message: '请输入正确邮箱', trigger: 'blur' }],
        tel: [{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号', trigger: 'blur' }]
      }, //创建或编辑的表单校验规则
      title: "", //编辑查看弹框-标题-编辑还是查看
      // 创建或编辑或查看中的表单及详情内容
      tableForm: {
        empCode: '', //后面用户要求加入人员编码作为必填项
        id: null,
        account: '',
        loginPassword: '',
        nickName: '',
        tel: '',
        mail: '',
        idCard: '',
        roleId: null,
        roleName: '',
        regionLst: [],
        projectIdLst: [],
        projectLst: [] //选择项目弹框，一级已选项目数据（全部信息）
      },
      dialogLoading: false, //编辑查看弹框的loading
      creatACKButtonLoading: false, //创建用户确认按钮，是否loading
      editACKButtonLoading: false, //编辑用户确认按钮，是否loading
      showRoleTag: [], //在创建弹窗显示角色?????
      /*
      选择角色弹框
      */
      createNewRoleModal: false, //角色弹窗 显示还是隐藏
      roleData: [], //角色弹框-供选择的角色列表
      roleList: [],
      checkedRoleId: null, //选择角色弹框
      checkedRoleName: '', //选择角色弹框
      //选择角色弹框-模糊搜索角色，因为只有一页，所以pageSize设置极大
      searchRole: {
        sysRoleName: "",
        pageNo: 1,
        pageSize: 1000
      },
      /*
      选择地区弹框
      */
      createNewAreaModal: false, //地区弹窗 显示还是隐藏
      checkedRegionLst: [], //选择地区弹框
      provinceInfo: [], //选择地区弹框-省的下拉列表信息
      province: null, //v-model绑定的省下拉框中的信息
      cityInfo: [], //选择地区弹框-市的信息
      city: null, //v-model绑定的市下拉框中的信息
      //热门城市
      popularCity: [{ province: "不限", city: "不限" }, { province: "北京市", city: "北京市" }, { province: "天津市", city: "天津市" }, { province: "广东省", city: "广州市" }, { province: "广东省", city: "深圳市" }, { province: "上海市", city: "上海市" }, { province: "四川省", city: "成都市" }, { province: "重庆市", city: "重庆市" }, { province: "黑龙江省", city: "哈尔滨市" }, { province: "陕西省", city: "西安市" }, { province: "浙江省", city: "杭州市" }, { province: "江苏省", city: "南京市" }, { province: "湖南省", city: "长沙市" }, { province: "河南省", city: "郑州市" }, { province: "福建省", city: "厦门市" }, { province: "福建省", city: "福州市" }, { province: "广西壮族自治区", city: "南宁市" }, { province: "山东省", city: "青岛市" }, { province: "新疆维吾尔自治区", city: "乌鲁木齐市" }, { province: "辽宁省", city: "大连市" }, { province: "山西省", city: "太原市" }, { province: "辽宁省", city: "沈阳市" }, { province: "吉林省", city: "长春市" }, { province: "甘肃省", city: "兰州市" }],
      /*
      选择项目弹框
      */
      createNewProjectModal: false, //项目弹窗 显示还是隐藏
      checked: false, //选择项目弹框-是否全选
      //选择项目弹窗--筛选项目的表单信息
      projectInfo: {
        projectCode: "",
        projectName: "",
        customer: "",
        pageNo: 1,
        pageSize: 10
      },
      projectTotal: null, //项目弹窗-筛选到的项目总数
      projectRealTotal: null, //项目弹窗-全部项目数，而非检索到的总项目数
      projectTableData: [], //项目弹窗-筛选到的当页数据，table数据
      checkedPrjLst: [], //选择项目弹框，二级已选项目数据（全部信息）
      getProjectDataLoading: false //getProjectData时候的table loading
    };
  },

  computed: {
    // 是否是编辑状态
    isEdit: function isEdit() {
      if (this.title == "查看详情") {
        return false;
      } else {
        //用户编辑
        return true;
      }
    }
  },
  mounted: function mounted() {
    // 180627韩金辰优化重写，变动较大(变动前此文件svn版本：2942)
    this.getData(true);
    var user = sessionStorage.getItem('user');
    if (user == 'admin1' || user == 'tinashi') {
      this.isAdmin = true;
    }
    this.getAuth();
    this.getCities();
    this.getRoleList();
  },

  methods: {
    /*
    首页方法
    */
    //工具类-弹窗简写
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },

    //首页-table行-点击表格中编辑和查看详情按钮
    handleEdit: function handleEdit(row, handle) {
      var _this2 = this;

      if (handle == "view") {
        this.title = "查看详情";
      } else {
        this.title = "用户编辑";
      }
      this.editRowDialog = true;
      this.dialogLoading = true;
      this.$http({
        method: "GET",
        url: '/rest/sysUser/getSysUserDetail',
        params: {
          sysUserId: row.sysUser.id
        }
      }).then(function (res) {
        var role = res.data.sysRole;
        var sysUser = res.data.sysUser;
        _this2.tableForm = {
          empCode: sysUser.empCode,
          id: sysUser.id,
          account: sysUser.account,
          loginPassword: sysUser.loginPassword,
          nickName: sysUser.nickName,
          tel: sysUser.tel,
          mail: sysUser.mail,
          idCard: sysUser.idCard,
          roleId: role ? role.id : null,
          roleName: role ? role.roleName : null,
          regionLst: [],
          projectIdLst: [],
          projectLst: []
        };

        var sysUserDivLst = res.data.sysUserDivLst;
        if (sysUserDivLst) {
          sysUserDivLst.map(function (item) {
            if (_this2.isProvinceInArray(_this2.tableForm.regionLst, item.province)) {
              _this2.tableForm.regionLst.map(function (province) {
                if (province.province === item.province) {
                  province.cityLst.push(item.city);
                }
              });
            } else {
              _this2.tableForm.regionLst.push({
                province: item.province,
                // cityLength: this.city.length,
                cityLst: [item.city]
              });
            }
          });
        }

        var projectLst = res.data.projectLst;
        if (projectLst) {
          projectLst.map(function (item) {
            _this2.tableForm.projectLst.push({
              id: item.id,
              projectName: item.id == -1 ? '不限' : item.projectName
            });
          });
        }

        _this2.dialogLoading = false;
      }).catch(function (err) {
        _this2.dialogLoading = false;
        _this2.myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //首页-table行-删除用户
    handleDelete: function handleDelete(index, row) {
      var _this3 = this;

      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$http({
          method: "POST",
          url: "/rest/sysUser/deleteUser",
          data: {
            id: row.sysUser.id
          }
        }).then(function (res) {
          _this3.myNotify(_this3, 'success', res, '删除成功');
          _this3.getData(true);
        }).catch(function (err) {
          _this3.myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
        });
      }).catch(function () {});
    },

    //主页table中用的项目数量的转换
    returnProjectCount: function returnProjectCount(count) {
      if (count == -1) {
        return '不限';
      } else {
        return count;
      }
    },

    //主页-获取数据
    getData: function getData(reset) {
      var _this4 = this;

      this.listLoading = true;
      var params = this.formData;
      if (reset) {
        params.pageNo = 1;
        params.pageSize = 10;
      }
      this.$http({
        // method: "GET",
        url: "/rest/sysUser/searchSysUser",
        params: params
      }).then(function (res) {
        //搜索时没有权限，进行提示
        if (res.data.status == 460) {
          _this4.myNotify(_this4, 'error', res, '查询失败，请稍后重试');
          return false;
        }
        _this4.listLoading = false;
        _this4.tableData = res.data;
      }).catch(function (err) {
        if (err.response) {
          _this4.myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
        }
        _this4.listLoading = false;
      });

      this.$http({
        method: "GET",
        url: "/rest/sysUser/countSysUser",
        params: this.formData
      }).then(function (res) {
        _this4.total = res.data;
      }).catch(function (err) {
        _this4.myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //主页-获取权限，没用到，留着吧先
    getAuth: function getAuth() {
      var _this5 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 14,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        res.data.map(function (item) {
          _this5.auths.push(item.auth);
        });
      }).catch(function (err) {
        _this5.myNotify(_this5, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //主页-切换table，Size
    handleSizeChange: function handleSizeChange(val) {
      //更改页面数据条数
      this.formData.pageSize = val;
      //更改新的页面数据条数后，重新请求数据
      this.getData(false);
    },

    //主页-切换table，pageNo
    handleCurrentChange: function handleCurrentChange(val) {
      //更改页数
      this.formData.pageNo = val;
      //更改新的页数后，重新请求数据
      this.getData(false);
    },

    /*
    创建、编辑、查看弹框-方法
    */
    // 打开创建用户对话框
    showNewUserDialog: function showNewUserDialog() {
      this.createNewUserModal = true;
      this.tableForm = {
        id: null,
        account: '',
        loginPassword: '',
        nickName: '',
        tel: '',
        mail: '',
        idCard: '',
        roleId: null,
        roleName: '',
        regionLst: [],
        projectIdLst: [],
        projectLst: []
      };
    },

    //查看和编辑弹窗-将选择的地区转换为城市
    //创建时候都没用这个，直接用的循环中的item，不知道这个方法有啥用，先留着吧
    returnCity: function returnCity(i, obj) {
      // console.log(i,obj)
      if (i == 'allcity') {
        return obj.province;
      } else if (i == null) {
        return '不限';
      } else {
        return i;
      }
    },

    //创建用户弹框-关闭弹框
    createNewUserCancel: function createNewUserCancel() {
      this.createNewUserModal = false;
      this.$refs['newUserForm'].resetFields();
    },

    //创建用户弹框-点击确定
    createNewUserSave: function createNewUserSave() {
      var _this6 = this;

      this.$refs['newUserForm'].validate(function (valid) {
        if (valid) {
          _this6.creatACKButtonLoading = true;
          var data = _this6.tableForm;
          data.projectIdLst = [];
          data.projectLst.map(function (item) {
            data.projectIdLst.push(item.id);
          });

          data.regionLst.map(function (item) {
            if (item.province == '不限' && item.cityLst[0] == '不限') {
              data.regionLst = [];
              data.regionLst.push({
                province: 'countrywide',
                cityLst: []
              });
            }
          });

          data.regionLst.map(function (item, index) {
            if (item.cityLst.length == 0 && item.province !== "countrywide") {
              data.regionLst.splice(index, 1);
            }
          });

          data.regionLst.map(function (item) {
            if (item.province == '北京市' || item.province == '天津市' || item.province == '上海市' || item.province == '重庆市') {
              item.cityLst = ['allcity'];
            }
          });

          _this6.$http({
            method: "POST",
            url: "/rest/sysUser/saveUpdateUser",
            data: {
              empCode: data.empCode,
              id: data.id,
              account: data.account,
              loginPassword: data.loginPassword,
              nickName: data.nickName,
              tel: data.tel,
              mail: data.mail,
              idCard: data.idCard,
              roleId: data.roleId,
              regionLst: data.regionLst,
              projectIdLst: data.projectIdLst
            }
          }).then(function (res) {
            _this6.myNotify(_this6, 'success', res, '保存成功');

            _this6.createNewUserModal = false;
            _this6.creatACKButtonLoading = false;
            _this6.$refs['newUserForm'].resetFields();
            _this6.getData(true);
          }).catch(function (err) {
            _this6.myNotify(_this6, 'error', err.response, '查询失败，请稍后重试');
            _this6.creatACKButtonLoading = false;
          });
        } else {
          return false;
        }
      });
    },

    //编辑或查看弹窗-关闭弹框
    editUserCancel: function editUserCancel() {
      //先将展开一行的方法，设置为false
      if (this.title == "用户编辑") {
        this.$refs['tableForm'].resetFields();
      }
      this.editRowDialog = false;
    },

    //编辑或查看弹窗-点击确定
    rowHandleSave: function rowHandleSave() {
      var _this7 = this;

      this.$refs['tableForm'].validate(function (valid) {
        if (valid) {
          _this7.editACKButtonLoading = true;
          var data = _this7.tableForm;
          data.projectLst.map(function (item) {
            data.projectIdLst.push(item.id);
          });
          data.projectIdLst.map(function (item, index) {
            if (item == undefined || item == null) {
              data.projectIdLst.splice(index, 1);
            }
          });

          data.regionLst.map(function (item) {
            if (item.province == '不限' && item.cityLst[0] == '不限') {
              data.regionLst = [];
              data.regionLst.push({
                province: 'countrywide',
                cityLst: []
              });
            }
          });

          data.regionLst.map(function (item, index) {
            if (item.cityLst.length == 0 && item.province !== "countrywide") {
              data.regionLst.splice(index, 1);
            }
          });

          // data.regionLst.map(item => {
          //   if(item.province == '北京市' || item.province == '天津市' || item.province == '上海市' || item.province == '重庆市' ){
          //     // item.cityLst = ['allcity']
          //   }
          // })
          // console.log(data.regionLst)

          var cccc = [].concat(data.regionLst);
          cccc.map(function (item) {
            if (item.province == '北京市' || item.province == '天津市' || item.province == '上海市' || item.province == '重庆市') {
              item.cityLst = ['allcity'];
            }
          });

          _this7.$http({
            method: "POST",
            url: "/rest/sysUser/saveUpdateUser",
            data: {
              empCode: data.empCode,
              id: data.id,
              account: data.account,
              loginPassword: data.loginPassword,
              nickName: data.nickName,
              tel: data.tel,
              mail: data.mail,
              idCard: data.idCard,
              roleId: data.roleId,
              regionLst: cccc,
              projectIdLst: data.projectIdLst
            }
          }).then(function (res) {
            _this7.editACKButtonLoading = false;
            _this7.myNotify(_this7, 'success', res, '保存成功');
            _this7.createNewUserModal = false;
            _this7.editRowDialog = false;
            _this7.getData(true);
          }).catch(function (err) {
            _this7.editACKButtonLoading = false;
            _this7.myNotify(_this7, 'error', err.response, '操作失败，请稍后重试');
          });
        } else {
          return false;
        }
      });
    },

    /*
    选择角色弹框-方法
    */
    // 打开角色弹窗
    openCreateNewRoleModal: function openCreateNewRoleModal() {
      this.checkedRoleId = this.tableForm.roleId;
      this.checkedRoleName = this.tableForm.roleName;
      this.createNewRoleModal = true;
      this.handleSearchRole();
    },

    // 搜索角色
    handleSearchRole: function handleSearchRole() {
      var _this8 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/searchRole",
        params: this.searchRole
      }).then(function (res) {
        _this8.roleData = res.data;
      }).catch(function (err) {
        _this8.myNotify(_this8, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 搜索角色
    getRoleList: function getRoleList() {
      var _this9 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/searchRole",
        params: {
          pageNo: 1,
          pageSize: 1000
        }
      }).then(function (res) {
        _this9.roleList = res.data;
      }).catch(function (err) {
        _this9.myNotify(_this9, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //选择角色
    addRoleTag: function addRoleTag(item) {
      this.checkedRoleId = item.id;
      this.checkedRoleName = item.roleName;
    },

    //删除已选择的角色
    removeShowRoleTag: function removeShowRoleTag() {
      this.checkedRoleId = null;
      this.checkedRoleName = '';
    },

    //选择角色弹窗-点击确定
    createNewRoleSave: function createNewRoleSave() {
      this.createNewRoleModal = false;
      this.tableForm.roleId = this.checkedRoleId;
      this.tableForm.roleName = this.checkedRoleName;
    },

    /*
    选择地区弹框
    */
    //打开地区弹窗
    openCreateNewAreaModal: function openCreateNewAreaModal() {
      var _this10 = this;

      this.city = null;
      this.province = null;
      this.checkedRegionLst = this.tableForm.regionLst.slice(0);
      this.createNewAreaModal = true;
      this.$http({
        method: "POST",
        url: "/rest/salesman/getRegion",
        params: {
          deep: 1,
          regionId: null
        }
      }).then(function (res) {
        _this10.provinceInfo = res.data;
      }).catch(function (err) {
        _this10.myNotify(_this10, 'error', err.response, '查询失败，请稍后重试');
      });
      //默认不选择省就不出城市
    },

    //选择地区弹窗-省的下拉框值变化时，自动获取市的列表，并且转码
    getCities: function getCities(province) {
      var _this11 = this;

      this.city = '';
      if (
      // province && province.id != null
      true) {
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 2
            // regionId: province.id
          }
        }).then(function (res) {
          //在map过程中多次splice极有可能出现index错乱，只能用笨点的办法
          var delArr = [];
          res.data.map(function (item, index) {
            switch (item.id) {
              case 15:
              case 37:
              case 873:
              case 2458:
                delArr.unshift(index);
                break; //有时city的名字是‘县’，需要去掉
              case 2:
              case 23:
              case 873:
              case 2458:
                item.adName = item.adName.replace('市辖区', "");
                break; //把上海市市辖区这种，换成上海市
            }
          });
          delArr.map(function (item) {
            res.data.splice(item, 1);
          });
          setTimeout(function () {
            _this11.cityInfo = res.data;
          }, 30);
        });
      }
    },

    //选择地区弹框-点击每个热门城市按钮
    areaSelectedSave: function areaSelectedSave(province, city) {
      var _this12 = this;

      if (province) {
        if (this.isProvinceInArray(this.checkedRegionLst, province)) {
          this.checkedRegionLst.map(function (item) {
            if (item.province === province && item.cityLst.indexOf(city) < 0) {
              item.cityLst.push(city);
            }
          });
        } else {
          if (city) {
            this.checkedRegionLst.push({
              province: province,
              // cityLength: this.city.length,
              cityLst: [city]
            });
          } else {
            var cityArr = [];
            this.cityInfo.map(function (city) {
              cityArr.push(city.adName);
            });
            this.checkedRegionLst.push({
              province: province,
              // cityLength: this.city.length,
              cityLst: cityArr
            });
          }
        }
      }
      if (province == '不限') {
        this.checkedRegionLst = [];
        this.checkedRegionLst.push({
          province: '不限',
          cityLst: ['不限']
        });
      } else if (province != '不限') {
        this.checkedRegionLst.map(function (item, index) {
          if (item.province == '不限' || item.province == 'countrywide') {
            _this12.checkedRegionLst.splice(index, 1);
          }
        });
      }
      // if(province)
    },

    //选择地区弹框-删除已选中的城市
    cancelCity: function cancelCity(pIndex, cIndex) {
      var _this13 = this;

      this.checkedRegionLst[pIndex].cityLst.splice(cIndex, 1);
      this.tableForm.regionLst.map(function (item, index) {
        if (item.province == 'countrywide') {
          _this13.cancelProvince();
        }
      });
    },

    //选择地区弹框-删除已选中的省
    cancelProvince: function cancelProvince(index) {
      var _this14 = this;

      this.checkedRegionLst.splice(index, 1);
      this.tableForm.regionLst.map(function (item, index) {
        if (item.province == 'countrywide') {
          _this14.tableForm.regionLst.splice(index, 1);
        }
      });
    },

    //选择地区弹框-确定
    createNewAreaSave: function createNewAreaSave() {
      this.createNewAreaModal = false;
      this.tableForm.regionLst = this.checkedRegionLst.slice(0);
    },

    //查看添加的省是否在已选的列表中
    isProvinceInArray: function isProvinceInArray(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (val == arr[i].province) {
          return true;
        }
      }
      return false;
    },

    /*
    选择项目弹框-方法
    */
    //打开项目弹窗
    openCreateNewProjectModal: function openCreateNewProjectModal() {
      //数组的深拷贝可以用.slice(0)，之前用的map+push有点笨
      this.checkedPrjLst = this.tableForm.projectLst.slice(0);
      if (this.checkedPrjLst[0] && this.checkedPrjLst[0].projectName == '不限') {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.createNewProjectModal = true;
      this.projectInfo = {
        projectCode: "",
        projectName: "",
        customer: "",
        pageNo: 1,
        pageSize: 10
      };
      this.getProjectData();
    },

    //项目弹框-选择全部项目@change
    selectAllProject: function selectAllProject() {
      this.checkedPrjLst = [];
      if (this.checked) {
        this.checkedPrjLst.push({
          projectName: '不限',
          id: -1
        });
      } else {
        this.getProjectData();
      }
    },

    //选择项目弹框，点击筛选
    searchProject: function searchProject() {
      this.projectInfo.pageNo = 1;
      this.getProjectData();
    },

    //传参this.projectInfo，获取及筛选项目信息
    getProjectData: function getProjectData() {
      var _this15 = this;

      this.getProjectDataLoading = true;
      this.$http({
        method: "GET",
        url: "/rest/sysUser/searchProject",
        params: this.projectInfo
      }).then(function (res) {
        _this15.getProjectDataLoading = false;
        _this15.projectTableData = res.data;
        setTimeout(function () {
          _this15.refreshProTableChecked();
        }, 20);
      }).catch(function (err) {
        _this15.getProjectDataLoading = false;
        _this15.myNotify(_this15, 'error', err.response, '查询失败，请稍后重试');
      });

      this.$http({
        method: "GET",
        url: "/rest/sysUser/countProject",
        params: this.projectInfo
      }).then(function (res) {
        //仅在第一次进入的时候获取总的项目条数（此时没有填写筛选项，所以是真的总项目数）
        if (!_this15.projectRealTotal) {
          _this15.projectRealTotal = res.data;
        }
        _this15.projectTotal = res.data;
      }).catch(function (err) {
        _this15.myNotify(_this15, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //根据this.projectInfo更新table的选中状态
    refreshProTableChecked: function refreshProTableChecked() {
      var _this16 = this;

      var ids = [];
      this.checkedPrjLst.map(function (item) {
        ids.push(item.id);
      });
      this.projectTableData.map(function (item) {
        if (ids.indexOf(item.id) > -1) {
          _this16.$refs["projectTable"].toggleRowSelection(item, true);
        }
      });
    },

    //删除项目
    removeProject: function removeProject(item, index) {
      var _this17 = this;

      if (item.projectName == '不限') {
        this.checked = false;
        this.getProjectData();
      } else {
        this.projectTableData.map(function (i) {
          if (item.id === i.id) {
            _this17.$refs["projectTable"].toggleRowSelection(i, false);
          }
        });
      }
      this.checkedPrjLst.splice(index, 1);
    },

    //选择项目弹框-全选或取消全选选择项目
    selectAllChange: function selectAllChange(selection) {
      var _this18 = this;

      //全选
      if (selection.length == this.projectTableData.length) {
        var ids = [];
        this.checkedPrjLst.map(function (item) {
          ids.push(item.id);
        });
        selection.map(function (item) {
          if (ids.indexOf(item.id) < 0) {
            _this18.checkedPrjLst.push(item);
          }
        });
      } else {
        //取消全选
        var delArr = [];
        this.projectTableData.map(function (item) {
          _this18.checkedPrjLst.map(function (item2, index) {
            if (item.id == item2.id) {
              delArr.unshift(index);
            }
          });
        });
        delArr.map(function (item) {
          _this18.checkedPrjLst.splice(item, 1);
        });
      }
    },

    //选择项目弹框-单独选择或取消选择项目
    changeProject: function changeProject(selection, row) {
      var ids = [];
      this.checkedPrjLst.map(function (item, index, arr) {
        ids.push(item.id);
        if (item.id == row.id) {
          arr.splice(index, 1);
        }
      });
      if (ids.indexOf(row.id) < 0) {
        this.checkedPrjLst.push(row);
      }
    },

    //选择项目弹框-点击确定
    createNewProjectSave: function createNewProjectSave() {
      this.createNewProjectModal = false; //关闭项目弹窗
      this.tableForm.projectLst = this.checkedPrjLst.slice(0);
    },

    //选择项目弹框-切换页码
    projectHandleCurrentChange: function projectHandleCurrentChange(val) {
      this.projectInfo.pageNo = val; //更改页数
      this.getProjectData(); //更改新的页数后，重新请求数据
    }
  }
});

/***/ }),

/***/ "RjCd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1Dashboard2.b4b2247.png";

/***/ }),

/***/ "RkUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login2_vue__ = __webpack_require__("mALu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0174f7b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login2_vue__ = __webpack_require__("4QAv");
function injectStyle (ssrContext) {
  __webpack_require__("85DT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0174f7b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0174f7b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RoIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_limitManager_vue__ = __webpack_require__("qdoz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8fbef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_limitManager_vue__ = __webpack_require__("R3fx");
function injectStyle (ssrContext) {
  __webpack_require__("E60D")
  __webpack_require__("4xzm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d8fbef4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_limitManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8fbef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_limitManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S0XV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SADZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "test123",
  mounted: function mounted() {
    console.log('执行js');
  }
});

/***/ }),

/***/ "SH69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zSystem_vue__ = __webpack_require__("hvK8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f8e376_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zSystem_vue__ = __webpack_require__("G+PA");
function injectStyle (ssrContext) {
  __webpack_require__("HWTB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14f8e376"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zSystem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f8e376_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zSystem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SP5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"},on:{"tab-click":_vm.tabClick}},[_c('el-tab-pane',{attrs:{"label":"全部人员"}},[(_vm.page==1)?_c('filter-param',{ref:"fp1",attrs:{"webId":_vm.webId,"postId":0,"educationList":_vm.educationList,"starLevelList":_vm.starLevelList,"channelList":_vm.channelList},on:{"filterParam":_vm.getParam}}):_vm._e()],1),_vm._v(" "),(_vm.userIsPLUS)?_c('el-tab-pane',{attrs:{"label":"筛选长促"}},[(_vm.page==2)?_c('filter-param',{ref:"fp2",attrs:{"webId":_vm.webId,"postId":1,"educationList":_vm.educationList,"starLevelList":_vm.starLevelList,"channelList":_vm.channelList},on:{"filterParam":_vm.getParam}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.userIsPLUS)?_c('el-tab-pane',{attrs:{"label":"筛选短促"}},[(_vm.page==3)?_c('filter-param',{ref:"fp3",attrs:{"webId":_vm.webId,"postId":2,"educationList":_vm.educationList,"starLevelList":_vm.starLevelList,"channelList":_vm.channelList},on:{"filterParam":_vm.getParam}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SRsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    itemId: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      //筛选项参数
      param: {},
      //表单信息
      tableData: [],
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.getData(); //获取终端筛选列表
  },

  methods: {
    //获取终端下拉列表
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      };
      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/qhrlongPromotionDetail?id=" + this.itemId,
        params: params
      }).then(function (res) {
        console.log(res.data);
        _this2.param = res.data.data;
        // this.param.isAuthentivayion = 3;
        _this2.tableData = res.data.data.detailList.items;
        _this2.formData.total = res.data.data.detailList.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
        _this2.listLoading = false;
      });
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.Information = false;
      this.getData();
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },

    //时间戳处理
    handleTime: function handleTime(res) {
      res = __WEBPACK_IMPORTED_MODULE_1_moment___default()(res).format("YYYY-MM-DD");
      return res;
    }
  },
  computed: {
    birthday: function birthday() {
      var res = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.param.birthday).format("YYYY-MM-DD");
      return res;
    },
    status: function status() {
      switch (this.param.quitCrmStatus) {
        case 1:
          return "在职";
        case 2:
          return "离职中";
        case 3:
          return "取消离职";
        case 4:
          return "离职";
      }
    },
    isAuthentivayion: function isAuthentivayion() {
      switch (this.param.isAuthentivayion) {
        case 9:
          return "未注册";
        case 0:
          return "注册会员";
        case 1:
          return "身份认证";
        case 2:
          return "实名认证";
        case 3:
          return "银行卡认证";
      }
    }
  }
});

/***/ }),

/***/ "SXjM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "SbHN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TiXi_vue__ = __webpack_require__("/Teq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e0ecf5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TiXi_vue__ = __webpack_require__("Nuj1");
function injectStyle (ssrContext) {
  __webpack_require__("M3Rr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41e0ecf5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TiXi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e0ecf5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TiXi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Syiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"1260px","center":true,"show-close":true,"visible":_vm.visiable,"close-on-click-modal":false,"top":"10vh"},on:{"update:visible":function($event){_vm.visiable=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('div',{staticStyle:{"font-size":"18px","margin-bottom":"4px"}},[_vm._v(_vm._s(_vm.item.title))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('el-form',{attrs:{"model":_vm.param,"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50,"clearable":""},model:{value:(_vm.param.projectCode),callback:function ($$v) {_vm.$set(_vm.param, "projectCode", $$v)},expression:"param.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50,"clearable":""},model:{value:(_vm.param.projectName),callback:function ($$v) {_vm.$set(_vm.param, "projectName", $$v)},expression:"param.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.status),callback:function ($$v) {_vm.$set(_vm.param, "status", $$v)},expression:"param.status"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"生效中","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已失效","value":"2"}})],1)],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1),_vm._v(" "),_c('div',[_c('el-button',{staticStyle:{"padding-left":"20px","padding-right":"20px"},attrs:{"type":"primary","size":"mini","icon":"el-icon-plus"},on:{"click":function($event){return _vm.add()}}},[_vm._v("\n        新增")])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"mini","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"minWidth":"200","prop":"projectCode","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","minWidth":"200","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"startTime","label":"项目开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"endTime","label":"项目结束日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.associatedStatus == 1)?_c('div',{staticStyle:{"color":"#66cc33"}},[_vm._v("关联中")]):_vm._e(),_vm._v(" "),(scope.row.associatedStatus == 2)?_c('div',[_vm._v("取消关联")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"creationTime","label":"生效时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row.creationTime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"accountEmpName","label":"操作人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"updatedTime","label":"更新时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row.updatedTime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.associatedStatus == 1)?[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.disassociate(scope.row)}}},[_c('span',{staticStyle:{"color":"#f56c6c"}},[_vm._v("取消关联")])])]:undefined}}],null,true)})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('Add',{ref:"Add",on:{"done":_vm.addDone}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T775":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dummyPhoneRecode_vue__ = __webpack_require__("sI1h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7b4b002_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dummyPhoneRecode_vue__ = __webpack_require__("Mn3u");
function injectStyle (ssrContext) {
  __webpack_require__("OQY8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7b4b002"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dummyPhoneRecode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7b4b002_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dummyPhoneRecode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TOzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LookHistoryTwo_vue__ = __webpack_require__("+gcn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84be4b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LookHistoryTwo_vue__ = __webpack_require__("a93p");
function injectStyle (ssrContext) {
  __webpack_require__("GoZ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84be4b3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LookHistoryTwo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84be4b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LookHistoryTwo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TSZV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TYKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.float1Loading),expression:"float1Loading"}],staticClass:"common-box"},[_c('div',{staticClass:"common-box-title common-box-Htitle clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("行业品类")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","round":"","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.showCategoryDialog('行业品类', 1)}}},[_vm._v("编辑\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},_vm._l((_vm.signList),function(item,index){return _c('div',{key:index,staticClass:"label-wrap clearfix"},[_c('div',{staticClass:"floatl label-name"},[_c('img',{attrs:{"src":__webpack_require__("kAZV"),"alt":""}}),_vm._v(" "+_vm._s(item.label)+"\n        ")]),_vm._v(" "),_c('div',{ref:"slideWrap",refInFor:true,staticClass:"label-list clearfix"},[_c('div',{class:{'toggle-btn': item.children ? (item.children.length > _vm.treeCol.length) : false },on:{"click":_vm.toggleSlide}}),_vm._v(" "),_c('div',_vm._l((_vm.treeCol),function(item2,index2){return _c('div',{staticClass:"label-tree floatl"},_vm._l((item.children),function(i,ind){return (ind % _vm.treeCol.length === item2)?_c('el-tree',{key:ind,attrs:{"data":[i],"props":_vm.defaultProps},on:{"node-click":function($event){return _vm.overToggle('body')},"node-expand":function($event){return _vm.overToggle('button')}}}):_vm._e()}),1)}),0)])])}),0)]),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.float2Loading),expression:"float2Loading"}],staticClass:"common-box"},[_c('div',{staticClass:"common-box-title common-box-Htitle clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("岗位类型")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","round":"","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.showCategoryDialog('岗位类型', 2)}}},[_vm._v("编辑\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},_vm._l((_vm.postList),function(item,index){return _c('div',{key:index,staticClass:"post-item"},[_c('div',{staticClass:"tag long",class:{'long': index % 2 == 0, 'short': index % 2 == 1}},[_vm._v(_vm._s(item.label.slice(0, 1))+"\n        ")]),_vm._v("\n        "+_vm._s(item.label)+"\n      ")])}),0)]),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.float3Loading),expression:"float3Loading"}],staticClass:"common-box"},[_c('div',{staticClass:"common-box-title common-box-Htitle clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("自我标签")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","round":"","size":"mini","disabled":_vm.auths.indexOf(2) < 0},on:{"click":_vm.openAddDialog}},[_vm._v("编辑\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"common-box-body cleafix"},_vm._l((_vm.selfLabel),function(item){return _c('div',{key:item.id,staticClass:"self-label floatl"},[_vm._v(_vm._s(item.signName))])}),0)]),_vm._v(" "),_c('el-dialog',{staticClass:"cardDialog dialog",attrs:{"title":_vm.categoryDialogTitle,"visible":_vm.categoryDialog,"width":"780px","center":""},on:{"update:visible":function($event){_vm.categoryDialog=$event}}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.categoryDialogLoading),expression:"categoryDialogLoading"}],staticClass:"dialog-body"},[_c('div',{staticStyle:{"text-align":"right","margin-bottom":"10px"}},[_c('el-button',{attrs:{"type":"primary","round":"","size":"small"},on:{"click":function($event){return _vm.openAddTreeLabelDialog(1, _vm.categoryDialogSignType, null)}}},[_vm._v("\n          + 添加"+_vm._s(_vm.categoryDialogTitle)+"\n        ")])],1),_vm._v(" "),_c('div',{staticStyle:{"max-height":"600px","overflow-y":"scroll"}},[_c('el-tree',{staticClass:"tree-area",attrs:{"indent":30,"data":_vm.categoryDialogList,"props":_vm.defaultProps,"expand-on-click-node":false,"node-key":"value","default-expanded-keys":_vm.expandedIds},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('div',{},[(_vm.categoryDialogSignType != 2)?_c('div',{staticClass:"clearfix",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"floatl title"},[_c('span',{staticClass:"delete-btn",on:{"click":function($event){return _vm.remove(node, data, _vm.categoryDialogSignType)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(node.label))])]),_vm._v(" "),_c('div',{staticClass:"floatr",staticStyle:{"line-height":"42px","margin-left":"10px"}},[_c('el-button',{staticClass:"edit-btn",attrs:{"size":"mini"},on:{"click":function($event){return _vm.editLabelName(node, data)}}},[_c('div',{staticClass:"editBtnIcon"},[_vm._v("修改标签")])]),_vm._v(" "),_c('el-button',{staticClass:"add-btn",attrs:{"size":"mini"},on:{"click":function($event){return _vm.openAddTreeLabelDialog(node.data.signLevel + 1,_vm.categoryDialogSignType,node.data.value)}}},[_c('div',{staticClass:"addBtnIcon"},[_vm._v("添加下级分类")])])],1)]):_c('div',{staticClass:"clearfix",staticStyle:{"width":"100%"}},[(node.label == '不限')?_c('span',[_vm._v(_vm._s(node.label))]):_c('div',[_c('span',{staticClass:"floatl title"},[_c('span',{staticClass:"delete-btn",on:{"click":function($event){return _vm.remove(node,data,_vm.categoryDialogSignType)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(node.label))])]),_vm._v(" "),_c('div',{staticClass:"floatr",staticStyle:{"line-height":"42px","margin-left":"10px"}},[_c('el-button',{staticClass:"edit-btn",attrs:{"size":"mini"},on:{"click":function($event){return _vm.editLabelName(node, data)}}},[_c('div',{staticClass:"editBtnIcon"},[_vm._v("修改标签")])])],1)])])])}}])})],1)]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.categoryDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.categoryDialog = false}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"cardDialog dialog",attrs:{"title":'添加' + _vm.categoryDialogTitle,"visible":_vm.addTreeLabelDialog,"width":"400px","center":""},on:{"update:visible":function($event){_vm.addTreeLabelDialog=$event}}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.addTreeLabelDialogLoading),expression:"addTreeLabelDialogLoading"}]},[_c('div',{staticClass:"dialog-body"},[_c('el-form',{staticClass:"formInline",attrs:{"inline":"","size":"mini"}},[_c('el-input',{staticStyle:{"width":"220px","margin-right":"10px"},attrs:{"size":"mini","placeholder":'请输入新增' + _vm.categoryDialogTitle + '标签的名称...'},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addNewLabel(_vm.addTreeLabelDialogInput, _vm.addTreeLabelDialogSignLevel, _vm.addTreeLabelDialogSignType, _vm.addTreeLabelDialogPid, _vm.addTreeLabelDialogList)}},model:{value:(_vm.addTreeLabelDialogInput),callback:function ($$v) {_vm.addTreeLabelDialogInput=$$v},expression:"addTreeLabelDialogInput"}}),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.addNewLabel(_vm.addTreeLabelDialogInput, _vm.addTreeLabelDialogSignLevel, _vm.addTreeLabelDialogSignType, _vm.addTreeLabelDialogPid, _vm.addTreeLabelDialogList)}}},[_vm._v("\n            确认添加\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"tag-list"},_vm._l((_vm.addTreeLabelDialogList),function(item){return _c('div',{key:item.id,staticClass:"tag-item"},[_vm._v(_vm._s(item.signName)+"\n            "),_c('span',{staticClass:"remove-btn",on:{"click":function($event){return _vm.deleteLabel(item)}}})])}),0)],1),_vm._v(" "),_c('div',{staticClass:"el-dialog__footer",staticStyle:{"text-align":"center","padding":"10px 0"}},[_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.addTreeLabelDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.saveUpdate(_vm.addTreeLabelDialogSignType)}}},[_vm._v("确 定")])],1)])])]),_vm._v(" "),_c('el-dialog',{staticClass:"cardDialog dialog",attrs:{"title":"自我标签","visible":_vm.addDialog,"width":"780px","center":""},on:{"update:visible":function($event){_vm.addDialog=$event},"close":_vm.getData}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.addDialogLoading),expression:"addDialogLoading"}],staticClass:"dialog-body"},[_c('el-form',{staticClass:"formInline",attrs:{"inline":"","size":"mini"}},[_c('el-input',{staticStyle:{"width":"220px","margin-right":"10px"},attrs:{"size":"mini","placeholder":"请输入新增标签的名称..."},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addNewLabel(_vm.addDialogInput, null, 3, null, _vm.addDialogList)}},model:{value:(_vm.addDialogInput),callback:function ($$v) {_vm.addDialogInput=$$v},expression:"addDialogInput"}}),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.addNewLabel(_vm.addDialogInput, null, 3, null, _vm.addDialogList)}}},[_vm._v("\n          确认添加\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"tag-list"},_vm._l((_vm.addDialogList),function(item){return _c('div',{key:item.id,staticClass:"tag-item"},[_vm._v(_vm._s(item.signName)+"\n          "),_c('span',{staticClass:"remove-btn",on:{"click":function($event){return _vm.deleteSelfLabel(item)}}})])}),0)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.addDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",staticStyle:{"background-color":"#8299dc"},attrs:{"size":"small","disabled":_vm.addDialogLoading},on:{"click":function($event){return _vm.saveUpdate(3)}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"cardDialog dialog",attrs:{"title":_vm.categoryDialogTitle,"visible":_vm.editLabelNameDialog,"width":"400px","center":""},on:{"update:visible":function($event){_vm.editLabelNameDialog=$event}}},[_c('div',{staticClass:"dialog-body",staticStyle:{"margin-top":"15px"}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":"","size":"mini"}},[_c('el-form-item',{attrs:{"label":"标签名称："}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"size":"mini"},model:{value:(_vm.editForm.jobTypeName),callback:function ($$v) {_vm.$set(_vm.editForm, "jobTypeName", $$v)},expression:"editForm.jobTypeName"}})],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.editLabelNameDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":_vm.saveEditLabel}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UEaS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Udey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"筛选"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"200px","size":"mini"}},[_c('div',{staticClass:"slide-wrap",staticStyle:{"height":"auto"}},[_c('el-form-item',{attrs:{"label":"开始日期"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.param.startDate),callback:function ($$v) {_vm.$set(_vm.param, "startDate", $$v)},expression:"param.startDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结束日期"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.param.endDate),callback:function ($$v) {_vm.$set(_vm.param, "endDate", $$v)},expression:"param.endDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"员工id"}},[_c('el-input',{attrs:{"placeholder":"请输入员工id...","maxlength":30},model:{value:(_vm.param.clerkId),callback:function ($$v) {_vm.$set(_vm.param, "clerkId", $$v)},expression:"param.clerkId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":20},model:{value:(_vm.param.clerkName),callback:function ($$v) {_vm.$set(_vm.param, "clerkName", $$v)},expression:"param.clerkName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省"}},[_c('el-input',{attrs:{"placeholder":"请输入所在省...","maxlength":15},model:{value:(_vm.param.province),callback:function ($$v) {_vm.$set(_vm.param, "province", $$v)},expression:"param.province"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"市"}},[_c('el-input',{attrs:{"placeholder":"请输入所在市...","maxlength":15},model:{value:(_vm.param.city),callback:function ($$v) {_vm.$set(_vm.param, "city", $$v)},expression:"param.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"县"}},[_c('el-input',{attrs:{"placeholder":"请输入所在县...","maxlength":15},model:{value:(_vm.param.country),callback:function ($$v) {_vm.$set(_vm.param, "country", $$v)},expression:"param.country"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店名称"}},[_c('el-input',{attrs:{"placeholder":"请输入所在门店名称...","maxlength":15},model:{value:(_vm.param.storeName),callback:function ($$v) {_vm.$set(_vm.param, "storeName", $$v)},expression:"param.storeName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店编号"}},[_c('el-input',{attrs:{"placeholder":"请输入所在门店编号...","maxlength":15},model:{value:(_vm.param.storeCode),callback:function ($$v) {_vm.$set(_vm.param, "storeCode", $$v)},expression:"param.storeCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"扫码消费者微信昵称"}},[_c('el-input',{attrs:{"placeholder":"请输入扫码消费者微信昵称...","maxlength":25},model:{value:(_vm.param.wechatName),callback:function ($$v) {_vm.$set(_vm.param, "wechatName", $$v)},expression:"param.wechatName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员回收样是否有效"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.isValid),callback:function ($$v) {_vm.$set(_vm.param, "isValid", $$v)},expression:"param.isValid"}},_vm._l((_vm.chooseValid),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"无效样本原因"}},[_c('el-input',{attrs:{"placeholder":"请输入无效样本原因...","maxlength":25},model:{value:(_vm.param.reasonStr),callback:function ($$v) {_vm.$set(_vm.param, "reasonStr", $$v)},expression:"param.reasonStr"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"活动名称"}},[_c('el-input',{attrs:{"placeholder":"请输入活动名称...","maxlength":25},model:{value:(_vm.param.activityName),callback:function ($$v) {_vm.$set(_vm.param, "activityName", $$v)},expression:"param.activityName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"供应商名称"}},[_c('el-input',{attrs:{"placeholder":"请输入供应商名称...","maxlength":25},model:{value:(_vm.param.supplierName),callback:function ($$v) {_vm.$set(_vm.param, "supplierName", $$v)},expression:"param.supplierName"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.resetParams}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.searchData}},[_vm._v("筛选")])],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.handling),expression:"handling"}],attrs:{"label":"上传数据","element-loading-text":"正在处理中"}},[_c('div',{staticStyle:{"text-align":"center","padding":"50px"}},[_c('el-upload',{attrs:{"action":"/rest/questionnaire/import","before-upload":_vm.handlePreview,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.tableData}},[_c('el-table-column',{attrs:{"width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"createDate","label":"日期","align":"center","formatter":_vm.dateFormat}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"clerkId","label":"员工id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"clerkName","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"91","prop":"province","label":"所在省","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"91","prop":"city","label":"所在市","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"91","prop":"country","label":"所在县","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"91","prop":"storeName","label":"门店名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"91","prop":"storeCode","label":"门店编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"wechatName","label":"扫码消费者微信昵称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"isValid","label":"促销员回收样是否有效","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isValid == 1)?_c('div',[_vm._v("有效")]):_vm._e(),_vm._v(" "),(scope.row.isValid == 0)?_c('div',[_vm._v("无效")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"300","prop":"reasonStr","label":"无效样本原因","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"activityName","label":"活动名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"supplierName","label":"供应商名称","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ufaa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ1RDExRTNCREZBRjExRTc4RTM2RkE2QzkzMkEwNEI1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQ1RDExRTNDREZBRjExRTc4RTM2RkE2QzkzMkEwNEI1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDVEMTFFMzlERkFGMTFFNzhFMzZGQTZDOTMyQTA0QjUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDVEMTFFM0FERkFGMTFFNzhFMzZGQTZDOTMyQTA0QjUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz58dBKqAAABV0lEQVR42syUv0oDQRCH70wEg1HQl/AdEhD/IFaioD6CHMHKJlFECwOWdhbXBGzt9RlELbTRRoQQCCjYaDRI1PMbmZN13TtTpHDgYza5vd/OzM6cH0WR1wvr83pk2XgRBMEKbhPy4P/xnqTxCrUwDLd+CGHbcAZHXUT6ATNQgl9CEkkTrvXENJOIx8zIs1aaq0qSvUPG+N1yCXXgAA6tzbFJTQbgWZ8vwpJLSE47pXjHSeFwIeu4fvZUWY+wXnAJSb5DKSK7uA2JnHUogmaN7Ntps2kUarBviOypSAMmiegeP+jsI7U3PUXyH0agpTe4BnWpCSLnujeT1tk5Nj7gZ+EGylCBW5g3RDy7RWyhr1N44QS3DHcgaczx32W3s+Zrap6KXeAmYJr1VUJPORvyBcapy5NGJqG3tdhFa/5EZCp+bgvt6NAWHAPqGuJHqH6n8+++R58CDABQ22VPeDPJvAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Uhh2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UiCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_c('span',[_vm._v("项目名称："+_vm._s(_vm.dataList[0].projectName))]),_vm._v(" "),_c('span',[_vm._v("门店："+_vm._s(_vm.dataList[0].storeName))]),_vm._v(" "),_c('span',[_vm._v("岗位："+_vm._s(_vm.dataList[0].posName))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.Child.planNumber)+"\n    "),_c('div',[_c('div',[_vm._v(_vm._s(_vm.dataList[0].planNumber))]),_vm._v(" "),_c('div',[_vm._v("计划人数")])]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(_vm.dataList[0].recruitsNumber))]),_vm._v(" "),_c('div',[_vm._v("招聘人数")])]),_vm._v(" "),_c('div',[(_vm.dataList[0].waitNumber)?_c('div',[_vm._v(_vm._s(_vm.dataList[0].waitNumber))]):_c('div',[_vm._v("0")]),_vm._v(" "),_c('div',[_vm._v("待审核人数")])]),_vm._v(" "),_c('div',[(_vm.dataList[0].interviewPassNumber)?_c('div',[_vm._v(_vm._s(_vm.dataList[0].interviewPassNumber))]):_c('div',[_vm._v("0")]),_vm._v(" "),_c('div',[_vm._v("审核通过人数")])])]),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中...","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"60","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"name","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"salesmanEmpPk","label":"促销员ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"attendanceRate","label":"考勤率","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"realNameAuthenticationTime","label":"实名认证时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"id":"mask_box","width":"110","prop":"telEncrypt","label":"联系电话","align":"center"},on:{"click":function($event){return _vm.createOutCall(_vm.scope.row.salesmanEmpPk, _vm.scope.row.name, _vm.scope.row.tel, '', _vm.dataList[0].projectCode, _vm.dataList[0].projectName)}},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":"##","id":"mask_box"},on:{"click":function($event){return _vm.createOutCall(scope.row.salesmanEmpPk, scope.row.name, scope.row.tel, '', _vm.dataList[0].projectCode, _vm.dataList[0].projectName)}}},[_vm._v(_vm._s(scope.row.telEncrypt))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"idCardEncrypt","label":"身份证号码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"applyTime","label":"应聘时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","label":"操作时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v("\n            "+_vm._s(_vm.formatTime2(scope.row.updateTime))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"stroeName","label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.auditStatus == -1)?_c('div',[_vm._v("该促销员为在岗状态")]):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 1)?_c('div',[_vm._v("未审核")]):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 4)?_c('div',[_vm._v("释放")]):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 5)?_c('div',[_vm._v("审核不通过")]):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 6)?_c('div',[_vm._v("审核通过")]):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 7)?_c('div',[_vm._v("释放")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"interviewerName","label":"审核者","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"releaserName","label":"释放者","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"160","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.auditStatus == 5  || scope.row.auditStatus == -1 ||(scope.row.auditStatus == 7 && scope.row.projectCategoryConfig != 'MNPG2202'))?_c('div',[_c('el-button',{staticStyle:{"color":"gray"},attrs:{"type":"text","size":"small","disabled":""}},[_vm._v("——")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{staticStyle:{"color":"gray"},attrs:{"type":"text","size":"small","disabled":""}},[_vm._v("——")])],1):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 6 && scope.row.releaseEnabled)?_c('div',[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.operation(scope.row,7,'释放')}}},[_vm._v("释放")])],1):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 1)?_c('div',[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.operation(scope.row,6,'审核通过')}}},[_vm._v("审核通过")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.operation(scope.row,5,'审核不通过')}}},[_vm._v("审核不通过")])],1):_vm._e(),_vm._v(" "),(scope.row.auditStatus == 7 && scope.row.projectCategoryConfig == 'MNPG2202')?_c('div',[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.operation(scope.row,8,'重新录用')}}},[_vm._v("重新录用")])],1):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"60%","margin":"0 auto"}},[_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"total":_vm.total,"layout":"total,prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog PromotersDialog",attrs:{"title":"释放处理","width":"600px","center":true,"show-close":false,"visible":_vm.release,"append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.release=$event}}},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("确认将该人员从此任务上释放吗？")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"40px"}},[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.changeRelease}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.submitRelease}},[_vm._v("提交")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uz+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("eZ4F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224f1343_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("YF/y");
function injectStyle (ssrContext) {
  __webpack_require__("gF0Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-224f1343"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224f1343_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VB5x":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "VNqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"container taskAudit",attrs:{"element-loading-text":"拼命加载中"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"筛选"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"100px","size":"mini","rules":_vm.rules}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"任务编号"}},[_c('el-input',{attrs:{"placeholder":"请输入准确的项目编号...","maxlength":30},model:{value:(_vm.param.taskNo),callback:function ($$v) {_vm.$set(_vm.param, "taskNo", $$v)},expression:"param.taskNo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务名称"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称..."},model:{value:(_vm.param.taskName),callback:function ($$v) {_vm.$set(_vm.param, "taskName", $$v)},expression:"param.taskName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"duration",attrs:{"label":"任务参与时间"}},[_c('el-date-picker',{staticStyle:{"width":"45%","float":"left","display":"inline-block"},attrs:{"type":"date","size":"mini","format":"yyyy 年 MM 月 dd 日","placeholder":"任务开始时间"},model:{value:(_vm.param.during.start),callback:function ($$v) {_vm.$set(_vm.param.during, "start", $$v)},expression:"param.during.start"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","width":"10%","text-align":"center","float":"left"}},[_vm._v("—")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"45%","float":"left","display":"inline-block"},attrs:{"type":"date","size":"mini","format":"yyyy 年 MM 月 dd 日","placeholder":"任务结束时间"},model:{value:(_vm.param.during.end),callback:function ($$v) {_vm.$set(_vm.param.during, "end", $$v)},expression:"param.during.end"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.state),callback:function ($$v) {_vm.$set(_vm.param, "state", $$v)},expression:"param.state"}},[_c('el-option',{attrs:{"label":"不限","value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":"活动中","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已结束","value":2}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员姓名","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":10},model:{value:(_vm.param.salesManName),callback:function ($$v) {_vm.$set(_vm.param, "salesManName", $$v)},expression:"param.salesManName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证...","maxlength":18},model:{value:(_vm.param.idCard),callback:function ($$v) {_vm.$set(_vm.param, "idCard", $$v)},expression:"param.idCard"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("展开筛选项")])],1)],1)],1)])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"common-box",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("筛选结果")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.getExcel}},[_vm._v("\n        导出表格 "),_c('i',{staticClass:"el-icon-download"})])],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","tooltip-effect":"dark","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"projectNo","label":"任务编号","width":"100","align":"center","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"任务名称","min-width":"300","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salesmanName","label":"姓名","min-width":"90","align":"center","formatter":_vm.formatName}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idcard","label":"身份证号","min-width":"135","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"开始时间","min-width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"结束时间","min-width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"任务提交时间","min-width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"任务状态","min-width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"操作","min-width":"180","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.taskDetail(scope.row)}}},[_vm._v("任务详情")]),_vm._v("\n            |\n            "),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.pass(scope.row)}}},[_vm._v("审核通过")]),_vm._v("\n            |\n            "),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.notPass(scope.row)}}},[_vm._v("审核不通过")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.param.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.param.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VTob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"1260px","center":true,"show-close":true,"visible":_vm.visiable,"close-on-click-modal":false,"top":"10vh"},on:{"update:visible":function($event){_vm.visiable=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('div',{staticStyle:{"font-size":"18px","margin-bottom":"4px"}},[_vm._v(_vm._s(_vm.item[1]))]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.item[3]))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('el-form',{attrs:{"model":_vm.param,"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50,"clearable":""},model:{value:(_vm.param.projectCode),callback:function ($$v) {_vm.$set(_vm.param, "projectCode", $$v)},expression:"param.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50,"clearable":""},model:{value:(_vm.param.projectName),callback:function ($$v) {_vm.$set(_vm.param, "projectName", $$v)},expression:"param.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.associatedStatus),callback:function ($$v) {_vm.$set(_vm.param, "associatedStatus", $$v)},expression:"param.associatedStatus"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"生效中","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已失效","value":"2"}})],1)],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1),_vm._v(" "),_c('div',[_c('el-button',{staticStyle:{"padding-left":"20px","padding-right":"20px"},attrs:{"type":"primary","size":"mini","icon":"el-icon-plus"},on:{"click":function($event){return _vm.add()}}},[_vm._v("\n        新增")])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"mini","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"minWidth":"200","prop":"[2]","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"[3]","minWidth":"200","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"[4]","label":"项目开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"[5]","label":"项目结束日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row[6] == 1)?_c('div',{staticStyle:{"color":"#66cc33"}},[_vm._v("关联中")]):_vm._e(),_vm._v(" "),(scope.row[6] == 2)?_c('div',[_vm._v("取消关联")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[7]","label":"操作人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[8]","label":"更新时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row[8])))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row[6] == 1)?[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.disassociate(scope.row)}}},[_c('span',{staticStyle:{"color":"#f56c6c"}},[_vm._v("取消关联")])])]:undefined}}],null,true)})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('Add',{ref:"Add",on:{"done":_vm.addDone}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vi8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_images_idCard_img_png__ = __webpack_require__("ImiH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_images_idCard_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_images_idCard_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_images_idCard_img2_png__ = __webpack_require__("jlKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_images_idCard_img2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_images_idCard_img2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_images_bankCard_img_png__ = __webpack_require__("4inT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_images_bankCard_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_images_bankCard_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_images_idCardBack_demo_png__ = __webpack_require__("q/7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_images_idCardBack_demo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_images_idCardBack_demo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_images_idCardCover_demo_png__ = __webpack_require__("ZjmJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_images_idCardCover_demo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_images_idCardCover_demo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_images_headImg_demo_png__ = __webpack_require__("CwPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_images_headImg_demo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_common_images_headImg_demo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_filterTab__ = __webpack_require__("4AQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_salespersonInfo__ = __webpack_require__("iepA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_js_formRules__ = __webpack_require__("8jay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_v_distpicker__ = __webpack_require__("95YI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_v_distpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_v_distpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_personnelCenter_baseCenter_LogOut_vue__ = __webpack_require__("ye6h");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilterTab: __WEBPACK_IMPORTED_MODULE_9_components_filterTab__["a" /* default */],
    SalespersonInfo: __WEBPACK_IMPORTED_MODULE_10_components_salespersonInfo__["a" /* default */],
    VDistpicker: __WEBPACK_IMPORTED_MODULE_13_v_distpicker___default.a,
    LogOut: __WEBPACK_IMPORTED_MODULE_14__views_personnelCenter_baseCenter_LogOut_vue__["a" /* default */]
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
      pageNo: 1,
      pageSize: 10,
      total: null,
      formData: {
        name: null,
        idcard: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        sex: null,
        educationId: null,
        status: null,
        starLevelId: null,
        agreement: null,
        channel: null,
        ageMin: null,
        ageMax: null,
        heightMin: null,
        heightMax: null,
        creditScoreMin: null,
        creditScoreMax: null,
        projectNumMin: null,
        projectNumMax: null,
        workMonthMin: null,
        workMonthMax: null,
        frequencyNumMin: null,
        frequencyNumMax: null,
        projectPriceMin: null,
        projectPriceMax: null,
        postId: 0,
        pageNo: 1,
        pageSize: 10,
        authorizeFlag: null
      },

      tableData: [],
      idList: [],
      idArr: [],
      resultList: [],
      reasonList: [],
      projectDropDownList: [], //所属项目选择
      projectDropDownListKeep: [], //存储所属项目选择
      unbindDialog: false, //注册解绑界面
      resetDialog: false, //认证重置界面
      blacklistDialog: false,
      greylistDialog: false,
      idCardDialog: false,
      bankCardDialog: false,
      personInfoDialog: false,
      approveDialog: false, //人工认证弹窗
      idCardCover_demo: __WEBPACK_IMPORTED_MODULE_7_common_images_idCardCover_demo_png___default.a, //人工认证弹窗中三张默认照片
      idCardBack_demo: __WEBPACK_IMPORTED_MODULE_6_common_images_idCardBack_demo_png___default.a,
      headImg_demo: __WEBPACK_IMPORTED_MODULE_8_common_images_headImg_demo_png___default.a,
      isUploading: '', //当前即将被校验的头像类型
      approveData: { //人工认证相关信息
        lockApproveDialog: false, //人工认证窗口的loading，防上传照片连续点击
        approvingID: '', //正在被人工认证的人的id
        newName: "", //新的姓名
        newIdcard: null, //新的身份证号
        lockIdCard: false, //上传图片后锁定身份证号字段，图片存储时命名需要，不然每张图都用不同的身份证号就乱套了
        headImg: '', //头像地址，仅用于成功后显示
        idCardCoverImg: '', //身份证正面地址，仅用于成功后显示
        idCardBackImg: '', //身份证背面地址，仅用于成功后显示
        headImgUpName: { name: '' }, //上传时头像的文件名字
        idCardCoverUpName: { name: '' }, //上传时身份证正面的文件名字
        idCardBackUpName: { name: '' }, //上传时身份证背面的文件名字
        lockConfirm: false, //上传过程中防连续点击，锁定确认按钮的可用状态
        empPk: "", // 促销员ID
        idcardValidStart: "",
        idcardValidEnd: "",
        applicant: "", //申请人
        applyReason: "", //申请原因
        projectCode: "", //所属项目 实际是projectCode&orgName 提交时剪掉
        orgName: "", //所属部门
        id: ""
      },
      rules: { //人工认证中的校验
        newIdcard: [__WEBPACK_IMPORTED_MODULE_11__common_js_formRules__["a" /* default */].idcard],
        applicant: [__WEBPACK_IMPORTED_MODULE_11__common_js_formRules__["a" /* default */].applicant]
      },
      reason: '',
      listLoading: false,

      SalespersonId: '',
      idcardCoverImg: '',
      idcardBackImg: '',
      bankCoverImg: '',
      idcardNum: '',
      bank: '',
      bankNum: '',

      idcardDefaultCover: __WEBPACK_IMPORTED_MODULE_3_common_images_idCard_img_png___default.a,
      idcardDefaultBack: __WEBPACK_IMPORTED_MODULE_4_common_images_idCard_img2_png___default.a,
      bankcardDefaultCover: __WEBPACK_IMPORTED_MODULE_5_common_images_bankCard_img_png___default.a,

      showbigImage: false,
      bigImage: null,
      bigImageWidth: null,
      bigImageHeight: null,
      bigImageWidth2: null,
      type: null,

      // 页面内权限
      auths: [],
      current: 0,
      num: 0,
      isAdmin: false, //是否是超级管理员进入
      operationLogDialog: false, // 操作日志
      operationLogTableData: [], // 操作日志数据
      operationLogFormData: { // 操作日志筛选条件
        pageNo: 1,
        pageSize: 10,
        salesmanName: null,
        idcard: null,
        operationType: "",
        userName: null,
        userAccount: null,
        tel: null,
        empPk: null
      },
      operationTotal: null,
      operationLoading: false,
      bankCardDialogFlag: false,
      bankCardArtificialData: {
        salesmanId: null,
        bank: null, // 开户行
        bankNum: null, // 银行卡号
        salesmanName: null, // 促销员姓名
        bankCover: null, // 银行卡照片
        bankCoverName: {
          name: null // 上传银行卡照片名字
        },
        branch: '', // 开户支行信息
        branchList: null, // 支行列表
        bankAddress: { // 开户行地址
          province: null,
          city: null,
          area: null
        },
        bankAddressCode: { // 开户行地址编码
          province: null,
          city: null,
          area: null
        },
        unionPayNo: null, // 联行号
        applicant: "", //申请人
        applyReason: "", //申请原因
        projectCode: "", //所属项目 实际是projectCode&orgName 提交时剪掉
        orgName: "" //所属部门
      },
      // 项目所有客户
      customerList: [],
      // 显示签约合同记录
      showContractDialog: false,
      contractDialogTitle: null,
      contractLoading: false,
      // 签约合同记录筛选条件
      contractFormData: {
        pageNo: 1,
        pageSize: 10,
        startTimeFrom: null,
        startTimeTo: null,
        endTimeFrom: null,
        endTimeTo: null,
        customer: null,
        serviceSupplier: null
      },
      contractTotal: null,
      contractData: null,
      authorizeDialogFlag: false,
      authorizeDialogSalesmanName: "",
      authorizeDialogList: [],
      authorizeDialog1: false,
      authorizeDialog2: false,
      authorizeDialog3: false,
      authorizeDialog4: false,
      authorizeDialog5: false,
      authorizeDialog6: false,
      authorizeDialog7: false,
      authorizeDialog8: false,
      authorizeDialog9: false,
      authorizeDialog10: false,
      authorizeDialog11: false,
      authorizeDialog12: false,
      authorizeDialog13: false,
      authorizeDialog14: false,
      authorizeDialog15: false,
      authorizeDialog16: false,
      authorizeDialog18: false,
      authorizeDialog19: false,
      authorizeDialog20: false,
      authorizeDialog21: false,
      authorizeDialog22: false
    }, 'isAdmin', false);
  },
  mounted: function mounted() {
    var user = sessionStorage.getItem('user');
    this.isAdmin = Boolean(user == 'admin1' || user == 'tinashi');
    this.getData();
    this.getAuth();
    this.searchAllCustomer();
    //判断是否是超级管理员
    var x = sessionStorage.getItem('user');
    this.isAdmin = Boolean(x == 'admin1' || x == 'tinashi');
    this.getProjDropDownList();
  },

  methods: {
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (this.isAdmin) {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      }
    },
    formatBankCard: function formatBankCard(row, column, cellValue) {
      if (this.isAdmin) {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].plusXing(cellValue, 4, 7);
      }
    },
    formatTel: function formatTel(row, column, cellValue) {
      if (this.isAdmin) {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].plusXing(cellValue, 3, 4);
      }
    },
    formatTel1: function formatTel1(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].plusXing(cellValue, 3, 4);
    },
    formatName: function formatName(row, column, cellValue) {
      var a = cellValue[0];
      if (this.isAdmin) {
        return cellValue;
      } else {
        for (var i = 0; i < cellValue.length - 1; i++) {
          a = a + '*';
        }
        return a;
      }
    },
    rotate: function rotate() {
      this.current = (this.current + 90) % 360;
      this.num++;

      // document.getElementsByClassName('dialogImage')[0].style.transform = 'rotate('+this.current+'deg)'
      console.log('点旋转图片', document.getElementsByClassName('dialogImage')[0]);

      document.getElementsByClassName('dialogImage')[0].parentNode.style.transform = 'rotate(' + this.current + 'deg)';
      // document.getElementsByClassName('dialogImage')[0].parentNode.parentNode.setAttribute("style","width:900px");
      // console.log(document.getElementsByClassName('dialogImage')[0].parentNode)
      // this.bigImageWidth2 = '600px'
    },

    // 图片出错
    setErrorImage: function setErrorImage(event) {
      switch (this.type) {
        case 1:
          event.target.parentNode.style.backgroundImage = 'url(' + this.idcardDefaultCover + ')';
          break;
        case 2:
          event.target.parentNode.style.backgroundImage = 'url(' + this.idcardDefaultBack + ')';
          break;
        case 3:
          event.target.parentNode.style.backgroundImage = 'url(' + this.bankcardDefaultCover + ')';
          break;
      }
    },

    // 查看原图
    viewImage: function viewImage(url, type) {
      this.type = type;
      this.showbigImage = true;
      this.current = 0;
      this.num++;

      var width = void 0;
      var height = void 0;
      if (type == 1) {
        if (url == null) {
          this.bigImage = this.idcardDefaultCover;
        } else {
          this.bigImage = url;
        }
        width = document.getElementsByClassName('floatle')[0].width;
        height = document.getElementsByClassName('floatle')[0].height;
      } else if (type == 2) {
        if (url == null) {
          this.bigImage = this.idcardDefaultBack;
        } else {
          this.bigImage = url;
        }
        width = document.getElementsByClassName('floatri')[0].width;
        height = document.getElementsByClassName('floatri')[0].height;
      } else {
        if (url == null) {
          this.bigImage = this.bankcardDefaultCover;
        } else {
          this.bigImage = url;
        }
        width = document.getElementsByClassName('bankCardss')[0].width;
        height = document.getElementsByClassName('bankCardss')[0].height;
      }
      // debugger
      width > 500 ? (width = width / 2, height = height / 2) : (width, height);
      width < 400 ? (width = 300, height = 300) : (width, height);
      this.bigImageWidth = width + 'px';
      this.bigImageWidth2 = width + 40 + 'px';
      this.bigImageHeight = height + 'px';
      if (document.getElementsByClassName('dialogImage').length != 0) {
        document.getElementsByClassName('dialogImage')[0].parentNode.style.transform = 'rotate(0deg)';
      }
    },
    avatarBigImg: function avatarBigImg(url) {
      if (url != null) {
        return {
          backgroundImage: 'url(' + url + ')',
          backgroundSize: 'cover'
          // width:this.bigImageWidth,
          // height:this.bigImageHeight
        };
      } else {
        return {
          backgroundImage: 'url(' + this.avatarDefault + ')',
          backgroundSize: 'cover'
          // width:this.bigImageWidth,
          // height:this.bigImageHeight
        };
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    getParam: function getParam(data) {
      //这里的pagesize有较大可能会传来48，需要按照本页的要求重置一下
      var size = this.formData.pageSize;
      this.formData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.formData, data);
      this.formData.pageSize = size;
      this.formData.pageNo = 1;
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      this.$http({
        method: "POST",
        url: '/rest/baseCenter/search',
        data: this.formData
      }).then(function (res) {
        _this.listLoading = false;
        _this.tableData = res.data;
        console.log(res.data[0].isLogout);
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this, "error", err.response, '查询失败，请稍后重试');
        _this.listLoading = false;
      });

      this.$http({
        method: "POST",
        url: '/rest/baseCenter/searchCount',
        data: this.formData
      }).then(function (res) {
        _this.total = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this, "error", err.response, '查询失败，请稍后重试');
      });
    },
    getAuth: function getAuth() {
      var _this2 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 2,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          _this2.auths.push(item.auth);
        });
        if (_this2.auths.indexOf(2) >= 0 || _this2.auths.indexOf(3) >= 0) {
          _this2.auths.push(1);
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this2, "error", err.response, '查询失败，请稍后重试');
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.idList = [];
      this.resultList = [];
      val.forEach(function (item) {
        _this3.idList.push({ id: item.id });
        _this3.resultList.push(item);
      });
    },

    // 解绑身份证
    batchIdcard: function batchIdcard() {
      var _this4 = this;

      this.unbindDialog = true;
      this.clearApproveData();
      this.idList.forEach(function (item) {
        _this4.idArr.push(item.id);
      });
    },


    //注册解绑
    unbindIdCardConfirm: function unbindIdCardConfirm() {
      var _this5 = this;

      if (!this.approveData.applicant) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请人');
        return false;
      } else if (!this.approveData.applyReason) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请原因');
        return false;
      }
      // console.log(this.idArr);
      // return
      this.$http({
        method: 'POST',
        url: '/rest/baseCenter/batchUnbindIdCard',
        data: this.idArr,
        params: {
          applicant: this.approveData.applicant,
          applyReason: this.approveData.applyReason,
          projectCode: this.approveData.projectCode.split('&')[0],
          orgName: this.getOptcode("idcard")
        }
      }).then(function (res) {
        if (res.data.code == '0' && res.data.status == 200) {
          _this5.getData();
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this5, "success", res, '操作成功');
          _this5.unbindDialog = false;
        } else {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this5, "error", res, '操作失败，请稍后重试');
        }
        _this5.idArr = [];
        _this5.idList = [];
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this5, "error", err.response, '操作失败，请稍后重试');
      });
    },
    showLogout: function showLogout() {
      this.$refs.LogOut.show();
    },

    // 解绑银行卡
    batchBank: function batchBank() {
      var _this6 = this;

      this.$confirm('确认解绑用户银行卡?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var idArr = [];
        _this6.idList.forEach(function (item) {
          idArr.push(item.id);
        });
        _this6.$http({
          method: 'POST',
          url: '/rest/baseCenter/batchUnbindBankCard',
          data: idArr
        }).then(function (res) {
          if (res.data.code == '0' && res.data.status == 200) {
            _this6.getData();
            __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this6, "success", res, '操作成功');
          } else {
            __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this6, "error", res, '操作失败，请稍后重试');
          }
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this6, "error", err.response, '操作失败，请稍后重试');
        });
      }).catch(function () {});
    },

    // 更改合约状态
    batchMarkAgreement: function batchMarkAgreement() {
      var _this7 = this;

      this.$confirm('确认更改用户合约状态？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.$http({
          method: "POST",
          url: '/rest/baseCenter/batchMarkAgreement',
          data: _this7.idList
        }).then(function (res) {
          if (res.data.code == '0' && res.data.status == 200) {
            _this7.getData();
            __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this7, 'success', res, '操作成功');
          } else {
            __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this7, 'error', res, '操作失败，请稍后重试');
          }
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this7, "error", err.response, '操作失败，请稍后重试');
        });
      }).catch(function () {});
    },

    //认证状态
    approveReset: function approveReset(id) {
      this.resetDialog = true;
      this.clearApproveData();
      this.approveData.id = id;
    },
    resetConfirm: function resetConfirm() {
      var _this8 = this;

      if (!this.approveData.applicant) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请人');
        return false;
      } else if (!this.approveData.applyReason) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请原因');
        return false;
      }
      this.$http({
        method: "GET",
        url: '/rest/Register/unbindIdentity',
        params: {
          salesmanId: this.approveData.id,
          applicant: this.approveData.applicant,
          applyReason: this.approveData.applyReason,
          projectCode: this.approveData.projectCode.split('&')[0],
          orgName: this.getOptcode("idcard")
        }
      }).then(function (res) {
        if (res.data.code == '0' && res.data.status == 200) {
          _this8.getData();
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this8, 'success', res, '操作成功');
        } else {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this8, 'error', res, '操作失败，请稍后重试');
        }
        _this8.resetDialog = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this8, "error", err.response, '操作失败，请稍后重试');
      });
    },

    // 确认拉黑
    batchBlack: function batchBlack() {
      var _this9 = this;

      this.reasonList = [];
      this.idList.forEach(function (item) {
        _this9.reasonList.push({
          id: item.id,
          reason: _this9.reason,
          operatorId: sessionStorage.getItem('sysUserId')
        });
      });
      this.$http({
        method: "POST",
        url: '/rest/baseCenter/batchBlack',
        data: this.reasonList
      }).then(function (res) {
        _this9.blacklistDialog = false;
        if (res.data.code == '0' && res.data.status == 200) {
          _this9.getData();
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this9, 'success', res, '操作成功');
        } else {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this9, 'error', res, '操作失败，请稍后重试');
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this9, "error", err.response, '操作失败，请稍后重试');
        _this9.blacklistDialog = false;
      });
    },
    batchGrey: function batchGrey() {
      var _this10 = this;

      var reasonList = [];
      var ids = {};
      this.idList.forEach(function (item) {
        reasonList.push(item.id);
      });
      ids.salesmanIdLst = reasonList;
      ids.reason = this.reason;
      ids.operatorId = sessionStorage.getItem('sysUserId');
      this.$http({
        method: "POST",
        url: '/rest/baseCenter/batchGrey',
        data: ids
      }).then(function (res) {
        _this10.greylistDialog = false;
        if (res.data.code == '0' && res.data.status == 200) {
          _this10.getData();
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this10, 'success', res, '操作成功');
        } else {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this10, 'error', res, '操作失败，请稍后重试');
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this10, "error", err.response, '操作失败，请稍后重试');
        _this10.greylistDialog = false;
      });
    },

    // 身份证对话框
    showIdCardDialog: function showIdCardDialog(row) {
      this.idCardDialog = true;
      this.idcardNum = row.idcard;
      if (!this.isAdmin) {
        this.idcardNum = __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].plusXing(row.idcard, 6, 4);
      }
      this.idcardCoverImg = row.idcardCover;
      this.idcardBackImg = row.idcardBack;
    },

    // 银行卡对话框
    showBankCardDialog: function showBankCardDialog(row) {
      this.bankCardDialog = true;
      this.bankCoverImg = row.bankCover;
      this.bank = row.bank;
      this.bankNum = row.bankNum;
      if (!this.isAdmin) {
        this.bankNum = __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].plusXing(row.bankNum, 4, 7);
      }
    },

    // 查看详情
    viewInfo: function viewInfo(id) {
      this.personInfoDialog = true;
      this.SalespersonId = id;
    },

    //人工认证
    approveByAdmin: function approveByAdmin(row) {
      var _this11 = this;

      //先通过后台验证此人是否可以人工认证（好像只有身份认证的可以），可以才继续
      this.$http({
        method: "POST",
        url: '/rest/IdCard/getCrmSalesmanInfo',
        params: {
          salesmanId: row.id
        }
      }).then(function (res) {
        _this11.approveDialog = true;
        _this11.clearApproveData();
        //先清空再赋值
        _this11.approveData.approvingID = row.id;
        _this11.approveData.newName = row.name;
        _this11.approveData.newIdcard = row.idcard;
        _this11.approveData.idcardValidStart = row.idcardValidStart && '';
        _this11.approveData.idcardValidEnd = row.idcardValidEnd && '';
        _this11.approveData.applicant = row.applicant;
        _this11.approveData.applyReason = row.applyReason;
        _this11.approveData.projectCode = row.projectCode && '';
        _this11.approveData.orgName = row.orgName && '';
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this11, 'warning', err.response, '查询失败，请稍后重试');
      });
    },

    //人工认证界面确认
    approveConfirm: function approveConfirm() {
      var _this12 = this;

      if (!this.approveData.newName) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写姓名');
        return false;
      } else if (!this.approveData.applicant) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请人');
        return false;
      } else if (!this.approveData.applyReason) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请原因');
        return false;
      } else if (!this.approveData.idCardCoverImg) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须上传身份证正面');
        return false;
      } else if (!this.approveData.idCardBackImg) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须上传身份证背面');
        return false;
      } else if (!this.approveData.idcardValidStart) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '请选择身份证有效期开始时间');
        return false;
      } else if (!this.approveData.idcardValidEnd) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '请选择身份证有效期结束时间');
        return false;
      }
      var params = {
        salesmanId: this.approveData.approvingID,
        idCard: String(this.approveData.newIdcard),
        // headImg: this.approveData.headImg,
        idCardCover: this.approveData.idCardCoverImg,
        idcardBack: this.approveData.idCardBackImg,
        name: this.approveData.newName,
        idcardValidStart: this.approveData.idcardValidStart,
        idcardValidEnd: this.approveData.idcardValidEnd,
        applicant: this.approveData.applicant,
        applyReason: this.approveData.applyReason,
        projectCode: this.approveData.projectCode ? this.approveData.projectCode.split('&')[0] : '',
        orgName: this.getOptcode("idcard")
        // console.log("---------",params);
        // return
        //请求
      };this.approveData.lockConfirm = true;
      console.log(this.approveData.newIdcard);
      this.$http({
        method: "POST",
        url: '/rest/IdCard/artificialCertification',
        params: params
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this12, 'success', '认证成功！');
        _this12.approveDialog = false;
        _this12.approveData.lockConfirm = false;
        _this12.getData();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this12, 'error', err.response, '认证失败');
        _this12.approveDialog = false;
        _this12.approveData.lockConfirm = false;
      });
    },

    //清空ApproveData数据
    clearApproveData: function clearApproveData() {
      var x = this.approveData;
      x.approvingID = '';
      x.approvingID = '';
      x.newName = '';
      x.newIdcard = null;
      x.lockIdCard = false;
      x.headImg = '';
      x.idCardCoverImg = '';
      x.idCardBackImg = '';
      x.headImgUpName.name = '';
      x.idCardCoverUpName.name = '';
      x.idCardBackUpName.name = '';
      x.applicant = '';
      x.applyReason = '';
      x.projectCode = '';
      x.orgName = '';
    },

    //头像上传成功
    headImgUpSucc: function headImgUpSucc(res, file) {
      this.approveData.headImg = res.message;
      this.approveData.lockApproveDialog = false;
    },

    //身份证正面上传成功
    idcardCoverUpSucc: function idcardCoverUpSucc(res, file) {
      this.approveData.idCardCoverImg = res.message;
      this.approveData.lockApproveDialog = false;
    },

    //身份证反面上传成功
    idCardBackUpSucc: function idCardBackUpSucc(res, file) {
      this.approveData.idCardBackImg = res.message;
      this.approveData.lockApproveDialog = false;
    },

    //图像上传失败通用
    imgUploadErr: function imgUploadErr(err) {
      __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'error', '上传失败，请稍后重试');
      this.approveData.lockApproveDialog = false;
    },

    //图片上传前校验通用方法
    beforeImgUp: function beforeImgUp(file) {
      var _this13 = this;

      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 1;
      var errMsg = '';
      if (!isLt2M) {
        errMsg = '上传的图片大小不能超过 1MB!';
      } else if (!isJPG) {
        errMsg = '请上传jpg、jpeg或png格式的图片';
      }
      if (errMsg != '') {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', errMsg);
        return false;
      } else {
        this.$refs['approveForm'].validate(function (valid) {
          //必须先输入正确的身份证号
          if (_this13.approveData.newIdcard && valid) {
            var x = file.name.split(".");
            _this13.approveData[_this13.isUploading + 'UpName'].name = _this13.approveData.newIdcard + new Date().getTime() + _this13.isUploading + '.' + x[x.length - 1];
            _this13.approveData.lockIdCard = true;
            _this13.approveData.lockApproveDialog = true;
          } else {
            __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this13, 'warning', '请先输入正确的身份证号');
            return false;
          }
        });
      }
    },

    // 身份证正面图片出错
    idcardCoverError: function idcardCoverError(event) {
      // event.target.src = this.idcardDefaultCover
      event.target.parentNode.style.backgroundImage = 'url(' + this.idcardDefaultCover + ')';
    },
    idcardCoverImgTableError: function idcardCoverImgTableError(event) {
      event.target.parentNode.style.backgroundImage = 'url(' + this.idcardDefaultCover + ')';
    },

    // 身份证背面图片出错
    idcardBackError: function idcardBackError(event) {
      // event.target.src = this.idcardDefaultBack
      event.target.parentNode.style.backgroundImage = 'url(' + this.idcardDefaultBack + ')';
    },
    idcardBackTableError: function idcardBackTableError(event) {
      event.target.parentNode.style.backgroundImage = 'url(' + this.idcardDefaultBack + ')';
    },

    // 银行卡图片出错
    bankCoverError: function bankCoverError(event) {
      // event.target.src = this.bankcardDefaultCover
      event.target.src = __webpack_require__("4inT");
      // `url(${this.bankcardDefaultCover})`
    },

    //弹框中的银行卡图片出错
    bankCoverError2: function bankCoverError2(event) {
      event.target.parentNode.style.backgroundImage = 'url(' + this.bankcardDefaultCover + ')';
    },

    // 表格中显示无压缩图
    noCompression: function noCompression(url, type) {

      if (type == 1) {
        if (url != null) {
          return {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover'
          };
        } else {
          return {
            backgroundImage: 'url(' + this.idcardDefaultCover + ')',
            backgroundSize: 'cover'
          };
        }
      } else if (type == 2) {
        if (url != null) {
          return {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover'
          };
        } else {
          return {
            backgroundImage: 'url(' + this.idcardDefaultBack + ')',
            backgroundSize: 'cover'
          };
        }
      } else if (type == 3) {
        if (url != null) {
          return {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover'
          };
        } else {
          return {
            backgroundImage: 'url(' + this.bankcardDefaultCover + ')',
            backgroundSize: 'cover'
          };
        }
      }
    },
    searchOperationData: function searchOperationData() {
      this.operationLogFormData.pageNo = 1;
      this.getOperationData();
    },

    //操作记录查询
    getOperationData: function getOperationData() {
      var _this14 = this;

      this.operationLogDialog = true;
      this.operationLoading = true;
      this.$http({
        method: 'post',
        url: '/rest/salesman/operationLog',
        data: this.operationLogFormData
      }).then(function (res) {
        _this14.operationLogTableData = res.data.data.list;
        _this14.operationTotal = res.data.data.totalCount;
        _this14.operationLoading = false;
      }).catch(function (err) {
        _this14.operationLoading = false;
        _this14.$alert("获取操作日志失败！");
      });
    },
    exportOperationData: function exportOperationData() {
      var _this15 = this;

      this.operationLogDialog = true;
      this.operationLoading = true;
      this.$http({
        method: 'post',
        url: '/rest/salesman/operationLog/export',
        data: this.operationLogFormData
      }).then(function (res) {
        location.href = __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        _this15.operationLoading = false;
      }).catch(function (err) {
        _this15.operationLoading = false;
        _this15.$alert("获取操作日志失败！");
      });
    },
    operationHandleSizeChange: function operationHandleSizeChange(val) {
      this.operationLogFormData.pageSize = val;
      this.getOperationData();
    },

    // 银行卡人工认证
    bankCardArtificial: function bankCardArtificial(salesmanId) {
      var _this16 = this;

      this.bankCardArtificialData.salesmanId = salesmanId;
      this.$http({
        method: 'get',
        url: '/rest/baseCenter/pre-bankcard-artificial',
        params: { "salesmanId": salesmanId }
      }).then(function (res) {
        if (res.data.status == 200) {
          var bankcardInfo = res.data.data;
          _this16.bankCardArtificialData.bank = bankcardInfo.bank;
          _this16.bankCardArtificialData.bankNum = bankcardInfo.bankNum;
          _this16.bankCardArtificialData.branch = bankcardInfo.branch;
          _this16.bankCardArtificialData.salesmanName = bankcardInfo.salesmanName;
          _this16.bankCardArtificialData.bankCover = bankcardInfo.bankCover;
          _this16.bankCardArtificialData.bankAddress.province = null;
          _this16.bankCardArtificialData.bankAddress.city = null;
          _this16.bankCardArtificialData.bankAddress.area = null;
          _this16.bankCardArtificialData.bankAddressCode.province = null;
          _this16.bankCardArtificialData.bankAddressCode.city = null;
          _this16.bankCardArtificialData.bankAddressCode.area = null;
          _this16.bankCardArtificialData.branchList = null;
          _this16.bankCardArtificialData.unionPayNo = null;
          _this16.bankCardDialogFlag = true;
          _this16.bankCardArtificialData.applicant = null;
          _this16.bankCardArtificialData.applyReason = null;
          _this16.bankCardArtificialData.projectCode = null;
        } else {
          _this16.bankCardDialogFlag = false;
          _this16.$alert(res.data.message);
        }
      }).catch(function (err) {
        _this16.$alert("无法进行银行卡人工认证！");
      });
    },
    operationHandleCurrentChange: function operationHandleCurrentChange(val) {
      this.operationLogFormData.pageNo = val;
      this.getOperationData();
    },

    // 校验银行卡图片
    verifyBankImage: function verifyBankImage(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 1;
      var errMsg = '';
      if (!isLt2M) {
        errMsg = '上传的图片大小不能超过 1MB!';
      } else if (!isJPG) {
        errMsg = '请上传jpg、jpeg或png格式的图片';
      }
      if (errMsg != '') {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', errMsg);
        return false;
      }
      var x = file.name.split(".");
      this.bankCardArtificialData.bankCoverName.name = new Date().getTime() + '.' + x[x.length - 1];
    },

    // 银行卡照片上传失败回调
    bankImageOnFailure: function bankImageOnFailure(err) {
      __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'error', '上传失败，请稍后重试');
    },

    // 银行卡照片上传成功回调
    bankImageOnSuccess: function bankImageOnSuccess(res, file) {
      var filePath = res.message;
      this.bankCardArtificialData.bankCover = filePath.substring(filePath.indexOf("https://resource.plscn.com/fileupload/") + "https://resource.plscn.com/fileupload/".length, filePath.length);
    },

    // 校验银行卡号
    validateIdCard: function validateIdCard() {
      return (/^\d{15,19}$/.test(this.bankCardArtificialData.bankNum) ? { valid: true } : {
          valid: false,
          msg: '请输入正确的银行卡！'
        }
      );
    },

    // 获取开户行信息
    getBank: function getBank() {
      var _this17 = this;

      var validateResult = this.validateIdCard();
      if (!validateResult.valid) {
        this.bankCardArtificialData.bank = null;
        this.$alert(validateResult.msg);
        return;
      }
      if (this.bankCardArtificialData.bankNum.length >= 15) {
        this.$http({
          method: "GET",
          url: "/rest/BankSubordinate/searchBankName",
          params: {
            bankNumber: this.bankCardArtificialData.bankNum
          }
        }).then(function (res) {
          if (res.data.message != '银行卡无效，请填写正确的银行卡！') {
            _this17.bankCardArtificialData.bank = res.data.message;
          }
        });
      }
    },
    chooseProvince: function chooseProvince(data) {
      this.bankCardArtificialData.bankAddress.province = data.value;
      this.bankCardArtificialData.bankAddress.city = null;
      this.bankCardArtificialData.bankAddress.area = null;
      this.bankCardArtificialData.bankAddressCode.province = data.code;
      this.bankCardArtificialData.bankAddressCode.city = null;
      this.bankCardArtificialData.bankAddressCode.area = null;
      this.bankCardArtificialData.branchList = null;
    },
    chooseCity: function chooseCity(data) {
      this.bankCardArtificialData.bankAddress.city = data.value;
      this.bankCardArtificialData.bankAddress.area = null;
      this.bankCardArtificialData.bankAddressCode.city = data.code;
      this.bankCardArtificialData.bankAddressCode.area = null;
      if (data.value == '东莞市' || data.value == '中山市') {
        this.searchBankBranchList();
      }
    },
    chooseArea: function chooseArea(data) {
      if (data.value != '区') {
        this.bankCardArtificialData.bankAddressCode.area = data.code;
        this.bankCardArtificialData.bankAddress.area = data.value;
      } else {
        this.bankCardArtificialData.bankAddressCode.area = "--";
        this.bankCardArtificialData.bankAddress.area = "";
      }
      this.searchBankBranchList();
    },

    // 获取开户支行列表
    searchBankBranchList: function searchBankBranchList() {
      if (this.bankCardArtificialData.bank == null) {
        this.$alert("请先填写正确的银行卡号！");
        return;
      }
      var queryParam = {
        bankcard: this.bankCardArtificialData.bankNum,
        bankname: this.bankCardArtificialData.bank, //银行
        city: this.bankCardArtificialData.bankAddress.city.indexOf('城区') != -1 || this.bankCardArtificialData.bankAddress.city.indexOf('市辖区') != -1 ? this.bankCardArtificialData.bankAddress.province : this.bankCardArtificialData.bankAddress.city,
        district: this.bankCardArtificialData.bankAddress.area,
        province: this.bankCardArtificialData.bankAddress.province,
        page: 1
      };
      this.queryBranchInfo(queryParam, []);
    },

    // 递归查询所有支行信息
    queryBranchInfo: function queryBranchInfo(param, list) {
      var _this18 = this;

      this.$http({
        method: "GET",
        url: "/rest/BankSubordinate/getLhhList",
        params: param
      }).then(function (res) {
        var data = res.data.data.result;
        if (data.list) {
          for (var i = 0; i < data.list.length; i++) {
            list.push(data.list[i]);
          }
        }

        var pager = data.paging;
        if (pager.page_total > param.page && param.page <= 10) {
          param.page = param.page + 1;
          // 递归查询
          _this18.queryBranchInfo(param, list);
        } else {
          if (data.list) {
            _this18.bankCardArtificialData.branchList = list;
          } else {
            _this18.bankCardArtificialData.branchList = [];
          }
        }
      });
    },

    // 获取银联号
    getUnionPayNo: function getUnionPayNo() {
      this.bankCardArtificialData.unionPayNo = this.bankCardArtificialData.branch.number;
    },

    // 取消银行卡认证
    bankCardArtificialCancel: function bankCardArtificialCancel() {
      this.bankCardDialogFlag = false;
      // this.clearBankCardArtificialData();
    },

    // 银行卡人工认证
    bankCardArtificialConfirm: function bankCardArtificialConfirm() {
      var _this19 = this;

      // 检验字段非空
      if (!this.verifyBankCardInfo()) {
        return;
      }
      var bankCardInfo = {
        salesmanId: this.bankCardArtificialData.salesmanId,
        bankNum: this.bankCardArtificialData.bankNum,
        bank: this.bankCardArtificialData.bank,
        // bankAddress: this.bankCardArtificialData.bankAddress.province + "," + this.bankCardArtificialData.bankAddress.city + "," + this.bankCardArtificialData.bankAddress.area,
        bankAddressCode: this.bankCardArtificialData.bankAddressCode.province + "," + this.bankCardArtificialData.bankAddressCode.city + "," + this.bankCardArtificialData.bankAddressCode.area,
        // bankBranch: this.bankCardArtificialData.branch.branchname,
        // unionPayNum: this.bankCardArtificialData.unionPayNo,
        bankCover: this.bankCardArtificialData.bankCover,
        applicant: this.bankCardArtificialData.applicant,
        applyReason: this.bankCardArtificialData.applyReason,
        projectCode: this.bankCardArtificialData.projectCode ? this.bankCardArtificialData.projectCode.split('&')[0] : '',
        orgName: this.getOptcode("bank")
        // console.log("!!!!!!!", bankCardInfo);
        // return
        // 银行卡人工认证
      };this.$http({
        method: 'post',
        url: '/rest/baseCenter/bankcard-artificial',
        data: bankCardInfo
      }).then(function (res) {
        if (res.data.code == '0') {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this19, 'success', '认证成功！');
          _this19.bankCardDialogFlag = false;
          _this19.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this19, 'error', res.data.message);
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this19, 'error', '银行卡人工认证失败！');
        console.log(err);
      });
    },

    // 校验银行卡人工认证字段
    verifyBankCardInfo: function verifyBankCardInfo() {
      if (this.bankCardArtificialData.bankNum == null || this.bankCardArtificialData.bankNum == '') {
        // this.$alert("银行卡号码不能为空！");
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '银行卡号码不能为空！');
        return false;
      }
      if (this.bankCardArtificialData.bank == null || this.bankCardArtificialData.bank == '') {
        // this.$alert("开户行不能为空！");
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '开户行不能为空！');
        return false;
      }
      if (this.bankCardArtificialData.applicant == null || this.bankCardArtificialData.applicant == '' || this.bankCardArtificialData.applicant == '--') {
        // this.$alert("申请人不能为空！");
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请人！');
        return false;
      }
      if (this.bankCardArtificialData.applyReason == null || this.bankCardArtificialData.applyReason == null || this.bankCardArtificialData.applyReason == '') {
        // this.$alert("申请原因不能为空！");
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '必须填写申请原因！');
        return false;
      }
      if (this.bankCardArtificialData.bankCover == null || this.bankCardArtificialData.bankCover == '') {
        // this.$alert("银行卡照片不能为空！");
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(this, 'warning', '银行卡照片不能为空！');
        return false;
      }
      return true;
    },

    // 查询所有项目客户
    searchAllCustomer: function searchAllCustomer() {
      var _this20 = this;

      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/all-customers'
      }).then(function (res) {
        _this20.customerList = res.data.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this20, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    openContractDialog: function openContractDialog(idcard, salesmanName) {
      this.contractDialogTitle = salesmanName;
      this.contractFormData.idcard = idcard;
      this.showContractDialog = true;
      this.searchContractData();
    },
    searchContractData: function searchContractData() {
      var _this21 = this;

      this.contractFormData.pageNo = 1;
      this.contractFormData.pageSize = 10;
      this.contractLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/contract-history',
        params: this.contractFormData
      }).then(function (res) {
        _this21.contractData = res.data.data.items;
        _this21.contractTotal = res.data.data.totalItemsCount;
        _this21.contractLoading = false;
      }).catch(function (err) {
        _this21.contractLoading = false;
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this21, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    handleContractSizeChange: function handleContractSizeChange(val) {
      this.contractFormData.pageSize = val;
      this.searchContractData();
    },
    handleContractCurrentChange: function handleContractCurrentChange(val) {
      this.contractFormData.pageNo = val;
      this.searchContractData();
    },
    showAuthorize: function showAuthorize(salesmanId, name) {
      var _this22 = this;

      this.authorizeDialogFlag = true;
      this.authorizeDialogSalesmanName = name;
      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/authorize-history',
        params: {
          salesmanId: salesmanId
        }
      }).then(function (res) {
        _this22.authorizeDialogList = res.data;
      }).catch(function (err) {
        _this22.authorizeDialogFlag = false;
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this22, 'error', err.response, '查询失败，请稍后重试');
      });
    },


    //获取所属项目对应的信息
    getProjDropDownList: function getProjDropDownList() {
      var _this23 = this;

      this.$http({
        method: "GET",
        url: "/rest/project/projectDropDownList"
      }).then(function (res) {
        _this23.projectDropDownList = res.data.items.map(function (item) {
          return {
            label: '\uFF08' + item.projectCode + '\uFF09' + item.projectName,
            valueOrgcode: item.orgName ? item.projectCode + '&' + item.orgName : item.projectCode
          };
        });
        _this23.projectDropDownListKeep = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this23.projectDropDownList));
        // console.log(res.data.items , "aaaaaaaaa" , this.projectDropDownList);
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_12__common_js_util_js__["a" /* default */].myNotify(_this23, "error", err.response, "获取失败，请稍后重试");
      });
    },
    getOptcode: function getOptcode(a) {
      if (a === "idcard") {
        var list = this.approveData.projectCode ? this.approveData.projectCode.split('&') : [];
        if (list.length > 1) {
          //存在orgCode
          return list[1];
        } else {
          return null;
        }
      } else {
        var _list = this.bankCardArtificialData.projectCode ? this.bankCardArtificialData.projectCode.split('&') : [];
        if (_list.length > 1) {
          //存在orgCode
          return _list[1];
        } else {

          return null;
        }
      }
    }
    // ,
    // //注销用户
    // logout(){
    //   let list =  this.resultList;
    //   let flag = 0;
    //   console.log('list',list);
    //   list.forEach(element=>{
    //     console.log('element',element);
    //     if (element.isLogout==0) {
    //       flag = 1;
    //       utils.myNotify(this, "error", element, '该人员未申请注销！')
    //     }
    //   })
    //   // 都申请注销了
    //   if(flag==0){
    //     this.$confirm('确认注销吗？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(()=>{
    //     let idArr = []
    //     this.idList.forEach(item => {
    //       idArr.push(item.id)
    //     })
    //     this.listLoading = true;
    //     this.$http({
    //       method:"POST",
    //       url:"/rest/baseCenter/logoutByIds",
    //       data: idArr
    //     }).then((res)=>{
    //       if (res.data.code == '0' && res.data.status == 200) {
    //         this.getData()
    //         utils.myNotify(this, "success", '注销成功', '操作成功')
    //       }else {
    //         utils.myNotify(this, "error", res, '操作失败，请稍后重试')
    //       }
    //     }).catch(err => {
    //     utils.myNotify(this, "error", err.response, '查询失败，请稍后重试')
    //     this.listLoading = false;
    //   })
    //   })
    //   }
    // }
    // ,
    // //筛选select
    // filterMethod(val){
    //   if (val) {
    //   //val存在筛选数组
    //   this.projectDropDownList = this.projectDropDownListKeep.filter((el) => {
    //     let re = new RegExp(val, 'i')
    //     return re.test(el.label)
    //   })
    // } else {
    //   //val不存在还原数组
    //   this.projectDropDownList = this.projectDropDownListKeep
    // }
    // }

  }
});

/***/ }),

/***/ "Vko2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("lvvn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da908b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("ltrf");
function injectStyle (ssrContext) {
  __webpack_require__("EY7K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6da908b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da908b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VuDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postTask_vue__ = __webpack_require__("HOQm");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b166f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postTask_vue__ = __webpack_require__("6ha/");
function injectStyle (ssrContext) {
  __webpack_require__("5l3o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52b166f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postTask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b166f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postTask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "WAyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container clearfix"},[_c('header',{staticClass:"main-header cleafix"},[_c('div',{staticClass:"logo floatl"},[(_vm.userIsPLUS)?_c('img',{attrs:{"src":__webpack_require__("1QZ/"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.userIsPG)?_c('img',{staticClass:"PGLogo",attrs:{"src":__webpack_require__("VB5x"),"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('img',{staticClass:"user-avatar",attrs:{"src":__webpack_require__("HXOI"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.nickname)+" "),(_vm.userIsPG)?_c('span',[_vm._v("宝洁")]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"quit",attrs:{"href":"javascript:;","title":"退出登录"},on:{"click":function($event){_vm.quitDialog = true}}},[_c('img',{attrs:{"src":__webpack_require__("+egd"),"alt":""}})]),_vm._v(" "),(_vm.userIsPLUS)?_c('a',{staticClass:"quit",attrs:{"href":"javascript:;","title":"修改密码"},on:{"click":function($event){_vm.changePassWordDialog = true}}},[_c('img',{attrs:{"src":__webpack_require__("fC+k"),"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('left-bar'),_vm._v(" "),_c('div',{staticClass:"right-container"},[_c('div',{staticClass:"main-body"},[(_vm.isLevelTwo)?_c('div',{staticClass:"breadcrumb",class:{'absolute':_vm.usingMyFilter}},[(!_vm.usingMyFilter)?_c('span',{staticClass:"currPage"},[_vm._v(_vm._s(_vm.$route.name))]):_vm._e(),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.$route.matched),function(item){return _c('el-breadcrumb-item',{key:item.id},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),1)],1):_vm._e(),_vm._v(" "),_c('router-view')],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"提 示","visible":_vm.dialogShow,"width":"30%","center":"","show-close":false,"close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.dialogShow=$event}}},[(_vm.loginTimeOut)?_c('div',{staticClass:"dialog-body"},[_c('img',{attrs:{"src":__webpack_require__("w2pP")}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"30px","display":"inline-block","width":"100px"}},[_vm._v("登陆超时 ！")])]):_c('div',{staticClass:"dialog-body"},[_c('img',{attrs:{"src":__webpack_require__("F0vU")}}),_vm._v("确认要退出现有账号吗？\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.notQuite()}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.quite()}}},[(!_vm.loginTimeOut)?_c('span',[_vm._v("确定")]):_c('span',[_vm._v("重新登录")])])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"修改密码","visible":_vm.changePassWordDialog,"width":"430px","center":""},on:{"update:visible":function($event){_vm.changePassWordDialog=$event}}},[_c('el-form',{ref:"ruleForm2",staticClass:"demo-ruleForm",staticStyle:{"margin-bottom":"50px"},attrs:{"model":_vm.ruleForm2,"status-icon":"","rules":_vm.rules2,"label-width":"100px","label-position":"right"}},[_c('el-row',{staticClass:"pwd"},[_c('el-form-item',{attrs:{"label":"旧密码","prop":"oldPassword"}},[_c('el-input',{staticStyle:{"width":"260px"},attrs:{"type":"password","size":"mini","placeholder":"请输入旧密码"},model:{value:(_vm.ruleForm2.oldPassword),callback:function ($$v) {_vm.$set(_vm.ruleForm2, "oldPassword", $$v)},expression:"ruleForm2.oldPassword"}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"pwd"},[_c('el-form-item',{attrs:{"label":"新密码","prop":"newPassword"}},[_c('el-input',{staticStyle:{"width":"260px"},attrs:{"type":"password","size":"mini","placeholder":"请输入新密码"},model:{value:(_vm.ruleForm2.newPassword),callback:function ($$v) {_vm.$set(_vm.ruleForm2, "newPassword", $$v)},expression:"ruleForm2.newPassword"}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"pwd"},[_c('el-form-item',{attrs:{"label":"确认新密码","prop":"rNewPassword"}},[_c('el-input',{staticStyle:{"width":"260px"},attrs:{"type":"password","size":"mini","placeholder":"确认新密码"},model:{value:(_vm.ruleForm2.rNewPassword),callback:function ($$v) {_vm.$set(_vm.ruleForm2, "rNewPassword", $$v)},expression:"ruleForm2.rNewPassword"}})],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.changePassWordDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.changePwd()}}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WPeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supplierPermute_vue__ = __webpack_require__("pRLy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bff7f2f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supplierPermute_vue__ = __webpack_require__("JViv");
function injectStyle (ssrContext) {
  __webpack_require__("kGVF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bff7f2f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supplierPermute_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bff7f2f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supplierPermute_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WV4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JwtLogin_vue__ = __webpack_require__("mgTQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797117a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JwtLogin_vue__ = __webpack_require__("snWy");
function injectStyle (ssrContext) {
  __webpack_require__("rufL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-797117a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JwtLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797117a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JwtLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wl6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"container salespersonDataShow",attrs:{"element-loading-text":"拼命加载中"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"筛选"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"70px","size":"mini","rules":_vm.rules}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入准确的项目编号...","maxlength":30},model:{value:(_vm.param.projectNo),callback:function ($$v) {_vm.$set(_vm.param, "projectNo", $$v)},expression:"param.projectNo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称..."},model:{value:(_vm.param.projectName),callback:function ($$v) {_vm.$set(_vm.param, "projectName", $$v)},expression:"param.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"品类"}},[_c('el-input',{attrs:{"placeholder":"请输入品类..."},model:{value:(_vm.param.brand),callback:function ($$v) {_vm.$set(_vm.param, "brand", $$v)},expression:"param.brand"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证...","maxlength":18},model:{value:(_vm.param.idCard),callback:function ($$v) {_vm.$set(_vm.param, "idCard", $$v)},expression:"param.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"星级"}},[_c('el-input',{attrs:{"placeholder":"请输入星级...","maxlength":5},model:{value:(_vm.param.rank),callback:function ($$v) {_vm.$set(_vm.param, "rank", _vm._n($$v))},expression:"param.rank"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在地区"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择省份..."},on:{"change":_vm.searchCity},model:{value:(_vm.param.province),callback:function ($$v) {_vm.$set(_vm.param, "province", $$v)},expression:"param.province"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.provinceList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.adName,"value":item.adName}})})],2),_vm._v(" "),_c('el-select',{attrs:{"filterable":"","placeholder":"请选择城市..."},model:{value:(_vm.param.city),callback:function ($$v) {_vm.$set(_vm.param, "city", $$v)},expression:"param.city"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.cityList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.adName,"value":item.adName}})})],2)],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("展开筛选项")])],1)],1)],1)])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"common-box",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("筛选结果")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.getExcel}},[_vm._v("\n        导出表格 "),_c('i',{staticClass:"el-icon-download"})])],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","tooltip-effect":"dark","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","min-width":"45","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"agency","label":"Agency","min-width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"province","label":"省份","width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"city","label":"城市","width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idcard","label":"身份证号","min-width":"135","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"eSalesmanId","label":"促销员ID","min-width":"90","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salesmanName","label":"促销员姓名","min-width":"90","align":"center","formatter":_vm.formatName}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storeCode","label":"门店SFA Code","min-width":"110","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"banner","label":"Banner","min-width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"workExperence","label":"工作经验","min-width":"140","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectNo","label":"项目编号","min-width":"150","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名称","min-width":"300","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"category","label":"Category","min-width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"brand","label":"品类","min-width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trainGrade","label":"培训成绩","min-width":"75","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"planWorkDays","label":"计划工作天数","min-width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"virtualWorkDays","label":"实际工作天数","min-width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sheduleCompletionRate","label":"档期内执行场次完成率","min-width":"90","align":"center","formatter":_vm.formatPercent}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activeDutyRate","label":"活动在岗率","min-width":"90","align":"center","formatter":_vm.formatPercent}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activeDutyGrade","label":"活动在岗成绩","min-width":"95","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"targetSales","label":"目标销量","min-width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"virtualSales","label":"实际销量","min-width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"virtualPosSales","label":"实际销量（POS）","min-width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salesRate","label":"销量达成率","min-width":"90","align":"center","formatter":_vm.formatPercent}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rank","label":"星级","min-width":"60","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.param.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.param.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wpm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WrK8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"兼职签约查询"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.params,"inline":true,"label-width":"200px","size":"mini"}},[_c('div',{staticClass:"slide-wrap",staticStyle:{"height":"auto"}},[_c('el-form-item',{attrs:{"label":"人员编码"}},[_c('el-input',{attrs:{"placeholder":"请输入人员编码..."},model:{value:(_vm.params.empCode),callback:function ($$v) {_vm.$set(_vm.params, "empCode", $$v)},expression:"params.empCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名..."},model:{value:(_vm.params.name),callback:function ($$v) {_vm.$set(_vm.params, "name", $$v)},expression:"params.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号码"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号码..."},model:{value:(_vm.params.idCard),callback:function ($$v) {_vm.$set(_vm.params, "idCard", $$v)},expression:"params.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否签约"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择是否签约...","clearable":""},model:{value:(_vm.params.signed),callback:function ($$v) {_vm.$set(_vm.params, "signed", $$v)},expression:"params.signed"}},[_c('el-option',{attrs:{"label":"是","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"否","value":0}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择签约平台...","clearable":""},model:{value:(_vm.params.serviceSupplier),callback:function ($$v) {_vm.$set(_vm.params, "serviceSupplier", $$v)},expression:"params.serviceSupplier"}},_vm._l((_vm.serviceSuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约公司"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择签约公司...","clearable":""},model:{value:(_vm.params.company),callback:function ($$v) {_vm.$set(_vm.params, "company", $$v)},expression:"params.company"}},_vm._l((_vm.companiesAll),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item.code}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务激活月份"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM","type":"month"},model:{value:(_vm.params.activateBegin),callback:function ($$v) {_vm.$set(_vm.params, "activateBegin", $$v)},expression:"params.activateBegin"}}),_vm._v("\n              -\n              "),_c('el-date-picker',{attrs:{"value-format":"yyyy-MM","type":"month"},model:{value:(_vm.params.activateEnd),callback:function ($$v) {_vm.$set(_vm.params, "activateEnd", $$v)},expression:"params.activateEnd"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.resetParams}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.searchData}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.exportData}},[_vm._v("导出")])],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empCode","label":"人员编码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idCard","label":"身份证号码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mobile","label":"手机号码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"openBank","label":"开户行","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bankNo","label":"银行卡号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"银行卡认证状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.bankAuth == 1)?_c('span',[_vm._v("通过")]):_c('span',[_vm._v("失败")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否签约","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.signed == 1)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.doShowContractDialog(scope.row.empCode)}}},[_vm._v("是")]):_c('span',[_vm._v("否")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务激活","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.doShowTaskDialog(scope.row.empCode)}}},[_vm._v("查看")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.params.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.params.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"签约合同","visible":_vm.showContractDialog,"width":"70%","center":""},on:{"update:visible":function($event){_vm.showContractDialog=$event}}},[_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.contractTableData}},[_c('el-table-column',{attrs:{"type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceSupplier","label":"签约平台","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"companyName","label":"公司名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskName","label":"任务名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierName","label":"供应商名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceNm","label":"服务商名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"signTime","label":"签约时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"beginDate","label":"合同开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endDate","label":"合同结束日期","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.contractParams.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.contractParams.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.contractTotal},on:{"size-change":_vm.handleContractSizeChange,"current-change":_vm.handleContractCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"任务激活","visible":_vm.showTaskDialog,"width":"70%","center":""},on:{"update:visible":function($event){_vm.showTaskDialog=$event}}},[_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.taskTableData}},[_c('el-table-column',{attrs:{"type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskName","label":"任务名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierName","label":"供应商名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceNm","label":"服务商名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activateMonth","label":"任务激活月份","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.taskParams.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.taskParams.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.taskTotal},on:{"size-change":_vm.handleTaskSizeChange,"current-change":_vm.handleTaskCurrentChange}})],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wt/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TiXi_vue__ = __webpack_require__("SbHN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiFen_vue__ = __webpack_require__("sKX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__XingJI_vue__ = __webpack_require__("50tf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__XinYong_vue__ = __webpack_require__("s+T2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js_util__ = __webpack_require__("hhm8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰7月重写，子组件星级信用待重写





// import XingJITwo from "./XingJi2";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SystemConfig",
  components: {
    TiXi: __WEBPACK_IMPORTED_MODULE_2__TiXi_vue__["a" /* default */],
    jiFen: __WEBPACK_IMPORTED_MODULE_3__jiFen_vue__["a" /* default */],
    XingJI: __WEBPACK_IMPORTED_MODULE_4__XingJI_vue__["a" /* default */],
    XinYong: __WEBPACK_IMPORTED_MODULE_5__XinYong_vue__["a" /* default */]
    // XingJITwo
  },
  data: function data() {
    return {
      pages: [{
        name: '体系配置',
        icon: __webpack_require__("Ufaa"),
        checkedIcon: __webpack_require__("kub0")
      }, {
        name: '积分',
        icon: __webpack_require__("l2JT"),
        checkedIcon: __webpack_require__("uCnF")
      }, {
        name: '星级',
        icon: __webpack_require__("IMXc"),
        checkedIcon: __webpack_require__("ttW4")
      }, {
        name: '信用',
        icon: __webpack_require__("ZH05"),
        checkedIcon: __webpack_require__("Y+6D")
      }],
      loading: false,
      navState: 9, //一开始不渲染组件，主页数据获取完毕后再赋正确的1234值来渲染
      isModify: false,
      startTime: "",
      quitDialog: false,
      alertText: "",
      // 页面内权限
      auths: []
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getAuth();
  },

  computed: {
    btnPre: function btnPre() {
      return this.navState == 1 ? '取消' : '上一步';
    },
    btnNext: function btnNext() {
      return this.navState == 4 ? '确认修改' : '下一步';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(["changeStartTime", "changeSystemArr", 'changejiFenArr', 'changeXingJiArr', 'changeXinYongArr']), {
    //工具类-将时间戳转换成YYMM格式
    toYYMM: function toYYMM(date) {
      return date.getFullYear() + "-" + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    },

    //工具类-检查区间是否设置正确
    checkArr: function checkArr(arr, name) {
      //先排序，方便比照
      arr.sort(function (n1, n2) {
        return n1.scoreMin - n2.scoreMin;
      });
      for (var i = 0; i < arr.length; i++) {
        if (Number(arr[i].scoreMin) >= Number(arr[i].scoreMax)) {
          return name + "\u5206\u503C\u533A\u95F4\u8303\u56F4\u4E0D\u7B26\uFF01";
        }
        if (i > 0) {
          if (arr[i].scoreMin <= arr[i - 1].scoreMax) {
            return name + "\u533A\u95F4\u4E0D\u80FD\u51FA\u73B0\u4EA4\u53C9\u60C5\u51B5\uFF01";
          }
        }
      }
    },

    //工具类-弹框提示
    openAlert: function openAlert() {
      this.$message({
        message: this.alertText,
        type: "warning"
      });
    },

    //工具类-确保mounted的体系(跟积分在一起)、星级、信用数据全部准备完毕
    // 只有这时候才能开始渲染主页面的1234，否则1234拿不到数据
    dataAllReady: function dataAllReady(arr) {
      var flag = true;
      arr.map(function (item) {
        if (!item) {
          flag = false;
        }
      });
      if (flag) {
        this.loading = false;
        this.navState = this.$route.query.navState || 1;
      }
      return flag;
    },

    //CSS工具类-nav切换(各种状态)
    navActive: function navActive(nav) {
      return this.isModify ? this.navState >= nav : this.navState == nav;
    },

    //CSS工具类-nav切换(编辑状态)
    navChangeColor: function navChangeColor(nav) {
      return this.navState > nav && this.isModify;
    },

    //获取数据后更新vuex
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var isReady = [false, false, false]; //积分和体系在一起，所以一共3个
      this.$http({
        method: "get",
        url: "/rest/ScoreSystemSettings/search"
      }).then(function (res) {
        var data = res.data;
        var date = new Date(data[0].startTime);
        _this.startTime = _this.toYYMM(date);
        _this.changeStartTime(data[0].startTime);
        //存体系的配置
        _this.$http({
          method: "get",
          url: "/rest/ScoreSystemSettings/searchScore?scoreType=1"
        }).then(function (res) {
          var jifenArr = [];
          data.map(function (item) {
            if (item.scoreType == 1) {
              res.data.map(function (item1) {
                if (item.masterId == item1.masterId) {
                  item.score = item1.score;
                }
              });
              jifenArr.push(item);
            }
          });
          _this.changejiFenArr(jifenArr);
          _this.changeSystemArr(data);
          isReady[0] = true;
          _this.dataAllReady(isReady);
        });
        //存星级的配置
        _this.$http({
          method: "get",
          url: "/rest/ScoreSystemSettings/searchScore?scoreType=2"
        }).then(function (res) {
          var arr = [];
          res.data.map(function (item) {
            arr.push({
              masterId: item.masterId,
              score: item.score,
              scoreMax: item.scoreMax,
              scoreMin: item.scoreMin,
              signId: item.signId,
              scoreType: 2
            });
          });
          _this.changeXingJiArr(arr);
          isReady[1] = true;
          _this.dataAllReady(isReady);
        });
        //存信用的配置
        _this.$http({
          method: "get",
          url: "/rest/ScoreSystemSettings/searchScore?scoreType=3"
        }).then(function (res) {
          var arr = [];
          res.data.map(function (item) {
            arr.push({
              masterId: item.masterId,
              score: item.score,
              scoreMax: item.scoreMax,
              scoreMin: item.scoreMin,
              signId: item.signId,
              scoreType: 3
            });
          });
          _this.changeXinYongArr(arr);
          isReady[2] = true;
          _this.dataAllReady(isReady);
        });
      });
    },

    //获取权限
    getAuth: function getAuth() {
      var _this2 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 20,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          _this2.auths.push(item.auth);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6__common_js_util__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //点击编辑按钮
    edit: function edit() {
      this.isModify = true;
      var date = new Date();
      console.log(date.getTime());
      this.changeStartTime(date.getTime());
      this.startTime = this.toYYMM(date);
    },

    //编辑情况下，点击页面顶端或者第一页时候底端的取消编辑
    quite: function quite() {
      this.isModify = false;
      this.quitDialog = false;
      window.location.reload();
    },

    //编辑-跳页检查-检查星级（第三页）
    chekckStar: function chekckStar(str) {
      var _this3 = this;

      var text = '';
      if (this.$store.state.xingJiArr != "") {
        this.$store.state.xingJiArr.map(function (item, index) {
          if (!item.score && item.score !== 0) {
            text = "警告 星级页分值没填写！";
          } else if (item.scoreMax === '') {
            //应该存，但没存就是''，不能用null等来判断
            text = "警告 星级页分值上限没有填写！";
          } else if (item.scoreMin === '') {
            //应该存，但没存就是''，不能用null等来判断
            text = "警告 星级页分值下限没有填写！";
          } else if (isNaN(item.score)) {
            text = "警告 星级页分值应该填写数字！";
          } else if (isNaN(item.scoreMin) || isNaN(item.scoreMax)) {
            text = "警告 星级页分值设定应该填写数字！";
          }
        });
      }
      if (this.$store.state.xingJiEdit != '') {
        this.$store.state.xingJiEdit.map(function (item) {
          if (item.scoreMax < 0) {
            text = "警告 星级设定分值不能为负！";
          } else if (item.scoreMin < 0) {
            text = "警告 星级设定分值不能为负！";
          }
        });
      }
      //检查区间
      this.$store.state.sortStar.map(function (item) {
        text = _this3.checkArr(item.long, '星级页') || '';
        text = _this3.checkArr(item.short, '星级页') || '';
      });
      if (text) {
        this.alertText = text;
        this.openAlert();
      } else {
        if (str == 'next') {
          this.navState = 4;
        } else if (str == 'pre') {
          this.navState = 2;
        } //else{仅仅检查数据，不跳页}
      }
    },

    //编辑-跳页检查-检查信用（第四页）
    checkCredit: function checkCredit() {
      var _this4 = this;

      var text = '';
      var arr = this.$store.state.xinYongArr;
      if (arr != "") {
        arr.map(function (item, index) {
          if (!item.score && item.score !== 0) {
            text = "警告 信用页分值没填写！";
          } else if (item.scoreMax === '') {
            //应该存，但没存就是''，不能用null等来判断
            text = "警告 信用页分值上限没有填写！";
          } else if (item.scoreMin === '') {
            //应该存，但没存就是''，不能用null等来判断
            text = "警告 信用页分值下限没有填写！";
          } else if (isNaN(item.score)) {
            text = "警告 信用页分值应该填写数字！";
          } else if (isNaN(item.scoreMin) || isNaN(item.scoreMax)) {
            text = "警告 信用页分值设定应该填写数字！";
          }
        });
      }
      //检查区间
      this.$store.state.sortPro.map(function (item) {
        text = _this4.checkArr(item.long, '信用页') || '';
        text = _this4.checkArr(item.short, '信用页') || '';
      });
      if (text) {
        this.alertText = text;
        this.openAlert();
      }
      return !Boolean(text);
    },

    //点击上一步（取消）按钮，均不校验
    btnPreClick: function btnPreClick() {
      var nav = this.navState;
      switch (nav) {
        case 1:
          this.quitDialog = true;
          break;
        case 2:
        case 3:
        case 4:
          this.navState = nav - 1; //非指针不简写
      }
    },

    //点击下一步（提交）按钮
    btnNextClick: function btnNextClick() {
      var _this5 = this;

      //点下一步均校验
      var nav = this.navState;
      if (nav == 1) {
        //第一页不检查
        this.navState = 2; //非指针不简写
      } else if (nav == 2) {
        //第二页检查积分，成功后跳页
        if (this.$refs.jifen.checkVals()) this.navState = 3;
      } else if (nav == 3) {
        //第三页检查星级，成功后跳页
        this.chekckStar('next');
      } else if (nav == 4) {
        //第四页这时候是保存，检查信用，成功后跳页
        // 在跳页的过程中都已经校验过了，所以仅校验当前页就够了
        if (!this.checkCredit()) {
          return;
        }
        this.alertText = "";
        var arr = [];
        //评估体系
        var systemArr = this.$store.state.systemArr;
        if (systemArr != "") {
          systemArr.map(function (item, index) {
            arr.push({
              scoreType: item.scoreType, //全都有
              masterId: item.masterId, //全都有（除了星级）
              signId: -1
            });
          });
        }
        //积分
        var jiFenArr = this.$store.state.jiFenArr;
        var jifenArrNotNull = true; //标志位，是否为空的意思
        if (jiFenArr == '') {
          jiFenArr = systemArr;
          jifenArrNotNull = false;
        }
        jiFenArr.map(function (item, index) {
          if (jifenArrNotNull || item.scoreType == 1) {
            //有值就不用这个判断，没值说明在systemArr中遍历，需要判断scoreType
            arr.push({
              scoreType: item.scoreType, //全都有
              masterId: item.masterId, //全都有（除了星级）
              score: item.score
            });
          }
        });
        //星级，星级和信用都用这个exceptArr
        var exceptArr = [118, 119, 120, 121, 122, 123, 124, 125, 127, 128, 129, 130, 131];
        if (this.$store.state.xingJiArr != "") {
          this.$store.state.xingJiArr.map(function (item, index) {
            var id = item.masterId;
            var obj = {
              masterId: id, //全都有（除了星级）
              signId: item.signId == -1 ? "" : item.signId,
              score: item.score
            };
            if (exceptArr.indexOf(id) > -1) {
              obj.scoreType = 2;
            } else {
              obj.scoreType = item.scoreType;
              obj.scoreMin = item.scoreMin;
              obj.scoreMax = item.scoreMax;
            }
            arr.push(obj);
          });
        }
        var xingJiEdit = this.$store.state.xingJiEdit;
        if (xingJiEdit != "") {
          xingJiEdit.map(function (item, index) {
            arr.push(item);
          });
          outer: for (var i = 0; i < xingJiEdit.length; i++) {
            for (var j = i + 1; j < xingJiEdit.length; j++) {
              if (xingJiEdit[i].starName == xingJiEdit[j].starName) {
                this.alertText = "警告 星级页名称重复！";
                this.openAlert();
                break outer; //跳出多层循环
              }
            }
          }
        }
        //信用
        if (this.$store.state.xinYongArr != "") {
          this.$store.state.xinYongArr.map(function (item, index) {
            var id = item.masterId;
            var obj = {
              masterId: id, //全都有（除了星级）
              signId: item.signId == -1 ? "" : item.signId,
              score: item.score
            };
            if (exceptArr.indexOf(id) > -1) {
              obj.scoreType = 3;
            } else {
              obj.scoreType = item.scoreType;
              obj.scoreMin = item.scoreMin;
              obj.scoreMax = item.scoreMax;
            }
            arr.push(obj);
          });
        }
        if (arr.length == 0) {
          //不走quite方法，直接退出编辑
          this.isModify = false;
          __WEBPACK_IMPORTED_MODULE_6__common_js_util__["a" /* default */].myNotify(this, 'error', '保存失败,配置为空');
        } else {
          this.loading = true;
          var sT = this.$store.state.startTime;
          arr.map(function (item) {
            item.startTime = sT;
          });
          this.$http({
            method: "POST",
            url: '/rest/ScoreSystemSettings/saveScoreSystemSettings',
            data: arr
          }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_6__common_js_util__["a" /* default */].myNotify(_this5, 'success', '保存成功');
            _this5.loading = false;
            _this5.isModify = false;
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_6__common_js_util__["a" /* default */].myNotify(_this5, 'error', err.response, '操作失败，请稍后重试');
            _this5.loading = false;
          });
        }
      }
    },

    //顶部图标，点击跳页
    changeNavState: function changeNavState(state) {
      var _this6 = this;

      if (state != this.navState) {
        //本页不跳
        if (state < this.navState) {
          //往回随便跳
          this.navState = state;
        } else {
          //非编辑时候随便跳
          if (this.isModify) {
            //往后跳走下一页的逻辑
            var x = state - this.navState;
            //navState会变化，所以不能把x的语句直接写在循环里
            for (var i = 0; i < x; i++) {
              //从第一页跳第三页时候，若不延迟，会找不到组件里面的方法
              setTimeout(function () {
                _this6.btnNextClick();
              }, 10);
            }
          } else {
            this.navState = state;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "X5MD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XhW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"客户项目维护"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"125px","size":"mini"}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"合同客户"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.qhrCustomerName),callback:function ($$v) {_vm.$set(_vm.param, "qhrCustomerName", $$v)},expression:"param.qhrCustomerName"}},_vm._l((_vm.allClientId),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目客户"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","filterMethod":function (val) {
                    _vm.$store.state.funciton.filter(
                      val,
                      this$1,
                      'allCustomer',
                      'keepAllCustomer'
                    );
                  },"placeholder":"请选择..."},on:{"visible-change":function () {
                    _vm.$store.state.funciton.filter(
                      '',
                      this$1,
                      'allCustomer',
                      'keepAllCustomer'
                    );
                  }},model:{value:(_vm.param.customerCode),callback:function ($$v) {_vm.$set(_vm.param, "customerCode", $$v)},expression:"param.customerCode"}},_vm._l((_vm.allCustomer),function(item){return _c('el-option',{key:item[0],attrs:{"label":item[1],"value":item[0]}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户维护状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.status),callback:function ($$v) {_vm.$set(_vm.param, "status", $$v)},expression:"param.status"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已维护","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未维护","value":"2"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否关联项目"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.projectCount),callback:function ($$v) {_vm.$set(_vm.param, "projectCount", $$v)},expression:"param.projectCount"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"是","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"否","value":"2"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.param.projectName),callback:function ($$v) {_vm.$set(_vm.param, "projectName", $$v)},expression:"param.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.param.projectCode),callback:function ($$v) {_vm.$set(_vm.param, "projectCode", $$v)},expression:"param.projectCode"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.exportResult()}}},[_vm._v("导出")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("展开筛选项")])],1)],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('div',{staticClass:"title"},[_vm._v("筛选结果")]),_vm._v(" "),_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"[1]","label":"合同客户","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"[2]","label":"合同项目ID","minWidth":"140","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"[3]","label":"项目客户","minWidth":"200","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row[3] || "--")+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"客户维护状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row[4] == 1)?_c('div',[_vm._v("已维护")]):_vm._e(),_vm._v(" "),(scope.row[4] == 2)?_c('div',{staticStyle:{"color":"#f56c6c"}},[_vm._v("未维护")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[5]","label":"关联项目","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"cursor":"pointer","color":"#18a7ff","text-decoration":"underline"},on:{"click":function($event){return _vm.handleProject(scope.row)}}},[_vm._v("\n              "+_vm._s(scope.row[5])+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[6]","label":"客户维护人账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[7]","label":"客户信息更新时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row[7])))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[8]","label":"项目维护人账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[9]","label":"项目更新时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row[9])))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"160","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleCustomer(scope.row)}}},[_c('span',{staticStyle:{"color":"#18a7ff"}},[_vm._v("客户维护")])]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleProject(scope.row)}}},[_c('span',{staticStyle:{"color":"#66cc33"}},[_vm._v("项目维护")])])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('Project',{ref:"Project",on:{"done":_vm.getData}}),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog Qhr_contract",attrs:{"title":_vm.handleItem ? _vm.handleItem[1] : '错误当前无操作对象',"width":"480px","show-close":true,"visible":_vm.customer,"top":"27vh","center":""},on:{"update:visible":function($event){_vm.customer=$event}}},[_c('el-form',{attrs:{"label-width":"140px"}},[_c('el-form-item',{staticStyle:{"margin":"20px 0"},attrs:{"label":"对应项目客户："}},[_c('el-select',{attrs:{"filterable":"","filterMethod":function (val) {
              _vm.$store.state.funciton.filter(
                val,
                this$1,
                'allCustomer',
                'keepAllCustomer'
              );
            },"placeholder":"请选择..."},on:{"visible-change":function () {
              _vm.$store.state.funciton.filter(
                '',
                this$1,
                'allCustomer',
                'keepAllCustomer'
              );
            },"change":function($event){_vm.disabledSubCustomer = false}},model:{value:(_vm.customerValue),callback:function ($$v) {_vm.customerValue=$$v},expression:"customerValue"}},_vm._l((_vm.allCustomer),function(item){return _c('el-option',{key:item[0],attrs:{"label":item[1],"value":item}})}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.customer = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.disabledSubCustomer,"size":"small"},on:{"click":function($event){return _vm.subCustomer()}}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y+6D":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ0MjBFNkIwREZBRjExRTc4MjFFRjEwQ0U4MkQzNzcyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQ0MjBFNkIxREZBRjExRTc4MjFFRjEwQ0U4MkQzNzcyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDQyMEU2QUVERkFGMTFFNzgyMUVGMTBDRTgyRDM3NzIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDQyMEU2QUZERkFGMTFFNzgyMUVGMTBDRTgyRDM3NzIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz40Yz8IAAABjUlEQVR42qzTSyjEURTH8RmPjSVmlMewImUsPCaPYqGsbGel7C1QLJTZSJ5FyspmVpJsrDwSNh7lURYWCguPwULTEFl4ju/Vj8b4D9Lc+nT73/+Zc8+5c/92d5HPFo+REGO9EH4EENLs1/qfEzVhCTtwI1XzNpb1/ttIinquwxCqcI1mFOAA49pgAxdY+amiQbTjXhWYamY0b2m9Q3Ffhj3isLOxj3QMqKLeiFifEnYhqPM6t6rIpRePKMNc1KbzKMWD4lyxWjMVOE2VONUBR45inOm9Q/GWh32EV1RjBLO4wiYq1GaD3pu4w1iJzE43GEUtvOhBvn7k1WarijPdvFi11oI99W/uyx3qkaf5VusBxbVaVeTQ31qJS3RiHSe6M1lKOKx7lqnrMKH2PyvqV7nlSEEfPMjFtGaP1lMUF9Lz+0jMcNbYdNGCaqEbizrcKd3oZ30apqU1pGFBccfRF/JjNGJMJZu//AnJSuLU2Uz+9q3ZFJSDXSWxaW5DiVWSWBX9a9jD4XBcEr0JMABoXGb4i4pdmgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "YAws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login3_vue__ = __webpack_require__("G/Jk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cecc76a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login3_vue__ = __webpack_require__("/25y");
function injectStyle (ssrContext) {
  __webpack_require__("LELj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cecc76a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cecc76a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YDFa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjVDM0Y3MTNBRDY3RTExRTdCQ0RCODIwMEFBNTQwNDcwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjVDM0Y3MTNCRDY3RTExRTdCQ0RCODIwMEFBNTQwNDcwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NUMzRjcxMzhENjdFMTFFN0JDREI4MjAwQUE1NDA0NzAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NUMzRjcxMzlENjdFMTFFN0JDREI4MjAwQUE1NDA0NzAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz54M0LCAAABZElEQVR42mL8//8/w0AAJoYBAixIbHp5nRHd4llArALETkC8CYhfUMkiCSD2A+J9QHwH4U1gHCPhqP8QYIMmTgm2gZoZhSw+YHFMicUcUExx4iIVbILSbvS2WGIw5eNaIA4aCIuLgThxoEouxkFdZBJrsQcQ5w+ExVlA3DAQFjMRG3dDqlrEBz4B8Rc0sc9Y1H3GIU62xaA4FkATC8YS/LZA/IEci3/iKA4/YDEQW339AE/R+gufxUeA+AcQdwMxH7HBhgfwQotRkJmHUWSwVNyRQPzlP/UAyKwIdHsYcbQyBYHYDOprZOALxLFA/B2I05CaTJxAvBiIN2NJlKeA+D2GDSQ0YbiA+BHUF01I4k1QsUdQNUSZR4rF9VALngAxD5I4D1TsP1QNVS2WAeKvUMPjsMjHQeVAamSpafFiqMGngJgRizwjVA4EllDLYgsg/gfFVnjUWSGpsyBkLuOI6zsBBBgA533P6u7y1FYAAAAASUVORK5CYII="

/***/ }),

/***/ "YF/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"1000px","center":true,"show-close":true,"visible":_vm.visiable,"close-on-click-modal":false,"append-to-body":"","top":"1vh"},on:{"update:visible":function($event){_vm.visiable=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('div',{staticStyle:{"font-size":"16px"}},[_vm._v("新增项目")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('el-form',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"model":_vm.param,"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":"选择项目"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","filterMethod":function (val){_vm.$store.state.funciton.filter(val, this$1, 'allCustomers', 'keep')},"placeholder":"请选择..."},on:{"visible-change":function (){_vm.$store.state.funciton.filter('', this$1, 'allCustomers', 'keep')}},model:{value:(_vm.param.prjCode),callback:function ($$v) {_vm.$set(_vm.param, "prjCode", $$v)},expression:"param.prjCode"}},_vm._l((_vm.allCustomers),function(item){return _c('el-option',{key:item[0],attrs:{"label":item[1],"value":item[0]}})}),1)],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("查询")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"color":"#ff9999","margin-bottom":"14px"}},[_c('i',{staticClass:"el-icon-warning"}),_vm._v("\n    请先选择一个项目，系统会将选择的项目所属的所有月份的项目一起查询出来\n  ")]),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"mini","border":"","header-row-class-name":"table-header"},on:{"selection-change":_vm.handleSelectionChange}},[_vm._v("\n      >\n      "),_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"minWidth":"200","prop":"[0]","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"[1]","minWidth":"200","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[2]","label":"项目开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"[3]","label":"项目结束日期","align":"center"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.visiable = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"small"},on:{"click":function($event){return _vm.subAdd()}}},[_vm._v("确认添加")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YPvR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/111.d782bc4.png";

/***/ }),

/***/ "YWNm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_home__ = __webpack_require__("26dS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_Login__ = __webpack_require__("lmfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Login2__ = __webpack_require__("RkUF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_JwtLogin__ = __webpack_require__("WV4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_noPermission__ = __webpack_require__("FzBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_dashboard_dashboard__ = __webpack_require__("DoUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_personnelCenter_salespersonLibrary__ = __webpack_require__("3Tmk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_personnelCenter_salespersonDetail__ = __webpack_require__("syeG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_personnelCenter_baseCenter__ = __webpack_require__("/gWG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_personnelCenter_blackList__ = __webpack_require__("qcEl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_personnelCenter_greyList__ = __webpack_require__("5hXt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_personnelCenter_importScore__ = __webpack_require__("tmg3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_personnelCenter_salespersonDataShow__ = __webpack_require__("ovos");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_personnelCenter_test123__ = __webpack_require__("AExF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_personnelCenter_questionnaire__ = __webpack_require__("MUm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_personnelCenter_dummyPhoneRecode__ = __webpack_require__("T775");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_personnelCenter_projectConfig__ = __webpack_require__("Qv+A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_personnelCenter_projectSupplierRecord__ = __webpack_require__("kNpw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_personnelCenter_projectCategory__ = __webpack_require__("2piF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_personnelCenter_customerConfig__ = __webpack_require__("cjyj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_personnelCenter_virtualProject__ = __webpack_require__("c0y2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_personnelCenter_supervise__ = __webpack_require__("aPDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_personnelCenter_QHRPersonnel__ = __webpack_require__("YfI5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_personnelCenter_CustomerProject__ = __webpack_require__("k+6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_views_personnelCenter_FlexibleSigningRecord__ = __webpack_require__("Bbqs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_views_labelSystem_labelManagement__ = __webpack_require__("AC+e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_views_labelSystem_projLabelConfig__ = __webpack_require__("LXjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_views_filterSetting_filterSetting__ = __webpack_require__("nqg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_views_limit_limitManager__ = __webpack_require__("RoIo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_views_limit_userManager__ = __webpack_require__("7Il1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_common_images_1Dashboard_png__ = __webpack_require__("+B1v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_common_images_1Dashboard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_common_images_1Dashboard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_common_images_1Dashboard2_png__ = __webpack_require__("RjCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_common_images_1Dashboard2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_common_images_1Dashboard2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_common_images_2renyuan_png__ = __webpack_require__("Eq+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_common_images_2renyuan_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_common_images_2renyuan_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_common_images_7biaoqian_png__ = __webpack_require__("LCYl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_common_images_7biaoqian_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_common_images_7biaoqian_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_common_images_9shaixuan_png__ = __webpack_require__("2E37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_common_images_9shaixuan_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_common_images_9shaixuan_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_common_images_9shaixuan2_png__ = __webpack_require__("Drhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_common_images_9shaixuan2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_common_images_9shaixuan2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_common_images_8quanxian_png__ = __webpack_require__("ErWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_common_images_8quanxian_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_common_images_8quanxian_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_common_images_6pinggu_png__ = __webpack_require__("YDFa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_common_images_6pinggu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_common_images_6pinggu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_views_Assessment_SystemConfig__ = __webpack_require__("odvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_views_Assessment_EvaluationDetail__ = __webpack_require__("cCgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_views_Assessment_LookHistory__ = __webpack_require__("hVYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_views_Assessment_LookHistoryTwo__ = __webpack_require__("TOzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_common_images_3gongchang_png__ = __webpack_require__("z8qU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_common_images_3gongchang_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_common_images_3gongchang_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_views_workSquare_managementApply__ = __webpack_require__("rD8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_views_workSquare_postJob_postJob__ = __webpack_require__("1Q91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_views_workSquare_supplierPermute__ = __webpack_require__("WPeR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_views_workSquare_PublishTaskConfiguration__ = __webpack_require__("8y9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_views_configCanage_mappingMead_MappingMead__ = __webpack_require__("BEg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_views_configCanage_tomd_Tomd__ = __webpack_require__("Or9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_views_configCanage_whitelist_Whitelist__ = __webpack_require__("4N/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_views_configCanage_agreeProject_AgreeProject__ = __webpack_require__("3vnA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_views_configCanage_mapper_MapperProject__ = __webpack_require__("xsrU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_views_taskCenter_postTask_postTask__ = __webpack_require__("VuDY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_views_taskCenter_taskAudit_taskAudit__ = __webpack_require__("+FQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_common_images_icon_taskCenter_png__ = __webpack_require__("aq3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_common_images_icon_taskCenter_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_common_images_icon_taskCenter_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_views_friendLink_workNews__ = __webpack_require__("Fe1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_common_images_17youqinglianjie_png__ = __webpack_require__("cghz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_common_images_17youqinglianjie_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_common_images_17youqinglianjie_png__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//登陆和主页面





// 无角色页面



// 人员中心




















// 标签体系


// 筛选项配置

//权限管理 角色管理



// icon






//权限管理icon


//评估体系






// import PDF from 'views/Assessment/cPDF'

// 工作广场






//配置管理






//任务中心




// 友情链接/工作快讯



var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  hidden: true,
  children: [{ path: '/noPermission', component: __WEBPACK_IMPORTED_MODULE_6_views_noPermission__["a" /* default */], name: '无权限页面', webId: null, hidden: true }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: 'Dashboard',
  redirect: '/dashboard',
  leaf: true,
  icon: __WEBPACK_IMPORTED_MODULE_32_common_images_1Dashboard_png___default.a,
  iconActive: __WEBPACK_IMPORTED_MODULE_33_common_images_1Dashboard2_png___default.a,
  children: [{ path: '/dashboard', component: __WEBPACK_IMPORTED_MODULE_7_views_dashboard_dashboard__["a" /* default */], name: 'Dashboard', webId: 25, hidden: false }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_3_views_Login__["a" /* default */],
  name: '登陆',
  leaf: true,
  hidden: true,
  children: [{ path: '/login', component: __WEBPACK_IMPORTED_MODULE_3_views_Login__["a" /* default */], name: '登陆', webId: null, hidden: true }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_views_Login2__["a" /* default */],
  name: '登陆',
  leaf: true,
  hidden: true,
  children: [{ path: '/loginPG', component: __WEBPACK_IMPORTED_MODULE_4_views_Login2__["a" /* default */], name: '登陆', webId: null, hidden: true }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_5_views_JwtLogin__["a" /* default */],
  name: '登陆',
  leaf: true,
  hidden: true,
  children: [{ path: '/jwtLogin', component: __WEBPACK_IMPORTED_MODULE_5_views_JwtLogin__["a" /* default */], name: '登陆', webId: null, hidden: true }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: '人员中心',
  hidden: false,
  icon: __WEBPACK_IMPORTED_MODULE_34_common_images_2renyuan_png___default.a,
  children: [{ path: '/salespersonLibrary', component: __WEBPACK_IMPORTED_MODULE_8_views_personnelCenter_salespersonLibrary__["a" /* default */], name: '促销员库', webId: 1, hidden: false }, { path: '/salespersonDetail', component: __WEBPACK_IMPORTED_MODULE_9_views_personnelCenter_salespersonDetail__["a" /* default */], name: '促销员详情', hidden: true, webId: null }, { path: '/baseCenter', component: __WEBPACK_IMPORTED_MODULE_10_views_personnelCenter_baseCenter__["a" /* default */], name: '基础中心', webId: 2, hidden: false }, { path: '/qhrPersonnel', component: __WEBPACK_IMPORTED_MODULE_24_views_personnelCenter_QHRPersonnel__["a" /* default */], name: 'QHR人员库', webId: 44, hidden: false }, { path: '/blackList', component: __WEBPACK_IMPORTED_MODULE_11_views_personnelCenter_blackList__["a" /* default */], name: '黑名单', webId: 17, hidden: false }, { path: '/greyList', component: __WEBPACK_IMPORTED_MODULE_12_views_personnelCenter_greyList__["a" /* default */], name: '灰名单', webId: 47, hidden: false }, { path: '/importScore', component: __WEBPACK_IMPORTED_MODULE_13_views_personnelCenter_importScore__["a" /* default */], name: '导入评分数据', webId: 18, hidden: false }, { path: '/salespersonDataShow', component: __WEBPACK_IMPORTED_MODULE_14_views_personnelCenter_salespersonDataShow__["a" /* default */], name: '促销员数据', webId: 27, hidden: false }, //宝洁专用页面
  { path: '/notFound404', component: __WEBPACK_IMPORTED_MODULE_15_views_personnelCenter_test123__["a" /* default */], name: '', webId: 999, hidden: true }, { path: '/dummyPhoneRecode', component: __WEBPACK_IMPORTED_MODULE_17_views_personnelCenter_dummyPhoneRecode__["a" /* default */], name: '拨号记录', webId: 34, hidden: false }, { path: '/supervise', component: __WEBPACK_IMPORTED_MODULE_23_views_personnelCenter_supervise__["a" /* default */], name: '兼职签约查询', webId: 42, hidden: false }, { path: '/flexibleSigningRecord', component: __WEBPACK_IMPORTED_MODULE_26_views_personnelCenter_FlexibleSigningRecord__["a" /* default */], name: '灵工签约记录', webId: 52, hidden: false }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: '工作广场',
  hidden: false,
  icon: __WEBPACK_IMPORTED_MODULE_44_common_images_3gongchang_png___default.a,
  children: [{ path: '/postJob', component: __WEBPACK_IMPORTED_MODULE_46_views_workSquare_postJob_postJob__["a" /* default */], name: '岗位发布', webId: 5, hidden: false }, { path: '/managementApply', component: __WEBPACK_IMPORTED_MODULE_45_views_workSquare_managementApply__["a" /* default */], name: '岗位管理', webId: 6, hidden: false }, { path: '/publishTaskConfiguration', component: __WEBPACK_IMPORTED_MODULE_48_views_workSquare_PublishTaskConfiguration__["a" /* default */], name: '任务字段配置', webId: 43, hidden: false }, { path: '/projectConfig', component: __WEBPACK_IMPORTED_MODULE_18_views_personnelCenter_projectConfig__["a" /* default */], name: '项目配置', webId: 35, hidden: false }, { path: '/projectSupplierRecord', component: __WEBPACK_IMPORTED_MODULE_19_views_personnelCenter_projectSupplierRecord__["a" /* default */], name: '项目灵工记录', webId: 55, hidden: false }, { path: '/projectCategory', component: __WEBPACK_IMPORTED_MODULE_20_views_personnelCenter_projectCategory__["a" /* default */], name: '自定义项目类型', webId: 45, hidden: false }, { path: '/customerConfig', component: __WEBPACK_IMPORTED_MODULE_21_views_personnelCenter_customerConfig__["a" /* default */], name: '客户配置', webId: 39, hidden: false }, { path: '/supplierPermute', component: __WEBPACK_IMPORTED_MODULE_47_views_workSquare_supplierPermute__["a" /* default */], name: '供应商置换', webId: 40, hidden: false }, { path: '/virtualProject', component: __WEBPACK_IMPORTED_MODULE_22_views_personnelCenter_virtualProject__["a" /* default */], name: '虚拟项目维护', webId: 41, hidden: false }, { path: '/customerProject', component: __WEBPACK_IMPORTED_MODULE_25_views_personnelCenter_CustomerProject__["a" /* default */], name: '客户项目维护', webId: 46, hidden: false }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: '配置管理', //webId 48
  hidden: false,
  icon: __WEBPACK_IMPORTED_MODULE_36_common_images_9shaixuan_png___default.a,
  children: [{ path: '/mapping', component: __WEBPACK_IMPORTED_MODULE_49_views_configCanage_mappingMead_MappingMead__["a" /* default */], name: '美赞人员映射', webId: 49, hidden: false }, { path: '/tomd', component: __WEBPACK_IMPORTED_MODULE_50_views_configCanage_tomd_Tomd__["a" /* default */], name: 'TOMD', webId: 50, hidden: false }, { path: '/whitelist', component: __WEBPACK_IMPORTED_MODULE_51_views_configCanage_whitelist_Whitelist__["a" /* default */], name: '长促白名单', webId: 51, hidden: false }, { path: '/agreeProject', component: __WEBPACK_IMPORTED_MODULE_52_views_configCanage_agreeProject_AgreeProject__["a" /* default */], name: '协议授权配置', webId: 53, hidden: false }, { path: '/mapperProject', component: __WEBPACK_IMPORTED_MODULE_53_views_configCanage_mapper_MapperProject__["a" /* default */], name: '灵工项目映射', webId: 54, hidden: false }]
},
// {
//   path: '/',
//   component:Home,
//   name: '米咖调研',
//   hidden: false,
//   icon: square,
//   children: [
//     { path: '/questionnaire', component: Questionnaire, name: '快决策问卷', webId: 33, hidden: false}
//   ]
// },
// {
//   path: '/',
//   component:Home,
//   name: '任务中心',//TaskCenter
//   hidden: false,
//   icon: renwuzhongxin,
//   children: [
//     { path: '/postTask', component: PostTask, name: '任务发布', webId: 29, hidden: false },
//     { path: '/taskAudit', component: TaskAudit, name: '任务审核', webId: 30, hidden: false },
//   ]
// },
{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: '标签体系',
  icon: __WEBPACK_IMPORTED_MODULE_35_common_images_7biaoqian_png___default.a,
  hidden: false,
  children: [{ path: '/labelManagement', component: __WEBPACK_IMPORTED_MODULE_27_views_labelSystem_labelManagement__["a" /* default */], name: '标签管理', webId: 8, hidden: false }, { path: '/projLabelConfig', component: __WEBPACK_IMPORTED_MODULE_28_views_labelSystem_projLabelConfig__["a" /* default */], name: '项目标签配置', webId: 10, hidden: false }]
},
//权限管理
{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: '权限管理',
  icon: __WEBPACK_IMPORTED_MODULE_38_common_images_8quanxian_png___default.a,
  hidden: false,
  children: [
  //角色管理
  { path: '/limitManager', component: __WEBPACK_IMPORTED_MODULE_30_views_limit_limitManager__["a" /* default */], name: '角色管理', webId: 13, hidden: false }, { path: '/userManager', component: __WEBPACK_IMPORTED_MODULE_31_views_limit_userManager__["a" /* default */], name: '用户管理', webId: 14, hidden: false }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: '评估体系',
  icon: __WEBPACK_IMPORTED_MODULE_39_common_images_6pinggu_png___default.a,
  hidden: false,
  children: [{ path: '/SystemConfig', component: __WEBPACK_IMPORTED_MODULE_40_views_Assessment_SystemConfig__["a" /* default */], name: '体系配置', webId: 20, hidden: false }, { path: '/EvaluationDetail', component: __WEBPACK_IMPORTED_MODULE_41_views_Assessment_EvaluationDetail__["a" /* default */], name: '评估明细查询', webId: 21, hidden: false }, { path: '/LookHistory', component: __WEBPACK_IMPORTED_MODULE_42_views_Assessment_LookHistory__["a" /* default */], name: '配置历史查询', hidden: true, webId: null }, { path: '/LookHistoryTwo', component: __WEBPACK_IMPORTED_MODULE_43_views_Assessment_LookHistoryTwo__["a" /* default */], name: '配置历史查询2', hidden: true, webId: null }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  leaf: true,
  icon: __WEBPACK_IMPORTED_MODULE_36_common_images_9shaixuan_png___default.a,
  name: '筛选项配置',
  hidden: false,
  iconActive: __WEBPACK_IMPORTED_MODULE_37_common_images_9shaixuan2_png___default.a,
  children: [{ path: '/filterSetting', component: __WEBPACK_IMPORTED_MODULE_29_views_filterSetting_filterSetting__["a" /* default */], name: '筛选项配置', webId: 24, hidden: false }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_home__["a" /* default */],
  name: '友情链接',
  icon: __WEBPACK_IMPORTED_MODULE_58_common_images_17youqinglianjie_png___default.a,
  hidden: false,
  children: [{ path: '/workNews', component: __WEBPACK_IMPORTED_MODULE_57_views_friendLink_workNews__["a" /* default */], name: '工作快讯', webId: 37, hidden: false }]
}];
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  routes: routes
}));

/***/ }),

/***/ "Ybxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f914e3bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contract_vue__ = __webpack_require__("8WPx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f914e3bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YfI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QHRPersonnel_vue__ = __webpack_require__("o0MO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5a04ca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QHRPersonnel_vue__ = __webpack_require__("ycBX");
function injectStyle (ssrContext) {
  __webpack_require__("u+6Z")
  __webpack_require__("I+mo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5a04ca6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QHRPersonnel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5a04ca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QHRPersonnel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z12W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z9z7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZBqX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZH05":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhCMUREQTVGREZBRTExRTdBMDk5QTNDMkFGRUYzQTVGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhCMUREQTYwREZBRTExRTdBMDk5QTNDMkFGRUYzQTVGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEIxRERBNURERkFFMTFFN0EwOTlBM0MyQUZFRjNBNUYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEIxRERBNUVERkFFMTFFN0EwOTlBM0MyQUZFRjNBNUYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4yxXnmAAABkUlEQVR42qzUOSxEQRzH8V1USrIKd0UUFJaNo1BIVNqtNlFuokBCQqIScSZEoqLYhogoKMQRZ+HYOBKFDoVjUYggROFc39n8Ipv1Hoqd5JPJm/nvzP8/b946/X6/Ix4twWa8AAGEcKc+oPF/L1SHFeyjECnq97Cq+R8tKea5Gv2owD3qkY8jjGiDbVxh7beM+tCMZ2VgsplRv6vxFsXZZpSp3afRizF0aW4WD2hFO0YVf2mVUbYmXlGC+ZhNF+DGi+Ky7UozZ5IGJ851wNGtCBeadynesrQTfKISg5jDDXZQpjJrNW/iju0WcuochlAFLzqRpx95tdmG4kw1H1alNeBQ9Zv78oQa5Kp/1HhIcY1WGbn0WstxjTZs4Ux3JkMLDuiepes6jKv874x6lG4pktEND3Iwpd6j8WTF3ek50hLdbvNGIxftViV0YEmHO6kb/a5Pw5S0iVQsKu40urR1Mc2HoFL2aWxYiwR1NhN/fWsOBWXhAG8aM30Tiq0WsVvIYfUt0ZbFsjnD4XBc/ti+BBgA9T9p9GYOIT8AAAAASUVORK5CYII="

/***/ }),

/***/ "ZSOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_china_area_data__ = __webpack_require__("Wxq9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_china_area_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_china_area_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_filterTag__ = __webpack_require__("PUCp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__ = __webpack_require__("8jay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_util__ = __webpack_require__("hhm8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilterTag: __WEBPACK_IMPORTED_MODULE_2_components_filterTag__["a" /* default */]
  },
  watch: {
    'paramForm.ageMin': function paramFormAgeMin() {
      this.$refs.paramForm.validateField('ageMax');
    },
    'paramForm.ageMax': function paramFormAgeMax() {
      this.$refs.paramForm.validateField('ageMin');
    },
    'paramForm.heightMin': function paramFormHeightMin() {
      this.$refs.paramForm.validateField('heightMax');
    },
    'paramForm.heightMax': function paramFormHeightMax() {
      this.$refs.paramForm.validateField('heightMin');
    },
    'paramForm.creditScoreMin': function paramFormCreditScoreMin() {
      this.$refs.paramForm.validateField('creditScoreMax');
    },
    'paramForm.creditScoreMax': function paramFormCreditScoreMax() {
      this.$refs.paramForm.validateField('creditScoreMin');
    },
    'paramForm.projectNumMin': function paramFormProjectNumMin() {
      this.$refs.paramForm.validateField('projectNumMax');
    },
    'paramForm.projectNumMax': function paramFormProjectNumMax() {
      this.$refs.paramForm.validateField('projectNumMin');
    },
    'paramForm.workMonthMin': function paramFormWorkMonthMin() {
      this.$refs.paramForm.validateField('workMonthMax');
    },
    'paramForm.workMonthMax': function paramFormWorkMonthMax() {
      this.$refs.paramForm.validateField('workMonthMin');
    },
    'paramForm.frequencyNumMin': function paramFormFrequencyNumMin() {
      this.$refs.paramForm.validateField('frequencyNumMax');
    },
    'paramForm.frequencyNumMax': function paramFormFrequencyNumMax() {
      this.$refs.paramForm.validateField('frequencyNumMin');
    },
    'paramForm.projectPriceMin': function paramFormProjectPriceMin() {
      this.$refs.paramForm.validateField('projectPriceMax');
    },
    'paramForm.projectPriceMax': function paramFormProjectPriceMax() {
      this.$refs.paramForm.validateField('projectPriceMin');
    }
  },
  data: function data() {
    var _this = this;
    //年龄-动态关联校验
    var ageMin = function ageMin(rule, value, callback) {
      //180622说不要年龄限制了
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMin(value, _this.paramForm.ageMax, callback);
    };
    var ageMax = function ageMax(rule, value, callback) {
      //180622说不要年龄限制了
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMax(value, _this.paramForm.ageMin, callback);
    };
    //身高：动态关联校验
    var heightMin = function heightMin(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMin(value, _this.paramForm.heightMax, callback);
    };
    var heightMax = function heightMax(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMax(value, _this.paramForm.heightMin, callback);
    };
    //信用：动态关联校验
    var creditScoreMin = function creditScoreMin(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMin(value, _this.paramForm.creditScoreMax, callback);
    };
    var creditScoreMax = function creditScoreMax(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMax(value, _this.paramForm.creditScoreMin, callback);
    };
    //项目数量：动态关联验证
    var projectNumMin = function projectNumMin(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMin(value, _this.paramForm.projectNumMax, callback);
    };
    var projectNumMax = function projectNumMax(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMax(value, _this.paramForm.projectNumMin, callback);
    };
    //服务月数：动态关联验证
    var workMonthMin = function workMonthMin(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMin(value, _this.paramForm.workMonthMax, callback);
    };
    var workMonthMax = function workMonthMax(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMax(value, _this.paramForm.workMonthMin, callback);
    };
    //场次数量：动态关联验证
    var frequencyNumMin = function frequencyNumMin(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMin(value, _this.paramForm.frequencyNumMax, callback);
    };
    var frequencyNumMax = function frequencyNumMax(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMax(value, _this.paramForm.frequencyNumMin, callback);
    };
    //项目单价：动态关联验证，已经用不上了
    var projectPriceMin = function projectPriceMin(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMin(value, _this.paramForm.projectPriceMax, callback);
    };
    var projectPriceMax = function projectPriceMax(rule, value, callback) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].rangeMax(value, _this.paramForm.projectPriceMin, callback);
    };
    var showAuthorizeFlag = false;
    if (this.postId == 0 && this.$route.path.indexOf("baseCenter") != -1) {
      showAuthorizeFlag = true;
    }
    return {
      userIsPLUS: false, //用户是否不是宝洁
      test: [],
      paramForm: {
        name: null,
        idcard: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        sex: null,
        educationId: null,
        status: null,
        starLevelId: null,
        agreement: null,
        channel: null,
        ageMin: null,
        ageMax: null,
        heightMin: null,
        heightMax: null,
        creditScoreMin: null,
        creditScoreMax: null,
        projectNumMin: null,
        projectNumMax: null,
        workMonthMin: null,
        workMonthMax: null,
        frequencyNumMin: null,
        frequencyNumMax: null,
        projectPriceMin: null,
        projectPriceMax: null,
        postId: this.postId,
        authorizeFlag: null,
        empPk: null,
        isAuthentication: null,
        isBankAuthentication: null,
        storeCode: null,
        storeName: null,
        tel: null,
        signContract: null,
        signCustomer: null
        // qhrStatusName:'0',//是否QHR人员
      },
      paramConfig: [],

      options: __WEBPACK_IMPORTED_MODULE_1_element_china_area_data__["regionData"],
      selectedArea: [],

      provinceList: [],
      cityList: [],
      areaList: [],
      config_top: false,
      config_bottom: false,
      // 规则
      rules: {
        name: __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].name,
        idcard: __WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].idcard,
        ageMin: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: ageMin, trigger: 'change' }],
        ageMax: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: ageMax, trigger: 'change' }],
        heightMin: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: heightMin, trigger: 'change' }],
        heightMax: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: heightMax, trigger: 'change' }],
        creditScoreMin: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: creditScoreMin, trigger: 'change' }],
        creditScoreMax: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: creditScoreMax, trigger: 'change' }],
        projectNumMin: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: projectNumMin, trigger: 'change' }],
        projectNumMax: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: projectNumMax, trigger: 'change' }],
        workMonthMin: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: workMonthMin, trigger: 'change' }],
        workMonthMax: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: workMonthMax, trigger: 'change' }],
        frequencyNumMin: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: frequencyNumMin, trigger: 'change' }],
        frequencyNumMax: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: frequencyNumMax, trigger: 'change' }],
        projectPriceMin: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: projectPriceMin, trigger: 'change' }],
        projectPriceMax: [__WEBPACK_IMPORTED_MODULE_3__common_js_formRules__["a" /* default */].number, { validator: projectPriceMax, trigger: 'change' }]
      },
      // 是否展示个人信息授权的选项
      showAuthorizeFlag: showAuthorizeFlag,
      customerList: []
    };
  },

  props: ['webId', 'postId', 'educationList', 'starLevelList', 'channelList'],
  mounted: function mounted() {
    //每次都能触发
    //挂载后才能找到refs
    this.$refs['paramForm'].resetFields();
    this.userIsPLUS = Boolean(sessionStorage.getItem('user'));
    if (this.userIsPLUS) {
      this.searchProvince();
      this.searchCity();
      this.searchArea();
      this.searchAllCustomer();
    }
  },
  created: function created() {
    var _this2 = this;

    //同样每次都能触发
    // 获取筛选项配置
    this.$http({
      method: 'POST',
      url: '/rest/webCondition/getWebCondition',
      params: {
        webId: this.webId, //1是促销员库，2是基础中心
        postId: this.postId //0是全部人员，1是筛选长促，2是筛选短促
      }
    }).then(function (res) {
      // console.log('筛选项',res.data)
      _this2.paramConfig = res.data;
      res.data.forEach(function (item) {
        if (item.crmMaster.id < 11 || item.crmMaster.id > 15) {
          _this2.config_top = true;
        }
      });
      res.data.forEach(function (item) {
        if (item.crmMaster.id > 10 && item.crmMaster.id < 16) {
          _this2.config_bottom = true;
        }
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
    });
  },

  methods: {
    signIdLsts: function signIdLsts(ids) {
      this.signIdLst = ids;
    },
    submitForm: function submitForm(formName, data) {
      var _this3 = this;

      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { signIdLst: this.signIdLst });
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$emit('filterParam', data);
        } else {
          __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this3, 'warning', '筛选项有误，请核对');
          return false;
        }
      });
    },

    //重置表单，调用el-form中方法
    resetForm: function resetForm(formName) {
      // 需要指定form-item的prop
      this.searchProvince();
      this.searchCity();
      this.searchArea();
      this.$refs[formName].resetFields();
      this.$refs['filterTag'].reset();
    },

    //展开和收起筛选框
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = 'auto';
        event.target.innerHTML = '收起筛选项';
      } else {
        this.$refs[slideWrap].style.height = '42px';
        event.target.innerHTML = '展开筛选项';
      }
    },
    searchProvince: function searchProvince(id) {
      var _this4 = this;

      this.$http({
        method: 'GET',
        url: '/rest/sysUser/getVisualRegionLst',
        params: {
          deep: 1,
          regionId: id
        }
      }).then(function (res) {
        _this4.provinceList = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    searchCity: function searchCity(id) {
      var _this5 = this;

      this.paramForm.cityId = null;
      this.paramForm.areaId = null;
      this.$http({
        method: 'GET',
        url: '/rest/sysUser/getVisualRegionLst',
        params: {
          deep: 2,
          regionId: id
        }
      }).then(function (res) {

        res.data.map(function (item) {
          if (item.adCode == "31020000") {
            item.adName = '上海市-县';
          } else if (item.adCode == "11020000") {
            item.adName = '北京市-县';
          } else if (item.adCode == '50020000') {
            item.adName = '重庆-县';
          } else if (item.adCode == '12020000') {
            item.adName = '天津-县';
          }
        });
        _this5.cityList = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this5, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    searchArea: function searchArea(id) {
      var _this6 = this;

      this.paramForm.areaId = null;
      this.$http({
        method: 'GET',
        url: '/rest/sysUser/getVisualRegionLst',
        params: {
          deep: 3,
          regionId: id
        }
      }).then(function (res) {
        _this6.areaList = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this6, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    handleChange: function handleChange(value) {},
    searchAllCustomer: function searchAllCustomer() {
      var _this7 = this;

      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/all-customers'
      }).then(function (res) {
        _this7.customerList = res.data.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_4__common_js_util__["a" /* default */].myNotify(_this7, 'error', err.response, '查询失败，请稍后重试');
      });
    }
  }
});

/***/ }),

/***/ "ZSZm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"90px","size":"mini","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":"身份证号","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18},model:{value:(_vm.searchData.idCard),callback:function ($$v) {_vm.$set(_vm.searchData, "idCard", $$v)},expression:"searchData.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名","prop":"custEmpName"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":6},model:{value:(_vm.searchData.custEmpName),callback:function ($$v) {_vm.$set(_vm.searchData, "custEmpName", $$v)},expression:"searchData.custEmpName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"人员ID","prop":"empPk"}},[_c('el-input',{attrs:{"placeholder":"请输入人员ID...","maxlength":12},model:{value:(_vm.searchData.empPk),callback:function ($$v) {_vm.$set(_vm.searchData, "empPk", $$v)},expression:"searchData.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"NC编码","prop":"custEmpCode"}},[_c('el-input',{attrs:{"placeholder":"请输入NC编码...","maxlength":12},model:{value:(_vm.searchData.custEmpCode),callback:function ($$v) {_vm.$set(_vm.searchData, "custEmpCode", $$v)},expression:"searchData.custEmpCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.searchData.status),callback:function ($$v) {_vm.$set(_vm.searchData, "status", $$v)},expression:"searchData.status"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"生效中","value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":"关闭","value":1}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.getData(1)}}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.exportData}},[_vm._v("导出")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.add}},[_vm._v("新增")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.insertBatchs}},[_vm._v("批量新增")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"custEmpName","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"custEmpIdcard","label":"身份证号","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","label":"人员ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"custEmpCode","label":"NC编码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 0)?_c('div',[_vm._v("生效中")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('div',[_vm._v("关闭")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"custRole","label":"职位","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createTime","label":"创建时间","align":"center","formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateTime","label":"更新时间","align":"center","formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createUser","label":"创建人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateUser","label":"更新人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"150","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 0)?_c('el-button',{staticStyle:{"color":"#1652ff"},attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.updateEmployee(scope.row)}}},[_vm._v("修改")]):_vm._e(),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{staticStyle:{"color":"rgb(245, 108, 108)"},attrs:{"type":"text","size":"mini","loading":_vm.closeLoading},on:{"click":function($event){return _vm.closeEmployee(scope.row)}}},[_vm._v("关闭")]):_vm._e(),_vm._v(" "),(scope.row.status != 0)?_c('span',[_vm._v("--")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.searchData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.searchData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"批量新增映射","visible":_vm.uploadDialog,"width":"500px","center":""},on:{"update:visible":function($event){_vm.uploadDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex"}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px","width":"41%","cursor":"pointer"},on:{"click":function($event){return _vm.downloadTmp()}}},[_vm._v("下载模板")]),_vm._v(" "),_c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":_vm.action,"on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"auto-upload":false,"limit":1,"data":{ operatorId: _vm.openid },"on-exceed":_vm.exceed,"on-change":_vm.changeUpload}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px"},attrs:{"slot":"trigger"},on:{"click":function($event){return _vm.$refs.upload.clearFiles()}},slot:"trigger"},[_vm._v("上传附件")])]),_vm._v(" "),(_vm.fileList.length == 0)?_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n            只能上传excel文件\n          ")]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small","type":"success","disabled":_vm.fileList.length === 0 || (_vm.fileList[0].percentage == 100),"loading":_vm.uploading},on:{"click":_vm.submitUpload}},[_vm._v("确认上传")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"新增映射","visible":_vm.uploadDialogi,"width":"600px","center":""},on:{"update:visible":function($event){_vm.uploadDialogi=$event}}},[_c('div',{staticClass:"dialog-body",staticStyle:{"padding-right":"20px"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("姓名：")]),_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":20},model:{value:(_vm.formData.custEmpName),callback:function ($$v) {_vm.$set(_vm.formData, "custEmpName", $$v)},expression:"formData.custEmpName"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("人员ID：")]),_c('el-input',{attrs:{"placeholder":"请输入人员ID...","maxlength":18},model:{value:(_vm.formData.empPkOrCode),callback:function ($$v) {_vm.$set(_vm.formData, "empPkOrCode", $$v)},expression:"formData.empPkOrCode"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("NC编码：")]),_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":200},model:{value:(_vm.formData.custEmpCode),callback:function ($$v) {_vm.$set(_vm.formData, "custEmpCode", $$v)},expression:"formData.custEmpCode"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("职位：")]),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择..."},model:{value:(_vm.formData.custRole),callback:function ($$v) {_vm.$set(_vm.formData, "custRole", $$v)},expression:"formData.custRole"}},_vm._l((_vm.allNcs),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"80px","color":"#f56c6c","margin-top":"10px"}},[_c('p',[_vm._v("注：如果职位是NC和兼职NC，人员ID需输入促销员ID；")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("如果职位是NCL、NCM、NCTM，人员ID需输入督导人员编码")])])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.aaa()}}},[_vm._v("确定")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"修改映射","visible":_vm.updateDialogi,"width":"600px","center":""},on:{"update:visible":function($event){_vm.updateDialogi=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("身份证号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.updateData.idCard))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("姓名：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.updateData.custEmpName))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("NC编码：")]),_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":200},model:{value:(_vm.updateData.custEmpCode),callback:function ($$v) {_vm.$set(_vm.updateData, "custEmpCode", $$v)},expression:"updateData.custEmpCode"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px","flex-shrink":"0","text-align":"right"}},[_vm._v("职位：")]),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择..."},model:{value:(_vm.updateData.custRole),callback:function ($$v) {_vm.$set(_vm.updateData, "custRole", $$v)},expression:"updateData.custRole"}},_vm._l((_vm.allNcs),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)],1)]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.update()}}},[_vm._v("确定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZjmJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/idCardCover-demo.f55001b.png";

/***/ }),

/***/ "ZlSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"90px","size":"mini","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":"姓名","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":6,"clearable":""},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18,"clearable":""},model:{value:(_vm.formData.idCard),callback:function ($$v) {_vm.$set(_vm.formData, "idCard", $$v)},expression:"formData.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","label-width":"20","prop":"status"}},[_c('el-select',{attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"生效中","value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已关闭","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已过期","value":2}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"合约公司","prop":"company"}},[_c('el-input',{attrs:{"placeholder":"请输入合约公司...","maxlength":60,"clearable":""},model:{value:(_vm.formData.company),callback:function ($$v) {_vm.$set(_vm.formData, "company", $$v)},expression:"formData.company"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.getData(1)}}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.exportData}},[_vm._v("导出")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.add}},[_vm._v("新增")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.insertBatchs}},[_vm._v("批量新增")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"not_affected_table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","align":"center","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idCard","label":"身份证","align":"center","formatter":_vm.formatIdCard,"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","label":"促销员ID","align":"center","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"clientId","label":"所属客户","align":"center","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qiyuesuoAccountId","label":"项目所属公司","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"company","label":"合约所属公司","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startDate","label":"开始日期","align":"center","width":"90","formatter":_vm.formatDateNoTime}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endDate","label":"结束日期","align":"center","width":"90","formatter":_vm.formatDateNoTime}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statusName","label":"状态","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"insertTime","label":"创建时间","align":"center","formatter":_vm.formatDate,"width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"creator","label":"创建人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateTime","label":"更新时间","align":"center","formatter":_vm.formatDate,"width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updator","label":"更新人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"80","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status === 0)?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.close(scope.row)}}},[_vm._v("关闭")]):_c('div',[_vm._v("--")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"批量新增长促白名单","visible":_vm.uploadDialog,"width":"500px","center":""},on:{"update:visible":function($event){_vm.uploadDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex"}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px","width":"41%","cursor":"pointer"},on:{"click":function($event){return _vm.downloadTmp()}}},[_vm._v("下载模板")]),_vm._v(" "),_c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":_vm.action,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"auto-upload":false,"limit":1,"data":{ operatorId: _vm.openid },"on-exceed":_vm.exceed,"on-change":_vm.changeUpload}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px"},attrs:{"slot":"trigger"},on:{"click":function($event){return _vm.$refs.upload.clearFiles()}},slot:"trigger"},[_vm._v("上传附件")])]),_vm._v(" "),(_vm.fileList.length === 0)?_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n             只能上传excel文件\n           ")]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small","type":"success","disabled":_vm.fileList.length === 0 || _vm.fileList[0].percentage == 100,"loading":_vm.uploading},on:{"click":_vm.submitUpload}},[_vm._v("确认上传")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"新增长促白名单","visible":_vm.uploadDialogi,"width":"600px","center":""},on:{"update:visible":function($event){_vm.uploadDialogi=$event}}},[_c('el-form',{ref:"formAdd",staticClass:"not_affected_m0",staticStyle:{"padding-right":"70px"},attrs:{"model":_vm.formAddData,"label-width":"150px","label-position":"right","rules":_vm.rulesAdd}},[_c('el-form-item',{attrs:{"label":"姓名:","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":20,"size":"small"},model:{value:(_vm.formAddData.name),callback:function ($$v) {_vm.$set(_vm.formAddData, "name", $$v)},expression:"formAddData.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号:","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":18,"size":"small"},model:{value:(_vm.formAddData.idCard),callback:function ($$v) {_vm.$set(_vm.formAddData, "idCard", $$v)},expression:"formAddData.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目所属公司:","prop":"qiyuesuoAccountId"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择...","size":"small","filterable":""},model:{value:(_vm.formAddData.qiyuesuoAccountId),callback:function ($$v) {_vm.$set(_vm.formAddData, "qiyuesuoAccountId", $$v)},expression:"formAddData.qiyuesuoAccountId"}},_vm._l((_vm.companyDownList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"合约所属公司:","prop":"company"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50,"size":"small"},model:{value:(_vm.formAddData.company),callback:function ($$v) {_vm.$set(_vm.formAddData, "company", $$v)},expression:"formAddData.company"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户:","prop":"clientId"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择...","size":"small","filterable":""},model:{value:(_vm.formAddData.clientId),callback:function ($$v) {_vm.$set(_vm.formAddData, "clientId", $$v)},expression:"formAddData.clientId"}},_vm._l((_vm.clientIdDropDownList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开始日期:","prop":"startDate"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"yyyy-MM-dd 00:00:00","type":"date","placeholder":"请选择...","size":"small","picker-options":_vm.pickerOptions0,"format":"yyyy-MM-dd 00:00:00"},model:{value:(_vm.formAddData.startDate),callback:function ($$v) {_vm.$set(_vm.formAddData, "startDate", $$v)},expression:"formAddData.startDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结束日期:","prop":"endDate"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"yyyy-MM-dd 23:59:59","type":"date","placeholder":"请选择...","size":"small","picker-options":_vm.pickerOptions0,"format":"yyyy-MM-dd 23:59:59"},model:{value:(_vm.formAddData.endDate),callback:function ($$v) {_vm.$set(_vm.formAddData, "endDate", $$v)},expression:"formAddData.endDate"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small","loading":_vm.addUpBtnLoading},on:{"click":function($event){return _vm.updata('formAdd')}}},[_vm._v("确定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a93p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"systemHeader"},[_c('router-link',{staticClass:"systemTitle pointer",attrs:{"to":"/LookHistory"}},[_vm._v("< 返回上一页")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("评估体系")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("体系配置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("配置历史查询")]),_vm._v(" "),(_vm.navState==1)?_c('el-breadcrumb-item',[_vm._v("体系配置")]):_vm._e(),_vm._v(" "),(_vm.navState==2)?_c('el-breadcrumb-item',[_vm._v("积分")]):_vm._e(),_vm._v(" "),(_vm.navState==3)?_c('el-breadcrumb-item',[_vm._v("星级")]):_vm._e(),_vm._v(" "),(_vm.navState==4)?_c('el-breadcrumb-item',[_vm._v("信用")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"tabPages"},[_c('div',{staticClass:"systemNav"},_vm._l((_vm.pages),function(item,index){return _c('div',{key:index,staticClass:"systemNavWrap"},[_c('div',{staticClass:"pages pointer",class:{'isActive': _vm.navState == index+1},on:{"click":function($event){_vm.navState = index+1}}},[_c('span',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.navState == index+1),expression:"navState == index+1"}],attrs:{"src":item.checkedIcon}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.navState != index+1),expression:"navState != index+1"}],attrs:{"src":item.icon}}),_vm._v("\n            "+_vm._s(item.name)+"\n          ")])])])}),0)]),_vm._v(" "),_c('div',[(_vm.navState == 1)?_c('System'):_vm._e(),_vm._v(" "),(_vm.navState == 2)?_c('Score'):_vm._e(),_vm._v(" "),(_vm.navState == 3)?_c('Star',{key:"星级",attrs:{"scoreType":2}}):_vm._e(),_vm._v(" "),(_vm.navState == 4)?_c('Star',{key:"信用",attrs:{"scoreType":3}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"systemCalendar"},[_c('span',{staticClass:"calendarStart"},[_vm._v("计算起点时间")]),_vm._v(" "),_c('span',{staticClass:"calendarTime"},[_vm._v("2017-03")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a9UP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allCustomers: [],
      allCompany: [],
      allService: [], //服务商
      allSupplier: [], //落地方
      formData: {
        pageNo: 1,
        pageSize: 10,
        projectCode: null,
        projectName: null,
        serviceSupplier: null,
        serviceId: null,
        supplierId: null
      },
      tableData: [],
      total: null,
      listLoading: false,
      editId: null,
      editCustomer: null,
      showEditDialog: false,
      editSuffix: null,
      nextEditSuffix: null,
      editAuth: false,
      serviceSuppliers: []
    };
  },
  mounted: function mounted() {
    // this.getEditCustomerConfigAuth();
    // this.searchAllCustomer();
    // this.searchAllCompany();
    this.getData();
    this.getServiceSuppliers();
    this.searchAllServiceSupplier('落地方');
    this.searchAllServiceSupplier('服务商');
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/projectSupplierRecord/recordList',
        params: this.formData
      }).then(function (res) {
        _this.tableData = res.data.data.items;
        _this.total = res.data.data.totalItemsCount;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    searchAllCustomer: function searchAllCustomer() {
      var _this2 = this;

      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/all-customers'
      }).then(function (res) {
        _this2.allCustomers = res.data.data;
      }).catch(function (err) {});
    },
    searchAllCompany: function searchAllCompany() {
      var _this3 = this;

      this.$http({
        method: 'GET',
        url: '/rest/customer/company-list'
      }).then(function (res) {
        _this3.allCompany = res.data.data;
      }).catch(function (err) {});
    },
    searchAllServiceSupplier: function searchAllServiceSupplier(typeName) {
      var _this4 = this;

      this.$http({
        method: 'GET',
        url: '/rest/customer/service-supplier',
        params: {
          typeName: typeName
        }
      }).then(function (res) {
        if (typeName == '服务商') {
          _this4.allService = res.data.data;
        } else if (typeName == '落地方') {
          _this4.allSupplier = res.data.data;
        }
      }).catch(function (err) {});
    },
    submitForm: function submitForm() {
      this.formData.pageSize = 10;
      this.formData.pageNo = 1;
      this.getData();
    },
    exportExcel: function exportExcel() {
      var _this5 = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/projectSupplierRecord/export',
        params: this.formData
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          _this5.listLoading = false;
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        } else {
          _this5.listLoading = false;
          _this5.$alert(res.data.message);
        }
      }).catch(function (error) {
        _this5.listLoading = false;
        _this5.$alert("导出错误，请联系管理员！");
      });
    },
    resetForm: function resetForm() {
      this.$refs['formData'].resetFields();
      this.submitForm();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    openEditDialog: function openEditDialog(id, customer, suffix, nextSuffix) {
      this.editId = id;
      this.editCustomer = customer;
      this.showEditDialog = true;
      this.editSuffix = suffix;
      this.nextEditSuffix = nextSuffix;
    },
    editCustomerConfig: function editCustomerConfig() {
      var _this6 = this;

      this.$http({
        method: 'POST',
        url: '/rest/customer/edit',
        params: {
          id: this.editId,
          suffix: this.editSuffix,
          nextSuffix: this.nextEditSuffix
        }
      }).then(function (res) {
        _this6.showEditDialog = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "success", res, '操作成功');
        _this6.getData();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "error", res, '操作失败');
      });
    },
    getEditCustomerConfigAuth: function getEditCustomerConfigAuth() {
      var _this7 = this;

      this.$http({
        method: 'GET',
        url: '/rest/customer/edit-auth'
      }).then(function (res) {
        _this7.editAuth = res.data.data;
      }).catch(function (err) {});
    },
    getServiceSuppliers: function getServiceSuppliers() {
      var _this8 = this;

      this.$http({
        method: 'GET',
        url: '/rest/JiangYiJoint/getServiceSuppliers'

      }).then(function (res) {
        _this8.serviceSuppliers = res.data;
      }).catch(function (err) {});
    }
  }
});

/***/ }),

/***/ "aPDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supervise_vue__ = __webpack_require__("9/4D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d820f78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supervise_vue__ = __webpack_require__("WrK8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supervise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d820f78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supervise_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "alHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xingji"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"starBody"},[_vm._l((_vm.infoArr),function(item,index){return _c('div',{staticClass:"starSet"},[_c('div',{staticClass:"starSetTitle"},[_vm._v("\n        "+_vm._s(item.masterName)+"\n      ")]),_vm._v(" "),(!_vm.isEdit)?_c('div',{staticClass:"starSetTitleTag"},[(item.long.length > 0)?_c('span',[_c('span',{staticClass:"tag-item long"},[_vm._v("长")]),_vm._v("长促\n        ")]):_vm._e(),_vm._v(" "),(item.short.length > 0)?_c('span',[_c('span',{staticClass:"tag-item"},[_vm._v("短")]),_vm._v(" 短促\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticClass:"starSetTitleTag"},[_c('el-checkbox',{attrs:{"checked":item.long.length>0},on:{"change":function($event){return _vm.changeState(item.masterId,'1')}}},[_vm._v("长促")]),_vm._v(" "),_c('el-checkbox',{attrs:{"checked":item.short.length>0},on:{"change":function($event){return _vm.changeState(item.masterId,'2')}}},[_vm._v("短促")])],1):_vm._e(),_vm._v(" "),(item.long.length>0)?_c('div',{staticClass:"starContainer"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list myForm"},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('tr',{staticStyle:{"background-color":"#f8f8f8"}},[_c('th',{staticStyle:{"padding":"8px"},attrs:{"width":"100px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数区间' : '分值区间'))]),_vm._v(" "),_vm._l((item.long),function(item2,index2){return _c('th',{staticClass:"jujian",attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item2.scoreMin)+" "),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item2.scoreMax)+" "),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMin"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":_vm.save},model:{value:(item2.scoreMin),callback:function ($$v) {_vm.$set(item2, "scoreMin", $$v)},expression:"item2.scoreMin"}})],1)],1),_vm._v("\n                  -\n                  "),_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMax"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":_vm.save},model:{value:(item2.scoreMax),callback:function ($$v) {_vm.$set(item2, "scoreMax", $$v)},expression:"item2.scoreMax"}})],1)],1)],1):_vm._e()])}),_vm._v(" "),_c('th'),_vm._v(" "),(item.long.length < 8 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.addInfo(item.masterId,1)}}},[_c('img',{attrs:{"src":__webpack_require__("7X0c"),"alt":""}})]):_vm._e(),_vm._v(" "),(item.long.length > 1 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.reduceInfo(item.masterId,'1')}}},[_vm._v("\n                —\n              ")]):_vm._e()],2),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"8px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数设定' : '分值设定'))]),_vm._v(" "),_vm._l((item.long),function(item2,index2){return _c('td',{attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',[_vm._v(_vm._s(item2.score))]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"score","rules":[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]}},[_c('el-input',{attrs:{"type":"age","auto-complete":"off","placeholder":"请输入分数"},on:{"change":_vm.save},model:{value:(item2.score),callback:function ($$v) {_vm.$set(item2, "score", _vm._n($$v))},expression:"item2.score"}})],1)],1):_vm._e()],1)}),_vm._v(" "),_c('td')],2)])])]):_vm._e(),_vm._v(" "),(item.short.length>0)?_c('div',{staticClass:"starContainer"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list myForm"},[_c('table',[_c('tr',{staticStyle:{"background-color":"#f8f8f8"}},[_c('th',{staticStyle:{"padding":"8px"},attrs:{"width":"100px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数区间' : '分值区间'))]),_vm._v(" "),_vm._l((item.short),function(item2,index2){return _c('th',{staticClass:"jujian",attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item2.scoreMin)+" "),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item2.scoreMax)+" "),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMin"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":_vm.save},model:{value:(item2.scoreMin),callback:function ($$v) {_vm.$set(item2, "scoreMin", $$v)},expression:"item2.scoreMin"}})],1)],1),_vm._v("\n                  -\n                  "),_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMax"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":_vm.save},model:{value:(item2.scoreMax),callback:function ($$v) {_vm.$set(item2, "scoreMax", $$v)},expression:"item2.scoreMax"}})],1)],1)],1):_vm._e()])}),_vm._v(" "),_c('th'),_vm._v(" "),(item.short.length < 8 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.addInfo(item.masterId,2)}}},[_c('img',{attrs:{"src":__webpack_require__("7X0c"),"alt":""}})]):_vm._e(),_vm._v(" "),(item.short.length > 1 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.reduceInfo(item.masterId,'2')}}},[_vm._v("\n                —\n              ")]):_vm._e()],2),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"8px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数设定' : '分值设定'))]),_vm._v(" "),_vm._l((item.short),function(item2,index2){return _c('td',{attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',[_vm._v(_vm._s(item2.score))]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"score","rules":[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]}},[_c('el-input',{attrs:{"type":"age","auto-complete":"off","placeholder":"请输入分数"},on:{"change":_vm.save},model:{value:(item2.score),callback:function ($$v) {_vm.$set(item2, "score", _vm._n($$v))},expression:"item2.score"}})],1)],1):_vm._e()],1)}),_vm._v(" "),_c('td')],2)])])]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.danXuanArr),function(item,index){return _c('div',{staticClass:"starSet danxuan"},[_c('div',{staticClass:"starSetTitle"},[_vm._v("\n        "+_vm._s(item.masterName)+"\n        "),_c('div',{staticClass:"valueSetting"},[_vm._v("\n          分值设定：\n          "),(!_vm.isEdit)?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            "+_vm._s(item.score)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticStyle:{"display":"inline-block"}},[_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"score"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"请输入分数","maxlength":4},on:{"change":_vm.save},model:{value:(item.score),callback:function ($$v) {_vm.$set(item, "score", $$v)},expression:"item.score"}})],1)],1)],1):_vm._e()])])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thisTitle"},[_c('span',{staticClass:"thisIcon"},[_c('img',{attrs:{"src":__webpack_require__("qeIN"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("信用")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headPortrait"},[_c('span',{staticClass:"tag-item big short"},[_vm._v("长")]),_vm._v(" "),_c('span',[_vm._v("长促")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headPortrait"},[_c('span',{staticClass:"tag-item big"},[_vm._v("短")]),_vm._v(" "),_c('span',[_vm._v("短促")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aq3u":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjAzNzMwMjVGNDkyQzExRTg5MkRCQjFCQUI1MEFFRkVEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjAzNzMwMjYwNDkyQzExRTg5MkRCQjFCQUI1MEFFRkVEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDM3MzAyNUQ0OTJDMTFFODkyREJCMUJBQjUwQUVGRUQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDM3MzAyNUU0OTJDMTFFODkyREJCMUJBQjUwQUVGRUQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7JghUDAAABl0lEQVR42ryWPUvEQBCGN0dsDw7sFBQ9RBDBH2CljdxZWFuJlR9wnVgIFmJlJVxxFvofbKxsxcLOSss0fheHhwriR3wmjhDi5eKZTQYedrLZ7LuzmUnWGMz3/Qqc+/ZN5qyIhqPOkfm2FjSNHStBUf2qCUWyDo4lEZnX0TmDyIw6jzZFImIyt1/QvqbjOL5tIZ0zeBWFLlY3DVNpwhPzEsYs67h3cLuc35MHfwnhF2EbhiMiYvV/BBIItVvdJGzAAvcPaDe1fw9q+rBs+Q6U2zz/DGu8n+uOW6eZ0ogUXiOclRr1a4dCnUuMSDIFW9HLJWjAajgr8VuMGcPtbxPRC/fPukoG+vss1JIXrqO4OriyVVOFhNX0QG+mQggs0tzDA/4FTKQRcmNExmn2ZfdA0nQUDukfYjs/dUw5dTJwXdP+XXmPcKnXI9bSW+1G2xm4hUH4gDvtf4J6h4L9c0SSBKeRVW6lSW83Jq3f9Es9DwNwQt9x2oJK/HpnXrA27UeolNWvXA8pJrfDSV7HrVmTwwGyKhpfAgwA43SU70BSMdgAAAAASUVORK5CYII="

/***/ }),

/***/ "ax23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰180723重写
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'zScore',
  data: function data() {
    return {
      scoreArr: [],
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.$http({
      method: "get",
      url: '/rest/ScoreSystemSettings/searchScore',
      params: {
        startTime: this.$route.query.sTime,
        scoreType: 1
      }
    }).then(function (res) {
      _this.scoreArr = res.data;
      _this.loading = false;
    }).catch(function () {
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ "b+OC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialogVisible: false,
      param: {
        salemansName: "",
        idCard: "",
        clientID: "",
        pageNo: 1,
        pageSize: 10
      },
      allCustomers: [], //项目列表数组
      tableData: [],
      total: 0,
      listLoading: true
    };
  },
  mounted: function mounted() {
    this.getTerminal();
    this.getList();
  },

  methods: {
    //获取项目列表
    getTerminal: function getTerminal() {
      var _this = this;

      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/clientDropDownList"
      }).then(function (res) {
        _this.allCustomers = res.data.data;
      }).catch(function (err) {
        _this.myNotify(_this, "error", err.response, "查询失败，请稍后重试");
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmQhrInfoRest/getContractList",
        headers: { "content-type": "application/json" },
        params: {
          salemansName: this.param.employeeName,
          clientID: this.param.clientId,
          idCard: this.param.idCard,
          pageNo: this.param.pageNo,
          pageSize: this.param.pageSize
        }
      }).then(function (res) {
        console.log(res.data);
        _this2.tableData = res.data;
        _this2.listLoading = false;
      });
      this.$http({
        method: "POST",
        url: "/rest/CrmQhrInfoRest/countContract",
        params: {
          salemansName: this.param.employeeName,
          clientID: this.param.clientId,
          idCard: this.param.idCard,
          pageNo: this.param.pageNo,
          pageSize: this.param.pageSize
        }
      }).then(function (res) {
        _this2.total = res.data;
      });
    },
    handleSizeChange: function handleSizeChange(value) {
      this.param.pageSize = value;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.param.pageNo = value;
      // this.Information = false;
      this.getList();
    },
    submitForm: function submitForm() {
      this.param.pageNo = 1;
      this.getList();
    },
    computedDate: function computedDate(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format("YYYY-MM-DD");
      } else {
        return "";
      }
    }
  }
});

/***/ }),

/***/ "b7sq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"协议授权配置"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"125px","size":"mini"}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.param.projectCode),callback:function ($$v) {_vm.$set(_vm.param, "projectCode", $$v)},expression:"param.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.param.projectName),callback:function ($$v) {_vm.$set(_vm.param, "projectName", $$v)},expression:"param.projectName"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("展开筛选项")])],1)],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('div',{staticClass:"title"},[_vm._v("筛选结果")]),_vm._v(" "),_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"100","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"30%"},attrs:{"prop":"title","label":"协议名称","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.handleAgreeContent(scope.row)}}},[_vm._v(_vm._s(scope.row.title))])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"30%"},attrs:{"prop":"count","label":"关联项目","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"cursor":"pointer","color":"#18a7ff","text-decoration":"underline"},on:{"click":function($event){return _vm.handleProject(scope.row)}}},[_vm._v("\n              "+_vm._s(scope.row.count)+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"30%"},attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleProject(scope.row)}}},[_c('span',{staticStyle:{"color":"#66cc33"}},[_vm._v("编辑")])])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('Project',{ref:"Project",on:{"done":_vm.getData}}),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog Qhr_contract",attrs:{"title":_vm.handleItem ? _vm.handleItem[1] : '错误当前无操作对象',"width":"480px","show-close":true,"visible":_vm.customer,"top":"27vh","center":""},on:{"update:visible":function($event){_vm.customer=$event}}},[_c('el-form',{attrs:{"label-width":"140px"}},[_c('el-form-item',{staticStyle:{"margin":"20px 0"},attrs:{"label":"对应项目客户："}},[_c('el-select',{attrs:{"filterable":"","filterMethod":function (val) {
              _vm.$store.state.funciton.filter(
                val,
                this$1,
                'allCustomer',
                'keepAllCustomer'
              );
            },"placeholder":"请选择..."},on:{"visible-change":function () {
              _vm.$store.state.funciton.filter(
                '',
                this$1,
                'allCustomer',
                'keepAllCustomer'
              );
            },"change":function($event){_vm.disabledSubCustomer = false}},model:{value:(_vm.customerValue),callback:function ($$v) {_vm.customerValue=$$v},expression:"customerValue"}},_vm._l((_vm.allCustomer),function(item){return _c('el-option',{key:item[0],attrs:{"label":item[1],"value":item}})}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.customer = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.disabledSubCustomer,"size":"small"},on:{"click":function($event){return _vm.subCustomer()}}},[_vm._v("确 定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"blacklistDialog dialog",attrs:{"title":this.title,"visible":_vm.authorizeDialog,"width":"1030px","center":""},on:{"update:visible":function($event){_vm.authorizeDialog=$event}}},[_c('div',{staticStyle:{"font-size":"15px","padding":"10px","text-align":"left"}},[_c('div',{},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"5px","font-weight":"700"}},[_vm._v(_vm._s(this.title))])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"scroll","max-height":"400px"}},[_c('span',{staticStyle:{"white-space":"pre-line","padding":"0 5px"}},[_vm._v("\n          "+_vm._s(this.content)+"\n        ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bDEP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "baD+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bo56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xingji"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"starBody"},[_vm._l((_vm.infoArr),function(item,index){return _c('div',{key:index,staticClass:"starSet"},[_c('div',{staticClass:"starSetTitle"},[_vm._v(_vm._s(item.masterName))]),_vm._v(" "),(!_vm.isEdit)?_c('div',{staticClass:"starSetTitleTag"},[(item.long.length > 0)?_c('span',[_c('span',{staticClass:"tag-item long"},[_vm._v("长")]),_vm._v("长促\n        ")]):_vm._e(),_vm._v(" "),(item.short.length > 0)?_c('span',[_c('span',{staticClass:"tag-item"},[_vm._v("短")]),_vm._v(" 短促\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticClass:"starSetTitleTag"},[_c('el-checkbox',{attrs:{"checked":item.long.length>0},on:{"change":function($event){return _vm.changeState(item.masterId,'1')}}},[_vm._v("长促")]),_vm._v(" "),_c('el-checkbox',{attrs:{"checked":item.short.length>0},on:{"change":function($event){return _vm.changeState(item.masterId,'2')}}},[_vm._v("短促")])],1):_vm._e(),_vm._v(" "),(item.long.length>0)?_c('div',{staticClass:"starContainer"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list myForm"},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('tr',{staticStyle:{"background-color":"#f8f8f8"}},[_c('th',{staticStyle:{"padding":"8px"},attrs:{"width":"100px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数区间' : '分值区间'))]),_vm._v(" "),_vm._l((item.long),function(item2,index2){return _c('th',{staticClass:"jujian",attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v("\n                  "+_vm._s(item2.scoreMin)+" "),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v("\n                  "+_vm._s(item2.scoreMax)+" "),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMin"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item2.scoreMin),callback:function ($$v) {_vm.$set(item2, "scoreMin", $$v)},expression:"item2.scoreMin"}})],1)],1),_vm._v(" -\n                  "),_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMax"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item2.scoreMax),callback:function ($$v) {_vm.$set(item2, "scoreMax", $$v)},expression:"item2.scoreMax"}})],1)],1)],1):_vm._e()])}),_vm._v(" "),_c('th'),_vm._v(" "),(item.long.length < 8 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.addInfo(item.masterId,1)}}},[_c('img',{attrs:{"src":__webpack_require__("7X0c"),"alt":""}})]):_vm._e(),_vm._v(" "),(item.long.length > 1 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.reduceInfo(item.masterId,'1')}}},[_vm._v(" —\n              ")]):_vm._e()],2),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"8px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数设定' : '分值设定'))]),_vm._v(" "),_vm._l((item.long),function(item2,index2){return _c('td',{attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',[_vm._v(_vm._s(item2.score))]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"score","rules":[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]}},[_c('el-input',{attrs:{"type":"age","auto-complete":"off","placeholder":"请输入分数"},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item2.score),callback:function ($$v) {_vm.$set(item2, "score", _vm._n($$v))},expression:"item2.score"}})],1)],1):_vm._e()],1)}),_vm._v(" "),_c('td')],2)])])]):_vm._e(),_vm._v(" "),(item.short.length>0)?_c('div',{staticClass:"starContainer"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list myForm"},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('tr',{staticStyle:{"background-color":"#f8f8f8"}},[_c('th',{staticStyle:{"padding":"8px"},attrs:{"width":"100px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数区间' : '分值区间'))]),_vm._v(" "),_vm._l((item.short),function(item2,index2){return _c('th',{staticClass:"jujian",attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item2.scoreMin)),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item2.scoreMax)),(item.masterId == 135 ||item.masterId == 136)?_c('i',[_vm._v("%")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMin"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item2.scoreMin),callback:function ($$v) {_vm.$set(item2, "scoreMin", $$v)},expression:"item2.scoreMin"}})],1)],1),_vm._v("\n                  -\n                  "),_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMax"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":item.masterId == 135 ||item.masterId ==  136 ? '%':'分'},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item2.scoreMax),callback:function ($$v) {_vm.$set(item2, "scoreMax", $$v)},expression:"item2.scoreMax"}})],1)],1)],1):_vm._e()])}),_vm._v(" "),_c('th'),_vm._v(" "),(item.short.length < 8 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.addInfo(item.masterId,2)}}},[_c('img',{attrs:{"src":__webpack_require__("7X0c"),"alt":""}})]):_vm._e(),_vm._v(" "),(item.short.length > 1 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.reduceInfo(item.masterId,'2')}}},[_vm._v("\n                —\n              ")]):_vm._e()],2),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"8px"}},[_vm._v(_vm._s(item.masterId == 128 ? '人数设定' : '分值设定'))]),_vm._v(" "),_vm._l((item.short),function(item2,index2){return _c('td',{attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',[_vm._v(_vm._s(item2.score))]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item2,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"score","rules":[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]}},[_c('el-input',{attrs:{"type":"age","auto-complete":"off","placeholder":"请输入分数"},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item2.score),callback:function ($$v) {_vm.$set(item2, "score", _vm._n($$v))},expression:"item2.score"}})],1)],1):_vm._e()],1)}),_vm._v(" "),_c('td')],2)])])]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.danXuanArr),function(item,index){return _c('div',{staticClass:"starSet danxuan"},[_c('div',{staticClass:"starSetTitle"},[_vm._v("\n        "+_vm._s(item.masterName)+"\n        "),_c('div',{staticClass:"valueSetting"},[_vm._v("\n          分值设定：\n          "),(!_vm.isEdit)?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            "+_vm._s(item.score)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticStyle:{"display":"inline-block"}},[_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item,"rules":_vm.rules,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"score"}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"请输入分数","maxlength":4},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item.score),callback:function ($$v) {_vm.$set(item, "score", $$v)},expression:"item.score"}})],1)],1)],1):_vm._e()])])])}),_vm._v(" "),_c('div',{staticClass:"starSet"},[_c('div',{staticClass:"starSetTitle"},[_vm._v("\n        星级设定\n      ")]),_vm._v(" "),_c('div',{staticClass:"starContainer myForm"},[_c('table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('tr',{staticStyle:{"background-color":"#f8f8f8"}},[_c('th',{staticStyle:{"padding":"8px"},attrs:{"width":"100px"}},[_vm._v("分值区间")]),_vm._v(" "),_vm._l((_vm.starSetArr),function(item,index){return _c('th',{attrs:{"width":"130"}},[(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item.scoreMin))]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('div',{staticClass:"showDiv"},[_vm._v(_vm._s(item.scoreMax))]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('div',{staticClass:"jujian",staticStyle:{"width":"100px","margin":"0 auto"}},[_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMin","rules":[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]}},[_c('el-input',{attrs:{"type":"age","auto-complete":"off","placeholder":"分","maxlength":4},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item.scoreMin),callback:function ($$v) {_vm.$set(item, "scoreMin", _vm._n($$v))},expression:"item.scoreMin"}})],1)],1),_vm._v(" -\n                "),_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"scoreMax","rules":[{ required: true,message:'*'},{ pattern: /^\d{1,4}$/, message: '*' }]}},[_c('el-input',{attrs:{"type":"age","auto-complete":"off","placeholder":"分"},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item.scoreMax),callback:function ($$v) {_vm.$set(item, "scoreMax", _vm._n($$v))},expression:"item.scoreMax"}})],1)],1)],1):_vm._e()])}),_vm._v(" "),_c('th'),_vm._v(" "),(_vm.starSetArr.length < 8 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.addStar()}}},[_c('img',{attrs:{"src":__webpack_require__("7X0c"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.starSetArr.length >1 && _vm.isEdit)?_c('th',{staticClass:"pointer",attrs:{"rowspan":"2","width":"50px"},on:{"click":function($event){return _vm.reduceStar()}}},[_vm._v("\n              —\n            ")]):_vm._e()],2),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"8px"}},[_vm._v("星级名称")]),_vm._v(" "),_vm._l((_vm.starSetArr),function(item,index){return _c('td',[(!_vm.isEdit)?_c('div',[_vm._v("\n                "+_vm._s(item.starName)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('el-form',{staticClass:"demo-ruleForm",attrs:{"model":item,"label-width":"50px"}},[_c('el-form-item',{attrs:{"prop":"starName"}},[_c('el-input',{attrs:{"type":"age","auto-complete":"off","placeholder":"请输入文字"},on:{"change":function($event){return _vm.changeValue()}},model:{value:(item.starName),callback:function ($$v) {_vm.$set(item, "starName", _vm._n($$v))},expression:"item.starName"}})],1)],1):_vm._e()],1)}),_vm._v(" "),_c('td')],2)])])])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thisTitle"},[_c('span',{staticClass:"thisIcon"},[_c('img',{attrs:{"src":__webpack_require__("0mlY"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("星级")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headPortrait"},[_c('span',{staticClass:"tag-item big short"},[_vm._v("长")]),_vm._v(" "),_c('span',[_vm._v("长促")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headPortrait"},[_c('span',{staticClass:"tag-item big"},[_vm._v("短")]),_vm._v(" "),_c('span',[_vm._v("短促")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bpl+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c0y2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_virtualProject_vue__ = __webpack_require__("1BE2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1535f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_virtualProject_vue__ = __webpack_require__("uCw4");
function injectStyle (ssrContext) {
  __webpack_require__("TSZV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c1535f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_virtualProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1535f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_virtualProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cCgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationDetail_vue__ = __webpack_require__("AMTf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d8afabc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationDetail_vue__ = __webpack_require__("ss1W");
function injectStyle (ssrContext) {
  __webpack_require__("FCKL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d8afabc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d8afabc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cMrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰180705优化重写



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "projLabelConfig",
  data: function data() {
    return {
      auths: [], // 页面内权限
      //筛选项及table数据
      formData: {
        projectId: null,
        projectCode: '',
        projectName: '',
        categoryStatus: '',
        postStatus: '',
        categoryId: null,
        postId: null,
        pageNo: 1,
        pageSize: 10
      },
      total: null,
      tableData: [],
      tableDataLoading: false,
      listDataLoading: true,
      /*
      弹窗相关数据
      */
      signList: [], //行业标签基础数据
      postList: [], //岗位标签基础数据
      ACKButtonLoading: false, //编辑弹窗的确认按钮是否不可用
      confirmDialog: false,
      editRowDialog: false,
      //弹窗数据
      editRowObj: {
        crmProject: {
          projectCode: null,
          projectName: null
        },
        categoryIdLst: null,
        postIdLst: null
      }
    };
  },

  computed: {
    listLoading: function listLoading() {
      return Boolean(this.tableDataLoading || this.listDataLoading);
    }
  },
  mounted: function mounted() {
    this.getData();
    this.getAuth();
    this.getLabalList();
  },

  methods: {
    //工具类-转换时间格式
    formatDate: function formatDate(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(cellValue).format('YYYY-MM-DD');
      } else {
        return '';
      }
    },

    //获取页面权限
    getAuth: function getAuth() {
      var _this = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 10,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        res.data.map(function (item) {
          _this.auths.push(item.auth);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '权限获取失败，请稍后重试');
      });
    },

    /*
    table相关
    */
    //获取数据并赋给tableData中
    getData: function getData() {
      var _this2 = this;

      this.tableDataLoading = true;
      this.$http({
        method: "GET",
        url: '/rest/projectSign/projectSignConfig',
        params: this.formData
      }).then(function (res) {
        //搜索时没有权限，进行提示
        if (res.data.status == 460) {
          __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this2, 'error', res, '查询失败，请稍后重试');
        } else {
          _this2.tableData = res.data;
        }
        _this2.tableDataLoading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
        _this2.tableDataLoading = false;
      });
      //获取搜索到的总条数
      this.$http({
        method: "GET",
        url: '/rest/projectSign/searchCountProjectSignConfig',
        params: this.formData
      }).then(function (res) {
        _this2.total = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },

    //编辑本行数据
    toggleExpansion: function toggleExpansion(row, handle) {
      this.editRowDialog = true;
      row.postIdLst = row.postIdLst[0] ? row.postIdLst[0] : null; //后端返回的格式不对，在这转换一下
      this.editRowObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row));
    },

    /*
    编辑弹窗相关
    */
    //获取标签列表的基础数据
    getLabalList: function getLabalList() {
      var _this3 = this;

      // 获取行业标签，按级别保存在signList中，随后删除没有children值的children属性
      this.$http({
        method: "GET",
        url: '/rest/projectSign/getSignLst',
        params: {
          signType: 1
        }
      }).then(function (res) {
        var data = []; //把所有的空集都删掉
        var maxLevel = 1; //每个数组中的级别肯定是一样的，所以只要有长度，就取他第一位的级别，记录其最大值
        res.data.map(function (item) {
          if (item.length) {
            data.push(item);
            if (item[0].signLevel > maxLevel) {
              maxLevel = item[0].signLevel;
            }
          }
        });
        //记录所有的level
        var everyLevel = [];
        for (var i = 0; i < maxLevel; i++) {
          everyLevel.push([]);
        }
        data.map(function (item) {
          item.map(function (item1) {
            everyLevel[item1.signLevel - 1].push({
              value: item1.id,
              label: item1.signName,
              pid: item1.pid,
              children: []
            });
          });
        });
        //为所有的子集找爸爸，必须是倒着来for

        var _loop = function _loop(_i) {
          everyLevel[_i].map(function (item1) {
            everyLevel[_i - 1].map(function (item2) {
              if (item2.value == item1.pid) {
                item2.children.push(item1);
              }
            });
          });
        };

        for (var _i = maxLevel - 1; _i > 0; _i--) {
          _loop(_i);
        }
        //最后把所有的空children数组删掉，然后赋值给list
        _this3.clearEmpty(everyLevel[0]);
        _this3.signList = everyLevel[0];
        _this3.listDataLoading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
        _this3.listDataLoading = false;
      });

      // 岗位标签，获取后按级别追加到postList
      this.$http({
        method: "GET",
        url: '/rest/projectSign/getSignLst',
        params: {
          signType: 2
        }
      }).then(function (res) {
        var data = res.data;
        data[0].map(function (item) {
          if (item.signName != '不限') {
            _this3.postList.push({
              value: item.id,
              label: item.signName
            });
          }
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //type 区分是编辑还是清空，row其实不用传，无所谓了
    //如果是清除绑定，则先清除，然后再以当前数据执行一次编辑-确认
    updateProjectSign: function updateProjectSign(row, type) {
      var _this4 = this;

      if (type == 'clear') {
        this.editRowObj.categoryIdLst = [];
        this.editRowObj.postIdLst = null;
        this.confirmDialog = false;
        this.updateProjectSign(this.editRowObj, 'edit');
      } else {
        this.ACKButtonLoading = true;
        this.$http({
          method: 'POST',
          url: '/rest/projectSign/updateProjectSign',
          data: {
            projectId: row.crmProject.id,
            categoryId: row.categoryIdLst[row.categoryIdLst.length - 1] || null, //插件必须读数组，而更新时候只要传里面最后一个孩子的id即可
            postId: row.postIdLst
          }
        }).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this4, 'success', res, '操作成功');
          _this4.getData();
          _this4.editRowDialog = false;
          _this4.ACKButtonLoading = false;
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_1__common_js_util__["a" /* default */].myNotify(_this4, 'error', err.response, '操作失败，请稍后重试');
          _this4.ACKButtonLoading = false;
        });
      }
    },

    //去除空的children（此弹窗专用的工具函数）
    clearEmpty: function clearEmpty(arr) {
      var _this5 = this;

      arr.map(function (item) {
        if (item.children.length == 0) {
          delete item.children;
        } else {
          _this5.clearEmpty(item.children);
        }
      });
    }
  }
});

/***/ }),

/***/ "cPAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterParam_vue__ = __webpack_require__("ZSOq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad7e9f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterParam_vue__ = __webpack_require__("HK3G");
function injectStyle (ssrContext) {
  __webpack_require__("Fjwn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ad7e9f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterParam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad7e9f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterParam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cPt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cYUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"thisTitle"},[_c('span',{staticClass:"thisIcon"},[(_vm.scoreType==2)?_c('img',{attrs:{"src":__webpack_require__("0mlY"),"alt":""}}):_c('img',{attrs:{"src":__webpack_require__("qeIN"),"alt":""}})]),_vm._v(" "),(_vm.scoreType==2)?_c('span',[_vm._v("星级")]):_c('span',[_vm._v("信用")])]),_vm._v(" "),_c('div',{staticClass:"starBody"},[_vm._l((_vm.mainData),function(item){return _c('div',{staticClass:"starSet"},[_c('div',{staticClass:"starSetTitle"},[_vm._v("\n        "+_vm._s(item.name)+"\n        "),(item.onlyScore != -1)?_c('div',{staticClass:"valueSetting"},[_vm._v("\n          分值设定："),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(item.onlyScore))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"starSetTitleTag"},_vm._l((item.type),function(item2){return _c('div',[_c('span',{staticClass:"tag-item",class:{'long':item2=='长'}},[_vm._v(_vm._s(item2))]),_vm._v(_vm._s(item2)+"促\n        ")])}),0),_vm._v(" "),_vm._l((item.type),function(item2){return _c('div',{staticClass:"starContainer"},[_c('div',{staticClass:"headPortrait"},[_c('span',{staticClass:"tag-item big",class:{'short':item2=='短'}},[_vm._v(_vm._s(item2))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item2)+"促")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right"})]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('table',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("分值区间")]),_vm._v(" "),_vm._l(((item2=='长' ? item.long : item.short)),function(item3){return _c('th',{staticClass:"wid130"},[_c('span',{staticClass:"range"},[_c('span',[_vm._v("\n                    "+_vm._s(item3.min)),(item.name.indexOf('率') > -1)?_c('span',[_vm._v("%")]):_c('span',[_vm._v("分")])]),_vm._v("-\n                  "),_c('span',[_vm._v("\n                    "+_vm._s(item3.max)),(item.name.indexOf('率') > -1)?_c('span',[_vm._v("%")]):_c('span',[_vm._v("分")])])])])})],2),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"100"}},[_vm._v("分值设定")]),_vm._v(" "),_vm._l(((item2=='长' ? item.long : item.short)),function(item3){return _c('td',{staticClass:"wid130"},[_vm._v("\n                "+_vm._s(item3.score)),(item.name.indexOf('率') > -1)?_c('span',[_vm._v("%")]):_c('span',[_vm._v("分")])])})],2)])])])})],2)}),_vm._v(" "),(_vm.scoreType==2)?_c('div',{staticClass:"starSet"},[_c('div',{staticClass:"starSetTitle"},[_vm._v("星级设定")]),_vm._v(" "),_c('div',{staticClass:"starContainer"},[_c('table',{staticClass:"wid100per"},[_c('tr',[_c('th',{attrs:{"width":"100px"}},[_vm._v("分值区间")]),_vm._v(" "),_vm._l((_vm.starSetArr),function(item){return _c('th',{staticClass:"wid130"},[_c('span',{staticClass:"range"},[_c('span',[_vm._v(_vm._s(item.scoreMin))]),_vm._v("-\n                "),_c('span',[_vm._v(_vm._s(item.scoreMax))])])])})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("星级名称")]),_vm._v(" "),_vm._l((_vm.starSetArr),function(item,index){return _c('td',[_c('div',[_vm._v(_vm._s(item.starName))])])})],2)])])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cdeW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cghz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAADdElEQVRYR+2WT4gURxTGv9e9wyJoYMOuM13Vs7JZvSj4Bw+rHmQjJsomCjkYFEXwIHgTQT14US96UDGXoHgwgaAHBRUSAlFC9paALMiGESUGZIeqnpkF8SIuuz31pKQnNMN0984fg4ftY3fVe7/6vvdeNeEjeugjYsESTJIbS8r8b8oopb4gonUANkdJp5i5JKV8lNUsPbOpUqmMGWOOAzjQKikR/ex53t40oJ7ABEGwj5nvxBLdJaLJer2+zHGcnQB222/M/EJKueaD2dQEcg/ABSHEVDxhpVL52hjzA4BBACeEEN+1VC/Lx7TvTSBWiYlisfi21R6t9VEAN+w313UL+Xy+2ryuK5u01lcBjBORk8vlJgYHB1UavNY6AFBg5l1Syoc9hWlX1SAI/mTmLUR0yvO8yz2DqVar+fn5+ZXFYvHvxUIppf4hotUADgshfuoaRmt9hZl3EtH6KNhLAL87jvOgUCj8kgRWLpfHXdf9I6qZDfl8frpjmCAI1trhlaHCLSHEoYQCtiDjAB4KIXZ13E0WBMAdZraT9TWA88aYXxcWFmr9/f3jzLyRiM5GCc4IIS7Gk2mt7QzaB6Dquu6XrVSx6zO7KQ5CRKV6vX7I9/0nzSdTSp2LgCaZ+WKjW2IgIKJvPc+729HQawYBYIM9VUptAnCEiPYQ0emkBO2ApCpTKpWWDwwM/AZgm1WkAdI4lVLqNhG9v4fsiefm5h6NjIxYCxEVq7XN1kimIo2YiTZpra8BOAbgJRF9ZRVplldrXQMwFHtv7fsEwGfRu1dEdCzNmnjMljAzMzOjfX19L+xCY8wR3/d/TPJZKfW9tQtAsWnNLSK60OoQbdWM1vobAPeYWUkp/cUMtVqttjEMw+3WpTAMp4eHh/9dzL5MZeKdIYT4vN2gna5vaVNDGVsvQoiRtOCzs7MrwjC8aYwJATyTUp7vKUy8ZtJmg9Z6FRHdZOYdAN4YY/b7vp94JWRBJnaTUuoSEZ20AXK5nBgaGrLX/39PuVwecxznOhHZ6asBHPQ8bzIrYdr31AmslJohovddwsxW/ueO44TGmFH7GwDgU2sNER32PO9xNyCpQ68ROAiCv5h5LCHR/TAMT3XSOa3iZd5NdlPUXfbW3hpNVPuT9FRKea5bNTJbu5cJ2om1KGXaCdjN2iWYtu6mbqTuZu871qhkM1q2GmcAAAAASUVORK5CYII="

/***/ }),

/***/ "cjyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerConfig_vue__ = __webpack_require__("OgOb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b457d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerConfig_vue__ = __webpack_require__("LNs8");
function injectStyle (ssrContext) {
  __webpack_require__("wkxw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53b457d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b457d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dWM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddas":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dmCX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUEAYAAADdGcFOAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAppJREFUSMfdVk0vLFEQvdWGEB8TEpuJrzCx8gNsJCzZWojY2AiJpcXgH7CwECRWlpYiESs9OvEXhmQEMcgkDGKImCBdFudV592e7unusXl5tTm5VbeqT1XdW7eV+seFojqwzTbb8bgiRYrGxqAdHgYmEvrufB5oWYoVKz48JIMMMorFsN8zwhGqrWVmZl5eBrFcDtbNTWBbGwicnzsoeqWUUhsb8Lu+RpylJcSNxaouLQK1tgLTaeD9PQLPzAjx0AmKHzMzPz4CLcvpSLQWSsWEWCYDfVdX1Rlr8Ts7EffsDOvj47AJK2mlXrHfE6tM9OkJmEoFOMTj2PjyIi3R7c3NsPf2lqHYQ+7T487Owl4sAhsbfSo3OQl8fnaXHPrpaa4oYg/ep8dtaHC+y8zMU1Nid91iGRemiXHw9eVd77s7YF+fvo6+j4iI6OMDq5MT4OCgD8FEAmNCxoifyK2TM+N3C7+/QeDqStbenauvx3cHBqCdmEAHk8mIcyibBe7uRvPzFyRQKoHQzg60ySQ6eHHhIpjPY6D29JRFYsWKMxnYV1Z0o7wobonF5HLIujLd9XX3PpeDZQG3tpBRXR0y+fwEsfFx2CXTIOnoAF5eBlbSIIOM19cyvVMgm222W1pA5OYGFUul4Li97YwHUqSovd27woXCX5Er7kPctzcZK2j1+3tgzs5byczMDw8g1t0drmLhBXH7+/WnT6ZIoKO8naYJx9NToMfZ/BWxbBa4vw+k8H9Xzs+CzTbbR0fAQgH6uTk5o+EINTXBb35efzEODoJ+FgIZO79FpEjRwgK0i4t/3AlnyjSxzuWwr6YGaxnQQ0PAUgm4ugpcW8PZY66aoDdhuUyjo9COjABl0EtCt7fQp9PQ7+05U+F/kR9MOwjR1K0kLwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wMy0wOVQxMToyMTowOSswODowMBoMdogAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDMtMDlUMTE6MjE6MDkrMDg6MDBrUc40AAAAWnRFWHRzdmc6YmFzZS11cmkAZmlsZTovLy9ob21lL2FkbWluL2ljb24tZm9udC90bXAvaWNvbl82bDY3ZnZrNXY1dGdsZGkvJUU2JTk3JThCJUU4JUJEJUFDMS5zdmdCKPSmAAAAAElFTkSuQmCC"

/***/ }),

/***/ "e8qJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login3.16d5efc.png";

/***/ }),

/***/ "eZ4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__ = __webpack_require__("hhm8");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allCustomers: [], //项目列表数组 用于筛选
      keep: [], //项目列表数组 全部用于还原
      multipleSelection: [], //选中项
      //筛选项参数
      param: {},
      //表单翻页
      formData: {
        total: null
      },
      tableData: [], //表单信息
      listLoading: false,
      item: {},
      visiable: false
    };
  },

  methods: {
    show: function show(item) {
      // console.log(item);
      this.getAllCustomer(item[0]);
      this.param = {};
      this.tableData = [];
      this.formData = {
        total: null
      };
      this.multipleSelection = [];
      this.item = item;
      this.visiable = true;
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },

    //获取项目列表
    getAllCustomer: function getAllCustomer(customerMappingId) {
      var _this2 = this;

      this.$http({
        method: "GET",
        url: "/rest/LongPromotionContractProject/projectDropDownList",
        params: {
          customerMappingId: customerMappingId
        }
      }).then(function (res) {
        _this2.allCustomers = res.data.items;
        _this2.keep = res.data.items;
      }).catch(function (err) {
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      //先判断是否选中了项目
      if (!this.param.prjCode) {
        this.myNotify(this, "warning", "请先选择一个项目");
      } else {
        this.getData();
      }
    },

    //获取数据
    getData: function getData() {
      var _this3 = this;

      this.listLoading = true;
      this.multipleSelection = [];
      var params = {
        prjCode: this.param.prjCode,
        customerMappingId: this.item[0]
      };
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/LongPromotionContractProject/customerPrjList",
        params: params
      }).then(function (res) {
        _this3.tableData = res.data.items;
        _this3.formData.total = res.data.totalItemsCount;
        _this3.listLoading = false;
      }).catch(function (err) {
        _this3.listLoading = false;
        _this3.myNotify(_this3, "error", err.response, "查询失败，请稍后重试");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkAdd: function checkAdd() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$http({
          method: "POST",
          headers: { "content-type": "application/json" },
          url: "/rest/LongPromotionContractProject/countCusMapIdAndQhrCusName",
          // data: this.multipleSelection.map((el) => el[0]),
          data: [{
            customerMappingId: _this4.item[0],
            projectCode: _this4.param.prjCode
          }]
        }).then(function (res) {
          if (res.data.status && res.data.status != 200) {
            _this4.myNotify(_this4, "error", res.data.message);
            return;
          }
          if (res.data.items.length != 0) {
            // 此处需要遍历
            var textList = res.data.items.map(function (el, index) {
              return "<div>" + (index + 1) + "\u3001\u9879\u76EE<span style=\"color:#ff4d4f\"> " + el[1] + " </span>\u4E0E\u5408\u540C\u5BA2\u6237<span style=\"color:#ff4d4f\"> " + el[0] + " </span>\u5DF2\u5173\u8054</div>";
            });
            var text = textList.join("");
            _this4.$confirm("\n        <div style=\"max-height:300px;overflow:auto\">" + text + "\n        \u662F\u5426\u7EE7\u7EED\u5C06\u9009\u4E2D\u7684\u9879\u76EE\u5173\u8054\u5230<span style=\"color:#ff4d4f\"> " + _this4.item[1] + " </span>\uFF1F</div>", "提示", {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
              appendToBody: true,
              confirmButtonText: "确认",
              cancelButtonText: "取消"
            }).then(function () {
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });
      });
    },

    //确认添加
    subAdd: function subAdd() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.checkAdd(_this5.multipleSelection);

              case 2:
                res = _context.sent;

                if (res) {
                  _this5.tosubAdd();
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    tosubAdd: function tosubAdd() {
      var _this6 = this;

      this.$http({
        method: "POST",
        url: "/rest/LongPromotionContractProject/insertCRMConPrj",
        headers: { "content-type": "application/json" },
        data: this.multipleSelection.map(function (el) {
          return {
            customerMappingId: _this6.item[0],
            projectCode: el[0]
          };
        }),
        params: {
          operatorId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        if (res.data.status && res.data.status != 200) {
          _this6.myNotify(_this6, "error", res.data.message);
          return;
        }
        _this6.$emit("done");
        // this.visiable = false;
        _this6.tableData = [];
        _this6.param = {};
        _this6.myNotify(_this6, "success", "添加成功");
      }).catch(function () {
        _this6.myNotify(_this6, "error", "请求失败，请稍后重试");
      });
    }
  }
});

/***/ }),

/***/ "f6oV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fC+k":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkY3QUJFOTlDMEFFQTExRThBMTExQTdCRUM3OUMwNDJCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkY3QUJFOTlEMEFFQTExRThBMTExQTdCRUM3OUMwNDJCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjdBQkU5OUEwQUVBMTFFOEExMTFBN0JFQzc5QzA0MkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjdBQkU5OUIwQUVBMTFFOEExMTFBN0JFQzc5QzA0MkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Ar5U2AAABlElEQVR42pSTzytEURTH542HJo0ZkcROZIqFSVkQZWthw8rGQkqkrCyInSLbsVJmyUYWYiV/AZM0svBjh2iykcY08XzOuFO317w77936dG/nnvO95957TjjkGo7jJOEMbiADV7AIVijIIGBMBfdrtkZIwX4QoVq4hQ6P/UMY9ys2AnuG/QERNGmEtXUC7gy+Wej0K9YAv16OlmUVmOpMYhap1zDPwwxE4NHgPwpp2EX8yb1pQwp+YAE+oWAQi0MPnMobI5hzP+x90BrCfxVmK73ZFyc4FQLikPDQe4Go6QPc41x+F8FB1yExdV2WTht0+xF7lqzhQxOSTJdVZhI7AUPYp8sf4DWOIcYTPGg2efwjbFlXthvVxIp63RHQp0rjhPWSVsAr8IZtUpyuPX4sAl366RCGKGwq2zBMlffl3vUeFZ93XVE6RLLLQyvB0g1JeGXdXMqUhaQ9B3aV2rJhR2XWC1ulq/3vib3FVm20LR3go3gv5BPI+BLfdeaiskut5oJWfhPTGkg/v0M7fMMBYpk/AQYAwScI41FzWnQAAAAASUVORK5CYII="

/***/ }),

/***/ "fEaS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftBar_vue__ = __webpack_require__("FRJE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7055aa35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftBar_vue__ = __webpack_require__("hkdJ");
function injectStyle (ssrContext) {
  __webpack_require__("GQFJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7055aa35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7055aa35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fLMO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰 180713 整理逻辑



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    jobInformation: { type: Object },
    proDuringTime: { type: Object }
  },
  data: function data() {
    var _this = this;
    //number都能写错。。
    // 判读是否是数字的工具函数
    var validateNmuber = function validateNmuber(rule, value, callback) {
      if (isNaN(value)) {
        callback(new Error('请输入数字'));
      } else if (value < 0) {
        callback(new Error('输入值>0'));
      } else {
        callback();
      }
    };
    //判断年龄上限是否填写正确，在选择促销员弹框中
    var ageRange1 = function ageRange1(rule, value, callback) {
      if (isNaN(value)) {
        callback(new Error('请输入数字'));
      } else if (value < _this.paramForm.ageMin) {
        callback(new Error('范围错误'));
      } else if (value > 70) {
        callback(new Error('年龄不正确'));
      } else {
        callback();
      }
    };
    //判断身高上限是否填写正确，在选择促销员弹框中
    var heightRange1 = function heightRange1(rule, value, callback) {
      if (isNaN(value)) {
        callback(new Error('请输入数字'));
      } else if (value < _this.paramForm.heightMin) {
        callback(new Error('范围错误'));
      } else if (value > 250) {
        callback(new Error("身高不正确"));
      } else {
        callback();
      }
    };
    return {
      //dataintype有个问题，当点搜索仅搜到一个卖进表的数据，发布后正常会去门店表再搜索，
      //但目前是用数据类型区分而不是以操作方式区分，所以发布光之后不会再去门店表搜索而继续在卖进表里搜索，得到空集
      //用户未必不能接受，提的时候再说，就把dataintype以操作方式区分，再根据返回的editflg区分是门店表还是卖进表的数据
      dataInType: '', //如果是一键导入则是menDianBiao，手动是byHand，搜索可能同一键，也能能是menDianBiao
      readOnly: false, //卖进表导入后，如果招聘设置里有数据，则不允许编辑
      notOneKeyInData: [], //普通导入时，返回的全部数据

      //表单内除了详细信息以外的信息
      formData: {
        storeCode: null, //搜索用
        storeName: null, //搜索用
        code: null, //
        pageNo: 1, //当前页数
        pageSize: 10 // 每页条数
      },
      total: null, //总条目
      tableData: [], //表单的详细信息
      selTableData: [], //记录选中的门店记录信息
      listLoading: false, //loading动画
      dialogTitle: null, //弹框标题（取消添加门店以后，没啥用了）


      // 任务编辑
      jobEdit: false, //整个弹框是否显示
      //单独任务编辑的数据先存在这里，确定后覆盖前页传来的数据，然后发布
      jobEditObj: {
        storeCode: null, //门店编码
        requirementsStart: null, //开始时间
        requirementsEnd: null, //结束时间
        recruitsNumber: null, //招聘人数
        // remark: null,
        //发布时间
        publishTime: new Date().getFullYear() + "-" + (new Date().getMonth() + 1 > 9 ? new Date().getMonth() + 1 : '0' + (new Date().getMonth() + 1)) + "-" + (new Date().getDate() > 9 ? new Date().getDate() : '0' + new Date().getDate()),
        planNumber: null, //计划人数
        postType: null, //推送设定
        moName: null, // 联系人姓名
        moTel: null // 联系人电话
      },
      salarySettlementOptions: [],
      starRatingOptions: [],
      labelPush: false, //标签推送么
      designatedPromoters: false, //指定促销员推送么
      isckeckPromoters: false, //没见有用到
      isckeckPromotersList: [], // 已选促销员
      checkingPromotersList: [], // 已选促销员，但还没点确定，点确定则覆盖ischeckpromoterslist
      // 促销员IDS（用于发布）
      salesmanIdList: [],
      // 发布成功后删除对应的表格中的数据的标志位
      tableIndex: null,
      // 促销员来源标志位
      salesFlag: null,
      // 保存选择的促销员，是不实时响应的id数据，isckeckPromotersList是实时响应的已确认数据，checkingPromotersList是实施相应的未确定的数据
      salesManIds: [],

      storeInformation: {
        crmDiv: {
          provinceAdName: null,
          cityAdName: null
        },
        channel: null,
        system: null,
        storeName: '',
        address: null,
        storeCode: ''
      },

      // 添加促销员
      addPromoterDialog: false,
      paramForm: {
        name: null,
        idcard: null,
        heightMin: null,
        heightMax: null,
        ageMin: null,
        ageMax: null,
        empCode: null,
        pageNo: 1,
        pageSize: 10
      },
      promotersTotal: null,
      promotersListLoading: false,
      promotersTableData: [],
      rules: {
        name: [{ max: 10, message: '不得超过6个字符', trigger: 'blur' }],
        idcard: [{
          pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
          message: '请输入15位或18位身份证号',
          trigger: 'blur'
        }],
        ageMin: [{ validator: validateNmuber, trigger: 'blur' }],
        heightMin: [{ validator: validateNmuber, trigger: 'blur' }],
        ageMax: [{ validator: ageRange1, trigger: 'blur' }],
        heightMax: [{ validator: heightRange1, trigger: 'blur' }]
      },
      selects: [],

      // 发布岗位需要的默认参数，是从发布岗位传过来的数据（的id转换版），在本页内应确保只读，严禁修改
      publicStore: {
        workCode: null, //岗位信息唯一标识
        projectId: null,
        posName: null,
        signId: null,
        customer: null,
        scheduleType: null,
        posDetail: null,
        salaryDetail: null,
        welfareDetail: null,
        requirements: null,
        salaryCycle: null,
        salary: null,
        salaryType: null,
        sex: null,
        moName: null,
        moTel: null,
        requirementsTel: null,
        searchType: null,
        crescoreMax: null,
        crescoreMin: null,
        signIdList: [],
        rankRuleId: null,
        publishUserId: sessionStorage.getItem('sysUserId')
      },
      //在选择门店任务编辑里的岗位信息，发布时获取此信息
      //publicStore2与jobeditobj都是要发的数据，分开是因为后台传参要求
      publicStore2: {
        salaryType: null,
        daySalary: null,
        daySalaryStatus: true,
        monthSalary: null,
        monthSalaryStatus: true,
        salarySettlement: null,
        starRating: null,
        crescoreMax: null,
        crescoreMin: null,
        searchType: null
      },
      // 添加门店loading
      listLoadingBtn: false,

      // 导入门店dialog标志位
      uploadDialog: false,
      uploadLoading: false, //上传控件loading


      // 使用门店名称或门店编码搜索时，对应的列会标红
      storeCodeColor: false,
      storeNameColor: false,
      empId: '',
      selStoreCnt: '0', //门店被选择数目,最大1000家
      selStoreAll: 'false', //门店被全选状态，处理分页表现
      scheduleNum: null
    };
  },

  computed: {
    //工具类，纯转换
    searchType_trans: function searchType_trans() {
      if (this.jobInformation.searchType.length == 2) {
        return 0;
      } else if (this.jobInformation.searchType.length == 0) {
        return '';
      }
      if (this.jobInformation.searchType[0] == "粉丝" && length == 1) {
        return 1;
      }
      if (this.jobInformation.searchType[0] == "会员" && length == 1) {
        return 2;
      }
    },
    searchType2_trans: function searchType2_trans() {
      var arr = this.publicStore2.searchType;
      var length = arr.length;
      if (length == 2) {
        return 0;
      } else if (length == 0) {
        return '';
      } else if (length == 1) {
        if (arr[0] == "粉丝") {
          return 1;
        } else {
          // =='会员'
          return 2;
        }
      }
    },
    postType_trans: function postType_trans() {
      if (this.labelPush && this.designatedPromoters) {
        return 0;
      } else if (this.labelPush) {
        return 2;
      } else if (this.designatedPromoters) {
        return 3;
      } else if (!this.labelPush && !this.designatedPromoters) {
        return 1;
      }
    }
  },
  watch: {
    // 任务编辑-岗位薪水disabled
    'publicStore2.salaryType': function publicStore2SalaryType(newVal) {
      var pStore2 = this.publicStore2;
      if (newVal == 1) {
        pStore2.daySalaryStatus = false;
        pStore2.monthSalaryStatus = true;
      } else if (newVal == 2) {
        pStore2.daySalaryStatus = true;
        pStore2.monthSalaryStatus = false;
      } else {
        pStore2.daySalaryStatus = true;
        pStore2.monthSalaryStatus = true;
      }
    }
  },
  mounted: function mounted() {
    //获取当前的用户id信息
    var jobInfo = this.jobInformation;
    var pStore = this.publicStore;
    this.empId = sessionStorage.getItem('empPk');
    jobInfo.navState = 2;
    // console.log('传入第二页的jobInformation', jobInfo)
    // console.log('传入第二页的proDuringTime', this.proDuringTime)
    //结算方式的下拉列表
    this.salarySettlementOptions = jobInfo.salarySettlementOptions;
    //星级下拉列表
    this.starRatingOptions = jobInfo.starRatingOptions;

    // 接下来从jobinfo里面读数据配置给publishStore
    //选择的标签checkboxids就是signidlist,前面页不知咋传的，每次更新是否勾选标签推送
    pStore.signIdList = jobInfo.checkboxIds.slice(0);
    // 岗位类型转成id（长短促等）
    jobInfo.jobTypeOptions.map(function (item) {
      if (item.signName == jobInfo.jobType) {
        pStore.signId = item.id;
      }
    });
    //性别转换成id
    jobInfo.sexOptions.map(function (item) {
      if (item.sexName == jobInfo.sexName) {
        pStore.sex = item.id;
      }
    });
    //档期类型转换成id（长期-做五休二等）
    jobInfo.dateTypeOptions.map(function (item) {
      if (item.masterName == jobInfo.dateType) {
        pStore.scheduleType = item.id;
      }
    });
    //结算方式转换成id（日结周结月结等），publish2需要每次从publish更新
    jobInfo.salarySettlementOptions.map(function (item) {
      if (item.masterName == jobInfo.salarySettlement) {
        pStore.salaryCycle = item.id;
      }
    });
    //星级转换成id（青铜白银），publish2需要每次从publish更新
    jobInfo.starRatingOptions.map(function (item) {
      if (item.rankName == jobInfo.starRating) {
        pStore.rankRuleId = item.id;
      }
    });
    //读取岗位薪水（多少钱），publish2需要每次从publish更新
    if (jobInfo.salaryType == '1') {
      pStore.salary = jobInfo.daySalary;
    } else if (jobInfo.salaryType == '2') {
      pStore.salary = jobInfo.monthSalary;
    } else {
      pStore.salary = null;
    }
    //默认的标签推送是否勾选
    this.labelPush = Boolean(pStore.signIdList.length != 0);

    //把可见范围（会员粉丝）转换成id，publish2使用的不是id形式，所以每次直接从jobinfo获取
    pStore.searchType = this.searchType_trans;

    //以下是不转换直接读取的
    //其中需要publish2需要每次从publish更新的有
    pStore.salaryType = jobInfo.salaryType;
    pStore.crescoreMin = jobInfo.crescoreMin;
    //这些不需要每次更新
    pStore.projectId = jobInfo.projectId;
    pStore.posName = jobInfo.posName;
    pStore.customer = jobInfo.customer;
    pStore.workCode = jobInfo.workCode;
    pStore.salaryDetail = jobInfo.salaryDetail;
    pStore.welfareDetail = jobInfo.welfareDetail;
    pStore.posDetail = jobInfo.posDetail;
    pStore.requirements = jobInfo.requirements;
    pStore.moName = jobInfo.moName;
    pStore.moTel = jobInfo.moTel;
    pStore.requirementsTel = jobInfo.requirementsTel;
    //其他还有月薪日新的金额的 是否可编辑，
    // 其他还有计划人数招聘人数，起止时间，都是从table的row读取的
    // produringTime用于校验岗位时间是否在项目时间之内
    // console.log('proDuringTime', this.proDuringTime)
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(["workSquareIsEditMethods"]), {
    //工具类，提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },

    //工具类-手机号加星，使用外调的utils工具函数
    formatTel: function formatTel(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].plusXing(cellValue, 3, 4);
    },

    //工具类，身份证号加星，使用外调的utils工具函数
    formatIdCard: function formatIdCard(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
    },

    /*
    页面基础功能
    */
    //获取数据，先判断xx，再取消搜索时纵向标红的样式，再清空表单详情，再请求后台查询门店
    //点搜索，改变页码，改变每页条目，可以触发此函数
    getData: function getData(resetPageNo) {
      var _this2 = this;

      if (resetPageNo) this.formData.pageNo = 1;
      this.tableData = [];
      // 查询门店，再判断是否有关键字（有就是搜索），loading加请求数据，获取table详情和总计条目
      this.storeCodeColor = Boolean(this.formData.storeCode);
      this.storeNameColor = Boolean(this.formData.storeName);
      this.listLoading = true;
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchStore",
        params: {
          workCode: this.publicStore.workCode,
          empId: this.empId,
          storeCode: this.formData.storeCode,
          storeName: this.formData.storeName,
          pageSize: this.formData.pageSize,
          pageNo: this.formData.pageNo,
          projectIpgId: this.jobInformation.projectIpgId //（回头再看）
        }
      }).then(function (res) {
        _this2.listLoading = false;
        var data = res.data;
        if (data.list) {
          //这个接口默认在卖进表里搜索，搜不到才进入门店表搜索
          //不是从卖进表导入的则提供默认的计划和招聘人数
          if (data.editFlg) {
            data.list.map(function (item) {
              item.planNumber = 1;
              item.recruitsNumber = 3;
              item.readOnly = false;
            });
            _this2.dataInType = 'menDianBiao';
          } else {
            data.list.map(function (item) {
              //只要有一个是空值，则允许修改
              item.readOnly = Boolean(item.planNumber) && Boolean(item.recruitsNumber) && Boolean(item.requirementsStart) && Boolean(item.requirementsEnd);
            });
            _this2.dataInType = 'maiJinBiao';
          }
          _this2.readOnly = !data.editFlg;
          _this2.tableData = data.list;
          _this2.total = data.countSize;
        }
      }).then(function (res) {
        // 根据门店选择标识，判断当前是权限，还是page选
        if (_this2.selStoreAll == 'true') {
          if (_this2.formData.pageNo * _this2.formData.pageSize <= 1000) {
            var rows = _this2.tableData;
            rows.forEach(function (row) {
              _this2.$refs.selStoreTable.toggleRowSelection(row, true);
            });
          } else if (1000 < _this2.formData.pageNo * _this2.formData.pageSize <= 1000 + _this2.formData.pageSize) {
            var i = _this2.formData.pageSize - (_this2.formData.pageNo * _this2.formData.pageSize - 1000);
            var rows = _this2.tableData;
            rows.forEach(function (row) {
              if (i > 0) {
                _this2.$refs.selStoreTable.toggleRowSelection(row, true);
                i = i - 1;
              }
            });
          }
        } else {
          _this2.selStoreCnt = 0;
          _this2.selTableData = []; //清空选择的数据
        }
      }).catch(function (err) {
        _this2.myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
        _this2.listLoading = false;
      });
      // // 查询门店条数
      // this.$http({
      // 	method:"GET",
      // 	url:"/rest/PublishedWork/countSearchStore",
      // 	params:{
      // 		storeCode:this.formData.storeCode,
      // 		storeName:this.formData.storeName
      // 	}
      // }).then(res=>{
      // 	let data = data
      // 	this.total = data
      // })
    },

    // 取消发布门店，相当于切换到上一页，不清空前一页的数据
    cancelPubStore: function cancelPubStore() {
      this.$emit('ReceiveState', 1);
    },

    // 删除一行数据
    delrow: function delrow(index, rows) {
      var _this3 = this;

      this.$confirm('确认删除吗？', '提示', {}).then(function () {
        if (_this3.dataInType != 'byHand') {
          _this3.$http({
            method: "POST",
            url: "/rest/PublishedWork/deleteProjectStore",
            data: {
              "empId": _this3.empId,
              "workCode": _this3.publicStore.workCode,
              "storeCode": rows[index].storeCode
            }
          }).then(function (res) {
            // console.log(res)
            if (res.data.message == '删除成功') {
              rows.splice(index, 1);
            }
          }).catch(function (err) {
            _this3.myNotify(_this3, 'error', err.response.message, '操作失败，请稍后重试');
          });
        } else {
          rows.splice(index, 1);
          var num = _this3.formData.pageSize * (_this3.formData.pageNo - 1) + index;
          _this3.notOneKeyInData.splice(num, 1);
        }
      }).catch(function () {});
    },

    // 下载模板
    downloadTem: function downloadTem() {
      location.href = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].returnUrlHead('temp/') + 'excel/store_mould.xlsx';
      // 以前是请求的地址，现在直接写死

      // this.listLoading = true
      // this.$http({
      //   method: "POST",
      //   url: "/rest/StoreUpDownload/downloadStore",
      // }).then(res => {
      //   if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
      //     location.href = utils.returnUrlHead() + res.data.message;
      //   }
      //
      //   this.listLoading = false
      // }).catch(err => {
      // this.myNotify(this, 'error', err.response.message, '查询失败，请稍后重试')
      //   this.listLoading = false
      // })
    },

    // 导入门店
    handleSuccess: function handleSuccess(response, file, fileList) {
      var _this4 = this;

      this.uploadLoading = false;
      this.storeCodeColor = false;
      this.storeNameColor = false;
      this.notOneKeyInData = response.lsw;
      this.tableData = [];
      this.formData.pageNo = 1;
      this.formData.pageSize = 10;
      this.tableData = this.notOneKeyInData.slice(0, 10);
      this.total = response.countSize;

      this.dataInType = 'byHand';
      //因为传入之后立即加入到列表，所以新增：如果未成功则把本条删掉
      //现在改为，成功后不保留列表
      fileList.splice(0, 1);
      this.$alert(response.message, '提示', {
        dangerouslyUseHTMLString: true,
        callback: function callback(action) {
          _this4.uploadDialog = false;
        }
      });
    },
    handlePreview: function handlePreview(file) {
      this.uploadLoading = true;
      // return this.$confirm("您确定导入门店吗？", "警告", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消"
      // })
    },
    handleError: function handleError(err, response, fileList) {
      var _this5 = this;

      //因为常见的错误后台都在success中返回错误，所以这个很少用到
      this.uploadLoading = false;
      var msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, '提示', {
        dangerouslyUseHTMLString: true,
        callback: function callback(action) {
          _this5.uploadDialog = false;
        }
      });
    },

    //更新导入门店的table
    refreshDataByHand: function refreshDataByHand(length) {
      var num = this.formData.pageSize * (this.formData.pageNo - 1);
      if (length == 1) {
        //当是单独编辑-发布时
        num = num + this.tableIndex;
      }
      this.notOneKeyInData.splice(num, length);

      //然后重新载入数据
      this.tableData = [];
      this.tableData = this.notOneKeyInData.slice(num, num + this.formData.pageSize);
      //促销员页的重置
      this.paramForm.pageNo = 1;
      this.paramForm.pageSize = 10;
      this.total = this.notOneKeyInData.length;
    },

    // 一键导入
    keyImport: function keyImport(resetPageNo) {
      var _this6 = this;

      if (resetPageNo) this.formData.pageNo = 1;
      var a = this.formData.storeCode;
      var b = this.formData.storeName;
      this.formData.storeCode = null;
      this.formData.storeName = null;
      if ((a == null ? '' : a) != "" || (b == null ? '' : b) != '' && this.formData.pageNo != 1) {
        this.formData.pageNo = 1;
      }

      this.listLoading = true;
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/importStore",
        params: {
          empId: this.empId,
          pageSize: this.formData.pageSize,
          pageNo: this.formData.pageNo,
          projectIpgId: this.jobInformation.projectIpgId,
          workCode: this.publicStore.workCode
        }
      }).then(function (res) {
        var data = res.data;
        if (data.workPosList) {
          data.workPosList.map(function (item) {
            //只要有一个是空值，则允许修改
            item.readOnly = Boolean(item.planNumber) && Boolean(item.recruitsNumber) && Boolean(item.requirementsStart) && Boolean(item.requirementsEnd);
          });
          _this6.storeCodeColor = false;
          _this6.storeNameColor = false;
          _this6.tableData = data.workPosList;
          _this6.total = data.countSize;
          _this6.dataInType = 'maiJinBiao';
        }
        _this6.listLoading = false;
      }).then(function (res) {
        // 根据门店选择标识，判断当前是权限，还是page选
        if (_this6.selStoreAll == 'true') {
          if (_this6.formData.pageNo * _this6.formData.pageSize <= 1000) {
            var rows = _this6.tableData;
            rows.forEach(function (row) {
              _this6.$refs.selStoreTable.toggleRowSelection(row, true);
            });
          } else if (1000 < _this6.formData.pageNo * _this6.formData.pageSize <= 1000 + _this6.formData.pageSize) {
            var i = _this6.formData.pageSize - (_this6.formData.pageNo * _this6.formData.pageSize - 1000);
            var rows = _this6.tableData;
            rows.forEach(function (row) {
              if (i > 0) {
                _this6.$refs.selStoreTable.toggleRowSelection(row, true);
                i = i - 1;
              }
            });
          }
        } else {
          _this6.selStoreCnt = 0;
          _this6.selTableData = []; //清空选择的数据
        }
      }).catch(function (err) {
        _this6.myNotify(_this6, 'error', err.response.message, '查询失败，请稍后重试');
        _this6.listLoading = false;
      });
    },

    /*
    table相关功能
    */
    // 换页或者size切换
    handleSizeChange: function handleSizeChange(val) {
      var _this7 = this;

      this.formData.pageSize = val;
      if (this.dataInType == 'maiJinBiao') {
        this.keyImport(false);
      } else if (this.dataInType == 'menDianBiao') {
        this.getData(false);
      } else {
        //byHand
        this.tableData = this.notOneKeyInData.slice(0, val);
        this.formData.pageNo = 1;

        // 根据门店选择标识，判断当前是权限，还是page选
        if (this.selStoreAll == 'true') {
          if (this.formData.pageNo * this.formData.pageSize <= 1000) {
            var rows = this.tableData;
            rows.forEach(function (row) {
              _this7.$refs.selStoreTable.toggleRowSelection(row, true);
            });
          } else if (1000 < this.formData.pageNo * this.formData.pageSize <= 1000 + this.formData.pageSize) {
            var i = this.formData.pageSize - (this.formData.pageNo * this.formData.pageSize - 1000);
            var rows = this.tableData;
            rows.forEach(function (row) {
              if (i > 0) {
                _this7.$refs.selStoreTable.toggleRowSelection(row, true);
                i = i - 1;
              }
            });
          }
        } else {
          this.selStoreCnt = 0;
          this.selTableData = []; //清空选择的数据
        }
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this8 = this;

      this.formData.pageNo = val;
      if (this.dataInType == 'maiJinBiao') {
        this.keyImport(false);
      } else if (this.dataInType == 'menDianBiao') {
        this.getData(false);
      } else {
        //byHand
        var start = (val - 1) * this.formData.pageSize;
        var end = start + this.formData.pageSize;
        this.tableData = this.notOneKeyInData.slice(start, end);

        // 根据门店选择标识，判断当前是权限，还是page选
        if (this.selStoreAll == 'true') {
          if (this.formData.pageNo * this.formData.pageSize <= 1000) {
            var rows = this.tableData;
            rows.forEach(function (row) {
              _this8.$refs.selStoreTable.toggleRowSelection(row, true);
            });
          } else if (1000 < this.formData.pageNo * this.formData.pageSize <= 1000 + this.formData.pageSize) {
            var i = this.formData.pageSize - (this.formData.pageNo * this.formData.pageSize - 1000);
            var rows = this.tableData;
            rows.forEach(function (row) {
              if (i > 0) {
                _this8.$refs.selStoreTable.toggleRowSelection(row, true);
                i = i - 1;
              }
            });
          }
        } else {
          this.selStoreCnt = 0;
          this.selTableData = []; //清空选择的数据
        }
      }
    },

    /*
    发布相关
    */
    // 发布本页全部10条（或几条根据下面设置）门店，点击选择门店最下面发布按钮时触发
    pubStore: function pubStore() {
      var _this9 = this;

      // console.time("时间测试时间测试");
      // console.log(this.publicStore)
      if (this.selStoreAll == 'false' && this.selTableData.length == 0) {
        this.myNotify(this, 'warning', '请导入门店！');
        return false;
      }
      //内容校验开始
      var time = {
        proStartT: new Date(this.proDuringTime.start).getTime(),
        proEndT: new Date(this.proDuringTime.end).getTime(),
        publishStart: '',
        publishEnd: ''
      };
      var arr = this.selTableData;
      var arrLength = arr.length;
      var hasErr = false;
      var isInt = /^\d+$/; // 非负整数
      var err = '';
      for (var i = 0; i < arrLength; i++) {
        if (!arr[i].planNumber || !isInt.test(arr[i].planNumber)) {
          hasErr = true;
          err = '请输入正确的计划人数';
        } else if (!arr[i].recruitsNumber || !isInt.test(arr[i].recruitsNumber)) {
          hasErr = true;
          err = '请输入正确的招聘人数';
        } else if (Number(arr[i].recruitsNumber) < Number(arr[i].planNumber)) {
          hasErr = true;
          err = '招聘人数不应小于计划人数';
        } else if (arr[i].moName == null || arr[i].moName == '' || arr[i].moName == undefined) {
          hasErr = true;
          err = "请输入联系人姓名";
        } else if (arr[i].moTel == null || arr[i].moTel == '' || arr[i].moTel == undefined) {
          hasErr = true;
          err = "请输入联系人电话！";
        } else if (!/^1[345789]\d{9}$/.test(arr[i].moTel) && !/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/.test(arr[i].moTel)) {
          hasErr = true;
          err = '请输入正确的电话号!';
        } else {
          time.publishStart = new Date(arr[i].requirementsStart).getTime();
          time.publishEnd = new Date(arr[i].requirementsEnd).getTime();
          if (time.publishEnd < time.publishStart) {
            hasErr = true;
            err = '开始时间应小于结束时间';
          } else if (time.publishEnd > time.proEndT) {
            hasErr = true;
            err = '岗位结束时间应在项目时间范围内';
          } else if (time.publishStart < time.proStartT) {
            hasErr = true;
            err = '岗位开始时间应在项目时间范围内';
          }
        }

        if (hasErr) {
          this.myNotify(this, 'warning', '\u672C\u9875\u7B2C' + (i + 1) + '\u6761\u5185\u5BB9\u9519\u8BEF\uFF0C' + err);
          return false;
        }
      }
      //校验结束且通过
      var storeArr = [];
      var date = new Date();
      var sysUserId = sessionStorage.getItem('sysUserId');
      this.selTableData.forEach(function (item, index, arr) {
        var storeObj = {
          storeCode: item.storeCode,
          requirementsStart: item.requirementsStart,
          requirementsEnd: item.requirementsEnd,
          recruitsNumber: item.recruitsNumber,
          planNumber: item.planNumber,
          // remark:item.remark,
          publishTime: __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].dateTrans(date),
          publishUserId: sysUserId,
          postType: _this9.postType_trans,
          moName: item.moName,
          moTel: item.moTel,
          scheduleNum: item.scheduleNum
        };
        storeArr.push(storeObj); //本页面的10或几十条数据
      });
      this.publish(storeArr, 1); //
      // console.timeEnd("时间测试时间测试");//40条数据时，2ms完成以上所有逻辑，挺惊人的
    },

    //发布，任务编辑页发布 和直接发布 触发
    //param接受生效范围及部分配置信息，另一部分在publicStore里，type=1发布本页，=2单独发布 =3什么也不做
    publish: function publish(param, type, index) {
      var _this10 = this;

      // console.log('param', param)
      // console.log('publicStore', this.publicStore)
      //把设置的可见范围 存储为正式...。。。。以前写的，是错的，不应将变化更新到默认设置中，publicStore应杜绝修改
      // this.publicStore.searchType = this.searchType2_trans
      //后台根据workcode查询是否有项目存储过，1无，2有，现在不用这个接口也行，后台返回的（修改了接口）都是未发布过的
      //上面说的仅当一键导入时才正确，所以这接口不能删掉
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchWorkPosByCode",
        params: {
          workCode: this.publicStore.workCode
        }
      }).then(function (res) {
        if (res.data.message == 1) {
          //如果是未存储过的，则提示一下
          _this10.$confirm(' 点击确定该岗位会发布，如需修改请到岗位管理内进行编辑，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this10.realPublish(param, true);
          }).catch(function () {
            //发布本页点取消，不弹出编辑框
            if (type == 2) {
              _this10.jobEdit = true;
            }
          });
        } else {
          _this10.realPublish(param, false);
        }
      });
    },

    //仅为精简代码，publish专用
    realPublish: function realPublish(param, isPublished) {
      var _this11 = this;

      if (isPublished) {
        this.workSquareIsEditMethods(true);
      } //记录下本岗位已经发布过了，不能回到上一页再编辑
      this.listLoading = true;
      var _jobInformation = this.jobInformation,
          otherPosDetail = _jobInformation.otherPosDetail,
          otherRequirements = _jobInformation.otherRequirements;

      this.$http({
        method: "POST",
        url: "/rest/PublishedWork/savePublishedWorks",
        data: {
          posStoreInfoList: param, //决定生效范围，及一些其他信息
          workPosInfo: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.publicStore, {
            otherPosDetail: otherPosDetail,
            otherRequirements: otherRequirements
          }), //决定改成什么
          allPageFlg: this.selStoreAll, //是否是全选
          searchStoreInfo: { //数据筛选的条件
            workCode: this.publicStore.workCode,
            empId: this.empId,
            storeCode: this.formData.storeCode,
            storeName: this.formData.storeName,
            pageSize: this.formData.pageSize,
            pageNo: this.formData.pageNo,
            projectIpgId: this.jobInformation.projectIpgId
          }
        }
      }).then(function (res) {
        //此loading顺序不能变
        _this11.listLoading = false;
        if (!isPublished) {
          _this11.workSquareIsEditMethods(true);
        }

        if (_this11.dataInType == 'maiJinBiao') {
          //当是一键导入的数据，再次一键导入，并返回未导入的数据
          _this11.keyImport(true);
        } else if (_this11.dataInType == 'menDianBiao') {
          //当是搜索的数据，再次搜索，并返回未导入的数据
          _this11.getData(true);
        } else {
          //byHand
          _this11.refreshDataByHand(param.length);
        }
        _this11.selStoreCnt = 0;
        _this11.selTableData = []; //清空选择的数据
        _this11.myNotify(_this11, 'success', res, '操作成功');
      }).catch(function (err) {
        _this11.myNotify(_this11, 'error', err.response, '操作失败，请稍后重试');
        _this11.listLoading = false;
      }); //下面这个catch前面的这一大段，跟下面的几乎一样，唯一区别是workSquareIsEditMethods的位置
    },

    // 任务编辑
    jobEdits: function jobEdits(row, index) {
      this.dialogTitle = "任务编辑";
      this.jobEdit = true;
      // this.jobEditObj.remark = row.remark
      // console.log(row.planNumber)
      //每次都获取默认的岗位薪水类型
      var pStore2 = this.publicStore2;
      var pStore = this.publicStore;
      var jobInfo = this.jobInformation;
      var salaryType = pStore.salaryType;
      // console.log("pStore2:" + JSON.stringify(pStore2));
      // console.log("pStore:" + JSON.stringify(pStore2));
      // console.log("jobInfo:" + JSON.stringify(jobInfo));
      // console.log("salaryType:" + JSON.stringify(salaryType));

      pStore2.salaryType = salaryType;
      pStore2.daySalary = null;
      pStore2.monthSalary = null;
      if (salaryType == '1') {
        pStore2.daySalary = jobInfo.daySalary;
      } else if (salaryType == '2') {
        pStore2.monthSalary = jobInfo.monthSalary;
      }
      //薪水输入框的禁用状态在watch里面
      //每次更新信用分值下限
      pStore2.crescoreMin = pStore.crescoreMin;
      //每次更新可见范围（会员粉丝），这里是从jobinfo获取，因为不要id形式
      pStore2.searchType = jobInfo.searchType;
      //每次更新结算方式
      pStore2.salarySettlement = pStore.salaryCycle;
      //每次更新星级
      pStore2.starRating = pStore.rankRuleId;
      //每次恢复到默认的标签推送是否勾选
      this.labelPush = Boolean(pStore.signIdList.length != 0);

      //接下来从row获取数据
      var jobEdit = this.jobEditObj;
      jobEdit.storeCode = row.storeCode; //岗位编码，仅为了推送
      jobEdit.requirementsStart = row.requirementsStart; //开始时间，展示及提送
      jobEdit.requirementsEnd = row.requirementsEnd; //结束时间，展示及推送
      jobEdit.recruitsNumber = Number(row.recruitsNumber); //招聘人数，展示及推送
      jobEdit.planNumber = row.planNumber; //计划人数，展示及推送
      jobEdit.moName = row.moName; // 联系人姓名
      jobEdit.moTel = row.moTel; // 联系人电话
      jobEdit.scheduleNum = row.scheduleNum; // 卖进序号
      this.tableIndex = index; //第几行，仅为了手动导入时，推送后删除该行

      this.salesmanIdList = []; //促销员id列表，在选择门店-任务编辑-选择促销员里面
      this.isckeckPromotersList = []; //已选择的 促销员id列表，在选择门店-任务编辑-选择促销员里面
      this.designatedPromoters = false; //是否指定促销员推送，在选择门店-任务编辑里面
      this.readOnly = row.readOnly;
    },

    // 任务编辑取消发布
    jobEditCancelPub: function jobEditCancelPub() {
      this.jobEdit = false;
    },

    // 任务编辑确认发布
    jobEditSurePub: function jobEditSurePub() {
      var storeItemEditObj = {
        salaryType: this.publicStore2.salaryType,
        salesmanIdList: this.salesmanIdList,
        searchType: this.searchType2_trans, //可见范围-如果修改了则后台会优先取这个值，发布本页的话
        crescoreMin: this.publicStore2.crescoreMin, //信用分下限
        rankRuleId: this.publicStore2.starRating, //星级
        salaryCycle: this.publicStore2.salarySettlement,
        salary: null,
        postType: this.postType_trans //推送类型

        //把设置的可见范围 存储为正式
        //岗位薪水（类型）
      };if (storeItemEditObj.salaryType == 1) {
        storeItemEditObj.salary = this.publicStore2.daySalary;
      } else if (storeItemEditObj.salaryType == 2) {
        storeItemEditObj.salary = this.publicStore2.monthSalary;
      } else {
        storeItemEditObj.salary = null;
      }

      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.jobEditObj, storeItemEditObj);
      // this.checkvalue(param)
      var paramArr = [];
      paramArr.push(param);

      var errMsg = '';
      var isInt = /^\d+$/; // 非负整数
      // console.log('jobEditObj', this.jobEditObj)
      var time = {
        proStartT: new Date(this.proDuringTime.start).getTime(),
        proEndT: new Date(this.proDuringTime.end).getTime(),
        publishStart: new Date(this.jobEditObj.requirementsStart).getTime(),
        publishEnd: new Date(this.jobEditObj.requirementsEnd).getTime()
      };

      if (!this.jobEditObj.planNumber || !isInt.test(this.jobEditObj.planNumber)) {
        errMsg = '请输入正确的计划人数';
      } else if (!this.jobEditObj.recruitsNumber || !isInt.test(this.jobEditObj.recruitsNumber)) {
        errMsg = '请输入正确的招聘人数';
      } else if (Number(this.jobEditObj.recruitsNumber) < Number(this.jobEditObj.planNumber)) {
        errMsg = '招聘人数不应小于计划人数';
      } else if (storeItemEditObj.salaryType == 1 && (!this.publicStore2.daySalary || !isInt.test(this.publicStore2.daySalary))) {
        errMsg = '请输入正确的岗位薪水';
      } else if (storeItemEditObj.salaryType == 2 && (!this.publicStore2.monthSalary || !isInt.test(this.publicStore2.monthSalary))) {
        errMsg = '请输入正确的岗位薪水';
      } else if ((this.publicStore2.crescoreMin || this.publicStore2.crescoreMin == 0) && !isInt.test(this.publicStore2.crescoreMin)) {
        errMsg = '信用分值填写错误';
      } else if (time.publishEnd < time.publishStart) {
        errMsg = '开始时间应小于结束时间';
      } else if (time.publishEnd > time.proEndT) {
        errMsg = '岗位结束时间应在项目时间范围内';
      } else if (time.publishStart < time.proStartT) {
        errMsg = '岗位开始时间应在项目时间范围内';
      } else if (storeItemEditObj.searchType === '') {
        //他会返回012和''，只有''是无效的
        errMsg = '请选择粉丝可见或者会员可见';
      } else if (this.jobEditObj.moName == null || this.jobEditObj.moName == '' || this.jobEditObj.moName == undefined) {
        errMsg = "请输入联系人姓名";
      } else if (this.jobEditObj.moTel == null || this.jobEditObj.moTel == '' || this.jobEditObj.moTel == undefined) {
        errMsg = "请输入联系人电话！";
      } else if (!/^1[345789]\d{9}$/.test(this.jobEditObj.moTel) && !/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/.test(this.jobEditObj.moTel)) {
        errMsg = '请输入正确的电话号!';
      }

      if (errMsg !== '') {
        this.myNotify(this, 'warning', errMsg);
        return false;
      }

      if (this.dialogTitle == "任务编辑") {
        this.publish(paramArr, 2);
      }
      //发布门店，现在不用了
      // else {
      //   this.publish(paramArr, 3)
      // }
      this.jobEdit = false;
    },

    /*    选择促销员相关逻辑
           核心参数：selects(当前页table中已选择的数据)，
          checkingPromotersList（待确定的所有的已选择的数据），
          salesManIds（checking的id列表）以及列表的选中状态
          点击确定后将checking同步给ischeck
          搞清楚这几个参数再碰这块代码
     */
    // 任务编辑选择促销员
    checkPromoters: function checkPromoters(title) {
      var _this12 = this;

      // 弹出选择促销员dialog
      this.addPromoterDialog = true;
      //现在要求第一次进入的时候，不搜索列表，就不走getDefaultPromotersData了，所以把这段单独拿出来显得代码整洁
      // this.getDefaultPromotersData(title, 'tableOpen')
      //先重置
      this.promotersTotal = null;
      this.promotersTableData = [];
      this.paramForm = {
        name: null,
        idcard: null,
        heightMin: null,
        heightMax: null,
        ageMin: null,
        ageMax: null,
        pageNo: 1,
        pageSize: 10
        //只有选了促销员再次进入选择促销员弹框时，此map才有用,给选择促销员弹窗赋值
      };this.checkingPromotersList = [];
      this.salesManIds = [];
      this.isckeckPromotersList.map(function (item) {
        _this12.salesManIds.push(item.id);
        _this12.checkingPromotersList.push(item);
      });
    },

    // 任务编辑删除已选的促销员
    deleteLabel: function deleteLabel(index, type) {
      var _this13 = this;

      if (type == 'ed') {
        //把自己删掉就行了
        this.isckeckPromotersList.splice(index, 1);
        if (this.isckeckPromotersList.length == 0) {
          this.designatedPromoters = false;
        }
      } else {
        //type =='ing'
        //先把自己删掉
        this.checkingPromotersList.splice(index, 1);
        //再重新写入salesManIds，更新选中状态
        //同时更新selects，不能直接指针复制
        this.salesManIds = [];
        this.selects = [];
        // console.log('this.checkingPromotersList', this.checkingPromotersList)
        this.checkingPromotersList.map(function (item) {
          _this13.salesManIds.push(item.id);
        });
        // console.log(this.selects)
        this.$refs.salesmuli.clearSelection();
        //这个方法不会清空已选，所以先清空再重选
        this.salesmanCheckToTrue(this.promotersTableData, false);
      }
    },

    // 获取默认的促销员
    getDefaultPromotersData: function getDefaultPromotersData(type, from) {
      var _this14 = this;

      //先重置
      this.promotersTotal = null;
      this.promotersTableData = [];

      this.promotersListLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/PublishedWork/searchSalesmans",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.paramForm, {
          projectStartTime: this.jobEditObj.requirementsStart,
          dto: {
            crescoreMin: this.publicStore2.crescoreMin,
            // crescoreMin: null,
            // crescoreMax: this.publicStore2.crescoreMax,
            // crescoreMax: null,
            searchType: this.searchType2_trans,
            // searchType: 0,
            storeCode: type == '任务编辑' ? this.jobEditObj.storeCode : this.storeInformation.storeCode,
            rankRuleId: this.jobInformation.rankRuleId,
            // rankRuleId: null,
            sex: this.publicStore.sex
          }
        })

      }).then(function (res) {
        var data = res.data;
        _this14.promotersTotal = data.countSize;
        _this14.salesFlag = data.flg;
        _this14.promotersListLoading = false;
        _this14.selects = [];
        _this14.promotersTableData = data.salesmanList;
        //=='tableChange'
        _this14.salesmanCheckToTrue(_this14.promotersTableData, true);
      }).catch(function (err) {
        _this14.myNotify(_this14, 'error', err.response.message, '查询失败，请稍后重试');
        _this14.promotersListLoading = false;
      });
    },
    salesmanCheckToTrue: function salesmanCheckToTrue(arr, refresh) {
      var _this15 = this;

      arr.map(function (item) {
        if (_this15.salesManIds.indexOf(item.id) > -1) {
          _this15.selects.push(item);
          if (refresh) {
            // 表格渲染需要时间，这里必须加延迟
            setTimeout(function () {
              _this15.$refs.salesmuli.toggleRowSelection(item, true);
            }, 200);
          } else {
            _this15.$refs.salesmuli.toggleRowSelection(item, true);
          }
        }
      });
    },

    //选择促销员信息变化时触发
    selectChange: function selectChange(selection, row) {
      var _this16 = this;

      //selection是所有选中的行，row是当前行
      // console.log('selection',selection)
      // console.log('row',row)
      // console.log('this.selects',this.selects)
      if (selection.length > this.selects.length) {
        // console.log(124124)
        //如果加了一个
        this.checkingPromotersList.push(row);
        this.salesManIds.push(row.id);
      } else {
        //如果减了一个
        this.checkingPromotersList.map(function (item, index, arr) {
          if (item.id == row.id) {
            arr.splice(index, 1);
            _this16.salesManIds.splice(index, 1);
          }
        });
      }
      //记录当前的选项，不能直接指针赋值
      this.selects = [];
      selection.map(function (item) {
        _this16.selects.push(item);
      });
    },

    //选择全部促销员时触发
    selectAllChange: function selectAllChange(selection) {
      var _this17 = this;

      if (selection.length > 0) {
        //如果是全选
        selection.map(function (item) {
          if (_this17.salesManIds.indexOf(item.id) < 0) {
            _this17.salesManIds.push(item.id);
            _this17.selects.push(item);
            _this17.checkingPromotersList.push(item);
          }
        });
      } else {
        //如果是取消全部选择
        this.selects = [];
        var delArr = [];
        this.promotersTableData.map(function (item) {
          _this17.checkingPromotersList.map(function (item2, index) {
            if (item.id == item2.id) {
              delArr.unshift(index);
            }
          });
        });
        delArr.map(function (item) {
          _this17.checkingPromotersList.splice(item, 1);
        });
        this.salesManIds = [];
        this.checkingPromotersList.map(function (item) {
          _this17.salesManIds.push(item.id);
        });
      }
    },

    //促销员页size变化
    promotersHandleSizeChange: function promotersHandleSizeChange(val) {
      this.paramForm.pageSize = val;
      //这诡异的逻辑，看getPromotersData的注释就知道了
      if (this.salesFlag == 1) {
        //1是默认促销员
        this.getDefaultPromotersData(this.dialogTitle, 'tableChange');
      } else {
        //否则是搜索到的促销员
        this.getDefaultPromotersData(this.dialogTitle, 'tableChange');
      }
    },

    //促销员页pageno变化
    promotersHandleCurrentChange: function promotersHandleCurrentChange(val) {
      this.paramForm.pageNo = val;
      //这诡异的逻辑，看getPromotersData的注释就知道了
      if (this.salesFlag == 1) {
        this.getDefaultPromotersData(this.dialogTitle, 'tableChange');
      } else {
        this.getDefaultPromotersData(this.dialogTitle, 'tableChange');
      }
    },

    //当在推送设定里勾选或取消指定促销员推送时触发
    promotersStatus: function promotersStatus() {
      if (!this.designatedPromoters) {
        //如果现在是不推送给促销员，则清空已选择的促销员及其转换好的idlist
        this.isckeckPromotersList = [];
        this.salesmanIdList = [];
      }
    },

    // 确认添加促销员
    addPromoter: function addPromoter() {
      var _this18 = this;

      this.salesmanIdList = [];
      this.isckeckPromotersList = this.checkingPromotersList;
      this.isckeckPromotersList.forEach(function (item, index, arr) {
        _this18.salesmanIdList.push(item.id);
      });
      this.addPromoterDialog = false;
    },


    // 处理选择，取消选择
    selStore: function selStore(type) {
      var _this19 = this;

      if (type == 'cancel') {
        this.$refs.selStoreTable.clearSelection();
        this.selStoreCnt = 0;
        this.selStoreAll = 'false';
        this.selTableData = []; //清空选择的数据
      } else if (type == 'page') {
        var rows = this.tableData;
        rows.forEach(function (row) {
          _this19.$refs.selStoreTable.toggleRowSelection(row, true);
        });
        this.selStoreCnt = rows.length;
        this.selStoreAll = 'false';
        this.selTableData = this.tableData;
      } else if (type == 'all') {
        var rows = this.tableData;
        rows.forEach(function (row) {
          _this19.$refs.selStoreTable.toggleRowSelection(row, true);
        });
        this.selStoreCnt = this.total ? this.total > 1000 ? 1000 : this.total : 0;
        this.selStoreAll = 'true';
        if (this.dataInType == 'maiJinBiao' || this.dataInType == 'menDianBiao') {
          this.selTableData = []; //清空选择的数据,后台自己查询所需数据
        } else {
          this.selStoreAll = 'false';
          this.selTableData = this.notOneKeyInData; //将导入的数据赋值给选中数据列表
        }
      }
    },

    // 如有点击事件选中门店，则取消数据全选状态，从新计数
    selectStoreChange: function selectStoreChange(selection, row) {
      if (selection.length) {
        this.selStoreCnt = selection.length;
        this.selStoreAll = 'false';
        this.selTableData = selection;
      } else {
        this.selStoreCnt = 0;
        this.selStoreAll = 'false';
        this.selTableData = [];
      }
    },

    // 如有门店全选事件，则认为是本页全选，则取消数据全选状态，从新计数
    selectStoreAllChange: function selectStoreAllChange(selection) {
      if (selection.length > 0) {
        //如果是全选
        this.selStoreCnt = this.tableData.length > 1000 ? 1000 : this.tableData.length;
        this.selStoreAll = 'false';
        this.selTableData = this.tableData;
      } else {
        //如果是取消全部选择
        this.selStoreCnt = 0;
        this.selStoreAll = 'false';
        this.selTableData = [];
      }
    }
  })
});

/***/ }),

/***/ "fqQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chooseStore"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-btn clearfix"},[_c('h2',{staticClass:"floatl"},[_vm._v("选择门店")]),_vm._v(" "),_c('el-button',{staticClass:"storeBtns",attrs:{"type":"primary"},on:{"click":_vm.downloadTem}},[_vm._v("下载模板")]),_vm._v(" "),_c('el-button',{staticClass:"storeBtns",attrs:{"type":"primary"},on:{"click":function($event){_vm.uploadDialog=true;}}},[_vm._v("导入门店")]),_vm._v(" "),_c('el-button',{staticClass:"storeBtns",staticStyle:{"width":"120px","background":"#2d2c7a"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.keyImport(true)}}},[_vm._v("\n          卖进表一键导入\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"common-search",staticStyle:{"padding":"10px 20px 0"}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"70px","size":"mini"}},[_c('el-col',{attrs:{"span":16}},[_c('el-form-item',{attrs:{"label":"门店编码"}},[_c('el-input',{attrs:{"placeholder":"请输入门店编码...","maxlength":30},model:{value:(_vm.formData.storeCode),callback:function ($$v) {_vm.$set(_vm.formData, "storeCode", $$v)},expression:"formData.storeCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店名称"}},[_c('el-input',{attrs:{"placeholder":"请输入门店名称...","maxlength":30},model:{value:(_vm.formData.storeName),callback:function ($$v) {_vm.$set(_vm.formData, "storeName", $$v)},expression:"formData.storeName"}})],1),_vm._v(" "),_c('el-button',{staticClass:"storeBtns",staticStyle:{"width":"60px","background":"#2d2c7a","border-radius":"5px","height":"28px","line-height":"28px","margin-top":"2px"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.getData(true)}}},[_vm._v("搜索\n            ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],ref:"selStoreTable",staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"},on:{"select":_vm.selectStoreChange,"select-all":_vm.selectStoreAllChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"50","align":"center","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"crmDiv.provinceAdName","label":"省","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"市","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.crmDiv.cityAdName || scope.row.crmDiv.adName))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"channel","label":"终端","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"system","label":"系统","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","label":"门店编码","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(_vm.storeCodeColor ? 'color:red' : '')},[_vm._v(_vm._s(scope.row.storeCode))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","label":"门店名称","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(_vm.storeNameColor ? 'color:red' : '')},[_vm._v(_vm._s(scope.row.storeName))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"scheduleNum","label":"卖进序号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"address","label":"门店地址","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"planNumber","label":"计划人数","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"recruitsNumber","label":"招聘人数","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"requirementsStart","label":"开始时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"requirementsEnd","label":"结束时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"160","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.jobEdits(scope.row,scope.$index)}}},[_vm._v("任务编辑\n              ")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.delrow(scope.$index,_vm.tableData)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin":"15px"}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.selStore('page')}}},[_vm._v("选中本页")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.selStore('all')}}},[_vm._v("选中全部")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.selStore('cancel')}}},[_vm._v("取消选中")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","vertical-align":"middle","margin-left":"10px"}},[_vm._v("已选择"+_vm._s(_vm.selStoreCnt)+"家门店")])],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",staticStyle:{"margin-top":"-20px","margin-bottom":"-17px"},attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"btns"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.cancelPubStore}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"sureBtn",attrs:{"type":"primary"},on:{"click":_vm.pubStore}},[_vm._v("发布选中")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":_vm.dialogTitle,"width":"1000px","center":true,"show-close":false,"visible":_vm.jobEdit,"top":"17vh"},on:{"update:visible":function($event){_vm.jobEdit=$event}}},[_c('div',{staticClass:"dialogContent"},[(_vm.dialogTitle == '添加门店')?_c('div',{staticClass:"storeInformation"},[_c('div',{staticClass:"detailInformation"},[_c('div',{staticClass:"areaData"},[_vm._v("\n              "+_vm._s(_vm.storeInformation.crmDiv.provinceAdName)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"blank"}),_vm._v(" "),_c('div',{staticClass:"area"},[_vm._v("\n              省份\n            ")])]),_vm._v(" "),_c('div',{staticClass:"detailInformation"},[_c('div',{staticClass:"areaData"},[_vm._v("\n              "+_vm._s(_vm.storeInformation.crmDiv.cityAdName)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"blank"}),_vm._v(" "),_c('div',{staticClass:"area"},[_vm._v("\n              城市\n            ")])]),_vm._v(" "),_c('div',{staticClass:"detailInformation"},[_c('div',{staticClass:"areaData"},[_vm._v("\n              "+_vm._s(_vm.storeInformation.channel)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"blank"}),_vm._v(" "),_c('div',{staticClass:"area"},[_vm._v("\n              终端\n            ")])]),_vm._v(" "),_c('div',{staticClass:"detailInformation"},[_c('div',{staticClass:"areaData"},[_vm._v("\n              "+_vm._s(_vm.storeInformation.system)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"blank"}),_vm._v(" "),_c('div',{staticClass:"area"},[_vm._v("\n              系统\n            ")])]),_vm._v(" "),_c('div',{staticClass:"detailInformation",staticStyle:{"width":"230px"}},[_c('div',{staticClass:"areaData"},[_vm._v("\n              "+_vm._s(_vm.storeInformation.storeName)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"blank"}),_vm._v(" "),_c('div',{staticClass:"area"},[_vm._v("\n              门店名称\n            ")])]),_vm._v(" "),_c('div',{staticClass:"detailInformation",staticStyle:{"width":"230px","border":"0"}},[_c('div',{staticClass:"areaData"},[_vm._v("\n              "+_vm._s(_vm.storeInformation.address)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"blank"}),_vm._v(" "),_c('div',{staticClass:"area"},[_vm._v("\n              门店地址\n            ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"recruitmentSettings"},[_c('div',{staticClass:"recruitmentSettingsTitle"},[_vm._v("\n            任务设置\n          ")]),_vm._v(" "),_c('div',{staticClass:"recruitmentSettingsDetailed"},[_c('el-form',{attrs:{"label-width":"80px","label-position":"right"}},[_c('el-row',[_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[_c('el-date-picker',{staticStyle:{"width":"150px"},attrs:{"disabled":_vm.readOnly,"type":"date","clearable":true,"value-format":"yyyy-MM-dd","editable":false,"placeholder":"开始时间"},model:{value:(_vm.jobEditObj.requirementsStart),callback:function ($$v) {_vm.$set(_vm.jobEditObj, "requirementsStart", $$v)},expression:"jobEditObj.requirementsStart"}})],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"20px"},attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[_c('el-date-picker',{staticStyle:{"width":"150px"},attrs:{"disabled":_vm.readOnly,"type":"date","clearable":true,"value-format":"yyyy-MM-dd","editable":false,"placeholder":"结束时间"},model:{value:(_vm.jobEditObj.requirementsEnd),callback:function ($$v) {_vm.$set(_vm.jobEditObj, "requirementsEnd", $$v)},expression:"jobEditObj.requirementsEnd"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"recruitmentSettings"},[_c('div',{staticClass:"recruitmentSettingsTitle"},[_vm._v("\n            推送设定\n          ")]),_vm._v(" "),_c('div',{staticClass:"recruitmentSettingsDetailed"},[_c('el-form',{attrs:{"label-width":"80px","label-position":"right"}},[_c('el-row',[_c('div',{staticClass:"checkGround"},[_c('el-checkbox',{model:{value:(_vm.labelPush),callback:function ($$v) {_vm.labelPush=$$v},expression:"labelPush"}},[_vm._v("标签推送")]),_vm._v(" "),_c('el-checkbox',{on:{"change":_vm.promotersStatus},model:{value:(_vm.designatedPromoters),callback:function ($$v) {_vm.designatedPromoters=$$v},expression:"designatedPromoters"}},[_vm._v("\n                    指定促销员推送\n                    "),_c('el-button',{staticClass:"ckeckPromoters",attrs:{"disabled":!_vm.designatedPromoters,"type":"primary","size":"mini"},on:{"click":function($event){return _vm.checkPromoters(_vm.dialogTitle)}}},[_vm._v("选择促销员\n                    ")])],1)],1)]),_vm._v(" "),_c('el-row',[(_vm.isckeckPromotersList&&_vm.isckeckPromotersList.length > 0)?_c('div',{staticClass:"isckeckPromoters"},[_c('div',{staticClass:"isckeckPromotersTitle"},[_vm._v("已选促销员 :")]),_vm._v(" "),_c('div',{staticClass:"isckeckPromotersContent"},[_c('div',{staticClass:"tag-list"},_vm._l((_vm.isckeckPromotersList),function(item,index){return _c('div',{key:item.id,staticClass:"tag-item"},[_vm._v("\n                        "+_vm._s(item.name)+"\n                        "),_c('span',{staticClass:"remove-btn",on:{"click":function($event){return _vm.deleteLabel(index,'ed')}}})])}),0)])]):_vm._e()])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"recruitmentSettings"},[_c('div',{staticClass:"recruitmentSettingsTitle"},[_vm._v("\n            联系人信息\n          ")]),_vm._v(" "),_c('div',{staticClass:"recruitmentSettingsDetailed"},[_c('el-form',{attrs:{"label-width":"100px","label-position":"right"}},[_c('el-row',[_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"label":"联系人姓名"}},[_c('el-input',{staticStyle:{"width":"155px"},attrs:{"placeholder":"请输入联系人姓名..."},model:{value:(_vm.jobEditObj.moName),callback:function ($$v) {_vm.$set(_vm.jobEditObj, "moName", _vm._n($$v))},expression:"jobEditObj.moName"}})],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"50px!important"},attrs:{"span":7}},[_c('el-form-item',{attrs:{"label":"联系人电话"}},[_c('el-input',{staticStyle:{"width":"155px"},attrs:{"placeholder":"请输入联系人电话..."},model:{value:(_vm.jobEditObj.moTel),callback:function ($$v) {_vm.$set(_vm.jobEditObj, "moTel", _vm._n($$v))},expression:"jobEditObj.moTel"}})],1)],1)],1)],1)],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.jobEditCancelPub}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"type":"primary"},on:{"click":_vm.jobEditSurePub}},[_vm._v("发布")])],1)]),_vm._v(" "),(_vm.addPromoterDialog)?_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"添加促销员","visible":true,"width":"1000px","center":true,"show-close":false}},[_c('div',{staticClass:"dialogContent",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"addPromoter"},[_c('div',{staticClass:"addPromoterDetailed"},[_c('el-row',[(_vm.checkingPromotersList&&_vm.checkingPromotersList.length > 0)?_c('div',{staticClass:"isckeckPromoters"},[_c('div',{staticClass:"isckeckPromotersTitle"},[_vm._v("已选促销员 :")]),_vm._v(" "),_c('div',{staticClass:"isckeckPromotersContent"},[_c('div',{staticClass:"tag-list"},_vm._l((_vm.checkingPromotersList),function(item,index){return _c('div',{key:item.id,staticClass:"tag-item"},[_vm._v("\n                      "+_vm._s(item.name)+" "),_c('span',{staticClass:"remove-btn",on:{"click":function($event){return _vm.deleteLabel(index,'ing')}}})])}),0)])]):_vm._e()]),_vm._v(" "),_c('el-row',[_c('el-form',{ref:"paramForm",staticClass:"formInline",attrs:{"model":_vm.paramForm,"inline":true,"label-width":"60px","size":"mini","rules":_vm.rules}},[_c('el-form-item',{staticStyle:{"margin-right":"20px"},attrs:{"label":"姓名","prop":"name"}},[_c('el-input',{staticStyle:{"width":"160px"},attrs:{"placeholder":"请输入...","maxlength":10},model:{value:(_vm.paramForm.name),callback:function ($$v) {_vm.$set(_vm.paramForm, "name", $$v)},expression:"paramForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证","prop":"idcard"}},[_c('el-input',{staticStyle:{"width":"160px"},attrs:{"placeholder":"请输入...","maxlength":18},model:{value:(_vm.paramForm.idcard),callback:function ($$v) {_vm.$set(_vm.paramForm, "idcard", $$v)},expression:"paramForm.idcard"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"年龄"}},[_c('el-form-item',{staticStyle:{"width":"60px","margin":"0","padding":"0"},attrs:{"prop":"ageMin"}},[_c('el-input',{staticClass:"small-input",staticStyle:{"width":"60px"},attrs:{"placeholder":"岁"},model:{value:(_vm.paramForm.ageMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "ageMin", _vm._n($$v))},expression:"paramForm.ageMin"}})],1),_vm._v("\n                  -\n                  "),_c('el-form-item',{attrs:{"prop":"ageMax"}},[_c('el-input',{staticClass:"small-input",staticStyle:{"width":"60px"},attrs:{"placeholder":"岁"},model:{value:(_vm.paramForm.ageMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "ageMax", _vm._n($$v))},expression:"paramForm.ageMax"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-bottom":"0","margin-right":"0"},attrs:{"label":"身高"}},[_c('el-form-item',{staticStyle:{"width":"60px","margin":"0","padding":"0"},attrs:{"prop":"heightMin"}},[_c('el-input',{staticClass:"small-input",staticStyle:{"width":"60px"},attrs:{"placeholder":"CM"},model:{value:(_vm.paramForm.heightMin),callback:function ($$v) {_vm.$set(_vm.paramForm, "heightMin", _vm._n($$v))},expression:"paramForm.heightMin"}})],1),_vm._v("\n                  -\n                  "),_c('el-form-item',{attrs:{"prop":"heightMax"}},[_c('el-input',{staticClass:"small-input",staticStyle:{"width":"60px"},attrs:{"placeholder":"CM"},model:{value:(_vm.paramForm.heightMax),callback:function ($$v) {_vm.$set(_vm.paramForm, "heightMax", _vm._n($$v))},expression:"paramForm.heightMax"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员编号","prop":"empCode"}},[_c('el-input',{staticStyle:{"width":"160px"},attrs:{"placeholder":"请输入...","maxlength":50},model:{value:(_vm.paramForm.empCode),callback:function ($$v) {_vm.$set(_vm.paramForm, "empCode", $$v)},expression:"paramForm.empCode"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"filterPromoters",attrs:{"type":"primary"},on:{"click":function($event){return _vm.getDefaultPromotersData(_vm.dialogTitle,'tableChange')}}},[_vm._v("筛选\n                  ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"tableContent"},[_c('div',{staticClass:"table",staticStyle:{"padding":"10px"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.promotersListLoading),expression:"promotersListLoading"}],ref:"salesmuli",staticStyle:{"width":"100%"},attrs:{"max-height":"350","data":_vm.promotersTableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"},on:{"select":_vm.selectChange,"select-all":_vm.selectAllChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empCode","label":"促销员编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idCard","label":"身份证号","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel","label":"手机号","align":"center","formatter":_vm.formatTel}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"age","label":"年龄（岁）","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"height","label":"身高（CM）","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",staticStyle:{"padding":"15px 0 8px"},attrs:{"current-page":_vm.paramForm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.paramForm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.promotersTotal},on:{"size-change":_vm.promotersHandleSizeChange,"current-change":_vm.promotersHandleCurrentChange}})],1)])])],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.addPromoterDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"type":"primary"},on:{"click":_vm.addPromoter}},[_vm._v("确 定")])],1)]):_vm._e(),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"上传门店数据","visible":_vm.uploadDialog,"width":"500px","center":"","close-on-click-modal":false,"close-on-press-escape":false,"show-close":false},on:{"update:visible":function($event){_vm.uploadDialog=$event}}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.uploadLoading),expression:"uploadLoading"}],staticClass:"dialog-body",attrs:{"fullscreen":"false"}},[_c('el-upload',{attrs:{"action":"/rest/StoreUpDownload/importStore","before-upload":_vm.handlePreview,"on-success":_vm.handleSuccess,"on-error":_vm.handleError}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传excel文件")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small","disabled":_vm.uploadLoading},on:{"click":function($event){_vm.uploadDialog = false}}},[_vm._v("关 闭")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fsa8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "fvXH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fx2k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gF0Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gW+x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "go+I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:({ height: _vm.height })},[_c('div',[_c('div',[_c('div',{staticClass:"title"},[_vm._v("任务说明")]),_vm._v(" "),_c('div',{staticClass:"addBox"},[_c('el-input',{staticClass:"textarea",attrs:{"type":"textarea","rows":5,"maxlength":"20"},model:{value:(_vm.addDescriptionValue),callback:function ($$v) {_vm.addDescriptionValue=$$v},expression:"addDescriptionValue"}}),_vm._v(" "),_c('div',[_c('el-button',{staticClass:"addBtn",attrs:{"type":"primary","size":"small","icon":"el-icon-plus"},on:{"click":function($event){return _vm.addTask(1)}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"content"},_vm._l((_vm.taskDescription),function(item,index){return _c('div',{key:item,class:_vm.activeDescriptionIndex === index ? 'active' : '',on:{"click":function($event){return _vm.changeIndex1(index)}}},[_vm._v("\n            "+_vm._s(item)+"\n          ")])}),0),_vm._v(" "),_c('div',{staticClass:"btnBox"},[_c('el-button',{attrs:{"type":"danger","size":"small","icon":"el-icon-minus"},on:{"click":_vm.del1}}),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small","icon":"el-icon-top","plain":"","disabled":_vm.activeDescriptionIndex == 0},on:{"click":_vm.top1}}),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small","icon":"el-icon-bottom","plain":"","disabled":_vm.activeDescriptionIndex == _vm.taskDescription.length - 1},on:{"click":_vm.bottom1}})],1)])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"title"},[_vm._v("任务要求")]),_vm._v(" "),_c('div',{staticClass:"addBox"},[_c('el-input',{staticClass:"textarea",attrs:{"type":"textarea","rows":5,"maxlength":"20"},model:{value:(_vm.addRequirementValue),callback:function ($$v) {_vm.addRequirementValue=$$v},expression:"addRequirementValue"}}),_vm._v(" "),_c('div',[_c('el-button',{staticClass:"addBtn",attrs:{"type":"primary","size":"small","icon":"el-icon-plus"},on:{"click":function($event){return _vm.addTask(2)}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"content"},_vm._l((_vm.taskRequirements),function(item,index){return _c('div',{key:item,class:_vm.activeRequirementsIndex === index ? 'active' : '',on:{"click":function($event){return _vm.changeIndex2(index)}}},[_vm._v("\n            "+_vm._s(item)+"\n          ")])}),0),_vm._v(" "),_c('div',{staticClass:"btnBox"},[_c('el-button',{attrs:{"type":"danger","size":"small","icon":"el-icon-minus"},on:{"click":_vm.del2}}),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small","icon":"el-icon-top","plain":"","disabled":_vm.activeRequirementsIndex == 0},on:{"click":_vm.top2}}),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small","icon":"el-icon-bottom","plain":"","disabled":_vm.activeRequirementsIndex == _vm.taskRequirements.length - 1},on:{"click":_vm.bottom2}})],1)])])]),_vm._v(" "),_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("提交保存")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateUserPasswoed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var base = '/rest';

// 基本系统功能接口
//登录

// //
// export const masterSearch = params => {
//   return axios.get(`${base}/master/search`, {params: params}).then(res => res.data)
// }
// 登出
var logout = function logout() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/auth/logout');
};
// 修改密码
var updateUserPasswoed = function updateUserPasswoed(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'post', params: params,
    url: base + '/sysUser/updateUserPasswoed'
  });
};

/***/ }),

/***/ "hFV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{ref:"formData",staticClass:"formInline",attrs:{"model":_vm.formData,"inline":true,"label-width":"90px","size":"mini","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":"身份证号","prop":"idCard"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18},model:{value:(_vm.formData.idCard),callback:function ($$v) {_vm.$set(_vm.formData, "idCard", $$v)},expression:"formData.idCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名","prop":"salemansName"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":6},model:{value:(_vm.formData.salemansName),callback:function ($$v) {_vm.$set(_vm.formData, "salemansName", $$v)},expression:"formData.salemansName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID","prop":"empPk"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID...","maxlength":12},model:{value:(_vm.formData.empPk),callback:function ($$v) {_vm.$set(_vm.formData, "empPk", $$v)},expression:"formData.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否QHR人员","label-width":"20","prop":"qhrStatus"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.formData.qhrStatus),callback:function ($$v) {_vm.$set(_vm.formData, "qhrStatus", $$v)},expression:"formData.qhrStatus"}},[_c('el-option',{attrs:{"label":"全部","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"否","value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"是","value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"在职","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职中","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"取消离职","value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职","value":"4"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.getData(1)}}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.exportData}},[_vm._v("导出")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":function($event){_vm.uploadDialogi = true}}},[_vm._v("新增")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",staticStyle:{"margin-left":"20px"},on:{"click":_vm.insertBatchs}},[_vm._v("上传数据")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idCard","label":"身份证","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salemansName","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","label":"促销员ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qhrStatusName","label":"是否是qhr人员","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reason","label":"拉黑原因","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userName","label":"操作用户","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createTime","label":"拉黑时间","align":"center","formatter":_vm.formatDate}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"上传黑名单数据","visible":_vm.uploadDialog,"width":"500px","center":""},on:{"update:visible":function($event){_vm.uploadDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex"}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px","width":"41%"},on:{"click":function($event){return _vm.downloadTmp()}}},[_vm._v("下载模板")]),_vm._v(" "),_c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":_vm.action,"on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"auto-upload":false,"limit":1,"data":{ operatorId: _vm.openid },"on-exceed":_vm.exceed}},[_c('a',{staticStyle:{"color":"blue","font-size":"18px"},attrs:{"slot":"trigger"},on:{"click":function($event){return _vm.$refs.upload.clearFiles()}},slot:"trigger"},[_vm._v("上传附件")])]),_vm._v(" "),(_vm.fileList.length == 0)?_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n            只能上传excel文件\n          ")]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small","type":"success"},on:{"click":_vm.submitUpload}},[_vm._v("确认上传")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"dialog",attrs:{"title":"新增黑名单数据","visible":_vm.uploadDialogi,"width":"600px","center":""},on:{"update:visible":function($event){_vm.uploadDialogi=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticStyle:{"width":"80px"}},[_vm._v("身份证号:")]),_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18},model:{value:(_vm.formData.cardId),callback:function ($$v) {_vm.$set(_vm.formData, "cardId", $$v)},expression:"formData.cardId"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px"}},[_vm._v("姓名:")]),_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":20},model:{value:(_vm.formData.name0),callback:function ($$v) {_vm.$set(_vm.formData, "name0", $$v)},expression:"formData.name0"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"width":"80px"}},[_vm._v("拉黑原因:")]),_c('el-input',{attrs:{"type":"textarea","placeholder":"请输入拉黑原因...","maxlength":200},model:{value:(_vm.formData.reason),callback:function ($$v) {_vm.$set(_vm.formData, "reason", $$v)},expression:"formData.reason"}})],1)]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){return _vm.aaa()}}},[_vm._v("确定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hVYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LookHistory_vue__ = __webpack_require__("6+Wg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_648e006c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LookHistory_vue__ = __webpack_require__("2hsf");
function injectStyle (ssrContext) {
  __webpack_require__("uI/1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-648e006c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LookHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_648e006c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LookHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hbbA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"introduce"},[_vm._v("\n        自定义项目类型\n    ")]),_vm._v(" "),_c('div',{staticClass:"tableContainer"},[_c('el-form',{attrs:{"size":"mini"}},[_c('el-checkbox-group',{model:{value:(_vm.checkedProject),callback:function ($$v) {_vm.checkedProject=$$v},expression:"checkedProject"}},_vm._l((_vm.projects),function(item){return _c('el-checkbox',{key:item,staticStyle:{"display":"block"},attrs:{"label":item,"disabled":_vm.enabled}},[_c('p',{staticStyle:{"padding-top":"10px"}},[_vm._v("\n                    "+_vm._s(item)+"\n                ")])])}),1)],1)],1),_vm._v(" "),_c('el-button',{staticClass:"btn",attrs:{"disabled":_vm.enabled,"type":"primary","plain":""},on:{"click":_vm.save}},[_vm._v("保存")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hhm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//utils意为：工具类
/* harmony default export */ __webpack_exports__["a"] = ({
  //查找DOM的父级元素，好像没被用到
  findParentNode: function findParentNode(node, parent) {
    if (node == parent) {
      return false;
    }
    //这什么循环写法，看不懂，估计用了会爆炸吧
    for (var i = 0, n; n = node.parentNode; i++) {
      if (n == parent) {
        return true;
      }
      if (n == document.documentElement) {
        return false;
      }
    }
  },

  //字符串加星号，前面保留位数，后面保留位数
  plusXing: function plusXing(str, frontLen, endLen) {
    if (str == null) {
      return str;
    } else {
      var len = str.length - frontLen - endLen;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      if (str.length == 2) {
        var a = str[0];
        return a + '*';
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    }
  },

  //自动识别是返回恰当的域名，供下载url拼接
  returnUrlHead: function returnUrlHead(add) {
    var href = window.location.href;
    var yuming = href.split('https://')[1].split('/')[0];
    return add ? 'https://' + yuming + '/' + add : 'https://' + yuming + '/';
  },

  //空值返回true，有值返回false，区别0
  bool: function bool(x) {
    if (!x) {
      if (x === 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  },

  //把date对象转换成2017-02-02
  dateTrans: function dateTrans(date) {
    var str = date.getFullYear() + "-";
    var month = date.getMonth() + 1;
    str += (month > 9 ? month : '0' + month) + "-";
    var day = date.getDate();
    str += day > 9 ? day : '0' + day;
    return str;
  },


  //notify自用，接收res或者err.response或者写死的文字。or可以不传
  //用之前，先看下之前以上3种情况都是怎么写的
  myNotify: function myNotify(_this, type, normal, or) {
    if (!normal) {
      //没有normal不弹窗（忘了写，或者err的数据被拦截住了，目前只有403状态会在main.js里被拦截）
    } else {
      var type2 = void 0;
      switch (type) {
        case 'warning':
          type2 = '提示';
          break;
        case 'success':
          type2 = '成功';
          break;
        case 'error':
          type2 = '错误';
      }
      if (or && normal) {
        if (normal.data && normal.data.message) {
          or = normal.data.message;
        } else if (normal.message) {
          or = normal.message;
        }
      } else {
        or = normal;
      }
      _this.$notify({
        title: type2,
        message: or,
        type: type
      });
    }
  },
  compareDate: function compareDate(date1, date2) {
    date1 = date1.replace(/\-/gi, "/");
    date2 = date2.replace(/\-/gi, "/");
    var time1 = new Date(date1).getTime();
    var time2 = new Date(date2).getTime();
    if (time1 > time2) {
      return false;
    } else if (time1 == time2) {
      return true;
    } else {
      return true;
    }
  },
  currentDate: function currentDate() {
    var nowDate = new Date();
    var year = nowDate.getFullYear();
    var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
    var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
    var dateStr = year + "-" + month + "-" + day;
    return dateStr;
  }
});

/***/ }),

/***/ "hkdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left-container floatl"},[_c('div',{staticClass:"scroll"},[_c('div',{staticClass:"scroll-bar",attrs:{"id":"scrollBar"}}),_vm._v(" "),(_vm.flag)?_c('el-row',{staticClass:"main-nav",attrs:{"id":"scroll"}},[_c('el-menu',{attrs:{"default-active":_vm.$route.path,"id":"nav","unique-opened":"","router":""}},[_vm._l((_vm.$router.options.routes),function(item,index){return (!item.hidden)?[(!item.leaf)?_c('el-submenu',{key:index,staticClass:"submenu",attrs:{"index":index+''}},[_c('template',{slot:"title"},[_c('img',{attrs:{"src":item.icon,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_vm._l((item.children),function(child,i){return (!child.hidden)?_c('el-menu-item',{key:i,staticClass:"submenu-item",attrs:{"index":child.path},nativeOn:{"mousedown":function($event){$event.preventDefault();return _vm.checkFrom(child.path)}}},[_c('i',{class:child.iconCls}),_vm._v(_vm._s(child.name)+"\n            ")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(item.leaf && item.children.length>0)?_c('el-menu-item',{key:index,staticClass:"single-item",attrs:{"index":item.children[0].path}},[(_vm.$route.path != item.children[0].path)?_c('img',{attrs:{"src":item.icon,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.$route.path == item.children[0].path)?_c('img',{attrs:{"src":item.iconActive,"alt":""}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.children[0].name))])]):_vm._e()]:_vm._e()})],2)],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hrN5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contractQys_vue__ = __webpack_require__("b+OC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f4c7d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contractQys_vue__ = __webpack_require__("KhWA");
function injectStyle (ssrContext) {
  __webpack_require__("+Zjf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28f4c7d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contractQys_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f4c7d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contractQys_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hvK8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//180723韩金辰重写
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "zSystem",
  data: function data() {
    return {
      cols: [{ name: '积分', scoreType: 1 }, { name: '星级', scoreType: 2 }, { name: '信用', scoreType: 3 }],
      tableData: [],
      loading: false,
      message: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    //   搜索体系配置页所有信息
    this.$http({
      method: "get",
      url: "/rest/ScoreSystemSettings/searchMastName"
    }).then(function (res) {
      _this.tableData = res.data;
      _this.loading = false;
    }).catch(function () {
      _this.loading = false;
    });
    //上个接口慢，所以用他的then关闭loading
    this.$http({
      method: "get",
      url: '/rest/ScoreSystemSettings/search',
      params: {
        startTime: this.$route.query.sTime
      }
    }).then(function (res) {
      _this.message = res.data;
    });
  }
});

/***/ }),

/***/ "i1bv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpEMDA3QUQ1QkNDRjMxMUU3QjgwN0Y4RjE4QjAxQUZFQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpEMDA3QUQ1Q0NDRjMxMUU3QjgwN0Y4RjE4QjAxQUZFQiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkQwMDdBRDU5Q0NGMzExRTdCODA3RjhGMThCMDFBRkVCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkQwMDdBRDVBQ0NGMzExRTdCODA3RjhGMThCMDFBRkVCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+gXQXFAAAAZVJREFUeNqMleuygjAMhNuiiDLc3v8l9QeiiHD4MhMmFjiaGaC1yXa7SaOfpsltWdd10/y4vu/d+/2W3w6Hgzsej+58PvP4rTgfAwJ0u91cCEGCAWGM3ziO8rAJ36qqVsAfgDPQ9Hg83Ol0+gBasfDePZ9PAYZtWZZ+BQiYOmgQxrqOY1CkQBYIzGzFKfC63+/C7HK5iCPMbGBsbKIb5XnuiEWqBRDNYKZsNWDPAFJAvlmWCYYAgpwkiSxaNnYcgzO3p0Bv/Nu2ncL8kmwq6F4S4jlZtvqiI0cPr9dLdmARkbc02zIYWl8wwArspPRh+Z921oiLDUIhTsSvDFVzjdG4gH7DMKyS8gugzbSeNHBMJnsJ2TPrSyyk0jR1gWJGTM3atwxvrRHHLQMLQI+YVstfykb9IAI75jQKSW9d11y/JTAu6ngTK5E2irlBuOXqgcz1UdCtkohrUE27Eyddta/r9SodBweStde+MI4JM6qkaRr/tcECSPVrX7R6kUTiiqJYmO0CqtHS6HUEa9LsX0AMpPYnwAA1eEwueKo9mAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "iFcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_layout_leftBar_vue__ = __webpack_require__("fEaS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//180711韩金辰 整理




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    var _this = this;

    //不能为空，提交后台校验后，再次出发此处
    var validateOldPass = function validateOldPass(rule, value, callback) {
      if (value === '' || value === null) {
        return callback(new Error('旧密码不能为空'));
      } else if (_this.oldPassErr) {
        return callback(new Error('旧密码输入错误'));
      } else {
        callback();
      }
    };
    //不能为空，和‘再次输入’进行对照
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (_this.ruleForm2.rNewPassword !== '') {
          _this.$refs.ruleForm2.validateField('rNewPassword');
        }
        callback();
      }
    };
    //不能为空，和‘新密码’进行对照
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== _this.ruleForm2.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      // tabs: [],//不知道是啥，180811仍然稳定就删掉
      quitDialog: false, //退出弹窗
      changePassWordDialog: false, //修改密码弹窗
      oldPassErr: false, //校验旧密码错误时修改
      ruleForm2: {
        oldPassword: '',
        newPassword: '',
        rNewPassword: ''
      },
      rules2: {
        newPassword: [{ validator: validatePass, trigger: 'blur' }],
        rNewPassword: [{ validator: validatePass2, trigger: 'blur' }],
        oldPassword: [{ validator: validateOldPass, trigger: 'blur' }]
      },
      nickname: '安琪儿',
      userIsPG: false,
      userIsPLUS: true
    };
  },

  watch: {
    changePassWordDialog: function changePassWordDialog(newVal, oldVal) {
      if (!newVal) {
        this.$refs.ruleForm2.resetFields();
      }
    }
  },
  computed: {
    loginTimeOut: function loginTimeOut() {
      return this.$store.state.loginTimeOut;
    },
    dialogShow: function dialogShow() {
      //如果允许直接修改dialogShow来关闭弹窗，则必须添加set方法
      return this.loginTimeOut || this.quitDialog;
    },

    //是否使用了自己的筛选组件，看html部分的注释
    usingMyFilter: function usingMyFilter() {
      var arr = ['/salespersonLibrary', '/baseCenter'];
      return arr.indexOf(this.$route.path) > -1;
    },

    //是否使用了自己的导航栏，html部分注释不准确
    isLevelTwo: function isLevelTwo() {
      var arr = ['/salespersonDetail', '/SystemConfig', '/LookHistoryTwo'];
      return arr.indexOf(this.$route.path) == -1;
    }
  },
  components: {
    "left-bar": __WEBPACK_IMPORTED_MODULE_1_views_layout_leftBar_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.userIsPG = Boolean(sessionStorage.getItem('usersPG'));
    this.userIsPLUS = Boolean(!this.userIsPG);

    this.nickname = sessionStorage.getItem('nickname');
    //不知道是啥，180811仍然稳定就删掉
    // if (this.tabs.length === 0 && this.$route.path !== '/') {
    //   this.tabs.push({
    //     label: this.$route.name,
    //     path: this.$route.path
    //   })
    // }
    //刷新可能会丢失title，重新赋值
    if (this.userIsPG) {
      document.title = '宝洁CRM';
    } else if (this.userIsPLUS) {
      document.title = '普乐师CRM';
    }
  },

  methods: {
    notQuite: function notQuite() {
      this.quitDialog = false;
      if (this.$store.state.loginTimeOut) {
        //如果此时是超时状态，则取消超时状态
        this.$store.commit('changeLoginTimeOutTo', false);
      }
    },
    quite: function quite() {
      var _this2 = this;

      //退出登录
      this.$confirm('确认退出吗?', '提示', {}).then(function () {
        _this2.quitDialog = false;
        if (_this2.$store.state.loginTimeOut) {
          //如果此时是超时状态，则取消超时状态
          _this2.$store.commit('changeLoginTimeOutTo', false);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__api_index__["a" /* logout */])().then(function (res) {
          //console.log(res.data);
          //现在在main.js里面清除session和Storage，只要是登录页，就清空
          //注销后，重置routes配置
          var routes = _this2.$router.options.routes;
          routes.map(function (item) {
            if (item.name != "登陆") {
              item.hidden = false;
            }
            item.children.map(function (item2) {
              var name = item2.name;
              //二级页面的hidden永远为true
              if (name != "促销员详情" && name != "配置历史查询" && name != "配置历史查询2" && name != "登陆") {
                item2.hidden = false;
              }
            });
          });
          //其实res.data.code == 0，才是真的注销成功，这里不让用户知道太多，就提示注销成功
          __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this2, 'success', '注销成功');
          sessionStorage.clear();
          //从哪登陆的就回哪去
          if (_this2.userIsPG) {
            _this2.$router.push('/loginPG');
          } else if (_this2.userIsPLUS) {
            _this2.$router.push('/login');
          }
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this2, 'warning', err.response, '注销失败');
        });
      }).catch(function () {});
    },
    changePwd: function changePwd() {
      var _this3 = this;

      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          Object(__WEBPACK_IMPORTED_MODULE_0__api_index__["b" /* updateUserPasswoed */])({
            oldPassword: _this3.ruleForm2.oldPassword,
            newPassword: _this3.ruleForm2.newPassword,
            rNewPassword: _this3.ruleForm2.rNewPassword
          }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this3, 'success', res, '密码更新成功');
            _this3.changePassWordDialog = false;
          }).catch(function (err) {
            if (err.response.data.message == '旧密码错误，请重新输入') {
              _this3.oldPassErr = true;
              _this3.$refs.ruleForm2.validateField('oldPassword');
              setTimeout(function () {
                _this3.oldPassErr = false;
              }, 100);
            } else {
              __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this3, 'error', err.response, '密码更新失败');
            }
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "iIyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_filterTab__ = __webpack_require__("4AQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_images_avatar_default_png__ = __webpack_require__("qvSl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_images_avatar_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_images_avatar_default_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilterTab: __WEBPACK_IMPORTED_MODULE_1_components_filterTab__["a" /* default */]
  },
  data: function data() {
    return {
      total: null,
      formData: {
        name: null,
        idcard: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        sex: null,
        educationId: null,
        status: null,
        starLevelId: null,
        agreement: null,
        channel: null,
        ageMin: null,
        ageMax: null,
        heightMin: null,
        heightMax: null,
        creditScoreMin: null,
        creditScoreMax: null,
        projectNumMin: null,
        projectNumMax: null,
        workMonthMin: null,
        workMonthMax: null,
        frequencyNumMin: null,
        frequencyNumMax: null,
        projectPriceMin: null,
        projectPriceMax: null,
        postId: 0,
        pageNo: 1,
        pageSize: 48,
        orderBy: null,
        orderByAd: null
      },
      dataList: null,
      asc1: true,
      asc2: false,
      asc3: false,
      asc4: false,
      listLoading: false,
      usersName: '',

      avatarDefault: __WEBPACK_IMPORTED_MODULE_2_common_images_avatar_default_png___default.a,

      // 页面内权限
      auths: [],
      innerVisible: false,
      list: {
        projectName: null,
        projectNum: null,
        startTime: null,
        endTime: null
      },
      checked: false,
      projectTableData: null,
      projectPageNo: null,
      projectPageSize: null,
      projectTotal: null,
      uploadDialog: false,
      obj: null,
      load: null,
      modelUrl: null,
      exportUrl: null,
      userIsPLUS: true, //是否是PLUS账号
      isAdmin: false, //是否是admin或者tinashi
      userIsPG: '' //是否是PG账号，这里直接存了PG账户名
    };
  },
  mounted: function mounted() {
    var PlusAccount = sessionStorage.getItem('user');
    this.userIsPLUS = Boolean(PlusAccount);
    this.isAdmin = Boolean(PlusAccount && (PlusAccount == 'admin1' || PlusAccount == 'tinashi'));
    this.userIsPG = sessionStorage.getItem('usersPG');
    this.getData();
    if (this.userIsPLUS) {
      this.getAuth();
    }
  },

  methods: {
    returnName: function returnName(name) {
      return this.isAdmin ? name : __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(name, 1, 1);
    },
    downloadModel: function downloadModel() {
      location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead('temp/') + 'excel/baojie_mould.xlsx';
    },
    requireList: function requireList() {
      this.uploadDialog = true;
      this.time = new Date().getTime();
      this.obj = { name: this.time + 'baojie_mould.xlsx' };
    },
    exportList: function exportList() {
      var _this = this;

      this.$http({
        method: "POST",
        url: "/rest/upDownload/download"
      }).then(function (res) {
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, 'error', err.response, '下载失败，请稍后重试');
      });
    },
    handlePreview: function handlePreview(file) {
      this.load = true;
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      // console.log('上传成功后返回的数据res', response)
      // console.log(2, file)
      // console.log(3, fileList)
      // console.log(this.obj)
      if (response.message == "操作成功") {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, 'success', '操作成功');
        this.uploadDialog = false;
        this.load = false;
        // this.$http({
        //   method: "POST",
        //   url: "/rest/upDownload/download",
        // }).then(res => {
        //   this.exportUrl = utils.returnUrlHead + res.data.message
        // })

        //成功后再走此接口，后台才开始真的存储
        this.$http({
          method: "GET",
          url: "/rest/BaojieDownload/savePGCR"
        }).then(function (res) {
          console.log('文件上传成功');
        });
        this.getData();
      } else if (response.message.search('不在促销员库') != -1 || response.message.search('没有获取到信息') != -1 || response.message.search('失败') != -1) {
        this.$alert(response.message, '提示', {
          confirmButtonText: '确定'
        });
        this.uploadDialog = false;
        this.load = false;
      } else {
        this.load = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, 'warning', response, '操作异常');
      }
    },
    handleError: function handleError(err, file, fileList) {
      this.load = false;
    },
    exportData: function exportData() {
      this.innerVisible = true;
    },
    avatarImg: function avatarImg(img) {
      if (img != null) {
        return {
          'background-image': 'url(' + img + ')',
          'background-size': 'cover',
          width: '80px',
          height: '80px'
        };
      } else {
        return {
          'background-image': 'url(' + this.avatarDefault + ')',
          'background-size': 'cover',
          width: '80px',
          height: '80px'
        };
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    getParam: function getParam(data) {
      // let pageSize = this.formData.pageSize;
      // let pageNo = this.formData.pageNo
      this.formData = data;
      // this.formData.pageSize = pageSize
      // this.formData.pageNo = pageNo
      this.getData();
    },
    getAuth: function getAuth() {
      var _this2 = this;

      this.auths = [];
      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 1,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          _this2.auths.push(item.auth);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    getData: function getData() {
      var _this3 = this;

      this.listLoading = true;
      var searchURL = '/rest/salesman/search';
      // let countURL = '/rest/salesman/searchCount'
      if (this.userIsPG) {
        searchURL += 'SalesmanPG';
        // countURL += 'PG'
      }
      this.$http({
        method: "POST",
        url: searchURL,
        data: this.formData
      }).then(function (res) {
        _this3.listLoading = false;
        _this3.dataList = res.data.items;
        _this3.total = Number(res.data.totalItemsCount);
        _this3.dataList.map(function (item) {
          var n = [];
          var m = [];
          //由于传过来的数据可能有重复，而且有各种标签，在此进行过滤
          item.crmSignLst.map(function (item1) {
            if (item1.id == 0 || item1.id == 1 || item1.id == 2) {
              if (m.indexOf(item1.id) == -1) {
                n.push(item1);
                m.push(item1.id);
              }
            }
          });
          n.map(function (item1) {
            if (item1.id == 0) {
              item.isLongSign = true;
              item.isShortSign = true;
            } else if (item1.id == 1) {
              item.isLongSign = true;
            } else {
              item.isShortSign = true;
            }
          });
          item.crmSignLst = n;
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
        _this3.listLoading = false;
      });
    },
    sortByAge: function sortByAge(event) {
      this.formData.orderBy = 1;
      this.formData.orderByAd = this.asc1 ? 1 : 2;
      this.asc1 = !this.asc1;
      this.getData();
    },

    //根据其他规则排序
    // sortByCredit() {
    //   this.formData.orderBy = 2
    //   this.formData.orderByAd = this.asc2 ? 1 : 2
    //   this.asc2 = !this.asc2
    //   this.getData()
    // },
    // sortByStar() {
    //   this.formData.orderBy = 3
    //   this.formData.orderByAd = this.asc3 ? 1 : 2
    //   this.asc3 = !this.asc3
    //   this.getData()
    // },
    // sortByProPrice() {
    //   this.formData.orderBy = 4
    //   this.formData.orderByAd = this.asc4 ? 1 : 2
    //   this.asc4 = !this.asc4
    //   this.getData()
    // },

    // 图片出错
    setErrorImage: function setErrorImage(event) {
      console.log('图片出错', event);
      event.target.parentNode.style.backgroundImage = 'url(' + this.avatarDefault + ')';
      // event.target.src = require('common/images/avatar-default.png')
    }
  }
});

/***/ }),

/***/ "iMMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var funcitonModule = {
  namespaced: true, //开启命名空间
  state: function state() {
    return {
      // 页面调用this.$store.state.funciton.dataFilter
      filter: function filter(val, that) {
        var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "allCustomers";
        var fieldKeep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "keep";

        if (val) {
          //val存在筛选数组
          that[field] = that[fieldKeep].filter(function (el) {
            var re = new RegExp(val, 'i');
            return re.test(el[0]) || re.test(el[1]);
          });
        } else {
          //val不存在还原数组
          that[field] = that[fieldKeep];
        }
      }
    };
  },
  mutations: {},
  actions: {},
  getters: {}
};
/* harmony default export */ __webpack_exports__["a"] = (funcitonModule);

/***/ }),

/***/ "iOJ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iepA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonInfo_vue__ = __webpack_require__("oyI4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_896dfcc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonInfo_vue__ = __webpack_require__("w90U");
function injectStyle (ssrContext) {
  __webpack_require__("/ChN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-896dfcc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_896dfcc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jABS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jlKY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/idCard-img2.89233f8.png";

/***/ }),

/***/ "k+6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerProject_vue__ = __webpack_require__("QsHF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8a1a7b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerProject_vue__ = __webpack_require__("XhW1");
function injectStyle (ssrContext) {
  __webpack_require__("zWC4")
  __webpack_require__("r8SX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c8a1a7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8a1a7b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kAZV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "kFVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\t无配置角色\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kGVF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kNpw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectSupplierRecord_vue__ = __webpack_require__("a9UP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e800c88a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projectSupplierRecord_vue__ = __webpack_require__("6EgS");
function injectStyle (ssrContext) {
  __webpack_require__("Ep28")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e800c88a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectSupplierRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e800c88a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projectSupplierRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kOl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// const remotesUrl = 'http://pgs.mecoolchina.com/';
var remotesUrl = 'http://jboss.remotes.myfmes.cn:8083/';

/* harmony default export */ __webpack_exports__["a"] = ({
  remotesUrl: remotesUrl
});

/***/ }),

/***/ "kng/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      action: "/rest/CrmGreylist/importGreyList?operatorId=" + sessionStorage.getItem("sysUserId"),
      openid: sessionStorage.getItem("sysUserId"),
      pageNo: 1,
      pageSize: 10,
      total: null,
      formData: {
        salemansName: "",
        idCard: "",
        status: null,
        qhrStatus: null,
        empPk: "",
        pageNo: 1,
        pageSize: 10
      },

      tableData: [],
      listLoading: false,
      uploadDialog: false,
      uploadDialogi: false,
      showBlackDialog: false,
      auths: [],
      reason: "",
      salesmanId: "",
      fileList: [],
      rules: {
        idCard: [{
          pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
          message: "请输入正确的身份证号",
          trigger: "blur"
        }]
      },
      options: [{ value: null, label: "全部" }, { value: 1, label: "灰名单" }, { value: 2, label: "黑名单" }, { value: 3, label: "白名单" }]
    };
  },
  mounted: function mounted() {
    this.getAuth();
    this.getData();
    this.$refs["formData"].resetFields();
  },

  methods: {
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      }
    },
    formatName: function formatName(row, column, cellValue) {
      var a = cellValue[0];
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        for (var i = 0; i < cellValue.length - 1; i++) {
          a = a + "*";
        }
        return a;
      }
    },
    addGrey: function addGrey() {
      if (this.formData.cardId || this.formData.reason || this.formData.name0) {
        this.formData.cardId = "";
        this.formData.reason = "";
        this.formData.name0 = "";
      }

      this.uploadDialogi = true;
    },
    getData: function getData(pageNo) {
      var _this = this;

      if (pageNo) {
        this.formData.pageNo = 1;
      }
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmGreylist/searchCrmGreylist",
        data: this.formData
      }).then(function (res) {
        _this.tableData = res.data;
        _this.tableData.forEach(function (ele) {
          ele.status == 1 ? ele.statusName = "灰名单" : ele.status == 2 ? ele.statusName = "黑名单" : "白名单";
          if (ele.status == 3) {
            ele.statusName = "白名单";
          }
        });
        _this.listLoading = false;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "查询失败，请稍后重试";
          }
          _this.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this.listLoading = false;
      });

      this.$http({
        method: "POST",
        url: "/rest/CrmGreylist/countCrmGreylist",
        data: this.formData
      }).then(function (res) {
        _this.total = res.data;
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = "查询失败，请稍后重试";
        }
        _this.$notify({
          title: "失败",
          message: errMsg,
          type: "error"
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(cellValue).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    getSalesmanId: function getSalesmanId(id) {
      this.salesmanId = id.id;
      this.showBlackDialog = true;
    },
    remove: function remove() {
      var _this2 = this;

      if (!this.reason) {
        this.$notify({
          title: "失败",
          message: '拉黑原因必填',
          type: "error"
        });
      } else {
        this.$http({
          method: "POST",
          url: "/rest/CrmGreylist/addCrmBlacklist",
          data: {
            id: this.salesmanId,
            reason: this.reason
          }
        }).then(function (res) {
          _this2.getData();
          _this2.showBlackDialog = false;
          _this2.$notify({
            title: "成功",
            message: "加入黑名单成功",
            type: "success"
          });
        }).catch(function (err) {
          var errMsg = void 0;
          _this2.showBlackDialog = false;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "操作失败，请稍后重试";
          }
          _this2.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        });
      }
    },
    downloadTmp: function downloadTmp() {
      var _this3 = this;

      this.$http({
        method: "POST",
        url: "/rest/CrmGreylist/downloademplate"
      }).then(function (res) {
        console.log(res.data.message);
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this3, "error", err.response, "查询失败，请稍后重试");
      });
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      console.log("222", fileList);
      if (response.message == "操作成功") {
        this.getData();
        this.uploadDialog = false;
      }
      this.$alert(response.message, "提示", {
        dangerouslyUseHTMLString: true
        // callback() {
        //   this.uploadDialog = false;
        // },
      });
    },
    handleError: function handleError(err, response, file) {
      var _this4 = this;

      this.$refs.upload.clearFiles();
      var msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, "提示", {
        dangerouslyUseHTMLString: true,
        customClass: "class",
        callback: function callback(action) {

          _this4.uploadDialog = false;
        }
      });
    },
    exportData: function exportData() {
      var _this5 = this;

      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmGreylist/exportGreyList",
        data: {
          idcard: this.formData.idcard,
          salemansName: this.formData.salemansName,
          empPk: this.formData.empPk,
          status: this.formData.status,
          qhrStatus: this.formData.qhrStatus,
          pageNo: this.formData.pageNo,
          pageSize: this.formData.pageSize
        }
      }).then(function (res) {
        // console.log(res.data.data);
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        _this5.listLoading = false;
      }).catch(function (err) {
        if (err.response) {
          var errMsg = void 0;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "导出失败，请稍后重试";
          }
          _this5.$notify({
            title: "失败",
            message: errMsg,
            type: "error"
          });
        }
        _this5.listLoading = false;
      });
    },

    //点击确定
    aaa: function aaa() {
      var _this6 = this;

      // this.formatDate.cardId,
      this.$http({
        method: "POST",
        url: "/rest/CrmGreylist/addGreylist",
        data: {
          cardId: this.formData.cardId,
          reason: this.formData.reason,
          name: this.formData.name0,
          operatorId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "success", res.data.message);
          _this6.uploadDialogi = false;
          _this6.formData = {
            salemansName: "",
            idCard: "",
            status: null,
            qhrStatus: null,
            empPk: "",
            pageNo: 1,
            pageSize: 10
          }, _this6.getData();
        }
        if (res && res.data && (res.data.code == 1 || res.data.code == null)) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "error", res.data.message);
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "error", err.response, "新增失败，请稍后重试");
      });
    },

    // action="/rest/CrmBlacklist/importBlackList"
    //                               :before-upload="handlePreview"
    //                               :on-success='handleSuccess'
    //                               :on-error='handleError'
    //                               :show-file-list="false"
    submitUpload: function submitUpload() {
      // operatorId: sessionStorage.getItem('sysUserId')
      this.$refs.upload.submit();
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file);
    },
    insertBatchs: function insertBatchs() {
      this.uploadDialog = true;
      // this.$refs.upload.clearFiles();
    },
    handlePreview: function handlePreview(file) {},
    exceed: function exceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(this, "warning", "只能上传一个文件,请删除后重新上传！");
    },
    reset: function reset(id) {
      var _this7 = this;

      this.$http({
        method: "POST",
        url: "/rest/CrmGreylist/restore",
        params: {
          id: id.id
        }
      }).then(function (res) {
        _this7.getData();
        if (res.data.code == 0) {
          _this7.$notify({
            title: "成功",
            message: "还原成功",
            type: "success"
          });
        } else {
          _this7.$notify({
            title: "失败",
            message: res.data.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        var errMsg = void 0;
        if (err.response.message) {
          errMsg = err.response.message;
        } else {
          errMsg = "操作失败，请稍后重试";
        }
        _this7.$notify({
          title: "失败",
          message: errMsg,
          type: "error"
        });
      });
    },
    checkStatus: function checkStatus(salesman) {
      if (salesman.status == 1) {
        return true;
      } else {
        return false;
      }
    },
    checkResetStatus: function checkResetStatus(salesman) {
      if (salesman.status == 1) {
        return true;
      } else {
        return false;
      }
    },
    getAuth: function getAuth() {
      var _this8 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 47,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          _this8.auths.push(item.auth);
          console.log(_this8.auths);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this8, "error", err.response, "查询失败，请稍后重试");
      });
    },
    clear: function clear(formName) {
      this.formData = {
        salemansName: "",
        idCard: "",
        status: null,
        qhrStatus: null,
        empPk: "",
        pageNo: 1,
        pageSize: 10
      };
      this.rules;
      this.getData();
      this.$refs[formName].resetFields();
    }
  }
});

/***/ }),

/***/ "kub0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlCMDQyRkRFREZBRTExRTc4NTExRkU5M0Q0NDdGOUE2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlCMDQyRkRGREZBRTExRTc4NTExRkU5M0Q0NDdGOUE2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUIwNDJGRENERkFFMTFFNzg1MTFGRTkzRDQ0N0Y5QTYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUIwNDJGRERERkFFMTFFNzg1MTFGRTkzRDQ0N0Y5QTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6IJN+7AAABWUlEQVR42mL8//8/AzUAEwOVAAuMoadbkwqkqoGYB4gZCegDeeMnEM+7dLmlFsUgIKgD4tNAvJUIl/4DYlcgzgRiDINALnkGxNehNuIDIBerI7ucBc2b2VCMC/wFYmYk/hdsBv0G4oVAvApNMQyAwoQDiL9C5YOBOASbQSDbTgEDbxsu5wAjpAJIsQLVNAPZgkB2ADaDQP7lxWNIG5CqBLkcyJ4JMhA5jNBj5ztQkRAQzwPiqUiG9EENeQzEjkAXvQLS3FjTERT8gdoC8j8f0IAv0BgsBOKHoDABGnIGqpYZX8rmBCp8C6TdgfgOEJcBcTkQ3wNifyRDGNCTCLpBYFuAGk4AqVAgfgnEIG/4AsUuEpvXGKFeY4AadgFIOQCxM5B9DUeawpogvwGxHTBcPkNdBnL6d2hgW6PlP5AhTjB5dIOaoJnWCksGxZaJPwFxM9w7g648AggwAEapZPGnrFo9AAAAAElFTkSuQmCC"

/***/ }),

/***/ "l2JT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhDQTRGNTREREZBRTExRTc4RDg3OTFEODE4QzIxNDQwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhDQTRGNTRFREZBRTExRTc4RDg3OTFEODE4QzIxNDQwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OENBNEY1NEJERkFFMTFFNzhEODc5MUQ4MThDMjE0NDAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OENBNEY1NENERkFFMTFFNzhEODc5MUQ4MThDMjE0NDAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5cx90MAAABX0lEQVR42szUPUvDUBTG8Vac1FEQXcTNqYtDx2AnBcGhIpQMSoMJpZUMTk6uQnHIZgYFN6dCJ/0IThla+g1KVdRFRcEl/i88kdD6ChkM/Lg59+X09N7e5uM4zmXxjOUyevKu66ZjH3t4UTyFGdziWX0TOEJggjAMRyoySWwUsaj3J+yrtdVf1LufrmB8KMk6rjGLExziDHeKVzVu5rW1NkgqMknqOMYSKrhADw9YU9tTf0XzzPy653l+UtEBBtjUJ8xhHjdoDO3pgr7qQPGb1gemIguvaGEFBfTRVJxoqr+guKV1VvLVuqhiB8kRtrVn6cdO7Yur+VVOrZve7CTZqWKzwZeYxr3aZVXykUTrRo7fdDrYVblXqGmsptjSuJNO8tkvu4MtbbLZ0LL6y4obGu/85opE2EYJkzhXW1J/9Je7Fql8k2BDrfNVkp8ubaSTelQbfXtp/93fSGaJ3gUYALJIWYXaJ3Y+AAAAAElFTkSuQmCC"

/***/ }),

/***/ "lgp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      action: '',
      searchType: '1',
      indexType: '1',
      indexCol: undefined,
      valCol: undefined,
      fileList: [],
      showbtn: true,
      btnAbled: true,
      options: [],
      contract: '',
      loading: false
    };
  },
  mounted: function mounted() {
    window.$this = this;
  },

  methods: {
    //标签页切换
    handleClick: function handleClick(tab, event) {
      this.indexType = '1';
      this.indexCol = undefined;
      this.valCol = undefined;
      this.showbtn = true;
      this.fileList = [];
      this.btnAbled = true;
      this.contract = '';
      // this.$refs.upload.clearFiles();
      if ('3' == this.searchType) {
        this.constantList();
      }
    },
    constantList: function constantList() {
      var _this = this;

      this.$http({
        method: "GET",
        url: "/rest/project/constantList"
      }).then(function (res) {
        _this.options = res.data;
      }).catch(function (err) {
        _this.myNotify(_this, "error", err.response, "查询失败，请稍后重试");
      });
    },
    indexColChange: function indexColChange(val) {
      this.indexCol = val.target.value || undefined;
      if (/^\d+$/.test(val.target.value)) {
        if ('3' == this.searchType) {
          if ('' != this.contract && /^\d+$/.test(this.valCol)) {
            this.btnAbled = false;
          } else {
            this.btnAbled = true;
          }
        } else {
          if (/^\d+$/.test(this.valCol)) {
            this.btnAbled = false;
          } else {
            this.btnAbled = true;
          }
        }
      } else {
        this.btnAbled = true;
      }
    },
    valColChange: function valColChange(val) {
      this.valCol = val.target.value || undefined;
      if (/^\d+$/.test(val.target.value)) {
        if ('3' == this.searchType) {
          if ('' != this.contract && /^\d+$/.test(this.indexCol)) {
            this.btnAbled = false;
          } else {
            this.btnAbled = true;
          }
        } else {
          if (/^\d+$/.test(this.indexCol)) {
            this.btnAbled = false;
          } else {
            this.btnAbled = true;
          }
        }
      } else {
        this.btnAbled = true; //置灰
      }
    },
    changeValue: function changeValue() {
      if ('' != this.contract && /^\d+$/.test(this.indexCol) && /^\d+$/.test(this.valCol)) {
        this.btnAbled = false;
      } else {
        this.btnAbled = true;
      }
    },
    handleExceed: function handleExceed(file, fileList) {
      this.$message.error('只能上传一个文件,请删除后重新上传！');
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
      if (fileList && fileList.length) {
        this.showbtn = false;
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      this.showbtn = true;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
    },
    handleError: function handleError(err) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.reset();
      });
      this.$message.error(err);
    },
    beforeUpload: function beforeUpload(file) {
      var fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      var whiteList = ["xls", "xlsx"];

      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error('上传文件只能是 xls、xlsx 格式');
        return false;
      }

      var isLt2M = file.size / 1024 / 1024 < 25;

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 25MB');
        return false;
      }
    },
    uploadSuccess: function uploadSuccess(res) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.reset();
      });
      location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data;
    },
    reset: function reset() {
      this.btnAbled = true;
      this.indexCol = undefined;
      this.showbtn = true;
      this.fileList = [];
      this.valCol = undefined;
      this.contract = '';
      this.loading = false;
    },
    submitUpload: function submitUpload(refName) {
      var _this4 = this;

      this.action = '/rest/salesman/tomd?indexCol=' + this.indexCol + '&valCol=' + this.valCol + '&searchType=' + this.searchType + '&indexType=' + this.indexType + '&projectCode=' + this.contract;
      this.$nextTick(function () {
        _this4.$refs[refName].submit();
      });
      this.loading = true;
    }
  }
});

/***/ }),

/***/ "ljJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"灵工签约记录"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"125px","size":"mini"}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.param.name),callback:function ($$v) {_vm.$set(_vm.param, "name", $$v)},expression:"param.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.param.empPk),callback:function ($$v) {_vm.$set(_vm.param, "empPk", $$v)},expression:"param.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":80},model:{value:(_vm.param.idcard),callback:function ($$v) {_vm.$set(_vm.param, "idcard", $$v)},expression:"param.idcard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.serviceSupplier),callback:function ($$v) {_vm.$set(_vm.param, "serviceSupplier", $$v)},expression:"param.serviceSupplier"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_vm._l((_vm.serviceSuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.customer),callback:function ($$v) {_vm.$set(_vm.param, "customer", $$v)},expression:"param.customer"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_vm._l((_vm.allClientId),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"供应商"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.merchantNO),callback:function ($$v) {_vm.$set(_vm.param, "merchantNO", $$v)},expression:"param.merchantNO"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_vm._l((_vm.suppliersAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"公司名称","prop":"companyCode"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择公司名称..."},model:{value:(_vm.param.companyCode),callback:function ($$v) {_vm.$set(_vm.param, "companyCode", $$v)},expression:"param.companyCode"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._v(" "),_vm._l((_vm.companiesAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约时间"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd 00:00:00","type":"date","placeholder":"请选择签约开始时间"},model:{value:(_vm.param.startTime),callback:function ($$v) {_vm.$set(_vm.param, "startTime", $$v)},expression:"param.startTime"}}),_vm._v("\n              -\n              "),_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd 23:59:59","type":"date","placeholder":"请选择签约结束时间"},model:{value:(_vm.param.endTime),callback:function ($$v) {_vm.$set(_vm.param, "endTime", $$v)},expression:"param.endTime"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.exportResult()}}},[_vm._v("导出")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("收起筛选项")])],1)],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('div',{staticClass:"title"},[_vm._v("筛选结果")]),_vm._v(" "),_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"name","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empPk","label":"促销员ID","minWidth":"110","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idcard","label":"身份证号","align":"center","formatter":_vm.formatIdCard,"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"companyName","label":"所属公司","minWidth":"210","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"owenrName","label":"服务商","minWidth":"210","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"客户","minWidth":"260","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceSupplier","label":"签约平台","minWidth":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"merchantName","label":"落地方","minWidth":"220","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"signedTime","label":"签约时间","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedTime(scope.row.signedTime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"startTime","label":"合同开始日期","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedDate(scope.row.startTime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"endTime","label":"合同结束日期","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.computedDate(scope.row.endTime)))])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.page.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.page.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.page.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139b7cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("mkBo");
function injectStyle (ssrContext) {
  __webpack_require__("vGSD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-139b7cb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139b7cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ltrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"1000px","center":true,"show-close":true,"visible":_vm.visiable,"close-on-click-modal":false,"append-to-body":"","top":"1vh"},on:{"update:visible":function($event){_vm.visiable=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('div',{staticStyle:{"font-size":"16px"}},[_vm._v("新增项目")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('el-form',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"model":_vm.param,"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50,"clearable":""},model:{value:(_vm.param.projectCode),callback:function ($$v) {_vm.$set(_vm.param, "projectCode", $$v)},expression:"param.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入...","maxlength":50,"clearable":""},model:{value:(_vm.param.projectName),callback:function ($$v) {_vm.$set(_vm.param, "projectName", $$v)},expression:"param.projectName"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("查询")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"14px"}}),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"mini","border":"","header-row-class-name":"table-header"},on:{"selection-change":_vm.handleSelectionChange}},[_vm._v("\n      >\n      "),_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"minWidth":"200","prop":"projectCode","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","minWidth":"200","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"startTime","label":"项目开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"endTime","label":"项目结束日期","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.visiable = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"small"},on:{"click":function($event){return _vm.subAdd()}}},[_vm._v("确认添加")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lvvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__ = __webpack_require__("hhm8");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allCustomers: [], //项目列表数组 用于筛选
      keep: [], //项目列表数组 全部用于还原
      multipleSelection: [], //选中项
      param2: {},
      //筛选项参数
      param: {},
      //表单翻页
      formData: {
        projectCode: null,
        projectName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      tableData: [], //表单信息
      listLoading: false,
      item: {},
      visiable: false
    };
  },

  methods: {
    show: function show(item) {
      this.param = {};
      this.tableData = [];
      this.formData = {
        projectCode: null,
        projectName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      };
      this.multipleSelection = [];
      this.item = item;
      this.visiable = true;
      this.param2 = {};
      this.getData();
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      //先判断是否选中了项目
      this.param2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.param));
      this.getData();
    },

    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      this.multipleSelection = [];
      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        id: this.item.id
      }, this.param2, {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      });
      //获取表单数据
      this.$http({
        method: "GET",
        headers: { "content-type": "application/json" },
        url: "/rest/agreementProject/listNoAgreementPro",
        params: params
      }).then(function (res) {
        _this2.tableData = res.data.items;
        _this2.formData.total = res.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //确认添加
    subAdd: function subAdd() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //先查询 选中的项目有所属其他月份的项目与其他合同客户是否关联
                _this3.tosubAdd();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    tosubAdd: function tosubAdd() {
      var _this4 = this;

      var projectCodesString = this.multipleSelection.map(function (el) {
        return el.projectCode;
      }).join(',');
      console.log("multipleSelection projectCodesString:" + projectCodesString);
      this.$http({
        method: "GET",
        url: "/rest/agreementProject/relatedProject",
        headers: { "content-type": "application/json" },
        params: {
          operatorId: sessionStorage.getItem("sysUserId"),
          id: this.item.id,
          projectCode: projectCodesString
        }
      }).then(function (res) {
        if (res.data.status && res.data.status != 200) {
          _this4.myNotify(_this4, "error", res.data.message);
          return;
        }
        _this4.$emit("done");
        // this.visiable = false;
        _this4.tableData = [];
        _this4.param = {};
        _this4.myNotify(_this4, "success", "添加成功");
        _this4.getData();
      }).catch(function () {
        _this4.myNotify(_this4, "error", "请求失败，请稍后重试");
      });
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    }
  }
});

/***/ }),

/***/ "lzcG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mALu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      numberValidateForm: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      projectPass: 'mecoolbu5', //项目密码
      userPass: '17mecool18', //客户密码
      canNotLogin: 0 //已经由于上个账号未注销而无法登陆的次数
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$refs.numberValidateForm.validate(function (valid) {
        if (valid) {
          var password = _this.numberValidateForm.checkPass;
          if (password == 'mecoolbu5' || password == '17mecool18') {
            var account = password == 'mecoolbu5' ? 'PGproject' : 'PGclient';

            _this.$http({
              method: "post",
              url: '/rest/auth/login',
              headers: { 'Content-type': 'application/x-authc-username-password+json' },
              data: {
                user: account,
                password: password
              }
            }).then(function (res) {
              //因为后台不允许同一个客户端登录两个账号，所以如果登陆了一个账号这里就提示他需要先注销
              //当前请求登录的账号和服务端返回的‘已经登录的账号’名称不匹配时，则判定是第二次登陆
              if (res.data.loginName != account) {
                if (_this.canNotLogin <= 1) {
                  _this.$alert('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆，本次登录无效', '提示', { type: 'error' });
                } else {
                  _this.$confirm('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆,  是否强制注销?', '提示', {
                    type: 'warning'
                  }).then(function () {
                    _this.$http.post('/rest/auth/logout').then(function (res) {
                      __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'success', res, '注销成功'); //有时候提示该用户未登入，此时code是一串字母，但我们仍然提示注销成功
                      sessionStorage.clear();
                      setTimeout(function () {
                        location.reload(true);
                      }, 1000);
                    }).catch(function (err) {
                      __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'warning', err.response, '注销失败');
                    });
                  }).catch(function () {});
                }
                _this.canNotLogin += 1;
              } else {
                //正常情况下直接登录
                sessionStorage.setItem('nickname', String(res.data.nickname));
                sessionStorage.setItem("usersPG", String(account));
                sessionStorage.setItem("passwordsPG", String(password));
                _this.$router.push({ path: '/salespersonLibrary' });
              }
            }).catch(function (err) {
              __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '无法登录系统，输入的账户或密码有误！');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'error', '您输入的账户或密码有误！');
          }
        }
      });
    }
  },
  mounted: function mounted() {
    document.title = '宝洁CRM';
  },
  destroyed: function destroyed() {
    window.onkeydown = null;
  }
});

/***/ }),

/***/ "mIHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Project_vue__ = __webpack_require__("6yCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Project: __WEBPACK_IMPORTED_MODULE_3__Project_vue__["a" /* default */] },
  watch: {},
  data: function data() {
    return {
      //筛选项参数
      param: {},
      param2: {}, //点击筛选之后param才赋值给param2
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      zhangTaoList: [], //账套数组
      allClientId: [], //合同下拉列表数组
      allCustomer: [], //项目客户下拉
      keepAllCustomer: [], //项目客户下拉 存储
      customer: false, //客户维护模态框
      customerValue: "", ///客户维护模态框 内的值
      disabledSubCustomer: true, //禁用提交按钮
      handleItem: {}, //当前操作对象
      tableData: [], //表单信息
      listLoading: false,
      authorizeDialog: false,
      title: "",
      content: ""
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.param2, {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      });
      //获取表单数据
      this.$http({
        method: "GET",
        // headers: { "content-type": "application/json" },
        url: "/rest/agreementProject/listAgreement",
        // data: params,
        params: params
      }).then(function (res) {

        _this2.tableData = res.data.items;
        _this2.formData.total = res.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },


    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    formatNum: function formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      this.param2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },

    //重置表单（清除筛选项）
    resetForm: function resetForm() {
      this.param = {};
      this.param2 = {};
      this.getData();
    },


    //展开收起
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },

    //项目维护
    handleProject: function handleProject(item) {
      this.$refs.Project.show(item);
    },

    //协议内容详情
    handleAgreeContent: function handleAgreeContent(item) {
      console.log("title:" + item.title);
      this.authorizeDialog = true;
      this.title = item.title;
      this.content = item.content;
    }
  }
});

/***/ }),

/***/ "mc+9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyNzI0MkQ3OUNGNDQxMUU3OUY2ODhEQzg1RUEwMjE1MSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyNzI0MkQ3QUNGNDQxMUU3OUY2ODhEQzg1RUEwMjE1MSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI3MjQyRDc3Q0Y0NDExRTc5RjY4OERDODVFQTAyMTUxIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI3MjQyRDc4Q0Y0NDExRTc5RjY4OERDODVFQTAyMTUxIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+6oLtbgAAAJlQTFRF9PT0rq6u8/Pz9fX1ra2tr6+vuLi4zs7Ourq6ubm5sLCwt7e38vLy4uLitra23NzcsrKy4eHh1dXV3t7e3d3d1tbW39/f2tra8fHx29vbxsbGz8/PsbGxxcXFzc3NtLS05+fnrKys6+vr5eXl6enp2NjY8PDwtbW1wMDA7Ozs0NDQy8vL9vb2x8fHu7u77+/vxMTE6OjowcHB/rPYtgAAAQ5JREFUeNpEkIduwzAMRO8kUt6O7djZO03Svf7/40o5RasBiCfi+HBwcN6V/Vuhm3TVLzy8g13vZoFUqpBhaj2w5RKS2cvQJak9Ehe1MlHJZvHfodpT17FvSj5+3J1wURFOgUXNcDXFrDHPjyHlrcREpMJojV4ZTq3oElt5HxGANpf65JByhSBrQ41DNrx9mc+ONXIOI9i5keYA79ExR8MhGh4abs4+GnWSIxiux8OeTZxnCDsW+NTUtJr57M7gU24Nie1TwYg8roqcoywYMtE5xiTcNWVdwlur6CVKdhbflInFh2fqvnp1zqa0mR7X+I8uGbpd9hedqX1QK8eQJ78Mtt1yWyiL1bKMlf8RYADySg0dOifBWQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "mgTQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_cook__ = __webpack_require__("xxzE");
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "JwtLogin",
  mounted: function mounted() {
    var _this = this;

    console.log(this.$route.query.token);
    this.$http({
      method: "GET",
      url: '/rest/sysUser/sysUserLogin',
      params: {
        token: this.$route.query.token
      }
    }).then(function (res) {
      console.log("进入123213");
      _this.$http({
        method: "post",
        url: '/rest/auth/login',
        headers: { 'Content-type': 'application/x-authc-username-password+json' },
        data: {
          user: String(res.data.sysUser.account),
          password: String(res.data.sysUser.password)
        }
      }).then(function (res2) {
        //获取登录人webid44的权限 给qhr页面权限使用
        res.data.webAuthLst.forEach(function (item) {
          if (item.webId == 44) {
            sessionStorage.setItem("webId_44Auth", String(item.auth));
          }
        });
        sessionStorage.setItem("account", String(res.data.sysUser.account));
        sessionStorage.setItem("sysUserId", String(res.data.sysUser.id));
        sessionStorage.setItem("empPk", String(res.data.sysUser.empPk));

        sessionStorage.setItem("user", String(res.data.sysUser.account));
        sessionStorage.setItem('nickname', String(res.data.sysUser.nickName));
        sessionStorage.setItem("passwords", String(res.data.sysUser.password));

        __WEBPACK_IMPORTED_MODULE_1__common_js_cook__["a" /* default */].setCookie('user', String(res.data.sysUser.account), 7200);
        console.log('getCookie' + __WEBPACK_IMPORTED_MODULE_1__common_js_cook__["a" /* default */].getCookie('user'));
        //成功后自动跳转到第一个有权限的页面，缺点是顺序被后台控制
        var webIdArr = [];
        var pathArr = [];
        var data = res.data;
        var routes = _this.$router.options.routes;
        data.webAuthLst.map(function (item) {
          webIdArr.push(item.webId);
        });
        routes.map(function (item) {
          item.children.map(function (item2) {
            if (webIdArr.indexOf(item2.webId) > -1) {
              pathArr.push(item2.path);
            }
          });
        });
        //这里其实可以优化，不等map结束，就可以跳转了，但也就几毫秒，无所谓
        if (pathArr.length > 0) {
          _this.$router.push({ path: pathArr[0] });
        } else {
          _this.$router.push({ path: '/noPermission' });
        }
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '获取用户权限信息失败，请稍后重试');
    });
  },

  methods: {}
});

/***/ }),

/***/ "mje6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allCustomers: [], //项目列表数组
      //筛选项参数
      param: {},
      param2: {},
      //表单翻页
      formData: {
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      tableData: [], //表单信息
      listLoading: false,
      visiable: false,
      btnLoading: false
    };
  },

  methods: {
    show: function show() {
      this.param = {};
      this.param2 = {};
      this.formData = {
        pageNo: 1,
        pageSize: 10,
        total: null
      };
      this.visiable = true;
      this.getData();
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    computedTime: function computedTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      this.param2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },

    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.param2, {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      });
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/baseCenter/cancellationList",
        data: params
      }).then(function (res) {
        _this2.tableData = res.data;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询列表失败，请稍后重试");
      });
      //获取总数量
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/baseCenter/cancellationListCount",
        data: params
      }).then(function (res) {
        _this2.formData.total = res.data;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询数量失败，请稍后重试");
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      this.btnLoading = true;
      this.$http({
        method: "post",
        url: "/rest/baseCenter/export",
        data: this.param
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          location.href = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
          _this3.btnLoading = false;
        } else {
          _this3.btnLoading = false;
          _this3.$alert(res.data.message);
        }
      }).catch(function (err) {
        _this3.btnLoading = false;
        _this3.$alert("获取注销记录失败！");
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "mkBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"login-wrap",style:(_vm.note)},[(!_vm.showLogin3)?_c('div',[_c('el-form',{ref:"ruleForm2",staticClass:"demo-ruleForm login-container",attrs:{"model":_vm.ruleForm2,"rules":_vm.rules2,"label-position":"right","label-width":"0px"}},[_c('img',{staticStyle:{"clear":"both","display":"block","margin":"auto","position":"absolute","top":"-123px","left":"0","right":"0"},attrs:{"src":__webpack_require__("bDEP"),"alt":""}}),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("系统登录")]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"account"}},[_c('el-input',{attrs:{"type":"text","auto-complete":"off","placeholder":"账号"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.handleSubmit2.apply(null, arguments)}},model:{value:(_vm.ruleForm2.account),callback:function ($$v) {_vm.$set(_vm.ruleForm2, "account", $$v)},expression:"ruleForm2.account"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"checkPass"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","placeholder":"密码"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.handleSubmit2.apply(null, arguments)}},model:{value:(_vm.ruleForm2.checkPass),callback:function ($$v) {_vm.$set(_vm.ruleForm2, "checkPass", $$v)},expression:"ruleForm2.checkPass"}})],1),_vm._v(" "),_c('el-checkbox',{staticClass:"remember",model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("记住账号")]),_vm._v(" "),_c('el-form-item',{staticStyle:{"width":"100%"}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary","loading":_vm.logining},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleSubmit2.apply(null, arguments)}}},[_vm._v("登录\n        ")]),_vm._v(" "),_c('img',{staticStyle:{"clear":"both","display":"block","margin":"auto","position":"absolute","top":"198px","left":"-105px","right":"0"},attrs:{"src":__webpack_require__("pSLs"),"alt":""}})],1)],1),_vm._v(" "),_vm._m(0)],1):_c('Login3')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-a1",staticStyle:{"text-align":"center"},attrs:{"onclick":"window.open('https://beian.miit.gov.cn')"}},[_c('h1',[_vm._v("普乐师（上海）数字科技股份有限公司 沪ICP备16008893号-4")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nEld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //筛选项参数
      param: {},
      param2: {}, //点击筛选之后param才赋值给param2
      //表单翻页
      page: {
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      allClientId: [],
      suppliersAll: [],
      companiesAll: [],
      serviceSuppliers: [],
      tableData: [], //表单信息
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getAllClientId();
    this.getServiceSuppliers();
    this.searchSuppliersAll();
    this.searchCompaniesAll();
  },

  methods: {
    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.param2, {
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNo
      });
      //获取表单数据
      this.$http({
        method: "POST",
        // headers: { "content-type": "application/json" },
        url: "/rest/salesman/signingRecordList",
        data: params
      }).then(function (res) {
        _this2.tableData = res.data.data.list;
        _this2.page.total = res.data.data.totalCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (sessionStorage.getItem("user") == "admin1" || sessionStorage.getItem("user") == "tinashi") {
        return cellValue;
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      }
    },
    computedTime: function computedTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    computedDate: function computedDate(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    formatNum: function formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      this.param2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.param));
      this.page.pageNo = 1;
      this.getData();
    },

    //重置表单（清除筛选项）
    resetForm: function resetForm() {
      this.param = {};
      this.param2 = {};
      this.getData();
    },

    //展开收起
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },

    // 导出筛选结果
    exportResult: function exportResult() {
      var _this3 = this;

      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.param);
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/salesman/signingRecordExport",
        data: params
      }).then(function (res) {
        _this3.listLoading = false;
        if (res.data && res.data.status == 200) {
          console.log(__WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data);
          location.href = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        } else {
          _this3.$alert(res.data.message);
        }
      }).catch(function (error) {
        _this3.listLoading = false;
        _this3.$alert("导出错误，请联系管理员！");
      });
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.page.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.page.pageNo = value;
      this.getData();
    },
    getServiceSuppliers: function getServiceSuppliers() {
      var _this4 = this;

      this.$http({
        method: "GET",
        url: "/rest/JiangYiJoint/getServiceSuppliers"
      }).then(function (res) {
        _this4.serviceSuppliers = res.data;
      }).catch(function (err) {
        _this4.myNotify(_this4, "error", err.response, "查询失败，请稍后重试");
      });
    },

    //获取客户列表
    getAllClientId: function getAllClientId() {
      var _this5 = this;

      this.$http({
        method: "GET",
        url: "/rest/baseCenter/all-customers"
      }).then(function (res) {
        _this5.allClientId = res.data.data;
      }).catch(function (err) {
        _this5.myNotify(_this5, "error", err.response, "查询失败，请稍后重试");
      });
    },
    searchSuppliersAll: function searchSuppliersAll() {
      var _this6 = this;

      this.$http({
        method: "GET",
        url: "/rest/supplier-permute/suppliers-all"
      }).then(function (res) {
        _this6.suppliersAll = res.data.data;
      }).catch(function (err) {
        _this6.myNotify(_this6, "error", err.response, "查询失败，请稍后重试");
      });
    },

    /**
       * 查询公司下拉列表
       */
    searchCompaniesAll: function searchCompaniesAll() {
      var _this7 = this;

      this.$http({
        method: 'GET',
        url: '/rest/superviseContract/virtual-project/companies'
      }).then(function (res) {
        _this7.companiesAll = res.data.data;
      }).catch(function (err) {});
    }
  }
});

/***/ }),

/***/ "nqg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterSetting_vue__ = __webpack_require__("Od1H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bd8d0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterSetting_vue__ = __webpack_require__("xco+");
function injectStyle (ssrContext) {
  __webpack_require__("uaAe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19bd8d0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterSetting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bd8d0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterSetting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nvWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticClass:"container salespersonLibray",attrs:{"element-loading-text":"拼命加载中","element-loading-background":"rgba(0, 0, 0, 0.6)"}},[_c('div',[_c('filter-tab',{attrs:{"webId":1},on:{"filterParam":_vm.getParam}})],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"order-by clearfix"},[_vm._v("\n        排序：\n        "),_c('el-button',{class:{'is-active': _vm.formData.orderBy == 1},attrs:{"round":"","size":"mini"},on:{"click":_vm.sortByAge}},[_vm._v("年龄"),_c('i',{staticClass:"el-icon-d-caret el-icon--right"})]),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('span',{staticClass:"total"},[_vm._v("\n            共"),_c('span',[_vm._v(_vm._s(_vm.total))]),_vm._v("位促销员\n          ")]),_vm._v(" "),(_vm.userIsPG && _vm.userIsPG == 'PGproject')?_c('span',[_c('el-button',{staticClass:"sellButton",attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.downloadModel}},[_vm._v("\n              下载模板 "),_c('i',{staticClass:"el-icon-download"})]),_vm._v(" "),_c('el-button',{staticClass:"sellButton",attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.requireList}},[_vm._v("\n              宝洁报表导入 "),_c('i',{staticClass:"el-icon-upload2"})]),_vm._v(" "),_c('el-button',{staticClass:"sellButton",attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.exportList}},[_vm._v("\n              宝洁报表导出 "),_c('i',{staticClass:"el-icon-download"})])],1):_vm._e()])],1)]),_vm._v(" "),_c('el-row',{staticStyle:{"overflow":"hidden"}},[_c('div',{staticStyle:{"width":"calc(100% + 186px)"}},_vm._l((_vm.dataList),function(item,index){return _c('el-col',{key:index,staticClass:"sales-persion-card"},[_c('div',{staticClass:"top-line",class:{
            'long': item.isLongSign && !item.isShortSign,
            'short': !item.isLongSign && item.isShortSign,
            'both': item.isLongSign && item.isShortSign}}),_vm._v(" "),_c('router-link',{class:{'pointer':_vm.userIsPLUS},staticStyle:{"display":"block"},attrs:{"to":_vm.userIsPLUS?{ path: '/salespersonDetail', query: { id: item.id , auths: _vm.auths}}:'',"target":"_blank","tag":"a","rel":"opener"}},[_c('div',{staticClass:"tag"},[(item.isLongSign)?_c('span',{staticClass:"tag-item long"},[_vm._v("长")]):_vm._e(),_vm._v(" "),(item.isShortSign)?_c('span',{staticClass:"tag-item"},[_vm._v("短")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"avatar",style:(_vm.avatarImg(item.headImg))},[_c('img',{attrs:{"src":item.headImg || '',"alt":""},on:{"error":_vm.setErrorImage}})]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),(_vm.userIsPLUS)?_c('div',{staticClass:"status",class:{'on-guard': item.status == '项目中' ||  item.status === '在岗'}},[_vm._v(_vm._s(item.status ===
                '项目中' || item.status === '在岗' ? '项目中' : '待岗中')+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"persional-info"},[_vm._v("促销员ID:"+_vm._s(item.empPk))]),_vm._v(" "),_c('div',{staticClass:"persional-info"},[_vm._v(_vm._s(item.age)+"岁"),_c('span',{staticClass:"line"}),_vm._v(_vm._s(item.height)+"cm")]),_vm._v(" "),_c('div',{staticClass:"info"},[(item.isLongSign)?_c('span',{staticClass:"tag-item long"},[_vm._v("服务月："+_vm._s(item.workMonth || '/'))]):_vm._e(),_vm._v(" "),(item.isShortSign)?_c('span',{staticClass:"tag-item"},[_vm._v("项目数："+_vm._s(item.projectNum || '/'))]):_vm._e()])])],1)}),1)]),_vm._v(" "),_c('el-pagination',{staticClass:"pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[48, 96, 144],"page-size":_vm.formData.pageSize,"layout":"slot, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}},[_vm._t("default",function(){return [_c('span',{staticClass:"slot-element"},[_vm._v("共"+_vm._s(_vm.total)+"位促销员")])]})],2),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.load),expression:"load"}],staticClass:"dialog",attrs:{"title":"导入宝洁数据","visible":_vm.uploadDialog,"width":"500px","center":"","element-loading-text":"数据正在上传中...","element-loading-background":"rgba(0, 0, 0, 0.8)"},on:{"update:visible":function($event){_vm.uploadDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('el-upload',{staticClass:"upload-demo",attrs:{"action":"/rest/upDownload/upload","data":_vm.obj,"on-error":_vm.handleError,"on-success":_vm.handleSuccess,"before-upload":_vm.handlePreview,"multiple":"","limit":3}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传excel文件")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":function($event){_vm.uploadDialog = false}}},[_vm._v("关 闭")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o0MO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qhr_Information_vue__ = __webpack_require__("DToB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__qhr_Contract_vue__ = __webpack_require__("Ybxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contractQys_vue__ = __webpack_require__("hrN5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Information: __WEBPACK_IMPORTED_MODULE_1__qhr_Information_vue__["a" /* default */], Contract: __WEBPACK_IMPORTED_MODULE_2__qhr_Contract_vue__["a" /* default */], contractQys: __WEBPACK_IMPORTED_MODULE_3__components_contractQys_vue__["a" /* default */] },
  watch: {},
  data: function data() {
    return {
      //筛选项参数
      param: {
        employeeName: null, //姓名
        documentNumber: null, //身份证号码
        phone: null, //手机号
        personType: null, //人员类别
        quitCrmStatus: null, //状态
        isAuthentivayion: null, //米咖注册认证状态
        contractTypeId: null, //合同类型
        clientId: null, //项目客户
        pensionClassCityId: null, //缴保城市
        zhangtaoId: null, //账套
        qiyuesuoAccountId: null, //所属公司
        empPk: null //促销员ID
      },
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      zhangTaoList: [], //账套数组
      allCustomers: [], //项目列表数组
      Information: false, //查看详情
      titleContract: "", //合同的表头
      Contract: false, //合同模态框
      tableData: [], //表单信息
      companyList: [], //公司数组
      listLoading: false,
      //查看详情绑定id
      itemId: -1,
      webId_44Auth: sessionStorage.getItem("webId_44Auth")
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getTerminal();
    this.getZhangtao();
    this.getCompany();
  },

  methods: {
    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      console.log(this.param);
      var params = {
        employeeName: this.param.employeeName,
        documentNumber: this.param.documentNumber,
        phone: this.param.phone,
        personType: this.param.personType,
        quitCrmStatus: this.param.quitCrmStatus,
        isAuthentivayion: this.param.isAuthentivayion,
        contractTypeId: this.param.contractTypeId,
        qiyuesuoAccountId: this.param.qiyuesuoAccountId,
        clientID: this.param.clientId,
        zhangtaoId: this.param.zhangtaoId,
        pensionClassCityId: this.param.pensionClassCityId,
        empPk: this.param.empPk,
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      };
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/CrmQhrInfoRest/qhrLongPromotionlist",
        data: params
      }).then(function (res) {
        _this2.tableData = res.data.items;
        _this2.formData.total = res.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },

    //获取项目列表
    getTerminal: function getTerminal() {
      var _this3 = this;

      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/clientDropDownList"
      }).then(function (res) {
        _this3.allCustomers = res.data.data;
      }).catch(function (err) {
        _this3.myNotify(_this3, "error", err.response, "查询失败，请稍后重试");
      });
    },

    //获取公司列表
    getCompany: function getCompany() {
      var _this4 = this;

      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/companyDownList"
      }).then(function (res) {
        _this4.companyList = res.data.data;
      }).catch(function (err) {
        _this4.myNotify(_this4, "error", err.response, "查询失败，请稍后重试");
      });
    },

    //获取账套下拉
    getZhangtao: function getZhangtao() {
      var _this5 = this;

      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/zhangtaoDropDownList"
      }).then(function (res) {
        console.log(res);
        _this5.zhangTaoList = res.data.data;
      }).catch(function (err) {
        _this5.myNotify(_this5, "error", err.response, "查询失败，请稍后重试");
      });
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    formatNum: function formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      this.formData.pageNo = 1;
      this.getData();
    },

    //重置表单（清除筛选项）
    resetForm: function resetForm() {
      this.param = {
        employeeName: null, //姓名
        documentNumber: null, //身份证号码
        phone: null, //手机号
        personType: null, //人员类别
        quitCrmStatus: null, //状态
        isAuthentivayion: null, //米咖注册认证状态
        contractTypeId: null, //合同类型
        qiyuesuoAccountId: null,
        clientId: null, //项目客户
        pensionClassCityId: null, //缴保城市
        zhangtaoId: null, //账套
        empPk: null //促销员ID
      }, this.getData();
    },


    //展开收起
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },

    // 导出筛选结果
    exportResult: function exportResult() {
      var _this6 = this;

      var params = {
        employeeName: this.param.employeeName,
        documentNumber: this.param.documentNumber,
        phone: this.param.phone,
        personType: this.param.personType,
        quitCrmStatus: this.param.quitCrmStatus,
        isAuthentivayion: this.param.isAuthentivayion,
        contractTypeId: this.param.contractTypeId,
        qiyuesuoAccountId: this.param.qiyuesuoAccountId,
        clientID: this.param.clientId,
        zhangtaoId: this.param.zhangtaoId,
        pensionClassCityId: this.param.pensionClassCityId,
        empPk: this.param.empPk,
        pageSize: 0,
        pageNo: 0
      };
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmQhrInfoRest/export",
        data: params
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          _this6.listLoading = false;
          // console.log(res);
          // console.log(utils.returnUrlHead() + res.data.message);
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
          // this.$alert(res.data.message);
        } else {
          _this6.listLoading = false;
          _this6.$alert(res.data.message);
        }
      }).catch(function (error) {
        _this6.listLoading = false;
        _this6.$alert("导出错误，请联系管理员！");
      });
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.Information = false;
      this.getData();
    },

    //确认离职 取消离职
    handleQuitCrmStatus: function handleQuitCrmStatus(item, type) {
      var _this7 = this;

      var title = void 0;
      if (type == 4) {
        title = "确认离职?";
      }
      if (type == 3) {
        title = "取消离职?";
      }
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var params = {
          id: item.id,
          quitCrmStatus: type
        };
        _this7.$http({
          method: "POST",
          url: "/rest/CrmQhrInfoRest/qhrlongPromotionQuit",
          params: params
        }).then(function (res) {
          console.log(res.data);
          if (res.data && res.data.status == 200) {
            _this7.listLoading = false;
            _this7.getData();
          } else {
            _this7.listLoading = false;
            _this7.$alert(res.data.message);
          }
        }).catch(function (error) {
          _this7.listLoading = false;
          _this7.$alert("修改状态失败，请联系管理员！");
        });
      });
    },

    //跳转详情
    handleDetails: function handleDetails(item) {
      this.itemId = item.id;
      this.Information = true;
    },
    searchContract: function searchContract() {
      this.$refs.contractQys.dialogVisible = true;
      this.$refs.contractQys.getList();
      this.$refs.contractQys.listLoading = true;
    }
  }
});

/***/ }),

/***/ "o8LF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addDescriptionValue: "",
      addRequirementValue: "",
      height: "600px",
      taskDescription: [],
      taskRequirements: [],
      activeDescriptionIndex: -9999,
      activeRequirementsIndex: -9999,
      loading: false
    };
  },

  methods: {
    getDataList: function getDataList() {
      var _this = this;

      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchTaskDescriptionRequirements?type=1"
      }).then(function (res) {
        _this.taskDescription = res.data;
      });
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchTaskDescriptionRequirements?type=2"
      }).then(function (res) {
        _this.taskRequirements = res.data;
      });
    },

    //add
    addTask: function addTask(type) {
      var _this2 = this;

      var flag = true;
      if (type === 1) {
        this.taskDescription.forEach(function (item) {
          if (item == _this2.addDescriptionValue.trim()) {
            flag = false;
            _this2.$message({
              message: "该任务已经存在",
              type: "warning"
            });
          }
          if (_this2.addDescriptionValue.trim() == "") {
            flag = false;
            _this2.$message({
              message: "不能输入空字符",
              type: "warning"
            });
          }
          if (_this2.addDescriptionValue.includes(";")) {
            flag = false;
            _this2.$message({
              message: "不能输入分号`;`",
              type: "warning"
            });
          }
        });
        if (flag) {
          this.taskDescription = [this.addDescriptionValue].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.taskDescription));
          this.addDescriptionValue = "";
        }
      }
      if (type === 2) {
        this.taskRequirements.forEach(function (item) {
          if (item == _this2.addRequirementValue.trim()) {
            flag = false;
            _this2.$message({
              message: "该任务已经存在",
              type: "warning"
            });
          }
          if (_this2.addRequirementValue.trim() == "") {
            flag = false;
            _this2.$message({
              message: "不能输入空字符",
              type: "warning"
            });
          }
          if (_this2.addRequirementValue.includes(";")) {
            flag = false;
            _this2.$message({
              message: "不能输入分号`;`",
              type: "warning"
            });
          }
        });
        if (flag) {
          this.taskRequirements = [this.addRequirementValue].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.taskRequirements));
          this.addRequirementValue = "";
        }
      }
    },

    // 改变选中状态
    changeIndex1: function changeIndex1(index) {
      this.activeDescriptionIndex = index;
    },
    changeIndex2: function changeIndex2(index) {
      this.activeRequirementsIndex = index;
    },

    //删除
    del1: function del1() {
      this.taskDescription.splice(this.activeDescriptionIndex, 1);
      this.activeDescriptionIndex = -9999;
    },
    del2: function del2() {
      this.taskRequirements.splice(this.activeRequirementsIndex, 1);
      this.activeRequirementsIndex = -9999;
    },
    top1: function top1() {
      var keep = this.taskDescription.splice(this.activeDescriptionIndex, 1).join();
      console.log(keep);
      this.taskDescription.splice(this.activeDescriptionIndex - 1, 0, keep);
      this.activeDescriptionIndex--;
    },
    top2: function top2() {
      var keep = this.taskRequirements.splice(this.activeRequirementsIndex, 1).join();
      console.log(keep);
      this.taskRequirements.splice(this.activeRequirementsIndex - 1, 0, keep);
      this.activeRequirementsIndex--;
    },
    bottom1: function bottom1() {
      var keep = this.taskDescription.splice(this.activeDescriptionIndex, 1).join();
      console.log(keep);
      this.taskDescription.splice(this.activeDescriptionIndex + 1, 0, keep);
      this.activeDescriptionIndex++;
    },
    bottom2: function bottom2() {
      var keep = this.taskRequirements.splice(this.activeRequirementsIndex, 1).join();
      console.log(keep);
      this.taskRequirements.splice(this.activeRequirementsIndex + 1, 0, keep);
      this.activeRequirementsIndex++;
    },
    submit: function submit() {
      var _this3 = this;

      this.loading = true;
      this.$http.post("/rest/PublishedWork/saveTaskDescriptionRequirements", [{
        workSignType: 1,
        workSignName: this.taskDescription
      }, {
        workSignType: 2,
        workSignName: this.taskRequirements
      }]).then(function (res) {
        if (res.data.code == 0) {
          _this3.$notify({
            title: '提示',
            message: '保存成功',
            type: 'success',
            dangerouslyUseHTMLString: true
          });
        }
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.height = window.screen.height - 290 + "px";
    this.getDataList();
  }
});

/***/ }),

/***/ "od8Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "odvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemConfig_vue__ = __webpack_require__("Wt/j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494e335c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemConfig_vue__ = __webpack_require__("rw/D");
function injectStyle (ssrContext) {
  __webpack_require__("PDS/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-494e335c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494e335c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ovos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonDataShow_vue__ = __webpack_require__("zIGr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3da677_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonDataShow_vue__ = __webpack_require__("Wl6S");
function injectStyle (ssrContext) {
  __webpack_require__("KNks")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f3da677"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonDataShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3da677_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonDataShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oyI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_images_avatar_default_png__ = __webpack_require__("qvSl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_images_avatar_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_images_avatar_default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_idCard_img_png__ = __webpack_require__("ImiH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_idCard_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_images_idCard_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_images_idCard_img2_png__ = __webpack_require__("jlKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_images_idCard_img2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_images_idCard_img2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_images_bankCard_img_png__ = __webpack_require__("4inT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_images_bankCard_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_images_bankCard_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这是基础中心和任务中心的组件。。跨菜单的共通组件都放这里






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isAdmin: false, //是否是tinashi或者admin1

      salepersionData: '',
      starValue: null,
      sex: '',
      agreement: '',

      avatarDefault: __WEBPACK_IMPORTED_MODULE_0_common_images_avatar_default_png___default.a,
      idcardDefaultCover: __WEBPACK_IMPORTED_MODULE_1_common_images_idCard_img_png___default.a,
      idcardDefaultBack: __WEBPACK_IMPORTED_MODULE_2_common_images_idCard_img2_png___default.a,
      bankcardDefaultCover: __WEBPACK_IMPORTED_MODULE_3_common_images_bankCard_img_png___default.a,
      bigImage: null,
      bigImageWidth: null,
      bigImageHeight: null,
      bigImageWidth2: null,
      showbigImage: false,

      loading: false,

      starName: null,
      nextstartName: null,
      precent: null
    };
  },

  props: ['id', "auths"],
  mounted: function mounted() {
    var _this = this;

    var x = sessionStorage.getItem('user');
    this.isAdmin = Boolean(x == 'admin1' || x == 'tinashi');

    this.loading = true;
    this.$http({
      method: "POST",
      url: '/rest/SalesmanParticulars/basicInformation',
      params: {
        id: this.id
      }
    }).then(function (res) {
      var data = res.data;
      if (!_this.isAdmin) {
        data.tel = __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].plusXing(data.tel, 3, 4);
        data.idcard = __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].plusXing(data.idcard, 6, 4);
        data.bankNum = __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].plusXing(data.bankNum, 4, 7);
      }
      data.emergencyTel = __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].plusXing(data.emergencyTel, 3, 4);
      data.recommendertel = __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].plusXing(data.recommendertel, 3, 4);
      _this.salepersionData = data;
      _this.starValue = data.starScore / 10000 * 5;
      switch (data.sex) {
        case 1:
          _this.sex = '男';
          break;
        case 2:
          _this.sex = '女';
          break;
        default:
          _this.sex = '性别未知';
      }
      data.agreement === 1 ? _this.agreement = '有合约' : _this.agreement = '无合约';

      _this.loading = false;
      _this.$http({
        method: "GET",
        url: "/rest/SearchScoreDetails/searchNextStartName",
        params: {
          score: _this.salepersionData.starScore
        }
      }).then(function (res) {
        var data1 = res.data;
        _this.starName = data1.startName;
        _this.nextstartName = data1.nextstartName;
        _this.precent = data1.mindifferenceScore / data1.poorScore * 100;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4__common_js_util_js__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
      _this.loading = false;
    });
  },

  methods: {
    // 图片出错
    setErrorImage: function setErrorImage(event) {
      event.target.parentNode.style.backgroundImage = 'url(' + this.avatarDefault + ')';
    },
    imgError1: function imgError1(event) {
      // setTimeout((event)=>{
      event.target.parentNode.style.backgroundImage = 'url(' + __WEBPACK_IMPORTED_MODULE_1_common_images_idCard_img_png___default.a + ')';
      event.target.parentNode.style.backgroundSize = 'cover';
      // },100,event)
    },
    imgError2: function imgError2(event) {
      // setTimeout((event)=>{
      event.target.parentNode.style.backgroundImage = 'url(' + __WEBPACK_IMPORTED_MODULE_3_common_images_bankCard_img_png___default.a + ')';
      event.target.parentNode.style.backgroundSize = 'cover';
      // },100,event)
    },
    avatarImg: function avatarImg(url) {
      if (url != null) {
        return {
          backgroundImage: 'url(' + url + ')',
          backgroundSize: 'cover',
          width: '150px',
          height: '150px'
        };
      } else {
        return {
          backgroundImage: 'url(' + this.avatarDefault + ')',
          backgroundSize: 'cover',
          width: '150px',
          height: '150px'
        };
      }
    },
    avatarBigImg: function avatarBigImg(url) {
      if (url != null) {
        return {
          backgroundImage: 'url(' + url + ')',
          backgroundSize: 'cover',
          width: this.bigImageWidth,
          height: this.bigImageHeight
        };
      } else {
        return {
          backgroundImage: 'url(' + this.avatarDefault + ')',
          backgroundSize: 'cover',
          width: this.bigImageWidth,
          height: this.bigImageHeight
        };
      }
    },
    showImage: function showImage(url) {
      this.showbigImage = true;
      this.bigImage = url;
    },
    noCompression: function noCompression(url) {
      //img的err事件有小概率在此之前执行，同样设置backgroundImage
      //为防止被此覆盖加个if判断，刚进来的时候不执行此语句
      if (url) {
        return {
          backgroundImage: 'url(' + url + ')',
          backgroundSize: 'cover'
        };
      }
    }
  },
  updated: function updated() {
    var width = document.getElementsByClassName('img')[0].width;
    var height = document.getElementsByClassName('img')[0].height;
    width > 500 ? (width = width / 2, height = height / 2) : (width, height);
    width < 300 ? (width = 300, height = 300) : (width, height);
    this.bigImageWidth = width + 'px';
    this.bigImageWidth2 = width + 40 + 'px';
    this.bigImageHeight = height + 'px';
  }
});

/***/ }),

/***/ "p+2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Add_vue__ = __webpack_require__("Uz+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Add: __WEBPACK_IMPORTED_MODULE_2__Add_vue__["a" /* default */] },
  data: function data() {
    return {
      allCustomers: [], //项目列表数组
      //筛选项参数
      param: {},
      param2: {},
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      tableData: [], //表单信息
      listLoading: false,
      item: {},
      visiable: false
    };
  },

  methods: {
    show: function show(item) {
      this.param = {};
      this.param2 = {};
      this.item = item;
      this.formData = {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      };
      this.visiable = true;
      this.getData();
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    computedTime: function computedTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      this.param2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },

    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        customerMappingId: this.item[0]
      }, this.param2, {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      });
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/LongPromotionContractProject/projectMaintenance",
        params: params
      }).then(function (res) {
        _this2.tableData = res.data.items;
        _this2.formData.total = res.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },

    // 取消关联
    disassociate: function disassociate(item) {
      var _this3 = this;

      this.$confirm("\u662F\u5426\u53D6\u6D88\u9879\u76EE<span style=\"color:#ff4d4f\">" + item[3] + "</span>\u4E0E<span style=\"color:#ff4d4f\">" + this.item[1] + "</span>\u7684\u5173\u8054\uFF1F", "提示", {
        distinguishCancelAndClose: true,
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _this3.$http({
          method: "GET",
          url: "/rest/LongPromotionContractProject/updateAssociatedStatus",
          params: {
            customerMappingId: _this3.item[0],
            id: item[0],
            operatorId: sessionStorage.getItem("sysUserId")
          }
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.status == 200) {
            _this3.$emit("done");
            _this3.getData();
          } else {
            _this3.myNotify(_this3, "error", data.message);
          }
        });
      });
    },

    //新增
    add: function add() {
      this.$refs.Add.show(this.item);
    },
    addDone: function addDone() {
      this.$emit("done");
      this.formData.pageNo = 1;
      this.getData();
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "p659":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"container",attrs:{"element-loading-text":"拼命加载中","element-loading-background":"rgba(0, 0, 0, 0.6)"}},[_c('div',{staticClass:"breadcrumb"},[_c('span',{staticClass:"currPage"},[_vm._v("促销员详情")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("基础中心")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: 'salespersonLibrary' }}},[_vm._v("促销员库")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("促销员详情")])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"clearfix",staticStyle:{"margin-bottom":"20px"}},[_c('el-col',{staticClass:"base-data left-data  leftBox"},[_c('div',{staticClass:"base-data-top"},[_c('div',{staticClass:"base-data-left floatl"},[_c('div',{staticClass:"avatar floatl",style:(_vm.avatarImg(_vm.salepersionData.headImg)),on:{"click":function($event){return _vm.showImage(_vm.salepersionData.headImg)}}},[_c('img',{staticClass:"img",staticStyle:{"display":"none"},attrs:{"src":_vm.salepersionData.headImg || '',"alt":""},on:{"error":_vm.setErrorImage}})]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n             "+_vm._s(_vm.salepersionData.name)+" "),(_vm.salepersionData.signContract)?_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer","fontSize":"8px","marginLeft":"45px","fontWeight":"400"},on:{"click":function($event){return _vm.openContractDialog(_vm.salepersionData.idcard, _vm.salepersionData.name)}}},[_vm._v("已签约")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"persional-info"},[_vm._v("米咖ID:"+_vm._s(_vm.salepersionData.empPk))]),_vm._v(" "),(_vm.salepersionData && _vm.salepersionData.salesmanCode)?_c('div',{staticClass:"persional-info"},[_vm._v("\n                水豚ID: "+_vm._s(_vm.salepersionData.salesmanCode)+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"persional-info"},[_vm._v(_vm._s(_vm.salepersionData.age)+"岁"),_c('span',{staticClass:"line"}),_vm._v(_vm._s(_vm.salepersionData.height)+"cm")]),_vm._v(" "),_c('div',{staticClass:"clearfix",staticStyle:{"margin-left":"140px"}},[_c('div',{staticClass:"status floatl",class:{'on-guard': _vm.salepersionData.status=='项目中' || _vm.salepersionData.status=='在岗' }},[_vm._v(_vm._s(_vm.salepersionData.status === '项目中' || _vm.salepersionData.status === '在岗' ? '项目中' : '待岗中'))]),_vm._v(" "),_c('div',{staticClass:"tag floatl"},[(_vm.isLong)?_c('span',{staticClass:"tag-item",class:{'long': true}},[_vm._v("长")]):_vm._e(),_vm._v(" "),(_vm.isShort)?_c('span',{staticClass:"tag-item"},[_vm._v("短")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"base-data-right floatr"},[_c('div',{staticClass:"title clearfix"},[_vm._v("\n            基本信息\n          ")]),_vm._v(" "),_c('a',{staticClass:"data-item floatl",attrs:{"href":"##","id":"mask_box"},on:{"click":function($event){return _vm.createOutCall(_vm.salepersionData.empPk, _vm.salepersionData.name, _vm.salepersionData.originTel)}}},[_c('img',{attrs:{"src":__webpack_require__("2uru"),"alt":""}}),_vm._v(_vm._s(_vm.salepersionData.tel || '无'))]),_vm._v(" "),_c('p',{staticClass:"data-item floatl",attrs:{"title":((_vm.salepersionData.province || '') +
            (_vm.salepersionData.city || '') +
            (_vm.salepersionData.area || '') +
            (_vm.salepersionData.homeAddress || '') || '无')}},[_c('img',{attrs:{"src":__webpack_require__("u6jE"),"alt":""}}),_vm._v(_vm._s(((_vm.salepersionData.province || '') +
            (_vm.salepersionData.city || '') +
            (_vm.salepersionData.area || '') +
            (_vm.salepersionData.homeAddress || '') || '无'))+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"data-item floatl"},[_vm._v("认证状态："+_vm._s(_vm.salepersionData.authenticationStatus))]),_vm._v(" "),_c('p',{staticClass:"data-item floatl"},[_vm._v("银行卡认证状态："+_vm._s(_vm.salepersionData.bankStatus))]),_vm._v(" "),_c('p',{staticClass:"data-item floatl"},[_vm._v("项目数量："+_vm._s(_vm.isShort ? ((_vm.salepersionData.projectCount || '0') + '个') : '- -'))]),_vm._v(" "),_c('p',{staticClass:"data-item floatl"},[_vm._v("服务月数："+_vm._s(_vm.isLong ? ((_vm.salepersionData.serviceMonths || '0') + '个月') : '- -'))]),_vm._v(" "),_c('p',{staticClass:"data-item floatl"},[_vm._v("紧急联系人："+_vm._s(_vm.salepersionData.emergencyContact || '无'))]),_vm._v(" "),_c('p',{staticClass:"data-item floatl"},[_vm._v("紧急联系人电话："+_vm._s(_vm.salepersionData.emergencyTel || '无'))])])]),_vm._v(" "),_c('div',{staticClass:"base-data-bottom clearfix"},[_c('div',{staticClass:"star floatl"},[_c('div',{staticClass:"star-level"},[_vm._v("星级："+_vm._s(_vm.salepersionData.starName))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_vm._v("\n            "+_vm._s(_vm.starName)+"\n            "),_c('div',{staticClass:"progress-line"},[_c('div',{staticClass:"bar",style:('width: '+_vm.precent+'%;')},[(_vm.mindifferenceScore!=null && _vm.poorScore!=null)?_c('div',{staticClass:"barText"},[_vm._v(_vm._s(_vm.mindifferenceScore)+"/"+_vm._s(_vm.poorScore))]):_vm._e()])]),_vm._v("\n            "+_vm._s(_vm.nextstartName)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"view-btn",on:{"click":function($event){return _vm.$router.push({path:'/SystemConfig',query:{navState:3}})}}},[_vm._v("\n            查看如何提升星级\n          ")])]),_vm._v(" "),_c('div',{staticClass:"credit floatl"},[_c('div',{staticClass:"credit-num clearfix"},[_c('span',{staticClass:"floatl"},[_vm._v(_vm._s(_vm.salepersionData.creditScore))]),_vm._v("\n            信用\n          ")]),_vm._v(" "),_c('div',{staticClass:"view-btn",on:{"click":function($event){return _vm.$router.push({path:'/SystemConfig',query:{navState:4}})}}},[_vm._v("\n            查看如何提升信用\n          ")])]),_vm._v(" "),_c('div',{staticClass:"score floatl"},[_c('div',{staticClass:"score-num clearfix"},[_c('span',{staticClass:"floatl"},[_vm._v(_vm._s(_vm.salepersionData.score))]),_vm._v("\n            积分\n          ")]),_vm._v(" "),_c('div',{staticClass:"view-btn",on:{"click":function($event){return _vm.$router.push({path:'/SystemConfig',query:{navState:2}})}}},[_vm._v("\n            查看如何获得积分\n          ")])])])]),_vm._v(" "),_c('el-col',{staticClass:"right-data",style:({'min-height':_vm.rightBoxHeight})},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-title"},[_c('h2',[_vm._v("标签")])]),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('div',{staticClass:"tag-body"},_vm._l((_vm.salepersionData.signName),function(item,index){return _c('el-tag',{key:index,staticClass:"tag-item",attrs:{"type":"info"}},[_vm._v(_vm._s(item))])}),1)])]),_vm._v(" "),_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-title"},[_c('h2',[_vm._v("自我喜好")])]),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('div',{staticClass:"tag-body"},_vm._l((_vm.salepersionData.selfSignName),function(item,index){return _c('el-tag',{key:index,staticClass:"tag-item",attrs:{"type":"info"}},[_vm._v(_vm._s(item))])}),1)])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-title"},[_c('h2',[_vm._v("米咖工作履历")])]),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","tooltip-effect":"dark","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"label":"编号","type":"index","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"项目开始时间","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":"项目结束时间","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"attendanceRate","label":"考勤率","width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"saleRate","label":"销售达成","width":"70","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.saleRate == null)?_c('div',[_vm._v(" - ")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.saleRate))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qcScore","label":"QC","width":"70","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.qcScore == null)?_c('div',[_vm._v(" - ")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.qcScore))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trainScore","label":"培训得分","width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customerScore","label":"客户评分","width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customerStar","label":"客户星级","width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectScore","label":"项目组评分","width":"90","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"slot, sizes, total, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-title"},[_c('h2',[_vm._v("水豚工作履历")])]),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableDataSyn,"size":"small","border":"","tooltip-effect":"dark","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"label":"编号","type":"index","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskCode","label":"任务编号","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskName","label":"任务名称","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskStartTime","label":"任务开始时间","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskEndTime","label":"任务结束时间","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskRequire","label":"任务要求","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salaryDetail","label":"服务费说明","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskDelegate","label":"任务委托方","width":"70","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskAssignmentTime","label":"任务领取时间","width":"160","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.pageNoSyn,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSizeSyn,"layout":"slot, sizes, total, prev, pager, next, jumper","total":_vm.totalSyn},on:{"size-change":_vm.handleSizeChangeSyn,"current-change":_vm.handleCurrentChangeSyn}})],1)]),_vm._v(" "),_c('div',{staticClass:"viewImage"},[_c('el-dialog',{staticClass:"dialog",attrs:{"title":"查看大图","visible":_vm.showbigImage,"width":_vm.bigImageWidth2},on:{"update:visible":function($event){_vm.showbigImage=$event}},model:{value:(_vm.bigImage),callback:function ($$v) {_vm.bigImage=$$v},expression:"bigImage"}},[_c('div',{staticClass:"dialogImage",style:(_vm.avatarBigImg(_vm.bigImage))},[_c('img',{staticStyle:{"display":"none"},attrs:{"src":_vm.bigImage || '',"alt":""},on:{"error":_vm.setErrorImage}})]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showbigImage = false}}},[_vm._v("确 定")])],1)])],1),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.contractLoading),expression:"contractLoading"}],staticClass:"blacklistDialog dialog",attrs:{"title":_vm.contractDialogTitle,"visible":_vm.showContractDialog,"width":"75%","center":""},on:{"update:visible":function($event){_vm.showContractDialog=$event}}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"150px","size":"mini"}},[_c('div',{staticClass:"slide-wrap",staticStyle:{"height":"auto"}},[_c('el-form-item',{attrs:{"label":"合同开始时间"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.startTimeFrom),callback:function ($$v) {_vm.$set(_vm.contractFormData, "startTimeFrom", $$v)},expression:"contractFormData.startTimeFrom"}}),_vm._v("\n          -\n          "),_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.startTimeTo),callback:function ($$v) {_vm.$set(_vm.contractFormData, "startTimeTo", $$v)},expression:"contractFormData.startTimeTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"合同结束时间："}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.endTimeFrom),callback:function ($$v) {_vm.$set(_vm.contractFormData, "endTimeFrom", $$v)},expression:"contractFormData.endTimeFrom"}}),_vm._v("\n          -\n          "),_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.contractFormData.endTimeTo),callback:function ($$v) {_vm.$set(_vm.contractFormData, "endTimeTo", $$v)},expression:"contractFormData.endTimeTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称："}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.contractFormData.customer),callback:function ($$v) {_vm.$set(_vm.contractFormData, "customer", $$v)},expression:"contractFormData.customer"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.customerList),function(item){return _c('el-option',{key:item,attrs:{"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台："}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择...","clearable":""},model:{value:(_vm.contractFormData.serviceSupplier),callback:function ($$v) {_vm.$set(_vm.contractFormData, "serviceSupplier", $$v)},expression:"contractFormData.serviceSupplier"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_c('el-option',{attrs:{"label":"薪太软","value":"薪太软"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"众简","value":"众简"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"float":"right","margin-right":"50px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.searchContractData()}}},[_vm._v("筛选")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.contractData}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"签约客户","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"merchantName","label":"供应商","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"signTime","label":"签约时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"合同开始时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":"合同结束时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceSupplier","label":"签约平台","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.contractFormData.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.contractFormData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.contractTotal},on:{"size-change":_vm.handleContractSizeChange,"current-change":_vm.handleContractCurrentChange}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p8Bm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pRLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      companiesAll: [],
      suppliersAll: [],
      companySuppliers: [],
      openBanks: [],
      openBankNos: [],
      formData: {
        pageNo: 1,
        pageSize: 10,
        company: null,
        originSupplier: null,
        permuteSupplier: null,
        status: null
      },
      addData: {
        company: null,
        originSupplier: null,
        permuteSupplier: null,
        permuteBank: null,
        permuteBankAccount: null
      },
      tableData: [],
      total: null,
      listLoading: false,
      showAddDialog: false,
      editAuth: false,
      showDetailDialog: false,
      detailCompany: null,
      detailConfigId: null,
      detailsData: [],
      currentDetailSupplier: null,
      showAddDetailDialog: false,
      addDetailData: {
        id: null,
        permuteSupplier: null,
        permuteBank: null,
        permuteBankAccount: null
      }
    };
  },
  mounted: function mounted() {
    this.getEditCustomerConfigAuth();
    this.searchCompaniesAll();
    this.searchSuppliersAll();
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/list',
        params: this.formData
      }).then(function (res) {
        _this.tableData = res.data.data.items;
        _this.total = res.data.data.totalItemsCount;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    searchCompaniesAll: function searchCompaniesAll() {
      var _this2 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/companies-all'
      }).then(function (res) {
        _this2.companiesAll = res.data.data;
      }).catch(function (err) {});
    },
    searchSuppliersAll: function searchSuppliersAll() {
      var _this3 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/suppliers-all'
      }).then(function (res) {
        _this3.suppliersAll = res.data.data;
      }).catch(function (err) {});
    },
    searchCompanySuppliers: function searchCompanySuppliers() {
      var _this4 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/company/suppliers',
        params: {
          companyCode: this.addData.company.code
        }
      }).then(function (res) {
        _this4.companySuppliers = res.data.data;
      }).catch(function (err) {});
    },
    searchOpenBanks: function searchOpenBanks() {
      var _this5 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/open-banks',
        params: {
          supplierId: this.addData.permuteSupplier.code
        }
      }).then(function (res) {
        _this5.openBanks = res.data.data;
      }).catch(function (err) {});
    },
    searchOpenBankNos: function searchOpenBankNos() {
      var _this6 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/open-bank-nos',
        params: {
          supplierId: this.addData.permuteSupplier.code,
          openBank: this.addData.permuteBank
        }
      }).then(function (res) {
        _this6.openBankNos = res.data.data;
      }).catch(function (err) {});
    },
    searchForm: function searchForm() {
      this.formData.pageSize = 10;
      this.formData.pageNo = 1;
      this.getData();
    },
    resetForm: function resetForm() {
      this.$refs['formData'].resetFields();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    addDialog: function addDialog() {
      this.clearAddData();
      this.showAddDialog = true;
    },
    clearAddData: function clearAddData() {
      this.addData = {
        companyCode: null,
        companyName: null,
        originSupplierId: null,
        originSupplierName: null,
        permuteSupplierId: null,
        permuteSupplierName: null,
        permuteBank: null,
        permuteBankAccount: null
      };
    },
    add: function add() {
      var _this7 = this;

      if (!this.addData.company || !this.addData.company.code || !this.addData.company.name || !this.addData.originSupplier || !this.addData.originSupplier.code || !this.addData.originSupplier.name || !this.addData.permuteSupplier || !this.addData.permuteSupplier.code || !this.addData.permuteSupplier.name || !this.addData.permuteBank || !this.addData.permuteBankAccount) {
        alert("参数填写不完整！");
        return;
      }
      var permuteData = {
        companyCode: this.addData.company.code,
        companyName: this.addData.company.name,
        originSupplierId: this.addData.originSupplier.code,
        originSupplierName: this.addData.originSupplier.name,
        permuteSupplierId: this.addData.permuteSupplier.code,
        permuteSupplierName: this.addData.permuteSupplier.name,
        permuteBank: this.addData.permuteBank,
        permuteBankAccount: this.addData.permuteBankAccount
      };
      this.listLoading = true;
      this.$http({
        method: 'POST',
        url: '/rest/supplier-permute/add',
        data: permuteData
      }).then(function (res) {
        _this7.clearAddData();
        _this7.showAddDialog = false;
        _this7.listLoading = false;
        if (res.data.code == '0' && res.data.status == 200) {
          _this7.getData();
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this7, 'success', res, '操作成功');
        } else {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this7, 'error', res, '操作失败，请稍后重试');
        }
      }).catch(function (err) {
        _this7.listLoading = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this7, "error", res, '操作失败');
      });
    },
    close: function close(id) {
      var _this8 = this;

      this.$confirm('是否确认关闭？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.listLoading = true;
        _this8.$http({
          method: "POST",
          url: '/rest/supplier-permute/close',
          params: {
            id: id
          }
        }).then(function (res) {
          _this8.listLoading = false;
          if (res.data.code == '0' && res.data.status == 200) {
            _this8.getData();
            __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this8, 'success', res, '操作成功');
          } else {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this8, 'error', res, '操作失败，请稍后重试');
          }
        }).catch(function (err) {
          _this8.listLoading = false;
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this8, "error", err.response, '操作失败，请稍后重试');
        });
      }).catch(function () {});
    },
    getEditCustomerConfigAuth: function getEditCustomerConfigAuth() {
      var _this9 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/edit-auth'
      }).then(function (res) {
        _this9.editAuth = res.data.data;
      }).catch(function (err) {});
    },
    showEdit: function showEdit(id, company) {
      this.detailConfigId = id;
      this.detailCompany = company;
      this.showDetailDialog = true;
      this.getDetailList(id);
    },
    getDetailList: function getDetailList(id) {
      var _this10 = this;

      this.listLoading = true;
      this.$http({
        method: "GET",
        url: '/rest/supplier-permute/detail-list',
        params: {
          id: id
        }
      }).then(function (res) {
        _this10.listLoading = false;
        if (res.data.code == '0' && res.data.status == 200) {
          _this10.detailsData = res.data.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this10, 'error', res, '操作失败，请稍后重试');
        }
      }).catch(function (err) {
        _this10.listLoading = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this10, "error", err.response, '操作失败，请稍后重试');
      });
    },
    showAddDetail: function showAddDetail(id, currentDetailSupplier) {
      this.currentDetailSupplier = currentDetailSupplier;
      this.clearDetailData();
      this.addDetailData.id = id;
      this.showAddDetailDialog = true;
    },
    searchDetailOpenBanks: function searchDetailOpenBanks() {
      var _this11 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/open-banks',
        params: {
          supplierId: this.addDetailData.permuteSupplier.code
        }
      }).then(function (res) {
        _this11.openBanks = res.data.data;
      }).catch(function (err) {});
    },
    searchDetailOpenBankNos: function searchDetailOpenBankNos() {
      var _this12 = this;

      this.$http({
        method: 'GET',
        url: '/rest/supplier-permute/open-bank-nos',
        params: {
          supplierId: this.addDetailData.permuteSupplier.code,
          openBank: this.addDetailData.permuteBank
        }
      }).then(function (res) {
        _this12.openBankNos = res.data.data;
      }).catch(function (err) {});
    },
    addDetail: function addDetail() {
      var _this13 = this;

      if (!this.addDetailData.id || !this.addDetailData.permuteSupplier || !this.addDetailData.permuteSupplier.code || !this.addDetailData.permuteSupplier.name || !this.addDetailData.permuteBank || !this.addDetailData.permuteBankAccount) {
        alert("参数填写不完整！");
        return;
      }
      var detailData = {
        id: this.addDetailData.id,
        permuteSupplierId: this.addDetailData.permuteSupplier.code,
        permuteSupplierName: this.addDetailData.permuteSupplier.name,
        permuteBank: this.addDetailData.permuteBank,
        permuteBankAccount: this.addDetailData.permuteBankAccount
      };
      this.listLoading = true;
      this.$http({
        method: 'POST',
        url: '/rest/supplier-permute/detail/add',
        data: detailData
      }).then(function (res) {
        _this13.clearDetailData();
        _this13.showAddDialog = false;
        _this13.listLoading = false;
        if (res.data.code == '0' && res.data.status == 200) {
          _this13.showAddDetailDialog = false;
          _this13.getDetailList(_this13.detailConfigId);
          _this13.getData();
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this13, 'success', res, '操作成功');
        } else {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this13, 'error', res, '操作失败，请稍后重试');
        }
      }).catch(function (err) {
        _this13.listLoading = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this13, "error", err.response, '操作失败');
      });
    },
    clearDetailData: function clearDetailData() {
      this.addDetailData = {
        id: null,
        originSupplier: null,
        permuteSupplier: null,
        permuteBank: null,
        permuteBankAccount: null
      };
    },
    showCloseDetail: function showCloseDetail(id) {
      var _this14 = this;

      this.$confirm('是否确认关闭？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this14.listLoading = true;
        _this14.$http({
          method: "POST",
          url: '/rest/supplier-permute/detail/close',
          params: {
            id: id
          }
        }).then(function (res) {
          _this14.listLoading = false;
          if (res.data.code == '0' && res.data.status == 200) {
            _this14.getDetailList(_this14.detailConfigId);
            _this14.getData();
            __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this14, 'success', res, '操作成功');
          } else {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this14, 'error', res, '操作失败，请稍后重试');
          }
        }).catch(function (err) {
          _this14.listLoading = false;
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this14, "error", err.response, '操作失败，请稍后重试');
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "pSLs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login2.380e8a9.png";

/***/ }),

/***/ "pXci":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "pn+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card","lazy":"","id":"Tomd"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.searchType),callback:function ($$v) {_vm.searchType=$$v},expression:"searchType"}},[_c('el-tab-pane',{staticStyle:{"height":"500px"},attrs:{"label":"查认证状态","name":"1"}},[_c('el-row',[_vm._v("选择导入的字段")]),_vm._v(" "),_c('el-row',[_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("身份证号")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("促销员ID")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("手机号")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_vm._v("字段所在列：")]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input-number',{ref:"indexCol",attrs:{"value":_vm.indexCol,"min":1,"size":"medium","step-strictly":"","controls":false},nativeOn:{"input":function($event){return _vm.indexColChange.apply(null, arguments)},"change":function($event){return _vm.indexColChange.apply(null, arguments)}}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"color":"red","margin-left":"60px"},attrs:{"span":4}},[_vm._v("导入的字段在文件中的第几列")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_vm._v("结果所在列：")]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input-number',{ref:"valCol",attrs:{"value":_vm.valCol,"min":1,"size":"medium","step-strictly":"","controls":false},nativeOn:{"input":function($event){return _vm.valColChange.apply(null, arguments)},"change":function($event){return _vm.valColChange.apply(null, arguments)}}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('span',{staticStyle:{"color":"red","margin-left":"60px"}},[_vm._v("查询的结果存在附件的第几列")])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"width":"250px"}},[_c('el-upload',{ref:"upload1",staticClass:"upload-demo",attrs:{"action":_vm.action,"before-remove":_vm.beforeRemove,"limit":1,"auto-upload":false,"on-exceed":_vm.handleExceed,"accept":".xls, .xlsx","before-upload":_vm.beforeUpload,"file-list":_vm.fileList,"on-success":_vm.uploadSuccess,"on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"on-error":_vm.handleError,"disabled":_vm.btnAbled}},[_c('el-button',{attrs:{"slot":"trigger","size":"small","type":"primary","disabled":_vm.btnAbled},slot:"trigger"},[_vm._v("点击上传")]),_vm._v(" "),_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"margin-left":"10px","border":"none"},attrs:{"size":"small","type":"primary","disabled":_vm.showbtn || (_vm.fileList&&_vm.fileList.length===0)},on:{"click":function($event){return _vm.submitUpload('upload1')}}},[_vm._v("导出结果")])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"color":"red"}},[_vm._v("\n      TIPS："),_c('br'),_vm._v("\n      仅支持excel文件导入，且大小不超过25M"),_c('br'),_vm._v("\n      导入文件的第一行视为表头，不做处理"),_c('br'),_vm._v("\n      导入的文件请不要有空行/列，不要有隐藏行/列"),_c('br')])],1),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"height":"500px"},attrs:{"label":"查促销员ID","name":"2"}},[_c('el-row',[_vm._v("选择导入的字段")]),_vm._v(" "),_c('el-row',[_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("身份证号")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("手机号")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_vm._v("字段所在列：")]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input-number',{ref:"indexCol",attrs:{"value":_vm.indexCol,"min":1,"size":"medium","step-strictly":"","controls":false},nativeOn:{"input":function($event){return _vm.indexColChange.apply(null, arguments)},"change":function($event){return _vm.indexColChange.apply(null, arguments)}}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"color":"red","margin-left":"60px"},attrs:{"span":4}},[_vm._v("导入的字段在文件中的第几列")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_vm._v("结果所在列：")]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input-number',{ref:"valCol",attrs:{"min":1,"size":"medium","step-strictly":"","controls":false},nativeOn:{"click":function($event){return _vm.valColChange.apply(null, arguments)},"input":function($event){return _vm.valColChange.apply(null, arguments)},"change":function($event){return _vm.valColChange.apply(null, arguments)}},model:{value:(_vm.valCol),callback:function ($$v) {_vm.valCol=$$v},expression:"valCol"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('span',{staticStyle:{"color":"red","margin-left":"60px"}},[_vm._v("查询的结果存在附件的第几列")])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"width":"250px"}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":_vm.action,"before-remove":_vm.beforeRemove,"limit":1,"auto-upload":false,"on-exceed":_vm.handleExceed,"accept":".xls, .xlsx","before-upload":_vm.beforeUpload,"file-list":_vm.fileList,"on-success":_vm.uploadSuccess,"on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"on-error":_vm.handleError,"disabled":_vm.btnAbled}},[_c('el-button',{attrs:{"slot":"trigger","size":"small","type":"primary","disabled":_vm.btnAbled},slot:"trigger"},[_vm._v("点击上传")]),_vm._v(" "),_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"margin-left":"10px","border":"none"},attrs:{"size":"small","type":"primary","disabled":_vm.showbtn || (_vm.fileList&&_vm.fileList.length===0)},on:{"click":function($event){return _vm.submitUpload('upload')}}},[_vm._v("导出结果")])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"color":"red"}},[_vm._v("\n      TIPS："),_c('br'),_vm._v("\n      仅支持excel文件导入，且大小不超过25M"),_c('br'),_vm._v("\n      导入文件的第一行视为表头，不做处理"),_c('br'),_vm._v("\n      导入的文件请不要有空行/列，不要有隐藏行/列"),_c('br')])],1),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"height":"500px"},attrs:{"label":"查灵工签约状态","name":"3"}},[_c('el-row',[_vm._v("选择导入的字段")]),_vm._v(" "),_c('el-row',[_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("身份证号")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("促销员ID")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"},model:{value:(_vm.indexType),callback:function ($$v) {_vm.indexType=$$v},expression:"indexType"}},[_vm._v("手机号")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_vm._v("签约项目：")]),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择"},on:{"change":function($event){return _vm.changeValue()}},model:{value:(_vm.contract),callback:function ($$v) {_vm.contract=$$v},expression:"contract"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.projectName,"value":item.projectCode}})}),1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_vm._v("字段所在列：")]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input-number',{ref:"indexCol",attrs:{"value":_vm.indexCol,"min":1,"size":"medium","step-strictly":"","controls":false},nativeOn:{"input":function($event){return _vm.indexColChange.apply(null, arguments)},"change":function($event){return _vm.indexColChange.apply(null, arguments)}}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"color":"red","margin-left":"60px"},attrs:{"span":4}},[_vm._v("导入的字段在文件中的第几列")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_vm._v("结果所在列：")]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input-number',{ref:"valCol",attrs:{"min":1,"size":"medium","step-strictly":"","controls":false},nativeOn:{"click":function($event){return _vm.valColChange.apply(null, arguments)},"input":function($event){return _vm.valColChange.apply(null, arguments)},"change":function($event){return _vm.valColChange.apply(null, arguments)}},model:{value:(_vm.valCol),callback:function ($$v) {_vm.valCol=$$v},expression:"valCol"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('span',{staticStyle:{"color":"red","margin-left":"60px"}},[_vm._v("查询的结果存在附件的第几列")])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"width":"250px"}},[_c('el-upload',{ref:"upload2",staticClass:"upload-demo",attrs:{"action":_vm.action,"before-remove":_vm.beforeRemove,"limit":1,"auto-upload":false,"on-exceed":_vm.handleExceed,"accept":".xls, .xlsx","before-upload":_vm.beforeUpload,"file-list":_vm.fileList,"on-success":_vm.uploadSuccess,"on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"on-error":_vm.handleError,"disabled":_vm.btnAbled}},[_c('el-button',{attrs:{"slot":"trigger","size":"small","type":"primary","disabled":_vm.btnAbled},slot:"trigger"},[_vm._v("点击上传")]),_vm._v(" "),_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"margin-left":"10px","border":"none"},attrs:{"size":"small","type":"primary","disabled":_vm.showbtn || (_vm.fileList&&_vm.fileList.length===0)},on:{"click":function($event){return _vm.submitUpload('upload2')}}},[_vm._v("导出结果")])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"color":"red"}},[_vm._v("\n      TIPS："),_c('br'),_vm._v("\n      仅支持excel文件导入，且大小不超过25M"),_c('br'),_vm._v("\n      导入文件的第一行视为表头，不做处理"),_c('br'),_vm._v("\n      导入的文件请不要有空行/列，不要有隐藏行/列"),_c('br')])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q/7T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/idCardBack-demo.29b3dc9.png";

/***/ }),

/***/ "qGYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"JiFenWrap"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"filterTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.scoreArr,"size":"small","border":""}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"masterName","label":"指标","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"score","label":"分数","align":"center"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thisTitle"},[_c('span',{staticClass:"thisIcon"},[_c('img',{attrs:{"src":__webpack_require__("fsa8"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("积分")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qIXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("p+2c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce8b1bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("VTob");
function injectStyle (ssrContext) {
  __webpack_require__("YWNm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ce8b1bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce8b1bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qIbC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      num: 1,
      dataList: null,
      workPosId: null,
      //编辑页信息
      jobInformation: {
        jobName: null,
        jobType: null,
        serviceObj: null,
        dateType: null,
        jobDescription: null,
        salaryTreatment: null,
        sex: null,
        salarySettlement: null,
        salary: null,
        visable: [],
        monthSalary: '',
        otherPosDetail: '', // 其他任务说明
        otherRequirements: '' // 其他任务要求
      },
      proStartTime: '', //岗位绑定的项目的起止时间，仅用作比较
      proEndTime: '',
      //工作类型
      jobTypeOptions: [{ id: 0, jobType: "不限" }, { id: 1, jobType: "长促" }, { id: 2, jobType: "短促" }],
      dateTypeOptions: [], //档期类型
      //性别
      sexOptions: [{ id: 0, sex: "不限" }, { id: 1, sex: "男" }, { id: 2, sex: "女" }],
      salarySettlementOptions: [],
      //计划人数
      plan: {
        number: null,
        applyNumber: null,
        startTime: null,
        endTime: null,
        Remarks: null
      },
      starRatingOptions: [],
      //再次推送弹窗
      innerVisible: false,
      //添加促销员弹窗
      innerVisible2: false,
      //添加标签弹窗
      innerVisible3: false,
      //制定促销员推送
      checkedPromoters: false,
      //指定标签推送
      checkedSign: false,
      //已选择得促销员
      PromotersArr: [],
      /*
      以下是标签相关，一共3级
      */
      //已选择的标签-1级
      //已选择行业品类
      array1: [],
      //已选择岗位类型
      array2: [],
      //已选择自我标签
      array3: [],
      //已选择标签--2级
      SignArr: {
        array_1: [],
        array_2: [],
        array_3: []
      },
      //已选择标签-3级
      SignArr2: {
        array_1: [],
        array_2: [],
        array_3: []
      },
      //所有的标签，用作map对照，同时也作为-3级页的展示和choosen
      SignPopUp: {
        checkboxGroup: [],
        //行业品类
        tabsData: [],
        //岗位类型
        tabsData2: [],
        //自我标签
        tabsData3: []
      },
      onceTime: true, //chooseSign方法中，作为只执行一次的函数的标志位
      /*
      以上是标签相关，一共3级
      */
      //添加促销员筛选项
      PromotersPopUp: {
        name: null,
        idCard: null,
        minAge: null,
        maxAge: null,
        minHeight: null,
        maxHeight: null,
        empCode: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      //添加促销员表格
      tableData: [],

      judgeInterview: null, //首页岗位薪水可修改状态
      storeCode: null, //storecode
      loading: false, //编辑岗位页loading
      posLoading: false, //推送管理页loading
      tableLoading: false, //推送管理-选择促销员页的tableloading
      isckeckPromotersList: [], //选择的促销员-2级
      isckeckPromotersList2: [], //选择的促销员-3级
      bluring: false,
      hasError: false, //和bluring一起，确保两轮校验不冲突且不遗漏
      planHasError: false, //和bluring一起，确保两轮校验不冲突且不遗漏
      infoHasError: false, //和bluring一起，确保两轮校验不冲突且不遗漏
      dataReady: {
        getIndustryLabel: false,
        getJobLabel: false,
        getSelfLabel: false,
        searchMasterName1: false,
        searchMasterName2: false,
        searchRankRuleName: false,
        searchJudgeInterview: false
      },

      taskInstructionsSigns1: [], //任务说明
      taskInstructionsSigns1V: [],
      taskInstructionsSigns2: [], //任务要求
      taskInstructionsSigns2V: []
    };
  },

  props: ["Child"],
  mounted: function mounted() {
    this.getIndustryLabel(); // 获取行业类型二级标签
    this.getJobLabel(); // 获取岗位标签
    this.getSelfLabel(); // 获取自我标签
    this.searchMasterName1(); //获取档期类型数据
    this.searchMasterName2(); //获取结算方式数据
    this.searchRankRuleName(); //获取星级
    this.searchJudgeInterview(); //获取是否可以编辑
    //由于getdata会用到前面几个请求的数据，可能还没回调呢，getdata就开始执行了
    //所以加了个watch，只有前面4个同时执行完毕后才调用getdata

    this.getTaskInstructionsSigns();
    this.getTaskInstructionsSigns2();
  },

  methods: {
    //删掉会报错。。。。。
    aaa: function aaa() {},

    //工具类，弹框简写
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },

    //工具类，把数据转换成传输用的id形式
    transDataToId: function transDataToId(which) {
      var _this2 = this;

      var toId = {};
      //把档期类型转换为id格式
      if (which.scheduleType) {
        this.dateTypeOptions.map(function (item) {
          if (item.masterName == _this2.jobInformation.dateType) {
            toId.scheduleType = item.id;
          }
        });
      }
      //把可见范围星级转换为id格式
      if (which.rankRuleId) {
        this.starRatingOptions.map(function (item) {
          if (item.rankName == _this2.jobInformation.starRating) {
            toId.rankRuleId = item.id;
          }
        });
      }
      //把岗位类型转换为id格式(长短促)
      if (which.signId) {
        this.jobTypeOptions.map(function (item) {
          if (_this2.jobInformation.jobType == item.signName) {
            toId.signId = item.id;
          }
        });
      }
      //把性别要求转换为id格式
      if (which.sex) {
        this.sexOptions.map(function (item) {
          if (_this2.jobInformation.sex == item.sex) {
            toId.sex = item.id;
          }
        });
      }
      //把结算方式周期转换为id格式
      if (which.salaryCycle) {
        this.salarySettlementOptions.map(function (item) {
          if (_this2.jobInformation.salarySettlement == item.masterName) {
            toId.salaryCycle = item.id;
          }
        });
      }
      //把可见范围-粉丝会员转换为id格式
      if (which.searchType) {
        if (this.jobInformation.visable.length == 2) {
          toId.searchType = 0;
        } else if (this.jobInformation.visable.length == 0) {
          toId.searchType = '';
        } else if (this.jobInformation.visable.length == 1) {
          if (this.jobInformation.visable[0] == "粉丝") {
            toId.searchType = 1;
          } else if (this.jobInformation.visable[0] == "会员") {
            toId.searchType = 2;
          }
        }
      }
      //
      return toId;
    },

    //工具类-blur时校验岗位信息
    checkValue: function checkValue(val, type) {
      var _this3 = this;

      this.bluring = true;
      setTimeout(function () {
        _this3.bluring = false;
      }, 100);
      var errMsg = "";
      switch (type) {
        //case '任务名称' || '项目客户' || '任务说明' || '薪资待遇' || '岗位福利' || '岗位要求':
        case '任务名称':
          if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(val)) {
            errMsg = '\u8BF7\u8F93\u5165' + type;
          }
          break;
        case '督导电话':
          if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(val)) {
            errMsg = '\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u65B9\u5F0F';
          } else if (isNaN(val)) {
            errMsg = "请输入数字类型!";
          } else if (!/^1[345789]\d{9}$/.test(val) && !/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/.test(val)) {
            errMsg = "请输入正确的电话号!";
          }
          break;
        case "联系人方式":
          //跟督导电话一样，但现在不用了
          break;
        case "计划人数" || "招聘人数":
          if (isNaN(val)) {
            errMsg = "请输入数字类型!";
          } else if (val < 0) {
            errMsg = "请输入正确的人数!";
          }
          break;
        case "分值下限" || '岗位薪水':
          if (val < 0) {
            errMsg = type + '\u4E0D\u53EF\u4EE5\u5C0F\u4E8E0!';
          } else if (isNaN(val)) {
            errMsg = "请输入数字类型!";
          }
          /*        关于区间上限的判断暂时不需要
          else if (
            this.jobInformation.scoreIntervalEnd != null &&
            this.jobInformation.scoreIntervalEnd != "" &&
            this.jobInformation.scoreIntervalEnd != undefined
          ) {
            if (val > this.jobInformation.scoreIntervalEnd) {
              errMsg = "分值区间有误!";
            }
          }*/
          break;
        /*      上限分值的判断暂时不需要
        else if (type == "endScore") {
          if (val == null || val == "" || val == undefined) {
            errMsg = `请输入分值!`;
          } else if(isNaN(val)){
            errMsg = "请输入数字类型!";
          } else if(this.jobInformation.scoreIntervalEnd < 0){
            errMsg = `分值区间不可以小于0!`
          } else if (
            this.jobInformation.scoreIntervalStart != null &&
            this.jobInformation.scoreIntervalStart != "" &&
            this.jobInformation.scoreIntervalStart != undefined
          ) {
            if (val < this.jobInformation.scoreIntervalStart) {
              errMsg = "分值区间有误!";
            }
          }
        }*/
      }
      // console.log('checkValue_errMsg',errMsg)
      if (errMsg != "") {
        this.myNotify(this, 'warning', errMsg);
        this.hasError = true;
      } else {
        this.hasError = false;
      }
    },

    //工具类-校验招聘设置表单
    checkPlans: function checkPlans(plan) {
      var errMsg = "";
      if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(plan.number)) {
        errMsg = "请填写计划人数";
      } else if (plan.number < 0) {
        errMsg = "计划人数不能小于0";
      } else if (isNaN(plan.number)) {
        errMsg = "计划人数请填写数字";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(plan.applyNumber)) {
        errMsg = "请填写招聘人数";
      } else if (plan.applyNumber < 0) {
        errMsg = "招聘人数不能小于0";
      } else if (isNaN(plan.applyNumber)) {
        errMsg = "招聘人数请填写数字";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(plan.startTime)) {
        errMsg = "请填写开始时间";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(plan.endTime)) {
        errMsg = "请填写结束时间";
      } else if (new Date(plan.startTime).getTime() > new Date(plan.endTime).getTime()) {
        errMsg = "开始时间应小于结束时间";
      } else {
        var time = {
          proStartT: new Date(this.proStartTime).getTime(),
          proEndT: new Date(this.proEndTime).getTime(),
          publishStart: new Date(this.plan.startTime).getTime(),
          publishEnd: new Date(this.plan.endTime).getTime()
        };
        if (time.publishEnd < time.publishStart) {
          errMsg = '开始时间应小于结束时间';
        } else if (time.publishEnd > time.proEndT) {
          errMsg = '岗位结束时间应在项目时间范围内';
        } else if (time.publishStart < time.proStartT) {
          errMsg = '岗位开始时间应在项目时间范围内';
        }
      }

      if (errMsg != "") {
        this.myNotify(this, 'warning', errMsg);
        this.planHasError = true;
      } else {
        this.planHasError = false;
      }
    },

    //工具类-检验岗位信息表单
    checkValues: function checkValues(jobInfo) {
      var errMsg = "";
      if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(jobInfo.jobName)) {
        errMsg = "请输入任务名称";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(jobInfo.jobType)) {
        errMsg = "请选择岗位类型";
        // } else if (utils.bool(jobInfo.serviceObj)) {
        //   errMsg = "请输入项目客户";
        // } else if (utils.bool(jobInfo.dateType)) {
        //   errMsg = "请选择档期类型";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(jobInfo.jobDescription)) {
        errMsg = "请输入任务说明";
        // } else if (utils.bool(jobInfo.salaryTreatment)) {
        //   errMsg = "请输入薪资待遇";
        // } else if (utils.bool(jobInfo.postWelfare)) {
        //   errMsg = "请输入岗位福利";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(jobInfo.jobRequirements)) {
        errMsg = "请输入任务要求";
        // } else if (utils.bool(jobInfo.salary)) {
        //   errMsg = "请选择岗位薪水";
        // } else if (utils.bool(jobInfo.monthSalary) && this.jobInformation.salary != 3) {
        //   errMsg = "请填写岗位薪水";
        // } else if (isNaN(jobInfo.monthSalary) || jobInfo.monthSalary < 0) {
        //   errMsg = "请输入正确岗位薪水"
        // } else if (utils.bool(jobInfo.salarySettlement)) {
        //   errMsg = "请选择结算方式";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(jobInfo.sex)) {
        errMsg = "请选择性别要求";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(jobInfo.supervisorName)) {
        errMsg = "请输入联系人姓名";
      } else if (__WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].bool(jobInfo.supervisorTel)) {
        errMsg = "请输入联系人电话";
      } else if (isNaN(jobInfo.supervisorTel)) {
        errMsg = "请输入数字类型!";
      } else if (!/^1[345789]\d{9}$/.test(jobInfo.supervisorTel) && !/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/.test(jobInfo.supervisorTel)) {
        errMsg = "请输入正确的电话号!";
      } /* else if (utils.bool(jobInfo.contactMethod)        ) {
         errMsg = "请输入联系人方式";
        } else if (typeof jobInfo.contactMethod !== "number") {
         errMsg = "请输入数字类型!";
        } else if (!/^1[34578]\d{9}$/.test(jobInfo.contactMethod)) {
         errMsg = "请输入正确的电话号!";
        } */ /*else if (utils.bool(jobInfo.scoreIntervalStart)/!*||utils.bool(jobInfo.scoreIntervalEnd)*!/) {
             errMsg = "请输入分值";
             } */else if (isNaN(jobInfo.scoreIntervalStart) || jobInfo.scoreIntervalStart < 0 /*||isNaN(jobInfo.scoreIntervalEnd)*/) {
            errMsg = "请输入正确的分值";
          } else if (!this.jobInformation.visable || this.jobInformation.visable.length == 0) {
          errMsg = '请选择粉丝可见或会员可见！';
        } else if (jobInfo.jobDescription.split(';').includes('其他') && !jobInfo.otherPosDetail) {
          errMsg = '请填写任务说明！';
        } else if (jobInfo.jobRequirements.split(';').includes('其他') && !jobInfo.otherRequirements) {
          errMsg = '请填写任务要求！';
        }
      /* else if (        jobInfo.scoreIntervalStart > jobInfo.scoreIntervalEnd      ) {
        errMsg = "分值区间有误!";
      }*/
      // console.log('checkValues_errMsg',errMsg)
      if (errMsg != "") {
        this.myNotify(this, 'warning', errMsg);
        this.infoHasError = true;
      } else {
        this.infoHasError = false;
      }
    },

    //工具类-再次推送-选择促销员-检查身份证
    checkIdCard: function checkIdCard() {
      var re = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      if (re.test(this.PromotersPopUp.idCard) == false && this.PromotersPopUp.idCard != "") {
        this.myNotify(this, 'warning', '请输入正确身份证号');
      }
    },

    //工具类-身份证号格式化
    formatIdCard: function formatIdCard(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
    },

    //工具类-电话号码格式化
    formatTel: function formatTel(row, column, cellValue) {
      return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 3, 4);
    },


    //getData方法专用：去除loading
    stopLoading: function stopLoading(x) {
      if (x.findWorkSign && x.moreStoreAndPosMessage) this.loading = false;
    },

    //本组件-获取详细信息
    getData: function getData() {
      var _this4 = this;

      this.loading = true;
      var x = {
        moreStoreAndPosMessage: false,
        findWorkSign: false

        //获取标签推送设定
      };{
        this.$http({
          method: "GET",
          url: "/rest/PostManagement/findWorkSign",
          params: {
            'workPosId': this.Child[0].workPosId
          }
        }).then(function (res) {
          //返回一个数组，所有推送的id
          res.data.map(function (item) {
            if (item == -2) {
              //如果-2的话，说明行业品类选择了不限，这里手动选择一下
              _this4.SignPopUp.tabsData[0].choose = true;
              _this4.array1.push(_this4.SignPopUp.tabsData[0]);
            } else if (item == -3) {
              //如果-3的话，说明自我标签选择了不限，这里手动选择一下
              _this4.SignPopUp.tabsData3[0].choose = true;
              _this4.array3.push(_this4.SignPopUp.tabsData3[0]);
            } else {
              //这里可以break或者return提高性能，先不做了
              //map行业品类的总数据，并保存
              _this4.SignPopUp.tabsData.map(function (item1) {
                if (item == item1.id) {
                  _this4.array1.push(item1);
                  item1.choose = true;
                }
              });
              //map岗位类型的总数据，并保存
              _this4.SignPopUp.tabsData2.map(function (item1) {
                if (item == item1.id) {
                  _this4.array2.push(item1);
                  item1.choose = true;
                }
              });
              //map自我标签的总数据，并保存
              _this4.SignPopUp.tabsData3.map(function (item1) {
                if (item == item1.id) {
                  _this4.array3.push(item1);
                  item1.choose = true;
                }
              });
            }
          });
          //强制顺序的代码，没啥别的作用
          x.findWorkSign = true;
          _this4.stopLoading(x);
        }).catch(function (err) {
          x.findWorkSign = true;
          _this4.stopLoading(x);
          _this4.myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
        });
      }
      //获取岗位数据
      {
        this.$http({
          method: "GET",
          url: "/rest/PostManagement/moreStoreAndPosMessage",
          params: {
            posStoreId: this.Child[0].posStoreId
          }
        }).then(function (res) {
          var data = res.data;
          _this4.proStartTime = data.projectStartTime;
          _this4.proEndTime = data.projectEndTime;
          _this4.storeCode = data.storeCode;
          // this.workPosId = data.workPosId;//这里是异步的，不能在这里赋值，下一步操作太快，获取不到数据
          _this4.jobInformation.jobName = data.posName;
          _this4.jobInformation.jobDescription = data.posDetail;

          _this4.jobInformation.salaryTreatment = data.salaryDetail;
          _this4.jobInformation.postWelfare = data.welfareDetail;
          _this4.jobInformation.jobRequirements = data.requirements;
          // 处理任务说明/任务要求，按';'拆分
          _this4.anTaskInstructionsSigns(data.posDetail, data.requirements);

          _this4.jobInformation.supervisorName = data.moName;
          _this4.jobInformation.supervisorTel = data.moTel;
          _this4.jobInformation.contactMethod = data.requirementsTel;
          _this4.jobInformation.monthSalary = data.salary;
          _this4.jobInformation.otherPosDetail = data.otherPosDetail;
          _this4.jobInformation.otherRequirements = data.otherRequirements;
          _this4.plan.number = data.planNumber;
          if (_this4.plan.number == null) {
            _this4.plan.number = 0;
          }
          _this4.plan.applyNumber = data.recruitsNumber;
          _this4.plan.startTime = data.requirementsStart;
          _this4.plan.endTime = data.requirementsEnd;
          _this4.plan.Remarks = data.remark;
          _this4.jobInformation.scoreIntervalStart = data.crescoreMin;
          // this.jobInformation.scoreIntervalEnd = data.crescoreMax;
          // 180713铎哥说用户还没想好可见范围这块怎么做，所以先隐藏掉
          //这里是必填项会影响到校验和后台可见逻辑，所以强制设置为全选
          _this4.jobInformation.visable = ['粉丝', '会员'];
          // if (data.searchType == 1) {
          //   this.jobInformation.visable = ['粉丝']
          // } else if (data.searchType == 2) {
          //   this.jobInformation.visable = ['会员']
          // } else if (data.searchType == 0) {
          //   this.jobInformation.visable = ['粉丝', '会员']
          // } else {
          //   this.jobInformation.visable = []
          // }
          _this4.jobInformation.serviceObj = data.customer;

          // this.jobInformation.dateType = data.scheduleType;
          _this4.salarySettlementOptions.map(function (item) {
            if (item.id == data.salaryCycle) {
              _this4.jobInformation.salarySettlement = item.masterName;
            }
          });
          _this4.dateTypeOptions.map(function (item, index) {
            if (item.id == data.scheduleType) {
              _this4.jobInformation.dateType = item.masterName;
            }
          });
          _this4.starRatingOptions.map(function (item) {
            if (item.id == data.rankRuleId) {
              _this4.jobInformation.starRating = item.rankName;
            }
          });
          _this4.jobTypeOptions.map(function (item) {
            if (item.id == data.signId) {
              _this4.jobInformation.jobType = item.signName;
            }
          });
          _this4.sexOptions.map(function (item) {
            if (item.id == data.sex) {
              _this4.jobInformation.sex = item.sex;
            }
          });

          _this4.jobInformation.salary = String(data.salaryType);

          x.moreStoreAndPosMessage = true;
          _this4.stopLoading(x);
        }).catch(function (err) {
          _this4.myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');

          x.moreStoreAndPosMessage = true;
          _this4.stopLoading(x);
        });
      }
      this.dataList = this.Child[0];
    },

    // 解析任务说明，任务要求字符串变复选框显示问题,v1任务说明，v2任务要求
    anTaskInstructionsSigns: function anTaskInstructionsSigns(v1, v2) {
      var self = this;
      // 处理任务说明，按';'拆分
      var v1A = v1.split(";");
      for (var i in v1A) {
        console.log(i, v1A[i]);
        for (var j in self.taskInstructionsSigns1) {
          if (v1A[i] === self.taskInstructionsSigns1[j]) {
            self.taskInstructionsSigns1V.push(v1A[i]);
          }
        }
      }
      console.log('1---->>', self.taskInstructionsSigns1V);

      // 处理任务要求，按';'拆分
      var v2A = v2.split(";");
      for (var _i in v2A) {
        console.log(_i, v2A[_i]);
        for (var _j in self.taskInstructionsSigns2) {
          if (v2A[_i] === self.taskInstructionsSigns2[_j]) {
            self.taskInstructionsSigns2V.push(v2A[_i]);
          }
        }
      }
      console.log('2---->>', self.taskInstructionsSigns2V);
    },

    //本组件-点击确定（保存本岗位）
    submit: function submit() {
      var _this5 = this;

      var idData = this.transDataToId({
        scheduleType: true,
        rankRuleId: true,
        signId: true,
        sex: true,
        salaryCycle: true,
        searchType: true
      });
      if (!this.hasError || !this.bluring) {
        console.log('进入校验');
        this.jobInformation.jobDescription = this.taskInstructionsSigns1V.join(";");
        this.jobInformation.jobRequirements = this.taskInstructionsSigns2V.join(";");

        this.checkValues(this.jobInformation);
        this.checkPlans(this.plan);
      }

      if (this.hasError || this.infoHasError || this.planHasError) {
        return false;
      } else {
        this.loading = true;
        this.$http({
          method: "POST",
          url: "/rest/PostManagement/updatePosSTore",
          data: {
            posStoreId: this.dataList.posStoreId,
            workPosId: this.Child[0].workPosId,
            posName: this.jobInformation.jobName,
            signId: idData.signId,
            customer: this.jobInformation.serviceObj,
            scheduleType: idData.scheduleType,
            posDetail: this.jobInformation.jobDescription,
            salaryDetail: this.jobInformation.salaryTreatment,
            welfareDetail: this.jobInformation.postWelfare,
            requirements: this.jobInformation.jobRequirements,
            salaryCycle: idData.salaryCycle,
            salary: this.jobInformation.monthSalary,
            salaryType: Number(this.jobInformation.salary),
            moName: this.jobInformation.supervisorName,
            moTel: this.jobInformation.supervisorTel,
            requirementsTel: this.jobInformation.contactMethod,
            otherPosDetail: this.jobInformation.otherPosDetail,
            otherRequirements: this.jobInformation.otherRequirements,
            searchType: idData.searchType,

            publishUserId: sessionStorage.getItem('sysUserId'),
            rankRuleId: idData.rankRuleId,
            sex: idData.sex,
            // workCode: "string",
            requirementsStart: this.plan.startTime,
            requirementsEnd: this.plan.endTime,
            recruitsNumber: this.plan.applyNumber,
            remark: this.plan.Remarks,

            planNumber: this.plan.number,

            /*crescoreMax: this.jobInformation.scoreIntervalEnd,*/
            crescoreMin: this.jobInformation.scoreIntervalStart
          }
        }).then(function (res) {
          _this5.myNotify(_this5, 'success', '更新成功');
          _this5.loading = false;
          _this5.$emit('submitForm'); //成功后后台数据变了，但页面上的数据不会变更，主动触发父级的‘筛选’按钮事件，以更新视图
          _this5.$emit("upupup", false); //主动触发upupup方法，'hehe'为向父组件传递的数据
        }).catch(function (err) {
          _this5.loading = false;
          _this5.myNotify(_this5, 'error', err.response, '查询失败，请稍后重试');
        });
      }
    },

    //本组件-点击再次推送
    alignSubmit: function alignSubmit() {
      var _this6 = this;

      var _loop = function _loop(i) {
        _this6.SignArr['array_' + i] = [];
        _this6['array' + i].map(function (item) {
          _this6.SignArr['array_' + i].push(item);
        });
      };

      // 点再次推送的时候，从array123获取值
      for (var i = 1; i < 4; i++) {
        _loop(i);
      }
      // console.log('选中的标签', this.SignArr)
      //推送设定：如果有则自动显示选了啥否则啥也不显示
      this.checkedSign = this.SignArr.array_1.length != 0 || this.SignArr.array_2.length != 0 || this.SignArr.array_3.length != 0;
      this.checkedPromoters = false;
      this.isckeckPromotersList = []; //这里要么第一次进来，要么点了取消再回来，肯定要置空
      //如果blur没发现错误，或者不是blur+click情况
      if (!this.hasError || !this.bluring) {
        this.jobInformation.jobDescription = this.taskInstructionsSigns1V.join(";");
        this.jobInformation.jobRequirements = this.taskInstructionsSigns2V.join(";");

        this.checkValues(this.jobInformation);
        this.checkPlans(this.plan);
      }
      //如果info和plan校验发现错误
      if (this.hasError || this.infoHasError || this.planHasError) {
        return false;
      } else {
        this.innerVisible = true;
      }
    },

    //本组件-点击取消
    cancel: function cancel() {
      this.$emit("upupup", false); //主动触发upup方法，'hehe'为向父组件传递的数据，意思是从父级关闭本对话框
    },

    // 获取行业类型二级标签-总数据
    getIndustryLabel: function getIndustryLabel() {
      var _this7 = this;

      this.dataReady.getIndustryLabel = false;
      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchIndustrySignName',
        params: {
          signType: 1,
          signLevel: 2
        }
      }).then(function (res) {
        res.data.map(function (item) {
          item.choose = false;
        });
        var data = res.data;
        _this7.SignPopUp.tabsData = data;
        //行业品类的不限，后台不给返回，需要自己追加
        _this7.SignPopUp.tabsData.unshift({
          choose: false,
          id: -2,
          signName: '不限'
        });
        _this7.dataReady.getIndustryLabel = true;
      }).catch(function (err) {
        _this7.myNotify(_this7, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取岗位标签-总数据
    getJobLabel: function getJobLabel() {
      var _this8 = this;

      this.dataReady.getJobLabel = false;
      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchSignName',
        params: {
          signType: 2
        }
      }).then(function (res) {
        _this8.jobTypeOptions = res.data;
        res.data.map(function (item) {
          item.choose = false;
        });
        _this8.SignPopUp.tabsData2 = res.data;
        _this8.dataReady.getJobLabel = true;
      }).catch(function (err) {
        _this8.myNotify(_this8, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取自我标签-总数据
    getSelfLabel: function getSelfLabel() {
      var _this9 = this;

      this.dataReady.getSelfLabel = false;
      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchSignName',
        params: {
          signType: 3
        }
      }).then(function (res) {
        res.data.map(function (item) {
          item.choose = false;
        });
        var data = res.data;
        _this9.SignPopUp.tabsData3 = data;
        //后台不会返自我标签的不限，需要自己追加
        _this9.SignPopUp.tabsData3.unshift({
          choose: false,
          id: -3,
          signName: '不限'
        });
        _this9.dataReady.getSelfLabel = true;
      }).catch(function (err) {
        _this9.myNotify(_this9, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //获取档期类型-总数据
    searchMasterName1: function searchMasterName1() {
      var _this10 = this;

      this.dataReady.searchMasterName1 = false;
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchMasterName",
        params: {
          masterCode: "SCHEDULE_TYPE"
        }
      }).then(function (res) {
        _this10.dateTypeOptions = res.data;
      }).catch(function (err) {
        _this10.myNotify(_this10, 'error', err.response, '查询失败，请稍后重试');
      });
      this.dataReady.searchMasterName1 = true;
    },

    //获取结算方式-总数据
    searchMasterName2: function searchMasterName2() {
      var _this11 = this;

      this.dataReady.searchMasterName2 = false;
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchMasterName",
        params: {
          masterCode: "SALARY_CYCLE"
        }
      }).then(function (res) {
        _this11.dataReady.searchMasterName2 = true;
        _this11.salarySettlementOptions = res.data;
      }).catch(function (err) {
        _this11.myNotify(_this11, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //星级查询-总数据
    searchRankRuleName: function searchRankRuleName() {
      var _this12 = this;

      this.dataReady.searchRankRuleName = false;
      this.$http({
        method: "GET",
        url: "/rest/PublishedWork/searchRankRuleName"
      }).then(function (res) {
        _this12.starRatingOptions = res.data;
        _this12.dataReady.searchRankRuleName = true;
      }).catch(function (err) {
        _this12.myNotify(_this12, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //查看该页薪资部分 是否可修改
    searchJudgeInterview: function searchJudgeInterview() {
      var _this13 = this;

      this.dataReady.searchJudgeInterview = false;
      this.$http({
        method: "GET",
        url: "/rest/PostManagement/judgeInterview",
        params: { posStoreId: this.Child[0].posStoreId }
      }).then(function (res) {
        _this13.judgeInterview = res.data.message;
        _this13.dataReady.searchJudgeInterview = true;
      }).catch(function (err) {
        _this13.myNotify(_this13, 'error', err.response, '查询失败，请稍后重试');
      });
    },


    //搜索促销员
    searchSaleManInfo: function searchSaleManInfo(jumpPage) {
      var _this14 = this;

      var idData = this.transDataToId({
        // scheduleType:true,
        // rankRuleId:true,
        // signId:true,
        sex: true,
        // salaryCycle:true,
        searchType: true
      });
      if (jumpPage != 'jumpPage') {
        this.PromotersPopUp.pageNo = 1;
      }
      this.tableLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/PublishedWork/searchSalesmans",
        data: {
          name: this.PromotersPopUp.name,
          idcard: this.PromotersPopUp.idCard,
          ageMin: this.PromotersPopUp.minAge,
          ageMax: this.PromotersPopUp.maxAge,
          heightMin: this.PromotersPopUp.minHeight,
          heightMax: this.PromotersPopUp.maxHeight,
          empCode: this.PromotersPopUp.empCode,
          pageNo: this.PromotersPopUp.pageNo,
          pageSize: this.PromotersPopUp.pageSize,
          projectStartTime: this.plan.startTime,
          dto: {
            // crescoreMin: this.jobInformation.scoreIntervalStart,
            crescoreMin: null,
            // crescoreMax: this.jobInformation.scoreIntervalEnd,
            crescoreMax: null,
            searchType: idData.searchType,
            // searchType: 0,
            storeCode: this.storeCode,
            // rankRuleId: this.jobInformation.rankRuleId,
            // rankRuleId: null,
            sex: idData.sex
          }
        }
      }).then(function (res) {
        _this14.tableData = res.data.salesmanList;
        _this14.PromotersPopUp.total = res.data.countSize;
        _this14.tableLoading = false;

        //创建一个id数组，方便查询
        var salesManIds = [];
        _this14.isckeckPromotersList2.map(function (item) {
          salesManIds.push(item.id);
        });
        //如果是在id数组中的，则选中
        setTimeout(function (salesManIds) {
          _this14.tableData.map(function (item) {
            if (salesManIds.indexOf(item.id) > -1) {
              _this14.$refs.salesmuli.toggleRowSelection(item, true);
            }
          });
        }, 50, salesManIds);
      }).catch(function (err) {
        _this14.myNotify(_this14, 'error', err.response, '查询失败，请稍后重试');
        _this14.tableLoading = false;
      });
    },

    //促销员2级页-单个删除
    deleteLabel: function deleteLabel(index) {
      this.isckeckPromotersList.splice(index, 1);
      if (this.isckeckPromotersList.length == 0) {
        this.checkedPromoters = false;
      }
    },

    //选择促销员，2级进入3级
    choosePromoters: function choosePromoters() {
      var _this15 = this;

      //先重置
      this.tableData = [];
      this.PromotersPopUp.total = null;

      this.innerVisible = false;
      this.innerVisible2 = true;
      //把2级的数据复制给3级
      this.isckeckPromotersList2 = [];
      this.isckeckPromotersList.map(function (item) {
        _this15.isckeckPromotersList2.push(item);
      });
      //清空筛选项
      this.PromotersPopUp.name = null;
      this.PromotersPopUp.idCard = null;
      this.PromotersPopUp.minAge = null;
      this.PromotersPopUp.maxAge = null;
      this.PromotersPopUp.minHeight = null;
      this.PromotersPopUp.maxHeight = null;
      //之前进来就获取数据，现在要求进去后点筛选才搜索
      //然后筛选
      // this.searchSaleManInfo('doNotJump');
    },

    //促销员3级页点击取消
    changeInnerVisible2: function changeInnerVisible2() {
      this.innerVisible = true;
      this.innerVisible2 = false;
    },

    //促销员3级页点击确定
    sureSaleMan: function sureSaleMan() {
      var _this16 = this;

      this.innerVisible = true;
      this.innerVisible2 = false;
      //把3级的数据复制给2级
      this.isckeckPromotersList = [];
      this.isckeckPromotersList2.map(function (item) {
        _this16.isckeckPromotersList.push(item);
      });
    },

    //促销员3级页-table check或取消
    selectChange: function selectChange(selection, row) {
      // selection是所有选中的行，row是当前被点击的行
      var add = false; //如果是新增的则是true，否则是false
      selection.map(function (item) {
        if (row.id == item.id) {
          add = true;
        }
      });
      if (add) {
        this.isckeckPromotersList2.push(row);
      } else {
        //这里用for循环break可以提高性能
        this.isckeckPromotersList2.map(function (item, index, arr) {
          if (row.id == item.id) {
            arr.splice(index, 1); //只删一次，所以可以用arr + splice
          }
        });
      }
      // console.log(selection,row)
    },

    //促销员3级页-table 全选或取消
    selectAllChange: function selectAllChange(selection) {
      var _this17 = this;

      //如果是全选中
      if (selection.length == this.tableData.length) {
        var ids = [];
        this.isckeckPromotersList2.map(function (item) {
          ids.push(item.id);
        });
        selection.map(function (item) {
          if (ids.indexOf(item.id) < 0) {
            _this17.isckeckPromotersList2.push(item);
          }
        });
      } else {
        //如果是“取消全选”
        var delArr = [];
        this.tableData.map(function (item) {
          _this17.isckeckPromotersList2.map(function (item2, index) {
            if (item.id == item2.id) {
              delArr.unshift(index);
            }
          });
        });
        delArr.map(function (item) {
          _this17.isckeckPromotersList2.splice(item, 1);
        });
      }
    },

    //促销员3级页面-单个促销员删除
    deleteLabel2: function deleteLabel2(index) {
      var _this18 = this;

      var item = this.isckeckPromotersList2[index];
      this.tableData.map(function (item1) {
        if (item.id == item1.id) {
          _this18.$refs.salesmuli.toggleRowSelection(item1, false);
        }
      }, 0);
      this.isckeckPromotersList2.splice(index, 1);
    },

    //促销员3级页面-更改页面大小
    handleSizeChange: function handleSizeChange(value) {
      this.PromotersPopUp.pageSize = value;
      this.searchSaleManInfo('doNotJump');
    },

    //促销员3级页面-更改页码
    handleCurrentChange: function handleCurrentChange(value) {
      this.PromotersPopUp.pageNo = value;
      this.searchSaleManInfo('jumpPage');
    },


    /*
    推送管理标签分3级，注意数据互通的逻辑
    1级：array123
    2级：SignArr
    3级：SignArr2
    贯通级：SignPopUp,主要用于第3级
    */
    //推送管理（2级）点击选择标签弹出3级
    chooseSign: function chooseSign() {
      var _this19 = this;

      this.innerVisible = false;
      this.innerVisible3 = true;
      //把2级页的标签数据配给3级
      var arr = this.SignArr;
      var arr2 = this.SignArr2;
      var ids = {
        arr1: [],
        arr2: [],
        arr3: []
      };
      var SignPopUp = this.SignPopUp;

      var _loop2 = function _loop2(i) {
        //先置空，再重新push
        arr2['array_' + i] = [];
        arr['array_' + i].map(function (item) {
          arr2['array_' + i].push(item);
          ids['arr' + i].push(item.id);
        });
        var x = void 0;
        if (i == 1) {
          x = '';
        } else {
          x = i;
        }
        SignPopUp['tabsData' + x].map(function (item) {
          if (ids['arr' + i].indexOf(item.id) != -1) {
            item.choose = true;
          } else {
            item.choose = false;
          }
        });
      };

      for (var i = 1; i < 4; i++) {
        _loop2(i);
      }
      //标签3级页的下拉框设定，放在全部数据加载完成之后
      //这个函数在本组件生命周期内只执行一次
      if (this.onceTime) {
        setTimeout(function () {
          var arr = document.getElementsByClassName('signWrap');
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].offsetHeight < 50) {
              arr[i].nextElementSibling.setAttribute("style", "display:none;");
            }
          }
          _this19.onceTime = false;
        }, 100);
      }
    },

    //推送管理(2级)，删除标签
    removeSignLabel: function removeSignLabel(index, type) {
      var obj = this.SignArr;
      obj['array_' + type].splice(index, 1);
      if (obj.array_1.length == 0 && obj.array_2.length == 0 && obj.array_3.length == 0) {
        this.checkedSign = false;
      }
    },

    //添加标签（3级），确定
    sureSignLabel: function sureSignLabel() {
      this.innerVisible = true;
      this.innerVisible3 = false;

      var arr2 = this.SignArr2;
      var arr = this.SignArr;

      var _loop3 = function _loop3(i) {
        arr['array_' + i] = [];
        arr2['array_' + i].map(function (item) {
          arr['array_' + i].push(item);
        });
      };

      for (var i = 1; i < 4; i++) {
        _loop3(i);
      }
    },

    //添加标签（3级），点击取消
    changeInnerVisible3: function changeInnerVisible3() {
      this.innerVisible = true;
      this.innerVisible3 = false;
    },

    //选择标签的3个函数，其实都类似，就指向不同，那天心情好了给合并下
    hangYeChoose: function hangYeChoose(item) {
      var arr = [];
      item.choose = !item.choose;
      if (item.choose) {
        // 如果是不限，则取消所有勾选，如果不是则取消'不限'的勾选
        if (item.id == -2) {
          this.SignPopUp.tabsData.map(function (item1) {
            item1.choose = false;
          });
          item.choose = true;
        } else {
          //否则取消不限
          this.SignPopUp.tabsData[0].choose = false;
        }
      }
      this.SignPopUp.tabsData.map(function (item1) {
        if (item1.choose) {
          arr.push(item1);
        }
      });
      this.SignArr2.array_1 = arr;
    },
    gangWeiChoose: function gangWeiChoose(item) {
      var arr = [];
      item.choose = !item.choose;
      if (item.choose) {
        // 如果是不限，则取消所有勾选，如果不是则取消'不限'的勾选
        if (item.id == 0) {
          this.SignPopUp.tabsData2.map(function (item1) {
            item1.choose = false;
          });
          item.choose = true;
        } else {
          this.SignPopUp.tabsData2.map(function (item1) {
            if (item1.id == 0) {
              item1.choose = false;
            }
          });
        }
      }
      this.SignPopUp.tabsData2.map(function (item1) {
        if (item1.choose) {
          arr.push(item1);
        }
      });
      this.SignArr2.array_2 = arr;
    },
    biaoQianChoose: function biaoQianChoose(item) {
      //自我标签
      var arr = [];
      item.choose = !item.choose;
      if (item.choose) {
        // 如果是不限，则取消所有勾选，如果不是则取消'不限'的勾选
        if (item.id == -3) {
          this.SignPopUp.tabsData3.map(function (item1) {
            item1.choose = false;
          });
          item.choose = true;
        } else {
          this.SignPopUp.tabsData3[0].choose = false;
        }
      }
      this.SignPopUp.tabsData3.map(function (item1) {
        if (item1.choose) {
          arr.push(item1);
        }
      });
      this.SignArr2.array_3 = arr;
    },

    //选择标签的清除函数
    removeArray: function removeArray(x) {
      this.SignArr2['array_' + x] = [];
      if (x == 1) {
        x = '';
      }
      this.SignPopUp['tabsData' + x].map(function (item) {
        item.choose = false;
      });
    },

    //推送管理（2级），点击推送
    levelTwoSubmit: function levelTwoSubmit() {
      var _this20 = this;

      var idData = this.transDataToId({
        scheduleType: true,
        rankRuleId: true,
        signId: true,
        sex: true,
        salaryCycle: true,
        searchType: true
      });
      //点再次推送的时候已经校验过了，这里不再校验表单
      //推送方式
      var postType = null;
      var checkSign = this.checkedSign;
      var checkPromoter = this.checkedPromoters;
      if (checkPromoter && checkSign) {
        //都选了
        postType = 0;
      } else if (!checkPromoter && !checkSign) {
        //都没选
        postType = 1;
      } else if (!checkPromoter && checkSign) {
        //仅选标签推送
        postType = 2;
      } else if (checkPromoter && !checkSign) {
        //仅选促销员推送
        postType = 3;
      }

      var errMsg2 = '';
      //推送是否选了内容
      if (postType == 1) {
        errMsg2 = '推送方式不能为空！';
      } else if (checkPromoter && this.isckeckPromotersList.length == 0) {
        errMsg2 = '请选择至少一个促销员！';
      } else if (checkSign && this.SignArr.array_1.length == 0 && this.SignArr.array_2.length == 0 && this.SignArr.array_3.length == 0) {
        errMsg2 = '请选择至少一个标签！';
      }
      if (errMsg2 != '') {
        this.myNotify(this, 'warning', errMsg2);
        return false;
      }

      var PromotersList = [];

      this.isckeckPromotersList.map(function (item) {
        PromotersList.push(item.id);
      });

      var signList = [];
      var SignArr = this.SignArr;
      SignArr.array_1.map(function (item) {
        signList.push(item.id);
      });
      SignArr.array_2.map(function (item) {
        signList.push(item.id);
      });
      SignArr.array_3.map(function (item) {
        signList.push(item.id);
      });
      //数据准备好了，发请求
      this.posLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/PostManagement/onceAgainPublish",
        data: {
          posStoreId: this.dataList.posStoreId,
          workPosId: this.Child[0].workPosId,
          posName: this.jobInformation.jobName,
          signId: idData.signId,
          customer: this.jobInformation.serviceObj,
          scheduleType: idData.scheduleType,
          posDetail: this.jobInformation.jobDescription,
          salaryDetail: this.jobInformation.salaryTreatment,
          welfareDetail: this.jobInformation.postWelfare,
          requirements: this.jobInformation.jobRequirements,
          salaryCycle: idData.salaryCycle,
          salary: this.jobInformation.monthSalary,
          salaryType: Number(this.jobInformation.salary),
          moName: this.jobInformation.supervisorName,
          moTel: this.jobInformation.supervisorTel,
          requirementsTel: this.jobInformation.contactMethod,
          searchType: idData.searchType,
          signIdList: postType == 2 || postType == 0 ? signList : [],
          salesmanIdList: postType == 3 || postType == 0 ? PromotersList : [],
          publishUserId: sessionStorage.getItem('sysUserId'),
          rankRuleId: idData.rankRuleId,
          sex: idData.sex,
          // workCode: "string",
          requirementsStart: this.plan.startTime,
          requirementsEnd: this.plan.endTime,
          recruitsNumber: this.plan.applyNumber,
          remark: this.plan.Remarks,
          postType: postType,
          planNumber: this.plan.number,

          /*crescoreMax: this.jobInformation.scoreIntervalEnd,*/
          crescoreMin: this.jobInformation.scoreIntervalStart,
          storeCode: this.storeCode,

          otherPosDetail: this.jobInformation.otherPosDetail,
          otherRequirements: this.jobInformation.otherRequirements
        }
      }).then(function (res) {
        _this20.posLoading = false;

        if (res.data.message != '发布失败') {
          _this20.innerVisible = false;
          console.log('this.innerVisible', _this20.innerVisible);
          _this20.myNotify(_this20, 'success', "推送成功");
          // window.location.reload()
          _this20.$emit('submitForm'); //成功后后台数据变了，但页面上的数据不会变更，主动触发父级的‘筛选’按钮事件，以更新视图
          setTimeout(function () {
            //这个方法可能优先级高
            _this20.$emit("upupup", false); //主动触发upup方法，'hehe'为向父组件传递的数据，这里将销毁此对象，所以必须放在最后一行
          }, 10);
        } else {
          _this20.myNotify(_this20, 'error', res, '发布失败，请稍后重试');
        }
      }).catch(function (err) {
        _this20.posLoading = false;
        _this20.myNotify(_this20, 'error', err.response, '发布失败，请稍后重试');
      });
    },

    //标签3级，展开收起所有标签
    toggleSlide: function toggleSlide(event) {
      var target = event.target;
      var parentNode = target.parentNode.previousElementSibling;
      if (parentNode.offsetHeight > 45) {
        target.className = "toggle-btn";
        parentNode.style.height = 45 + "px";
      } else {
        target.className = "toggle-btn up";
        parentNode.style.height = "auto";
      }
    },
    checkBoxValue: function checkBoxValue(val, type) {
      var self = this;
      var v = '';
      if (type == '任务说明') {
        v = self.taskInstructionsSigns1V.join(";");
        self.jobInformation.posDetail = v;
        if (!self.taskInstructionsSigns1V.includes('其他')) {
          self.jobInformation.otherPosDetail = '';
        }
      } else if (type == '任务要求') {
        v = self.taskInstructionsSigns2V.join(";");
        self.jobInformation.requirements = v;
        if (!self.taskInstructionsSigns2V.includes('其他')) {
          self.jobInformation.otherRequirements = '';
        }
      }
      console.log('--------->', v);
    },

    // 获取任务说明
    getTaskInstructionsSigns: function getTaskInstructionsSigns() {
      var _this21 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=1'
      }).then(function (res) {
        var data = res.data;
        _this21.taskInstructionsSigns1 = data;
      }).catch(function (err) {
        _this21.myNotify(_this21, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取任务要求
    getTaskInstructionsSigns2: function getTaskInstructionsSigns2() {
      var _this22 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=2'
      }).then(function (res) {
        var data = res.data;
        _this22.taskInstructionsSigns2 = data;
      }).catch(function (err) {
        _this22.myNotify(_this22, 'error', err.response, '查询失败，请稍后重试');
      });
    }
  },
  watch: {
    dataReady: {
      handler: function handler(newVal, oldVal) {
        if (newVal.getIndustryLabel && newVal.getJobLabel && newVal.getSelfLabel && newVal.searchMasterName1 && newVal.searchMasterName2 && newVal.searchRankRuleName && newVal.searchJudgeInterview) {
          console.log('基础数据准备完毕');
          this.getData();
        }
      },
      deep: true
    }
  }
});

/***/ }),

/***/ "qSDM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qcEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blackList_vue__ = __webpack_require__("+lts");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1a868ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blackList_vue__ = __webpack_require__("hFV0");
function injectStyle (ssrContext) {
  __webpack_require__("sxKq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1a868ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blackList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1a868ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blackList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qdoz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "limitManager",
  data: function data() {
    return {
      new_ACKDisabled: false,
      //默认隐藏创建角色框
      createNewRoleModal: false,

      //创建角色数据
      createRoleName: "",
      createRoleMark: "",
      //页面权限编辑输入框
      webName: "",

      //页面权限查看中的信息 等后台数据确定后 再进行修改
      tagInfo: [{
        title: "dashboard",
        show: true,
        webId: 22,
        info: [{
          webId: 25,
          webName: "dashboard",
          webShow: true,
          pid: 22,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "人员中心",
        show: true,
        webId: 3,
        info: [{
          webId: 1,
          webName: "促销员库",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 2,
          webName: "基础中心",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 17,
          webName: "黑名单",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 18,
          webName: "导入评分数据",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 33,
          webName: "快决策问卷",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 34,
          webName: "拨号记录",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 35,
          webName: "项目配置",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 42,
          webName: "兼职签约查询",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 44,
          webName: "QHR人员库",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 47,
          webName: "灰名单查询",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 52,
          webName: "灵工签约记录",
          webShow: true,
          pid: 3,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "工作广场",
        show: true,
        webId: 4,
        info: [{
          webId: 5,
          webName: "岗位发布",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 6,
          webName: "岗位管理",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 39,
          webName: "客户配置",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 40,
          webName: "供应商置换",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 41,
          webName: "虚拟项目维护",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 43,
          webName: "任务配置字段",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 45,
          webName: "自定义项目类型",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 46,
          webName: "客户项目维护",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 55,
          webName: "项目灵工记录",
          webShow: true,
          pid: 4,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "配置管理",
        show: true,
        webId: 48,
        info: [{
          webId: 49,
          webName: "美赞人员映射",
          webShow: true,
          pid: 49,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 50,
          webName: "TOMD",
          webShow: true,
          pid: 50,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 51,
          webName: "长促白名单",
          webShow: true,
          pid: 51,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 53,
          webName: "协议授权配置",
          webShow: true,
          pid: 53,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 54,
          webName: "灵工项目映射",
          webShow: true,
          pid: 54,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "任务中心",
        show: true,
        webId: 28,
        info: [{
          webId: 29,
          webName: "发布任务",
          webShow: true,
          pid: 28,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 30,
          webName: "任务审核",
          webShow: true,
          pid: 28,
          webLevel: 2,
          webAuth: null
        }]
      },
      // {
      //   title: "活动中心",
      //   show: true,
      //   webId: 15,
      //   info: [
      //     {
      //       webId: 16,
      //       webName: "活动中心",
      //       webShow: true,
      //       pid: 15,
      //       webLevel: 2,
      //       webAuth: null,
      //     }
      //   ]
      // },
      // {
      //   title: "积分商城",
      //   show: true,
      //   info: []
      // },
      {
        title: "评估体系",
        show: true,
        webId: 19,
        info: [{
          webId: 20,
          webName: "体系配置",
          webShow: true,
          pid: 19,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 21,
          webName: "评估明细查询",
          webShow: true,
          pid: 19,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "标签体系",
        show: true,
        webId: 7,
        info: [{
          webId: 8,
          webName: "标签管理",
          webShow: true,
          pid: 7,
          webLevel: 2,
          webAuth: null
        },
        // {
        //   webId: 9,
        //   webName: "岗位类型",
        //   webShow: true,
        //   pid: 7,
        //   webLevel: 2,
        //   webAuth: null,
        // },
        {
          webId: 10,
          webName: "项目标签配置",
          webShow: true,
          pid: 7,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "权限管理",
        show: true,
        webId: 12,
        info: [{
          webId: 13,
          webName: "角色管理",
          webShow: true,
          pid: 12,
          webLevel: 2,
          webAuth: null
        }, {
          webId: 14,
          webName: "用户管理",
          webShow: true,
          pid: 12,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "筛选项配置",
        show: true,
        webId: 23,
        info: [{
          webId: 24,
          webName: "筛选项配置",
          webShow: true,
          pid: 23,
          webLevel: 2,
          webAuth: null
        }]
      }, {
        title: "友情链接",
        show: true,
        webId: 36,
        info: [{
          webId: 37,
          webName: "工作快讯",
          webShow: true,
          pid: 36,
          webLevel: 2,
          webAuth: null
        }]
      }],
      //默认隐藏每一行修改弹窗
      reviseTag: false,
      //默认隐藏查看页面权限弹窗
      handleView: false,

      //默认显示第一页的数据
      pageNo: 1,
      //默认显示10条数据
      pageSize: 10,
      //总页数
      total: null,

      //table请求数据
      formData: {
        //角色名称
        roleName: "",
        //传参的默认页数未1
        pageNo: 1,
        //传参的默认页数未10
        pageSize: 10
      },
      //数据加载后这个数组的内容就是数据
      tableData: [],
      //默认‘拼命加载’显示
      listLoading: true,

      // 已选择的页面
      checkTagList: [],

      // 单行编辑dialog标志位
      editRowDialog: false,
      editLoading: false,
      editRowObj: {
        roleName: [],
        roleRemark: [],
        aaa: '',
        bbb: ''
      },
      aaaLength: 0,
      bbbLength: 0,
      // 页面内权限
      auths: []
      // num:0
    };
  },
  mounted: function mounted() {
    //页面激活后，请求数据
    this.getData();

    this.getAuth();
  },

  methods: {
    //工具类，弹框简写
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    check: function check() {
      this.aaaLength = this.editRowObj.aaa ? this.editRowObj.aaa.length : 0;
    },
    checkb: function checkb() {
      this.bbbLength = this.editRowObj.bbb ? this.editRowObj.bbb.length : 0;
    },
    createNewRoleModalTrue: function createNewRoleModalTrue() {
      this.createNewRoleModal = true;
      this.checkTagList = [];
    },

    //查看电话权限
    telTool: function telTool(val) {
      var _this2 = this;

      var webId = [];
      this.handleExamine(val);
      this.handleView = false;
      this.checkTagList.forEach(function (item) {
        webId.push({
          webId: item.webId,
          webAuth: item.webAuth
        });
      });
      this.$http({
        method: "POST",
        url: "/rest/role/updateRoleAuthCheckTel",
        data: {
          id: val.id,
          roleName: val.roleName,
          roleRemark: val.roleRemark,
          checkTelBool: val.checkTelBool,
          webId: webId
        }
      }).then(function (res) {
        //搜索时没有权限，进行提示
        if (res.data.status == 460) {
          _this2.myNotify(_this2, 'error', res, '查询失败，请稍后重试');
          return false;
        }
        _this2.myNotify(_this2, 'success', res, '操作成功');
        _this2.getData();
        _this2.initTagInfo();
      }).catch(function (err) {
        if (err.response.status == 456) {
          _this2.myNotify(_this2, 'error', '此角色无任何页面权限,请先添加页面权限');
          val.checkTelBool = !val.checkTelBool;
          return false;
        }
        _this2.myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //取消创建
    createNewRoleCancel: function createNewRoleCancel() {
      this.createRoleName = "";
      this.createRoleMark = "";
      this.createNewRoleModal = false;
      this.initTagInfo();
    },


    //编辑模糊搜索
    blurrySearch: function blurrySearch(data) {
      // for (var i = 0; i < data.length; i++) {
      //   for (var j = 0; j < this.tagInfo.length; j++) {
      //     for(var k = 0; k < this.tagInfo[j].info.length; k ++) {
      //       this.tagInfo[j].show = false
      //       this.tagInfo[j].info[k].webShow = false
      //       if (data.webLevel === 1) {
      //         this.tagInfo[j].show = true
      //         this.tagInfo[j].info[k].webShow = true
      //         console.log(111)
      //       } else if (data.webLevel === 2) {
      //         this.tagInfo[j].info[k].webShow = true
      //       }
      //     }
      //   }
      // }
    },


    //模糊检索
    searchEditLimit: function searchEditLimit() {
      var _this3 = this;

      this.$http({
        method: "GET",
        url: "/rest/role/searchRoleAuth",
        params: {
          webName: this.webName
        }
      }).then(function (res) {
        _this3.blurrySearch(res.data);
      }).catch(function (err) {
        _this3.myNotify(_this3, 'error', err.response, '操作失败，请稍后重试');
      });
    },

    //创建角色方法
    createNewRole: function createNewRole() {
      var _this4 = this;

      if (this.checkTagList.length == 0) {
        this.myNotify(this, 'error', '请选择页面权限');
      } else if (!this.createRoleName && this.createRoleName !== 0) {
        this.myNotify(this, 'error', '请填写角色名称');
      } else {
        var webId = [];
        this.checkTagList.forEach(function (item) {
          webId.push({
            webId: item.webId,
            webAuth: item.webAuth
          });
        });
        this.new_ACKDisabled = true;
        this.$http({
          method: "POST",
          url: "/rest/role/saveUpdateRole",
          data: {
            id: null,
            roleName: this.createRoleName,
            roleRemark: this.createRoleMark,
            checkTelBool: true,
            webId: webId
          }
        }).then(function (res) {
          _this4.new_ACKDisabled = false;
          //关闭创建角色弹窗
          var status = res.data.status;
          if (status == 400 || status == 460) {
            _this4.myNotify(_this4, 'error', res, '操作失败，请稍后重试');
          } else {
            _this4.myNotify(_this4, 'success', res, '操作成功');
            _this4.createNewRoleModal = false;
            _this4.getData();
          }
        }).catch(function (err) {
          _this4.new_ACKDisabled = false;
          _this4.myNotify(_this4, 'error', err.response, '操作失败，请稍后重试');
        });
      }
    },

    //每一行的保存按钮
    rowHandleSave: function rowHandleSave(row) {
      var _this5 = this;

      var webId = [];
      this.checkTagList.forEach(function (item) {
        webId.push({
          webId: item.webId,
          webAuth: item.webAuth
        });
      });
      this.editLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/role/saveUpdateRole",
        data: {
          id: row.id,
          roleName: this.editRowObj.aaa,
          roleRemark: this.editRowObj.bbb,
          checkTelBool: row.checkTelBool,
          webId: webId
        }
      }).then(function (res) {
        //先将展开一行的方法，设置为false
        // this.$refs["table"].toggleRowExpansion(row, false);
        _this5.editRowDialog = false;
        _this5.editLoading = false;
        _this5.initTagInfo();
        _this5.myNotify(_this5, 'success', res, '操作成功');
        _this5.getData();
      }).catch(function (err) {
        _this5.myNotify(_this5, 'error', err.response, '操作失败，请稍后重试');
        _this5.editLoading = false;
      });
    },

    //每一行的取消按钮
    rowHandleCancel: function rowHandleCancel(row) {
      this.initTagInfo();
      this.editRowDialog = false;
      // this.$refs["table"].toggleRowExpansion(row, false);
    },


    //编辑展开后，修改按钮
    reviseRowBtn: function reviseRowBtn(row) {
      this.checkTagList = [];
      //编辑权限弹窗
      this.reviseTag = true;
      this.handleEdit(row);
    },

    // 修改保存标签到row里面
    saveCheckedTags: function saveCheckedTags() {
      var _this6 = this;

      this.checkTagList = [];
      this.tagInfo.forEach(function (t) {
        t.info.forEach(function (i) {
          if (i.webAuth === 1 || i.webAuth === 2) {
            _this6.checkTagList.push(i);
          }
        });
      });
      this.reviseTag = false;
    },

    //删除
    handleDelete: function handleDelete(row) {
      var _this7 = this;

      var roleId = row.id;
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.$http({
          method: "POST",
          url: "/rest/sysUser/deleteUserRole",
          params: {
            roleId: roleId
          }
        }).then(function () {
          // 角色删除后相应的用户角色置null
          _this7.$http({
            method: "POST",
            url: "/rest/role/deleteRole",
            data: {
              id: row.id
            }
          }).then(function (res) {
            _this7.getData();
            _this7.myNotify(_this7, 'success', res, '操作成功');
          });
        }).catch(function (err) {
          _this7.myNotify(_this7, 'error', err.response, '查询失败，请稍后重试');
        });
      });
    },

    //请求数据
    getData: function getData() {
      var _this8 = this;

      //加载的时候，让‘拼命加载’隐藏
      this.listLoading = true;
      this.$http({
        method: "GET",
        url: "/rest/role/getRole",
        params: this.formData
      }).then(function (res) {
        _this8.listLoading = false;
        _this8.tableData = res.data;
        _this8.total = res.data.length > 0 ? Number(res.data[0].numList) : 0;
      }).catch(function (err) {
        if (err.response) {
          _this8.myNotify(_this8, 'error', err.response, '查询失败，请稍后重试');
        }
        _this8.listLoading = false;
      });
    },
    getAuth: function getAuth() {
      var _this9 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 13,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          _this9.auths.push(item.auth);
        });
      }).catch(function (err) {
        _this9.myNotify(_this9, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      //更改页面数据条数
      this.formData.pageSize = val;
      //更改新的页面数据条数后，重新请求数据
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      //更改页数
      this.formData.pageNo = val;
      //更改新的页数后，重新请求数据
      this.getData();
    },


    //编辑
    handleEdit: function handleEdit(row) {
      var _this10 = this;

      // console.log(this.tableData)
      // this.tableData.forEach(t => {
      //   if (t.id !== row.id) {
      //     // this.$refs["table"].toggleRowExpansion(t, false)
      //     this.editRowDialog = true
      //     this.editRowObj = row
      //   }
      // })

      this.editRowDialog = true;
      this.editRowObj = row;
      this.editRowObj.aaa = row.roleName;
      this.aaaLength = this.editRowObj.aaa ? this.editRowObj.aaa.length : 0;
      this.editRowObj.bbb = row.roleRemark;
      this.bbbLength = this.editRowObj.bbb ? this.editRowObj.bbb.length : 0;
      // console.log(this.editRowObj)
      this.editLoading = true;
      this.$http({
        method: "GET",
        url: "/rest/role/getRoleAuth",
        params: {
          id: row.id
        }
      }).then(function (res) {
        _this10.checkResTag(res.data);
        _this10.editLoading = false;
        // this.$refs["table"].toggleRowExpansion(row, true)
      }).catch(function (err) {
        _this10.myNotify(_this10, 'error', err.response, '查询失败，请稍后重试');
        _this10.editLoading = false;
      });
    },


    //页面权限查看
    handleExamine: function handleExamine(row) {
      var _this11 = this;

      this.handleView = true;
      this.tableData.forEach(function (t) {
        if (t.id !== row.id) {
          _this11.$refs["table"].toggleRowExpansion(t, false);
        }
      });
      this.$http({
        method: "GET",
        url: "/rest/role/getRoleAuth",
        params: {
          id: row.id
        }
      }).then(function (res) {
        _this11.checkResTag(res.data);
      }).catch(function (err) {
        _this11.myNotify(_this11, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    checkResTag: function checkResTag(data) {
      var _this12 = this;

      this.checkTagList = [];
      data.forEach(function (d) {
        if (d.webAuth === 1 || d.webAuth === 2) {
          _this12.checkTagList.push(d);
        }
        _this12.tagInfo.forEach(function (t) {
          t.info.forEach(function (i) {
            if (i.webId === d.webId) {
              i.webAuth = d.webAuth;
            }
          });
        });
      });
    },


    //初始化tagInfo
    initTagInfo: function initTagInfo() {
      this.webName = "";
      for (var i = 0; i < this.tagInfo.length; i++) {
        this.tagInfo[i].show = true;
        for (var j = 0; j < this.tagInfo[i].info.length; j++) {
          this.tagInfo[i].info[j].webShow = true;
          this.tagInfo[i].info[j].webAuth = null;
        }
      }
    },


    //关闭页面权限查看头部tag
    colseViewPageTag: function colseViewPageTag() {
      this.handleView = false;
    },

    // 修改关闭岗位权限
    editClosePosFlg: function editClosePosFlg(val) {
      var _this13 = this;

      var closePosFlg;
      if (val.closePosFlg) {
        closePosFlg = 1;
      } else {
        closePosFlg = 0;
      }
      this.$http({
        method: "POST",
        url: "/rest/role/updateClosePosFlag",
        params: {
          id: val.id,
          flag: closePosFlg
        }
      }).then(function (res) {
        _this13.myNotify(_this13, 'success', res, '操作成功');
      }).catch(function (err) {
        _this13.getData();
        _this13.myNotify(_this13, 'error', err.response, '更新失败，请稍后重试');
      });
    },

    // 修改招聘特权
    editRecruitmentPrivilege: function editRecruitmentPrivilege(val) {
      var _this14 = this;

      var recruitmentPrivilege;
      if (val.recruitmentPrivilege) {
        recruitmentPrivilege = 1;
      } else {
        recruitmentPrivilege = 0;
      }
      this.$http({
        method: "POST",
        url: "/rest/role/updateRecruitmentPrivilege",
        params: {
          id: val.id,
          flag: recruitmentPrivilege
        }
      }).then(function (res) {
        _this14.myNotify(_this14, 'success', res, '操作成功');
      }).catch(function (err) {
        _this14.getData();
        _this14.myNotify(_this14, 'error', err.response, '更新失败，请稍后重试');
      });
    }
  }
});

/***/ }),

/***/ "qeIN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "qvSl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "r8SX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rD8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_managementApply_vue__ = __webpack_require__("FO3r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f951bc28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_managementApply_vue__ = __webpack_require__("wOUk");
function injectStyle (ssrContext) {
  __webpack_require__("X5MD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f951bc28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_managementApply_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f951bc28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_managementApply_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rIZC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rufL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rvF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var projectOptions = ['(GX)共享促销员', '(SP)店内短促', '(RS)路演', '(ST)店内长促', '(GA)GA共享促销员', '(GS)GS共享促销员', '(MM)物料制作', '(PR)会务/会展', '(DS)派样', '(SE)店内活动', '(SM)销售管理', '(TS)技术服务', '(PP)PP店内短促', '(CA)费用代垫'];
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            auths: [],
            projects: [],
            checkedProject: [],
            // checkedProject:[ "(RS)路演", "(SP)店内短促", "(GX)共享促销员", "(GS)GS共享促销员", "(MM)物料制作" ],
            enabled: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.getAuth();
        this.$http({
            method: "GET",
            url: "/rest/projectCategory/init"
        }).then(function (res) {
            console.log(res.data.data);
            res.data.data.map(function (item) {
                var porjectTypeName = item.porjectTypeName != null ? item.porjectTypeName : "--";
                _this.projects.push("(" + item.porjectType + ")" + porjectTypeName);
            });
        });

        this.$http({
            method: "GET",
            url: "/rest/projectCategory/list"
        }).then(function (res) {
            console.log(res.data.data);
            res.data.data.map(function (item) {
                _this.checkedProject.push(item.categoryName);
            });
        });
    },


    methods: {
        getAuth: function getAuth() {
            var _this2 = this;

            this.$http({
                method: "GET",
                url: "/rest/sysUser/getSysUserWebAuth",
                params: {
                    webId: 45,
                    sysUserId: sessionStorage.getItem("sysUserId")
                }
            }).then(function (res) {
                res.data.map(function (item) {
                    _this2.auths.push(item.auth);
                });
                if (_this2.auths[0] < 2) {
                    _this2.enabled = true;
                }
            }).catch(function (err) {
                utils.myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.projects = val;
        },

        // toggleSelection(rows) {
        //   if (rows) {
        //     rows.forEach(row => {
        //       this.$refs.multipleTable.toggleRowSelection(row);
        //     });
        //   } else {
        //     this.$refs.multipleTable.clearSelection();
        //   }
        // },
        save: function save() {
            var _this3 = this;

            this.$http({
                method: "POST",
                url: "/rest/projectCategory/save",
                data: this.checkedProject
            }).then(function (res) {
                _this3.$router.go(0);
            }).catch(function (err) {
                //   utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
            });
        }
    }
});

/***/ }),

/***/ "rw/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"systemHeader"},[(!_vm.isModify)?_c('el-button',{staticClass:"seeHistory blueButton pointer",attrs:{"disabled":_vm.auths.indexOf(2) < 0},on:{"click":function($event){return _vm.$router.push({path: '/LookHistory'})}}},[_vm._v("查看历史配置\n    ")]):_vm._e(),_vm._v(" "),(_vm.isModify)?_c('span',{staticClass:"pointer cancelEdit",on:{"click":_vm.quite}},[_vm._v("取消编辑")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"systemCalendar"},[_c('span',{staticClass:"calendarStart"},[_vm._v("起始时间")]),_vm._v(" "),_c('span',{staticClass:"calendarTime"},[_vm._v(_vm._s(_vm.startTime))])]),_vm._v(" "),_c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("评估体系")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.pages[_vm.navState-1].name))])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"tabPages"},[_c('div',{staticClass:"systemNav"},_vm._l((_vm.pages),function(item,index){return _c('div',{key:index,staticClass:"systemNavWrap"},[_c('div',{staticClass:"pages pointer",class:{'isActive': _vm.navActive(index+1)},on:{"click":function($event){return _vm.changeNavState(index+1)}}},[_c('span',[(_vm.navActive(index+1))?_c('img',{attrs:{"src":item.checkedIcon}}):_c('img',{attrs:{"src":item.icon}}),_vm._v("\n            "+_vm._s(item.name)+"\n          ")])]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModify && index!=3),expression:"isModify && index!=3"}],staticClass:"el-icon-arrow-right",class:{'changeColor': _vm.navChangeColor(index+1)}})])}),0),_vm._v(" "),(_vm.navState == 1 && !_vm.isModify)?_c('el-button',{staticClass:"edit blueButton pointer",attrs:{"disabled":_vm.auths.indexOf(2) < 0},on:{"click":_vm.edit}},[_vm._v("编辑")]):_vm._e()],1),_vm._v(" "),_c('div',[(_vm.navState == 1)?_c('TiXi',{attrs:{"isEdit":_vm.isModify}}):_vm._e(),_vm._v(" "),(_vm.navState == 2)?_c('jiFen',{ref:"jifen",attrs:{"isEdit":_vm.isModify}}):_vm._e(),_vm._v(" "),(_vm.navState == 3)?_c('XingJI',{attrs:{"isEdit":_vm.isModify}}):_vm._e(),_vm._v(" "),(_vm.navState == 4)?_c('XinYong',{attrs:{"isEdit":_vm.isModify}}):_vm._e()],1),_vm._v(" "),(_vm.isModify)?_c('div',{staticClass:"systemFooter"},[_c('span',{staticClass:"btn-pre",domProps:{"innerHTML":_vm._s(_vm.btnPre)},on:{"click":_vm.btnPreClick}}),_vm._v(" "),_c('span',{staticClass:"btn-next",domProps:{"innerHTML":_vm._s(_vm.btnNext)},on:{"click":_vm.btnNextClick}})]):_vm._e(),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"提 示","visible":_vm.quitDialog,"width":"30%","center":""},on:{"update:visible":function($event){_vm.quitDialog=$event}}},[_c('div',{staticClass:"dialog-body"},[_c('img',{attrs:{"src":__webpack_require__("F0vU")}}),_vm._v("确认要退出编辑吗？")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.quitDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticClass:"dialog-btn",attrs:{"size":"small"},on:{"click":_vm.quite}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rxb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addWorks_vue__ = __webpack_require__("sMW+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58a26122_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addWorks_vue__ = __webpack_require__("BANe");
function injectStyle (ssrContext) {
  __webpack_require__("od8Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addWorks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58a26122_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addWorks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s+T2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_XinYong_vue__ = __webpack_require__("3ele");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6d5f46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XinYong_vue__ = __webpack_require__("alHo");
function injectStyle (ssrContext) {
  __webpack_require__("E5Jd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f6d5f46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_XinYong_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6d5f46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XinYong_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s4KX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Add_vue__ = __webpack_require__("Vko2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Add: __WEBPACK_IMPORTED_MODULE_2__Add_vue__["a" /* default */] },
  data: function data() {
    return {
      allCustomers: [], //项目列表数组
      //筛选项参数
      param: {},
      param2: {},
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      tableData: [], //表单信息
      listLoading: false,
      item: {},
      visiable: false
    };
  },

  methods: {
    show: function show(item) {
      this.param = {};
      this.param2 = {};
      this.item = item;
      this.formData = {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null
      };
      this.visiable = true;
      this.getData();
    },

    //工具类，错误提示框
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },
    computedTime: function computedTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      this.param2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },

    //翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },

    //获取数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        id: this.item.id
      }, this.param2, {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo
      });
      //获取表单数据
      this.$http({
        method: "GET",
        headers: { "content-type": "application/json" },
        url: "/rest/agreementProject/listAgreementProject",
        params: params
      }).then(function (res) {
        _this2.tableData = res.data.items;
        _this2.formData.total = res.data.totalItemsCount;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.myNotify(_this2, "error", err.response, "查询失败，请稍后重试");
      });
    },

    // 取消关联
    disassociate: function disassociate(item) {
      var _this3 = this;

      this.$confirm("\u662F\u5426\u53D6\u6D88\u9879\u76EE<span style=\"color:#ff4d4f\">" + item.projectName + "</span>\u4E0E<span style=\"color:#ff4d4f\">" + this.item.title + "</span>\u7684\u5173\u8054\uFF1F", "提示", {
        distinguishCancelAndClose: true,
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _this3.$http({
          method: "GET",
          url: "/rest/agreementProject/updateAgreementProject",
          params: {
            id: item.id,
            operatorId: sessionStorage.getItem("sysUserId")
          }
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.status == 200) {
            _this3.$emit("done");
            _this3.getData();
          } else {
            _this3.myNotify(_this3, "error", data.message);
          }
        });
      });
    },

    //新增
    add: function add() {
      this.$refs.Add.show(this.item);
    },
    addDone: function addDone() {
      this.$emit("done");
      this.formData.pageNo = 1;
      this.getData();
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "sI1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dummyPhoneRecode",
  data: function data() {
    return {
      param: {
        callerName: null, // 拨打人姓名
        callerAccount: null, // 拨打人账号
        callPage: null, // 拨出页面
        salesmanName: null, // 促销员姓名
        empPk: null, // 促销员id
        projectCode: null, // 项目编号
        projectName: null, // 项目名称
        projectDepartment: null, // 项目所属部门
        salesmanTel: null, // 促销员真实号码
        callDateBegin: null, // 选择开始日期
        callDateEnd: null, // 选择结束日期
        sysUserId: null, // 当前用户id
        pageSize: null,
        pageNo: null
      },
      formData: {
        pageNo: 1,
        pageSize: 10,
        total: null
      },
      tableData: [],
      chooseCallPage: [{ name: '不限', id: null }, { name: "促销员库", id: 1 }, { name: "岗位管理", id: 0 }],
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    // 翻页
    handleSizeChange: function handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      this.param.pageNo = this.formData.pageNo;
      this.param.pageSize = this.formData.pageSize;
      this.param.sysUserId = sessionStorage.getItem("sysUserId");
      this.$http({
        method: 'get',
        url: '/rest/JiangYiJoint/dummyPhoneRecodes',
        params: this.param
      }).then(function (res) {
        if (res.data && res.data.code == '0') {
          var data = res.data.data;
          _this.formData.total = data.totalCount;
          _this.tableData = data.results;
        }
        _this.listLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this.listLoading = false;
      });
    },
    resetParams: function resetParams() {
      this.param.callerName = null;
      this.param.callerAccount = null;
      this.param.callPage = null;
      this.param.salesmanName = null;
      this.param.empPk = null;
      this.param.projectCode = null;
      this.param.projectName = null;
      this.param.projectDepartment = null;
      this.param.salesmanTel = null;
      this.param.callDateBegin = null;
      this.param.callDateEnd = null;
    },
    searchData: function searchData() {
      this.formData.pageNo = 1;
      this.getData();
    },
    exportData: function exportData() {
      var _this2 = this;

      this.listLoading = true;
      this.param.sysUserId = sessionStorage.getItem("sysUserId");
      this.$http({
        method: 'GET',
        url: '/rest/JiangYiJoint/dummyPhoneRecodes/export',
        params: this.param
      }).then(function (res) {
        if (res.data && res.data.status == 200) {
          _this2.listLoading = false;
          location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        } else {
          _this2.listLoading = false;
          _this2.$alert(res.data.message);
        }
      }).catch(function (error) {
        console.log(error);
        _this2.listLoading = false;
        _this2.$alert("导出错误，请联系管理员！");
      });
    }
  }
});

/***/ }),

/***/ "sKX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jiFen_vue__ = __webpack_require__("97cg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af46046_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jiFen_vue__ = __webpack_require__("PZAf");
function injectStyle (ssrContext) {
  __webpack_require__("/5RU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1af46046"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jiFen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af46046_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jiFen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sMW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__ = __webpack_require__("hhm8");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    store_WSInfo: function store_WSInfo() {
      return this.$store.state.workSquareInfo;
    },
    store_WSIsEdit: function store_WSIsEdit() {
      return this.$store.state.workSquareIsEdit;
    }
  },
  data: function data() {
    return {
      total: null,
      formData: {
        projectCode: null,
        projectName: null,
        pageNo: 1,
        pageSize: 10,
        empId: sessionStorage.getItem('empPk')
      },
      tableData: [],
      allData: [],
      listLoading: false,

      // 岗位信息
      jobInformation: {
        visable: [],
        navState: 2,
        workCode: null,
        projectCode: null,
        projectId: null,
        projectName: null,
        projectIpgId: null,
        posName: null,
        jobType: null,
        signId: null,
        customer: null,
        dateType: null,
        scheduleType: null,
        posDetail: null,
        salaryDetail: null,
        welfareDetail: null,
        requirements: null,
        // moName: null,
        // moTel: null,
        salarySettlement: null,
        salaryCycle: null,
        salaryType: null,
        daySalary: null,
        monthSalary: null,
        salary: null,
        sexName: null,
        sex: null,
        starRating: null,
        rankRuleId: null,
        // crescoreMax: null,
        crescoreMin: null,
        requirementsTel: null,
        checkboxGroup: [],
        checkboxIds: [],
        checkboxGroup1: [],
        checkboxGroup2: [],
        daySalaryStatus: false,
        monthSalaryStatus: false,
        searchType: ['粉丝', '会员'], //因为把整个可见范围设定都隐藏掉了，所以这个必填项传个默认值（全选）
        signIdList: [],
        jobTypeOptions: [],
        dateTypeOptions: [],
        salarySettlementOptions: [],
        sexOptions: [{ id: 0, sexName: '不限' }, { id: 1, sexName: '男' }, { id: 2, sexName: '女' }],
        starRatingOptions: [],

        otherPosDetail: '', // 其他任务说明
        otherRequirements: '' // 其他任务要求
      },

      tabsData: [],
      tabsData2: [],
      tabsData3: [],
      multipleSelection: [],
      jobPreviewDialog: false,
      bluring: false, //可以防止提示两次
      hasError: false, //配合bluring，效果更佳
      taskInstructionsSigns1: [], //任务说明
      taskInstructionsSigns1V: [],
      taskInstructionsSigns2: [], //任务要求
      taskInstructionsSigns2V: [],

      proDuringTime: '' //新加的，记录当前选中的项目的duringTime，并传给第二页
    };
  },
  updated: function updated() {
    this.disabled();
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.store_WSInfo != null) {
      this.jobInformation = this.store_WSInfo;
      setTimeout(function () {
        _this2.tableData.map(function (item, index) {
          if (item.projectCode == _this2.store_WSInfo.projectCode) {
            _this2.$refs.multipleTable.toggleRowSelection(item, true);
          }
        });
      }, 1000);
    }
    this.disabled();
    this.getData();
    this.getDateType();
    this.getSalarySettlement();
    this.getIndustryLabel();
    this.getJobLabel();
    this.getSelfLabel();
    this.getRankLabel();

    this.getTaskInstructionsSigns();
    this.getTaskInstructionsSigns2();

    window.onresize = function () {
      return _this2.autoResize();
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(["saveWorkSquareInfo", "workSquareIsEditMethods"]), {
    //工具类-弹窗简写
    myNotify: function myNotify(_this, type, normal, or) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_util_js__["a" /* default */].myNotify(_this, type, normal, or);
    },

    //自动根据标签div的高度，添加或移除下拉小按钮。除此之外，在获取三类标签后，且渲染后，各执行一次。
    autoResize: function autoResize() {
      var arr = document.getElementsByClassName('label-tabs');
      if (arr.length != 0) {
        for (var i = 0; i < arr.length; i++) {
          //注意如果在引用了此组件 的页面里加了label-tabs类，一定要小心，记得关注这里
          if (arr[i].offsetHeight < 51) {
            arr[i].previousElementSibling.setAttribute("style", "display:none;");
          } else {
            arr[i].previousElementSibling.setAttribute("style", "display:block;");
          }
          if (i == 2) {
            //因为有的时候arr不足3个，i上限是length，有时候大于3个，所以到3就停止
            break;
          }
        }
      }
    },

    //曾经是有区间上限的，现在暂时不需要，checkScore中的Max不再有意义
    checkScore: function checkScore() {
      if (this.jobInformation.crescoreMin < 0 /*|| this.jobInformation.crescoreMax < 0*/) {
          this.myNotify(this, 'warning', '分值下限不可以小于0');
          this.jobInformation.crescoreMin = null;
        } else if (isNaN(this.jobInformation.crescoreMin)) {
        this.myNotify(this, 'warning', '请输入数字类型');
        this.jobInformation.crescoreMin = null;
      }
    },
    showTabs: function showTabs(tab, e) {
      var idsArr = this.jobInformation.checkboxIds;
      if (e) {
        //如果是选中
        if (idsArr.indexOf(tab.id) < 0) {
          idsArr.push(tab.id);
        }
      } else {
        //一次仅删一个
        idsArr.map(function (item, index, arr) {
          if (item == tab.id) {
            arr.splice(index, 1);
          }
        });
      }
    },

    //请求项目数据
    getData: function getData() {
      var _this3 = this;

      this.allData = [];
      var empPk = sessionStorage.getItem('empPk');
      if (!isNaN(parseInt(empPk))) {
        this.listLoading = true;
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchProject2',
          params: { empId: empPk }
        }).then(function (res) {
          _this3.allData = res.data;
          _this3.getDataLocal();
          _this3.listLoading = false;
        }).catch(function (res) {
          _this3.myNotify(_this3, 'error', '查询失败，请稍后重试');
          _this3.listLoading = false;
        });
      }
    },
    getDataLocal: function getDataLocal() {
      var _this4 = this;

      var result = new Array();
      var projectCode = this.formData.projectCode;
      var projectName = this.formData.projectName;
      // 遍历allData筛选出符合条件的
      this.allData.forEach(function (value, index) {
        if (projectCode && projectCode != '' && value.projectCode.indexOf(projectCode) == -1) {
          return;
        }
        if (projectName && projectName != '' && value.projectName.indexOf(projectName) == -1) {
          return;
        }
        result.push(value);
      });
      this.total = result.length;
      var begin = (this.formData.pageNo - 1) * this.formData.pageSize;
      var end = this.formData.pageNo * this.formData.pageSize > result.length ? result.length : this.formData.pageNo * this.formData.pageSize;
      this.tableData = result.slice(begin, end);

      //如果是从选择门店页面跳转回来，则是带有项目信息的，这时候帮他选中并且配置proDuringTing，不然传参会丢失
      if (this.jobInformation.projectCode) {
        this.tableData.map(function (item) {
          if (_this4.jobInformation.projectCode == item.projectCode) {
            _this4.proDuringTime = { end: item.endTime, start: item.startTime
              //如果能选就给他选上
            };if (!_this4.store_WSIsEdit) {
              setTimeout(function () {
                _this4.$refs.multipleTable.toggleRowSelection(item, true);
              }, 100);
            }
          }
        });
      }
    },
    searchData: function searchData() {
      this.formData.pageNo = 1;
      this.getDataLocal();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getDataLocal();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getDataLocal();
    },

    // 获取档期类型list
    getDateType: function getDateType() {
      var _this5 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchMasterName',
        params: {
          masterCode: 'SCHEDULE_TYPE'
        }
      }).then(function (res) {
        var data = res.data;
        _this5.jobInformation.dateTypeOptions = data;
      }).catch(function (err) {
        _this5.myNotify(_this5, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取结算方式list
    getSalarySettlement: function getSalarySettlement() {
      var _this6 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchMasterName',
        params: {
          masterCode: 'SALARY_CYCLE'
        }
      }).then(function (res) {
        var data = res.data;
        _this6.jobInformation.salarySettlementOptions = data;
      }).catch(function (err) {
        _this6.myNotify(_this6, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取行业类型二级标签
    getIndustryLabel: function getIndustryLabel() {
      var _this7 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchIndustrySignName',
        params: {
          signType: 1,
          signLevel: 2
        }
      }).then(function (res) {
        var data = res.data;
        _this7.tabsData = data;

        setTimeout(function () {
          _this7.autoResize(); //校验一下高度，添加下拉小按钮
        }, 100);
      }).catch(function (err) {
        _this7.myNotify(_this7, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取岗位标签
    getJobLabel: function getJobLabel() {
      var _this8 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchSignName',
        params: {
          signType: 2
        }
      }).then(function (res) {
        var data = res.data;
        _this8.tabsData2 = data;
        _this8.jobInformation.jobTypeOptions = data;
        setTimeout(function () {
          _this8.autoResize(); //校验一下高度，添加下拉小按钮
        }, 100);
      }).catch(function (err) {
        _this8.myNotify(_this8, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取自我标签
    getSelfLabel: function getSelfLabel() {
      var _this9 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchSignName',
        params: {
          signType: 3
        }
      }).then(function (res) {
        var data = res.data;
        _this9.tabsData3 = data;

        setTimeout(function () {
          _this9.autoResize(); //校验一下高度，添加下拉小按钮
        }, 100);
      }).catch(function (err) {
        _this9.myNotify(_this9, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取星级
    getRankLabel: function getRankLabel() {
      var _this10 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchRankRuleName'
      }).then(function (res) {
        var data = res.data;
        _this10.jobInformation.starRatingOptions = data;
      }).catch(function (err) {
        _this10.myNotify(_this10, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取任务说明
    getTaskInstructionsSigns: function getTaskInstructionsSigns() {
      var _this11 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=1'
      }).then(function (res) {
        var data = res.data;
        _this11.taskInstructionsSigns1 = data;
      }).catch(function (err) {
        _this11.myNotify(_this11, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取任务要求
    getTaskInstructionsSigns2: function getTaskInstructionsSigns2() {
      var _this12 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=2'
      }).then(function (res) {
        var data = res.data;
        _this12.taskInstructionsSigns2 = data;
      }).catch(function (err) {
        _this12.myNotify(_this12, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    // 获取项目服务费说明
    getPrjServiceCharge: function getPrjServiceCharge(prjCode) {
      var _this13 = this;

      this.$http({
        method: "GET",
        url: '/rest/PublishedWork/searchPrjServiceCharge?prjCode=' + prjCode
      }).then(function (res) {
        var data = res.data;
        _this13.jobInformation.salaryDetail = data.message;
      }).catch(function (err) {
        _this13.myNotify(_this13, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    handleSelectionChange: function handleSelectionChange(rows) {
      if (rows) {
        var length = rows.length;
        switch (length) {
          case 0:
            this.jobInformation.projectCode = null;
            this.jobInformation.projectName = null;
            this.jobInformation.projectIpgId = null;
            this.jobInformation.projectId = null;
            this.proDuringTime = null;
            break;
          case 1:
            this.jobInformation.projectCode = rows[length - 1].projectCode;
            this.jobInformation.projectName = rows[length - 1].projectName;
            this.jobInformation.projectIpgId = rows[length - 1].projectIpgId;
            this.jobInformation.projectId = rows[length - 1].id;
            this.proDuringTime = { end: rows[0].endTime, start: rows[0].startTime
              // 加载服务费说明
            };this.getPrjServiceCharge(this.jobInformation.projectCode);
            break;
          case 2:
            this.$refs.multipleTable.clearSelection();
            this.$refs.multipleTable.toggleRowSelection(rows[length - 1], true);
        }
      }
    },

    // 预览岗位
    previewPost: function previewPost() {
      if (!this.hasError || !this.bluring) {
        this.checkValues(this.jobInformation);
      }
      // this.jobPreviewDialog = true
    },
    disabled: function disabled() {
      //这里绝对不能简化，否则会不断触发updated()然后卡死
      var info = this.jobInformation;
      if (info.salaryType == 1) {
        info.daySalaryStatus = false;
        info.monthSalaryStatus = true;
      } else if (info.salaryType == 2) {
        info.monthSalaryStatus = false;
        info.daySalaryStatus = true;
      } else {
        info.daySalaryStatus = true;
        info.monthSalaryStatus = true;
      }
    },
    toggleSlide: function toggleSlide(event) {
      var target = event.target;
      var parentNode = target.parentNode;
      if (parentNode.offsetHeight > 40) {
        target.className = 'toggle-btn';
        parentNode.style.height = 40 + 'px';
      } else {
        target.className = 'toggle-btn up';
        parentNode.style.height = 'auto';
      }
    },

    // 清空行业品类所选
    deleteSelfLabel: function deleteSelfLabel(val) {
      var _this14 = this;

      if (this.store_WSIsEdit) {
        return;
      } else {
        if (val == 1) {
          var rows = [];
          this.jobInformation.checkboxGroup.forEach(function (item) {
            _this14.tabsData.forEach(function (item2, index2, arr2) {
              if (item == item2.signName) {
                rows.push(item2);
              }
            });
          });
          rows.forEach(function (item) {
            _this14.jobInformation.checkboxIds.forEach(function (item2, index, arr) {
              if (item.id == item2) {
                _this14.jobInformation.checkboxIds.splice(index, 1);
              }
            });
          });
          this.jobInformation.checkboxGroup = [];
        } else if (val == 2) {
          var _rows = [];
          this.jobInformation.checkboxGroup1.forEach(function (item) {
            _this14.tabsData2.forEach(function (item2, index2, arr2) {
              if (item == item2.signName) {
                _rows.push(item2);
              }
            });
          });
          _rows.forEach(function (item) {
            _this14.jobInformation.checkboxIds.forEach(function (item2, index, arr) {
              if (item.id == item2) {
                _this14.jobInformation.checkboxIds.splice(index, 1);
              }
            });
          });
          this.jobInformation.checkboxGroup1 = [];
        } else {
          var _rows2 = [];
          this.jobInformation.checkboxGroup2.forEach(function (item) {
            _this14.tabsData3.forEach(function (item2, index2, arr2) {
              if (item == item2.signName) {
                _rows2.push(item2);
              }
            });
          });
          _rows2.forEach(function (item) {
            _this14.jobInformation.checkboxIds.forEach(function (item2, index, arr) {
              if (item.id == item2) {
                _this14.jobInformation.checkboxIds.splice(index, 1);
              }
            });
          });
          this.jobInformation.checkboxGroup2 = [];
        }
      }
    },
    checkStore: function checkStore() {
      // 发布任务时输入的字段去掉，这里赋予默认值，如下
      this.jobInformation.jobType = '0'; // 岗位类型：不限
      this.jobInformation.customer = '默认客户'; // 服务对象
      this.jobInformation.dateType = '1125'; // 空
      this.jobInformation.welfareDetail = '无'; // 岗位福利
      this.jobInformation.salaryType = '3'; // 薪资要求：面议
      this.jobInformation.salarySettlement = '日结'; // 结算方式：日结
      this.jobInformation.salaryCycle = '150'; // 结算方式：日结
      if (!this.hasError || !this.bluring) {
        this.$emit('check-store', this.jobInformation, this.proDuringTime);
        this.saveWorkSquareInfo(this.jobInformation);
      }
    },
    cancelCheckStore: function cancelCheckStore() {
      var _this15 = this;

      this.$confirm('此操作将清空本页未保存的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        //清除store中第一页的数据
        _this15.saveWorkSquareInfo(null);
        //清除已经发布的状态，然后重新渲染
        _this15.workSquareIsEditMethods(false);
        _this15.$emit('resetThis');
      });
    },
    checkBoxValue: function checkBoxValue(val, type) {
      var self = this;
      var v = '';
      if (type == '任务说明') {
        v = self.taskInstructionsSigns1V.join(";");
        self.jobInformation.posDetail = v;
        if (!self.taskInstructionsSigns1V.includes('其他')) {
          self.jobInformation.otherPosDetail = '';
        }
      } else if (type == '任务要求') {
        v = self.taskInstructionsSigns2V.join(";");
        self.jobInformation.requirements = v;
        if (!self.taskInstructionsSigns2V.includes('其他')) {
          self.jobInformation.otherRequirements = '';
        }
      }
    },
    checkValue: function checkValue(val, type) {
      var _this16 = this;

      this.bluring = true;
      setTimeout(function () {
        _this16.bluring = false;
      }, 100);
      var errMag = '';
      if (type == '岗位类型' || type == '档期类型' || type == '结算方式' || type == '性别要求') {
        if (val == null || val == '' || val == undefined) {
          errMag = '\u8BF7\u9009\u62E9' + type + '!';
        }
      } else if (type == '联系人方式' || type == '督导电话') {
        if (val == null || val == '' || val == undefined) {
          // errMag = `请输入${type}!`
          errMag = '请输入联系人电话！';
        } else if (isNaN(parseInt(val))) {
          errMag = '请输入数字类型!';
        } else if (typeof parseInt(val) !== 'number') {
          errMag = '请输入数字类型!';
        } else if (!/^1[345789]\d{9}$/.test(val) && !/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/.test(val)) {
          errMag = '<span>请输入正确的电话号! <br/> 例：13611111111 或 010-88888888</span>';
        }
      } else if (type == 'daySalary' || type == 'monthSalary') {
        if (isNaN(Number(val))) {
          errMag = '岗位薪水请输入数字类型!';
        } else if (Number(val) < 0) {
          errMag = '请输入正确岗位薪水!';
        }
      }
      if (errMag !== '') {
        this.hasError = true;
        this.$notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          title: '提示',
          message: errMag,
          type: 'warning',
          dangerouslyUseHTMLString: true
        }, 'message', errMag));
      } else {
        this.hasError = false;
      }
    },
    checkValues: function checkValues(jobInformation) {
      var errMag = '';
      if (jobInformation.posName == null || jobInformation.posName == '' || jobInformation.posName == undefined) {
        errMag = "请输入岗位名称";
      } else if (jobInformation.jobType == null || jobInformation.jobType == '' || jobInformation.jobType == undefined) {
        errMag = "请选择岗位类型";
      } else if (jobInformation.customer == null || jobInformation.customer == '' || jobInformation.customer == undefined) {
        errMag = "请输入项目客户";
      } else if (jobInformation.dateType == null || jobInformation.dateType == '' || jobInformation.dateType == undefined) {
        errMag = "请选择档期类型";
      } else if (jobInformation.posDetail == null || jobInformation.posDetail == '' || jobInformation.posDetail == undefined) {
        errMag = "请输入任务说明";
      } else if (jobInformation.salaryDetail == null || jobInformation.salaryDetail == '' || jobInformation.salaryDetail == undefined) {
        errMag = "请输入薪资待遇";
      } else if (jobInformation.welfareDetail == null || jobInformation.welfareDetail == '' || jobInformation.welfareDetail == undefined) {
        errMag = "请输入岗位福利";
      } else if (jobInformation.requirements == null || jobInformation.requirements == '' || jobInformation.requirements == undefined) {
        errMag = "请输入任务要求";
      } else if (jobInformation.salaryType == null) {
        errMag = "请选择岗位薪水";
      } else if (jobInformation.salaryType == 1 && jobInformation.daySalary != null && jobInformation.daySalary != '' && jobInformation.daySalary != undefined && !isNaN(Number(jobInformation.daySalary)) && Number(jobInformation.daySalary) < 0) {
        errMag = "请输入正确岗位薪水";
      } else if (jobInformation.salaryType == 1 && (jobInformation.daySalary == null || jobInformation.daySalary == '' || jobInformation.daySalary == undefined)) {
        errMag = "请输入岗位薪水";
      } else if (jobInformation.salaryType == 1 && isNaN(Number(jobInformation.daySalary))) {
        errMag = "岗位薪水请输入数字类型!";
      } else if (jobInformation.salaryType == 2 && jobInformation.monthSalary != null && jobInformation.monthSalary != '' && jobInformation.monthSalary != undefined && !isNaN(Number(jobInformation.monthSalary)) && Number(jobInformation.monthSalary) < 0) {
        errMag = "请输入正确岗位薪水";
      } else if (jobInformation.salaryType == 2 && (jobInformation.monthSalary == null || jobInformation.monthSalary == '' || jobInformation.monthSalary == undefined)) {
        errMag = "请输入岗位薪水";
      } else if (jobInformation.salaryType == 2 && isNaN(Number(jobInformation.monthSalary))) {
        errMag = "岗位薪水请输入数字类型!";
      } else if (jobInformation.salarySettlement == null || jobInformation.salarySettlement == '' || jobInformation.salarySettlement == undefined) {
        errMag = "请选择结算方式";
      } else if (jobInformation.sexName == null || jobInformation.sexName == '' || jobInformation.sexName == undefined) {
        errMag = "请选择性别要求";
        // } else if (jobInformation.moName == null || jobInformation.moName == '' || jobInformation.moName == undefined) {
        //   errMag = "请输入联系人姓名";
        // } else if (jobInformation.moTel == null || jobInformation.moTel == '' || jobInformation.moTel == undefined) {
        //   errMag = "请输入联系人电话！";
        // } else if (isNaN(parseInt(jobInformation.moTel))) {
        //   errMag = '请输入数字类型!'
        // } else if (typeof parseInt(jobInformation.moTel) !== 'number') {
        //   errMag = '请输入数字类型!'
        // } else if (!(/^1[345789]\d{9}$/.test(jobInformation.moTel)) && !(/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/).test(jobInformation.moTel)) {
        //   errMag = '<span>请输入正确的电话号! <br/> 例：13611111111 或 010-88888888</span>'
      } /* else if (jobInformation.requirementsTel == null || jobInformation.requirementsTel == '' || jobInformation.requirementsTel == undefined) {
         errMag = "请输入联系人方式";
        } else if (isNaN(parseInt(jobInformation.requirementsTel))) {
         errMag = '请输入数字类型!'
        } else if (typeof parseInt(jobInformation.requirementsTel) !== 'number') {
         errMag = '请输入数字类型!'
        } else if (!(/^1[34578]\d{9}$/.test(jobInformation.requirementsTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(jobInformation.requirementsTel)) {
         errMag = '<span>请输入正确的电话号! <br/> 例：13611111111 或 010-88888888</span>'
        }*/
      //没必要校验下面这个
      // else if(jobInformation.searchType == null || jobInformation.searchType.length == 0){
      // 	errMag = '请选择粉丝可见或者会员可见！'
      // }
      else {
          this.jobPreviewDialog = true;
        }
      if (errMag !== '') {
        this.myNotify(this, 'error', errMag);
      }
    }
  })
});

/***/ }),

/***/ "sXZb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "snWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ss1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"systemNav"},[_c('div',{staticClass:"systemNavWrap"},_vm._l((_vm.pages),function(item){return _c('div',{class:{'isActive' : _vm.navState == item.nav},on:{"click":function($event){_vm.navState=item.nav}}},[_c('span',[(_vm.navState == item.nav)?_c('img',{attrs:{"src":item.checkedIcon}}):_vm._e(),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.navState != item.nav),expression:"navState != item.nav"}],attrs:{"src":item.icon}}),_vm._v("\n          "+_vm._s(item.name)+"明细查询")])])}),0)]),_vm._v(" "),_c('div',[(_vm.navState ==1)?_c('superDetail',{key:"score",attrs:{"auths":_vm.auths,"page":'积分',"scoreType":1}}):_vm._e(),_vm._v(" "),(_vm.navState ==2)?_c('superDetail',{key:"star",attrs:{"auths":_vm.auths,"page":'星级',"scoreType":2}}):_vm._e(),_vm._v(" "),(_vm.navState ==3)?_c('superDetail',{key:"pro",attrs:{"auths":_vm.auths,"page":'信用',"scoreType":3}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swku":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sxKq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "syeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonDetail_vue__ = __webpack_require__("t5lg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f61938e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonDetail_vue__ = __webpack_require__("p659");
function injectStyle (ssrContext) {
  __webpack_require__("UEaS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f61938e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salespersonDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f61938e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salespersonDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t5lg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_avatar_default_png__ = __webpack_require__("qvSl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_images_avatar_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_images_avatar_default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__ = __webpack_require__("hhm8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'salespersonDetail',
  data: function data() {
    return {
      isAdmin: false, //是否是tinashi或者admin1

      pageNo: 1,
      pageSize: 10,
      pageNoSyn: 1,
      pageSizeSyn: 10,
      total: null,
      totalSyn: null,
      starValue: null,
      salepersionData: {
        headImg: ''
      },
      tableData: [],
      tableDataSyn: [],
      addScore: '',
      addStar: '',
      addCredit: '',
      loading: false,
      isLong: false,
      isShort: false,

      avatarDefault: __WEBPACK_IMPORTED_MODULE_1_common_images_avatar_default_png___default.a,
      showbigImage: false,
      bigImage: null,
      bigImageWidth: null,
      bigImageHeight: null,
      bigImageWidth2: null,

      startName: null,
      nextstartName: null,
      precent: null,
      mindifferenceScore: null,
      poorScore: null,
      starName: null,
      // 项目所有客户
      customerList: [],
      // 显示签约合同记录
      showContractDialog: false,
      contractDialogTitle: null,
      contractLoading: false,
      // 签约合同记录筛选条件
      contractFormData: {
        pageNo: 1,
        pageSize: 10,
        startTimeFrom: null,
        startTimeTo: null,
        endTimeFrom: null,
        endTimeTo: null,
        customer: null,
        serviceSupplier: null
      },
      contractTotal: null,
      contractData: null,
      // auths:[]
      rightBoxHeight: '270px' //右侧盒子的高度动态获取和左侧一样高
    };
  },
  created: function created() {
    //不知道干啥的。。
    // for (let i = 0; i < this.$route.query.auths.length; i++) {
    //   this.auths.push (parseInt(this.$route.query.auths[i]))
    // }
    // console.log(this.auths)
  },
  mounted: function mounted() {
    var _this = this;

    this.rightBoxHeight = document.querySelector('.leftBox').clientHeight + 'px';
    var user = sessionStorage.getItem('user');
    this.isAdmin = Boolean(user == 'admin1' || user == 'tinashi');

    this.loading = true;
    this.$http({
      method: "POST",
      url: '/rest/SalesmanParticulars/basicInformation',
      params: {
        id: this.$route.query.id
        // id:'wwwww'
      }
    }).then(function (res) {
      var data = res.data;
      if (!_this.isAdmin) {
        data.originTel = data.tel;
        data.tel = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].plusXing(data.tel, 3, 4);
      }
      data.emergencyTel = __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].plusXing(data.emergencyTel, 3, 4);
      _this.salepersionData = data;
      _this.salepersionData.idcard = data.idcard;
      var join = _this.salepersionData.signName.join();
      if (join.indexOf('不限') >= 0) {
        _this.isLong = true;
        _this.isShort = true;
      } else {
        _this.isLong = join.indexOf('长促') >= 0;
        _this.isShort = join.indexOf('短促') >= 0;
      }
      _this.starValue = data.starScore / 10000 * 5;
      _this.getTableData();
      _this.getTableDataSyn();
      _this.loading = false;

      _this.$http({
        method: "GET",
        url: "/rest/SearchScoreDetails/searchNextStartName",
        params: {
          score: _this.salepersionData.starScore
        }
      }).then(function (res) {
        var data1 = res.data;
        _this.starName = data1.startName;
        _this.nextstartName = data1.nextstartName;
        _this.mindifferenceScore = data1.mindifferenceScore;
        _this.poorScore = data1.poorScore;
        _this.precent = data1.mindifferenceScore / data1.poorScore * 100;
      });
    }).catch(function () {
      _this.loading = false;
    });

    this.searchAllCustomer();
  },

  methods: {
    returnName: function returnName(name) {
      if (this.isAdmin) {
        return name;
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].plusXing(name, 1, 1);
      }
    },
    hideName: function hideName(val) {
      console.log(val);
      var a = val[0];
      if (this.isAdmin) {
        return val;
      } else {
        for (var i = 0; i < val.length - 1; i++) {
          a = a + '*';
        }
        return a;
      }
    },
    avatarImg: function avatarImg(url) {
      if (url != null) {
        return {
          backgroundImage: 'url(' + url + ')',
          backgroundSize: 'cover',
          width: '110px',
          height: '110px'
        };
      } else {
        return {
          backgroundImage: 'url(' + this.avatarDefault + ')',
          backgroundSize: 'cover',
          width: '110px',
          height: '110px'
        };
      }
    },
    avatarBigImg: function avatarBigImg(url) {
      if (url != null) {
        return {
          backgroundImage: 'url(' + url + ')',
          backgroundSize: 'cover',
          width: this.bigImageWidth,
          height: this.bigImageHeight
        };
      } else {
        return {
          backgroundImage: 'url(' + this.avatarDefault + ')',
          backgroundSize: 'cover',
          width: this.bigImageWidth,
          height: this.bigImageHeight
        };
      }
    },
    dialogWidth: function dialogWidth() {
      return {
        width: this.bigImageWidth
      };
    },
    showImage: function showImage(url) {
      this.showbigImage = true;
      this.bigImage = url;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.getTableData();
    },
    handleSizeChangeSyn: function handleSizeChangeSyn(val2) {
      this.pageSizeSyn = val2;
      this.getTableDataSyn();
    },
    handleCurrentChangeSyn: function handleCurrentChangeSyn(val2) {
      this.pageNoSyn = val2;
      this.getTableDataSyn();
    },
    getTableData: function getTableData() {
      var _this2 = this;

      this.$http({
        method: 'POST',
        url: '/rest/CrmWorkExperience/list',
        params: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          idCard: this.salepersionData.idcard
        }
      }).then(function (res) {
        _this2.tableData = res.data;
        _this2.rightBoxHeight = document.querySelector('.leftBox').clientHeight + 'px';
      });

      this.$http({
        method: 'POST',
        url: '/rest/CrmWorkExperience/countCrmWorkExperience',
        params: {
          // pageNo: this.pageNo,
          // pageSize: this.pageSize,
          idCard: this.salepersionData.idcard || 1
        }
      }).then(function (res) {
        _this2.total = Number(res.data);
      });
    },
    getTableDataSyn: function getTableDataSyn() {
      var _this3 = this;

      this.$http({
        method: 'POST',
        url: '/rest/CrmSynRest/findCrmWorkExperience',
        params: {
          pageNo: this.pageNoSyn,
          pageSize: this.pageSizeSyn,
          id: this.$route.query.id
        }
      }).then(function (res) {
        _this3.tableDataSyn = res.data;
        _this3.rightBoxHeight = document.querySelector('.leftBox').clientHeight + 'px';
      });

      this.$http({
        method: 'POST',
        url: '/rest/CrmSynRest/countCrmWorkExperience',
        params: {
          // pageNo: this.pageNo,
          // pageSize: this.pageSize,
          id: this.$route.query.id
        }
      }).then(function (res) {
        _this3.totalSyn = Number(res.data);
      });
    },


    // 图片出错
    setErrorImage: function setErrorImage(event) {
      event.target.parentNode.style.backgroundImage = 'url(' + this.avatarDefault + ')';
    },


    // 查看操作
    // viewEnhance(){
    //   this.
    // }

    // 虚拟拨号
    createOutCall: function createOutCall(salesmanId, salesmanName, salesmanTel) {
      var _this4 = this;

      // 获取当前用户虚拟电话配置
      this.$http({
        method: 'get',
        url: '/rest/JiangYiJoint/dummy-config',
        params: {
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        if (res.data.status == '200' && res.data.data) {
          var config = res.data.data;
          // 拨打虚拟电话
          var ajaxdata = {
            city: null,
            cityCode: null,
            county: null,
            countyCode: null,
            empPK: config.phoneUserEmpPk,
            module: "促销员库",
            phoneUserCode: config.phoneUserCode,
            phoneUserName: config.phoneUserName,
            projectBU: null,
            projectCode: null,
            projectName: null,
            province: null,
            provinceCode: null,
            salesId: salesmanId,
            salesName: salesmanName,
            storeCode: null,
            storeName: null,
            ivr: { called: salesmanTel, caller: config.phoneNumber }
          };
          var xhrs2 = new XMLHttpRequest();
          xhrs2.onreadystatechange = function () {
            if (xhrs2.readyState == 4) {
              if (xhrs2.status == 200) {
                // 成功不做任何事
                document.getElementById('mask_box').disabled = true;
                setTimeout(function () {
                  document.getElementById('mask_box').disabled = false;
                }, 5000);
                alert("号码呼叫中....");
              } else {
                var str = JSON.parse(xhrs2.responseText);
                document.getElementById('mask_box').disabled = true;
                setTimeout(function () {
                  document.getElementById('mask_box').disabled = false;
                }, 5000);
                alert(str.msg);
              }
            }
          };
          var callurl = _this4.globalParams.remotesUrl + "/plugs/phoneCall/createOutCall";
          xhrs2.open('POST', callurl, true);
          xhrs2.setRequestHeader("Content-type", "application/json");
          xhrs2.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ajaxdata));
        } else {
          alert("当前账号未配置虚拟拨号");
          console.log(res.data);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    // 查询所有项目客户
    searchAllCustomer: function searchAllCustomer() {
      var _this5 = this;

      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/all-customers'
      }).then(function (res) {
        _this5.customerList = res.data.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this5, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    openContractDialog: function openContractDialog(idcard, salesmanName) {
      this.contractDialogTitle = salesmanName;
      this.contractFormData.idcard = idcard;
      this.showContractDialog = true;
      this.searchContractData();
    },
    searchContractData: function searchContractData() {
      var _this6 = this;

      this.contractFormData.pageNo = 1;
      this.contractFormData.pageSize = 10;
      this.contractLoading = true;
      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/contract-history',
        params: this.contractFormData
      }).then(function (res) {
        _this6.contractData = res.data.data.items;
        _this6.contractTotal = res.data.data.totalItemsCount;
        _this6.contractLoading = false;
      }).catch(function (err) {
        _this6.contractLoading = false;
        __WEBPACK_IMPORTED_MODULE_2__common_js_util_js__["a" /* default */].myNotify(_this6, 'error', err.response, '查询失败，请稍后重试');
      });
    }
  },
  updated: function updated() {
    var width = document.getElementsByClassName('img')[0].width;
    var height = document.getElementsByClassName('img')[0].height;
    width > 500 ? (width = width / 2, height = height / 2) : (width, height);
    width < 300 ? (width = 300, height = 300) : (width, height);
    this.bigImageWidth = width + 'px';
    this.bigImageWidth2 = width + 40 + 'px';
    this.bigImageHeight = height + 'px';
  }
});

/***/ }),

/***/ "tNt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//韩金辰180724重写


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      loading: true,
      starSetArr: [],
      mainData: []
    };
  },

  props: ['scoreType'],
  mounted: function mounted() {
    var _this = this;

    this.$http({
      method: "get",
      url: '/rest/ScoreSystemSettings/searchScore',
      params: {
        startTime: this.$route.query.sTime,
        scoreType: this.scoreType
      }
    }).then(function (res) {
      var arr = [];
      res.data.map(function (item) {
        var noSame = true;
        arr.map(function (item2) {
          if (item2.masterId == item.masterId) {
            //signId还有可能是null，但这种情况不可能重复，所以不会进入masterId相等的判断
            noSame = false;
            //先把min max等数据推进对应的数组，再更新type属性，有可能是全选
            var type = item.signId == 1 ? 'long' : 'short';
            item2[type].push({
              min: item.scoreMin,
              max: item.scoreMax,
              score: item.score
            });
            var type2 = item.signId == 1 ? '长' : '短';
            if (item2.type.indexOf(type2) < 0) {
              item2.type.push(type2);
            }
          }
        });
        //如果arr中没有这个相同的item，则push进arr
        if (noSame) {
          var type = item.signId ? item.signId == 1 ? ['长'] : ['短'] : []; //signId是null时，不显示长短促，仅显示分值
          var long = [];
          var short = [];
          var onlyScore = -1;
          if (type.length > 0) {
            (type[0] == '长' ? long : short).push({
              min: item.scoreMin,
              max: item.scoreMax,
              score: item.score
            });
          } else {
            onlyScore = item.score;
          }
          arr.push({
            name: item.masterName,
            masterId: item.masterId,
            type: type,
            long: long,
            short: short,
            onlyScore: onlyScore //是-1的时候说明不是仅展示分数的，是展示长短促的
          });
        }
      });
      _this.mainData = arr; //一顿操作之后赋给页面主数据
      _this.loading = false;
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
      _this.loading = false;
    });
    //本页有个写死的星级设定，从这里取
    this.$http({
      method: "get",
      url: '/rest/ScoreSystemSettings/searchStar',
      params: {
        startTime: this.$route.query.id
      }
    }).then(function (res) {
      res.data.map(function (item) {
        var arr = [];
        if (item.signId == 1) {
          arr.push;
        }
      });
      _this.starSetArr = res.data;
    });
  }
});

/***/ }),

/***/ "tmg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_importScore_vue__ = __webpack_require__("HtIy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94796fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_importScore_vue__ = __webpack_require__("OoVD");
function injectStyle (ssrContext) {
  __webpack_require__("3kNb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94796fda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_importScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94796fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_importScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ttW4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ0QkY4N0VEREZBRjExRTdBNjIxRkVGRDY2QTVFMTQ1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQ0QkY4N0VFREZBRjExRTdBNjIxRkVGRDY2QTVFMTQ1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDRCRjg3RUJERkFGMTFFN0E2MjFGRUZENjZBNUUxNDUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDRCRjg3RUNERkFGMTFFN0E2MjFGRUZENjZBNUUxNDUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7uGBqcAAACQ0lEQVR42pxUz4vTQBTOZPKrbHaxXbdtVmoFI60/igdPeha8iAcPYhVFhdYVPAmedEVB7x7tuUUFWRarf4MeF1pRVrvt9mTbbLdJa5qkJqlvli6imybowCPDfG++9837HkGZEw8ov3X6jILJ9+OHBccLr1Sf7nwZKmC1W6HsZFvyy6MD1DDdLr9Mguz/m6j1PXR5koNbv5X9GxFRsL3NL0ci1rMwRHeLf+inip5CwiodIUfwuGSUJMkoIkQx5IxgXndQPp/n2m3hdr/PpWwbyWMXyRi7ScdFViQ8yjUa4iuSmDz045ra417QNMXZDmpiPK4xzLg2Nzdaj8XMAg22jlwXqcYQL0UXzLVUWruUSvfjmsqJuyRkNTfFoqZxM+mjWkKWB9fnI9aXoY6XyN1CoTDaedpmQyxGo2a21Q7lej1OBPLutF4A1tJ1hla2hKugJFsuPy/+0SOo/mb/vHUD5mb1sDw4N41IPjI4CzlvIfcWuePZ7HpdfC8tGrlORyhDUwUPE0LQz3eSNMyRXF/XoIkDakwp8ATT41kGYCqNqUGg/ZrKZsCNykTB7OKB4WOIR7AXJ4U+qz02E0hkWjjD887XREK/V62E60OdOQ9x4VN138bBpH6X49xv1gjvIdozqfZPlLFM9iRUXo/FjTvg5go5h2G8qCjCE8dBKcDWfIlAPt1szrAC794EkpfQE3ejNrsLrwC+Co5dMS36/rHjKplBd6qiZFI/BQk2uOI1Q+RiCQhf+yqaJLpB/yhS6O+zXwIMAK/4DCG9ERxSAAAAAElFTkSuQmCC"

/***/ }),

/***/ "tu0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//180717韩金辰全面整理优化


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      float1Loading: false, //行业标签，岗位类型，自我标签，数据加载的loading
      float2Loading: false,
      float3Loading: false,
      addDialogLoading: false, //自我标签的弹窗loading
      signList: [], //主页面行业标签，岗位类型，自我标签，数据存放
      postList: [],
      selfLabel: [],
      screenWidth: document.body.clientWidth, //视窗宽度，计算列数
      //树形结构的默认配置
      defaultProps: {
        children: "children",
        label: "label"
      },

      categoryDialog: false, //点击主页行业标签，岗位类型树的编辑二级弹窗
      categoryDialogTitle: "",
      categoryDialogSignType: "", //弹框标志位，1行业品类，2岗位类型
      categoryDialogList: [], //弹框中的树形数据

      addTreeLabelDialog: false, //行业品类、岗位类型三级弹窗
      addTreeLabelDialogLoading: false,
      addTreeLabelDialogList: [],
      addTreeLabelDialogInput: "",
      addTreeLabelDialogSignLevel: "",
      addTreeLabelDialogSignType: "",
      addTreeLabelDialogPid: "",

      addDialog: false, //自我标签二级弹窗
      addDialogList: [],
      addDialogInput: "",

      addList: [], //需要添加的数据中转存储在这里，其实不用这个，现在既然用了就最好别动他否则大改
      auths: [], // 页面内权限
      expandedIds: [],

      editLabelNameDialog: false, // 修改标签名
      editForm: {
        jobTypeName: null,
        data: null,
        node: null,
        signType: null
      }
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getAuth();
    var _this = this;
    window.onresize = function temp() {
      _this.screenWidth = document.documentElement.clientWidth;
    };
  },

  computed: {
    //样式相关,根据视窗宽度计算列数
    treeCol: function treeCol() {
      var width = this.screenWidth;
      var cols = 0;
      if (width < 1440) {
        cols = 3;
      } else if (width < 1640) {
        cols = 4;
      } else if (width < 1890) {
        cols = 5;
      } else {
        cols = 6;
      }
      var data = [];
      for (var i = 0; i < cols; i++) {
        data.push(i);
      }
      return data;
    },

    categoryDialogLoading: {
      get: function get() {
        var flag = false;
        if (this.categoryDialog) {
          flag = this.categoryDialogSignType == 1 ? this.float1Loading : this.float2Loading;
        }
        return flag;
      },
      set: function set(newVal) {}
    }
  },
  methods: {
    /*
    工具类
    */
    //工具类-树形结构解析相关
    pushChildren: function pushChildren(data, arr) {
      var _this2 = this;

      arr.forEach(function (item) {
        if (item.value == data.pid) {
          item.children.push({
            value: data.id,
            label: data.signName,
            signLevel: data.signLevel,
            pid: data.pid,
            children: []
          });
        } else {
          _this2.pushChildren(data, item.children);
        }
      });
    },

    //工具类-树形结构解析相关
    clearEmptyChildren: function clearEmptyChildren(arr) {
      var _this3 = this;

      arr.forEach(function (item) {
        if (item.children.length === 0) {
          delete item.children;
        } else {
          _this3.clearEmptyChildren(item.children);
        }
      });
    },

    /*
    主页面相关--一级
    */
    //获取数据-行业品类、岗位类型、自我标签
    //有时候需要更新数据后重新打开弹框，所以传这个参数
    getData: function getData(openDialog) {
      var _this4 = this;

      // 行业品类
      this.float1Loading = true;
      this.$http({
        method: "GET",
        url: "/rest/projectSign/getSignLst",
        params: {
          signType: 1
        }
      }).then(function (res) {
        _this4.float1Loading = false;
        var data = res.data;
        _this4.signList = [];
        data.map(function (item) {
          item.map(function (item2) {
            if (item2.signLevel == 1) {
              _this4.signList.push({
                value: item2.id,
                label: item2.signName,
                signLevel: item2.signLevel,
                pid: item2.pid,
                children: []
              });
            } else if (item2.signLevel > 1) {
              _this4.pushChildren(item2, _this4.signList);
            }
          });
        });
        _this4.clearEmptyChildren(_this4.signList);
        if (openDialog == '行业品类') {
          _this4.showCategoryDialog(openDialog, 1);
        }
      }).catch(function (err) {
        _this4.float1Loading = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
      });

      // 岗位类型
      this.float2Loading = true;
      this.$http({
        method: "GET",
        url: "/rest/projectSign/getSignLst",
        params: {
          signType: 2
        }
      }).then(function (res) {
        _this4.float2Loading = false;
        var data = res.data;
        _this4.postList = [];
        data.map(function (item) {
          item.map(function (item2) {
            if (item2.signLevel == 1) {
              _this4.postList.push({
                value: item2.id,
                label: item2.signName,
                signLevel: item2.signLevel,
                pid: item2.pid,
                children: []
              });
            } else if (item2.signLevel > 1) {
              _this4.pushChildren(item2, _this4.postList);
            }
          });
        });
        _this4.clearEmptyChildren(_this4.postList);
        if (openDialog == '岗位类型') {
          _this4.showCategoryDialog(openDialog, 2);
        }
      }).catch(function (err) {
        _this4.float2Loading = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
      });

      // 自我标签
      this.float3Loading = true;
      if (openDialog == '自我标签') {
        this.addDialogLoading = true;
      }
      this.$http({
        method: "GET",
        url: "/rest/sign/search",
        params: {
          signType: 3,
          signLevel: null,
          pid: null
        }
      }).then(function (res) {
        _this4.float3Loading = false;
        _this4.addDialogLoading = false;
        _this4.selfLabel = res.data;
      }).catch(function (err) {
        _this4.addDialogLoading = false;
        _this4.float3Loading = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this4, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //获取权限
    getAuth: function getAuth() {
      var _this5 = this;

      this.$http({
        method: "GET",
        url: "/rest/sysUser/getSysUserWebAuth",
        params: {
          webId: 8,
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        res.data.map(function (item) {
          _this5.auths.push(item.auth);
        });
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this5, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //收起展开一级选项栏
    toggleSlide: function toggleSlide(event) {
      var target = event.target;
      var parentNode = target.parentNode;
      if (parentNode.offsetHeight > 40) {
        target.className = "toggle-btn";
        parentNode.style.height = 40 + "px";
      } else {
        target.className = "toggle-btn up";
        parentNode.style.height = "auto";
      }
    },

    // 主页面的树，右上角点击编辑（行业和岗位标签）
    showCategoryDialog: function showCategoryDialog(dialogTitle, signType) {
      this.categoryDialog = true;
      this.categoryDialogList = signType == 1 ? this.signList : this.postList; //不是1就是2,1行业品类2岗位类型
      this.categoryDialogTitle = dialogTitle;
      this.categoryDialogSignType = signType;
    },

    // 主页面的树，右上角点击编辑（自我标签）
    openAddDialog: function openAddDialog() {
      this.addDialogList = this.selfLabel.slice(0);
      this.addDialog = true;
      this.addList = [];
    },

    //收起展开一级选项栏,点击tree标签上的箭头的时候
    overToggle: function overToggle(from) {
      // 跟this.toggleSlide类似，但事件对象不同(这里必须从全局event里拿)，逻辑也不大相同
      var target = event.target;
      //.......额
      var parentNode = target.parentNode.parentNode.parentNode.parentNode.parentNode;
      if (from == 'button') parentNode = parentNode.parentNode;
      var toggle_btn = parentNode.getElementsByClassName('toggle-btn');
      setTimeout(function () {
        if (parentNode.offsetHeight <= 40) {
          if (toggle_btn.length > 0) {
            toggle_btn[0].className = "toggle-btn up";
          }
          parentNode.style.height = "auto";
        }
      }, 50);
    },

    /*
    编辑弹框相关--二级
    */
    //编辑弹窗中的删除单行功能
    remove: function remove(node, data, signType) {
      var _this6 = this;

      var pid = data.pid;
      var signId = data.value;
      this.expandedIds = [];
      this.$confirm("此操作将永久删除该标签及该标签下所有子标签, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this6.categoryDialogSignType == 1 ? _this6.float1Loading = true : _this6.float2Loading = true;
        _this6.$http({
          method: "POST",
          url: "/rest/salesman/deleteSalesmanSign",
          params: {
            signId: signId
          }
        }).then(function () {
          // 编辑项目标签(含解绑)
          _this6.$http({
            method: "POST",
            url: '/rest/projectSign/deleteProjectSign',
            params: {
              signId: signId
            }
          }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this6, 'success', res, '操作成功');
            // 删除标签时，相应的促销员标签也要删除
            _this6.$http({
              method: "POST",
              url: "/rest/sign/delete",
              data: [{
                id: data.value,
                signName: data.label,
                signType: signType,
                pid: null,
                signLevel: data.signLevel
              }]
            }).catch(function (err) {
              __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this6, 'error', err.response, '操作失败，请稍后重试');
            }).then(function () {
              _this6.getData(signType == 1 ? '行业品类' : '岗位类型');
              _this6.expandedIds.push(pid);
            });
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this6, 'error', err.response, '操作失败，请稍后重试');
          });
        });
      });
    },

    //编辑弹窗中的修改标签按钮
    editLabelName: function editLabelName(node, data) {
      this.editLabelNameDialog = true;
      this.editForm.jobTypeName = data.label;
      this.categoryDialogTitle == '行业品类' ? this.editForm.signType = 1 : this.editForm.signType = 2;
      this.editForm.data = data;
      this.editForm.node = data.node;
    },

    //主页树-右上角编辑-弹框中右上角添加
    openAddTreeLabelDialog: function openAddTreeLabelDialog(signLevel, signType, pid) {
      console.log(pid);
      this.addTreeLabelDialog = true;
      this.addTreeLabelDialogList = [];
      this.addTreeLabelDialogSignLevel = signLevel;
      this.addTreeLabelDialogSignType = signType;
      this.addTreeLabelDialogPid = pid;

      this.addList = [];
    },

    //自我标签二级弹框，点击'列表中删除按钮'
    deleteSelfLabel: function deleteSelfLabel(data) {
      var _this7 = this;

      // 有id要弹窗确认，成功删除后再更新列表
      var signId = data.id;
      if (signId) {
        this.$confirm("此操作将永久删除该标签, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this7.addDialogLoading = true;
          _this7.$http({
            method: "POST",
            url: "/rest/salesman/deleteSalesmanSign",
            params: {
              signId: signId
            }
          }).then(function () {
            // 删除标签时，相应的促销员标签也要删除
            _this7.$http({
              method: "POST",
              url: "/rest/sign/delete",
              data: [{
                id: data.id,
                signName: data.signName,
                signType: 3,
                pid: null,
                signLevel: null
              }]
            }).then(function (res) {
              _this7.addDialogLoading = false;
              __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this7, 'success', res, '操作成功');
              _this7.addDialogList.forEach(function (item, index, arr) {
                if (item.signName === data.signName && item.id === data.id) {
                  arr.splice(index, 1);
                }
              });
              _this7.addList.forEach(function (item, index, arr) {
                if (item.signName === data.signName && item.id === data.id) {
                  arr.splice(index, 1);
                }
              });
              _this7.getData('自我标签');
            }).catch(function (err) {
              _this7.addDialogLoading = false;
              __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this7, 'error', err.response, '查询失败，请稍后重试');
            });
          });
        });
      } else {
        this.addDialogList.forEach(function (item, index, arr) {
          if (item.signName === data.signName && item.id === data.id) {
            arr.splice(index, 1);
          }
        });
        this.addList.forEach(function (item, index, arr) {
          if (item.signName === data.signName && item.id === data.id) {
            arr.splice(index, 1);
          }
        });
      }
    },

    /*
    编辑弹框相关--三级
    */
    //编辑弹窗-修改标签-三级弹窗点击确认
    saveEditLabel: function saveEditLabel() {
      var _this8 = this;

      this.$confirm("此操作将修改该标签名称, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var editLabel = [{
          id: _this8.editForm.data.value,
          signName: _this8.editForm.jobTypeName,
          signType: _this8.editForm.signType
        }];
        _this8.$http({
          method: "POST",
          url: "/rest/sign/saveUpdate",
          data: editLabel
        }).then(function (res) {
          _this8.expandedIds = [];
          __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this8, 'success', res, '操作成功');
          _this8.editLabelNameDialog = false;
          setTimeout(function () {
            if (_this8.editForm.signType == 1) {
              _this8.showCategoryDialog("行业品类", 1);
            } else if (_this8.editForm.signType == 2) {
              _this8.showCategoryDialog("岗位类型", 2);
            }
          }, 500);
          _this8.getData();
          _this8.expandedIds.push(_this8.editForm.data.pid);
        }).catch(function (err) {
          if (err.response.data.status == 400) {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this8, 'error', '该标签已存在！');
          } else {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this8, 'error', err.response, '操作失败');
          }
        });
      });
    },

    //自我标签二级弹框-或者行业和岗位标签三级弹窗中，点击'确认添加'的通用方法
    addNewLabel: function addNewLabel(signName, signLevel, signType, pid, arr) {
      if (signName.replace(/\s+/g, '') == "") {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(this, 'warning', "您输入的内容为空");
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].signName === signName) {
            __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(this, 'warning', "您输入的标签内容重复，请重新输入");
            return false;
          }
        }
        this.addList.push({
          signName: signName,
          signType: signType,
          pid: pid,
          signLevel: signLevel
        });
        arr.push({
          signName: signName,
          signType: signType,
          pid: pid,
          signLevel: signLevel
        });
        this.addDialogInput = "";
        this.addTreeLabelDialogInput = "";
      }
    },

    //行业和岗位标签三级弹窗中，点击'列表中删除按钮'
    deleteLabel: function deleteLabel(data) {
      this.addTreeLabelDialogList.forEach(function (item, index, arr) {
        if (item.signName === data.signName && item.id === data.id) {
          arr.splice(index, 1);
        }
      });
      this.addList.forEach(function (item, index, arr) {
        if (item.signName === data.signName && item.id === data.id) {
          arr.splice(index, 1);
        }
      });
    },

    //添加标签最终点击确认时的通用方法
    saveUpdate: function saveUpdate(signType) {
      var _this9 = this;

      this.expandedIds = [];
      if (this.addList.length === 0) {
        this.addDialog = false;
        this.addTreeLabelDialog = false;
        return false;
      }
      signType == 3 ? this.addDialogLoading = true : this.addTreeLabelDialogLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/sign/saveUpdate",
        data: this.addList
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this9, 'success', res, '操作成功');
        _this9.getData(signType == 1 ? '行业品类' : signType == 2 ? '岗位类型' : null);
        _this9.expandedIds.push(_this9.addList[0].pid);
        _this9.addDialog = false;
        signType == 3 ? _this9.addDialogLoading = false : _this9.addTreeLabelDialogLoading = false;
        _this9.addTreeLabelDialog = false;
        // this.categoryDialog = false
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* default */].myNotify(_this9, 'error', err.response, '查询失败，请稍后重试');
        signType == 3 ? _this9.addDialogLoading = false : _this9.addTreeLabelDialogLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "u+6Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u6jE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlDREM5M0Q0Qzg0ODExRTc4OTJDQjJBMUQ2MEQzQUI2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlDREM5M0Q1Qzg0ODExRTc4OTJDQjJBMUQ2MEQzQUI2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUNEQzkzRDJDODQ4MTFFNzg5MkNCMkExRDYwRDNBQjYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUNEQzkzRDNDODQ4MTFFNzg5MkNCMkExRDYwRDNBQjYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz42yeGVAAABSUlEQVR42ozSzyuEQRzH8cGmpJajHNyVKEWcNu1BIUncJAcObn6UUChKjiQHPxJ7Iw6Uk1zIgZu9cHbwY2vDX/B4T32eGtM8rW+9ema+O893v8/MlEVRZFZv1owTDZhHL2rwgyts4NVduJxdMuXmb2Rwhxe0olbPZ+Uz3nqTcsb1OEY/npx8Edu4xSU68Rb/6HYwhy29XIFpnGFWc5vf1DoTKtCHnMb2pSx20YUZ5XNaFyyQVrs2erCAayxqQ+PPSScVKKBO4zyGUaln3tmnQlKBU4xqvIJmbVaL5jZGcJJ0Cge4xw6+MOCdWDUm0ZHUgf23C0yZcNj8OT6TOrBhr+QjDvHu3ZExtPlV/ZtY1JXd8/L7WMd3qQLxXlRhXPMJdXoU+q5UIBfpNB7QhEG0K2/+00G8oUPo1j34SFgX7CAO20GjKRG/AgwA925DaXRg3EgAAAAASUVORK5CYII="

/***/ }),

/***/ "uCnF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ1NEFEOTU2REZBRjExRTdBQzRDQjZFNjlBMUQ4QjU1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQ1NEFEOTU3REZBRjExRTdBQzRDQjZFNjlBMUQ4QjU1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDU0QUQ5NTRERkFGMTFFN0FDNENCNkU2OUExRDhCNTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDU0QUQ5NTVERkFGMTFFN0FDNENCNkU2OUExRDhCNTUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6WJNoWAAABZElEQVR42syUPUvDUBSGW3FSJxFEEVwdbBaH4hTspCA41KVkqDRYKK1kcBIdHYTi0M1Fwc2p0En/gU4ZEvoDBFHEj0FFx/hceCPB1i/I4IWHc8+557735CQ32SiKMmmMgUxKI5ub3U76HmzCq/wRGIdbeFFsCPahZZwg3O2pyIg4kIcZzZ9hS9ZRPK+5l6xg8JPICtzABBzCHhzDnfwlrZu8jva24oqMSB0OYA5KcApdeIBl2a7iJeWZ/LqV2/HiHj1ir+FKJ0zCNJz36ek8XCrfjCmTT59GTUU2vEEbFsGSaFN+TFNxS35b++z40UKowDpUdVJHPUsOJ9GXqvIrVBMmmx2LHck3DT6DMbiXXVAlHyLa1/P6TdCFDZV7ATWt1eTbWneTIv2+7ADK0FBDi4oX5Te0HvzmiviwBgUYhhPZguL+X+6ar/KNwKqs+5XIT5fW15t6kvW/vbT/7jeSmtC7AAMAd+1brQfaSc0AAAAASUVORK5CYII="

/***/ }),

/***/ "uCw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-search"},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"100px","size":"mini"}},[_c('el-form-item',[_c('el-button',{staticClass:"search-btn",staticStyle:{"float":"left"},on:{"click":_vm.getData}},[_vm._v("查询")]),_vm._v(" "),(_vm.editAuth)?_c('el-button',{staticClass:"search-btn",staticStyle:{"float":"left","margin-left":"0px!important"},on:{"click":_vm.addVirtualProjectDialog}},[_vm._v("新增\n          ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"common-box-body"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","element-loading-text":"拼命加载中","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","align":"center","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectCode","label":"项目编号","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectName","label":"项目名称","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceSupplier","label":"签约平台","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"项目状态","align":"center","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 0)?_c('div',[_vm._v("已结束")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('div',[_vm._v("进行中")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"companyName","label":"所属公司","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"batchNo","label":"任务批次","align":"center","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierCode","label":"供应商编号","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplierName","label":"供应商名称","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceId","label":"服务商编号","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceNm","label":"服务商名称","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"beginDate","label":"供应商开始日期","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endDate","label":"供应商结束日期","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateTime","label":"更新时间","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updatedBy","label":"操作者","align":"center","width":"100"}}),_vm._v(" "),(_vm.editAuth)?_c('el-table-column',{attrs:{"label":"操作","align":"center","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.getVirtualProjectInfo(scope.row.id)}}},[_vm._v("修改")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.supplierListDialog(scope.row.projectCode)}}},[_vm._v("供应商维护")])]}}],null,false,2332862713)}):_vm._e()],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formConditionData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formConditionData.pageSize,"layout":"slot, total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑项目信息","visible":_vm.showAddDialog,"width":"40%","center":""},on:{"update:visible":function($event){_vm.showAddDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"add-select",staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('el-form',{ref:"addData",attrs:{"model":_vm.addData,"label-width":"200px","size":"small","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"项目编号1","required":true}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"text","size":"small","disabled":this.addData.id != null,"placeholder":"请输入项目编号","maxlength":"20"},nativeOn:{"keyup":function($event){return _vm.inputLimit2.apply(null, arguments)}},model:{value:(_vm.addData.projectCode),callback:function ($$v) {_vm.$set(_vm.addData, "projectCode", $$v)},expression:"addData.projectCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","required":true}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"text","size":"small","placeholder":"请输入项目名称","maxlength":"50"},nativeOn:{"keyup":function($event){return _vm.inputLimit3.apply(null, arguments)}},model:{value:(_vm.addData.projectName),callback:function ($$v) {_vm.$set(_vm.addData, "projectName", $$v)},expression:"addData.projectName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"签约平台","required":true}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择签约平台..."},model:{value:(_vm.addData.serviceSupplier),callback:function ($$v) {_vm.$set(_vm.addData, "serviceSupplier", $$v)},expression:"addData.serviceSupplier"}},_vm._l((_vm.serviceSuppliers),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目状态","required":true}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择项目状态..."},model:{value:(_vm.addData.status),callback:function ($$v) {_vm.$set(_vm.addData, "status", $$v)},expression:"addData.status"}},[_c('el-option',{attrs:{"label":"进行中","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已结束","value":0}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属公司","required":true}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择所属公司...","clearable":""},model:{value:(_vm.addData.company),callback:function ($$v) {_vm.$set(_vm.addData, "company", $$v)},expression:"addData.company"}},_vm._l((_vm.companiesAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务批次","required":true}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"text","size":"small","placeholder":"请输入任务批次","maxlength":"10"},nativeOn:{"keyup":function($event){return _vm.inputLimit4.apply(null, arguments)}},model:{value:(_vm.addData.batchNo),callback:function ($$v) {_vm.$set(_vm.addData, "batchNo", $$v)},expression:"addData.batchNo"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.addVirtualProject}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showAddDialog=false}}},[_vm._v("取消")])],1)],1)]),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.supplierListLoading),expression:"supplierListLoading"}],staticClass:"dialog",attrs:{"title":"供应商维护","visible":_vm.showSupplierDialog,"width":"70%","center":""},on:{"update:visible":function($event){_vm.showSupplierDialog=$event}}},[_c('el-form',{staticClass:"formInline",attrs:{"inline":true,"label-width":"150px","size":"mini"}},[_c('el-form-item',{staticStyle:{"float":"left"}},[_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.editSupplierDialog()}}},[_vm._v("新增")])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('el-table',{staticClass:"table-expand",staticStyle:{"width":"100%"},attrs:{"size":"small","border":"","data":_vm.supplierTableData}},[_c('el-table-column',{attrs:{"width":"100","type":"index","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"supplierCode","label":"供应商编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"supplierName","label":"供应商名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"supplierBank","label":"供应商开户行","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"supplierBankAccount","label":"供应商银行账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"serviceId","label":"服务商编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"serviceNm","label":"服务商名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"serviceOpenBank","label":"服务商开户行","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"serviceOpenBankCardNo","label":"服务商银行账号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"beginDate","label":"供应商开始日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"endDate","label":"供应商结束日期","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"updatedBy","label":"操作者","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"updateTime","label":"操作时间","align":"center"}}),_vm._v(" "),(_vm.editAuth)?_c('el-table-column',{attrs:{"label":"操作","align":"center","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"color":"#1652ff","cursor":"pointer"},on:{"click":function($event){return _vm.editSupplierDialog(scope.row.id)}}},[_vm._v("修改")])]}}],null,false,2892023848)}):_vm._e()],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.supplierConditionData.pageNo,"page-sizes":[10, 20, 50, 100],"page-size":_vm.supplierConditionData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.supplierTotal},on:{"size-change":_vm.handleSupplierSizeChange,"current-change":_vm.handleSupplierCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"供应商维护","visible":_vm.showSupplierEditDialog,"width":"40%","center":""},on:{"update:visible":function($event){_vm.showSupplierEditDialog=$event}}},[_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"add-select",staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('el-form',{ref:"editSupplierData",attrs:{"model":_vm.editSupplierData,"label-width":"200px","size":"small","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"选择供应商","required":true}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择供应商...","clearable":"","disabled":_vm.editSupplierFlag},on:{"change":function($event){return _vm.searchOpenBanks(1)},"clear":function($event){_vm.editSupplierData.supplierBank = null,_vm.editSupplierData.supplierBankAccount = null}},model:{value:(_vm.editSupplierData.supplier),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "supplier", $$v)},expression:"editSupplierData.supplier"}},_vm._l((_vm.suppliersAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"供应商开户行","required":true}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择供应商开户行...","disabled":_vm.editSupplierFlag,"clearable":""},on:{"change":function($event){return _vm.searchOpenBankNos(1)},"clear":function($event){_vm.editSupplierData.supplierBankAccount = null}},model:{value:(_vm.editSupplierData.supplierBank),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "supplierBank", $$v)},expression:"editSupplierData.supplierBank"}},_vm._l((_vm.openBanks),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"供应商银行账号","required":true}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","disabled":_vm.editSupplierFlag,"placeholder":"请选择供应商银行账号...","clearable":""},model:{value:(_vm.editSupplierData.supplierBankAccount),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "supplierBankAccount", $$v)},expression:"editSupplierData.supplierBankAccount"}},_vm._l((_vm.openBankNos),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"选择服务商"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择服务商...","clearable":"","disabled":_vm.editSupplierFlag},on:{"change":function($event){return _vm.searchOpenBanks(2)},"clear":function($event){_vm.editSupplierData.serviceOpenBank = null,_vm.editSupplierData.serviceOpenBankCardNo = null}},model:{value:(_vm.editSupplierData.service),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "service", $$v)},expression:"editSupplierData.service"}},_vm._l((_vm.servicesAll),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"服务商开户行"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","placeholder":"请选择服务商开户行...","disabled":_vm.editSupplierFlag,"clearable":""},on:{"change":function($event){return _vm.searchOpenBankNos(2)},"clear":function($event){_vm.editSupplierData.serviceOpenBankCardNo = null}},model:{value:(_vm.editSupplierData.serviceOpenBank),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "serviceOpenBank", $$v)},expression:"editSupplierData.serviceOpenBank"}},_vm._l((_vm.serviceOpenBanks),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"服务商银行账号"}},[_c('el-select',{attrs:{"value-key":"code","filterable":"","disabled":_vm.editSupplierFlag,"placeholder":"请选择服务商银行账号...","clearable":""},model:{value:(_vm.editSupplierData.serviceOpenBankCardNo),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "serviceOpenBankCardNo", $$v)},expression:"editSupplierData.serviceOpenBankCardNo"}},_vm._l((_vm.serviceOpenBankNos),function(item){return _c('el-option',{key:item,attrs:{"label":item.name,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"供应商开始日期","required":true}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.editSupplierData.beginDate),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "beginDate", $$v)},expression:"editSupplierData.beginDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"供应商结束日期","required":true}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.editSupplierData.endDate),callback:function ($$v) {_vm.$set(_vm.editSupplierData, "endDate", $$v)},expression:"editSupplierData.endDate"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"search-btn",on:{"click":_vm.editSupplier}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){_vm.showSupplierEditDialog=false}}},[_vm._v("取消")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uI/1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uaAe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v/xe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"postEdit"},[_c('div',{staticStyle:{"width":"980px","overflow":"scroll","overflow-x":"hidden","height":"600px"}},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_vm._v("任务信息")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务名称")]),_vm._v(" "),_c('el-input',{staticClass:"formInpWid",attrs:{"size":"mini","placeholder":"请输入任务名称..."},on:{"blur":function($event){return _vm.checkValue(_vm.jobInformation.jobName,'任务名称')}},model:{value:(_vm.jobInformation.jobName),callback:function ($$v) {_vm.$set(_vm.jobInformation, "jobName", $$v)},expression:"jobInformation.jobName"}})],1),_vm._v(" "),_c('div',{staticClass:"formArea"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("性别要求")]),_vm._v(" "),_c('el-select',{staticClass:"formInpWid",attrs:{"size":"mini","placeholder":"请选择...","clearable":false},on:{"change":function($event){return _vm.checkValue(_vm.jobInformation.sex,'性别要求')}},model:{value:(_vm.jobInformation.sex),callback:function ($$v) {_vm.$set(_vm.jobInformation, "sex", $$v)},expression:"jobInformation.sex"}},_vm._l((_vm.sexOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.sex,"value":item.sex}})}),1)],1)]),_vm._v(" "),_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务说明")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"90%"}},_vm._l((_vm.taskInstructionsSigns1),function(item,index){return _c('label',{key:index,staticStyle:{"font-size":"14px","color":"#606266","line-height":"27px","padding-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskInstructionsSigns1V),expression:"taskInstructionsSigns1V"}],staticStyle:{"vertical-align":"middle","width":"16px","height":"16px","margin-right":"10px"},attrs:{"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.taskInstructionsSigns1V)?_vm._i(_vm.taskInstructionsSigns1V,item)>-1:(_vm.taskInstructionsSigns1V)},on:{"change":[function($event){var $$a=_vm.taskInstructionsSigns1V,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.taskInstructionsSigns1V=$$a.concat([$$v]))}else{$$i>-1&&(_vm.taskInstructionsSigns1V=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.taskInstructionsSigns1V=$$c}},function($event){return _vm.checkBoxValue(item,'任务说明')}]}}),_vm._v(_vm._s(item)+"\n            ")])}),0),_vm._v(" "),_c('label',{staticStyle:{"font-size":"14px","color":"#8B8D91","line-height":"27px","padding-right":"15px","margin-left":"10%","float":"left"}},[_vm._v("\n              "+_vm._s(_vm.jobInformation.jobDescription)+"\n            ")]),_vm._v(" "),(_vm.taskInstructionsSigns1V.includes('其他'))?_c('el-input',{staticStyle:{"margin":"10px 0 0 92px","width":"calc(5% - 150px)"},attrs:{"type":"textarea","placeholder":"请输入其他说明","maxlength":500},model:{value:(_vm.jobInformation.otherPosDetail),callback:function ($$v) {_vm.$set(_vm.jobInformation, "otherPosDetail", $$v)},expression:"jobInformation.otherPosDetail"}}):_vm._e()],1)]),_vm._v(" "),_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("任务要求")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"90%"}},_vm._l((_vm.taskInstructionsSigns2),function(item,index){return _c('label',{key:index,staticStyle:{"font-size":"14px","color":"#606266","line-height":"27px","padding-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskInstructionsSigns2V),expression:"taskInstructionsSigns2V"}],staticStyle:{"vertical-align":"middle","width":"16px","height":"16px","margin-right":"10px"},attrs:{"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.taskInstructionsSigns2V)?_vm._i(_vm.taskInstructionsSigns2V,item)>-1:(_vm.taskInstructionsSigns2V)},on:{"change":[function($event){var $$a=_vm.taskInstructionsSigns2V,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.taskInstructionsSigns2V=$$a.concat([$$v]))}else{$$i>-1&&(_vm.taskInstructionsSigns2V=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.taskInstructionsSigns2V=$$c}},function($event){return _vm.checkBoxValue(item,'任务要求')}]}}),_vm._v(_vm._s(item)+"\n            ")])}),0),_vm._v(" "),_c('label',{staticStyle:{"font-size":"14px","color":"#8B8D91","line-height":"27px","padding-right":"15px","margin-left":"10%","float":"left"}},[_vm._v("\n              "+_vm._s(_vm.jobInformation.jobRequirements)+"\n            ")]),_vm._v(" "),(_vm.taskInstructionsSigns2V.includes('其他'))?_c('el-input',{staticStyle:{"margin":"10px 0 0 92px","width":"calc(100% - 150px)"},attrs:{"type":"textarea","placeholder":"请输入其他要求","maxlength":500},model:{value:(_vm.jobInformation.otherRequirements),callback:function ($$v) {_vm.$set(_vm.jobInformation, "otherRequirements", $$v)},expression:"jobInformation.otherRequirements"}}):_vm._e()],1)]),_vm._v(" "),_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("服务费说明")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"90%"}},[_c('label',{staticStyle:{"font-size":"14px","color":"#8B8D91","line-height":"27px","padding-right":"15px"}},[_vm._v("\n              "+_vm._s(_vm.jobInformation.salaryTreatment)+"\n            ")])])])]),_vm._v(" "),_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"formArea"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("联系人姓名")]),_vm._v(" "),_c('el-input',{staticClass:"formInpWid",attrs:{"size":"mini","placeholder":"联系人姓名..."},on:{"blur":function($event){return _vm.checkValue(_vm.jobInformation.supervisorName,'督导姓名')}},model:{value:(_vm.jobInformation.supervisorName),callback:function ($$v) {_vm.$set(_vm.jobInformation, "supervisorName", $$v)},expression:"jobInformation.supervisorName"}})],1),_vm._v(" "),_c('div',{staticClass:"formArea"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("联系人电话")]),_vm._v(" "),_c('el-input',{staticClass:"formInpWid",attrs:{"maxlength":11,"size":"mini","placeholder":"联系人电话..."},on:{"blur":function($event){return _vm.checkValue(_vm.jobInformation.supervisorTel,'督导电话')}},model:{value:(_vm.jobInformation.supervisorTel),callback:function ($$v) {_vm.$set(_vm.jobInformation, "supervisorTel", _vm._n($$v))},expression:"jobInformation.supervisorTel"}})],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"wrap plan"},[_c('div',{staticClass:"title"},[_vm._v("任务设置")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-row',{staticClass:"formSty"},[_c('div',{staticClass:"half"},[_c('div',{staticClass:"formInp"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("开始时间")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期","value-format":"yyyy-MM-dd","editable":false,"clearable":false},model:{value:(_vm.plan.startTime),callback:function ($$v) {_vm.$set(_vm.plan, "startTime", $$v)},expression:"plan.startTime"}})],1),_vm._v(" "),_c('div',{staticClass:"formInp"},[_c('span',{staticClass:"formLabel"},[_c('span',{staticClass:"required"},[_vm._v("* ")]),_vm._v("结束时间")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期","value-format":"yyyy-MM-dd","editable":false,"clearable":false},model:{value:(_vm.plan.endTime),callback:function ($$v) {_vm.$set(_vm.plan, "endTime", $$v)},expression:"plan.endTime"}})],1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_vm._v("推送设定")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-row',[_c('el-col',{attrs:{"span":3}},[_c('b',{staticStyle:{"line-height":"30px"}},[_vm._v("已选择标签：")])]),_vm._v(" "),_c('el-col',{attrs:{"span":21}},[(_vm.array1.length > 0)?_c('span',{staticClass:"already-btn"},[_vm._v("行业品类:\n            "),_vm._l((_vm.array1),function(item,index){return _c('span',{key:item.id},[_vm._v(_vm._s(item.signName)+"\n              "),(index != (_vm.array1.length - 1))?_c('span',[_vm._v("、")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.array2.length > 0)?_c('span',{staticClass:"already-btn"},[_vm._v("岗位类型:\n            "),_vm._l((_vm.array2),function(item,index){return _c('span',{key:item.id},[_vm._v(_vm._s(item.signName)+"\n              "),(index != (_vm.array2.length - 1))?_c('span',[_vm._v("、")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.array3.length > 0)?_c('span',{staticClass:"already-btn"},[_vm._v("自我标签:\n            "),_vm._l((_vm.array3),function(item,index){return _c('span',{key:item.id},[_vm._v(_vm._s(item.signName)+"\n              "),(index != (_vm.array3.length - 1))?_c('span',[_vm._v("、")]):_vm._e()])})],2):_vm._e()])],1)],1)])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.cancel}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.submit}},[_vm._v("确定")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.alignSubmit}},[_vm._v("再次推送")])],1),_vm._v(" "),_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.posLoading),expression:"posLoading"}],staticClass:"quitDialog dialog postEditManagement",attrs:{"title":"推送管理","width":"1000px","center":true,"show-close":false,"visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('h4',[_vm._v("推送设定")]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('el-checkbox',{model:{value:(_vm.checkedPromoters),callback:function ($$v) {_vm.checkedPromoters=$$v},expression:"checkedPromoters"}},[_vm._v("指定促销员推送")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedPromoters),expression:"checkedPromoters"}],staticClass:"clickSign pointer",on:{"click":_vm.choosePromoters}},[_vm._v("选择促销员")])],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedPromoters),expression:"checkedPromoters"}]},[_c('el-col',{attrs:{"span":3}},[_c('b',[_vm._v("已选择促销员：")])]),_vm._v(" "),_c('el-col',{attrs:{"span":21}},_vm._l((_vm.isckeckPromotersList),function(item,index){return _c('span',{key:index,staticClass:"already-btn"},[_vm._v(" "+_vm._s(item.name)+"\n            "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.deleteLabel(index)}}})])}),0)],1)],1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('el-checkbox',{model:{value:(_vm.checkedSign),callback:function ($$v) {_vm.checkedSign=$$v},expression:"checkedSign"}},[_vm._v("标签推送")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedSign),expression:"checkedSign"}],staticClass:"clickSign pointer",on:{"click":_vm.chooseSign}},[_vm._v("选择标签")])],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedSign),expression:"checkedSign"}]},[_c('el-col',{attrs:{"span":3}},[_c('b',[_vm._v("已选择标签：")])]),_vm._v(" "),_c('el-col',{attrs:{"span":21}},[_vm._l((_vm.SignArr.array_1),function(item,index){return _c('span',{key:item.id,staticClass:"already-btn"},[(item.signName != '不限')?_c('span',[_vm._v(" "+_vm._s(item.signName))]):_c('span',[_vm._v(" 行业品类：不限")]),_vm._v(" "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.removeSignLabel(index,1)}}})])}),_vm._v(" "),_vm._l((_vm.SignArr.array_2),function(item,index){return _c('span',{key:item.id,staticClass:"already-btn"},[(item.signName != '不限')?_c('span',[_vm._v(" "+_vm._s(item.signName))]):_c('span',[_vm._v(" 岗位类型：不限")]),_vm._v(" "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.removeSignLabel(index,2)}}})])}),_vm._v(" "),_vm._l((_vm.SignArr.array_3),function(item,index){return _c('span',{key:item.id,staticClass:"already-btn"},[(item.signName != '不限')?_c('span',[_vm._v(" "+_vm._s(item.signName))]):_c('span',[_vm._v(" 自我标签：不限")]),_vm._v(" "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.removeSignLabel(index,3)}}})])})],2)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){_vm.innerVisible=false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.levelTwoSubmit}},[_vm._v("推送")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog PromotersDialog",attrs:{"title":"添加促销员","width":"1000px","center":true,"show-close":false,"visible":_vm.innerVisible2,"append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.innerVisible2=$event}}},[_c('el-row',{staticStyle:{"margin-bottom":"10px"}},[_c('b',[_vm._v("已选择促销员:")]),_vm._v(" "),_vm._l((_vm.isckeckPromotersList2),function(item,index){return _c('span',{key:index,staticClass:"already-btn"},[_vm._v(" "+_vm._s(item.name)+"\n        "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.deleteLabel2(index)}}})])})],2),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"}},[_c('el-col',{attrs:{"span":5}},[_c('span',{staticClass:"formLabel "},[_vm._v("姓名")]),_vm._v(" "),_c('el-input',{staticClass:"formInpWid",attrs:{"size":"mini","placeholder":"请输入...","maxlength":10},model:{value:(_vm.PromotersPopUp.name),callback:function ($$v) {_vm.$set(_vm.PromotersPopUp, "name", $$v)},expression:"PromotersPopUp.name"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('span',{staticClass:"formLabel "},[_vm._v("身份证号")]),_vm._v(" "),_c('el-input',{staticClass:"formInpWid",staticStyle:{"width":"65%"},attrs:{"size":"mini","placeholder":"请输入...","maxlength":19},on:{"change":_vm.checkIdCard},model:{value:(_vm.PromotersPopUp.idCard),callback:function ($$v) {_vm.$set(_vm.PromotersPopUp, "idCard", $$v)},expression:"PromotersPopUp.idCard"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('span',{staticClass:"formLabel",staticStyle:{"width":"50px"}},[_vm._v("年龄")]),_vm._v(" "),_c('el-input',{staticClass:"rangeSettingAge",attrs:{"size":"mini","placeholder":"岁","maxlength":3},model:{value:(_vm.PromotersPopUp.minAge),callback:function ($$v) {_vm.$set(_vm.PromotersPopUp, "minAge", _vm._n($$v))},expression:"PromotersPopUp.minAge"}}),_vm._v("\n        —\n        "),_c('el-input',{staticClass:"rangeSettingAge",attrs:{"size":"mini","placeholder":"岁","maxlength":3},model:{value:(_vm.PromotersPopUp.maxAge),callback:function ($$v) {_vm.$set(_vm.PromotersPopUp, "maxAge", _vm._n($$v))},expression:"PromotersPopUp.maxAge"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('span',{staticClass:"formLabel",staticStyle:{"width":"50px"}},[_vm._v("身高")]),_vm._v(" "),_c('el-input',{staticClass:"rangeSettingAge",attrs:{"size":"mini","placeholder":"CM","maxlength":3},model:{value:(_vm.PromotersPopUp.minHeight),callback:function ($$v) {_vm.$set(_vm.PromotersPopUp, "minHeight", _vm._n($$v))},expression:"PromotersPopUp.minHeight"}}),_vm._v("\n        —\n        "),_c('el-input',{staticClass:"rangeSettingAge",attrs:{"size":"mini","placeholder":"CM","maxlength":3},model:{value:(_vm.PromotersPopUp.maxHeight),callback:function ($$v) {_vm.$set(_vm.PromotersPopUp, "maxHeight", _vm._n($$v))},expression:"PromotersPopUp.maxHeight"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"5px"}},[_c('el-col',{attrs:{"span":7}},[_c('span',{staticClass:"formLabel "},[_vm._v("促销员编号")]),_vm._v(" "),_c('el-input',{staticClass:"formInpWid",attrs:{"size":"mini","placeholder":"请输入...","maxlength":50},model:{value:(_vm.PromotersPopUp.empCode),callback:function ($$v) {_vm.$set(_vm.PromotersPopUp, "empCode", $$v)},expression:"PromotersPopUp.empCode"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"search",on:{"click":function($event){return _vm.searchSaleManInfo('doNotJump')}}},[_vm._v("\n          筛选\n        ")])])],1),_vm._v(" "),_c('div',{staticClass:"tableBackGround"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableLoading),expression:"tableLoading"}],ref:"salesmuli",staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"},on:{"select":_vm.selectChange,"select-all":_vm.selectAllChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","width":"50","label":"编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"empCode","label":"促销员编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idCard","label":"身份证号","align":"center","formatter":_vm.formatIdCard}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel","label":"手机号","align":"center","formatter":_vm.formatTel}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"age","label":"年龄","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"height","label":"身高","align":"center"}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"60%","margin":"0 auto"}},[_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.PromotersPopUp.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.PromotersPopUp.pageSize,"total":_vm.PromotersPopUp.total,"layout":"total,prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.changeInnerVisible2}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.sureSaleMan}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"添加标签","width":"1000px","center":true,"show-close":false,"visible":_vm.innerVisible3,"append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.innerVisible3=$event}}},[_c('el-row',{staticStyle:{"margin-bottom":"10px","margin-top":"10px"}},[_c('el-col',{attrs:{"span":2}},[_c('span',[_vm._v("您已选择")])]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[(_vm.SignArr2.array_1.length > 0)?_c('span',{staticClass:"already-btn"},[_vm._v("行业品类:\n          "),_vm._l((_vm.SignArr2.array_1),function(item,index){return _c('span',{key:item.id},[_vm._v(_vm._s(item.signName)+"\n            "),(index != (_vm.SignArr2.array_1.length - 1))?_c('span',[_vm._v("、")]):_vm._e()])}),_vm._v(" "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.removeArray(1)}}})],2):_vm._e(),_vm._v(" "),(_vm.SignArr2.array_2.length > 0)?_c('span',{staticClass:"already-btn"},[_vm._v("岗位类型:\n          "),_vm._l((_vm.SignArr2.array_2),function(item,index){return _c('span',{key:item.id},[_vm._v(_vm._s(item.signName)+"\n            "),(index != (_vm.SignArr2.array_2.length - 1))?_c('span',[_vm._v("、")]):_vm._e()])}),_vm._v(" "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.removeArray(2)}}})],2):_vm._e(),_vm._v(" "),(_vm.SignArr2.array_3.length > 0)?_c('span',{staticClass:"already-btn"},[_vm._v("自我标签:\n          "),_vm._l((_vm.SignArr2.array_3),function(item,index){return _c('span',{key:item.id},[_vm._v(_vm._s(item.signName)+"\n            "),(index != (_vm.SignArr2.array_3.length - 1))?_c('span',[_vm._v("、")]):_vm._e()])}),_vm._v(" "),_c('span',{staticClass:"remove-btn pointer",on:{"click":function($event){return _vm.removeArray(3)}}})],2):_vm._e()])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_c('span',[_vm._v("行业品类")])]),_vm._v(" "),_c('el-col',{staticClass:"signWrap",staticStyle:{"overflow":"hidden"},attrs:{"span":20}},_vm._l((_vm.SignPopUp.tabsData),function(item,index){return _c('div',{key:item.id,staticClass:"signList pointer",class:{'active' : item.choose},on:{"click":function($event){return _vm.hangYeChoose(item)}}},[_vm._v(_vm._s(item.signName)+"\n        ")])}),0),_vm._v(" "),_c('el-col',{staticStyle:{"position":"relative"},attrs:{"span":2}},[_c('div',{staticClass:"toggle-btn",on:{"click":_vm.toggleSlide}})])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_c('span',[_vm._v("岗位类型")])]),_vm._v(" "),_c('el-col',{staticClass:"signWrap",staticStyle:{"overflow":"hidden"},attrs:{"span":20}},_vm._l((_vm.SignPopUp.tabsData2),function(item,index){return _c('div',{key:item.id,staticClass:"signList pointer",class:{'active' : item.choose},on:{"click":function($event){return _vm.gangWeiChoose(item)}}},[_vm._v(_vm._s(item.signName)+"\n        ")])}),0),_vm._v(" "),_c('el-col',{staticStyle:{"position":"relative"},attrs:{"span":2}},[_c('div',{staticClass:"toggle-btn",on:{"click":_vm.toggleSlide}})])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":2}},[_c('span',[_vm._v("自我标签")])]),_vm._v(" "),_c('el-col',{staticClass:"signWrap",staticStyle:{"overflow":"hidden"},attrs:{"span":20}},_vm._l((_vm.SignPopUp.tabsData3),function(item,index){return _c('div',{key:item.id,staticClass:"signList pointer",class:{'active' : item.choose},on:{"click":function($event){return _vm.biaoQianChoose(item)}}},[_vm._v(_vm._s(item.signName)+"\n        ")])}),0),_vm._v(" "),_c('el-col',{staticStyle:{"position":"relative"},attrs:{"span":2}},[_c('div',{staticClass:"toggle-btn",on:{"click":_vm.toggleSlide}})])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":_vm.changeInnerVisible3}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":_vm.sureSignLabel}},[_vm._v("确定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vGSD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w2pP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "w90U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"clearfix",attrs:{"element-loading-text":"拼命加载中","element-loading-background":"rgba(0, 0, 0, 0.6)"}},[_c('div',{staticClass:"floatl top-left"},[_c('div',{staticClass:"avatar",style:(_vm.avatarImg(_vm.salepersionData.headImg)),on:{"click":function($event){return _vm.showImage(_vm.salepersionData.headImg)}}},[_c('img',{staticClass:"img",staticStyle:{"display":"none"},attrs:{"src":_vm.salepersionData.headImg || '',"alt":""},on:{"error":_vm.setErrorImage}})]),_vm._v(" "),_c('div',{staticClass:"star-level"},[_vm._v("星级："+_vm._s(_vm.salepersionData.starName))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_vm._v("\n        "+_vm._s(_vm.starName)+"\n        "),_c('div',{staticClass:"progress-line"},[_c('div',{staticClass:"bar",style:('width: '+_vm.precent+'%;')})]),_vm._v("\n        "+_vm._s(_vm.nextstartName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"credit-num clearfix"},[_c('span',{staticClass:"floatl"},[_vm._v(_vm._s(_vm.salepersionData.creditScore))]),_vm._v("\n        信用\n      ")]),_vm._v(" "),_c('div',{staticClass:"credit-num clearfix"},[_c('span',{staticClass:"floatl"},[_vm._v(_vm._s(_vm.salepersionData.score))]),_vm._v("\n        积分\n      ")])]),_vm._v(" "),_c('div',{staticClass:"floatl top-right"},[_c('div',{staticClass:"name clearfix"},[_c('span',{staticClass:"floatl"},[_vm._v(_vm._s(_vm.salepersionData.name))]),_vm._v(" "),_c('p',{staticClass:"floatr"},[(_vm.isAdmin && _vm.salepersionData.height)?_c('span',[_vm._v(_vm._s(_vm.salepersionData.age)+"岁 | "+_vm._s(_vm.salepersionData.height)+"cm")]):_vm._e(),_vm._v(" "),(_vm.isAdmin && !_vm.salepersionData.height)?_c('span',[_vm._v(_vm._s(_vm.salepersionData.age)+"岁")]):_vm._e(),_vm._v(" "),(!_vm.isAdmin && _vm.salepersionData.height)?_c('span',[_vm._v(_vm._s(_vm.salepersionData.height)+"cm")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.sex))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.agreement))])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both","line-height":"0px","margin-bottom":"20px"}},[_vm._v("促销员ID:"+_vm._s(_vm.salepersionData.empPk))])]),_vm._v(" "),_c('div',{staticClass:"text-info clearfix"},[_c('div',{staticClass:"floatl text-info-left"},[_c('p',{staticClass:"floatl"},[_vm._v("微信昵称："+_vm._s(_vm.salepersionData.wxName || '无'))]),_vm._v(" "),_c('p',{staticClass:"floatl"},[_vm._v("联系电话："+_vm._s(_vm.salepersionData.tel || '无'))]),_vm._v(" "),_c('p',{staticClass:"floatl"},[_vm._v("紧急联系人："+_vm._s(_vm.salepersionData.emergencyContact || '无'))]),_vm._v(" "),_c('p',{staticClass:"floatl"},[_vm._v("紧急联系人电话："+_vm._s(_vm.salepersionData.emergencyTel || '无'))])]),_vm._v(" "),_c('div',{staticClass:"floatr text-info-right"},[_c('p',{staticClass:"floatl"},[_vm._v("推荐人："+_vm._s(_vm.salepersionData.recommenderName || '无'))]),_vm._v(" "),_c('p',{staticClass:"floatl"},[_vm._v("推荐人电话："+_vm._s(_vm.salepersionData.recommendertel || '无'))]),_vm._v(" "),_c('p',{staticClass:"floatl",attrs:{"title":((_vm.salepersionData.province || '') +
            (_vm.salepersionData.city || '') +
            (_vm.salepersionData.area || '') +
            (_vm.salepersionData.homeAddress || '') || '无')}},[_vm._v("现住地址："+_vm._s(((_vm.salepersionData.province || '') +
            (_vm.salepersionData.city || '') +
            (_vm.salepersionData.area || '') +
            (_vm.salepersionData.homeAddress || '') || '无'))+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"floatl"},[_vm._v("户口地址："+_vm._s(_vm.salepersionData.registeredAdd || '无'))])])]),_vm._v(" "),_c('div',{staticClass:"latest-proj clearfix",staticStyle:{"padding":"5px!important"}},[_c('div',{staticClass:"proj-box floatl"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm.salepersionData.insertTime))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("注册时间")])]),_vm._v(" "),_c('div',{staticClass:"proj-box floatl"},[_c('p',{staticClass:"p1",attrs:{"title":_vm.salepersionData.lastPrj}},[_vm._v(_vm._s(_vm.salepersionData.lastPrj))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("最近一次项目")])]),_vm._v(" "),_c('div',{staticClass:"proj-box floatl"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm.salepersionData.lastPrjTime))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("最近一次项目时间")])])]),_vm._v(" "),_c('div',{staticClass:"latest-proj clearfix",staticStyle:{"margin-top":"0px!important","padding":"5px!important"}},[_c('div',{staticClass:"proj-box floatl"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm.salepersionData.identityAuthenticationTime))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("身份认证时间")])]),_vm._v(" "),_c('div',{staticClass:"proj-box floatl"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm.salepersionData.realNameAuthenticationTime))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("实名认证时间")])])]),_vm._v(" "),_c('div',{staticClass:"tags-wrap clearfix"},[_c('div',{staticClass:"tag clearfix"},[_c('h2',[_vm._v("标签")]),_vm._v(" "),_c('div',{staticClass:"tag-body"},_vm._l((_vm.salepersionData.signName),function(item,index){return _c('el-tag',{key:index,staticClass:"tag-item",attrs:{"type":"info"}},[_vm._v("\n              "+_vm._s(item)+"\n            ")])}),1)]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"tag",staticStyle:{"margin-left":"0px","padding":"5px"}},[_c('h2',[_vm._v("自我喜好")]),_vm._v(" "),_c('div',{staticClass:"tag-body"},_vm._l((_vm.salepersionData.selfSignName),function(item,index){return _c('el-tag',{key:index,staticClass:"tag-item",attrs:{"type":"info"}},[_vm._v("\n              "+_vm._s(item)+"\n            ")])}),1)])])])]),_vm._v(" "),_c('el-row',{staticClass:"cards"},[_c('div',{staticClass:"card-img clearfix",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"imgs",style:(_vm.noCompression(_vm.salepersionData.idcardCover))},[_c('img',{staticStyle:{"display":"none"},attrs:{"src":_vm.salepersionData.idcardCover ? _vm.salepersionData.idcardCover :'https://120.55.166.247:9191/noimg/no/no/no.jpg'},on:{"error":_vm.imgError1}})]),_vm._v(" "),_c('div',{staticClass:"imgs",style:(_vm.noCompression((!_vm.salepersionData.idcardBack || _vm.salepersionData.idcardBack.slice(-4) == 'null') ? _vm.idcardDefaultBack : _vm.salepersionData.idcardBack))}),_vm._v(" "),_c('div',{staticClass:"imgs",style:(_vm.noCompression(_vm.salepersionData.bankCover))},[_c('img',{staticStyle:{"display":"none"},attrs:{"src":_vm.salepersionData.bankCover ? _vm.salepersionData.bankCover :'https://120.55.166.247:9191/noimg/no/no/no.jpg'},on:{"error":_vm.imgError2}})])]),_vm._v(" "),_c('div',{staticClass:"card-info clearfix"},[_c('div',{staticClass:"idCard floatl"},[_vm._v("\n        身份证号："+_vm._s(_vm.salepersionData.idcard)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"bankCard floatr"},[_c('p',[_vm._v("开户行："+_vm._s(_vm.salepersionData.bank))]),_vm._v(" "),_c('p',[_vm._v("银行卡号："+_vm._s(_vm.salepersionData.bankNum))])])])]),_vm._v(" "),_c('div',{staticClass:"viewImage"},[_c('el-dialog',{staticClass:"dialog",attrs:{"title":"查看大图","visible":_vm.showbigImage,"width":_vm.bigImageWidth2,"modal":false},on:{"update:visible":function($event){_vm.showbigImage=$event}},model:{value:(_vm.bigImage),callback:function ($$v) {_vm.bigImage=$$v},expression:"bigImage"}},[_c('div',{staticClass:"dialogImage",style:(_vm.avatarBigImg(_vm.bigImage))},[_c('img',{attrs:{"src":_vm.bigImage || '',"alt":""},on:{"error":_vm.setErrorImage}})]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showbigImage = false}}},[_vm._v("确 定")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wOUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"筛选"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"100px","size":"mini"}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"任务名称"}},[_c('el-input',{attrs:{"placeholder":"请输入任务名称...","maxlength":30},model:{value:(_vm.param.posName),callback:function ($$v) {_vm.$set(_vm.param, "posName", $$v)},expression:"param.posName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目编号"}},[_c('el-input',{attrs:{"placeholder":"请输入项目编号...","maxlength":30},model:{value:(_vm.param.proCode),callback:function ($$v) {_vm.$set(_vm.param, "proCode", $$v)},expression:"param.proCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称...","maxlength":20},model:{value:(_vm.param.proName),callback:function ($$v) {_vm.$set(_vm.param, "proName", $$v)},expression:"param.proName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店名称"}},[_c('el-input',{attrs:{"placeholder":"请输入门店名称...","maxlength":15},model:{value:(_vm.param.storeName),callback:function ($$v) {_vm.$set(_vm.param, "storeName", $$v)},expression:"param.storeName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店编码"}},[_c('el-input',{attrs:{"placeholder":"请输入门店编码...","maxlength":25},model:{value:(_vm.param.storeCode),callback:function ($$v) {_vm.$set(_vm.param, "storeCode", $$v)},expression:"param.storeCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发布人"}},[_c('el-input',{attrs:{"placeholder":"请输入发布人...","maxlength":5},model:{value:(_vm.param.postMan),callback:function ($$v) {_vm.$set(_vm.param, "postMan", $$v)},expression:"param.postMan"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员姓名...","maxlength":6},model:{value:(_vm.param.salesmanName),callback:function ($$v) {_vm.$set(_vm.param, "salesmanName", $$v)},expression:"param.salesmanName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员身份证"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员身份证号...","maxlength":18},model:{value:(_vm.param.salesmanIdCard),callback:function ($$v) {_vm.$set(_vm.param, "salesmanIdCard", $$v)},expression:"param.salesmanIdCard"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID...","maxlength":12},model:{value:(_vm.param.empPk),callback:function ($$v) {_vm.$set(_vm.param, "empPk", $$v)},expression:"param.empPk"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在地区"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择地区..."},on:{"change":_vm.searchCity},model:{value:(_vm.param.provinceId),callback:function ($$v) {_vm.$set(_vm.param, "provinceId", $$v)},expression:"param.provinceId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.provinceList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.adName,"value":item.id}})})],2),_vm._v(" "),_c('el-select',{attrs:{"filterable":"","placeholder":"请选择地区..."},model:{value:(_vm.param.cityId),callback:function ($$v) {_vm.$set(_vm.param, "cityId", $$v)},expression:"param.cityId"}},[_c('el-option',{attrs:{"label":"不限","value":null}}),_vm._v(" "),_vm._l((_vm.cityList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.adName,"value":item.id}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"终端"}},[_c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"请输入终端..."},model:{value:(_vm.param.terminal),callback:function ($$v) {_vm.$set(_vm.param, "terminal", $$v)},expression:"param.terminal"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"岗位状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.post),callback:function ($$v) {_vm.$set(_vm.param, "post", $$v)},expression:"param.post"}},_vm._l((_vm.choosePost),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"应聘状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.apply),callback:function ($$v) {_vm.$set(_vm.param, "apply", $$v)},expression:"param.apply"}},_vm._l((_vm.chooseApply),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发布时间"}},[_c('el-date-picker',{attrs:{"placeholder":"请输入最小发布时间...","value-format":"yyyy-MM-dd"},model:{value:(_vm.param.publishTimeStart),callback:function ($$v) {_vm.$set(_vm.param, "publishTimeStart", $$v)},expression:"param.publishTimeStart"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-date-picker',{attrs:{"placeholder":"请输入最大发布时间...","value-format":"yyyy-MM-dd"},model:{value:(_vm.param.publishTimeEnd),callback:function ($$v) {_vm.$set(_vm.param, "publishTimeEnd", $$v)},expression:"param.publishTimeEnd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"岗位编码"}},[_c('el-input',{attrs:{"placeholder":"请输入岗位编码..."},model:{value:(_vm.param.code),callback:function ($$v) {_vm.$set(_vm.param, "code", $$v)},expression:"param.code"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.exportResult()}}},[_vm._v("导出")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("展开筛选项")])],1)],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('div',{staticClass:"title"},[_vm._v("\n        筛选结果\n      ")]),_vm._v(" "),_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"posStoreCode","label":"岗位编码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"posName","label":"岗位名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"salary","label":"岗位薪水","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"180","prop":"projectCode","label":"项目编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"projectName","label":"项目名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"province","label":"省","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"city","label":"市","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"channel","label":"终端","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"160","prop":"system","label":"系统","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"storeCode","label":"门店编码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"storeName","label":"门店名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"scheduleNum","label":"卖进序号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"220","prop":"address","label":"门店地址","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"publishUserName","label":"发布人","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"130","prop":"publishTime","label":"发布时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"130","prop":"requirementsStart","label":"开始时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"130","prop":"requirementsEnd","label":"结束时间","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"planNumber","label":"计划人数","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"recruitsNumber","label":"招聘人数","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"interviewNumber","label":"面试人数","align":"center","formatter":_vm.formatNum}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"interviewPassNumber","label":"通过人数","align":"center","formatter":_vm.formatNum}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"waitNumber","label":"待审核人数","align":"center","formatter":_vm.formatNum}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"requirementsStatus","label":"岗位状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.requirementsStatus == 1)?_c('div',[_vm._v("招聘中")]):_vm._e(),_vm._v(" "),(scope.row.requirementsStatus == 2)?_c('div',[_vm._v("已完成")]):_vm._e(),_vm._v(" "),(scope.row.requirementsStatus == 3)?_c('div',[_vm._v("已结束")]):_vm._e(),_vm._v(" "),(scope.row.requirementsStatus == 4)?_c('div',[_vm._v("已关闭")]):_vm._e(),_vm._v(" "),(scope.row.requirementsStatus == 5)?_c('div',[_vm._v("卖进关闭")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"260","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small","disabled":scope.row.requirementsStatus == 3},on:{"click":function($event){return _vm.edit(scope.row)}}},[_vm._v("编辑\n            ")]),_vm._v(" "),_c('span',{staticClass:"cutLine"}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small","disabled":scope.row.requirementsStatus == 3},on:{"click":function($event){return _vm.handleApplyy(scope.row)}}},[_vm._v("处理应聘\n            ")]),_vm._v(" "),(_vm.closePosStoreFLag)?_c('span',{staticClass:"cutLine"}):_vm._e(),_vm._v(" "),(_vm.closePosStoreFLag)?_c('el-button',{attrs:{"type":"text","size":"small","disabled":scope.row.requirementsStatus == 4 || scope.row.requirementsStatus == 5},on:{"click":function($event){return _vm.confirmClosePosStore(scope.row.posStoreId)}}},[_vm._v("关闭岗位\n            ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"处理应聘","width":"1000px","center":true,"show-close":true,"visible":_vm.jobEdit},on:{"update:visible":function($event){_vm.jobEdit=$event}}},[(_vm.jobEdit)?_c('HandleApply',{attrs:{"Child":_vm.clickThis,"msg":_vm.msg},on:{"fresh":_vm.reFresh,"upup":_vm.changeHandle}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog",attrs:{"title":"编辑岗位","width":"1020px","center":true,"show-close":false,"visible":_vm.postEdit},on:{"update:visible":function($event){_vm.postEdit=$event}}},[(_vm.postEdit)?_c('PostEdit',{attrs:{"Child":_vm.clickThis,"msg":_vm.msg1},on:{"upupup":_vm.changeEdit,"submitForm":function($event){return _vm.submitForm()}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wYi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postEdit_vue__ = __webpack_require__("qIbC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ff0534_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postEdit_vue__ = __webpack_require__("v/xe");
function injectStyle (ssrContext) {
  __webpack_require__("jABS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36ff0534"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ff0534_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wkxw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_function_js__ = __webpack_require__("iMMx");
/**
 * Created by ICG-DL-035 on 2017/12/18.
 */


 //引入模块
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    funciton: __WEBPACK_IMPORTED_MODULE_2__store_modules_function_js__["a" /* default */]
  },
  state: {
    //起始时间
    startTime: '',
    //体系配置首页数据
    systemArr: '',
    //配置积分页
    jiFenArr: '',
    //配置星级页
    xingJiArr: '',
    //星级设定
    xingJiEdit: '',
    //星级排序
    sortStar: [],
    //配置信用页
    xinYongArr: [],
    //信用排序
    sortPro: [],
    //保存工作广场首页数据
    workSquareInfo: null,
    //判断工作广场是否可修改
    workSquareIsEdit: null,
    //判断用户登陆是否超时
    loginTimeOut: false,
    //岗位发布页是否有数据
    postJobHasData: false,
    //任务发布页是否有数据
    postTaskHasData: false
  },
  mutations: {
    changeStartTime: function changeStartTime(state, startTime) {
      state.startTime = startTime;
    },
    changeSystemArr: function changeSystemArr(state, arr) {
      state.systemArr = arr;
    },
    changejiFenArr: function changejiFenArr(state, arr) {
      state.jiFenArr = arr;
    },
    changeXingJiArr: function changeXingJiArr(state, arr) {
      state.xingJiArr = arr;
    },
    changeXingJiEditArr: function changeXingJiEditArr(state, arr) {
      state.xingJiEdit = arr;
    },
    changeSortStar: function changeSortStar(state, arr) {
      state.sortStar = arr;
    },
    changeXinYongArr: function changeXinYongArr(state, arr) {
      state.xinYongArr = arr;
    },
    changeSortPro: function changeSortPro(state, arr) {
      state.sortPro = arr;
    },
    saveWorkSquareInfo: function saveWorkSquareInfo(state, arr) {
      state.workSquareInfo = arr;
    },
    workSquareIsEditMethods: function workSquareIsEditMethods(state, arr) {
      state.workSquareIsEdit = arr;
    },
    changeLoginTimeOutTo: function changeLoginTimeOutTo(state, boolean) {
      state.loginTimeOut = boolean;
    },
    changePostJobHasDataTo: function changePostJobHasDataTo(state, boolean) {
      state.postJobHasData = boolean;
    },
    changePostTaskHasDataTo: function changePostTaskHasDataTo(state, boolean) {
      state.postTaskHasData = boolean;
    }
  },
  getters: {
    systemArr: function systemArr(state) {
      return state.systemArr;
    }
  },
  actions: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xV4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allCustomers: [],
      formData: {
        pageNo: 1,
        pageSize: 10,
        projectCode: null,
        projectName: null,
        status: null,
        customer: null,
        supplier: null,
        updater: null,
        startDate: null,
        endDate: null
      },
      tableData: [],
      total: null,
      listLoading: false,
      editProjectId: null,
      editProjectName: null,
      showEditDialog: false,
      editProjectAuth: false,
      selectSupplier: null,
      serviceSuppliers: []
    };
  },
  mounted: function mounted() {
    this.getEditProjectAuth();
    this.searchAllCustomer();
    this.getData();
    this.getServiceSuppliers();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.listLoading = true;
      if (this.formData.startDate) {
        this.formData.startDate = this.computeDate(this.formData.startDate);
      }
      if (this.formData.endDate) {
        this.formData.endDate = this.computeDate(this.formData.endDate);
      }
      console.log('this.formData', this.formData);
      this.$http({
        method: 'GET',
        url: '/rest/project/list',
        params: this.formData
      }).then(function (res) {
        _this.tableData = res.data.items;
        _this.total = res.data.totalItemsCount;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    searchAllCustomer: function searchAllCustomer() {
      var _this2 = this;

      this.$http({
        method: 'GET',
        url: '/rest/baseCenter/all-customers'
      }).then(function (res) {
        _this2.allCustomers = res.data.data;
      }).catch(function (err) {});
    },
    resetForm: function resetForm() {
      this.$refs['formData'].resetFields();
    },
    submitForm: function submitForm() {
      this.formData.pageSize = 10;
      this.formData.pageNo = 1;
      this.getData();
    },
    exportProject: function exportProject() {
      var _this3 = this;

      this.listLoading = true;
      this.$http({
        method: "GET",
        url: "/rest/project/export",
        params: this.formData
      }).then(function (res) {
        console.log(res.data);
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
        _this3.listLoading = false;
      }).catch(function (error) {
        _this3.listLoading = false;
        _this3.$alert("导出错误，请联系管理员！");
      });
    },
    exportProjectCategory: function exportProjectCategory() {
      var _this4 = this;

      this.$http({
        method: "GET",
        url: "/rest/projectCategory/export",
        params: {}
      }).then(function (res) {
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.data;
        _this4.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    openEditDialog: function openEditDialog(projectId, projectName, supplier) {
      this.editProjectId = projectId;
      this.editProjectName = projectName;
      this.showEditDialog = true;
      if (supplier != '--') {
        this.selectSupplier = supplier;
      } else {
        this.selectSupplier = null;
      }
    },
    getEditProjectAuth: function getEditProjectAuth() {
      var _this5 = this;

      this.$http({
        method: 'GET',
        url: '/rest/project/edit-auth',
        params: {
          userId: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        _this5.editProjectAuth = res.data.data;
      }).catch(function (err) {});
    },
    editProjectSupplier: function editProjectSupplier() {
      var _this6 = this;

      this.$http({
        method: 'POST',
        url: '/rest/project/edit',
        data: {
          id: this.editProjectId,
          supplier: this.selectSupplier,
          updater: sessionStorage.getItem("sysUserId")
        }
      }).then(function (res) {
        _this6.showEditDialog = false;
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "success", res, '操作成功');
        _this6.getData();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this6, "error", res, '操作失败');
      });
    },
    getServiceSuppliers: function getServiceSuppliers() {
      var _this7 = this;

      this.$http({
        method: 'GET',
        url: '/rest/JiangYiJoint/getServiceSuppliers'

      }).then(function (res) {
        _this7.serviceSuppliers = res.data;
      }).catch(function (err) {});
    },
    computeDate: function computeDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format("YYYY-MM-DD");
    }
  }
});

/***/ }),

/***/ "xco+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{staticClass:"common-box"},[_c('div',{staticClass:"common-box-body"},[_c('el-table',{staticClass:"filterTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"type":"index","label":"编号","width":"50","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"masterName","label":"项目名","width":"180","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.id === 15)?_c('div',[_vm._v("\n              "+_vm._s(scope.row.masterName)+"\n              （"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.projectPricemonth),expression:"projectPricemonth"}],staticStyle:{"width":"40px","border":"none","border-bottom":"1px solid #c4c4c4","text-align":"center","color":"#333"},attrs:{"type":"number"},domProps:{"value":(_vm.projectPricemonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.projectPricemonth=$event.target.value}}}),_vm._v("个月）\n            ")]):_c('div',[_vm._v(_vm._s(scope.row.masterName))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"促销员库","align":"center"}},_vm._l((_vm.signNameList),function(item){return _c('el-table-column',{key:item.id,attrs:{"label":item.id === 0 ? '全部人员' : item.signName,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.configList),function(config,index){return (config.conditionId === scope.row.id && config.postId === item.id && config.webId === 1)?_c('div',{key:index,staticClass:"checked",on:{"click":function($event){return _vm.check('remove', scope.row.id, item.id, 1)}}},[_c('img',{attrs:{"src":__webpack_require__("SXjM"),"alt":""}}),_vm._v("\n                已选择\n              ")]):_vm._e()}),_vm._v(" "),(
                (scope.row.id === 11 && item.id === 1) ||
                (scope.row.id === 12 && item.id === 2) )?_c('div',{staticClass:"disabled"},[_c('img',{attrs:{"src":__webpack_require__("mc+9"),"alt":""}}),_vm._v("\n                已禁用\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default",on:{"click":function($event){return _vm.check('add', scope.row.id, item.id, 1)}}},[_c('img',{attrs:{"src":__webpack_require__("i1bv"),"alt":""}}),_vm._v("\n                请选择\n              ")])]}}],null,true)})}),1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"基础中心","align":"center"}},_vm._l((_vm.signNameList),function(item){return _c('el-table-column',{key:item.id,attrs:{"label":item.id === 0 ? '全部人员' : item.signName,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.configList),function(config,index){return (config.conditionId === scope.row.id && config.postId === item.id && config.webId === 2)?_c('div',{key:index,staticClass:"checked",on:{"click":function($event){return _vm.check('remove', scope.row.id, item.id, 2)}}},[_c('img',{attrs:{"src":__webpack_require__("SXjM"),"alt":""}}),_vm._v("\n                已选择\n              ")]):_vm._e()}),_vm._v(" "),(
                (scope.row.id === 11 && item.id === 1) ||
                (scope.row.id === 12 && item.id === 2))?_c('div',{staticClass:"disabled"},[_c('img',{attrs:{"src":__webpack_require__("mc+9"),"alt":""}}),_vm._v("\n                已禁用\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default",on:{"click":function($event){return _vm.check('add', scope.row.id, item.id, 2)}}},[_c('img',{attrs:{"src":__webpack_require__("i1bv"),"alt":""}}),_vm._v("\n                请选择\n              ")])]}}],null,true)})}),1)],1),_vm._v(" "),_c('div',{staticClass:"save-button"},[(_vm.auths.indexOf(2) > -1)?_c('el-button',{attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.save}},[_vm._v("确认选择")]):_vm._e()],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xmOy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xsrU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapperProject_vue__ = __webpack_require__("LmCP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6243eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapperProject_vue__ = __webpack_require__("AbRs");
function injectStyle (ssrContext) {
  __webpack_require__("iOJ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d6243eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapperProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6243eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapperProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xxzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    // 如果要设置过期时间以秒为单位
    setCookie: function setCookie(c_name, value, expireseconds) {
        var exdate = new Date();
        exdate.setTime(exdate.getTime() + expireseconds * 1000);
        document.cookie = c_name + "=" + escape(value) + (expireseconds == null ? "" : ";expires=" + exdate.toGMTString());
    },

    // 函数中的参数为 要获取的cookie键的名称。
    getCookie: function getCookie(c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                var c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }

                return unescape(document.cookie.substring(c_start, c_end));
            }
        }

        return "";
    },

    // 函数中的参数为，要判断的cookie名称
    checkCookie: function checkCookie(c_name) {
        username = getCookie(c_name);
        if (username != null && username != "") {
            // 如果cookie值存在，执行下面的操作。
            alert('Welcome again ' + username + '!');
        } else {
            username = prompt('Please enter your name:', "");
            if (username != null && username != "") {
                //如果cookie不存在，执行下面的操作。
                setCookie('username', username, 365);
            }
        }
    }
});

/***/ }),

/***/ "yDw1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ycBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"element-loading-text":"拼命加载中..."}},[_c('div',{staticClass:"filter",staticStyle:{"margin-top":"-30px"}},[_c('el-tabs',{staticClass:"card-tab",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"长促人员库"}},[_c('el-form',{staticClass:"formInline",attrs:{"model":_vm.param,"inline":true,"label-width":"125px","size":"mini"}},[_c('div',{ref:"slideWrap1",staticClass:"slide-wrap"},[_c('el-form-item',{attrs:{"label":"姓名"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名...","maxlength":30},model:{value:(_vm.param.employeeName),callback:function ($$v) {_vm.$set(_vm.param, "employeeName", $$v)},expression:"param.employeeName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号...","maxlength":18},model:{value:(_vm.param.documentNumber),callback:function ($$v) {_vm.$set(_vm.param, "documentNumber", $$v)},expression:"param.documentNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号...","maxlength":20},model:{value:(_vm.param.phone),callback:function ($$v) {_vm.$set(_vm.param, "phone", $$v)},expression:"param.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"人员类别"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择...","disabled":""},model:{value:(_vm.param.personType),callback:function ($$v) {_vm.$set(_vm.param, "personType", $$v)},expression:"param.personType"}},[_c('el-option',{attrs:{"label":"全部","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":"促销员","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"督导","value":"1"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.quitCrmStatus),callback:function ($$v) {_vm.$set(_vm.param, "quitCrmStatus", $$v)},expression:"param.quitCrmStatus"}},[_c('el-option',{attrs:{"label":"全部","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":"在职","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职中","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职","value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"取消离职","value":"3"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"米咖注册认证状态"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.isAuthentivayion),callback:function ($$v) {_vm.$set(_vm.param, "isAuthentivayion", $$v)},expression:"param.isAuthentivayion"}},[_c('el-option',{attrs:{"label":"全部","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":"未注册","value":"9"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"注册会员","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"身份认证","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"实名认证","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"银行卡认证","value":"3"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"合同类型"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.contractTypeId),callback:function ($$v) {_vm.$set(_vm.param, "contractTypeId", $$v)},expression:"param.contractTypeId"}},[_c('el-option',{attrs:{"label":"全部","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":"劳务合同","value":"劳务合同"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"劳动合同","value":"劳动合同"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目客户"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.clientId),callback:function ($$v) {_vm.$set(_vm.param, "clientId", $$v)},expression:"param.clientId"}},_vm._l((_vm.allCustomers),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"账套"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.zhangtaoId),callback:function ($$v) {_vm.$set(_vm.param, "zhangtaoId", $$v)},expression:"param.zhangtaoId"}},[_c('el-option',{attrs:{"label":"全部","value":""}}),_vm._v(" "),_vm._l((_vm.zhangTaoList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"缴保城市"}},[_c('el-input',{attrs:{"placeholder":"请输入城市...","maxlength":30},model:{value:(_vm.param.pensionClassCityId),callback:function ($$v) {_vm.$set(_vm.param, "pensionClassCityId", $$v)},expression:"param.pensionClassCityId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属公司"}},[_c('el-select',{attrs:{"filterable":"","placeholder":"请选择..."},model:{value:(_vm.param.qiyuesuoAccountId),callback:function ($$v) {_vm.$set(_vm.param, "qiyuesuoAccountId", $$v)},expression:"param.qiyuesuoAccountId"}},[_c('el-option',{attrs:{"label":"全部","value":""}}),_vm._v(" "),_vm._l((_vm.companyList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"促销员ID"}},[_c('el-input',{attrs:{"placeholder":"请输入促销员ID..."},model:{value:(_vm.param.empPk),callback:function ($$v) {_vm.$set(_vm.param, "empPk", $$v)},expression:"param.empPk"}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"9px"}}),_vm._v(" "),_c('div',{staticClass:"slide-btns clearfix"},[_c('el-form-item',[_c('el-button',{staticClass:"reset-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("筛选")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.exportResult()}}},[_vm._v("导出")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",on:{"click":function($event){return _vm.searchContract()}}},[_vm._v("合同发起记录查询")])],1),_vm._v(" "),_c('div',{staticClass:"floatr"},[_c('el-form-item',[_c('el-button',{staticClass:"slide-btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.toggleSlide('slideWrap1', $event)}}},[_vm._v("展开筛选项")])],1)],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"tableBody"},[_c('div',{staticClass:"title"},[_vm._v("筛选结果")]),_vm._v(" "),_c('el-table',{staticClass:"limitManagerTable table-expand",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"small","border":"","header-row-class-name":"table-header"}},[_c('el-table-column',{attrs:{"fixed":"left","width":"50","type":"index","label":"#","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"employeeName","label":"姓名","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"documentNumber","label":"身份证号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"employeeNumber","label":"员工编号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"id","label":"促销员ID","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.empPk)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"140","prop":"phone","label":"手机号","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"personType","label":"人员类别","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.quitCrmStatus == 1)?_c('div',[_vm._v("在职")]):_vm._e(),_vm._v(" "),(scope.row.quitCrmStatus == 2)?_c('div',[_vm._v("离职中")]):_vm._e(),_vm._v(" "),(scope.row.quitCrmStatus == 4)?_c('div',[_vm._v("离职")]):_vm._e(),_vm._v(" "),(scope.row.quitCrmStatus == 3)?_c('div',[_vm._v("取消离职")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"米咖注册认证状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isAuthentivayion == 9)?_c('div',[_vm._v("未注册")]):_vm._e(),_vm._v(" "),(scope.row.isAuthentivayion == 0)?_c('div',[_vm._v("注册会员")]):_vm._e(),_vm._v(" "),(scope.row.isAuthentivayion == 1)?_c('div',[_vm._v("身份认证")]):_vm._e(),_vm._v(" "),(scope.row.isAuthentivayion == 2)?_c('div',[_vm._v("实名认证")]):_vm._e(),_vm._v(" "),(scope.row.isAuthentivayion == 3)?_c('div',[_vm._v("银行卡认证")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","prop":"clientId","label":"在职项目客户","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"pensionClassCityId","label":"缴保城市","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","prop":"qiyuesuoAccountId","label":"所属公司","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","prop":"zhangtaoId","label":"账套","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"240","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleDetails(scope.row)}}},[_c('span',{staticStyle:{"color":"#66cc33"}},[_vm._v("查看详情")])]),_vm._v(" "),(scope.row.quitCrmStatus == 2 && _vm.webId_44Auth == 2)?_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleQuitCrmStatus(scope.row, 4)}}},[_c('span',{staticStyle:{"color":"#f63"}},[_vm._v("确认离职")])]):_vm._e(),_vm._v(" "),(scope.row.quitCrmStatus == 2 && _vm.webId_44Auth == 2)?_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleQuitCrmStatus(scope.row, 3)}}},[_c('span',{staticStyle:{"color":"#18a7ff"}},[_vm._v("取消离职")])]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"pagination table-pagination",attrs:{"current-page":_vm.formData.pageNo,"page-sizes":[10, 20, 30, 40],"page-size":_vm.formData.pageSize,"layout":"slot,sizes, total,  prev, pager, next, jumper","total":_vm.formData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog QHR_InformationBox",attrs:{"title":"人员信息","width":"1160px","center":true,"show-close":true,"visible":_vm.Information},on:{"update:visible":function($event){_vm.Information=$event}}},[(_vm.Information)?_c('Information',{attrs:{"itemId":_vm.itemId}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{staticClass:"quitDialog dialog Qhr_contract",attrs:{"title":_vm.titleContract,"width":"1020px","show-close":true,"visible":_vm.Contract},on:{"update:visible":function($event){_vm.Contract=$event}}},[(_vm.Contract)?_c('Contract'):_vm._e()],1),_vm._v(" "),_c('contractQys',{ref:"contractQys"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ye6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogOut_vue__ = __webpack_require__("mje6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b435d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogOut_vue__ = __webpack_require__("59bP");
function injectStyle (ssrContext) {
  __webpack_require__("p8Bm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65b435d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b435d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z8qU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "zIGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_formRules__ = __webpack_require__("8jay");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "salesperson-data-show",
  data: function data() {
    return {
      //筛选项参数
      param: {
        projectNo: '', //项目编号
        projectName: '', //项目名称
        brand: '', //品类，不是品类标签
        province: '', //省级id
        city: '', //区级id
        idCard: '', //身份证号
        rank: '', //星级
        pageNo: 1, //数据页码总数信息
        pageSize: 10 //当前页展示的信息条数
      },
      starLevelList: [], //获取到的星级列表
      signIdLst: [], //存储tag组件返回的选择的品类
      provinceList: [], //存储省-列表数据
      cityList: [], //存储获取到城市列表
      tableData: [], //展示的表格数据
      total: null, //总数
      uploadDialog: false, //是否展示上传对话框
      listLoading: false, //列表的loading
      loading: false, //全局loading
      rules: { idCard: __WEBPACK_IMPORTED_MODULE_1__common_js_formRules__["a" /* default */].idcard //表单校验规则
      } };
  },
  mounted: function mounted() {
    //获取省市列表数据
    this.searchProvince();
    //获取数据
    this.getData();
  },

  methods: {
    //展开收起
    toggleSlide: function toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight == 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },

    //搜索省市
    searchProvince: function searchProvince(id) {
      var _this = this;

      this.$http({
        method: "POST",
        url: "/rest/salesman/getRegion",
        params: {
          deep: 1,
          regionId: id
        }
      }).then(function (res) {
        _this.provinceList = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this, 'error', err.response, '查询省市数据失败，请稍后重试');
      });
    },


    //清空筛选项
    resetForm: function resetForm() {
      this.param.projectNo = null;
      this.param.projectName = null;
      this.param.brand = null;
      this.param.province = '';
      this.param.city = '';
      this.param.idCard = null;
      this.param.rank = '';
    },

    //提交表单（筛选功能）
    submitForm: function submitForm() {
      //是否要加上是否是市辖区的逻辑？如果是则city为市辖区
      this.getData();
    },

    //获取筛选数据
    getData: function getData() {
      var _this2 = this;

      this.listLoading = true;
      //获取table数据
      this.$http({
        method: "get",
        url: "/rest/BaoJieCr/searchBaoJieCr",
        params: this.param
      }).then(function (res) {
        _this2.tableData = res.data;
        _this2.listLoading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
        _this2.listLoading = false;
      });
      //获取页码数据
      this.$http({
        method: "get",
        url: "/rest/BaoJieCr/searchBaoJieCrSize",
        params: this.param
      }).then(function (res) {
        _this2.total = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this2, 'error', err.response, '查询失败，请稍后重试');
      });
    },

    //获取城市列表
    searchCity: function searchCity() {
      var _this3 = this;

      var id = null;
      this.param.cityId = null;
      this.provinceList.map(function (item) {
        if (_this3.param.province == item.adName) {
          id = item.id;
        }
      });
      if (id != null) {
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 2,
            regionId: id
          }
        }).then(function (res) {
          _this3.cityList = res.data;
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
        });
      }
    },

    //对于非超级管理员，需要把数据加密
    //身份证加密
    formatIdCard: function formatIdCard(row, column, cellValue) {
      if (cellValue.length == 15) {
        return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 7, 4);
      } else if (cellValue.length == 18) {
        return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 6, 4);
      } else {
        console.log('身份证位数不对', cellValue);
      }
    },

    //姓名加密
    formatName: function formatName(row, column, cellValue) {
      if (cellValue) {
        return __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].plusXing(cellValue, 1, 1);
      }
    },

    //数字转百分比
    formatPercent: function formatPercent(row, column, cellValue) {
      var x = 0;
      if (cellValue != 0) {
        x = parseFloat((cellValue * 100).toFixed(2)) + '%';
      }
      return x;
    },

    //每页的显示条目改变时
    handleSizeChange: function handleSizeChange(val) {
      this.param.pageSize = val;
      this.getData();
    },

    //手动选择页码时
    handleCurrentChange: function handleCurrentChange(val) {
      this.param.pageNo = val;
      this.getData();
    },

    //导出表格
    getExcel: function getExcel() {
      var _this4 = this;

      this.loading = true; //进入全局loading
      this.$http({
        method: "GET",
        url: "/rest/BaoJieCr/downLoadBaoJieCr",
        params: this.param
      }).then(function (res) {
        _this4.loading = false;
        location.href = __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].returnUrlHead() + res.data.message;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__common_js_util_js__["a" /* default */].myNotify(_this4, 'error', err.response, '下载失败，请稍后重试');
        _this4.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "zN4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util__ = __webpack_require__("hhm8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isEdit'],
  name: '',

  data: function data() {
    var checkNum = function checkNum(rule, value, callback) {
      if (isNaN(Number(value))) {
        callback(new Error('*'));
      } else if (value == '') {
        callback(new Error('*'));
      } else {
        callback();
      }
    };
    return {
      tableData: [],
      starSetArr: [],
      infoArr: [],
      starArr: [],
      danXuanArr: [],
      num: 1,
      loading: false,
      rules: {
        score: [{ validator: checkNum, trigger: 'blur' }],
        scoreMin: [{ validator: checkNum, trigger: 'blur' }],
        scoreMax: [{ validator: checkNum, trigger: 'blur' }]
      }
    };
  },
  mounted: function mounted() {
    console.log('星级', this.$store.state.xingJiArr);
    if (this.$store.state.xingJiArr == '') {
      this.getData();
    } else {
      this.getVuex();
    }

    if (this.$store.state.xingJiEdit == '') {
      this.getStar();
    } else {
      this.starSetArr = this.$store.state.xingJiEdit;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeXingJiArr', 'changeXingJiEditArr', 'changeSortStar']), {
    // isInArr (arr, item, flag) {
    //   for(var i = 0; i < arr.length; i++) {
    //     if (arr[i][flag] === item[flag]) {
    //       return i
    //     }
    //     return false
    //   }
    // },
    getData: function getData() {
      var _this = this;

      this.loading = true;
      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/searchScore?scoreType=2'
      }).then(function (res) {
        //获取第一页选的所有2
        var danXuanArr = [];
        _this.$store.state.systemArr.map(function (item, index) {
          var exceptArr = [118, 119, 120, 121, 122, 123, 124, 125, 127, 128, 129, 130, 131];
          if (item.scoreType == 2) {
            if (exceptArr.indexOf(item.masterId) < 0) {
              _this.starArr.push(item);
            } else {
              danXuanArr.push(item);
            }
          }
        });
        // this.danXuanArr = danXuanArr
        //初始化数组
        danXuanArr.map(function (item, index) {
          _this.danXuanArr[index] = {
            masterId: item.masterId,
            masterName: item.masterName,
            score: item.score,
            longSign: item.signId,
            shortSign: item.signId,
            signId: item.signId
          };
        });

        _this.danXuanArr.map(function (item, index) {
          var long = item.longSign;
          if (long == -1 || long == 2) {
            item.longSign = false;
          } else if (long == 0 || long == 1) {
            item.longSign = true;
          }
          var short = item.shortSign;
          if (short == -1 || short == 1) {
            item.shortSign = false;
          } else if (short == 0 || short == 2) {
            item.shortSign = true;
          }
        });

        _this.starArr.map(function (item, index) {
          _this.infoArr[index] = {
            masterId: item.masterId,
            masterName: item.masterName,
            long: [],
            short: []
          };
        });

        _this.tableData = res.data;

        _this.tableData.map(function (item, index) {
          _this.infoArr.map(function (item2, index2) {
            if (item2.masterId == item.masterId && item.signId == 1) {
              item2.long.push(item);
            } else if (item2.masterId == item.masterId && item.signId == 2) {
              item2.short.push(item);
            }
          });
          _this.danXuanArr.map(function (item2, index2) {
            if (item2.masterId == item.masterId) {
              item2.score = item.score;
              item2.signId = item.signId;
            }
          });
        });

        _this.loading = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this, 'error', err.response, '查询失败，请稍后重试');
        _this.loading = false;
      });
    },
    getVuex: function getVuex() {
      var _this2 = this;

      //获取第一页选的所有2
      var danXuanArr = [];
      this.$store.state.systemArr.map(function (item, index) {
        if (item.scoreType == 2 && item.masterId != 118 && item.masterId != 119 && item.masterId != 120 && item.masterId != 121 && item.masterId != 122 && item.masterId != 123 && item.masterId != 124 && item.masterId != 125 && item.masterId != 127 && item.masterId != 128 && item.masterId != 129 && item.masterId != 130 && item.masterId != 131) {
          _this2.starArr.push(item);
        }
        if (item.masterId == 118 && item.scoreType == 2 || item.masterId == 119 && item.scoreType == 2 || item.masterId == 120 && item.scoreType == 2 || item.masterId == 121 && item.scoreType == 2 || item.masterId == 122 && item.scoreType == 2 || item.masterId == 123 && item.scoreType == 2 || item.masterId == 124 && item.scoreType == 2 || item.masterId == 125 && item.scoreType == 2 || item.masterId == 127 && item.scoreType == 2 || item.masterId == 128 && item.scoreType == 2 || item.masterId == 129 && item.scoreType == 2 || item.masterId == 130 && item.scoreType == 2 || item.masterId == 131 && item.scoreType == 2) {
          danXuanArr.push(item);
        }
      });

      //初始化数组
      danXuanArr.map(function (item, index) {
        _this2.$store.state.xingJiArr.map(function (item2, index) {
          if (item.masterId == item2.masterId) {
            item.score = item2.score;
            item.longSign = item2.longSign;
            item.shortSign = item2.shortSign;
            item.signId = item2.signId;
          }
        });
      });

      this.danXuanArr = danXuanArr;

      this.starArr.map(function (item, index) {
        _this2.$set(_this2.infoArr, index, {
          masterId: item.masterId,
          masterName: item.masterName,
          long: [],
          short: []
        });
      });

      this.tableData = this.$store.state.xingJiArr;

      this.tableData.map(function (item, index) {
        _this2.infoArr.map(function (item2, index2) {
          if (item2.masterId == item.masterId && item.signId == 1) {
            item2.long.push(item);
          } else if (item2.masterId == item.masterId && item.signId == 2) {
            item2.short.push(item);
          }
        });
      });
    },
    getStar: function getStar() {
      var _this3 = this;

      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/searchStar'
      }).then(function (res) {
        _this3.starSetArr = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_2__common_js_util__["a" /* default */].myNotify(_this3, 'error', err.response, '查询失败，请稍后重试');
      });
    },
    changeState: function changeState(masterId, choose) {
      this.num++;
      this.infoArr.map(function (item, index) {
        if (item.masterId == masterId) {
          if (choose == 1) {
            if (item.long.length > 0) {
              item.long = [];
            } else {
              item.long.push({
                scoreMax: '',
                scoreMin: '',
                score: '',
                signId: 1,
                scoreType: 2
              });
            }
          }
          if (choose == 2) {
            if (item.short.length > 0) {
              item.short = [];
            } else {
              item.short.push({
                scoreMax: '',
                scoreMin: '',
                score: '',
                signId: 2,
                scoreType: 2
              });
            }
          }
        }
      });
      this.save();
    },
    addInfo: function addInfo(masterId, signId) {
      var _this4 = this;

      this.num++;
      this.infoArr.map(function (item, index) {
        if (item.masterId == masterId) {
          if (signId == 1) {
            item.long.push({
              "masterId": masterId,
              "scoreMax": '',
              "scoreMin": '',
              "score": '',
              "scoreType": 2,
              "startTime": _this4.$store.state.startTime,
              "signId": 1
            });
          } else if (signId == 2) {
            item.short.push({
              "masterId": masterId,
              "scoreMax": '',
              "scoreMin": '',
              "score": '',
              "scoreType": 2,
              "startTime": _this4.$store.state.startTime,
              "signId": 2
            });
          }
        }
      });
      this.save();
    },
    reduceInfo: function reduceInfo(masterId, signId) {
      this.num++;
      this.infoArr.map(function (item, index) {
        if (item.masterId == masterId) {
          if (signId == 1) {
            item.long.splice(item.long.length - 1, 1);
          } else if (signId == 2) {
            item.short.splice(item.short.length - 1, 1);
          }
        }
      });
      this.save();
    },
    changeMan: function changeMan(type, item) {
      if (type == 1) {
        item.longSign = !item.longSign;
      }
      if (type == 2) {
        item.shortSign = !item.shortSign;
      }
      this.save();
    },
    addStar: function addStar() {
      this.num++;
      this.starSetArr.push({
        scoreMax: '',
        scoreMin: '',
        starName: '',
        startTime: this.$store.state.startTime
      });
      this.save();
    },
    reduceStar: function reduceStar() {
      this.num++;
      this.starSetArr.splice(this.starSetArr.length - 1, 1);
      this.save();
    },
    changeValue: function changeValue() {
      console.log(456);
      this.save();
    },
    save: function save() {
      var _this5 = this;

      console.log(123);
      this.changeSortStar(this.infoArr);
      var arr = [];
      this.infoArr.map(function (item, index) {
        item.long.map(function (item2, index2) {
          arr.push({
            masterId: item.masterId,
            scoreMax: item2.scoreMax,
            scoreMin: item2.scoreMin,
            signId: item2.signId,
            score: item2.score,
            scoreType: 2,
            startTime: _this5.$store.state.startTime
          });
        });
        item.short.map(function (item2, index2) {
          arr.push({
            masterId: item.masterId,
            scoreMax: item2.scoreMax,
            scoreMin: item2.scoreMin,
            signId: item2.signId,
            score: item2.score,
            scoreType: 2,
            startTime: _this5.$store.state.startTime
          });
        });
      });

      this.danXuanArr.map(function (item, index) {
        if (item.longSign == true && item.shortSign == true) {
          item.signId = 0;
        } else if (item.longSign == true && item.shortSign == false) {
          item.signId = 1;
        } else if (item.longSign == false && item.shortSign == true) {
          item.signId = 2;
        } else {
          item.signId = -1;
        }
      });

      this.danXuanArr.map(function (item, index) {
        arr.push(item);
      });

      this.changeXingJiArr(arr);
      this.changeXingJiEditArr(this.starSetArr);
    }
  })
});

/***/ }),

/***/ "zWC4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.00b781a68c3e9dd0402c.js